

export const ALL_RESTAURANT_DATA = {
  statusCode: 0,
  data: {
    cacheExpiryTime: 320,
    pages: 1,
    pageIndex: 0,
    scrubber: 0,
    filters: [
      {
        type: "FilterWidget",
        title: "Cuisines",
        key: "CUISINES",
        configType: "checkbox",
        visible: 1,
        options: [
          {
            option: "Afghani",
            selected: 0,
            visible: 1,
          },
          {
            option: "American",
            selected: 0,
            visible: 1,
          },
          {
            option: "Andhra",
            selected: 0,
            visible: 1,
          },
          {
            option: "Arabian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Asian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Assamese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Awadhi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Bakery",
            selected: 0,
            visible: 1,
          },
          {
            option: "Barbecue",
            selected: 0,
            visible: 1,
          },
          {
            option: "Bengali",
            selected: 0,
            visible: 1,
          },
          {
            option: "Beverages",
            selected: 0,
            visible: 1,
          },
          {
            option: "Bhutanese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Bihari",
            selected: 0,
            visible: 1,
          },
          {
            option: "Biryani",
            selected: 0,
            visible: 1,
          },
          {
            option: "British",
            selected: 0,
            visible: 1,
          },
          {
            option: "Burgers",
            selected: 0,
            visible: 1,
          },
          {
            option: "Cafe",
            selected: 0,
            visible: 1,
          },
          {
            option: "Chaat",
            selected: 0,
            visible: 1,
          },
          {
            option: "Chettinad",
            selected: 0,
            visible: 1,
          },
          {
            option: "Chinese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Coastal",
            selected: 0,
            visible: 1,
          },
          {
            option: "Combo",
            selected: 0,
            visible: 1,
          },
          {
            option: "Continental",
            selected: 0,
            visible: 1,
          },
          {
            option: "Desserts",
            selected: 0,
            visible: 1,
          },
          {
            option: "European",
            selected: 0,
            visible: 1,
          },
          {
            option: "Fast Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "French",
            selected: 0,
            visible: 1,
          },
          {
            option: "German",
            selected: 0,
            visible: 1,
          },
          {
            option: "Grill",
            selected: 0,
            visible: 1,
          },
          {
            option: "Healthy Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "Home Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "Hyderabadi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Ice Cream",
            selected: 0,
            visible: 1,
          },
          {
            option: "Ice Cream Cakes",
            selected: 0,
            visible: 1,
          },
          {
            option: "Indian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Italian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Italian-American",
            selected: 0,
            visible: 1,
          },
          {
            option: "Jain",
            selected: 0,
            visible: 1,
          },
          {
            option: "Japanese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Juices",
            selected: 0,
            visible: 1,
          },
          {
            option: "Kebabs",
            selected: 0,
            visible: 1,
          },
          {
            option: "Kerala",
            selected: 0,
            visible: 1,
          },
          {
            option: "Keto",
            selected: 0,
            visible: 1,
          },
          {
            option: "Korean",
            selected: 0,
            visible: 1,
          },
          {
            option: "Lebanese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Lucknowi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Maharashtrian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Malaysian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Mangalorean",
            selected: 0,
            visible: 1,
          },
          {
            option: "Mediterranean",
            selected: 0,
            visible: 1,
          },
          {
            option: "Mexican",
            selected: 0,
            visible: 1,
          },
          {
            option: "Middle Eastern",
            selected: 0,
            visible: 1,
          },
          {
            option: "Mughlai",
            selected: 0,
            visible: 1,
          },
          {
            option: "Naga",
            selected: 0,
            visible: 1,
          },
          {
            option: "Nepalese",
            selected: 0,
            visible: 1,
          },
          {
            option: "North Indian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Oriental",
            selected: 0,
            visible: 1,
          },
          {
            option: "Oriya",
            selected: 0,
            visible: 1,
          },
          {
            option: "Paan",
            selected: 0,
            visible: 1,
          },
          {
            option: "Pan-Asian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Pastas",
            selected: 0,
            visible: 1,
          },
          {
            option: "Persian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Pizzas",
            selected: 0,
            visible: 1,
          },
          {
            option: "Portuguese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Punjabi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Raja",
            selected: 0,
            visible: 1,
          },
          {
            option: "Rajasthani",
            selected: 0,
            visible: 1,
          },
          {
            option: "Salads",
            selected: 0,
            visible: 1,
          },
          {
            option: "Seafood",
            selected: 0,
            visible: 1,
          },
          {
            option: "Singaporean",
            selected: 0,
            visible: 1,
          },
          {
            option: "Snacks",
            selected: 0,
            visible: 1,
          },
          {
            option: "South Indian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Steakhouse",
            selected: 0,
            visible: 1,
          },
          {
            option: "Street Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "Sushi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Sweets",
            selected: 0,
            visible: 1,
          },
          {
            option: "Tandoor",
            selected: 0,
            visible: 1,
          },
          {
            option: "Tex-Mex",
            selected: 0,
            visible: 1,
          },
          {
            option: "Thai",
            selected: 0,
            visible: 1,
          },
          {
            option: "Thalis",
            selected: 0,
            visible: 1,
          },
          {
            option: "Tibetan",
            selected: 0,
            visible: 1,
          },
          {
            option: "Turkish",
            selected: 0,
            visible: 1,
          },
          {
            option: "Vietnamese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Waffle",
            selected: 0,
            visible: 1,
          },
        ],
        detail: "",
        heading: "Cuisines",
        applicable: 1,
        searchable: 1,
      },
      {
        type: "FilterWidget",
        title: "Show Restaurants With",
        key: "SHOW_RESTAURANTS_WITH",
        configType: "checkbox",
        visible: 1,
        options: [
          {
            option: "Pure Veg",
            selected: 0,
            visible: 1,
          },
        ],
        detail: "",
        heading: "Offers & More",
        applicable: 1,
        searchable: 0,
      },
    ],
    sorts: [
      {
        type: "SortWidget",
        key: "RELEVANCE",
        title: "Relevance",
        selected: 1,
        visible: 1,
        defaultSelection: true,
      },
      {
        type: "SortWidget",
        key: "DELIVERY_TIME",
        title: "Delivery Time",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
      {
        type: "SortWidget",
        key: "RATING",
        title: "Rating",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
      {
        type: "SortWidget",
        key: "COST_FOR_TWO",
        title: "Cost: Low to High",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
      {
        type: "SortWidget",
        key: "COST_FOR_TWO_H2L",
        title: "Cost: High to Low",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
    ],
    configs: {
      ribbons: {
        PREORDER: {
          type: "PREORDER",
          text: "Preorder",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#d53d4c",
          bottomBackgroundColor: "#af2330",
          priority: 3,
        },
        EXCLUSIVE: {
          type: "EXCLUSIVE",
          text: "Exclusive",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#fa4a5b",
          bottomBackgroundColor: "#d12a3b",
          priority: 2,
        },
        NEW: {
          type: "NEW",
          text: "Newly Added",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#d53d4c",
          bottomBackgroundColor: "#af2330",
          priority: 4,
        },
        REPEAT: {
          type: "REPEAT",
          text: "Repeat",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#D53D4C",
          bottomBackgroundColor: "#B02331",
          priority: 6,
        },
        CLOUD: {
          type: "CLOUD",
          text: "Daily Menus",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#fa4a5b",
          bottomBackgroundColor: "#d12a3b",
          priority: 5,
        },
        PREMIUM: {
          type: "PREMIUM",
          text: "Premium",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#8a584b",
          bottomBackgroundColor: "#583229",
          priority: 7,
        },
        PROMOTED: {
          type: "PROMOTED",
          text: "Promoted",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#3a3c41",
          bottomBackgroundColor: "#1e2023",
          priority: 1,
        },
      },
      croutons: {
        RAIN: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "surge_listing_piuzrv",
          textColor: "#ffffff",
          title: "Bad Weather",
          message: "${amount} extra levied on some restaurants",
        },
        SERVICEABLE_WITH_BANNER_RAIN: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "rain_crouton_4x",
          textColor: "#ffffff",
          title: "Bad Weather",
          message: "Few restaurants unserviceable due to rains",
        },
      },
    },
    cards: [
      {
        cardType: "carousel",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "carousel",
          subtype: "topCarousel",
          data: {
            cards: [
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 635529,
                  creativeId: "rng/md/carousel/production/pneknawbadtvceqzwiep",
                  type: "restaurantCollectionV2",
                  link: "49301",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 619141,
                  creativeId: "rng/md/carousel/production/zpkkdkmvlj5cuvqbc50t",
                  type: "restaurantCollectionV2",
                  link: "56413",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 619143,
                  creativeId: "rng/md/carousel/production/lzkjv3sxwwjkzg0vxpvt",
                  type: "restaurantCollectionV2",
                  link: "56422",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 619142,
                  creativeId: "rng/md/carousel/production/tgnvusbs3fnzz7xupeno",
                  type: "restaurantCollectionV2",
                  link: "56417",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 619145,
                  creativeId: "rng/md/carousel/production/nhubtkw7dukg3ukcmpam",
                  type: "restaurantCollectionV2",
                  link: "56414",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 607193,
                  creativeId: "rng/md/carousel/production/s5ug2key6e2sptaxku5v",
                  type: "restaurantCollectionV2",
                  link: "56410",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 607188,
                  creativeId: "rng/md/carousel/production/oxe97jexxbnxqtbhg2zo",
                  type: "restaurantCollectionV2",
                  link: "11740",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 607195,
                  creativeId: "rng/md/carousel/production/ifi2lbzxeu1hvsqrsip3",
                  type: "restaurantCollectionV2",
                  link: "56421",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
            ],
          },
        },
        parentWidget: false,
      },
      {
        cardType: "carousel",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "carousel",
          subtype: "openFilter",
          data: {
            cards: [
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 181684,
                  creativeId: "bkhjfipzydkoqncrxpyi",
                  type: "restaurantCollectionV2",
                  link: "11718",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  title: "Offers Near You",
                  subtitle: "0 OPTIONS",
                  restaurants: [],
                  totalCount: 0,
                  dwebOpenFilterTitle: "Offers Near You",
                  dwebOpenFilterBgColor: "#FF0000",
                  dwebOpenFilterSelectIcon: "eyperwsfhaoa5vktjtu4",
                  dwebOpenFilterDeselectIcon: "urw8usdf4mk9aywd59gq",
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 273242,
                  creativeId: "rng/md/carousel/production/vquntqrzvkb08pe59cec",
                  type: "restaurantCollectionV2",
                  link: "46147",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  title: "Top Picks",
                  subtitle: "0 OPTIONS",
                  restaurants: [],
                  totalCount: 0,
                  dwebOpenFilterTitle: "Top Picks",
                  dwebOpenFilterBgColor: "#FF0000",
                  dwebOpenFilterSelectIcon:
                    "rng/md/carousel/production/vt13uzhjrg5r49kh9oru",
                  dwebOpenFilterDeselectIcon:
                    "rng/md/carousel/production/ser2sttildk9yt7t2s91",
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 181685,
                  creativeId: "auhzanqqslsq5meh0m9l",
                  type: "restaurantCollectionV2",
                  link: "11709",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  title: "Only on Swiggy",
                  subtitle: "0 OPTIONS",
                  restaurants: [],
                  totalCount: 0,
                  dwebOpenFilterTitle: "Only on Swiggy",
                  dwebOpenFilterBgColor: "#FF0000",
                  dwebOpenFilterSelectIcon: "tvjhvfzjhbxune2idler",
                  dwebOpenFilterDeselectIcon: "y4vnumwu4f8olsly1hnw",
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 181680,
                  creativeId: "a3jqjjod5taken7dh1bs",
                  type: "restaurantCollectionV2",
                  link: "11721",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  title: "Veg Only",
                  subtitle: "0 OPTIONS",
                  restaurants: [],
                  totalCount: 0,
                  dwebOpenFilterTitle: "Vegetarian Options",
                  dwebOpenFilterBgColor: "#FF0000",
                  dwebOpenFilterSelectIcon: "qtjc8dzfexg72lug37a0",
                  dwebOpenFilterDeselectIcon: "bm8bziikwyvwqsml1clm",
                },
              },
            ],
          },
        },
        parentWidget: false,
      },
      {
        cardType: "seeAllRestaurants",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "seeAllRestaurants",
          data: {
            title: "SEE ALL",
            totalOpenRestaurants: 1340,
            cards: [
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "425",
                  name: "Hotel Empire",
                  uuid: "c0c37758-2e83-4429-aad6-eb94debb48f5",
                  city: "1",
                  area: "Koramangala",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "un4omn7rcunkmlw6vikr",
                  cuisines: ["North Indian", "Kebabs", "Biryani"],
                  tags: [],
                  costForTwo: 45000,
                  costForTwoString: "₹450 FOR TWO",
                  deliveryTime: 26,
                  minDeliveryTime: 26,
                  maxDeliveryTime: 26,
                  slaString: "26 MINS",
                  lastMileTravel: 1.2999999523162842,
                  slugs: {
                    restaurant: "hotel-empire-5th-block-koramangala",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "103, Industrial Area, 5th Block, Near Jyothi Nivas College, Koramangala 5th Block, Bangalore",
                  locality: "Koramangala",
                  parentId: 475,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "10% off",
                    shortDescriptionList: [
                      {
                        meta: "10% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "10% off up to ₹40 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "10% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "10% off up to ₹40 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=5864391~p=1~eid=00000186-9203-8e37-3ede-987500c60116",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.2 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "425",
                    deliveryTime: 26,
                    minDeliveryTime: 26,
                    maxDeliveryTime: 26,
                    lastMileTravel: 1.2999999523162842,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.1",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "229",
                  name: "Meghana Foods",
                  uuid: "4fdd19e2-5d0f-4bde-9c7f-dc3e8d36021f",
                  city: "1",
                  area: "Koramangala",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "xqwpuhgnsaf18te7zvtv",
                  cuisines: [
                    "Biryani",
                    "Andhra",
                    "South Indian",
                    "North Indian",
                    "Chinese",
                    "Seafood",
                  ],
                  tags: [],
                  costForTwo: 50000,
                  costForTwoString: "₹500 FOR TWO",
                  deliveryTime: 26,
                  minDeliveryTime: 26,
                  maxDeliveryTime: 26,
                  slaString: "26 MINS",
                  lastMileTravel: 1.399999976158142,
                  slugs: {
                    restaurant: "meghana-foods-5th-block-koramangala",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "124, Near Jyothi Nivas College, 1st Cross, KHB Colony, Koramangala 5th Block, Bangalore",
                  locality: "5th Block",
                  parentId: 635,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FREE DELIVERY",
                    shortDescriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "",
                    shortDescriptionList: [
                      {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.3 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "229",
                    deliveryTime: 26,
                    minDeliveryTime: 26,
                    maxDeliveryTime: 26,
                    lastMileTravel: 1.399999976158142,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.4",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "121603",
                  name: "Kannur Food Point",
                  uuid: "51983905-e698-4e31-b0d7-e376eca56320",
                  city: "1",
                  area: "Tavarekere",
                  totalRatingsString: "5000+ ratings",
                  cloudinaryImageId: "bmwn4n4bn6n1tcpc8x2h",
                  cuisines: ["Kerala", "Chinese"],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 28,
                  minDeliveryTime: 28,
                  maxDeliveryTime: 28,
                  slaString: "28 MINS",
                  lastMileTravel: 3,
                  slugs: {
                    restaurant: "kannur-food-point-btm",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "6/21,9TH CROSS ,1ST MAIN, VENKATESHWARA LAYOUT,SG PALYA, BENGALURU, - 560093",
                  locality: "SG Palya",
                  parentId: 20974,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FREE DELIVERY",
                    shortDescriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "50% off on all orders",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "50% off on all orders",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "50% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "50% off on all orders",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "3 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "121603",
                    deliveryTime: 28,
                    minDeliveryTime: 28,
                    maxDeliveryTime: 28,
                    lastMileTravel: 3,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.8",
                  totalRatings: 5000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "492159",
                  name: "Roti Wala",
                  uuid: "ada41f9b-cca3-4197-805c-8c43798919e9",
                  city: "1",
                  area: "Koramangala",
                  totalRatingsString: "100+ ratings",
                  cloudinaryImageId: "51f52730c0a08dc89dca3df021370477",
                  cuisines: ["Home Food", "North Indian", "Thalis"],
                  tags: [],
                  costForTwo: 20000,
                  costForTwoString: "₹200 FOR TWO",
                  deliveryTime: 36,
                  minDeliveryTime: 36,
                  maxDeliveryTime: 36,
                  slaString: "36 MINS",
                  lastMileTravel: 1,
                  slugs: {
                    restaurant: "new-roti-wala-koramangala-koramangala",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "No 18 ,MIG, KHB Colony, 5th Block, Koramangala, Bengaluru, Karnataka 560095, India",
                  locality: "5th Block",
                  parentId: 171678,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "20% off",
                    shortDescriptionList: [
                      {
                        meta: "20% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "20% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "492159",
                    deliveryTime: 36,
                    minDeliveryTime: 36,
                    maxDeliveryTime: 36,
                    lastMileTravel: 1,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.2",
                  totalRatings: 100,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "428",
                  name: "Biryani Pot",
                  uuid: "6db20a8b-dd85-4148-b750-107169f7f826",
                  city: "1",
                  area: "Btm Layout",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "mdipoyzfzsa7n7igskht",
                  cuisines: ["North Indian", "Biryani"],
                  tags: [],
                  costForTwo: 50000,
                  costForTwoString: "₹500 FOR TWO",
                  deliveryTime: 23,
                  minDeliveryTime: 23,
                  maxDeliveryTime: 23,
                  slaString: "23 MINS",
                  lastMileTravel: 1.899999976158142,
                  slugs: {
                    restaurant: "biryani-pot-madiwala-junction-btm",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "14th  Cross, 4th link Road Maruthi Nagar Madiwala Bangalore 68",
                  locality: "Maruti Nagar",
                  parentId: 21798,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "20% off",
                    shortDescriptionList: [
                      {
                        meta: "20% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "20% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.8 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "428",
                    deliveryTime: 23,
                    minDeliveryTime: 23,
                    maxDeliveryTime: 23,
                    lastMileTravel: 1.899999976158142,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.8",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "592285",
                  name: "Shyamji's Chole Bhature",
                  uuid: "cf0fce9a-f4a2-4880-9985-7a35480404ae",
                  city: "1",
                  area: "Koramangala",
                  totalRatingsString: "100+ ratings",
                  cloudinaryImageId: "ugxnshnc5dctksihttvq",
                  cuisines: ["North Indian", "Beverages", "Snacks"],
                  tags: [],
                  costForTwo: 40000,
                  costForTwoString: "₹400 FOR TWO",
                  deliveryTime: 23,
                  minDeliveryTime: 23,
                  maxDeliveryTime: 23,
                  slaString: "23 MINS",
                  lastMileTravel: 0.4000000059604645,
                  slugs: {
                    restaurant:
                      "shyamji's-chole-bhature-koramangala-koramangala",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "No. 3, 70/1, 17th Cross, B Main, 5th Block, Koramangla, Bengaluru, 560095",
                  locality: "5th Block",
                  parentId: 255424,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FLAT100 off",
                    shortDescriptionList: [
                      {
                        meta: "FLAT100 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FLAT100 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹100 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FLAT100 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=5951558~p=7~eid=00000186-9203-8e37-3ede-987700c60701",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "0.4 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "592285",
                    deliveryTime: 23,
                    minDeliveryTime: 23,
                    maxDeliveryTime: 23,
                    lastMileTravel: 0.4000000059604645,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.3",
                  totalRatings: 100,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "337335",
                  name: "Kannur food kitchen",
                  uuid: "c70b61bc-0f68-4e24-996b-749fbf295c35",
                  city: "1",
                  area: "BTM Layout",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "a27weqanhnszqiuzsoik",
                  cuisines: ["Kerala", "Biryani", "Beverages"],
                  tags: [],
                  costForTwo: 20000,
                  costForTwoString: "₹200 FOR TWO",
                  deliveryTime: 27,
                  minDeliveryTime: 27,
                  maxDeliveryTime: 27,
                  slaString: "27 MINS",
                  lastMileTravel: 2.5,
                  slugs: {
                    restaurant: "kannur-food-kitchen-btm-btm",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "kannur food point, Chocolate Factory Road, Tavarekere, Cashier Layout, 1st Stage, BTM Layout, thavrakharea, Karnataka, India",
                  locality: "1st  Stage",
                  parentId: 114756,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FREE DELIVERY",
                    shortDescriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "50% off on all orders",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "50% off on all orders",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "50% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "50% off on all orders",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "2.5 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "337335",
                    deliveryTime: 27,
                    minDeliveryTime: 27,
                    maxDeliveryTime: 27,
                    lastMileTravel: 2.5,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.8",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "108158",
                  name: "Kabab magic",
                  uuid: "2fc26cdc-f642-4459-9888-6661c142e8b7",
                  city: "1",
                  area: "Btm Layout",
                  totalRatingsString: "100+ ratings",
                  cloudinaryImageId: "aagnmdkdxshwhhtzl7vk",
                  cuisines: [
                    "Chinese",
                    "South Indian",
                    "North Indian",
                    "Fast Food",
                    "Mexican",
                    "Kerala",
                  ],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 24,
                  minDeliveryTime: 24,
                  maxDeliveryTime: 24,
                  slaString: "24 MINS",
                  lastMileTravel: 2.0999999046325684,
                  slugs: {
                    restaurant: "kabab-magic-btm-2",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "3/1, 1st main road 2 nd cross,Maruthi nagar ,Madiwala,Bangalore",
                  locality: "Maruti Nagar",
                  parentId: 527,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FREE DELIVERY",
                    shortDescriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "",
                    shortDescriptionList: [
                      {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "2 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "108158",
                    deliveryTime: 24,
                    minDeliveryTime: 24,
                    maxDeliveryTime: 24,
                    lastMileTravel: 2.0999999046325684,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.8",
                  totalRatings: 100,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "92389",
                  name: "Muthashy's",
                  uuid: "1e47bc36-13c4-45af-a29d-9c2417a383cb",
                  city: "1",
                  area: "Btm Layout",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "fifv8bhm4mzqausmynfa",
                  cuisines: [
                    "Chinese",
                    "South Indian",
                    "North Indian",
                    "Kerala",
                    "Seafood",
                  ],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 25,
                  minDeliveryTime: 25,
                  maxDeliveryTime: 25,
                  slaString: "25 MINS",
                  lastMileTravel: 2.5,
                  slugs: {
                    restaurant: "muthashy39s-btm",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "3, Brindavan Complex, 20th Main, Maruthi Nagar Main Road, 1st Stage, BTM Layout",
                  locality: "Maruti Nagar",
                  parentId: 21429,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FREE DELIVERY",
                    shortDescriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "",
                    shortDescriptionList: [
                      {
                        meta: "Free Delivery",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=5830834~p=10~eid=00000186-9203-8e37-3ede-987800c60a02",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "2.5 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "92389",
                    deliveryTime: 25,
                    minDeliveryTime: 25,
                    maxDeliveryTime: 25,
                    lastMileTravel: 2.5,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.3",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "223",
                  name: "Truffles",
                  uuid: "8250cc38-4752-4f42-928b-4da5f01e5cbe",
                  city: "1",
                  area: "Koramangala",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "cd832b6167eb9f88aeb1ccdebf38d942",
                  cuisines: ["American", "Continental", "Desserts", "Italian"],
                  tags: [],
                  costForTwo: 45000,
                  costForTwoString: "₹450 FOR TWO",
                  deliveryTime: 29,
                  minDeliveryTime: 29,
                  maxDeliveryTime: 29,
                  slaString: "29 MINS",
                  lastMileTravel: 1.600000023841858,
                  slugs: {
                    restaurant: "truffles-ice-spice-5th-block-koramangala",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "93/A, Appek Building, 'A' Wing,  4th 'B' Cross,  Koramangala Industrial Layout, 5th Block, Koramangala, Bangalore - 560 095",
                  locality: "5th Block",
                  parentId: 218065,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "20% off",
                    shortDescriptionList: [
                      {
                        meta: "20% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "20% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.6 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "223",
                    deliveryTime: 29,
                    minDeliveryTime: 29,
                    maxDeliveryTime: 29,
                    lastMileTravel: 1.600000023841858,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.4",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "5934",
                  name: "Burger King",
                  uuid: "ac56f2ac-71d3-4978-9513-b3aa68e25463",
                  city: "1",
                  area: "Koramangala",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "jpohkfkofao0hxez7vdh",
                  cuisines: ["Burgers", "American"],
                  tags: [],
                  costForTwo: 35000,
                  costForTwoString: "₹350 FOR TWO",
                  deliveryTime: 27,
                  minDeliveryTime: 27,
                  maxDeliveryTime: 27,
                  slaString: "27 MINS",
                  lastMileTravel: 1.399999976158142,
                  slugs: {
                    restaurant: "burger-king-koramangala",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "Unit No. 1, Davar Atrium, Corporation No. 118, Koramangala Industrial Area 7th Block, Bangalore 560095",
                  locality: "7th Block",
                  parentId: 166,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "Get every item under 129",
                    shortDescriptionList: [
                      {
                        meta: "Get every item under 129",
                        discountType: "FinalPrice",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Get every item under 129",
                        discountType: "FinalPrice",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "",
                    shortDescriptionList: [
                      {
                        meta: "",
                        discountType: "FinalPrice",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Get every item under 129",
                        discountType: "FinalPrice",
                        operationType: "RESTAURANT",
                      },
                      {
                        meta: "FREE DELIVERY",
                        discountType: "FREE_DELIVERY",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.3 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "5934",
                    deliveryTime: 27,
                    minDeliveryTime: 27,
                    maxDeliveryTime: 27,
                    lastMileTravel: 1.399999976158142,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.2",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "410683",
                  name: "Soul Rasa",
                  uuid: "5fddc67b-5287-45a0-a252-c34eb9b290d1",
                  city: "1",
                  area: "Koramangala",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "xoth5ysuv2r6ctizaso5",
                  cuisines: [
                    "Indian",
                    "Healthy Food",
                    "Home Food",
                    "South Indian",
                    "North Indian",
                  ],
                  tags: [],
                  costForTwo: 40000,
                  costForTwoString: "₹400 FOR TWO",
                  deliveryTime: 31,
                  minDeliveryTime: 31,
                  maxDeliveryTime: 31,
                  slaString: "31 MINS",
                  lastMileTravel: 2.4000000953674316,
                  slugs: {
                    restaurant: "hb-koramangala-koramangala",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "88/1,Ward No.66, Sajjapura Road, Madiwala, Jakkasandra Village Bangalore-South, 560034",
                  locality: "Jakkasandra",
                  parentId: 239281,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FLAT150 off",
                    shortDescriptionList: [
                      {
                        meta: "FLAT150 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FLAT150 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹150 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FLAT150 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=6003197~p=13~eid=00000186-9203-8e37-3ede-987900c60d51",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "2.4 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "410683",
                    deliveryTime: 31,
                    minDeliveryTime: 31,
                    maxDeliveryTime: 31,
                    lastMileTravel: 2.4000000953674316,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.4",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "118278",
                  name: "Namaste",
                  uuid: "81f6e475-dc52-4954-aefa-1dbcc740227d",
                  city: "1",
                  area: "BTM Layout",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "wya5kg7wxvbh5opfpo1m",
                  cuisines: [
                    "South Indian",
                    "Thalis",
                    "Snacks",
                    "Biryani",
                    "Indian",
                    "Chinese",
                    "Desserts",
                    "Beverages",
                  ],
                  tags: [],
                  costForTwo: 10000,
                  costForTwoString: "₹100 FOR TWO",
                  deliveryTime: 30,
                  minDeliveryTime: 30,
                  maxDeliveryTime: 30,
                  slaString: "30 MINS",
                  lastMileTravel: 4.199999809265137,
                  slugs: {
                    restaurant: "namaste-btm",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address: "69, 7th Main Road, BTM 2nd Stage, Bangalore - 76",
                  locality: "2nd Stage",
                  parentId: 366271,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "50% off",
                    shortDescriptionList: [
                      {
                        meta: "50% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "50% off up to ₹100 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "50% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "50% off up to ₹100 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "4.1 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "118278",
                    deliveryTime: 30,
                    minDeliveryTime: 30,
                    maxDeliveryTime: 30,
                    lastMileTravel: 4.199999809265137,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.3",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "656392",
                  name: "Subway",
                  uuid: "b649dc2d-8e82-4c70-b864-91ae31ba4739",
                  city: "1",
                  area: "CNA, Koramangla",
                  totalRatingsString: "100+ ratings",
                  cloudinaryImageId: "0bf19a82b109b40c2f5c56d00f071a33",
                  cuisines: ["Salads", "Snacks", "Desserts", "Beverages"],
                  tags: [],
                  costForTwo: 35000,
                  costForTwoString: "₹350 FOR TWO",
                  deliveryTime: 25,
                  minDeliveryTime: 25,
                  maxDeliveryTime: 25,
                  slaString: "25 MINS",
                  lastMileTravel: 1.7000000476837158,
                  slugs: {
                    restaurant: "subway-koramangala-koramangala-2",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "CNA Arcade, Ground Floor, No. 37, 1st Main, 1st Block, Koramangala, Bangalore-560034",
                  locality: "1st Block",
                  parentId: 2,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "20% off",
                    shortDescriptionList: [
                      {
                        meta: "20% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "20% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "20% off up to ₹50 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=5998838~p=16~eid=00000186-9203-8e37-3ede-987a00c6106e",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.7 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "656392",
                    deliveryTime: 25,
                    minDeliveryTime: 25,
                    maxDeliveryTime: 25,
                    lastMileTravel: 1.7000000476837158,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.2",
                  totalRatings: 100,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "419413",
                  name: "MIRCHI MAHARAJ",
                  uuid: "67181ec9-aa3e-4168-9e50-7b841c51b0ff",
                  city: "1",
                  area: "HSR Layout",
                  totalRatingsString: "100+ ratings",
                  cloudinaryImageId: "sh5gkksgojqf8jfey6my",
                  cuisines: ["Indian", "Chinese"],
                  tags: [],
                  costForTwo: 20000,
                  costForTwoString: "₹200 FOR TWO",
                  deliveryTime: 32,
                  minDeliveryTime: 32,
                  maxDeliveryTime: 32,
                  slaString: "32 MINS",
                  lastMileTravel: 3.9000000953674316,
                  slugs: {
                    restaurant: "mirchi-maharaj-hsr-hsr",
                    city: "bangalore",
                  },
                  cityState: "1",
                  address:
                    "NO.89,14TH MAIN,17TH CROSS,SECTOR-4,HSR  LAYOUT,BANGALORE-560102, BTM Layout ,  B.B.M.P South, Karnataka-560102",
                  locality: "4th Sector",
                  parentId: 233709,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "40% off",
                    shortDescriptionList: [
                      {
                        meta: "40% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "40% off up to ₹80 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "40% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "40% off up to ₹80 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [],
                    totalFees: 0,
                    message: "",
                    title: "",
                    amount: "",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "3.9 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "419413",
                    deliveryTime: 32,
                    minDeliveryTime: 32,
                    maxDeliveryTime: 32,
                    lastMileTravel: 3.9000000953674316,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.7",
                  totalRatings: 100,
                  new: false,
                },
                subtype: "basic",
              },
            ],
            totalRestaurants: 1340,
          },
          subtype: "personalized",
        },
        parentWidget: false,
      },
    ],
    nextPageFetch: 0,
  },
  tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
  sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
  deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
  csrfToken: "gpzSdFpZdqzi-DHr8PmlQfr3RzZdodkA1F07F27k",
};

export const ALL_RESTAURANTS_LIST =
  ALL_RESTAURANT_DATA?.data?.cards[2]?.data?.data?.cards;

export const ARRAY_OF_MENU_OF_RESTAURANTS = [
  {"statusCode":0,"data":{"experiments":[{"experimentId":"menu_via_timeline","variantId":"true"}],"restaurantAttributes":[],"id":"425","name":"Hotel Empire","uuid":"c0c37758-2e83-4429-aad6-eb94debb48f5","slug":"hotel-empire-5th-block-koramangala","latLong":"12.934816,77.61580500000002","city":"Bangalore","area":"Koramangala","areaPostalCode":"560034","areaSlug":"koramangala","restaurantSlug":{"restaurant":"hotel-empire-5th-block-koramangala","city":"bangalore"},"type":"F","locality":"Koramangala","avgRating":4.1,"totalRatings":1000,"avgRatingString":"4.1","totalRatingsString":"1K+ ratings","cloudinaryImageId":"un4omn7rcunkmlw6vikr","costForTwo":45000,"costForTwoMsg":"₹450 for two","cuisines":["North Indian","Kebabs"],"minimumOrder":0,"opened":1,"parentId":475,"isNew":false,"isVeg":false,"favorite":false,"multiOutlet":true,"restaurantServiceLine":["REGULAR"],"sla":{"slaString":"23 MINS","lastMileDistanceString":"1.3 kms","restaurantId":"425","deliveryTime":23,"minDeliveryTime":23,"maxDeliveryTime":23,"lastMileTravel":1.3,"thirtyMinOrFree":false,"serviceability":"SERVICEABLE","stressFactor":0.6715776920318604,"rainMode":"NONE","longDistance":"NOT_LONG_DISTANCE","preferentialService":false,"batchable":false,"stress":{"value":0.3333333432674408,"components":{"de":0.3333333432674408}},"surge":{"applicable":false,"components":[{"value":0,"type":"STRESS"}]},"zoneId":1},"availability":{"nextCloseTime":"2023-02-28 05:00:00","nextChangeTime":1677540600000,"visibility":true,"opened":true},"badges":{"imageBased":[],"textBased":[],"textExtendedBadges":[]},"labels":[{"title":"Timings","message":"null"},{"title":"Address","message":"103, Industrial Area, 5th Block, Near Jyothi Nivas College, Koramangala 5th Block, Bangalore"},{"title":"Cuisines","message":"North Indian,Kebabs"}],"thirdPartyAddress":false,"menu":{"items":{"215004":{"id":215004,"name":"Chicken Clear Soup","category":"Soup","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":8900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67840602,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215007":{"id":215007,"name":"Gobi Manchurian","category":"Veg Dry","description":"","cloudinaryImageId":"rsis0nq4bvjiu2g7ncks","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810882","name":"Portion ","variations":[{"name":"Half","price":170,"default":0,"id":"18814010","inStock":1,"isVeg":1,"variant_group_id":"5810882","order":0},{"name":"Qtr","price":95,"default":1,"id":"18814009","inStock":1,"isVeg":1,"variant_group_id":"5810882","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810882","variation_id":"18814010"}],"price":17000,"addon_combinations":[{"group_id":"67838240","addon_id":"54156457"},{"group_id":"67838240","addon_id":"54156458"},{"group_id":"67838240","addon_id":"54156459"},{"group_id":"67838240","addon_id":"54156460"},{"group_id":"67838240","addon_id":"54156461"},{"group_id":"67838240","addon_id":"54156462"},{"group_id":"67838247","addon_id":"54156425"},{"group_id":"67838247","addon_id":"54156426"},{"group_id":"67838247","addon_id":"54156427"},{"group_id":"67838247","addon_id":"54156428"},{"group_id":"67838247","addon_id":"54156429"}]},{"variations":[{"group_id":"5810882","variation_id":"18814009"}],"price":9500,"addon_combinations":[{"group_id":"67838240","addon_id":"54156457"},{"group_id":"67838240","addon_id":"54156458"},{"group_id":"67838240","addon_id":"54156459"},{"group_id":"67838240","addon_id":"54156460"},{"group_id":"67838240","addon_id":"54156461"},{"group_id":"67838240","addon_id":"54156462"},{"group_id":"67838247","addon_id":"54156425"},{"group_id":"67838247","addon_id":"54156426"},{"group_id":"67838247","addon_id":"54156427"},{"group_id":"67838247","addon_id":"54156428"},{"group_id":"67838247","addon_id":"54156429"}]}]},"addons":[{"group_id":67838240,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838247,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9500,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215032":{"id":215032,"name":"Pepper Chicken Dry","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"nrx3bnvkrvjblpwnejze","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810789","name":"Portion","variations":[{"name":"Full","price":440,"default":0,"id":"18813752","inStock":1,"isVeg":0,"variant_group_id":"5810789","order":0},{"name":"Half","price":230,"default":0,"id":"18813751","inStock":1,"isVeg":0,"variant_group_id":"5810789","order":0},{"name":"Qtr","price":130,"default":1,"id":"18813750","inStock":1,"isVeg":0,"variant_group_id":"5810789","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810789","variation_id":"18813752"}],"price":44000,"addon_combinations":[{"group_id":"67835314","addon_id":"54156436"},{"group_id":"67835314","addon_id":"54156437"},{"group_id":"67835314","addon_id":"54156438"},{"group_id":"67835323","addon_id":"54156457"},{"group_id":"67835323","addon_id":"54156458"},{"group_id":"67835323","addon_id":"54156459"},{"group_id":"67835323","addon_id":"54156460"},{"group_id":"67835323","addon_id":"54156461"},{"group_id":"67835323","addon_id":"54156462"},{"group_id":"67835302","addon_id":"54156450"},{"group_id":"67835302","addon_id":"54156451"},{"group_id":"67835302","addon_id":"54156452"},{"group_id":"67835327","addon_id":"54156425"},{"group_id":"67835327","addon_id":"54156426"},{"group_id":"67835327","addon_id":"54156427"},{"group_id":"67835327","addon_id":"54156428"},{"group_id":"67835327","addon_id":"54156429"}]},{"variations":[{"group_id":"5810789","variation_id":"18813751"}],"price":23000,"addon_combinations":[{"group_id":"67835314","addon_id":"54156436"},{"group_id":"67835314","addon_id":"54156437"},{"group_id":"67835314","addon_id":"54156438"},{"group_id":"67835323","addon_id":"54156457"},{"group_id":"67835323","addon_id":"54156458"},{"group_id":"67835323","addon_id":"54156459"},{"group_id":"67835323","addon_id":"54156460"},{"group_id":"67835323","addon_id":"54156461"},{"group_id":"67835323","addon_id":"54156462"},{"group_id":"67835302","addon_id":"54156450"},{"group_id":"67835302","addon_id":"54156451"},{"group_id":"67835302","addon_id":"54156452"},{"group_id":"67835327","addon_id":"54156425"},{"group_id":"67835327","addon_id":"54156426"},{"group_id":"67835327","addon_id":"54156427"},{"group_id":"67835327","addon_id":"54156428"},{"group_id":"67835327","addon_id":"54156429"}]},{"variations":[{"group_id":"5810789","variation_id":"18813750"}],"price":13000,"addon_combinations":[{"group_id":"67835314","addon_id":"54156436"},{"group_id":"67835314","addon_id":"54156437"},{"group_id":"67835314","addon_id":"54156438"},{"group_id":"67835323","addon_id":"54156457"},{"group_id":"67835323","addon_id":"54156458"},{"group_id":"67835323","addon_id":"54156459"},{"group_id":"67835323","addon_id":"54156460"},{"group_id":"67835323","addon_id":"54156461"},{"group_id":"67835323","addon_id":"54156462"},{"group_id":"67835302","addon_id":"54156450"},{"group_id":"67835302","addon_id":"54156451"},{"group_id":"67835302","addon_id":"54156452"},{"group_id":"67835327","addon_id":"54156425"},{"group_id":"67835327","addon_id":"54156426"},{"group_id":"67835327","addon_id":"54156427"},{"group_id":"67835327","addon_id":"54156428"},{"group_id":"67835327","addon_id":"54156429"}]}]},"addons":[{"group_id":67835314,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835323,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835302,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835327,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215037":{"id":215037,"name":"Grilled Chicken","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"wyxryeipwcmz4q6hen2h","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810794","name":"Portion","variations":[{"name":"Full","price":412,"default":0,"id":"18813765","inStock":1,"isVeg":0,"variant_group_id":"5810794","order":0},{"name":"Half","price":210,"default":1,"id":"18813764","inStock":1,"isVeg":0,"variant_group_id":"5810794","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810794","variation_id":"18813765"}],"price":41200,"addon_combinations":[{"group_id":"67835557","addon_id":"54156436"},{"group_id":"67835557","addon_id":"54156437"},{"group_id":"67835557","addon_id":"54156438"},{"group_id":"67835568","addon_id":"54156457"},{"group_id":"67835568","addon_id":"54156458"},{"group_id":"67835568","addon_id":"54156459"},{"group_id":"67835568","addon_id":"54156460"},{"group_id":"67835568","addon_id":"54156461"},{"group_id":"67835568","addon_id":"54156462"},{"group_id":"67835542","addon_id":"54156450"},{"group_id":"67835542","addon_id":"54156451"},{"group_id":"67835542","addon_id":"54156452"},{"group_id":"67835580","addon_id":"54156425"},{"group_id":"67835580","addon_id":"54156426"},{"group_id":"67835580","addon_id":"54156427"},{"group_id":"67835580","addon_id":"54156428"},{"group_id":"67835580","addon_id":"54156429"},{"group_id":"67866479","addon_id":"54168863"}]},{"variations":[{"group_id":"5810794","variation_id":"18813764"}],"price":21000,"addon_combinations":[{"group_id":"67835557","addon_id":"54156436"},{"group_id":"67835557","addon_id":"54156437"},{"group_id":"67835557","addon_id":"54156438"},{"group_id":"67835568","addon_id":"54156457"},{"group_id":"67835568","addon_id":"54156458"},{"group_id":"67835568","addon_id":"54156459"},{"group_id":"67835568","addon_id":"54156460"},{"group_id":"67835568","addon_id":"54156461"},{"group_id":"67835568","addon_id":"54156462"},{"group_id":"67835542","addon_id":"54156450"},{"group_id":"67835542","addon_id":"54156451"},{"group_id":"67835542","addon_id":"54156452"},{"group_id":"67835580","addon_id":"54156425"},{"group_id":"67835580","addon_id":"54156426"},{"group_id":"67835580","addon_id":"54156427"},{"group_id":"67835580","addon_id":"54156428"},{"group_id":"67835580","addon_id":"54156429"},{"group_id":"67866479","addon_id":"54168863"}]}]},"addons":[{"group_id":67835557,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835568,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835542,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835580,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93},{"group_id":67866479,"group_name":"Bread","choices":[{"id":54168863,"name":"Kuboos","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":92}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":21000,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"215045":{"id":215045,"name":"Mutton Raan","category":"Empire Special Mutton (Dry)","description":"","cloudinaryImageId":"gge20xy6rhc5xgr2urit","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810864","name":"Portion","variations":[{"name":"Full","price":1190,"default":0,"id":"18813962","inStock":1,"isVeg":0,"variant_group_id":"5810864","order":0},{"name":"Half","price":610,"default":1,"id":"18813961","inStock":1,"isVeg":0,"variant_group_id":"5810864","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810864","variation_id":"18813962"}],"price":119000,"addon_combinations":[{"group_id":"67837388","addon_id":"54156436"},{"group_id":"67837388","addon_id":"54156437"},{"group_id":"67837388","addon_id":"54156438"},{"group_id":"67837378","addon_id":"54156450"},{"group_id":"67837378","addon_id":"54156451"},{"group_id":"67837378","addon_id":"54156452"},{"group_id":"67837396","addon_id":"54156425"},{"group_id":"67837396","addon_id":"54156426"},{"group_id":"67837396","addon_id":"54156427"},{"group_id":"67837396","addon_id":"54156428"},{"group_id":"67837396","addon_id":"54156429"}]},{"variations":[{"group_id":"5810864","variation_id":"18813961"}],"price":61000,"addon_combinations":[{"group_id":"67837388","addon_id":"54156436"},{"group_id":"67837388","addon_id":"54156437"},{"group_id":"67837388","addon_id":"54156438"},{"group_id":"67837378","addon_id":"54156450"},{"group_id":"67837378","addon_id":"54156451"},{"group_id":"67837378","addon_id":"54156452"},{"group_id":"67837396","addon_id":"54156425"},{"group_id":"67837396","addon_id":"54156426"},{"group_id":"67837396","addon_id":"54156427"},{"group_id":"67837396","addon_id":"54156428"},{"group_id":"67837396","addon_id":"54156429"}]}]},"addons":[{"group_id":67837388,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837378,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67837396,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":61000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215067":{"id":215067,"name":"Green Salad","category":"Salads","description":"","cloudinaryImageId":"un1hkz8tobnfonsmllh0","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":9500,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215068":{"id":215068,"name":"Aloo Masala","category":"Veg Gravy","description":"","cloudinaryImageId":"evvmainq9mnv616adg3b","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810840","name":"Portion ","variations":[{"name":"Half","price":165,"default":0,"id":"18813895","inStock":1,"isVeg":1,"variant_group_id":"5810840","order":0},{"name":"Qtr","price":95,"default":1,"id":"18813894","inStock":1,"isVeg":1,"variant_group_id":"5810840","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810840","variation_id":"18813895"}],"price":16500,"addon_combinations":[{"group_id":"68923539","addon_id":"54935012"},{"group_id":"67836579","addon_id":"54156416"},{"group_id":"67836579","addon_id":"54156417"},{"group_id":"67836579","addon_id":"54156418"},{"group_id":"67836591","addon_id":"54156419"},{"group_id":"67836591","addon_id":"54156420"},{"group_id":"67836591","addon_id":"54156421"},{"group_id":"67836591","addon_id":"54156422"},{"group_id":"67836591","addon_id":"54156423"},{"group_id":"67836591","addon_id":"54156424"},{"group_id":"67836602","addon_id":"54156425"},{"group_id":"67836602","addon_id":"54156426"},{"group_id":"67836602","addon_id":"54156427"},{"group_id":"67836602","addon_id":"54156428"},{"group_id":"67836602","addon_id":"54156429"}]},{"variations":[{"group_id":"5810840","variation_id":"18813894"}],"price":9500,"addon_combinations":[{"group_id":"68923539","addon_id":"54935012"},{"group_id":"67836579","addon_id":"54156416"},{"group_id":"67836579","addon_id":"54156417"},{"group_id":"67836579","addon_id":"54156418"},{"group_id":"67836591","addon_id":"54156419"},{"group_id":"67836591","addon_id":"54156420"},{"group_id":"67836591","addon_id":"54156421"},{"group_id":"67836591","addon_id":"54156422"},{"group_id":"67836591","addon_id":"54156423"},{"group_id":"67836591","addon_id":"54156424"},{"group_id":"67836602","addon_id":"54156425"},{"group_id":"67836602","addon_id":"54156426"},{"group_id":"67836602","addon_id":"54156427"},{"group_id":"67836602","addon_id":"54156428"},{"group_id":"67836602","addon_id":"54156429"}]}]},"addons":[{"group_id":68923539,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836579,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836591,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836602,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9500,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215075":{"id":215075,"name":"Paneer Tikka Masala","category":"North Indian Veg (gravy)","description":"","cloudinaryImageId":"tyrlfm9g8r18zdarvhsv","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810852","name":"Portion ","variations":[{"name":"Half","price":235,"default":0,"id":"18813928","inStock":1,"isVeg":1,"variant_group_id":"5810852","order":0},{"name":"Qtr","price":130,"default":1,"id":"18813927","inStock":1,"isVeg":1,"variant_group_id":"5810852","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810852","variation_id":"18813928"}],"price":23500,"addon_combinations":[{"group_id":"68923572","addon_id":"54935012"},{"group_id":"67836888","addon_id":"54156416"},{"group_id":"67836888","addon_id":"54156417"},{"group_id":"67836888","addon_id":"54156418"},{"group_id":"67836894","addon_id":"54156419"},{"group_id":"67836894","addon_id":"54156420"},{"group_id":"67836894","addon_id":"54156421"},{"group_id":"67836894","addon_id":"54156422"},{"group_id":"67836894","addon_id":"54156423"},{"group_id":"67836894","addon_id":"54156424"},{"group_id":"67836919","addon_id":"54156425"},{"group_id":"67836919","addon_id":"54156426"},{"group_id":"67836919","addon_id":"54156427"},{"group_id":"67836919","addon_id":"54156428"},{"group_id":"67836919","addon_id":"54156429"}]},{"variations":[{"group_id":"5810852","variation_id":"18813927"}],"price":13000,"addon_combinations":[{"group_id":"68923572","addon_id":"54935012"},{"group_id":"67836888","addon_id":"54156416"},{"group_id":"67836888","addon_id":"54156417"},{"group_id":"67836888","addon_id":"54156418"},{"group_id":"67836894","addon_id":"54156419"},{"group_id":"67836894","addon_id":"54156420"},{"group_id":"67836894","addon_id":"54156421"},{"group_id":"67836894","addon_id":"54156422"},{"group_id":"67836894","addon_id":"54156423"},{"group_id":"67836894","addon_id":"54156424"},{"group_id":"67836919","addon_id":"54156425"},{"group_id":"67836919","addon_id":"54156426"},{"group_id":"67836919","addon_id":"54156427"},{"group_id":"67836919","addon_id":"54156428"},{"group_id":"67836919","addon_id":"54156429"}]}]},"addons":[{"group_id":68923572,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836888,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836894,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836919,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215084":{"id":215084,"name":"Paneer Butter Masala","category":"Veg Gravy","description":"","cloudinaryImageId":"aebk3ggsozr3gtijronv","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810851","name":"Portion ","variations":[{"name":"Half","price":185,"default":0,"id":"18813925","inStock":1,"isVeg":1,"variant_group_id":"5810851","order":0},{"name":"Qtr","price":110,"default":1,"id":"18813924","inStock":1,"isVeg":1,"variant_group_id":"5810851","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810851","variation_id":"18813925"}],"price":18500,"addon_combinations":[{"group_id":"68923559","addon_id":"54935012"},{"group_id":"67836806","addon_id":"54156416"},{"group_id":"67836806","addon_id":"54156417"},{"group_id":"67836806","addon_id":"54156418"},{"group_id":"67836836","addon_id":"54156419"},{"group_id":"67836836","addon_id":"54156420"},{"group_id":"67836836","addon_id":"54156421"},{"group_id":"67836836","addon_id":"54156422"},{"group_id":"67836836","addon_id":"54156423"},{"group_id":"67836836","addon_id":"54156424"},{"group_id":"67836847","addon_id":"54156425"},{"group_id":"67836847","addon_id":"54156426"},{"group_id":"67836847","addon_id":"54156427"},{"group_id":"67836847","addon_id":"54156428"},{"group_id":"67836847","addon_id":"54156429"}]},{"variations":[{"group_id":"5810851","variation_id":"18813924"}],"price":11000,"addon_combinations":[{"group_id":"68923559","addon_id":"54935012"},{"group_id":"67836806","addon_id":"54156416"},{"group_id":"67836806","addon_id":"54156417"},{"group_id":"67836806","addon_id":"54156418"},{"group_id":"67836836","addon_id":"54156419"},{"group_id":"67836836","addon_id":"54156420"},{"group_id":"67836836","addon_id":"54156421"},{"group_id":"67836836","addon_id":"54156422"},{"group_id":"67836836","addon_id":"54156423"},{"group_id":"67836836","addon_id":"54156424"},{"group_id":"67836847","addon_id":"54156425"},{"group_id":"67836847","addon_id":"54156426"},{"group_id":"67836847","addon_id":"54156427"},{"group_id":"67836847","addon_id":"54156428"},{"group_id":"67836847","addon_id":"54156429"}]}]},"addons":[{"group_id":68923559,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836806,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836836,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836847,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":11000,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"215089":{"id":215089,"name":"Dal Fry","category":"Veg Gravy","description":"","cloudinaryImageId":"jxxtujwekfghedg6axk1","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810896","name":"Portion ","variations":[{"name":"Half","price":125,"default":0,"id":"18814050","inStock":1,"isVeg":1,"variant_group_id":"5810896","order":0},{"name":"Qtr","price":70,"default":1,"id":"18814049","inStock":1,"isVeg":1,"variant_group_id":"5810896","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810896","variation_id":"18814050"}],"price":12500,"addon_combinations":[{"group_id":"68923715","addon_id":"54935012"},{"group_id":"67838709","addon_id":"54156416"},{"group_id":"67838709","addon_id":"54156417"},{"group_id":"67838709","addon_id":"54156418"},{"group_id":"67838720","addon_id":"54156419"},{"group_id":"67838720","addon_id":"54156420"},{"group_id":"67838720","addon_id":"54156421"},{"group_id":"67838720","addon_id":"54156422"},{"group_id":"67838720","addon_id":"54156423"},{"group_id":"67838720","addon_id":"54156424"},{"group_id":"67838750","addon_id":"54156425"},{"group_id":"67838750","addon_id":"54156426"},{"group_id":"67838750","addon_id":"54156427"},{"group_id":"67838750","addon_id":"54156428"},{"group_id":"67838750","addon_id":"54156429"}]},{"variations":[{"group_id":"5810896","variation_id":"18814049"}],"price":7000,"addon_combinations":[{"group_id":"68923715","addon_id":"54935012"},{"group_id":"67838709","addon_id":"54156416"},{"group_id":"67838709","addon_id":"54156417"},{"group_id":"67838709","addon_id":"54156418"},{"group_id":"67838720","addon_id":"54156419"},{"group_id":"67838720","addon_id":"54156420"},{"group_id":"67838720","addon_id":"54156421"},{"group_id":"67838720","addon_id":"54156422"},{"group_id":"67838720","addon_id":"54156423"},{"group_id":"67838720","addon_id":"54156424"},{"group_id":"67838750","addon_id":"54156425"},{"group_id":"67838750","addon_id":"54156426"},{"group_id":"67838750","addon_id":"54156427"},{"group_id":"67838750","addon_id":"54156428"},{"group_id":"67838750","addon_id":"54156429"}]}]},"addons":[{"group_id":68923715,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67838709,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67838720,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838750,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215091":{"id":215091,"name":"Egg Masala","category":"Egg Item","description":"","cloudinaryImageId":"nfzt7u6m5oqvohhvejq7","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810826","name":"Portion ","variations":[{"name":"Full","price":220,"default":0,"id":"18813856","inStock":1,"isVeg":0,"variant_group_id":"5810826","order":0},{"name":"Half","price":115,"default":1,"id":"18813855","inStock":1,"isVeg":0,"variant_group_id":"5810826","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810826","variation_id":"18813856"}],"price":22000,"addon_combinations":[{"group_id":"68923499","addon_id":"54935012"},{"group_id":"67836076","addon_id":"54156416"},{"group_id":"67836076","addon_id":"54156417"},{"group_id":"67836076","addon_id":"54156418"}]},{"variations":[{"group_id":"5810826","variation_id":"18813855"}],"price":11500,"addon_combinations":[{"group_id":"68923499","addon_id":"54935012"},{"group_id":"67836076","addon_id":"54156416"},{"group_id":"67836076","addon_id":"54156417"},{"group_id":"67836076","addon_id":"54156418"}]}]},"addons":[{"group_id":68923499,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836076,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":11500,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215092":{"id":215092,"name":"Egg Omelette","category":"Egg Item","description":"","cloudinaryImageId":"mkh1a6yrfor6cqvr1tua","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":8000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215100":{"id":215100,"name":"Chicken Manchurian Masala","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"ks5nvn1d9ufzq7bxifvu","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810913","name":"Portion","variations":[{"name":"Full","price":485,"default":0,"id":"18814099","inStock":1,"isVeg":0,"variant_group_id":"5810913","order":0},{"name":"Half","price":255,"default":0,"id":"18814098","inStock":1,"isVeg":0,"variant_group_id":"5810913","order":0},{"name":"Qtr","price":145,"default":1,"id":"18814097","inStock":1,"isVeg":0,"variant_group_id":"5810913","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810913","variation_id":"18814099"}],"price":48500,"addon_combinations":[{"group_id":"68923885","addon_id":"54935012"},{"group_id":"67840048","addon_id":"54156416"},{"group_id":"67840048","addon_id":"54156417"},{"group_id":"67840048","addon_id":"54156418"},{"group_id":"67840057","addon_id":"54156419"},{"group_id":"67840057","addon_id":"54156420"},{"group_id":"67840057","addon_id":"54156421"},{"group_id":"67840057","addon_id":"54156422"},{"group_id":"67840057","addon_id":"54156423"},{"group_id":"67840057","addon_id":"54156424"},{"group_id":"67840080","addon_id":"54156425"},{"group_id":"67840080","addon_id":"54156426"},{"group_id":"67840080","addon_id":"54156427"},{"group_id":"67840080","addon_id":"54156428"},{"group_id":"67840080","addon_id":"54156429"}]},{"variations":[{"group_id":"5810913","variation_id":"18814098"}],"price":25500,"addon_combinations":[{"group_id":"68923885","addon_id":"54935012"},{"group_id":"67840048","addon_id":"54156416"},{"group_id":"67840048","addon_id":"54156417"},{"group_id":"67840048","addon_id":"54156418"},{"group_id":"67840057","addon_id":"54156419"},{"group_id":"67840057","addon_id":"54156420"},{"group_id":"67840057","addon_id":"54156421"},{"group_id":"67840057","addon_id":"54156422"},{"group_id":"67840057","addon_id":"54156423"},{"group_id":"67840057","addon_id":"54156424"},{"group_id":"67840080","addon_id":"54156425"},{"group_id":"67840080","addon_id":"54156426"},{"group_id":"67840080","addon_id":"54156427"},{"group_id":"67840080","addon_id":"54156428"},{"group_id":"67840080","addon_id":"54156429"}]},{"variations":[{"group_id":"5810913","variation_id":"18814097"}],"price":14500,"addon_combinations":[{"group_id":"68923885","addon_id":"54935012"},{"group_id":"67840048","addon_id":"54156416"},{"group_id":"67840048","addon_id":"54156417"},{"group_id":"67840048","addon_id":"54156418"},{"group_id":"67840057","addon_id":"54156419"},{"group_id":"67840057","addon_id":"54156420"},{"group_id":"67840057","addon_id":"54156421"},{"group_id":"67840057","addon_id":"54156422"},{"group_id":"67840057","addon_id":"54156423"},{"group_id":"67840057","addon_id":"54156424"},{"group_id":"67840080","addon_id":"54156425"},{"group_id":"67840080","addon_id":"54156426"},{"group_id":"67840080","addon_id":"54156427"},{"group_id":"67840080","addon_id":"54156428"},{"group_id":"67840080","addon_id":"54156429"}]}]},"addons":[{"group_id":68923885,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67840048,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67840057,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840080,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215108":{"id":215108,"name":"Chicken Masala","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"jnd6i6omxpfa3nosk8zy","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810791","name":"Portion","variations":[{"name":"Full","price":474,"default":0,"id":"18813757","inStock":1,"isVeg":0,"variant_group_id":"5810791","order":0},{"name":"Half","price":250,"default":0,"id":"18813756","inStock":1,"isVeg":0,"variant_group_id":"5810791","order":0},{"name":"Qtr","price":140,"default":1,"id":"18813755","inStock":1,"isVeg":0,"variant_group_id":"5810791","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810791","variation_id":"18813757"}],"price":47400,"addon_combinations":[{"group_id":"68923309","addon_id":"54935012"},{"group_id":"67835406","addon_id":"54156416"},{"group_id":"67835406","addon_id":"54156417"},{"group_id":"67835406","addon_id":"54156418"},{"group_id":"67835411","addon_id":"54156419"},{"group_id":"67835411","addon_id":"54156420"},{"group_id":"67835411","addon_id":"54156421"},{"group_id":"67835411","addon_id":"54156422"},{"group_id":"67835411","addon_id":"54156423"},{"group_id":"67835411","addon_id":"54156424"},{"group_id":"67835429","addon_id":"54156425"},{"group_id":"67835429","addon_id":"54156426"},{"group_id":"67835429","addon_id":"54156427"},{"group_id":"67835429","addon_id":"54156428"},{"group_id":"67835429","addon_id":"54156429"}]},{"variations":[{"group_id":"5810791","variation_id":"18813756"}],"price":25000,"addon_combinations":[{"group_id":"68923309","addon_id":"54935012"},{"group_id":"67835406","addon_id":"54156416"},{"group_id":"67835406","addon_id":"54156417"},{"group_id":"67835406","addon_id":"54156418"},{"group_id":"67835411","addon_id":"54156419"},{"group_id":"67835411","addon_id":"54156420"},{"group_id":"67835411","addon_id":"54156421"},{"group_id":"67835411","addon_id":"54156422"},{"group_id":"67835411","addon_id":"54156423"},{"group_id":"67835411","addon_id":"54156424"},{"group_id":"67835429","addon_id":"54156425"},{"group_id":"67835429","addon_id":"54156426"},{"group_id":"67835429","addon_id":"54156427"},{"group_id":"67835429","addon_id":"54156428"},{"group_id":"67835429","addon_id":"54156429"}]},{"variations":[{"group_id":"5810791","variation_id":"18813755"}],"price":14000,"addon_combinations":[{"group_id":"68923309","addon_id":"54935012"},{"group_id":"67835406","addon_id":"54156416"},{"group_id":"67835406","addon_id":"54156417"},{"group_id":"67835406","addon_id":"54156418"},{"group_id":"67835411","addon_id":"54156419"},{"group_id":"67835411","addon_id":"54156420"},{"group_id":"67835411","addon_id":"54156421"},{"group_id":"67835411","addon_id":"54156422"},{"group_id":"67835411","addon_id":"54156423"},{"group_id":"67835411","addon_id":"54156424"},{"group_id":"67835429","addon_id":"54156425"},{"group_id":"67835429","addon_id":"54156426"},{"group_id":"67835429","addon_id":"54156427"},{"group_id":"67835429","addon_id":"54156428"},{"group_id":"67835429","addon_id":"54156429"}]}]},"addons":[{"group_id":68923309,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67835406,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67835411,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835429,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215110":{"id":215110,"name":"Chicken Tikka Masala","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"icpycagtwmqflonmjud8","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810906","name":"Portion","variations":[{"name":"Full","price":505,"default":0,"id":"18814079","inStock":1,"isVeg":0,"variant_group_id":"5810906","order":0},{"name":"Half","price":268,"default":0,"id":"18814078","inStock":1,"isVeg":0,"variant_group_id":"5810906","order":0},{"name":"Qtr","price":150,"default":1,"id":"18814077","inStock":1,"isVeg":0,"variant_group_id":"5810906","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810906","variation_id":"18814079"}],"price":50500,"addon_combinations":[{"group_id":"68923857","addon_id":"54935012"},{"group_id":"67839762","addon_id":"54156416"},{"group_id":"67839762","addon_id":"54156417"},{"group_id":"67839762","addon_id":"54156418"},{"group_id":"67839769","addon_id":"54156419"},{"group_id":"67839769","addon_id":"54156420"},{"group_id":"67839769","addon_id":"54156421"},{"group_id":"67839769","addon_id":"54156422"},{"group_id":"67839769","addon_id":"54156423"},{"group_id":"67839769","addon_id":"54156424"},{"group_id":"67839808","addon_id":"54156425"},{"group_id":"67839808","addon_id":"54156426"},{"group_id":"67839808","addon_id":"54156427"},{"group_id":"67839808","addon_id":"54156428"},{"group_id":"67839808","addon_id":"54156429"}]},{"variations":[{"group_id":"5810906","variation_id":"18814078"}],"price":26800,"addon_combinations":[{"group_id":"68923857","addon_id":"54935012"},{"group_id":"67839762","addon_id":"54156416"},{"group_id":"67839762","addon_id":"54156417"},{"group_id":"67839762","addon_id":"54156418"},{"group_id":"67839769","addon_id":"54156419"},{"group_id":"67839769","addon_id":"54156420"},{"group_id":"67839769","addon_id":"54156421"},{"group_id":"67839769","addon_id":"54156422"},{"group_id":"67839769","addon_id":"54156423"},{"group_id":"67839769","addon_id":"54156424"},{"group_id":"67839808","addon_id":"54156425"},{"group_id":"67839808","addon_id":"54156426"},{"group_id":"67839808","addon_id":"54156427"},{"group_id":"67839808","addon_id":"54156428"},{"group_id":"67839808","addon_id":"54156429"}]},{"variations":[{"group_id":"5810906","variation_id":"18814077"}],"price":15000,"addon_combinations":[{"group_id":"68923857","addon_id":"54935012"},{"group_id":"67839762","addon_id":"54156416"},{"group_id":"67839762","addon_id":"54156417"},{"group_id":"67839762","addon_id":"54156418"},{"group_id":"67839769","addon_id":"54156419"},{"group_id":"67839769","addon_id":"54156420"},{"group_id":"67839769","addon_id":"54156421"},{"group_id":"67839769","addon_id":"54156422"},{"group_id":"67839769","addon_id":"54156423"},{"group_id":"67839769","addon_id":"54156424"},{"group_id":"67839808","addon_id":"54156425"},{"group_id":"67839808","addon_id":"54156426"},{"group_id":"67839808","addon_id":"54156427"},{"group_id":"67839808","addon_id":"54156428"},{"group_id":"67839808","addon_id":"54156429"}]}]},"addons":[{"group_id":68923857,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67839762,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67839769,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67839808,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":15000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215111":{"id":215111,"name":"Chicken Tandoori Masala","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"l9jc37cdfdc0nnpk49ln","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810917","name":"Portion","variations":[{"name":"Full","price":500,"default":0,"id":"18814109","inStock":1,"isVeg":0,"variant_group_id":"5810917","order":0},{"name":"Half","price":270,"default":0,"id":"18814108","inStock":1,"isVeg":0,"variant_group_id":"5810917","order":0},{"name":"Qtr","price":155,"default":1,"id":"18814107","inStock":1,"isVeg":0,"variant_group_id":"5810917","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810917","variation_id":"18814109"}],"price":50000,"addon_combinations":[{"group_id":"68923893","addon_id":"54935012"},{"group_id":"67840315","addon_id":"54156416"},{"group_id":"67840315","addon_id":"54156417"},{"group_id":"67840315","addon_id":"54156418"},{"group_id":"67840319","addon_id":"54156419"},{"group_id":"67840319","addon_id":"54156420"},{"group_id":"67840319","addon_id":"54156421"},{"group_id":"67840319","addon_id":"54156422"},{"group_id":"67840319","addon_id":"54156423"},{"group_id":"67840319","addon_id":"54156424"},{"group_id":"67840339","addon_id":"54156425"},{"group_id":"67840339","addon_id":"54156426"},{"group_id":"67840339","addon_id":"54156427"},{"group_id":"67840339","addon_id":"54156428"},{"group_id":"67840339","addon_id":"54156429"}]},{"variations":[{"group_id":"5810917","variation_id":"18814108"}],"price":27000,"addon_combinations":[{"group_id":"68923893","addon_id":"54935012"},{"group_id":"67840315","addon_id":"54156416"},{"group_id":"67840315","addon_id":"54156417"},{"group_id":"67840315","addon_id":"54156418"},{"group_id":"67840319","addon_id":"54156419"},{"group_id":"67840319","addon_id":"54156420"},{"group_id":"67840319","addon_id":"54156421"},{"group_id":"67840319","addon_id":"54156422"},{"group_id":"67840319","addon_id":"54156423"},{"group_id":"67840319","addon_id":"54156424"},{"group_id":"67840339","addon_id":"54156425"},{"group_id":"67840339","addon_id":"54156426"},{"group_id":"67840339","addon_id":"54156427"},{"group_id":"67840339","addon_id":"54156428"},{"group_id":"67840339","addon_id":"54156429"}]},{"variations":[{"group_id":"5810917","variation_id":"18814107"}],"price":15500,"addon_combinations":[{"group_id":"68923893","addon_id":"54935012"},{"group_id":"67840315","addon_id":"54156416"},{"group_id":"67840315","addon_id":"54156417"},{"group_id":"67840315","addon_id":"54156418"},{"group_id":"67840319","addon_id":"54156419"},{"group_id":"67840319","addon_id":"54156420"},{"group_id":"67840319","addon_id":"54156421"},{"group_id":"67840319","addon_id":"54156422"},{"group_id":"67840319","addon_id":"54156423"},{"group_id":"67840319","addon_id":"54156424"},{"group_id":"67840339","addon_id":"54156425"},{"group_id":"67840339","addon_id":"54156426"},{"group_id":"67840339","addon_id":"54156427"},{"group_id":"67840339","addon_id":"54156428"},{"group_id":"67840339","addon_id":"54156429"}]}]},"addons":[{"group_id":68923893,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67840315,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67840319,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840339,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":15500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215113":{"id":215113,"name":"Kadai Chicken Gravy","category":"North Indian Non Veg (gravy)","description":"","cloudinaryImageId":"sw1jachllyur2m1eew2c","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"9996806","name":"Portion ","variations":[{"name":"Full","price":474,"default":0,"id":"33010918","inStock":1,"isVeg":0,"variant_group_id":"9996806","order":0},{"name":"Half","price":250,"default":0,"id":"33010919","inStock":1,"isVeg":0,"variant_group_id":"9996806","order":0},{"name":"Qtr","price":140,"default":1,"id":"33010920","inStock":1,"isVeg":0,"variant_group_id":"9996806","order":0}]}],"pricing_models":[{"variations":[{"group_id":"9996806","variation_id":"33010918"}],"price":47400,"addon_combinations":[{"group_id":"68923698","addon_id":"54935012"},{"group_id":"67838631","addon_id":"54156416"},{"group_id":"67838631","addon_id":"54156417"},{"group_id":"67838631","addon_id":"54156418"},{"group_id":"67838645","addon_id":"54156419"},{"group_id":"67838645","addon_id":"54156420"},{"group_id":"67838645","addon_id":"54156421"},{"group_id":"67838645","addon_id":"54156422"},{"group_id":"67838645","addon_id":"54156423"},{"group_id":"67838645","addon_id":"54156424"},{"group_id":"67838678","addon_id":"54156425"},{"group_id":"67838678","addon_id":"54156426"},{"group_id":"67838678","addon_id":"54156427"},{"group_id":"67838678","addon_id":"54156428"},{"group_id":"67838678","addon_id":"54156429"}]},{"variations":[{"group_id":"9996806","variation_id":"33010919"}],"price":25000,"addon_combinations":[{"group_id":"68923698","addon_id":"54935012"},{"group_id":"67838631","addon_id":"54156416"},{"group_id":"67838631","addon_id":"54156417"},{"group_id":"67838631","addon_id":"54156418"},{"group_id":"67838645","addon_id":"54156419"},{"group_id":"67838645","addon_id":"54156420"},{"group_id":"67838645","addon_id":"54156421"},{"group_id":"67838645","addon_id":"54156422"},{"group_id":"67838645","addon_id":"54156423"},{"group_id":"67838645","addon_id":"54156424"},{"group_id":"67838678","addon_id":"54156425"},{"group_id":"67838678","addon_id":"54156426"},{"group_id":"67838678","addon_id":"54156427"},{"group_id":"67838678","addon_id":"54156428"},{"group_id":"67838678","addon_id":"54156429"}]},{"variations":[{"group_id":"9996806","variation_id":"33010920"}],"price":14000,"addon_combinations":[{"group_id":"68923698","addon_id":"54935012"},{"group_id":"67838631","addon_id":"54156416"},{"group_id":"67838631","addon_id":"54156417"},{"group_id":"67838631","addon_id":"54156418"},{"group_id":"67838645","addon_id":"54156419"},{"group_id":"67838645","addon_id":"54156420"},{"group_id":"67838645","addon_id":"54156421"},{"group_id":"67838645","addon_id":"54156422"},{"group_id":"67838645","addon_id":"54156423"},{"group_id":"67838645","addon_id":"54156424"},{"group_id":"67838678","addon_id":"54156425"},{"group_id":"67838678","addon_id":"54156426"},{"group_id":"67838678","addon_id":"54156427"},{"group_id":"67838678","addon_id":"54156428"},{"group_id":"67838678","addon_id":"54156429"}]}]},"addons":[{"group_id":68923698,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67838631,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67838645,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838678,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215123":{"id":215123,"name":"Kadai Mutton Gravy","category":"North Indian Non Veg (gravy)","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810863","name":"Portion ","variations":[{"name":"Full","price":560,"default":0,"id":"18813960","inStock":1,"isVeg":0,"variant_group_id":"5810863","order":0},{"name":"Half","price":290,"default":0,"id":"18813959","inStock":1,"isVeg":0,"variant_group_id":"5810863","order":0},{"name":"Qtr","price":160,"default":1,"id":"18813958","inStock":1,"isVeg":0,"variant_group_id":"5810863","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810863","variation_id":"18813960"}],"price":56000,"addon_combinations":[]},{"variations":[{"group_id":"5810863","variation_id":"18813959"}],"price":29000,"addon_combinations":[]},{"variations":[{"group_id":"5810863","variation_id":"18813958"}],"price":16000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":16000,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215129":{"id":215129,"name":"Mutton Masala","category":"Empire Special Mutton (Gravy)","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810858","name":"Portion","variations":[{"name":"Full","price":570,"default":0,"id":"18813946","inStock":1,"isVeg":0,"variant_group_id":"5810858","order":0},{"name":"Half","price":295,"default":0,"id":"18813945","inStock":1,"isVeg":0,"variant_group_id":"5810858","order":0},{"name":"Qtr","price":170,"default":1,"id":"18813944","inStock":1,"isVeg":0,"variant_group_id":"5810858","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810858","variation_id":"18813946"}],"price":57000,"addon_combinations":[{"group_id":"68923585","addon_id":"54935012"},{"group_id":"67837041","addon_id":"54156416"},{"group_id":"67837041","addon_id":"54156417"},{"group_id":"67837041","addon_id":"54156418"},{"group_id":"67837050","addon_id":"54156419"},{"group_id":"67837050","addon_id":"54156420"},{"group_id":"67837050","addon_id":"54156421"},{"group_id":"67837050","addon_id":"54156422"},{"group_id":"67837050","addon_id":"54156423"},{"group_id":"67837050","addon_id":"54156424"},{"group_id":"67837060","addon_id":"54156425"},{"group_id":"67837060","addon_id":"54156426"},{"group_id":"67837060","addon_id":"54156427"},{"group_id":"67837060","addon_id":"54156428"},{"group_id":"67837060","addon_id":"54156429"}]},{"variations":[{"group_id":"5810858","variation_id":"18813945"}],"price":29500,"addon_combinations":[{"group_id":"68923585","addon_id":"54935012"},{"group_id":"67837041","addon_id":"54156416"},{"group_id":"67837041","addon_id":"54156417"},{"group_id":"67837041","addon_id":"54156418"},{"group_id":"67837050","addon_id":"54156419"},{"group_id":"67837050","addon_id":"54156420"},{"group_id":"67837050","addon_id":"54156421"},{"group_id":"67837050","addon_id":"54156422"},{"group_id":"67837050","addon_id":"54156423"},{"group_id":"67837050","addon_id":"54156424"},{"group_id":"67837060","addon_id":"54156425"},{"group_id":"67837060","addon_id":"54156426"},{"group_id":"67837060","addon_id":"54156427"},{"group_id":"67837060","addon_id":"54156428"},{"group_id":"67837060","addon_id":"54156429"}]},{"variations":[{"group_id":"5810858","variation_id":"18813944"}],"price":17000,"addon_combinations":[{"group_id":"68923585","addon_id":"54935012"},{"group_id":"67837041","addon_id":"54156416"},{"group_id":"67837041","addon_id":"54156417"},{"group_id":"67837041","addon_id":"54156418"},{"group_id":"67837050","addon_id":"54156419"},{"group_id":"67837050","addon_id":"54156420"},{"group_id":"67837050","addon_id":"54156421"},{"group_id":"67837050","addon_id":"54156422"},{"group_id":"67837050","addon_id":"54156423"},{"group_id":"67837050","addon_id":"54156424"},{"group_id":"67837060","addon_id":"54156425"},{"group_id":"67837060","addon_id":"54156426"},{"group_id":"67837060","addon_id":"54156427"},{"group_id":"67837060","addon_id":"54156428"},{"group_id":"67837060","addon_id":"54156429"}]}]},"addons":[{"group_id":68923585,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67837041,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67837050,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837060,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215131":{"id":215131,"name":"Mutton Brain Masala","category":"Empire Special Mutton (Gravy)","description":"","cloudinaryImageId":"adqdbgha4yupdvrd3lmx","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810785","name":"Portion","variations":[{"name":"Full","price":680,"default":0,"id":"18813741","inStock":1,"isVeg":0,"variant_group_id":"5810785","order":0},{"name":"Half","price":340,"default":0,"id":"18813740","inStock":1,"isVeg":0,"variant_group_id":"5810785","order":0},{"name":"Qtr","price":170,"default":1,"id":"18813739","inStock":1,"isVeg":0,"variant_group_id":"5810785","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810785","variation_id":"18813741"}],"price":68000,"addon_combinations":[{"group_id":"68923299","addon_id":"54935012"},{"group_id":"67835203","addon_id":"54156416"},{"group_id":"67835203","addon_id":"54156417"},{"group_id":"67835203","addon_id":"54156418"},{"group_id":"67835208","addon_id":"54156419"},{"group_id":"67835208","addon_id":"54156420"},{"group_id":"67835208","addon_id":"54156421"},{"group_id":"67835208","addon_id":"54156422"},{"group_id":"67835208","addon_id":"54156423"},{"group_id":"67835208","addon_id":"54156424"},{"group_id":"67835217","addon_id":"54156425"},{"group_id":"67835217","addon_id":"54156426"},{"group_id":"67835217","addon_id":"54156427"},{"group_id":"67835217","addon_id":"54156428"},{"group_id":"67835217","addon_id":"54156429"}]},{"variations":[{"group_id":"5810785","variation_id":"18813740"}],"price":34000,"addon_combinations":[{"group_id":"68923299","addon_id":"54935012"},{"group_id":"67835203","addon_id":"54156416"},{"group_id":"67835203","addon_id":"54156417"},{"group_id":"67835203","addon_id":"54156418"},{"group_id":"67835208","addon_id":"54156419"},{"group_id":"67835208","addon_id":"54156420"},{"group_id":"67835208","addon_id":"54156421"},{"group_id":"67835208","addon_id":"54156422"},{"group_id":"67835208","addon_id":"54156423"},{"group_id":"67835208","addon_id":"54156424"},{"group_id":"67835217","addon_id":"54156425"},{"group_id":"67835217","addon_id":"54156426"},{"group_id":"67835217","addon_id":"54156427"},{"group_id":"67835217","addon_id":"54156428"},{"group_id":"67835217","addon_id":"54156429"}]},{"variations":[{"group_id":"5810785","variation_id":"18813739"}],"price":17000,"addon_combinations":[{"group_id":"68923299","addon_id":"54935012"},{"group_id":"67835203","addon_id":"54156416"},{"group_id":"67835203","addon_id":"54156417"},{"group_id":"67835203","addon_id":"54156418"},{"group_id":"67835208","addon_id":"54156419"},{"group_id":"67835208","addon_id":"54156420"},{"group_id":"67835208","addon_id":"54156421"},{"group_id":"67835208","addon_id":"54156422"},{"group_id":"67835208","addon_id":"54156423"},{"group_id":"67835208","addon_id":"54156424"},{"group_id":"67835217","addon_id":"54156425"},{"group_id":"67835217","addon_id":"54156426"},{"group_id":"67835217","addon_id":"54156427"},{"group_id":"67835217","addon_id":"54156428"},{"group_id":"67835217","addon_id":"54156429"}]}]},"addons":[{"group_id":68923299,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67835203,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67835208,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835217,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215135":{"id":215135,"name":"Pepper Mutton Masala","category":"Empire Special Mutton (Gravy)","description":"","cloudinaryImageId":"smhvpyjoep9h1buvkpfl","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810910","name":"Portion","variations":[{"name":"Full","price":618,"default":0,"id":"18814091","inStock":1,"isVeg":0,"variant_group_id":"5810910","order":0},{"name":"Half","price":319,"default":0,"id":"18814090","inStock":1,"isVeg":0,"variant_group_id":"5810910","order":0},{"name":"Qtr","price":170,"default":1,"id":"18814089","inStock":1,"isVeg":0,"variant_group_id":"5810910","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810910","variation_id":"18814091"}],"price":61800,"addon_combinations":[{"group_id":"68923867","addon_id":"54935012"},{"group_id":"67839945","addon_id":"54156416"},{"group_id":"67839945","addon_id":"54156417"},{"group_id":"67839945","addon_id":"54156418"},{"group_id":"67839951","addon_id":"54156419"},{"group_id":"67839951","addon_id":"54156420"},{"group_id":"67839951","addon_id":"54156421"},{"group_id":"67839951","addon_id":"54156422"},{"group_id":"67839951","addon_id":"54156423"},{"group_id":"67839951","addon_id":"54156424"},{"group_id":"67839993","addon_id":"54156425"},{"group_id":"67839993","addon_id":"54156426"},{"group_id":"67839993","addon_id":"54156427"},{"group_id":"67839993","addon_id":"54156428"},{"group_id":"67839993","addon_id":"54156429"}]},{"variations":[{"group_id":"5810910","variation_id":"18814090"}],"price":31900,"addon_combinations":[{"group_id":"68923867","addon_id":"54935012"},{"group_id":"67839945","addon_id":"54156416"},{"group_id":"67839945","addon_id":"54156417"},{"group_id":"67839945","addon_id":"54156418"},{"group_id":"67839951","addon_id":"54156419"},{"group_id":"67839951","addon_id":"54156420"},{"group_id":"67839951","addon_id":"54156421"},{"group_id":"67839951","addon_id":"54156422"},{"group_id":"67839951","addon_id":"54156423"},{"group_id":"67839951","addon_id":"54156424"},{"group_id":"67839993","addon_id":"54156425"},{"group_id":"67839993","addon_id":"54156426"},{"group_id":"67839993","addon_id":"54156427"},{"group_id":"67839993","addon_id":"54156428"},{"group_id":"67839993","addon_id":"54156429"}]},{"variations":[{"group_id":"5810910","variation_id":"18814089"}],"price":17000,"addon_combinations":[{"group_id":"68923867","addon_id":"54935012"},{"group_id":"67839945","addon_id":"54156416"},{"group_id":"67839945","addon_id":"54156417"},{"group_id":"67839945","addon_id":"54156418"},{"group_id":"67839951","addon_id":"54156419"},{"group_id":"67839951","addon_id":"54156420"},{"group_id":"67839951","addon_id":"54156421"},{"group_id":"67839951","addon_id":"54156422"},{"group_id":"67839951","addon_id":"54156423"},{"group_id":"67839951","addon_id":"54156424"},{"group_id":"67839993","addon_id":"54156425"},{"group_id":"67839993","addon_id":"54156426"},{"group_id":"67839993","addon_id":"54156427"},{"group_id":"67839993","addon_id":"54156428"},{"group_id":"67839993","addon_id":"54156429"}]}]},"addons":[{"group_id":68923867,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67839945,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67839951,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67839993,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215160":{"id":215160,"name":"Grilled Chicken Biryani","category":"Biriyani And Rice","description":"","cloudinaryImageId":"zmz8cvbu6lstifyvdftl","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"12307838","name":"Portion","variations":[{"name":"Full","price":685,"default":0,"id":"40195395","inStock":1,"isVeg":0,"variant_group_id":"12307838","order":0},{"name":"Half","price":365,"default":1,"id":"40195396","inStock":1,"isVeg":0,"variant_group_id":"12307838","order":0}]}],"pricing_models":[{"variations":[{"group_id":"12307838","variation_id":"40195395"}],"price":68500,"addon_combinations":[{"group_id":"68923415","addon_id":"54935061"},{"group_id":"67835796","addon_id":"54156416"},{"group_id":"67835796","addon_id":"54156417"},{"group_id":"67835796","addon_id":"54156418"},{"group_id":"67835816","addon_id":"54156419"},{"group_id":"67835816","addon_id":"54156420"},{"group_id":"67835816","addon_id":"54156421"},{"group_id":"67835816","addon_id":"54156422"},{"group_id":"67835816","addon_id":"54156423"},{"group_id":"67835816","addon_id":"54156424"},{"group_id":"67835809","addon_id":"54156436"},{"group_id":"67835809","addon_id":"54156437"},{"group_id":"67835809","addon_id":"54156438"},{"group_id":"67835824","addon_id":"54156457"},{"group_id":"67835824","addon_id":"54156458"},{"group_id":"67835824","addon_id":"54156459"},{"group_id":"67835824","addon_id":"54156460"},{"group_id":"67835824","addon_id":"54156461"},{"group_id":"67835824","addon_id":"54156462"},{"group_id":"67835802","addon_id":"54156450"},{"group_id":"67835802","addon_id":"54156451"},{"group_id":"67835802","addon_id":"54156452"},{"group_id":"67835792","addon_id":"17505976"},{"group_id":"67835792","addon_id":"54156510"},{"group_id":"67835828","addon_id":"54156512"},{"group_id":"67835830","addon_id":"54156425"},{"group_id":"67835830","addon_id":"54156426"},{"group_id":"67835830","addon_id":"54156427"},{"group_id":"67835830","addon_id":"54156428"},{"group_id":"67835830","addon_id":"54156429"}]},{"variations":[{"group_id":"12307838","variation_id":"40195396"}],"price":36500,"addon_combinations":[{"group_id":"68923415","addon_id":"54935061"},{"group_id":"67835796","addon_id":"54156416"},{"group_id":"67835796","addon_id":"54156417"},{"group_id":"67835796","addon_id":"54156418"},{"group_id":"67835816","addon_id":"54156419"},{"group_id":"67835816","addon_id":"54156420"},{"group_id":"67835816","addon_id":"54156421"},{"group_id":"67835816","addon_id":"54156422"},{"group_id":"67835816","addon_id":"54156423"},{"group_id":"67835816","addon_id":"54156424"},{"group_id":"67835809","addon_id":"54156436"},{"group_id":"67835809","addon_id":"54156437"},{"group_id":"67835809","addon_id":"54156438"},{"group_id":"67835824","addon_id":"54156457"},{"group_id":"67835824","addon_id":"54156458"},{"group_id":"67835824","addon_id":"54156459"},{"group_id":"67835824","addon_id":"54156460"},{"group_id":"67835824","addon_id":"54156461"},{"group_id":"67835824","addon_id":"54156462"},{"group_id":"67835802","addon_id":"54156450"},{"group_id":"67835802","addon_id":"54156451"},{"group_id":"67835802","addon_id":"54156452"},{"group_id":"67835792","addon_id":"17505976"},{"group_id":"67835792","addon_id":"54156510"},{"group_id":"67835828","addon_id":"54156512"},{"group_id":"67835830","addon_id":"54156425"},{"group_id":"67835830","addon_id":"54156426"},{"group_id":"67835830","addon_id":"54156427"},{"group_id":"67835830","addon_id":"54156428"},{"group_id":"67835830","addon_id":"54156429"}]}]},"addons":[{"group_id":68923415,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67835796,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67835816,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835809,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835824,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835802,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835792,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67835828,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67835830,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":36500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215166":{"id":215166,"name":"Ghee Rice","category":"Biriyani And Rice","description":"","cloudinaryImageId":"troivpi2v0ybmdzwwz7l","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808629","name":"Complementary","variations":[{"name":"Complementary Dal","price":99,"default":1,"id":"77096199","inStock":1,"isVeg":1,"variant_group_id":"23808629","order":100},{"name":"Complementary Red Gravy","price":99,"default":0,"id":"77096200","inStock":1,"isVeg":1,"variant_group_id":"23808629","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808629","variation_id":"77096199"}],"price":9900,"addon_combinations":[{"group_id":"67841722","addon_id":"54156419"},{"group_id":"67841722","addon_id":"54156420"},{"group_id":"67841722","addon_id":"54156421"},{"group_id":"67841722","addon_id":"54156422"},{"group_id":"67841722","addon_id":"54156423"},{"group_id":"67841722","addon_id":"54156424"},{"group_id":"67841735","addon_id":"54156457"},{"group_id":"67841735","addon_id":"54156458"},{"group_id":"67841735","addon_id":"54156459"},{"group_id":"67841735","addon_id":"54156460"},{"group_id":"67841735","addon_id":"54156461"},{"group_id":"67841735","addon_id":"54156462"},{"group_id":"67841713","addon_id":"54156450"},{"group_id":"67841713","addon_id":"54156451"},{"group_id":"67841713","addon_id":"54156452"},{"group_id":"67841710","addon_id":"17505976"},{"group_id":"67841710","addon_id":"54156510"},{"group_id":"67841749","addon_id":"54156512"},{"group_id":"67841754","addon_id":"54156425"},{"group_id":"67841754","addon_id":"54156426"},{"group_id":"67841754","addon_id":"54156427"},{"group_id":"67841754","addon_id":"54156428"},{"group_id":"67841754","addon_id":"54156429"}]},{"variations":[{"group_id":"23808629","variation_id":"77096200"}],"price":9900,"addon_combinations":[{"group_id":"67841722","addon_id":"54156419"},{"group_id":"67841722","addon_id":"54156420"},{"group_id":"67841722","addon_id":"54156421"},{"group_id":"67841722","addon_id":"54156422"},{"group_id":"67841722","addon_id":"54156423"},{"group_id":"67841722","addon_id":"54156424"},{"group_id":"67841735","addon_id":"54156457"},{"group_id":"67841735","addon_id":"54156458"},{"group_id":"67841735","addon_id":"54156459"},{"group_id":"67841735","addon_id":"54156460"},{"group_id":"67841735","addon_id":"54156461"},{"group_id":"67841735","addon_id":"54156462"},{"group_id":"67841713","addon_id":"54156450"},{"group_id":"67841713","addon_id":"54156451"},{"group_id":"67841713","addon_id":"54156452"},{"group_id":"67841710","addon_id":"17505976"},{"group_id":"67841710","addon_id":"54156510"},{"group_id":"67841749","addon_id":"54156512"},{"group_id":"67841754","addon_id":"54156425"},{"group_id":"67841754","addon_id":"54156426"},{"group_id":"67841754","addon_id":"54156427"},{"group_id":"67841754","addon_id":"54156428"},{"group_id":"67841754","addon_id":"54156429"}]}]},"addons":[{"group_id":67841722,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67841735,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841713,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841710,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67841749,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67841754,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"215167":{"id":215167,"name":"Lemon Rice","category":"Biriyani And Rice","description":"","cloudinaryImageId":"vgmmxxdnxv06pjgf3ksw","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808621","name":"Complementary","variations":[{"name":"Complementary Dal","price":136,"default":1,"id":"77096183","inStock":1,"isVeg":1,"variant_group_id":"23808621","order":100},{"name":"Complementary Red Gravy","price":136,"default":0,"id":"77096184","inStock":1,"isVeg":1,"variant_group_id":"23808621","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808621","variation_id":"77096183"}],"price":13600,"addon_combinations":[{"group_id":"67841561","addon_id":"54156419"},{"group_id":"67841561","addon_id":"54156420"},{"group_id":"67841561","addon_id":"54156421"},{"group_id":"67841561","addon_id":"54156422"},{"group_id":"67841561","addon_id":"54156423"},{"group_id":"67841561","addon_id":"54156424"},{"group_id":"67841578","addon_id":"54156457"},{"group_id":"67841578","addon_id":"54156458"},{"group_id":"67841578","addon_id":"54156459"},{"group_id":"67841578","addon_id":"54156460"},{"group_id":"67841578","addon_id":"54156461"},{"group_id":"67841578","addon_id":"54156462"},{"group_id":"67841555","addon_id":"54156450"},{"group_id":"67841555","addon_id":"54156451"},{"group_id":"67841555","addon_id":"54156452"},{"group_id":"67841551","addon_id":"17505976"},{"group_id":"67841551","addon_id":"54156510"},{"group_id":"67841593","addon_id":"54156512"},{"group_id":"67841598","addon_id":"54156425"},{"group_id":"67841598","addon_id":"54156426"},{"group_id":"67841598","addon_id":"54156427"},{"group_id":"67841598","addon_id":"54156428"},{"group_id":"67841598","addon_id":"54156429"}]},{"variations":[{"group_id":"23808621","variation_id":"77096184"}],"price":13600,"addon_combinations":[{"group_id":"67841561","addon_id":"54156419"},{"group_id":"67841561","addon_id":"54156420"},{"group_id":"67841561","addon_id":"54156421"},{"group_id":"67841561","addon_id":"54156422"},{"group_id":"67841561","addon_id":"54156423"},{"group_id":"67841561","addon_id":"54156424"},{"group_id":"67841578","addon_id":"54156457"},{"group_id":"67841578","addon_id":"54156458"},{"group_id":"67841578","addon_id":"54156459"},{"group_id":"67841578","addon_id":"54156460"},{"group_id":"67841578","addon_id":"54156461"},{"group_id":"67841578","addon_id":"54156462"},{"group_id":"67841555","addon_id":"54156450"},{"group_id":"67841555","addon_id":"54156451"},{"group_id":"67841555","addon_id":"54156452"},{"group_id":"67841551","addon_id":"17505976"},{"group_id":"67841551","addon_id":"54156510"},{"group_id":"67841593","addon_id":"54156512"},{"group_id":"67841598","addon_id":"54156425"},{"group_id":"67841598","addon_id":"54156426"},{"group_id":"67841598","addon_id":"54156427"},{"group_id":"67841598","addon_id":"54156428"},{"group_id":"67841598","addon_id":"54156429"}]}]},"addons":[{"group_id":67841561,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67841578,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841555,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841551,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67841593,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67841598,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13600,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215168":{"id":215168,"name":"Jeera Rice","category":"Biriyani And Rice","description":"","cloudinaryImageId":"vk0r9hgvonmw9zd4ymwp","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808622","name":"Complementary","variations":[{"name":"Complementary Dal","price":136,"default":1,"id":"77096185","inStock":1,"isVeg":1,"variant_group_id":"23808622","order":100},{"name":"Complementary Red Gravy","price":136,"default":0,"id":"77096186","inStock":1,"isVeg":1,"variant_group_id":"23808622","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808622","variation_id":"77096185"}],"price":13600,"addon_combinations":[{"group_id":"67841638","addon_id":"54156419"},{"group_id":"67841638","addon_id":"54156420"},{"group_id":"67841638","addon_id":"54156421"},{"group_id":"67841638","addon_id":"54156422"},{"group_id":"67841638","addon_id":"54156423"},{"group_id":"67841638","addon_id":"54156424"},{"group_id":"67841668","addon_id":"54156457"},{"group_id":"67841668","addon_id":"54156458"},{"group_id":"67841668","addon_id":"54156459"},{"group_id":"67841668","addon_id":"54156460"},{"group_id":"67841668","addon_id":"54156461"},{"group_id":"67841668","addon_id":"54156462"},{"group_id":"67841633","addon_id":"54156450"},{"group_id":"67841633","addon_id":"54156451"},{"group_id":"67841633","addon_id":"54156452"},{"group_id":"67841630","addon_id":"17505976"},{"group_id":"67841630","addon_id":"54156510"},{"group_id":"67841685","addon_id":"54156512"},{"group_id":"67841688","addon_id":"54156425"},{"group_id":"67841688","addon_id":"54156426"},{"group_id":"67841688","addon_id":"54156427"},{"group_id":"67841688","addon_id":"54156428"},{"group_id":"67841688","addon_id":"54156429"}]},{"variations":[{"group_id":"23808622","variation_id":"77096186"}],"price":13600,"addon_combinations":[{"group_id":"67841638","addon_id":"54156419"},{"group_id":"67841638","addon_id":"54156420"},{"group_id":"67841638","addon_id":"54156421"},{"group_id":"67841638","addon_id":"54156422"},{"group_id":"67841638","addon_id":"54156423"},{"group_id":"67841638","addon_id":"54156424"},{"group_id":"67841668","addon_id":"54156457"},{"group_id":"67841668","addon_id":"54156458"},{"group_id":"67841668","addon_id":"54156459"},{"group_id":"67841668","addon_id":"54156460"},{"group_id":"67841668","addon_id":"54156461"},{"group_id":"67841668","addon_id":"54156462"},{"group_id":"67841633","addon_id":"54156450"},{"group_id":"67841633","addon_id":"54156451"},{"group_id":"67841633","addon_id":"54156452"},{"group_id":"67841630","addon_id":"17505976"},{"group_id":"67841630","addon_id":"54156510"},{"group_id":"67841685","addon_id":"54156512"},{"group_id":"67841688","addon_id":"54156425"},{"group_id":"67841688","addon_id":"54156426"},{"group_id":"67841688","addon_id":"54156427"},{"group_id":"67841688","addon_id":"54156428"},{"group_id":"67841688","addon_id":"54156429"}]}]},"addons":[{"group_id":67841638,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67841668,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841633,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841630,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67841685,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67841688,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13600,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215169":{"id":215169,"name":"Curd Rice","category":"Biriyani And Rice","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":13600,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67844116,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67844149,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67844104,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67844096,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67844177,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215171":{"id":215171,"name":"Tandoori Roti","category":"Rotis","description":"","cloudinaryImageId":"w3yfetb1zmaa7yawvmbg","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":3100,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67837261,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837273,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837281,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215173":{"id":215173,"name":"Butter Roti","category":"Rotis","description":"","cloudinaryImageId":"svkp2zkf11nyaz7w6vs1","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":3500,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67836402,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836415,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67836422,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215175":{"id":215175,"name":"Kulcha","category":"Rotis","description":"","cloudinaryImageId":"bzdjx3rqgccz6iuyyk0b","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"24090406","name":"Complementary","variations":[{"name":"Complementary Dal","price":34,"default":1,"id":"77727447","inStock":1,"isVeg":1,"variant_group_id":"24090406","order":100},{"name":"Complementary Red Gravy","price":34,"default":0,"id":"77727448","inStock":1,"isVeg":1,"variant_group_id":"24090406","order":100}]}],"pricing_models":[{"variations":[{"group_id":"24090406","variation_id":"77727447"}],"price":3400,"addon_combinations":[{"group_id":"67839052","addon_id":"54156419"},{"group_id":"67839052","addon_id":"54156420"},{"group_id":"67839052","addon_id":"54156421"},{"group_id":"67839052","addon_id":"54156422"},{"group_id":"67839052","addon_id":"54156423"},{"group_id":"67839052","addon_id":"54156424"},{"group_id":"67839089","addon_id":"54156457"},{"group_id":"67839089","addon_id":"54156458"},{"group_id":"67839089","addon_id":"54156459"},{"group_id":"67839089","addon_id":"54156460"},{"group_id":"67839089","addon_id":"54156461"},{"group_id":"67839089","addon_id":"54156462"},{"group_id":"67839103","addon_id":"54156425"},{"group_id":"67839103","addon_id":"54156426"},{"group_id":"67839103","addon_id":"54156427"},{"group_id":"67839103","addon_id":"54156428"},{"group_id":"67839103","addon_id":"54156429"}]},{"variations":[{"group_id":"24090406","variation_id":"77727448"}],"price":3400,"addon_combinations":[{"group_id":"67839052","addon_id":"54156419"},{"group_id":"67839052","addon_id":"54156420"},{"group_id":"67839052","addon_id":"54156421"},{"group_id":"67839052","addon_id":"54156422"},{"group_id":"67839052","addon_id":"54156423"},{"group_id":"67839052","addon_id":"54156424"},{"group_id":"67839089","addon_id":"54156457"},{"group_id":"67839089","addon_id":"54156458"},{"group_id":"67839089","addon_id":"54156459"},{"group_id":"67839089","addon_id":"54156460"},{"group_id":"67839089","addon_id":"54156461"},{"group_id":"67839089","addon_id":"54156462"},{"group_id":"67839103","addon_id":"54156425"},{"group_id":"67839103","addon_id":"54156426"},{"group_id":"67839103","addon_id":"54156427"},{"group_id":"67839103","addon_id":"54156428"},{"group_id":"67839103","addon_id":"54156429"}]}]},"addons":[{"group_id":67839052,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67839089,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839103,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3400,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215176":{"id":215176,"name":"Tandoori Naan","category":"Rotis","description":"","cloudinaryImageId":"mq1wvypya46dahpmedir","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"24090400","name":"Complementary","variations":[{"name":"Complementary Dal","price":34,"default":1,"id":"77727435","inStock":1,"isVeg":1,"variant_group_id":"24090400","order":100},{"name":"Complementary Red Gravy","price":34,"default":0,"id":"77727436","inStock":1,"isVeg":1,"variant_group_id":"24090400","order":100}]}],"pricing_models":[{"variations":[{"group_id":"24090400","variation_id":"77727435"}],"price":3400,"addon_combinations":[{"group_id":"67838177","addon_id":"54156419"},{"group_id":"67838177","addon_id":"54156420"},{"group_id":"67838177","addon_id":"54156421"},{"group_id":"67838177","addon_id":"54156422"},{"group_id":"67838177","addon_id":"54156423"},{"group_id":"67838177","addon_id":"54156424"},{"group_id":"67838207","addon_id":"54156457"},{"group_id":"67838207","addon_id":"54156458"},{"group_id":"67838207","addon_id":"54156459"},{"group_id":"67838207","addon_id":"54156460"},{"group_id":"67838207","addon_id":"54156461"},{"group_id":"67838207","addon_id":"54156462"},{"group_id":"67838216","addon_id":"54156425"},{"group_id":"67838216","addon_id":"54156426"},{"group_id":"67838216","addon_id":"54156427"},{"group_id":"67838216","addon_id":"54156428"},{"group_id":"67838216","addon_id":"54156429"}]},{"variations":[{"group_id":"24090400","variation_id":"77727436"}],"price":3400,"addon_combinations":[{"group_id":"67838177","addon_id":"54156419"},{"group_id":"67838177","addon_id":"54156420"},{"group_id":"67838177","addon_id":"54156421"},{"group_id":"67838177","addon_id":"54156422"},{"group_id":"67838177","addon_id":"54156423"},{"group_id":"67838177","addon_id":"54156424"},{"group_id":"67838207","addon_id":"54156457"},{"group_id":"67838207","addon_id":"54156458"},{"group_id":"67838207","addon_id":"54156459"},{"group_id":"67838207","addon_id":"54156460"},{"group_id":"67838207","addon_id":"54156461"},{"group_id":"67838207","addon_id":"54156462"},{"group_id":"67838216","addon_id":"54156425"},{"group_id":"67838216","addon_id":"54156426"},{"group_id":"67838216","addon_id":"54156427"},{"group_id":"67838216","addon_id":"54156428"},{"group_id":"67838216","addon_id":"54156429"}]}]},"addons":[{"group_id":67838177,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838207,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838216,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3400,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215177":{"id":215177,"name":"Butter Naan","category":"Rotis","description":"","cloudinaryImageId":"kpzbzfamrpnqune4nxn6","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"24090407","name":"Complementary","variations":[{"name":"Complementary Dal","price":42,"default":1,"id":"77727449","inStock":1,"isVeg":1,"variant_group_id":"24090407","order":100},{"name":"Complementary Red Gravy","price":42,"default":0,"id":"77727450","inStock":1,"isVeg":1,"variant_group_id":"24090407","order":100}]}],"pricing_models":[{"variations":[{"group_id":"24090407","variation_id":"77727449"}],"price":4200,"addon_combinations":[{"group_id":"67839310","addon_id":"54156419"},{"group_id":"67839310","addon_id":"54156420"},{"group_id":"67839310","addon_id":"54156421"},{"group_id":"67839310","addon_id":"54156422"},{"group_id":"67839310","addon_id":"54156423"},{"group_id":"67839310","addon_id":"54156424"},{"group_id":"67839343","addon_id":"54156457"},{"group_id":"67839343","addon_id":"54156458"},{"group_id":"67839343","addon_id":"54156459"},{"group_id":"67839343","addon_id":"54156460"},{"group_id":"67839343","addon_id":"54156461"},{"group_id":"67839343","addon_id":"54156462"},{"group_id":"67839371","addon_id":"54156425"},{"group_id":"67839371","addon_id":"54156426"},{"group_id":"67839371","addon_id":"54156427"},{"group_id":"67839371","addon_id":"54156428"},{"group_id":"67839371","addon_id":"54156429"}]},{"variations":[{"group_id":"24090407","variation_id":"77727450"}],"price":4200,"addon_combinations":[{"group_id":"67839310","addon_id":"54156419"},{"group_id":"67839310","addon_id":"54156420"},{"group_id":"67839310","addon_id":"54156421"},{"group_id":"67839310","addon_id":"54156422"},{"group_id":"67839310","addon_id":"54156423"},{"group_id":"67839310","addon_id":"54156424"},{"group_id":"67839343","addon_id":"54156457"},{"group_id":"67839343","addon_id":"54156458"},{"group_id":"67839343","addon_id":"54156459"},{"group_id":"67839343","addon_id":"54156460"},{"group_id":"67839343","addon_id":"54156461"},{"group_id":"67839343","addon_id":"54156462"},{"group_id":"67839371","addon_id":"54156425"},{"group_id":"67839371","addon_id":"54156426"},{"group_id":"67839371","addon_id":"54156427"},{"group_id":"67839371","addon_id":"54156428"},{"group_id":"67839371","addon_id":"54156429"}]}]},"addons":[{"group_id":67839310,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67839343,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839371,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":4200,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215180":{"id":215180,"name":"Dry Chapati","category":"Parottas","description":"","cloudinaryImageId":"vujildtrdyn6temnxvio","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808602","name":"Complementary","variations":[{"name":"Complementary Dal","price":29,"default":1,"id":"77096145","inStock":1,"isVeg":1,"variant_group_id":"23808602","order":100},{"name":"Complementary Red Gravy","price":29,"default":0,"id":"77096146","inStock":1,"isVeg":1,"variant_group_id":"23808602","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808602","variation_id":"77096145"}],"price":2900,"addon_combinations":[{"group_id":"67838969","addon_id":"54156419"},{"group_id":"67838969","addon_id":"54156420"},{"group_id":"67838969","addon_id":"54156421"},{"group_id":"67838969","addon_id":"54156422"},{"group_id":"67838969","addon_id":"54156423"},{"group_id":"67838969","addon_id":"54156424"},{"group_id":"67838986","addon_id":"54156457"},{"group_id":"67838986","addon_id":"54156458"},{"group_id":"67838986","addon_id":"54156459"},{"group_id":"67838986","addon_id":"54156460"},{"group_id":"67838986","addon_id":"54156461"},{"group_id":"67838986","addon_id":"54156462"},{"group_id":"67838998","addon_id":"54156425"},{"group_id":"67838998","addon_id":"54156426"},{"group_id":"67838998","addon_id":"54156427"},{"group_id":"67838998","addon_id":"54156428"},{"group_id":"67838998","addon_id":"54156429"}]},{"variations":[{"group_id":"23808602","variation_id":"77096146"}],"price":2900,"addon_combinations":[{"group_id":"67838969","addon_id":"54156419"},{"group_id":"67838969","addon_id":"54156420"},{"group_id":"67838969","addon_id":"54156421"},{"group_id":"67838969","addon_id":"54156422"},{"group_id":"67838969","addon_id":"54156423"},{"group_id":"67838969","addon_id":"54156424"},{"group_id":"67838986","addon_id":"54156457"},{"group_id":"67838986","addon_id":"54156458"},{"group_id":"67838986","addon_id":"54156459"},{"group_id":"67838986","addon_id":"54156460"},{"group_id":"67838986","addon_id":"54156461"},{"group_id":"67838986","addon_id":"54156462"},{"group_id":"67838998","addon_id":"54156425"},{"group_id":"67838998","addon_id":"54156426"},{"group_id":"67838998","addon_id":"54156427"},{"group_id":"67838998","addon_id":"54156428"},{"group_id":"67838998","addon_id":"54156429"}]}]},"addons":[{"group_id":67838969,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838986,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838998,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":2900,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215184":{"id":215184,"name":"Kerala Parotta","category":"Parottas","description":"","cloudinaryImageId":"pwgx9hyprqwfn7nzbxew","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808588","name":"Complementary","variations":[{"name":"Complementary Dal","price":36,"default":1,"id":"77096117","inStock":1,"isVeg":1,"variant_group_id":"23808588","order":100},{"name":"Complementary Red Gravy","price":36,"default":0,"id":"77096118","inStock":1,"isVeg":1,"variant_group_id":"23808588","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808588","variation_id":"77096117"}],"price":3600,"addon_combinations":[{"group_id":"67837727","addon_id":"54156419"},{"group_id":"67837727","addon_id":"54156420"},{"group_id":"67837727","addon_id":"54156421"},{"group_id":"67837727","addon_id":"54156422"},{"group_id":"67837727","addon_id":"54156423"},{"group_id":"67837727","addon_id":"54156424"},{"group_id":"67837773","addon_id":"54156457"},{"group_id":"67837773","addon_id":"54156458"},{"group_id":"67837773","addon_id":"54156459"},{"group_id":"67837773","addon_id":"54156460"},{"group_id":"67837773","addon_id":"54156461"},{"group_id":"67837773","addon_id":"54156462"},{"group_id":"67837789","addon_id":"54156425"},{"group_id":"67837789","addon_id":"54156426"},{"group_id":"67837789","addon_id":"54156427"},{"group_id":"67837789","addon_id":"54156428"},{"group_id":"67837789","addon_id":"54156429"}]},{"variations":[{"group_id":"23808588","variation_id":"77096118"}],"price":3600,"addon_combinations":[{"group_id":"67837727","addon_id":"54156419"},{"group_id":"67837727","addon_id":"54156420"},{"group_id":"67837727","addon_id":"54156421"},{"group_id":"67837727","addon_id":"54156422"},{"group_id":"67837727","addon_id":"54156423"},{"group_id":"67837727","addon_id":"54156424"},{"group_id":"67837773","addon_id":"54156457"},{"group_id":"67837773","addon_id":"54156458"},{"group_id":"67837773","addon_id":"54156459"},{"group_id":"67837773","addon_id":"54156460"},{"group_id":"67837773","addon_id":"54156461"},{"group_id":"67837773","addon_id":"54156462"},{"group_id":"67837789","addon_id":"54156425"},{"group_id":"67837789","addon_id":"54156426"},{"group_id":"67837789","addon_id":"54156427"},{"group_id":"67837789","addon_id":"54156428"},{"group_id":"67837789","addon_id":"54156429"}]}]},"addons":[{"group_id":67837727,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837773,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837789,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3600,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215185":{"id":215185,"name":"Malabar Parotta","category":"Parottas","description":"","cloudinaryImageId":"ldyhzva56ancpx51vbcl","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808559","name":"Complementary","variations":[{"name":"Complementary Dal","price":30,"default":1,"id":"77096061","inStock":1,"isVeg":1,"variant_group_id":"23808559","order":100},{"name":"Complementary Red Gravy","price":30,"default":0,"id":"77096062","inStock":1,"isVeg":1,"variant_group_id":"23808559","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808559","variation_id":"77096061"}],"price":3000,"addon_combinations":[{"group_id":"67835746","addon_id":"54156419"},{"group_id":"67835746","addon_id":"54156420"},{"group_id":"67835746","addon_id":"54156421"},{"group_id":"67835746","addon_id":"54156422"},{"group_id":"67835746","addon_id":"54156423"},{"group_id":"67835746","addon_id":"54156424"},{"group_id":"67835767","addon_id":"54156457"},{"group_id":"67835767","addon_id":"54156458"},{"group_id":"67835767","addon_id":"54156459"},{"group_id":"67835767","addon_id":"54156460"},{"group_id":"67835767","addon_id":"54156461"},{"group_id":"67835767","addon_id":"54156462"},{"group_id":"67835775","addon_id":"54156425"},{"group_id":"67835775","addon_id":"54156426"},{"group_id":"67835775","addon_id":"54156427"},{"group_id":"67835775","addon_id":"54156428"},{"group_id":"67835775","addon_id":"54156429"}]},{"variations":[{"group_id":"23808559","variation_id":"77096062"}],"price":3000,"addon_combinations":[{"group_id":"67835746","addon_id":"54156419"},{"group_id":"67835746","addon_id":"54156420"},{"group_id":"67835746","addon_id":"54156421"},{"group_id":"67835746","addon_id":"54156422"},{"group_id":"67835746","addon_id":"54156423"},{"group_id":"67835746","addon_id":"54156424"},{"group_id":"67835767","addon_id":"54156457"},{"group_id":"67835767","addon_id":"54156458"},{"group_id":"67835767","addon_id":"54156459"},{"group_id":"67835767","addon_id":"54156460"},{"group_id":"67835767","addon_id":"54156461"},{"group_id":"67835767","addon_id":"54156462"},{"group_id":"67835775","addon_id":"54156425"},{"group_id":"67835775","addon_id":"54156426"},{"group_id":"67835775","addon_id":"54156427"},{"group_id":"67835775","addon_id":"54156428"},{"group_id":"67835775","addon_id":"54156429"}]}]},"addons":[{"group_id":67835746,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835767,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835775,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3000,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215186":{"id":215186,"name":"Ceylon Parotta","category":"Parottas","description":"","cloudinaryImageId":"ediibdf3gsujqd6ifutq","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808578","name":"Complementary","variations":[{"name":"Complementary Dal","price":36,"default":1,"id":"77096099","inStock":1,"isVeg":1,"variant_group_id":"23808578","order":100},{"name":"Complementary Red Gravy","price":36,"default":0,"id":"77096100","inStock":1,"isVeg":1,"variant_group_id":"23808578","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808578","variation_id":"77096099"}],"price":3600,"addon_combinations":[{"group_id":"67836362","addon_id":"54156419"},{"group_id":"67836362","addon_id":"54156420"},{"group_id":"67836362","addon_id":"54156421"},{"group_id":"67836362","addon_id":"54156422"},{"group_id":"67836362","addon_id":"54156423"},{"group_id":"67836362","addon_id":"54156424"},{"group_id":"67836368","addon_id":"54156457"},{"group_id":"67836368","addon_id":"54156458"},{"group_id":"67836368","addon_id":"54156459"},{"group_id":"67836368","addon_id":"54156460"},{"group_id":"67836368","addon_id":"54156461"},{"group_id":"67836368","addon_id":"54156462"},{"group_id":"67836374","addon_id":"54156425"},{"group_id":"67836374","addon_id":"54156426"},{"group_id":"67836374","addon_id":"54156427"},{"group_id":"67836374","addon_id":"54156428"},{"group_id":"67836374","addon_id":"54156429"}]},{"variations":[{"group_id":"23808578","variation_id":"77096100"}],"price":3600,"addon_combinations":[{"group_id":"67836362","addon_id":"54156419"},{"group_id":"67836362","addon_id":"54156420"},{"group_id":"67836362","addon_id":"54156421"},{"group_id":"67836362","addon_id":"54156422"},{"group_id":"67836362","addon_id":"54156423"},{"group_id":"67836362","addon_id":"54156424"},{"group_id":"67836368","addon_id":"54156457"},{"group_id":"67836368","addon_id":"54156458"},{"group_id":"67836368","addon_id":"54156459"},{"group_id":"67836368","addon_id":"54156460"},{"group_id":"67836368","addon_id":"54156461"},{"group_id":"67836368","addon_id":"54156462"},{"group_id":"67836374","addon_id":"54156425"},{"group_id":"67836374","addon_id":"54156426"},{"group_id":"67836374","addon_id":"54156427"},{"group_id":"67836374","addon_id":"54156428"},{"group_id":"67836374","addon_id":"54156429"}]}]},"addons":[{"group_id":67836362,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836368,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67836374,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3600,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215187":{"id":215187,"name":"Coin Parotta","category":"Parottas","description":"","cloudinaryImageId":"fmfupmuieyd62gfdcddh","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808597","name":"Complementary","variations":[{"name":"Complementary Dal","price":29,"default":1,"id":"77096135","inStock":1,"isVeg":1,"variant_group_id":"23808597","order":100},{"name":"Complementary Red Gravy","price":29,"default":0,"id":"77096136","inStock":1,"isVeg":1,"variant_group_id":"23808597","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808597","variation_id":"77096135"}],"price":2900,"addon_combinations":[{"group_id":"67838789","addon_id":"54156419"},{"group_id":"67838789","addon_id":"54156420"},{"group_id":"67838789","addon_id":"54156421"},{"group_id":"67838789","addon_id":"54156422"},{"group_id":"67838789","addon_id":"54156423"},{"group_id":"67838789","addon_id":"54156424"},{"group_id":"67838811","addon_id":"54156457"},{"group_id":"67838811","addon_id":"54156458"},{"group_id":"67838811","addon_id":"54156459"},{"group_id":"67838811","addon_id":"54156460"},{"group_id":"67838811","addon_id":"54156461"},{"group_id":"67838811","addon_id":"54156462"},{"group_id":"67838847","addon_id":"54156425"},{"group_id":"67838847","addon_id":"54156426"},{"group_id":"67838847","addon_id":"54156427"},{"group_id":"67838847","addon_id":"54156428"},{"group_id":"67838847","addon_id":"54156429"}]},{"variations":[{"group_id":"23808597","variation_id":"77096136"}],"price":2900,"addon_combinations":[{"group_id":"67838789","addon_id":"54156419"},{"group_id":"67838789","addon_id":"54156420"},{"group_id":"67838789","addon_id":"54156421"},{"group_id":"67838789","addon_id":"54156422"},{"group_id":"67838789","addon_id":"54156423"},{"group_id":"67838789","addon_id":"54156424"},{"group_id":"67838811","addon_id":"54156457"},{"group_id":"67838811","addon_id":"54156458"},{"group_id":"67838811","addon_id":"54156459"},{"group_id":"67838811","addon_id":"54156460"},{"group_id":"67838811","addon_id":"54156461"},{"group_id":"67838811","addon_id":"54156462"},{"group_id":"67838847","addon_id":"54156425"},{"group_id":"67838847","addon_id":"54156426"},{"group_id":"67838847","addon_id":"54156427"},{"group_id":"67838847","addon_id":"54156428"},{"group_id":"67838847","addon_id":"54156429"}]}]},"addons":[{"group_id":67838789,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838811,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838847,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":2900,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215188":{"id":215188,"name":"Wheat Parotta","category":"Parottas","description":"","cloudinaryImageId":"pcazjlp7ayhpfx6utrfs","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808587","name":"Complementary","variations":[{"name":"Complementary Dal","price":36,"default":1,"id":"77096115","inStock":1,"isVeg":1,"variant_group_id":"23808587","order":100},{"name":"Complementary Red Gravy","price":36,"default":0,"id":"77096116","inStock":1,"isVeg":1,"variant_group_id":"23808587","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808587","variation_id":"77096115"}],"price":3600,"addon_combinations":[{"group_id":"67837637","addon_id":"54156419"},{"group_id":"67837637","addon_id":"54156420"},{"group_id":"67837637","addon_id":"54156421"},{"group_id":"67837637","addon_id":"54156422"},{"group_id":"67837637","addon_id":"54156423"},{"group_id":"67837637","addon_id":"54156424"},{"group_id":"67837672","addon_id":"54156457"},{"group_id":"67837672","addon_id":"54156458"},{"group_id":"67837672","addon_id":"54156459"},{"group_id":"67837672","addon_id":"54156460"},{"group_id":"67837672","addon_id":"54156461"},{"group_id":"67837672","addon_id":"54156462"},{"group_id":"67837698","addon_id":"54156425"},{"group_id":"67837698","addon_id":"54156426"},{"group_id":"67837698","addon_id":"54156427"},{"group_id":"67837698","addon_id":"54156428"},{"group_id":"67837698","addon_id":"54156429"}]},{"variations":[{"group_id":"23808587","variation_id":"77096116"}],"price":3600,"addon_combinations":[{"group_id":"67837637","addon_id":"54156419"},{"group_id":"67837637","addon_id":"54156420"},{"group_id":"67837637","addon_id":"54156421"},{"group_id":"67837637","addon_id":"54156422"},{"group_id":"67837637","addon_id":"54156423"},{"group_id":"67837637","addon_id":"54156424"},{"group_id":"67837672","addon_id":"54156457"},{"group_id":"67837672","addon_id":"54156458"},{"group_id":"67837672","addon_id":"54156459"},{"group_id":"67837672","addon_id":"54156460"},{"group_id":"67837672","addon_id":"54156461"},{"group_id":"67837672","addon_id":"54156462"},{"group_id":"67837698","addon_id":"54156425"},{"group_id":"67837698","addon_id":"54156426"},{"group_id":"67837698","addon_id":"54156427"},{"group_id":"67837698","addon_id":"54156428"},{"group_id":"67837698","addon_id":"54156429"}]}]},"addons":[{"group_id":67837637,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837672,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837698,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3600,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215192":{"id":215192,"name":"Empire Butter Parotta","category":"Parottas","description":"","cloudinaryImageId":"alnvnbfhdf1zaw3js35b","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808592","name":"Complementary","variations":[{"name":"Complementary Dal","price":45,"default":1,"id":"77096125","inStock":1,"isVeg":1,"variant_group_id":"23808592","order":100},{"name":"Complementary Red Gravy","price":45,"default":0,"id":"77096126","inStock":1,"isVeg":1,"variant_group_id":"23808592","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808592","variation_id":"77096125"}],"price":4500,"addon_combinations":[{"group_id":"67838131","addon_id":"54156419"},{"group_id":"67838131","addon_id":"54156420"},{"group_id":"67838131","addon_id":"54156421"},{"group_id":"67838131","addon_id":"54156422"},{"group_id":"67838131","addon_id":"54156423"},{"group_id":"67838131","addon_id":"54156424"},{"group_id":"67838144","addon_id":"54156457"},{"group_id":"67838144","addon_id":"54156458"},{"group_id":"67838144","addon_id":"54156459"},{"group_id":"67838144","addon_id":"54156460"},{"group_id":"67838144","addon_id":"54156461"},{"group_id":"67838144","addon_id":"54156462"},{"group_id":"67838152","addon_id":"54156425"},{"group_id":"67838152","addon_id":"54156426"},{"group_id":"67838152","addon_id":"54156427"},{"group_id":"67838152","addon_id":"54156428"},{"group_id":"67838152","addon_id":"54156429"}]},{"variations":[{"group_id":"23808592","variation_id":"77096126"}],"price":4500,"addon_combinations":[{"group_id":"67838131","addon_id":"54156419"},{"group_id":"67838131","addon_id":"54156420"},{"group_id":"67838131","addon_id":"54156421"},{"group_id":"67838131","addon_id":"54156422"},{"group_id":"67838131","addon_id":"54156423"},{"group_id":"67838131","addon_id":"54156424"},{"group_id":"67838144","addon_id":"54156457"},{"group_id":"67838144","addon_id":"54156458"},{"group_id":"67838144","addon_id":"54156459"},{"group_id":"67838144","addon_id":"54156460"},{"group_id":"67838144","addon_id":"54156461"},{"group_id":"67838144","addon_id":"54156462"},{"group_id":"67838152","addon_id":"54156425"},{"group_id":"67838152","addon_id":"54156426"},{"group_id":"67838152","addon_id":"54156427"},{"group_id":"67838152","addon_id":"54156428"},{"group_id":"67838152","addon_id":"54156429"}]}]},"addons":[{"group_id":67838131,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838144,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838152,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":4500,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215218":{"id":215218,"name":"Veg Thali","category":"Thali","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":21000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67838887,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67838897,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838933,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838894,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67838947,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215223":{"id":215223,"name":"Veg Fried Rice","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"vvpigujlw9jyfbtt2xxa","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":18000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67836131,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836150,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215224":{"id":215224,"name":"Egg Fried Rice","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"vretzm7ieccmpf28g4oh","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":19000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67838357,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838381,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215225":{"id":215225,"name":"Chicken Fried Rice","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"pkoi9cfitwisdevisr7v","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":21000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67840112,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840153,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215226":{"id":215226,"name":"Mutton Fried Rice","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"uocn0xa0orusb0hitvqw","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":24000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67835071,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835074,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215228":{"id":215228,"name":"Prawns Fried Rice","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"csop6sf3zuvis19txy7q","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":24000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67840628,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840658,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215229":{"id":215229,"name":"Veg Noodles","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"hswbhovmezcxwmsxgap3","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":18000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67840435,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840474,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215230":{"id":215230,"name":"Egg Noodles","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"xwj7vognggrordwiqgag","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":19000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67835087,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835090,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215231":{"id":215231,"name":"Chicken Noodles","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"bmwno4vupnvavpiylhii","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":21000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67835355,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835373,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215233":{"id":215233,"name":"Prawns Noodles","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"u6dyi5smdbza2mzgayc4","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":24000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67835862,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835877,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215259":{"id":215259,"name":"Arabian Dry Fruit","category":"Juice Shop","description":"Our Arabian Dry Fruit Thick Shake is bursting with flavors. The smooth shake combines ice cream, mango pulp and crunchy dry fruits to make a truly indulgent drink. It’s topped off with chocolate syrup for the perfect combination of sweetness, fruitiness and creaminess.","cloudinaryImageId":"ujizbqb5tumbx26gmjaj","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685263","name":"Potion","variations":[{"name":"300ml","price":165,"default":1,"id":"71452757","inStock":1,"isVeg":1,"variant_group_id":"21685263","order":100},{"name":"1Ltr","price":485,"default":0,"id":"71452758","inStock":1,"isVeg":1,"variant_group_id":"21685263","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685263","variation_id":"71452757"}],"price":16500,"addon_combinations":[]},{"variations":[{"group_id":"21685263","variation_id":"71452758"}],"price":48500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":16500,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215260":{"id":215260,"name":"Red Velvet Queen","category":"Juice Shop","description":"Our Red Velvet Queen Shake is a blissful marriage of rich, creamy ice cream, chunks of red velvet sponge and chilled milk topped with strawberry syrup, this thick shake will get your taste buds tingling!","cloudinaryImageId":"gzwmxysqktbtir27y7tl","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685082","name":"Potion","variations":[{"name":"300ml","price":126.5,"default":1,"id":"71452394","inStock":1,"isVeg":1,"variant_group_id":"21685082","order":100},{"name":"1Ltr","price":370.5,"default":0,"id":"71452395","inStock":1,"isVeg":1,"variant_group_id":"21685082","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685082","variation_id":"71452394"}],"price":12650,"addon_combinations":[]},{"variations":[{"group_id":"21685082","variation_id":"71452395"}],"price":37050,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":12650,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215289":{"id":215289,"name":"Lime Soda","category":"Juice Shop","description":"A refreshing citrus flavored soda made with fresh lime, cooled with chilled soda and mixed with a touch of sugar syrup.","cloudinaryImageId":"udoijcwgskygmkhlmtvi","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685013","name":"Potion","variations":[{"name":"300ml","price":66,"default":1,"id":"71452255","inStock":1,"isVeg":1,"variant_group_id":"21685013","order":100},{"name":"1ltr","price":202,"default":0,"id":"71452256","inStock":1,"isVeg":1,"variant_group_id":"21685013","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685013","variation_id":"71452255"}],"price":6600,"addon_combinations":[]},{"variations":[{"group_id":"21685013","variation_id":"71452256"}],"price":20200,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":6600,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215291":{"id":215291,"name":"Ginger Lime Soda","category":"Juice Shop","description":"Ginger-lime soda is infused with the flavour of real ginger and lime, and sweetened sugar syrup.","cloudinaryImageId":"hs1ym1gdojov0hqd3x5o","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685216","name":"Potion","variations":[{"name":"300ml","price":71.5,"default":1,"id":"71452662","inStock":1,"isVeg":1,"variant_group_id":"21685216","order":100},{"name":"1Ltr","price":205,"default":0,"id":"71452663","inStock":1,"isVeg":1,"variant_group_id":"21685216","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685216","variation_id":"71452662"}],"price":7150,"addon_combinations":[]},{"variations":[{"group_id":"21685216","variation_id":"71452663"}],"price":20500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7150,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215298":{"id":215298,"name":"Dates Thick Shakes","category":"Juice Shop","description":"Lean back and enjoy the thick goodness of Dates Thick Shake which is blended to perfection using creamy ice cream and chilled milk.","cloudinaryImageId":"zjbrmgzznqzprv0eqxkf","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685091","name":"Potion","variations":[{"name":"300ml","price":99,"default":1,"id":"71452412","inStock":1,"isVeg":1,"variant_group_id":"21685091","order":100},{"name":"1Ltr","price":290,"default":0,"id":"71452413","inStock":1,"isVeg":1,"variant_group_id":"21685091","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685091","variation_id":"71452412"}],"price":9900,"addon_combinations":[]},{"variations":[{"group_id":"21685091","variation_id":"71452413"}],"price":29000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215301":{"id":215301,"name":"Mango Thick Shakes","category":"Juice Shop","description":"Relish the rich and luscious mango flavour with the delightful taste of ice cream blended with chilled milk and mango pulp.","cloudinaryImageId":"vcatjomn6wq2f7uc5bif","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685327","name":"Potion","variations":[{"name":"300ml","price":88,"default":1,"id":"71452886","inStock":1,"isVeg":1,"variant_group_id":"21685327","order":100},{"name":"1Ltr","price":255,"default":0,"id":"71452887","inStock":1,"isVeg":1,"variant_group_id":"21685327","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685327","variation_id":"71452886"}],"price":8800,"addon_combinations":[]},{"variations":[{"group_id":"21685327","variation_id":"71452887"}],"price":25500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":8800,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"215304":{"id":215304,"name":"Sharjah Thick Shakes","category":"Juice Shop","description":"Constituted by the best of three - banana, mocha and chocolate syrup - this thick shake will keep you refreshed all day long.","cloudinaryImageId":"qutjx0rbupksxw5m5txz","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685329","name":"Potion","variations":[{"name":"300ml","price":99,"default":1,"id":"71452890","inStock":1,"isVeg":1,"variant_group_id":"21685329","order":100},{"name":"1Ltr","price":290,"default":0,"id":"71452891","inStock":1,"isVeg":1,"variant_group_id":"21685329","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685329","variation_id":"71452890"}],"price":9900,"addon_combinations":[]},{"variations":[{"group_id":"21685329","variation_id":"71452891"}],"price":29000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"1395450":{"id":1395450,"name":"Butter Kulcha","category":"Rotis","description":"","cloudinaryImageId":"thbj92jjhbmctknwaqnh","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"24090387","name":"Complementary","variations":[{"name":"Complementary Dal","price":42,"default":1,"id":"77727410","inStock":1,"isVeg":1,"variant_group_id":"24090387","order":100},{"name":"Complementary Red Gravy","price":42,"default":0,"id":"77727411","inStock":1,"isVeg":1,"variant_group_id":"24090387","order":100}]}],"pricing_models":[{"variations":[{"group_id":"24090387","variation_id":"77727410"}],"price":4200,"addon_combinations":[{"group_id":"67837159","addon_id":"54156419"},{"group_id":"67837159","addon_id":"54156420"},{"group_id":"67837159","addon_id":"54156421"},{"group_id":"67837159","addon_id":"54156422"},{"group_id":"67837159","addon_id":"54156423"},{"group_id":"67837159","addon_id":"54156424"},{"group_id":"67837167","addon_id":"54156457"},{"group_id":"67837167","addon_id":"54156458"},{"group_id":"67837167","addon_id":"54156459"},{"group_id":"67837167","addon_id":"54156460"},{"group_id":"67837167","addon_id":"54156461"},{"group_id":"67837167","addon_id":"54156462"},{"group_id":"67837185","addon_id":"54156425"},{"group_id":"67837185","addon_id":"54156426"},{"group_id":"67837185","addon_id":"54156427"},{"group_id":"67837185","addon_id":"54156428"},{"group_id":"67837185","addon_id":"54156429"}]},{"variations":[{"group_id":"24090387","variation_id":"77727411"}],"price":4200,"addon_combinations":[{"group_id":"67837159","addon_id":"54156419"},{"group_id":"67837159","addon_id":"54156420"},{"group_id":"67837159","addon_id":"54156421"},{"group_id":"67837159","addon_id":"54156422"},{"group_id":"67837159","addon_id":"54156423"},{"group_id":"67837159","addon_id":"54156424"},{"group_id":"67837167","addon_id":"54156457"},{"group_id":"67837167","addon_id":"54156458"},{"group_id":"67837167","addon_id":"54156459"},{"group_id":"67837167","addon_id":"54156460"},{"group_id":"67837167","addon_id":"54156461"},{"group_id":"67837167","addon_id":"54156462"},{"group_id":"67837185","addon_id":"54156425"},{"group_id":"67837185","addon_id":"54156426"},{"group_id":"67837185","addon_id":"54156427"},{"group_id":"67837185","addon_id":"54156428"},{"group_id":"67837185","addon_id":"54156429"}]}]},"addons":[{"group_id":67837159,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837167,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837185,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":4200,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"1794387":{"id":1794387,"name":"Chicken Shawarma","category":"Shawarma","description":"","cloudinaryImageId":"fbtsm6ejxytccvjbjf4l","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":8500,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67839459,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839468,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"4300494":{"id":4300494,"name":"Popcorn Chicken Kebab","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"irvoj3hrrcsu5t5n3wx8","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810784","name":"Portion","variations":[{"name":"Full","price":479,"default":0,"id":"18813738","inStock":1,"isVeg":0,"variant_group_id":"5810784","order":0},{"name":"Half","price":249,"default":0,"id":"18813737","inStock":1,"isVeg":0,"variant_group_id":"5810784","order":0},{"name":"Qtr","price":134,"default":1,"id":"18813736","inStock":1,"isVeg":0,"variant_group_id":"5810784","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810784","variation_id":"18813738"}],"price":47900,"addon_combinations":[{"group_id":"67835113","addon_id":"54156436"},{"group_id":"67835113","addon_id":"54156437"},{"group_id":"67835113","addon_id":"54156438"},{"group_id":"67835120","addon_id":"54156457"},{"group_id":"67835120","addon_id":"54156458"},{"group_id":"67835120","addon_id":"54156459"},{"group_id":"67835120","addon_id":"54156460"},{"group_id":"67835120","addon_id":"54156461"},{"group_id":"67835120","addon_id":"54156462"},{"group_id":"67835111","addon_id":"54156450"},{"group_id":"67835111","addon_id":"54156451"},{"group_id":"67835111","addon_id":"54156452"},{"group_id":"67835125","addon_id":"54156425"},{"group_id":"67835125","addon_id":"54156426"},{"group_id":"67835125","addon_id":"54156427"},{"group_id":"67835125","addon_id":"54156428"},{"group_id":"67835125","addon_id":"54156429"}]},{"variations":[{"group_id":"5810784","variation_id":"18813737"}],"price":24900,"addon_combinations":[{"group_id":"67835113","addon_id":"54156436"},{"group_id":"67835113","addon_id":"54156437"},{"group_id":"67835113","addon_id":"54156438"},{"group_id":"67835120","addon_id":"54156457"},{"group_id":"67835120","addon_id":"54156458"},{"group_id":"67835120","addon_id":"54156459"},{"group_id":"67835120","addon_id":"54156460"},{"group_id":"67835120","addon_id":"54156461"},{"group_id":"67835120","addon_id":"54156462"},{"group_id":"67835111","addon_id":"54156450"},{"group_id":"67835111","addon_id":"54156451"},{"group_id":"67835111","addon_id":"54156452"},{"group_id":"67835125","addon_id":"54156425"},{"group_id":"67835125","addon_id":"54156426"},{"group_id":"67835125","addon_id":"54156427"},{"group_id":"67835125","addon_id":"54156428"},{"group_id":"67835125","addon_id":"54156429"}]},{"variations":[{"group_id":"5810784","variation_id":"18813736"}],"price":13400,"addon_combinations":[{"group_id":"67835113","addon_id":"54156436"},{"group_id":"67835113","addon_id":"54156437"},{"group_id":"67835113","addon_id":"54156438"},{"group_id":"67835120","addon_id":"54156457"},{"group_id":"67835120","addon_id":"54156458"},{"group_id":"67835120","addon_id":"54156459"},{"group_id":"67835120","addon_id":"54156460"},{"group_id":"67835120","addon_id":"54156461"},{"group_id":"67835120","addon_id":"54156462"},{"group_id":"67835111","addon_id":"54156450"},{"group_id":"67835111","addon_id":"54156451"},{"group_id":"67835111","addon_id":"54156452"},{"group_id":"67835125","addon_id":"54156425"},{"group_id":"67835125","addon_id":"54156426"},{"group_id":"67835125","addon_id":"54156427"},{"group_id":"67835125","addon_id":"54156428"},{"group_id":"67835125","addon_id":"54156429"}]}]},"addons":[{"group_id":67835113,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835120,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835111,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835125,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13400,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"24685892":{"id":24685892,"name":"Lemon Coriander Chicken Soup","category":"Soup","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":8900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67837574,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"24685899":{"id":24685899,"name":"Paneer Tikka Dry","category":"Veg Dry","description":"","cloudinaryImageId":"bnnvweiswij9ms6srn5y","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810901","name":"Portion ","variations":[{"name":"Half","price":200,"default":0,"id":"18814064","inStock":1,"isVeg":1,"variant_group_id":"5810901","order":0},{"name":"Qtr","price":110,"default":1,"id":"18814063","inStock":1,"isVeg":1,"variant_group_id":"5810901","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810901","variation_id":"18814064"}],"price":20000,"addon_combinations":[{"group_id":"67839560","addon_id":"54156457"},{"group_id":"67839560","addon_id":"54156458"},{"group_id":"67839560","addon_id":"54156459"},{"group_id":"67839560","addon_id":"54156460"},{"group_id":"67839560","addon_id":"54156461"},{"group_id":"67839560","addon_id":"54156462"},{"group_id":"67839573","addon_id":"54156425"},{"group_id":"67839573","addon_id":"54156426"},{"group_id":"67839573","addon_id":"54156427"},{"group_id":"67839573","addon_id":"54156428"},{"group_id":"67839573","addon_id":"54156429"}]},{"variations":[{"group_id":"5810901","variation_id":"18814063"}],"price":11000,"addon_combinations":[{"group_id":"67839560","addon_id":"54156457"},{"group_id":"67839560","addon_id":"54156458"},{"group_id":"67839560","addon_id":"54156459"},{"group_id":"67839560","addon_id":"54156460"},{"group_id":"67839560","addon_id":"54156461"},{"group_id":"67839560","addon_id":"54156462"},{"group_id":"67839573","addon_id":"54156425"},{"group_id":"67839573","addon_id":"54156426"},{"group_id":"67839573","addon_id":"54156427"},{"group_id":"67839573","addon_id":"54156428"},{"group_id":"67839573","addon_id":"54156429"}]}]},"addons":[{"group_id":67839560,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839573,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":11000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28308865":{"id":28308865,"name":"Bombay Falooda","category":"Juice Shop","description":"This Falooda is our interpretation of the classical Bombay style Falooda. Made from special homemade rose milk mix combined with layers of jelly, poppy seeds, vermicelli, dry fruit mixture, and topped with red cherry.","cloudinaryImageId":"r6rf3osd6glvxzj7p0d7","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":15400,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309026":{"id":28309026,"name":"Strawberry Ice Cream","category":"Juice Shop","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"6952726","name":"Scoops","variations":[{"name":"Single","price":70,"default":1,"id":"23380925","inStock":1,"isVeg":1,"variant_group_id":"6952726","order":99},{"name":"Double","price":135,"default":0,"id":"23380926","inStock":1,"isVeg":1,"variant_group_id":"6952726","order":98}]}],"pricing_models":[{"variations":[{"group_id":"6952726","variation_id":"23380925"}],"price":7000,"addon_combinations":[]},{"variations":[{"group_id":"6952726","variation_id":"23380926"}],"price":13500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309058":{"id":28309058,"name":"Blue Angel","category":"Juice Shop","description":"Sip on a bright Blue Angel, a fun drink made with lime juice, sugar syrup, ice slush, soda and Blue Curacao syrup","cloudinaryImageId":"pr3ptnuz1yfiy0lsxg32","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685217","name":"Potion","variations":[{"name":"300ml","price":99,"default":1,"id":"71452664","inStock":1,"isVeg":1,"variant_group_id":"21685217","order":100},{"name":"1Ltr","price":290,"default":0,"id":"71452665","inStock":1,"isVeg":1,"variant_group_id":"21685217","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685217","variation_id":"71452664"}],"price":9900,"addon_combinations":[]},{"variations":[{"group_id":"21685217","variation_id":"71452665"}],"price":29000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309135":{"id":28309135,"name":"Pista Ice Cream","category":"Juice Shop","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21698387","name":"Scoops","variations":[{"name":"Single","price":70,"default":1,"id":"71481571","inStock":1,"isVeg":1,"variant_group_id":"21698387","order":99},{"name":"Double","price":135,"default":0,"id":"71481572","inStock":1,"isVeg":1,"variant_group_id":"21698387","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21698387","variation_id":"71481571"}],"price":7000,"addon_combinations":[]},{"variations":[{"group_id":"21698387","variation_id":"71481572"}],"price":13500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309278":{"id":28309278,"name":"Badam Kulfi","category":"Juice Shop","description":"","cloudinaryImageId":"zndmhkekkyowt6bbrzjy","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":7000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309296":{"id":28309296,"name":"Pista Kulfi","category":"Juice Shop","description":"","cloudinaryImageId":"rngynunellqmkinhe2t4","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":7000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309444":{"id":28309444,"name":"Death By Chocolate","category":"Juice Shop","description":"DBC is everyone’s favourite. Scoops of rich and creamy vanilla ice cream with of a warm homemade chocolate cake sponge, drizzled with our signature homemade DBC sauce and roasted peanuts is an absolute treat for every dessert lover.","cloudinaryImageId":"lvhxynldslndyn4u02ma","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":16500,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309455":{"id":28309455,"name":"Banoffee Sundae","category":"Juice Shop","description":"Sweet and nutty, this banana sundae features our creamy butterscotch ice cream with caramelized powdered nuts, bananas, and a drizzle of honey.","cloudinaryImageId":"xyzo6bnmzc1aspobpmbo","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":15400,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309643":{"id":28309643,"name":"Kulfi Falooda","category":"Juice Shop","description":"Treat yourself to a little indulgence with our Kulfi Ice Cream Falooda. Topped with Rich Malai Kulfi Ice Cream combined with layers of jelly, poppy seeds, vermicelli and dry fruit mixture, . It's the perfect end to any meal.","cloudinaryImageId":"ehwvo8dhazsxoslkfb9s","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":15400,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"28309677":{"id":28309677,"name":"Rabdi Falooda","category":"Juice Shop","description":"Rabdi Falooda Ice Cream is an enticing and mouthwatering dessert. It has a delicious taste that is simply appetizing. This dessert is prepared using homemade rabadi, poppy seeds, vermicelli, ice cream, dry fruit mixture topped with red cherry.","cloudinaryImageId":"lbdoyqirtmggsxfag7z5","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":15400,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822482":{"id":47822482,"name":"Mutton Kurma","category":"Empire Special Mutton (Gravy)","description":"","cloudinaryImageId":"twjmxjokmjh7g0a7atwf","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810776","name":"Portion","variations":[{"name":"Full","price":618,"default":0,"id":"18813717","inStock":1,"isVeg":0,"variant_group_id":"5810776","order":0},{"name":"Half","price":319,"default":0,"id":"18813716","inStock":1,"isVeg":0,"variant_group_id":"5810776","order":0},{"name":"Qtr","price":170,"default":1,"id":"18813715","inStock":1,"isVeg":0,"variant_group_id":"5810776","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810776","variation_id":"18813717"}],"price":61800,"addon_combinations":[{"group_id":"68923273","addon_id":"54935012"},{"group_id":"67835059","addon_id":"54156416"},{"group_id":"67835059","addon_id":"54156417"},{"group_id":"67835059","addon_id":"54156418"},{"group_id":"67835061","addon_id":"54156419"},{"group_id":"67835061","addon_id":"54156420"},{"group_id":"67835061","addon_id":"54156421"},{"group_id":"67835061","addon_id":"54156422"},{"group_id":"67835061","addon_id":"54156423"},{"group_id":"67835061","addon_id":"54156424"},{"group_id":"67835065","addon_id":"54156425"},{"group_id":"67835065","addon_id":"54156426"},{"group_id":"67835065","addon_id":"54156427"},{"group_id":"67835065","addon_id":"54156428"},{"group_id":"67835065","addon_id":"54156429"}]},{"variations":[{"group_id":"5810776","variation_id":"18813716"}],"price":31900,"addon_combinations":[{"group_id":"68923273","addon_id":"54935012"},{"group_id":"67835059","addon_id":"54156416"},{"group_id":"67835059","addon_id":"54156417"},{"group_id":"67835059","addon_id":"54156418"},{"group_id":"67835061","addon_id":"54156419"},{"group_id":"67835061","addon_id":"54156420"},{"group_id":"67835061","addon_id":"54156421"},{"group_id":"67835061","addon_id":"54156422"},{"group_id":"67835061","addon_id":"54156423"},{"group_id":"67835061","addon_id":"54156424"},{"group_id":"67835065","addon_id":"54156425"},{"group_id":"67835065","addon_id":"54156426"},{"group_id":"67835065","addon_id":"54156427"},{"group_id":"67835065","addon_id":"54156428"},{"group_id":"67835065","addon_id":"54156429"}]},{"variations":[{"group_id":"5810776","variation_id":"18813715"}],"price":17000,"addon_combinations":[{"group_id":"68923273","addon_id":"54935012"},{"group_id":"67835059","addon_id":"54156416"},{"group_id":"67835059","addon_id":"54156417"},{"group_id":"67835059","addon_id":"54156418"},{"group_id":"67835061","addon_id":"54156419"},{"group_id":"67835061","addon_id":"54156420"},{"group_id":"67835061","addon_id":"54156421"},{"group_id":"67835061","addon_id":"54156422"},{"group_id":"67835061","addon_id":"54156423"},{"group_id":"67835061","addon_id":"54156424"},{"group_id":"67835065","addon_id":"54156425"},{"group_id":"67835065","addon_id":"54156426"},{"group_id":"67835065","addon_id":"54156427"},{"group_id":"67835065","addon_id":"54156428"},{"group_id":"67835065","addon_id":"54156429"}]}]},"addons":[{"group_id":68923273,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67835059,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67835061,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835065,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822484":{"id":47822484,"name":"Egg Bulls Eye","category":"Egg Item","description":"","cloudinaryImageId":"fryhh8spfxlbiwtamjgp","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":5000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822488":{"id":47822488,"name":"Blue Lime Soda","category":"Juice Shop","description":"Lighten up your mood with our Blue lime Soda. Made with blue curac?ao syrup, lemonade and splash of chilled soda water.","cloudinaryImageId":"rkz3pwnxd3b3l7satpsa","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":8800,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822492":{"id":47822492,"name":"Chicken Kebab Boneless","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"sexytz31r1pqfx5xomd5","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810786","name":"Portion","variations":[{"name":"Full","price":474,"default":0,"id":"18813744","inStock":1,"isVeg":0,"variant_group_id":"5810786","order":0},{"name":"Half","price":244,"default":0,"id":"18813743","inStock":1,"isVeg":0,"variant_group_id":"5810786","order":0},{"name":"Qtr","price":129,"default":1,"id":"18813742","inStock":1,"isVeg":0,"variant_group_id":"5810786","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810786","variation_id":"18813744"}],"price":47400,"addon_combinations":[{"group_id":"67835237","addon_id":"54156436"},{"group_id":"67835237","addon_id":"54156437"},{"group_id":"67835237","addon_id":"54156438"},{"group_id":"67835242","addon_id":"54156457"},{"group_id":"67835242","addon_id":"54156458"},{"group_id":"67835242","addon_id":"54156459"},{"group_id":"67835242","addon_id":"54156460"},{"group_id":"67835242","addon_id":"54156461"},{"group_id":"67835242","addon_id":"54156462"},{"group_id":"67835230","addon_id":"54156450"},{"group_id":"67835230","addon_id":"54156451"},{"group_id":"67835230","addon_id":"54156452"},{"group_id":"67835275","addon_id":"54156425"},{"group_id":"67835275","addon_id":"54156426"},{"group_id":"67835275","addon_id":"54156427"},{"group_id":"67835275","addon_id":"54156428"},{"group_id":"67835275","addon_id":"54156429"}]},{"variations":[{"group_id":"5810786","variation_id":"18813743"}],"price":24400,"addon_combinations":[{"group_id":"67835237","addon_id":"54156436"},{"group_id":"67835237","addon_id":"54156437"},{"group_id":"67835237","addon_id":"54156438"},{"group_id":"67835242","addon_id":"54156457"},{"group_id":"67835242","addon_id":"54156458"},{"group_id":"67835242","addon_id":"54156459"},{"group_id":"67835242","addon_id":"54156460"},{"group_id":"67835242","addon_id":"54156461"},{"group_id":"67835242","addon_id":"54156462"},{"group_id":"67835230","addon_id":"54156450"},{"group_id":"67835230","addon_id":"54156451"},{"group_id":"67835230","addon_id":"54156452"},{"group_id":"67835275","addon_id":"54156425"},{"group_id":"67835275","addon_id":"54156426"},{"group_id":"67835275","addon_id":"54156427"},{"group_id":"67835275","addon_id":"54156428"},{"group_id":"67835275","addon_id":"54156429"}]},{"variations":[{"group_id":"5810786","variation_id":"18813742"}],"price":12900,"addon_combinations":[{"group_id":"67835237","addon_id":"54156436"},{"group_id":"67835237","addon_id":"54156437"},{"group_id":"67835237","addon_id":"54156438"},{"group_id":"67835242","addon_id":"54156457"},{"group_id":"67835242","addon_id":"54156458"},{"group_id":"67835242","addon_id":"54156459"},{"group_id":"67835242","addon_id":"54156460"},{"group_id":"67835242","addon_id":"54156461"},{"group_id":"67835242","addon_id":"54156462"},{"group_id":"67835230","addon_id":"54156450"},{"group_id":"67835230","addon_id":"54156451"},{"group_id":"67835230","addon_id":"54156452"},{"group_id":"67835275","addon_id":"54156425"},{"group_id":"67835275","addon_id":"54156426"},{"group_id":"67835275","addon_id":"54156427"},{"group_id":"67835275","addon_id":"54156428"},{"group_id":"67835275","addon_id":"54156429"}]}]},"addons":[{"group_id":67835237,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835242,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835230,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835275,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":12900,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822493":{"id":47822493,"name":"Pepper Mutton Masala Boneless","category":"Empire Special Mutton (Gravy)","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810787","name":"Portion","variations":[{"name":"Full","price":600,"default":0,"id":"18813747","inStock":1,"isVeg":0,"variant_group_id":"5810787","order":0},{"name":"Half","price":320,"default":0,"id":"18813746","inStock":1,"isVeg":0,"variant_group_id":"5810787","order":0},{"name":"Qtr","price":180,"default":1,"id":"18813745","inStock":1,"isVeg":0,"variant_group_id":"5810787","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810787","variation_id":"18813747"}],"price":60000,"addon_combinations":[]},{"variations":[{"group_id":"5810787","variation_id":"18813746"}],"price":32000,"addon_combinations":[]},{"variations":[{"group_id":"5810787","variation_id":"18813745"}],"price":18000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":18000,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822494":{"id":47822494,"name":"Chocolate Ice Cream","category":"Juice Shop","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"6952699","name":"Scoops","variations":[{"name":"Single","price":70,"default":1,"id":"23378257","inStock":1,"isVeg":1,"variant_group_id":"6952699","order":99},{"name":"Double","price":135,"default":0,"id":"23378258","inStock":1,"isVeg":1,"variant_group_id":"6952699","order":98}]}],"pricing_models":[{"variations":[{"group_id":"6952699","variation_id":"23378257"}],"price":7000,"addon_combinations":[]},{"variations":[{"group_id":"6952699","variation_id":"23378258"}],"price":13500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822495":{"id":47822495,"name":"Egg Burji","category":"Egg Item","description":"","cloudinaryImageId":"cg5s6kzlpaunkh8fplua","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":8000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822497":{"id":47822497,"name":"Spl Dal Fry With Egg","category":"Egg Item","description":"","cloudinaryImageId":"auuwpssammnfjaocpuam","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810792","name":"Portion ","variations":[{"name":"Full","price":255,"default":0,"id":"18813759","inStock":1,"isVeg":0,"variant_group_id":"5810792","order":0},{"name":"Half","price":140,"default":1,"id":"18813758","inStock":1,"isVeg":0,"variant_group_id":"5810792","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810792","variation_id":"18813759"}],"price":25500,"addon_combinations":[{"group_id":"68923338","addon_id":"54935012"},{"group_id":"67835471","addon_id":"54156416"},{"group_id":"67835471","addon_id":"54156417"},{"group_id":"67835471","addon_id":"54156418"}]},{"variations":[{"group_id":"5810792","variation_id":"18813758"}],"price":14000,"addon_combinations":[{"group_id":"68923338","addon_id":"54935012"},{"group_id":"67835471","addon_id":"54156416"},{"group_id":"67835471","addon_id":"54156417"},{"group_id":"67835471","addon_id":"54156418"}]}]},"addons":[{"group_id":68923338,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67835471,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822498":{"id":47822498,"name":"Chicken Kurma","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810793","name":"Portion","variations":[{"name":"Full","price":474,"default":0,"id":"18813762","inStock":1,"isVeg":0,"variant_group_id":"5810793","order":0},{"name":"Half","price":250,"default":0,"id":"18813761","inStock":1,"isVeg":0,"variant_group_id":"5810793","order":0},{"name":"Qtr","price":140,"default":1,"id":"18813760","inStock":1,"isVeg":0,"variant_group_id":"5810793","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810793","variation_id":"18813762"}],"price":47400,"addon_combinations":[{"group_id":"68923345","addon_id":"54935012"},{"group_id":"67835486","addon_id":"54156416"},{"group_id":"67835486","addon_id":"54156417"},{"group_id":"67835486","addon_id":"54156418"},{"group_id":"67835488","addon_id":"54156419"},{"group_id":"67835488","addon_id":"54156420"},{"group_id":"67835488","addon_id":"54156421"},{"group_id":"67835488","addon_id":"54156422"},{"group_id":"67835488","addon_id":"54156423"},{"group_id":"67835488","addon_id":"54156424"},{"group_id":"67835511","addon_id":"54156425"},{"group_id":"67835511","addon_id":"54156426"},{"group_id":"67835511","addon_id":"54156427"},{"group_id":"67835511","addon_id":"54156428"},{"group_id":"67835511","addon_id":"54156429"}]},{"variations":[{"group_id":"5810793","variation_id":"18813761"}],"price":25000,"addon_combinations":[{"group_id":"68923345","addon_id":"54935012"},{"group_id":"67835486","addon_id":"54156416"},{"group_id":"67835486","addon_id":"54156417"},{"group_id":"67835486","addon_id":"54156418"},{"group_id":"67835488","addon_id":"54156419"},{"group_id":"67835488","addon_id":"54156420"},{"group_id":"67835488","addon_id":"54156421"},{"group_id":"67835488","addon_id":"54156422"},{"group_id":"67835488","addon_id":"54156423"},{"group_id":"67835488","addon_id":"54156424"},{"group_id":"67835511","addon_id":"54156425"},{"group_id":"67835511","addon_id":"54156426"},{"group_id":"67835511","addon_id":"54156427"},{"group_id":"67835511","addon_id":"54156428"},{"group_id":"67835511","addon_id":"54156429"}]},{"variations":[{"group_id":"5810793","variation_id":"18813760"}],"price":14000,"addon_combinations":[{"group_id":"68923345","addon_id":"54935012"},{"group_id":"67835486","addon_id":"54156416"},{"group_id":"67835486","addon_id":"54156417"},{"group_id":"67835486","addon_id":"54156418"},{"group_id":"67835488","addon_id":"54156419"},{"group_id":"67835488","addon_id":"54156420"},{"group_id":"67835488","addon_id":"54156421"},{"group_id":"67835488","addon_id":"54156422"},{"group_id":"67835488","addon_id":"54156423"},{"group_id":"67835488","addon_id":"54156424"},{"group_id":"67835511","addon_id":"54156425"},{"group_id":"67835511","addon_id":"54156426"},{"group_id":"67835511","addon_id":"54156427"},{"group_id":"67835511","addon_id":"54156428"},{"group_id":"67835511","addon_id":"54156429"}]}]},"addons":[{"group_id":68923345,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67835486,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67835488,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67835511,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822501":{"id":47822501,"name":"Kalmi Kabab","category":"Tandoori(dry)","description":"","cloudinaryImageId":"ymipyekw4xeq0mkufsl8","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810797","name":"Portion ","variations":[{"name":"Full","price":490,"default":0,"id":"18813774","inStock":1,"isVeg":0,"variant_group_id":"5810797","order":0},{"name":"Half","price":270,"default":0,"id":"18813773","inStock":1,"isVeg":0,"variant_group_id":"5810797","order":0},{"name":"Qtr","price":145,"default":1,"id":"18813772","inStock":1,"isVeg":0,"variant_group_id":"5810797","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810797","variation_id":"18813774"}],"price":49000,"addon_combinations":[{"group_id":"67835637","addon_id":"54156436"},{"group_id":"67835637","addon_id":"54156437"},{"group_id":"67835637","addon_id":"54156438"},{"group_id":"67835627","addon_id":"54156450"},{"group_id":"67835627","addon_id":"54156451"},{"group_id":"67835627","addon_id":"54156452"},{"group_id":"67835642","addon_id":"54156425"},{"group_id":"67835642","addon_id":"54156426"},{"group_id":"67835642","addon_id":"54156427"},{"group_id":"67835642","addon_id":"54156428"},{"group_id":"67835642","addon_id":"54156429"}]},{"variations":[{"group_id":"5810797","variation_id":"18813773"}],"price":27000,"addon_combinations":[{"group_id":"67835637","addon_id":"54156436"},{"group_id":"67835637","addon_id":"54156437"},{"group_id":"67835637","addon_id":"54156438"},{"group_id":"67835627","addon_id":"54156450"},{"group_id":"67835627","addon_id":"54156451"},{"group_id":"67835627","addon_id":"54156452"},{"group_id":"67835642","addon_id":"54156425"},{"group_id":"67835642","addon_id":"54156426"},{"group_id":"67835642","addon_id":"54156427"},{"group_id":"67835642","addon_id":"54156428"},{"group_id":"67835642","addon_id":"54156429"}]},{"variations":[{"group_id":"5810797","variation_id":"18813772"}],"price":14500,"addon_combinations":[{"group_id":"67835637","addon_id":"54156436"},{"group_id":"67835637","addon_id":"54156437"},{"group_id":"67835637","addon_id":"54156438"},{"group_id":"67835627","addon_id":"54156450"},{"group_id":"67835627","addon_id":"54156451"},{"group_id":"67835627","addon_id":"54156452"},{"group_id":"67835642","addon_id":"54156425"},{"group_id":"67835642","addon_id":"54156426"},{"group_id":"67835642","addon_id":"54156427"},{"group_id":"67835642","addon_id":"54156428"},{"group_id":"67835642","addon_id":"54156429"}]}]},"addons":[{"group_id":67835637,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835627,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835642,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822505":{"id":47822505,"name":"Empire Spl Chicken Kebab","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"obqi7kmdulkmoyrbbx1g","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810800","name":"Portion ","variations":[{"name":"Full","price":370,"default":0,"id":"18813783","inStock":1,"isVeg":0,"variant_group_id":"5810800","order":0},{"name":"Half","price":190,"default":0,"id":"18813782","inStock":1,"isVeg":0,"variant_group_id":"5810800","order":0},{"name":"Qtr","price":105,"default":1,"id":"18813781","inStock":1,"isVeg":0,"variant_group_id":"5810800","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810800","variation_id":"18813783"}],"price":37000,"addon_combinations":[{"group_id":"67835673","addon_id":"54156436"},{"group_id":"67835673","addon_id":"54156437"},{"group_id":"67835673","addon_id":"54156438"},{"group_id":"67835677","addon_id":"54156457"},{"group_id":"67835677","addon_id":"54156458"},{"group_id":"67835677","addon_id":"54156459"},{"group_id":"67835677","addon_id":"54156460"},{"group_id":"67835677","addon_id":"54156461"},{"group_id":"67835677","addon_id":"54156462"},{"group_id":"67835670","addon_id":"54156450"},{"group_id":"67835670","addon_id":"54156451"},{"group_id":"67835670","addon_id":"54156452"},{"group_id":"67835696","addon_id":"54156425"},{"group_id":"67835696","addon_id":"54156426"},{"group_id":"67835696","addon_id":"54156427"},{"group_id":"67835696","addon_id":"54156428"},{"group_id":"67835696","addon_id":"54156429"}]},{"variations":[{"group_id":"5810800","variation_id":"18813782"}],"price":19000,"addon_combinations":[{"group_id":"67835673","addon_id":"54156436"},{"group_id":"67835673","addon_id":"54156437"},{"group_id":"67835673","addon_id":"54156438"},{"group_id":"67835677","addon_id":"54156457"},{"group_id":"67835677","addon_id":"54156458"},{"group_id":"67835677","addon_id":"54156459"},{"group_id":"67835677","addon_id":"54156460"},{"group_id":"67835677","addon_id":"54156461"},{"group_id":"67835677","addon_id":"54156462"},{"group_id":"67835670","addon_id":"54156450"},{"group_id":"67835670","addon_id":"54156451"},{"group_id":"67835670","addon_id":"54156452"},{"group_id":"67835696","addon_id":"54156425"},{"group_id":"67835696","addon_id":"54156426"},{"group_id":"67835696","addon_id":"54156427"},{"group_id":"67835696","addon_id":"54156428"},{"group_id":"67835696","addon_id":"54156429"}]},{"variations":[{"group_id":"5810800","variation_id":"18813781"}],"price":10500,"addon_combinations":[{"group_id":"67835673","addon_id":"54156436"},{"group_id":"67835673","addon_id":"54156437"},{"group_id":"67835673","addon_id":"54156438"},{"group_id":"67835677","addon_id":"54156457"},{"group_id":"67835677","addon_id":"54156458"},{"group_id":"67835677","addon_id":"54156459"},{"group_id":"67835677","addon_id":"54156460"},{"group_id":"67835677","addon_id":"54156461"},{"group_id":"67835677","addon_id":"54156462"},{"group_id":"67835670","addon_id":"54156450"},{"group_id":"67835670","addon_id":"54156451"},{"group_id":"67835670","addon_id":"54156452"},{"group_id":"67835696","addon_id":"54156425"},{"group_id":"67835696","addon_id":"54156426"},{"group_id":"67835696","addon_id":"54156427"},{"group_id":"67835696","addon_id":"54156428"},{"group_id":"67835696","addon_id":"54156429"}]}]},"addons":[{"group_id":67835673,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835677,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835670,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835696,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":10500,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"47822506":{"id":47822506,"name":"Fiery Basa Fish Fillet","category":"Empire Special Tawa Dishes","description":"","cloudinaryImageId":"cmbtminwmsomjsaxmad4","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":35500,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67835720,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835726,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822509":{"id":47822509,"name":"Pineapple Juice","category":"Juice Shop","description":"100% Pure Fresh Juices, No Water Added","cloudinaryImageId":"npo1tjeruli8uhjz9bzd","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685094","name":"Potion","variations":[{"name":"300ml","price":77,"default":1,"id":"71452418","inStock":1,"isVeg":1,"variant_group_id":"21685094","order":100},{"name":"1Ltr","price":220,"default":0,"id":"71452419","inStock":1,"isVeg":1,"variant_group_id":"21685094","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685094","variation_id":"71452418"}],"price":7700,"addon_combinations":[]},{"variations":[{"group_id":"21685094","variation_id":"71452419"}],"price":22000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7700,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822514":{"id":47822514,"name":"Prawns Biriyani","category":"Biriyani And Rice","description":"","cloudinaryImageId":"advclisbcydlpxmr8xds","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":33000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68923965,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67841325,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67891832,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841320,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841316,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67841340,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67841345,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822517":{"id":47822517,"name":"Egg Biriyani","category":"Biriyani And Rice","description":"","cloudinaryImageId":"estud4jfulsslglmzges","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":21000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68923986,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67841797,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67841860,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841791,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841790,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67841929,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67841944,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822519":{"id":47822519,"name":"Chicken Biriyani","category":"Biriyani And Rice","description":"","cloudinaryImageId":"wxiqzeafmwowtfuskf1z","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810810","name":"Portion ","variations":[{"name":"LARGE","price":285,"default":0,"id":"18813809","inStock":1,"isVeg":0,"variant_group_id":"5810810","order":0},{"name":"REGULAR","price":175,"default":1,"id":"18813808","inStock":1,"isVeg":0,"variant_group_id":"5810810","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810810","variation_id":"18813809"}],"price":28500,"addon_combinations":[{"group_id":"68923396","addon_id":"54935061"},{"group_id":"67864967","addon_id":"54156419"},{"group_id":"67864967","addon_id":"54156420"},{"group_id":"67864967","addon_id":"54156421"},{"group_id":"67864967","addon_id":"54156422"},{"group_id":"67864967","addon_id":"54156423"},{"group_id":"67864967","addon_id":"54156424"},{"group_id":"67864971","addon_id":"54156457"},{"group_id":"67864971","addon_id":"54156458"},{"group_id":"67864971","addon_id":"54156459"},{"group_id":"67864971","addon_id":"54156460"},{"group_id":"67864971","addon_id":"54156461"},{"group_id":"67864971","addon_id":"54156462"},{"group_id":"67864966","addon_id":"54156450"},{"group_id":"67864966","addon_id":"54156451"},{"group_id":"67864966","addon_id":"54156452"},{"group_id":"67864965","addon_id":"17505976"},{"group_id":"67864965","addon_id":"54156510"},{"group_id":"67891740","addon_id":"54156512"},{"group_id":"67864973","addon_id":"54156425"},{"group_id":"67864973","addon_id":"54156426"},{"group_id":"67864973","addon_id":"54156427"},{"group_id":"67864973","addon_id":"54156428"},{"group_id":"67864973","addon_id":"54156429"}]},{"variations":[{"group_id":"5810810","variation_id":"18813808"}],"price":17500,"addon_combinations":[{"group_id":"68923396","addon_id":"54935061"},{"group_id":"67864967","addon_id":"54156419"},{"group_id":"67864967","addon_id":"54156420"},{"group_id":"67864967","addon_id":"54156421"},{"group_id":"67864967","addon_id":"54156422"},{"group_id":"67864967","addon_id":"54156423"},{"group_id":"67864967","addon_id":"54156424"},{"group_id":"67864971","addon_id":"54156457"},{"group_id":"67864971","addon_id":"54156458"},{"group_id":"67864971","addon_id":"54156459"},{"group_id":"67864971","addon_id":"54156460"},{"group_id":"67864971","addon_id":"54156461"},{"group_id":"67864971","addon_id":"54156462"},{"group_id":"67864966","addon_id":"54156450"},{"group_id":"67864966","addon_id":"54156451"},{"group_id":"67864966","addon_id":"54156452"},{"group_id":"67864965","addon_id":"17505976"},{"group_id":"67864965","addon_id":"54156510"},{"group_id":"67891740","addon_id":"54156512"},{"group_id":"67864973","addon_id":"54156425"},{"group_id":"67864973","addon_id":"54156426"},{"group_id":"67864973","addon_id":"54156427"},{"group_id":"67864973","addon_id":"54156428"},{"group_id":"67864973","addon_id":"54156429"}]}]},"addons":[{"group_id":68923396,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67864967,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67864971,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67864966,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67864965,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67891740,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67864973,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17500,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"47822520":{"id":47822520,"name":"Veg Biriyani","category":"Biriyani And Rice","description":"","cloudinaryImageId":"kklrjlpk5igqswxwfrga","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":21000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67841197,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67841228,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841173,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841165,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67841251,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67841256,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822522":{"id":47822522,"name":"Mutton Raan Biriyani","category":"Biriyani And Rice","description":"","cloudinaryImageId":"sqnozrogkkcx4qfdban7","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810815","name":"Portion","variations":[{"name":"Full","price":1581,"default":0,"id":"18813826","inStock":1,"isVeg":0,"variant_group_id":"5810815","order":0},{"name":"Half","price":876,"default":1,"id":"18813825","inStock":1,"isVeg":0,"variant_group_id":"5810815","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810815","variation_id":"18813826"}],"price":158100,"addon_combinations":[{"group_id":"68923974","addon_id":"54935061"},{"group_id":"67841436","addon_id":"54156419"},{"group_id":"67841436","addon_id":"54156420"},{"group_id":"67841436","addon_id":"54156421"},{"group_id":"67841436","addon_id":"54156422"},{"group_id":"67841436","addon_id":"54156423"},{"group_id":"67841436","addon_id":"54156424"},{"group_id":"67841430","addon_id":"54156436"},{"group_id":"67841430","addon_id":"54156437"},{"group_id":"67841430","addon_id":"54156438"},{"group_id":"67841469","addon_id":"54156457"},{"group_id":"67841469","addon_id":"54156458"},{"group_id":"67841469","addon_id":"54156459"},{"group_id":"67841469","addon_id":"54156460"},{"group_id":"67841469","addon_id":"54156461"},{"group_id":"67841469","addon_id":"54156462"},{"group_id":"67841426","addon_id":"54156450"},{"group_id":"67841426","addon_id":"54156451"},{"group_id":"67841426","addon_id":"54156452"},{"group_id":"67841424","addon_id":"17505976"},{"group_id":"67841424","addon_id":"54156510"},{"group_id":"67841506","addon_id":"54156512"},{"group_id":"67841508","addon_id":"54156425"},{"group_id":"67841508","addon_id":"54156426"},{"group_id":"67841508","addon_id":"54156427"},{"group_id":"67841508","addon_id":"54156428"},{"group_id":"67841508","addon_id":"54156429"}]},{"variations":[{"group_id":"5810815","variation_id":"18813825"}],"price":87600,"addon_combinations":[{"group_id":"68923974","addon_id":"54935061"},{"group_id":"67841436","addon_id":"54156419"},{"group_id":"67841436","addon_id":"54156420"},{"group_id":"67841436","addon_id":"54156421"},{"group_id":"67841436","addon_id":"54156422"},{"group_id":"67841436","addon_id":"54156423"},{"group_id":"67841436","addon_id":"54156424"},{"group_id":"67841430","addon_id":"54156436"},{"group_id":"67841430","addon_id":"54156437"},{"group_id":"67841430","addon_id":"54156438"},{"group_id":"67841469","addon_id":"54156457"},{"group_id":"67841469","addon_id":"54156458"},{"group_id":"67841469","addon_id":"54156459"},{"group_id":"67841469","addon_id":"54156460"},{"group_id":"67841469","addon_id":"54156461"},{"group_id":"67841469","addon_id":"54156462"},{"group_id":"67841426","addon_id":"54156450"},{"group_id":"67841426","addon_id":"54156451"},{"group_id":"67841426","addon_id":"54156452"},{"group_id":"67841424","addon_id":"17505976"},{"group_id":"67841424","addon_id":"54156510"},{"group_id":"67841506","addon_id":"54156512"},{"group_id":"67841508","addon_id":"54156425"},{"group_id":"67841508","addon_id":"54156426"},{"group_id":"67841508","addon_id":"54156427"},{"group_id":"67841508","addon_id":"54156428"},{"group_id":"67841508","addon_id":"54156429"}]}]},"addons":[{"group_id":68923974,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67841436,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67841469,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841430,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841426,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841424,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67841506,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67841508,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":87600,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822532":{"id":47822532,"name":"Chilly Kebab","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"mwjxnsys86a5apetncxm","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810824","name":"Portion","variations":[{"name":"Full","price":402,"default":0,"id":"18813851","inStock":1,"isVeg":0,"variant_group_id":"5810824","order":0},{"name":"Half","price":206,"default":0,"id":"18813850","inStock":1,"isVeg":0,"variant_group_id":"5810824","order":0},{"name":"Qtr","price":120,"default":1,"id":"18813849","inStock":1,"isVeg":0,"variant_group_id":"5810824","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810824","variation_id":"18813851"}],"price":40200,"addon_combinations":[{"group_id":"67835949","addon_id":"54156436"},{"group_id":"67835949","addon_id":"54156437"},{"group_id":"67835949","addon_id":"54156438"},{"group_id":"67835953","addon_id":"54156457"},{"group_id":"67835953","addon_id":"54156458"},{"group_id":"67835953","addon_id":"54156459"},{"group_id":"67835953","addon_id":"54156460"},{"group_id":"67835953","addon_id":"54156461"},{"group_id":"67835953","addon_id":"54156462"},{"group_id":"67835944","addon_id":"54156450"},{"group_id":"67835944","addon_id":"54156451"},{"group_id":"67835944","addon_id":"54156452"},{"group_id":"67835960","addon_id":"54156425"},{"group_id":"67835960","addon_id":"54156426"},{"group_id":"67835960","addon_id":"54156427"},{"group_id":"67835960","addon_id":"54156428"},{"group_id":"67835960","addon_id":"54156429"}]},{"variations":[{"group_id":"5810824","variation_id":"18813850"}],"price":20600,"addon_combinations":[{"group_id":"67835949","addon_id":"54156436"},{"group_id":"67835949","addon_id":"54156437"},{"group_id":"67835949","addon_id":"54156438"},{"group_id":"67835953","addon_id":"54156457"},{"group_id":"67835953","addon_id":"54156458"},{"group_id":"67835953","addon_id":"54156459"},{"group_id":"67835953","addon_id":"54156460"},{"group_id":"67835953","addon_id":"54156461"},{"group_id":"67835953","addon_id":"54156462"},{"group_id":"67835944","addon_id":"54156450"},{"group_id":"67835944","addon_id":"54156451"},{"group_id":"67835944","addon_id":"54156452"},{"group_id":"67835960","addon_id":"54156425"},{"group_id":"67835960","addon_id":"54156426"},{"group_id":"67835960","addon_id":"54156427"},{"group_id":"67835960","addon_id":"54156428"},{"group_id":"67835960","addon_id":"54156429"}]},{"variations":[{"group_id":"5810824","variation_id":"18813849"}],"price":12000,"addon_combinations":[{"group_id":"67835949","addon_id":"54156436"},{"group_id":"67835949","addon_id":"54156437"},{"group_id":"67835949","addon_id":"54156438"},{"group_id":"67835953","addon_id":"54156457"},{"group_id":"67835953","addon_id":"54156458"},{"group_id":"67835953","addon_id":"54156459"},{"group_id":"67835953","addon_id":"54156460"},{"group_id":"67835953","addon_id":"54156461"},{"group_id":"67835953","addon_id":"54156462"},{"group_id":"67835944","addon_id":"54156450"},{"group_id":"67835944","addon_id":"54156451"},{"group_id":"67835944","addon_id":"54156452"},{"group_id":"67835960","addon_id":"54156425"},{"group_id":"67835960","addon_id":"54156426"},{"group_id":"67835960","addon_id":"54156427"},{"group_id":"67835960","addon_id":"54156428"},{"group_id":"67835960","addon_id":"54156429"}]}]},"addons":[{"group_id":67835949,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835953,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835944,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67835960,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":12000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822533":{"id":47822533,"name":"Hot Chilly Prawns (tawa Fry)","category":"Empire Special Tawa Dishes","description":"","cloudinaryImageId":"w0ryzceyck4utca3l9pf","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":36200,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67835979,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67835986,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822534":{"id":47822534,"name":"Musambi Juice","category":"Juice Shop","description":"100% Pure Fresh Juices, No Water Added","cloudinaryImageId":"omk7dilfhvfqcaekxj7q","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685156","name":"Potion","variations":[{"name":"300ml","price":88,"default":1,"id":"71452542","inStock":1,"isVeg":1,"variant_group_id":"21685156","order":100},{"name":"1Ltr","price":255,"default":0,"id":"71452543","inStock":1,"isVeg":1,"variant_group_id":"21685156","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685156","variation_id":"71452542"}],"price":8800,"addon_combinations":[]},{"variations":[{"group_id":"21685156","variation_id":"71452543"}],"price":25500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":8800,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822535":{"id":47822535,"name":"Butter Chicken","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"kywkfwwyqscindrzh1fa","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810825","name":"Portion","variations":[{"name":"Full","price":474,"default":0,"id":"18813854","inStock":1,"isVeg":0,"variant_group_id":"5810825","order":0},{"name":"Half","price":250,"default":0,"id":"18813853","inStock":1,"isVeg":0,"variant_group_id":"5810825","order":0},{"name":"Qtr","price":140,"default":1,"id":"18813852","inStock":1,"isVeg":0,"variant_group_id":"5810825","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810825","variation_id":"18813854"}],"price":47400,"addon_combinations":[{"group_id":"68923482","addon_id":"54935012"},{"group_id":"67836035","addon_id":"54156416"},{"group_id":"67836035","addon_id":"54156417"},{"group_id":"67836035","addon_id":"54156418"},{"group_id":"67836041","addon_id":"54156419"},{"group_id":"67836041","addon_id":"54156420"},{"group_id":"67836041","addon_id":"54156421"},{"group_id":"67836041","addon_id":"54156422"},{"group_id":"67836041","addon_id":"54156423"},{"group_id":"67836041","addon_id":"54156424"},{"group_id":"67836052","addon_id":"54156425"},{"group_id":"67836052","addon_id":"54156426"},{"group_id":"67836052","addon_id":"54156427"},{"group_id":"67836052","addon_id":"54156428"},{"group_id":"67836052","addon_id":"54156429"}]},{"variations":[{"group_id":"5810825","variation_id":"18813853"}],"price":25000,"addon_combinations":[{"group_id":"68923482","addon_id":"54935012"},{"group_id":"67836035","addon_id":"54156416"},{"group_id":"67836035","addon_id":"54156417"},{"group_id":"67836035","addon_id":"54156418"},{"group_id":"67836041","addon_id":"54156419"},{"group_id":"67836041","addon_id":"54156420"},{"group_id":"67836041","addon_id":"54156421"},{"group_id":"67836041","addon_id":"54156422"},{"group_id":"67836041","addon_id":"54156423"},{"group_id":"67836041","addon_id":"54156424"},{"group_id":"67836052","addon_id":"54156425"},{"group_id":"67836052","addon_id":"54156426"},{"group_id":"67836052","addon_id":"54156427"},{"group_id":"67836052","addon_id":"54156428"},{"group_id":"67836052","addon_id":"54156429"}]},{"variations":[{"group_id":"5810825","variation_id":"18813852"}],"price":14000,"addon_combinations":[{"group_id":"68923482","addon_id":"54935012"},{"group_id":"67836035","addon_id":"54156416"},{"group_id":"67836035","addon_id":"54156417"},{"group_id":"67836035","addon_id":"54156418"},{"group_id":"67836041","addon_id":"54156419"},{"group_id":"67836041","addon_id":"54156420"},{"group_id":"67836041","addon_id":"54156421"},{"group_id":"67836041","addon_id":"54156422"},{"group_id":"67836041","addon_id":"54156423"},{"group_id":"67836041","addon_id":"54156424"},{"group_id":"67836052","addon_id":"54156425"},{"group_id":"67836052","addon_id":"54156426"},{"group_id":"67836052","addon_id":"54156427"},{"group_id":"67836052","addon_id":"54156428"},{"group_id":"67836052","addon_id":"54156429"}]}]},"addons":[{"group_id":68923482,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836035,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836041,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836052,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822540":{"id":47822540,"name":"Watermelon Juice","category":"Juice Shop","description":"100% Pure Fresh Juices, No Water Added","cloudinaryImageId":"fvckyewcu6jqz8zzn1ft","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685158","name":"Potion","variations":[{"name":"300ml","price":77,"default":1,"id":"71452546","inStock":1,"isVeg":1,"variant_group_id":"21685158","order":100},{"name":"1Ltr","price":211,"default":0,"id":"71452547","inStock":1,"isVeg":1,"variant_group_id":"21685158","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685158","variation_id":"71452546"}],"price":7700,"addon_combinations":[]},{"variations":[{"group_id":"21685158","variation_id":"71452547"}],"price":21100,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7700,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822542":{"id":47822542,"name":"Lime Mint Cooler","category":"Juice Shop","description":"This is a cool and refreshing blend of crushed ice cubes, lime juice, mint leaves, and chilled water that is blended together .","cloudinaryImageId":"evunfe79jfwckwn2zx2r","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685167","name":"Potion","variations":[{"name":"300ml","price":71.5,"default":1,"id":"71452564","inStock":1,"isVeg":1,"variant_group_id":"21685167","order":100},{"name":"1Ltr","price":205.5,"default":0,"id":"71452565","inStock":1,"isVeg":1,"variant_group_id":"21685167","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685167","variation_id":"71452564"}],"price":7150,"addon_combinations":[]},{"variations":[{"group_id":"21685167","variation_id":"71452565"}],"price":20550,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7150,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822543":{"id":47822543,"name":"Pepper Chicken Masala","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"flq53krkpkjkhod7zrwr","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810830","name":"Portion","variations":[{"name":"Full","price":470,"default":0,"id":"18813867","inStock":1,"isVeg":0,"variant_group_id":"5810830","order":0},{"name":"Half","price":250,"default":0,"id":"18813866","inStock":1,"isVeg":0,"variant_group_id":"5810830","order":0},{"name":"Qtr","price":140,"default":1,"id":"18813865","inStock":1,"isVeg":0,"variant_group_id":"5810830","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810830","variation_id":"18813867"}],"price":47000,"addon_combinations":[{"group_id":"68923504","addon_id":"54935012"},{"group_id":"67836082","addon_id":"54156416"},{"group_id":"67836082","addon_id":"54156417"},{"group_id":"67836082","addon_id":"54156418"},{"group_id":"67836087","addon_id":"54156419"},{"group_id":"67836087","addon_id":"54156420"},{"group_id":"67836087","addon_id":"54156421"},{"group_id":"67836087","addon_id":"54156422"},{"group_id":"67836087","addon_id":"54156423"},{"group_id":"67836087","addon_id":"54156424"},{"group_id":"67836094","addon_id":"54156425"},{"group_id":"67836094","addon_id":"54156426"},{"group_id":"67836094","addon_id":"54156427"},{"group_id":"67836094","addon_id":"54156428"},{"group_id":"67836094","addon_id":"54156429"}]},{"variations":[{"group_id":"5810830","variation_id":"18813866"}],"price":25000,"addon_combinations":[{"group_id":"68923504","addon_id":"54935012"},{"group_id":"67836082","addon_id":"54156416"},{"group_id":"67836082","addon_id":"54156417"},{"group_id":"67836082","addon_id":"54156418"},{"group_id":"67836087","addon_id":"54156419"},{"group_id":"67836087","addon_id":"54156420"},{"group_id":"67836087","addon_id":"54156421"},{"group_id":"67836087","addon_id":"54156422"},{"group_id":"67836087","addon_id":"54156423"},{"group_id":"67836087","addon_id":"54156424"},{"group_id":"67836094","addon_id":"54156425"},{"group_id":"67836094","addon_id":"54156426"},{"group_id":"67836094","addon_id":"54156427"},{"group_id":"67836094","addon_id":"54156428"},{"group_id":"67836094","addon_id":"54156429"}]},{"variations":[{"group_id":"5810830","variation_id":"18813865"}],"price":14000,"addon_combinations":[{"group_id":"68923504","addon_id":"54935012"},{"group_id":"67836082","addon_id":"54156416"},{"group_id":"67836082","addon_id":"54156417"},{"group_id":"67836082","addon_id":"54156418"},{"group_id":"67836087","addon_id":"54156419"},{"group_id":"67836087","addon_id":"54156420"},{"group_id":"67836087","addon_id":"54156421"},{"group_id":"67836087","addon_id":"54156422"},{"group_id":"67836087","addon_id":"54156423"},{"group_id":"67836087","addon_id":"54156424"},{"group_id":"67836094","addon_id":"54156425"},{"group_id":"67836094","addon_id":"54156426"},{"group_id":"67836094","addon_id":"54156427"},{"group_id":"67836094","addon_id":"54156428"},{"group_id":"67836094","addon_id":"54156429"}]}]},"addons":[{"group_id":68923504,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836082,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836087,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836094,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822547":{"id":47822547,"name":"Alfaham Chicken","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"2e675d94449140ec4a4954c992533725","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810833","name":"Portion ","variations":[{"name":"Full","price":433,"default":0,"id":"18813875","inStock":1,"isVeg":0,"variant_group_id":"5810833","order":0},{"name":"Half","price":240,"default":0,"id":"18813874","inStock":1,"isVeg":0,"variant_group_id":"5810833","order":0},{"name":"Qtr","price":135,"default":1,"id":"18813873","inStock":1,"isVeg":0,"variant_group_id":"5810833","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810833","variation_id":"18813875"}],"price":43300,"addon_combinations":[{"group_id":"67836197","addon_id":"54156436"},{"group_id":"67836197","addon_id":"54156437"},{"group_id":"67836197","addon_id":"54156438"},{"group_id":"67836203","addon_id":"54156457"},{"group_id":"67836203","addon_id":"54156458"},{"group_id":"67836203","addon_id":"54156459"},{"group_id":"67836203","addon_id":"54156460"},{"group_id":"67836203","addon_id":"54156461"},{"group_id":"67836203","addon_id":"54156462"},{"group_id":"67836191","addon_id":"54156450"},{"group_id":"67836191","addon_id":"54156451"},{"group_id":"67836191","addon_id":"54156452"},{"group_id":"67836215","addon_id":"54156425"},{"group_id":"67836215","addon_id":"54156426"},{"group_id":"67836215","addon_id":"54156427"},{"group_id":"67836215","addon_id":"54156428"},{"group_id":"67836215","addon_id":"54156429"},{"group_id":"67866511","addon_id":"54168863"}]},{"variations":[{"group_id":"5810833","variation_id":"18813874"}],"price":24000,"addon_combinations":[{"group_id":"67836197","addon_id":"54156436"},{"group_id":"67836197","addon_id":"54156437"},{"group_id":"67836197","addon_id":"54156438"},{"group_id":"67836203","addon_id":"54156457"},{"group_id":"67836203","addon_id":"54156458"},{"group_id":"67836203","addon_id":"54156459"},{"group_id":"67836203","addon_id":"54156460"},{"group_id":"67836203","addon_id":"54156461"},{"group_id":"67836203","addon_id":"54156462"},{"group_id":"67836191","addon_id":"54156450"},{"group_id":"67836191","addon_id":"54156451"},{"group_id":"67836191","addon_id":"54156452"},{"group_id":"67836215","addon_id":"54156425"},{"group_id":"67836215","addon_id":"54156426"},{"group_id":"67836215","addon_id":"54156427"},{"group_id":"67836215","addon_id":"54156428"},{"group_id":"67836215","addon_id":"54156429"},{"group_id":"67866511","addon_id":"54168863"}]},{"variations":[{"group_id":"5810833","variation_id":"18813873"}],"price":13500,"addon_combinations":[{"group_id":"67836197","addon_id":"54156436"},{"group_id":"67836197","addon_id":"54156437"},{"group_id":"67836197","addon_id":"54156438"},{"group_id":"67836203","addon_id":"54156457"},{"group_id":"67836203","addon_id":"54156458"},{"group_id":"67836203","addon_id":"54156459"},{"group_id":"67836203","addon_id":"54156460"},{"group_id":"67836203","addon_id":"54156461"},{"group_id":"67836203","addon_id":"54156462"},{"group_id":"67836191","addon_id":"54156450"},{"group_id":"67836191","addon_id":"54156451"},{"group_id":"67836191","addon_id":"54156452"},{"group_id":"67836215","addon_id":"54156425"},{"group_id":"67836215","addon_id":"54156426"},{"group_id":"67836215","addon_id":"54156427"},{"group_id":"67836215","addon_id":"54156428"},{"group_id":"67836215","addon_id":"54156429"},{"group_id":"67866511","addon_id":"54168863"}]}]},"addons":[{"group_id":67836197,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67836203,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67836191,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67836215,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93},{"group_id":67866511,"group_name":"Bread","choices":[{"id":54168863,"name":"Kuboos","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":92}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822549":{"id":47822549,"name":"Mutton Varuval","category":"Empire Special Mutton (Gravy)","description":"","cloudinaryImageId":"bmeksa4b6do9jkpxurz7","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810834","name":"Portion","variations":[{"name":"Full","price":618,"default":0,"id":"18813878","inStock":1,"isVeg":0,"variant_group_id":"5810834","order":0},{"name":"Half","price":319,"default":0,"id":"18813877","inStock":1,"isVeg":0,"variant_group_id":"5810834","order":0},{"name":"Qtr","price":170,"default":1,"id":"18813876","inStock":1,"isVeg":0,"variant_group_id":"5810834","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810834","variation_id":"18813878"}],"price":61800,"addon_combinations":[{"group_id":"68923517","addon_id":"54935012"},{"group_id":"67836280","addon_id":"54156416"},{"group_id":"67836280","addon_id":"54156417"},{"group_id":"67836280","addon_id":"54156418"},{"group_id":"67836282","addon_id":"54156419"},{"group_id":"67836282","addon_id":"54156420"},{"group_id":"67836282","addon_id":"54156421"},{"group_id":"67836282","addon_id":"54156422"},{"group_id":"67836282","addon_id":"54156423"},{"group_id":"67836282","addon_id":"54156424"},{"group_id":"67836302","addon_id":"54156425"},{"group_id":"67836302","addon_id":"54156426"},{"group_id":"67836302","addon_id":"54156427"},{"group_id":"67836302","addon_id":"54156428"},{"group_id":"67836302","addon_id":"54156429"}]},{"variations":[{"group_id":"5810834","variation_id":"18813877"}],"price":31900,"addon_combinations":[{"group_id":"68923517","addon_id":"54935012"},{"group_id":"67836280","addon_id":"54156416"},{"group_id":"67836280","addon_id":"54156417"},{"group_id":"67836280","addon_id":"54156418"},{"group_id":"67836282","addon_id":"54156419"},{"group_id":"67836282","addon_id":"54156420"},{"group_id":"67836282","addon_id":"54156421"},{"group_id":"67836282","addon_id":"54156422"},{"group_id":"67836282","addon_id":"54156423"},{"group_id":"67836282","addon_id":"54156424"},{"group_id":"67836302","addon_id":"54156425"},{"group_id":"67836302","addon_id":"54156426"},{"group_id":"67836302","addon_id":"54156427"},{"group_id":"67836302","addon_id":"54156428"},{"group_id":"67836302","addon_id":"54156429"}]},{"variations":[{"group_id":"5810834","variation_id":"18813876"}],"price":17000,"addon_combinations":[{"group_id":"68923517","addon_id":"54935012"},{"group_id":"67836280","addon_id":"54156416"},{"group_id":"67836280","addon_id":"54156417"},{"group_id":"67836280","addon_id":"54156418"},{"group_id":"67836282","addon_id":"54156419"},{"group_id":"67836282","addon_id":"54156420"},{"group_id":"67836282","addon_id":"54156421"},{"group_id":"67836282","addon_id":"54156422"},{"group_id":"67836282","addon_id":"54156423"},{"group_id":"67836282","addon_id":"54156424"},{"group_id":"67836302","addon_id":"54156425"},{"group_id":"67836302","addon_id":"54156426"},{"group_id":"67836302","addon_id":"54156427"},{"group_id":"67836302","addon_id":"54156428"},{"group_id":"67836302","addon_id":"54156429"}]}]},"addons":[{"group_id":68923517,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836280,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836282,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836302,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822550":{"id":47822550,"name":"Arabian Dry Fruit Sundae","category":"Juice Shop","description":"Enjoy this royal treat of sundae made from combination of chocolate, butterscotch and fig ice cream. it's topped with chocolate sauce, cereals and dry fruits.","cloudinaryImageId":"ruf8nsri8m5igsex3yvv","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":17600,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822555":{"id":47822555,"name":"Veg Kurma","category":"Veg Gravy","description":"","cloudinaryImageId":"aabyscimg5b0yyf4k4yu","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810837","name":"Portion ","variations":[{"name":"Half","price":145,"default":0,"id":"18813886","inStock":1,"isVeg":1,"variant_group_id":"5810837","order":0},{"name":"Qtr","price":85,"default":1,"id":"18813885","inStock":1,"isVeg":1,"variant_group_id":"5810837","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810837","variation_id":"18813886"}],"price":14500,"addon_combinations":[{"group_id":"68924583","addon_id":"54935012"},{"group_id":"67836466","addon_id":"54156416"},{"group_id":"67836466","addon_id":"54156417"},{"group_id":"67836466","addon_id":"54156418"},{"group_id":"67836496","addon_id":"54156419"},{"group_id":"67836496","addon_id":"54156420"},{"group_id":"67836496","addon_id":"54156421"},{"group_id":"67836496","addon_id":"54156422"},{"group_id":"67836496","addon_id":"54156423"},{"group_id":"67836496","addon_id":"54156424"},{"group_id":"67836512","addon_id":"54156425"},{"group_id":"67836512","addon_id":"54156426"},{"group_id":"67836512","addon_id":"54156427"},{"group_id":"67836512","addon_id":"54156428"},{"group_id":"67836512","addon_id":"54156429"}]},{"variations":[{"group_id":"5810837","variation_id":"18813885"}],"price":8500,"addon_combinations":[{"group_id":"68924583","addon_id":"54935012"},{"group_id":"67836466","addon_id":"54156416"},{"group_id":"67836466","addon_id":"54156417"},{"group_id":"67836466","addon_id":"54156418"},{"group_id":"67836496","addon_id":"54156419"},{"group_id":"67836496","addon_id":"54156420"},{"group_id":"67836496","addon_id":"54156421"},{"group_id":"67836496","addon_id":"54156422"},{"group_id":"67836496","addon_id":"54156423"},{"group_id":"67836496","addon_id":"54156424"},{"group_id":"67836512","addon_id":"54156425"},{"group_id":"67836512","addon_id":"54156426"},{"group_id":"67836512","addon_id":"54156427"},{"group_id":"67836512","addon_id":"54156428"},{"group_id":"67836512","addon_id":"54156429"}]}]},"addons":[{"group_id":68924583,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836466,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836496,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836512,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":8500,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822560":{"id":47822560,"name":"Kadai Veg","category":"North Indian Veg (gravy)","description":"","cloudinaryImageId":"s3wwjyfhrp5fgcmajdjr","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":13500,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68923548,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67836618,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836629,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836637,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822563":{"id":47822563,"name":"Raitha","category":"Veg Gravy","description":"","cloudinaryImageId":"pxfpgtc5od4wnvqtqlgk","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810843","name":"Portion ","variations":[{"name":"Half","price":55,"default":0,"id":"18813903","inStock":1,"isVeg":1,"variant_group_id":"5810843","order":0},{"name":"Qtr","price":35,"default":1,"id":"18813902","inStock":1,"isVeg":1,"variant_group_id":"5810843","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810843","variation_id":"18813903"}],"price":5500,"addon_combinations":[{"group_id":"67836658","addon_id":"54156416"},{"group_id":"67836658","addon_id":"54156417"},{"group_id":"67836658","addon_id":"54156418"},{"group_id":"67836663","addon_id":"54156419"},{"group_id":"67836663","addon_id":"54156420"},{"group_id":"67836663","addon_id":"54156421"},{"group_id":"67836663","addon_id":"54156422"},{"group_id":"67836663","addon_id":"54156423"},{"group_id":"67836663","addon_id":"54156424"},{"group_id":"67836673","addon_id":"54156425"},{"group_id":"67836673","addon_id":"54156426"},{"group_id":"67836673","addon_id":"54156427"},{"group_id":"67836673","addon_id":"54156428"},{"group_id":"67836673","addon_id":"54156429"}]},{"variations":[{"group_id":"5810843","variation_id":"18813902"}],"price":3500,"addon_combinations":[{"group_id":"67836658","addon_id":"54156416"},{"group_id":"67836658","addon_id":"54156417"},{"group_id":"67836658","addon_id":"54156418"},{"group_id":"67836663","addon_id":"54156419"},{"group_id":"67836663","addon_id":"54156420"},{"group_id":"67836663","addon_id":"54156421"},{"group_id":"67836663","addon_id":"54156422"},{"group_id":"67836663","addon_id":"54156423"},{"group_id":"67836663","addon_id":"54156424"},{"group_id":"67836673","addon_id":"54156425"},{"group_id":"67836673","addon_id":"54156426"},{"group_id":"67836673","addon_id":"54156427"},{"group_id":"67836673","addon_id":"54156428"},{"group_id":"67836673","addon_id":"54156429"}]}]},"addons":[{"group_id":67836658,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67836663,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67836673,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3500,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822570":{"id":47822570,"name":"Murg Tikka","category":"Tandoori(dry)","description":"","cloudinaryImageId":"nncv1qc5djsgljrs2eoz","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810850","name":"Portion ","variations":[{"name":"Full","price":490,"default":0,"id":"18813923","inStock":1,"isVeg":0,"variant_group_id":"5810850","order":0},{"name":"Half","price":250,"default":0,"id":"18813922","inStock":1,"isVeg":0,"variant_group_id":"5810850","order":0},{"name":"Qtr","price":140,"default":1,"id":"18813921","inStock":1,"isVeg":0,"variant_group_id":"5810850","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810850","variation_id":"18813923"}],"price":49000,"addon_combinations":[{"group_id":"67836747","addon_id":"54156436"},{"group_id":"67836747","addon_id":"54156437"},{"group_id":"67836747","addon_id":"54156438"},{"group_id":"67836743","addon_id":"54156450"},{"group_id":"67836743","addon_id":"54156451"},{"group_id":"67836743","addon_id":"54156452"},{"group_id":"67836756","addon_id":"54156425"},{"group_id":"67836756","addon_id":"54156426"},{"group_id":"67836756","addon_id":"54156427"},{"group_id":"67836756","addon_id":"54156428"},{"group_id":"67836756","addon_id":"54156429"}]},{"variations":[{"group_id":"5810850","variation_id":"18813922"}],"price":25000,"addon_combinations":[{"group_id":"67836747","addon_id":"54156436"},{"group_id":"67836747","addon_id":"54156437"},{"group_id":"67836747","addon_id":"54156438"},{"group_id":"67836743","addon_id":"54156450"},{"group_id":"67836743","addon_id":"54156451"},{"group_id":"67836743","addon_id":"54156452"},{"group_id":"67836756","addon_id":"54156425"},{"group_id":"67836756","addon_id":"54156426"},{"group_id":"67836756","addon_id":"54156427"},{"group_id":"67836756","addon_id":"54156428"},{"group_id":"67836756","addon_id":"54156429"}]},{"variations":[{"group_id":"5810850","variation_id":"18813921"}],"price":14000,"addon_combinations":[{"group_id":"67836747","addon_id":"54156436"},{"group_id":"67836747","addon_id":"54156437"},{"group_id":"67836747","addon_id":"54156438"},{"group_id":"67836743","addon_id":"54156450"},{"group_id":"67836743","addon_id":"54156451"},{"group_id":"67836743","addon_id":"54156452"},{"group_id":"67836756","addon_id":"54156425"},{"group_id":"67836756","addon_id":"54156426"},{"group_id":"67836756","addon_id":"54156427"},{"group_id":"67836756","addon_id":"54156428"},{"group_id":"67836756","addon_id":"54156429"}]}]},"addons":[{"group_id":67836747,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67836743,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67836756,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822573":{"id":47822573,"name":"Chicken Manchurian Boneless","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"gloajcuovqkezogtpfud","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"8244229","name":"Portion ","variations":[{"name":"Full","price":474,"default":0,"id":"27551810","inStock":1,"isVeg":0,"variant_group_id":"8244229","order":0},{"name":"Half","price":247,"default":0,"id":"27551809","inStock":1,"isVeg":0,"variant_group_id":"8244229","order":0},{"name":"Qtr","price":134,"default":1,"id":"27551808","inStock":1,"isVeg":0,"variant_group_id":"8244229","order":0}]}],"pricing_models":[{"variations":[{"group_id":"8244229","variation_id":"27551810"}],"price":47400,"addon_combinations":[{"group_id":"67836982","addon_id":"54156436"},{"group_id":"67836982","addon_id":"54156437"},{"group_id":"67836982","addon_id":"54156438"},{"group_id":"67836987","addon_id":"54156457"},{"group_id":"67836987","addon_id":"54156458"},{"group_id":"67836987","addon_id":"54156459"},{"group_id":"67836987","addon_id":"54156460"},{"group_id":"67836987","addon_id":"54156461"},{"group_id":"67836987","addon_id":"54156462"},{"group_id":"67836975","addon_id":"54156450"},{"group_id":"67836975","addon_id":"54156451"},{"group_id":"67836975","addon_id":"54156452"},{"group_id":"67836998","addon_id":"54156425"},{"group_id":"67836998","addon_id":"54156426"},{"group_id":"67836998","addon_id":"54156427"},{"group_id":"67836998","addon_id":"54156428"},{"group_id":"67836998","addon_id":"54156429"}]},{"variations":[{"group_id":"8244229","variation_id":"27551809"}],"price":24700,"addon_combinations":[{"group_id":"67836982","addon_id":"54156436"},{"group_id":"67836982","addon_id":"54156437"},{"group_id":"67836982","addon_id":"54156438"},{"group_id":"67836987","addon_id":"54156457"},{"group_id":"67836987","addon_id":"54156458"},{"group_id":"67836987","addon_id":"54156459"},{"group_id":"67836987","addon_id":"54156460"},{"group_id":"67836987","addon_id":"54156461"},{"group_id":"67836987","addon_id":"54156462"},{"group_id":"67836975","addon_id":"54156450"},{"group_id":"67836975","addon_id":"54156451"},{"group_id":"67836975","addon_id":"54156452"},{"group_id":"67836998","addon_id":"54156425"},{"group_id":"67836998","addon_id":"54156426"},{"group_id":"67836998","addon_id":"54156427"},{"group_id":"67836998","addon_id":"54156428"},{"group_id":"67836998","addon_id":"54156429"}]},{"variations":[{"group_id":"8244229","variation_id":"27551808"}],"price":13400,"addon_combinations":[{"group_id":"67836982","addon_id":"54156436"},{"group_id":"67836982","addon_id":"54156437"},{"group_id":"67836982","addon_id":"54156438"},{"group_id":"67836987","addon_id":"54156457"},{"group_id":"67836987","addon_id":"54156458"},{"group_id":"67836987","addon_id":"54156459"},{"group_id":"67836987","addon_id":"54156460"},{"group_id":"67836987","addon_id":"54156461"},{"group_id":"67836987","addon_id":"54156462"},{"group_id":"67836975","addon_id":"54156450"},{"group_id":"67836975","addon_id":"54156451"},{"group_id":"67836975","addon_id":"54156452"},{"group_id":"67836998","addon_id":"54156425"},{"group_id":"67836998","addon_id":"54156426"},{"group_id":"67836998","addon_id":"54156427"},{"group_id":"67836998","addon_id":"54156428"},{"group_id":"67836998","addon_id":"54156429"}]}]},"addons":[{"group_id":67836982,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67836987,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67836975,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67836998,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13400,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822574":{"id":47822574,"name":"Mutton Pepper Dry","category":"Empire Special Mutton (Dry)","description":"","cloudinaryImageId":"tbbdp3koyjvnutggkual","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810856","name":"Portion","variations":[{"name":"Full","price":618,"default":0,"id":"18813940","inStock":1,"isVeg":0,"variant_group_id":"5810856","order":0},{"name":"Half","price":319,"default":0,"id":"18813939","inStock":1,"isVeg":0,"variant_group_id":"5810856","order":0},{"name":"Qtr","price":175,"default":1,"id":"18813938","inStock":1,"isVeg":0,"variant_group_id":"5810856","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810856","variation_id":"18813940"}],"price":61800,"addon_combinations":[{"group_id":"67837014","addon_id":"54156425"},{"group_id":"67837014","addon_id":"54156426"},{"group_id":"67837014","addon_id":"54156427"},{"group_id":"67837014","addon_id":"54156428"},{"group_id":"67837014","addon_id":"54156429"}]},{"variations":[{"group_id":"5810856","variation_id":"18813939"}],"price":31900,"addon_combinations":[{"group_id":"67837014","addon_id":"54156425"},{"group_id":"67837014","addon_id":"54156426"},{"group_id":"67837014","addon_id":"54156427"},{"group_id":"67837014","addon_id":"54156428"},{"group_id":"67837014","addon_id":"54156429"}]},{"variations":[{"group_id":"5810856","variation_id":"18813938"}],"price":17500,"addon_combinations":[{"group_id":"67837014","addon_id":"54156425"},{"group_id":"67837014","addon_id":"54156426"},{"group_id":"67837014","addon_id":"54156427"},{"group_id":"67837014","addon_id":"54156428"},{"group_id":"67837014","addon_id":"54156429"}]}]},"addons":[{"group_id":67837014,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822576":{"id":47822576,"name":"Biriyani Rice (non Veg)","category":"Biriyani And Rice","description":"","cloudinaryImageId":"yaou4iakzffgz8zl8rhj","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":12700,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924001,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67842001,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842039,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67841997,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67841992,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67842072,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67842075,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822578":{"id":47822578,"name":"Chilly Chicken Dry","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"yhq0iyriltkxoyh0yqyl","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810860","name":"Portion","variations":[{"name":"Full","price":440,"default":0,"id":"18813951","inStock":1,"isVeg":0,"variant_group_id":"5810860","order":0},{"name":"Half","price":230,"default":0,"id":"18813950","inStock":1,"isVeg":0,"variant_group_id":"5810860","order":0},{"name":"Qtr","price":130,"default":1,"id":"18813949","inStock":1,"isVeg":0,"variant_group_id":"5810860","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810860","variation_id":"18813951"}],"price":44000,"addon_combinations":[]},{"variations":[{"group_id":"5810860","variation_id":"18813950"}],"price":23000,"addon_combinations":[]},{"variations":[{"group_id":"5810860","variation_id":"18813949"}],"price":13000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13000,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822582":{"id":47822582,"name":"Paneer Chilly Dry","category":"Veg Dry","description":"","cloudinaryImageId":"j1kkkv5uzgtbtgnwexkr","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810862","name":"Portion ","variations":[{"name":"Half","price":175,"default":0,"id":"18813956","inStock":1,"isVeg":1,"variant_group_id":"5810862","order":0},{"name":"Qtr","price":100,"default":1,"id":"18813955","inStock":1,"isVeg":1,"variant_group_id":"5810862","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810862","variation_id":"18813956"}],"price":17500,"addon_combinations":[{"group_id":"67837200","addon_id":"54156457"},{"group_id":"67837200","addon_id":"54156458"},{"group_id":"67837200","addon_id":"54156459"},{"group_id":"67837200","addon_id":"54156460"},{"group_id":"67837200","addon_id":"54156461"},{"group_id":"67837200","addon_id":"54156462"},{"group_id":"67837210","addon_id":"54156425"},{"group_id":"67837210","addon_id":"54156426"},{"group_id":"67837210","addon_id":"54156427"},{"group_id":"67837210","addon_id":"54156428"},{"group_id":"67837210","addon_id":"54156429"}]},{"variations":[{"group_id":"5810862","variation_id":"18813955"}],"price":10000,"addon_combinations":[{"group_id":"67837200","addon_id":"54156457"},{"group_id":"67837200","addon_id":"54156458"},{"group_id":"67837200","addon_id":"54156459"},{"group_id":"67837200","addon_id":"54156460"},{"group_id":"67837200","addon_id":"54156461"},{"group_id":"67837200","addon_id":"54156462"},{"group_id":"67837210","addon_id":"54156425"},{"group_id":"67837210","addon_id":"54156426"},{"group_id":"67837210","addon_id":"54156427"},{"group_id":"67837210","addon_id":"54156428"},{"group_id":"67837210","addon_id":"54156429"}]}]},"addons":[{"group_id":67837200,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837210,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":10000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822584":{"id":47822584,"name":"Egg Parotta","category":"Parottas","description":"","cloudinaryImageId":"fdreyhmkuy5uqcsp4yj4","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":8900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67837329,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837341,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837355,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822589":{"id":47822589,"name":"Ghee Chapathi","category":"Parottas","description":"","cloudinaryImageId":"qsdkgx5pnq02wplrjoet","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808585","name":"Complementary","variations":[{"name":"Complementary Dal","price":32,"default":1,"id":"77096111","inStock":1,"isVeg":1,"variant_group_id":"23808585","order":100},{"name":"Complementary Red Gravy","price":32,"default":0,"id":"77096112","inStock":1,"isVeg":1,"variant_group_id":"23808585","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808585","variation_id":"77096111"}],"price":3200,"addon_combinations":[{"group_id":"67837531","addon_id":"54156419"},{"group_id":"67837531","addon_id":"54156420"},{"group_id":"67837531","addon_id":"54156421"},{"group_id":"67837531","addon_id":"54156422"},{"group_id":"67837531","addon_id":"54156423"},{"group_id":"67837531","addon_id":"54156424"},{"group_id":"67837547","addon_id":"54156457"},{"group_id":"67837547","addon_id":"54156458"},{"group_id":"67837547","addon_id":"54156459"},{"group_id":"67837547","addon_id":"54156460"},{"group_id":"67837547","addon_id":"54156461"},{"group_id":"67837547","addon_id":"54156462"},{"group_id":"67837556","addon_id":"54156425"},{"group_id":"67837556","addon_id":"54156426"},{"group_id":"67837556","addon_id":"54156427"},{"group_id":"67837556","addon_id":"54156428"},{"group_id":"67837556","addon_id":"54156429"}]},{"variations":[{"group_id":"23808585","variation_id":"77096112"}],"price":3200,"addon_combinations":[{"group_id":"67837531","addon_id":"54156419"},{"group_id":"67837531","addon_id":"54156420"},{"group_id":"67837531","addon_id":"54156421"},{"group_id":"67837531","addon_id":"54156422"},{"group_id":"67837531","addon_id":"54156423"},{"group_id":"67837531","addon_id":"54156424"},{"group_id":"67837547","addon_id":"54156457"},{"group_id":"67837547","addon_id":"54156458"},{"group_id":"67837547","addon_id":"54156459"},{"group_id":"67837547","addon_id":"54156460"},{"group_id":"67837547","addon_id":"54156461"},{"group_id":"67837547","addon_id":"54156462"},{"group_id":"67837556","addon_id":"54156425"},{"group_id":"67837556","addon_id":"54156426"},{"group_id":"67837556","addon_id":"54156427"},{"group_id":"67837556","addon_id":"54156428"},{"group_id":"67837556","addon_id":"54156429"}]}]},"addons":[{"group_id":67837531,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837547,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837556,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":3200,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822591":{"id":47822591,"name":"Orange Juice","category":"Juice Shop","description":"100% Pure Fresh Juices, No Water Added","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":9900,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822592":{"id":47822592,"name":"Pappad","category":"Veg Dry","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":2000,"variants_new":{},"addons":[{"group_id":67837611,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67837620,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822599":{"id":47822599,"name":"Aloo Gobi Gravy","category":"Veg Gravy","description":"","cloudinaryImageId":"oozehfnmdnbwmhtxyq9a","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810873","name":"Portion ","variations":[{"name":"Half","price":165,"default":0,"id":"18813985","inStock":1,"isVeg":1,"variant_group_id":"5810873","order":0},{"name":"Qtr","price":95,"default":1,"id":"18813984","inStock":1,"isVeg":1,"variant_group_id":"5810873","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810873","variation_id":"18813985"}],"price":16500,"addon_combinations":[{"group_id":"68923609","addon_id":"54935012"},{"group_id":"67837843","addon_id":"54156416"},{"group_id":"67837843","addon_id":"54156417"},{"group_id":"67837843","addon_id":"54156418"},{"group_id":"67837852","addon_id":"54156419"},{"group_id":"67837852","addon_id":"54156420"},{"group_id":"67837852","addon_id":"54156421"},{"group_id":"67837852","addon_id":"54156422"},{"group_id":"67837852","addon_id":"54156423"},{"group_id":"67837852","addon_id":"54156424"},{"group_id":"67837868","addon_id":"54156425"},{"group_id":"67837868","addon_id":"54156426"},{"group_id":"67837868","addon_id":"54156427"},{"group_id":"67837868","addon_id":"54156428"},{"group_id":"67837868","addon_id":"54156429"}]},{"variations":[{"group_id":"5810873","variation_id":"18813984"}],"price":9500,"addon_combinations":[{"group_id":"68923609","addon_id":"54935012"},{"group_id":"67837843","addon_id":"54156416"},{"group_id":"67837843","addon_id":"54156417"},{"group_id":"67837843","addon_id":"54156418"},{"group_id":"67837852","addon_id":"54156419"},{"group_id":"67837852","addon_id":"54156420"},{"group_id":"67837852","addon_id":"54156421"},{"group_id":"67837852","addon_id":"54156422"},{"group_id":"67837852","addon_id":"54156423"},{"group_id":"67837852","addon_id":"54156424"},{"group_id":"67837868","addon_id":"54156425"},{"group_id":"67837868","addon_id":"54156426"},{"group_id":"67837868","addon_id":"54156427"},{"group_id":"67837868","addon_id":"54156428"},{"group_id":"67837868","addon_id":"54156429"}]}]},"addons":[{"group_id":68923609,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67837843,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67837852,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837868,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9500,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822601":{"id":47822601,"name":"Butter Chicken Boneless","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"vbtgihmcmseeizl1iuma","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810875","name":"Portion ","variations":[{"name":"Full","price":490,"default":0,"id":"18813991","inStock":1,"isVeg":0,"variant_group_id":"5810875","order":0},{"name":"Half","price":260,"default":0,"id":"18813990","inStock":1,"isVeg":0,"variant_group_id":"5810875","order":0},{"name":"Qtr","price":150,"default":1,"id":"18813989","inStock":1,"isVeg":0,"variant_group_id":"5810875","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810875","variation_id":"18813991"}],"price":49000,"addon_combinations":[{"group_id":"68923621","addon_id":"54935012"},{"group_id":"67837898","addon_id":"54156416"},{"group_id":"67837898","addon_id":"54156417"},{"group_id":"67837898","addon_id":"54156418"},{"group_id":"67837909","addon_id":"54156419"},{"group_id":"67837909","addon_id":"54156420"},{"group_id":"67837909","addon_id":"54156421"},{"group_id":"67837909","addon_id":"54156422"},{"group_id":"67837909","addon_id":"54156423"},{"group_id":"67837909","addon_id":"54156424"},{"group_id":"67837929","addon_id":"54156425"},{"group_id":"67837929","addon_id":"54156426"},{"group_id":"67837929","addon_id":"54156427"},{"group_id":"67837929","addon_id":"54156428"},{"group_id":"67837929","addon_id":"54156429"}]},{"variations":[{"group_id":"5810875","variation_id":"18813990"}],"price":26000,"addon_combinations":[{"group_id":"68923621","addon_id":"54935012"},{"group_id":"67837898","addon_id":"54156416"},{"group_id":"67837898","addon_id":"54156417"},{"group_id":"67837898","addon_id":"54156418"},{"group_id":"67837909","addon_id":"54156419"},{"group_id":"67837909","addon_id":"54156420"},{"group_id":"67837909","addon_id":"54156421"},{"group_id":"67837909","addon_id":"54156422"},{"group_id":"67837909","addon_id":"54156423"},{"group_id":"67837909","addon_id":"54156424"},{"group_id":"67837929","addon_id":"54156425"},{"group_id":"67837929","addon_id":"54156426"},{"group_id":"67837929","addon_id":"54156427"},{"group_id":"67837929","addon_id":"54156428"},{"group_id":"67837929","addon_id":"54156429"}]},{"variations":[{"group_id":"5810875","variation_id":"18813989"}],"price":15000,"addon_combinations":[{"group_id":"68923621","addon_id":"54935012"},{"group_id":"67837898","addon_id":"54156416"},{"group_id":"67837898","addon_id":"54156417"},{"group_id":"67837898","addon_id":"54156418"},{"group_id":"67837909","addon_id":"54156419"},{"group_id":"67837909","addon_id":"54156420"},{"group_id":"67837909","addon_id":"54156421"},{"group_id":"67837909","addon_id":"54156422"},{"group_id":"67837909","addon_id":"54156423"},{"group_id":"67837909","addon_id":"54156424"},{"group_id":"67837929","addon_id":"54156425"},{"group_id":"67837929","addon_id":"54156426"},{"group_id":"67837929","addon_id":"54156427"},{"group_id":"67837929","addon_id":"54156428"},{"group_id":"67837929","addon_id":"54156429"}]}]},"addons":[{"group_id":68923621,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67837898,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67837909,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67837929,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":15000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822606":{"id":47822606,"name":"Vanilla Ice Cream","category":"Juice Shop","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"6952722","name":"Scoops","variations":[{"name":"Single","price":70,"default":1,"id":"23380101","inStock":1,"isVeg":1,"variant_group_id":"6952722","order":99},{"name":"Double","price":135,"default":0,"id":"23380102","inStock":1,"isVeg":1,"variant_group_id":"6952722","order":98}]}],"pricing_models":[{"variations":[{"group_id":"6952722","variation_id":"23380101"}],"price":7000,"addon_combinations":[]},{"variations":[{"group_id":"6952722","variation_id":"23380102"}],"price":13500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822607":{"id":47822607,"name":"Fruit Salad With Vanilla Ice Cream","category":"Juice Shop","description":"You’ll love this Fruit Salad with Ice Cream! It is made with freshly cut tropical fruits that are then mixed with pure honey. To finish it off, we top it with a scoop of rich vanilla and strawberry ice cream. This sweet treat is the perfect way to complete your meal.","cloudinaryImageId":"jgrrpdkpqkg89mhzz9cy","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":12100,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822609":{"id":47822609,"name":"Chilly Chicken Boneless","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"jkyfek2e4uuwxduqec89","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810879","name":"Portion","variations":[{"name":"Full","price":470,"default":0,"id":"18814002","inStock":1,"isVeg":0,"variant_group_id":"5810879","order":0},{"name":"Half","price":247,"default":0,"id":"18814001","inStock":1,"isVeg":0,"variant_group_id":"5810879","order":0},{"name":"Qtr","price":140,"default":1,"id":"18814000","inStock":1,"isVeg":0,"variant_group_id":"5810879","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810879","variation_id":"18814002"}],"price":47000,"addon_combinations":[{"group_id":"67838071","addon_id":"54156436"},{"group_id":"67838071","addon_id":"54156437"},{"group_id":"67838071","addon_id":"54156438"},{"group_id":"67838079","addon_id":"54156457"},{"group_id":"67838079","addon_id":"54156458"},{"group_id":"67838079","addon_id":"54156459"},{"group_id":"67838079","addon_id":"54156460"},{"group_id":"67838079","addon_id":"54156461"},{"group_id":"67838079","addon_id":"54156462"},{"group_id":"67838067","addon_id":"54156450"},{"group_id":"67838067","addon_id":"54156451"},{"group_id":"67838067","addon_id":"54156452"},{"group_id":"67838091","addon_id":"54156425"},{"group_id":"67838091","addon_id":"54156426"},{"group_id":"67838091","addon_id":"54156427"},{"group_id":"67838091","addon_id":"54156428"},{"group_id":"67838091","addon_id":"54156429"}]},{"variations":[{"group_id":"5810879","variation_id":"18814001"}],"price":24700,"addon_combinations":[{"group_id":"67838071","addon_id":"54156436"},{"group_id":"67838071","addon_id":"54156437"},{"group_id":"67838071","addon_id":"54156438"},{"group_id":"67838079","addon_id":"54156457"},{"group_id":"67838079","addon_id":"54156458"},{"group_id":"67838079","addon_id":"54156459"},{"group_id":"67838079","addon_id":"54156460"},{"group_id":"67838079","addon_id":"54156461"},{"group_id":"67838079","addon_id":"54156462"},{"group_id":"67838067","addon_id":"54156450"},{"group_id":"67838067","addon_id":"54156451"},{"group_id":"67838067","addon_id":"54156452"},{"group_id":"67838091","addon_id":"54156425"},{"group_id":"67838091","addon_id":"54156426"},{"group_id":"67838091","addon_id":"54156427"},{"group_id":"67838091","addon_id":"54156428"},{"group_id":"67838091","addon_id":"54156429"}]},{"variations":[{"group_id":"5810879","variation_id":"18814000"}],"price":14000,"addon_combinations":[{"group_id":"67838071","addon_id":"54156436"},{"group_id":"67838071","addon_id":"54156437"},{"group_id":"67838071","addon_id":"54156438"},{"group_id":"67838079","addon_id":"54156457"},{"group_id":"67838079","addon_id":"54156458"},{"group_id":"67838079","addon_id":"54156459"},{"group_id":"67838079","addon_id":"54156460"},{"group_id":"67838079","addon_id":"54156461"},{"group_id":"67838079","addon_id":"54156462"},{"group_id":"67838067","addon_id":"54156450"},{"group_id":"67838067","addon_id":"54156451"},{"group_id":"67838067","addon_id":"54156452"},{"group_id":"67838091","addon_id":"54156425"},{"group_id":"67838091","addon_id":"54156426"},{"group_id":"67838091","addon_id":"54156427"},{"group_id":"67838091","addon_id":"54156428"},{"group_id":"67838091","addon_id":"54156429"}]}]},"addons":[{"group_id":67838071,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838079,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838067,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67838091,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822610":{"id":47822610,"name":"Mutton Pepper Dry Boneless","category":"Empire Special Mutton (Dry)","description":"","cloudinaryImageId":"r31xfm9x08iok9q0d5qo","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810880","name":"Portion","variations":[{"name":"Full","price":628,"default":0,"id":"18814005","inStock":1,"isVeg":0,"variant_group_id":"5810880","order":0},{"name":"Half","price":330,"default":0,"id":"18814004","inStock":1,"isVeg":0,"variant_group_id":"5810880","order":0},{"name":"Qtr","price":185,"default":1,"id":"18814003","inStock":1,"isVeg":0,"variant_group_id":"5810880","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810880","variation_id":"18814005"}],"price":62800,"addon_combinations":[{"group_id":"67838112","addon_id":"54156425"},{"group_id":"67838112","addon_id":"54156426"},{"group_id":"67838112","addon_id":"54156427"},{"group_id":"67838112","addon_id":"54156428"},{"group_id":"67838112","addon_id":"54156429"}]},{"variations":[{"group_id":"5810880","variation_id":"18814004"}],"price":33000,"addon_combinations":[{"group_id":"67838112","addon_id":"54156425"},{"group_id":"67838112","addon_id":"54156426"},{"group_id":"67838112","addon_id":"54156427"},{"group_id":"67838112","addon_id":"54156428"},{"group_id":"67838112","addon_id":"54156429"}]},{"variations":[{"group_id":"5810880","variation_id":"18814003"}],"price":18500,"addon_combinations":[{"group_id":"67838112","addon_id":"54156425"},{"group_id":"67838112","addon_id":"54156426"},{"group_id":"67838112","addon_id":"54156427"},{"group_id":"67838112","addon_id":"54156428"},{"group_id":"67838112","addon_id":"54156429"}]}]},"addons":[{"group_id":67838112,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":18500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822614":{"id":47822614,"name":"Pepper Chicken Dry Boneless","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"jzjh2o2tntz1kpp8bxug","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810885","name":"Portion","variations":[{"name":"Full","price":470,"default":0,"id":"18814020","inStock":1,"isVeg":0,"variant_group_id":"5810885","order":0},{"name":"Half","price":247,"default":0,"id":"18814019","inStock":1,"isVeg":0,"variant_group_id":"5810885","order":0},{"name":"Qtr","price":140,"default":1,"id":"18814018","inStock":1,"isVeg":0,"variant_group_id":"5810885","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810885","variation_id":"18814020"}],"price":47000,"addon_combinations":[{"group_id":"67838284","addon_id":"54156436"},{"group_id":"67838284","addon_id":"54156437"},{"group_id":"67838284","addon_id":"54156438"},{"group_id":"67838289","addon_id":"54156457"},{"group_id":"67838289","addon_id":"54156458"},{"group_id":"67838289","addon_id":"54156459"},{"group_id":"67838289","addon_id":"54156460"},{"group_id":"67838289","addon_id":"54156461"},{"group_id":"67838289","addon_id":"54156462"},{"group_id":"67838281","addon_id":"54156450"},{"group_id":"67838281","addon_id":"54156451"},{"group_id":"67838281","addon_id":"54156452"},{"group_id":"67838304","addon_id":"54156425"},{"group_id":"67838304","addon_id":"54156426"},{"group_id":"67838304","addon_id":"54156427"},{"group_id":"67838304","addon_id":"54156428"},{"group_id":"67838304","addon_id":"54156429"}]},{"variations":[{"group_id":"5810885","variation_id":"18814019"}],"price":24700,"addon_combinations":[{"group_id":"67838284","addon_id":"54156436"},{"group_id":"67838284","addon_id":"54156437"},{"group_id":"67838284","addon_id":"54156438"},{"group_id":"67838289","addon_id":"54156457"},{"group_id":"67838289","addon_id":"54156458"},{"group_id":"67838289","addon_id":"54156459"},{"group_id":"67838289","addon_id":"54156460"},{"group_id":"67838289","addon_id":"54156461"},{"group_id":"67838289","addon_id":"54156462"},{"group_id":"67838281","addon_id":"54156450"},{"group_id":"67838281","addon_id":"54156451"},{"group_id":"67838281","addon_id":"54156452"},{"group_id":"67838304","addon_id":"54156425"},{"group_id":"67838304","addon_id":"54156426"},{"group_id":"67838304","addon_id":"54156427"},{"group_id":"67838304","addon_id":"54156428"},{"group_id":"67838304","addon_id":"54156429"}]},{"variations":[{"group_id":"5810885","variation_id":"18814018"}],"price":14000,"addon_combinations":[{"group_id":"67838284","addon_id":"54156436"},{"group_id":"67838284","addon_id":"54156437"},{"group_id":"67838284","addon_id":"54156438"},{"group_id":"67838289","addon_id":"54156457"},{"group_id":"67838289","addon_id":"54156458"},{"group_id":"67838289","addon_id":"54156459"},{"group_id":"67838289","addon_id":"54156460"},{"group_id":"67838289","addon_id":"54156461"},{"group_id":"67838289","addon_id":"54156462"},{"group_id":"67838281","addon_id":"54156450"},{"group_id":"67838281","addon_id":"54156451"},{"group_id":"67838281","addon_id":"54156452"},{"group_id":"67838304","addon_id":"54156425"},{"group_id":"67838304","addon_id":"54156426"},{"group_id":"67838304","addon_id":"54156427"},{"group_id":"67838304","addon_id":"54156428"},{"group_id":"67838304","addon_id":"54156429"}]}]},"addons":[{"group_id":67838284,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838289,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67838281,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67838304,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"47822617":{"id":47822617,"name":"Chicken Varuval","category":"Empire Special Chicken (Gravy)","description":"","cloudinaryImageId":"mk3acltmonkzutknsqny","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810887","name":"Portion","variations":[{"name":"Full","price":470,"default":0,"id":"18814025","inStock":1,"isVeg":0,"variant_group_id":"5810887","order":0},{"name":"Half","price":250,"default":0,"id":"18814024","inStock":1,"isVeg":0,"variant_group_id":"5810887","order":0},{"name":"Qtr","price":140,"default":1,"id":"18814023","inStock":1,"isVeg":0,"variant_group_id":"5810887","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810887","variation_id":"18814025"}],"price":47000,"addon_combinations":[{"group_id":"68923663","addon_id":"54935012"},{"group_id":"67838418","addon_id":"54156416"},{"group_id":"67838418","addon_id":"54156417"},{"group_id":"67838418","addon_id":"54156418"},{"group_id":"67838427","addon_id":"54156419"},{"group_id":"67838427","addon_id":"54156420"},{"group_id":"67838427","addon_id":"54156421"},{"group_id":"67838427","addon_id":"54156422"},{"group_id":"67838427","addon_id":"54156423"},{"group_id":"67838427","addon_id":"54156424"},{"group_id":"67838446","addon_id":"54156425"},{"group_id":"67838446","addon_id":"54156426"},{"group_id":"67838446","addon_id":"54156427"},{"group_id":"67838446","addon_id":"54156428"},{"group_id":"67838446","addon_id":"54156429"}]},{"variations":[{"group_id":"5810887","variation_id":"18814024"}],"price":25000,"addon_combinations":[{"group_id":"68923663","addon_id":"54935012"},{"group_id":"67838418","addon_id":"54156416"},{"group_id":"67838418","addon_id":"54156417"},{"group_id":"67838418","addon_id":"54156418"},{"group_id":"67838427","addon_id":"54156419"},{"group_id":"67838427","addon_id":"54156420"},{"group_id":"67838427","addon_id":"54156421"},{"group_id":"67838427","addon_id":"54156422"},{"group_id":"67838427","addon_id":"54156423"},{"group_id":"67838427","addon_id":"54156424"},{"group_id":"67838446","addon_id":"54156425"},{"group_id":"67838446","addon_id":"54156426"},{"group_id":"67838446","addon_id":"54156427"},{"group_id":"67838446","addon_id":"54156428"},{"group_id":"67838446","addon_id":"54156429"}]},{"variations":[{"group_id":"5810887","variation_id":"18814023"}],"price":14000,"addon_combinations":[{"group_id":"68923663","addon_id":"54935012"},{"group_id":"67838418","addon_id":"54156416"},{"group_id":"67838418","addon_id":"54156417"},{"group_id":"67838418","addon_id":"54156418"},{"group_id":"67838427","addon_id":"54156419"},{"group_id":"67838427","addon_id":"54156420"},{"group_id":"67838427","addon_id":"54156421"},{"group_id":"67838427","addon_id":"54156422"},{"group_id":"67838427","addon_id":"54156423"},{"group_id":"67838427","addon_id":"54156424"},{"group_id":"67838446","addon_id":"54156425"},{"group_id":"67838446","addon_id":"54156426"},{"group_id":"67838446","addon_id":"54156427"},{"group_id":"67838446","addon_id":"54156428"},{"group_id":"67838446","addon_id":"54156429"}]}]},"addons":[{"group_id":68923663,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67838418,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67838427,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838446,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822621":{"id":47822621,"name":"Hyderabadi Chicken Boneless Gravy","category":"North Indian Non Veg (gravy)","description":"","cloudinaryImageId":"vjzytwcf9qrj6mjqm0hh","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810891","name":"Portion","variations":[{"name":"Full","price":490,"default":0,"id":"18814037","inStock":1,"isVeg":0,"variant_group_id":"5810891","order":0},{"name":"Half","price":260,"default":0,"id":"18814036","inStock":1,"isVeg":0,"variant_group_id":"5810891","order":0},{"name":"Qtr","price":150,"default":1,"id":"18814035","inStock":1,"isVeg":0,"variant_group_id":"5810891","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810891","variation_id":"18814037"}],"price":49000,"addon_combinations":[{"group_id":"68923672","addon_id":"54935012"},{"group_id":"67838478","addon_id":"54156416"},{"group_id":"67838478","addon_id":"54156417"},{"group_id":"67838478","addon_id":"54156418"},{"group_id":"67838496","addon_id":"54156419"},{"group_id":"67838496","addon_id":"54156420"},{"group_id":"67838496","addon_id":"54156421"},{"group_id":"67838496","addon_id":"54156422"},{"group_id":"67838496","addon_id":"54156423"},{"group_id":"67838496","addon_id":"54156424"},{"group_id":"67838519","addon_id":"54156425"},{"group_id":"67838519","addon_id":"54156426"},{"group_id":"67838519","addon_id":"54156427"},{"group_id":"67838519","addon_id":"54156428"},{"group_id":"67838519","addon_id":"54156429"}]},{"variations":[{"group_id":"5810891","variation_id":"18814036"}],"price":26000,"addon_combinations":[{"group_id":"68923672","addon_id":"54935012"},{"group_id":"67838478","addon_id":"54156416"},{"group_id":"67838478","addon_id":"54156417"},{"group_id":"67838478","addon_id":"54156418"},{"group_id":"67838496","addon_id":"54156419"},{"group_id":"67838496","addon_id":"54156420"},{"group_id":"67838496","addon_id":"54156421"},{"group_id":"67838496","addon_id":"54156422"},{"group_id":"67838496","addon_id":"54156423"},{"group_id":"67838496","addon_id":"54156424"},{"group_id":"67838519","addon_id":"54156425"},{"group_id":"67838519","addon_id":"54156426"},{"group_id":"67838519","addon_id":"54156427"},{"group_id":"67838519","addon_id":"54156428"},{"group_id":"67838519","addon_id":"54156429"}]},{"variations":[{"group_id":"5810891","variation_id":"18814035"}],"price":15000,"addon_combinations":[{"group_id":"68923672","addon_id":"54935012"},{"group_id":"67838478","addon_id":"54156416"},{"group_id":"67838478","addon_id":"54156417"},{"group_id":"67838478","addon_id":"54156418"},{"group_id":"67838496","addon_id":"54156419"},{"group_id":"67838496","addon_id":"54156420"},{"group_id":"67838496","addon_id":"54156421"},{"group_id":"67838496","addon_id":"54156422"},{"group_id":"67838496","addon_id":"54156423"},{"group_id":"67838496","addon_id":"54156424"},{"group_id":"67838519","addon_id":"54156425"},{"group_id":"67838519","addon_id":"54156426"},{"group_id":"67838519","addon_id":"54156427"},{"group_id":"67838519","addon_id":"54156428"},{"group_id":"67838519","addon_id":"54156429"}]}]},"addons":[{"group_id":68923672,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67838478,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67838496,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838519,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":15000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822622":{"id":47822622,"name":"Kadai Paneer","category":"North Indian Veg (gravy)","description":"","cloudinaryImageId":"bxxarwcannwouaouy3os","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810893","name":"Portion ","variations":[{"name":"Half","price":235,"default":0,"id":"18814042","inStock":1,"isVeg":1,"variant_group_id":"5810893","order":0},{"name":"Qtr","price":130,"default":1,"id":"18814041","inStock":1,"isVeg":1,"variant_group_id":"5810893","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810893","variation_id":"18814042"}],"price":23500,"addon_combinations":[{"group_id":"68923684","addon_id":"54935012"},{"group_id":"67838548","addon_id":"54156416"},{"group_id":"67838548","addon_id":"54156417"},{"group_id":"67838548","addon_id":"54156418"},{"group_id":"67838552","addon_id":"54156419"},{"group_id":"67838552","addon_id":"54156420"},{"group_id":"67838552","addon_id":"54156421"},{"group_id":"67838552","addon_id":"54156422"},{"group_id":"67838552","addon_id":"54156423"},{"group_id":"67838552","addon_id":"54156424"},{"group_id":"67838573","addon_id":"54156425"},{"group_id":"67838573","addon_id":"54156426"},{"group_id":"67838573","addon_id":"54156427"},{"group_id":"67838573","addon_id":"54156428"},{"group_id":"67838573","addon_id":"54156429"}]},{"variations":[{"group_id":"5810893","variation_id":"18814041"}],"price":13000,"addon_combinations":[{"group_id":"68923684","addon_id":"54935012"},{"group_id":"67838548","addon_id":"54156416"},{"group_id":"67838548","addon_id":"54156417"},{"group_id":"67838548","addon_id":"54156418"},{"group_id":"67838552","addon_id":"54156419"},{"group_id":"67838552","addon_id":"54156420"},{"group_id":"67838552","addon_id":"54156421"},{"group_id":"67838552","addon_id":"54156422"},{"group_id":"67838552","addon_id":"54156423"},{"group_id":"67838552","addon_id":"54156424"},{"group_id":"67838573","addon_id":"54156425"},{"group_id":"67838573","addon_id":"54156426"},{"group_id":"67838573","addon_id":"54156427"},{"group_id":"67838573","addon_id":"54156428"},{"group_id":"67838573","addon_id":"54156429"}]}]},"addons":[{"group_id":68923684,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67838548,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67838552,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67838573,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822626":{"id":47822626,"name":"Mojito Mint","category":"Juice Shop","description":"A refreshing classical drink made with muddling lemon wedge and fresh mint leaves and combined with fresh lime juice, chilled soda and crushed ice","cloudinaryImageId":"ye7vp7dueayhccb55znv","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685219","name":"Potion","variations":[{"name":"300ml","price":99,"default":1,"id":"71452668","inStock":1,"isVeg":1,"variant_group_id":"21685219","order":100},{"name":"1Ltr","price":290,"default":0,"id":"71452669","inStock":1,"isVeg":1,"variant_group_id":"21685219","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685219","variation_id":"71452668"}],"price":9900,"addon_combinations":[]},{"variations":[{"group_id":"21685219","variation_id":"71452669"}],"price":29000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822628":{"id":47822628,"name":"Murg Hariyali Tikka","category":"Tandoori(dry)","description":"","cloudinaryImageId":"tdugs28uwynfza1rlj64","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810898","name":"Portion ","variations":[{"name":"Full","price":505,"default":0,"id":"18814056","inStock":1,"isVeg":0,"variant_group_id":"5810898","order":0},{"name":"Half","price":260,"default":0,"id":"18814055","inStock":1,"isVeg":0,"variant_group_id":"5810898","order":0},{"name":"Qtr","price":140,"default":1,"id":"18814054","inStock":1,"isVeg":0,"variant_group_id":"5810898","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810898","variation_id":"18814056"}],"price":50500,"addon_combinations":[{"group_id":"67839024","addon_id":"54156436"},{"group_id":"67839024","addon_id":"54156437"},{"group_id":"67839024","addon_id":"54156438"},{"group_id":"67839017","addon_id":"54156450"},{"group_id":"67839017","addon_id":"54156451"},{"group_id":"67839017","addon_id":"54156452"},{"group_id":"67839035","addon_id":"54156425"},{"group_id":"67839035","addon_id":"54156426"},{"group_id":"67839035","addon_id":"54156427"},{"group_id":"67839035","addon_id":"54156428"},{"group_id":"67839035","addon_id":"54156429"}]},{"variations":[{"group_id":"5810898","variation_id":"18814055"}],"price":26000,"addon_combinations":[{"group_id":"67839024","addon_id":"54156436"},{"group_id":"67839024","addon_id":"54156437"},{"group_id":"67839024","addon_id":"54156438"},{"group_id":"67839017","addon_id":"54156450"},{"group_id":"67839017","addon_id":"54156451"},{"group_id":"67839017","addon_id":"54156452"},{"group_id":"67839035","addon_id":"54156425"},{"group_id":"67839035","addon_id":"54156426"},{"group_id":"67839035","addon_id":"54156427"},{"group_id":"67839035","addon_id":"54156428"},{"group_id":"67839035","addon_id":"54156429"}]},{"variations":[{"group_id":"5810898","variation_id":"18814054"}],"price":14000,"addon_combinations":[{"group_id":"67839024","addon_id":"54156436"},{"group_id":"67839024","addon_id":"54156437"},{"group_id":"67839024","addon_id":"54156438"},{"group_id":"67839017","addon_id":"54156450"},{"group_id":"67839017","addon_id":"54156451"},{"group_id":"67839017","addon_id":"54156452"},{"group_id":"67839035","addon_id":"54156425"},{"group_id":"67839035","addon_id":"54156426"},{"group_id":"67839035","addon_id":"54156427"},{"group_id":"67839035","addon_id":"54156428"},{"group_id":"67839035","addon_id":"54156429"}]}]},"addons":[{"group_id":67839024,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839017,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67839035,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822629":{"id":47822629,"name":"Empire Mix Parotta","category":"Parottas","description":"","cloudinaryImageId":"obn7o07vyyjjeqwifnsd","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":13700,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67839129,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67839139,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839151,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822630":{"id":47822630,"name":"Aloo Parotta","category":"Parottas","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":9100,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67839219,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67839243,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839211,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67839263,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822632":{"id":47822632,"name":"Empire Special Porota","category":"Parottas","description":"","cloudinaryImageId":"bvctwoc4xuwlpwwe1bif","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"23808606","name":"Complementary","variations":[{"name":"Complementary Dal","price":47,"default":1,"id":"77096153","inStock":1,"isVeg":1,"variant_group_id":"23808606","order":100},{"name":"Complementary Red Gravy","price":47,"default":0,"id":"77096154","inStock":1,"isVeg":1,"variant_group_id":"23808606","order":100}]}],"pricing_models":[{"variations":[{"group_id":"23808606","variation_id":"77096153"}],"price":4700,"addon_combinations":[{"group_id":"67839504","addon_id":"54156419"},{"group_id":"67839504","addon_id":"54156420"},{"group_id":"67839504","addon_id":"54156421"},{"group_id":"67839504","addon_id":"54156422"},{"group_id":"67839504","addon_id":"54156423"},{"group_id":"67839504","addon_id":"54156424"},{"group_id":"67839520","addon_id":"54156457"},{"group_id":"67839520","addon_id":"54156458"},{"group_id":"67839520","addon_id":"54156459"},{"group_id":"67839520","addon_id":"54156460"},{"group_id":"67839520","addon_id":"54156461"},{"group_id":"67839520","addon_id":"54156462"},{"group_id":"67839535","addon_id":"54156425"},{"group_id":"67839535","addon_id":"54156426"},{"group_id":"67839535","addon_id":"54156427"},{"group_id":"67839535","addon_id":"54156428"},{"group_id":"67839535","addon_id":"54156429"}]},{"variations":[{"group_id":"23808606","variation_id":"77096154"}],"price":4700,"addon_combinations":[{"group_id":"67839504","addon_id":"54156419"},{"group_id":"67839504","addon_id":"54156420"},{"group_id":"67839504","addon_id":"54156421"},{"group_id":"67839504","addon_id":"54156422"},{"group_id":"67839504","addon_id":"54156423"},{"group_id":"67839504","addon_id":"54156424"},{"group_id":"67839520","addon_id":"54156457"},{"group_id":"67839520","addon_id":"54156458"},{"group_id":"67839520","addon_id":"54156459"},{"group_id":"67839520","addon_id":"54156460"},{"group_id":"67839520","addon_id":"54156461"},{"group_id":"67839520","addon_id":"54156462"},{"group_id":"67839535","addon_id":"54156425"},{"group_id":"67839535","addon_id":"54156426"},{"group_id":"67839535","addon_id":"54156427"},{"group_id":"67839535","addon_id":"54156428"},{"group_id":"67839535","addon_id":"54156429"}]}]},"addons":[{"group_id":67839504,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67839520,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839535,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":4700,"attributes":{"portionSize":"","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822635":{"id":47822635,"name":"Fiery Chicken Wings","category":"Empire Special Chicken (Dry)","description":"","cloudinaryImageId":"pw9oczdrdjeeos8zxwn2","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810904","name":"Portion ","variations":[{"name":"Full","price":490,"default":0,"id":"18814073","inStock":1,"isVeg":0,"variant_group_id":"5810904","order":0},{"name":"Half","price":260,"default":0,"id":"18814072","inStock":1,"isVeg":0,"variant_group_id":"5810904","order":0},{"name":"Qtr","price":140,"default":1,"id":"28135464","inStock":1,"isVeg":0,"variant_group_id":"5810904","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810904","variation_id":"18814073"}],"price":49000,"addon_combinations":[{"group_id":"67839669","addon_id":"54156436"},{"group_id":"67839669","addon_id":"54156437"},{"group_id":"67839669","addon_id":"54156438"},{"group_id":"67839674","addon_id":"54156425"},{"group_id":"67839674","addon_id":"54156426"},{"group_id":"67839674","addon_id":"54156427"},{"group_id":"67839674","addon_id":"54156428"},{"group_id":"67839674","addon_id":"54156429"}]},{"variations":[{"group_id":"5810904","variation_id":"18814072"}],"price":26000,"addon_combinations":[{"group_id":"67839669","addon_id":"54156436"},{"group_id":"67839669","addon_id":"54156437"},{"group_id":"67839669","addon_id":"54156438"},{"group_id":"67839674","addon_id":"54156425"},{"group_id":"67839674","addon_id":"54156426"},{"group_id":"67839674","addon_id":"54156427"},{"group_id":"67839674","addon_id":"54156428"},{"group_id":"67839674","addon_id":"54156429"}]},{"variations":[{"group_id":"5810904","variation_id":"28135464"}],"price":14000,"addon_combinations":[{"group_id":"67839669","addon_id":"54156436"},{"group_id":"67839669","addon_id":"54156437"},{"group_id":"67839669","addon_id":"54156438"},{"group_id":"67839674","addon_id":"54156425"},{"group_id":"67839674","addon_id":"54156426"},{"group_id":"67839674","addon_id":"54156427"},{"group_id":"67839674","addon_id":"54156428"},{"group_id":"67839674","addon_id":"54156429"}]}]},"addons":[{"group_id":67839669,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67839674,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":14000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822640":{"id":47822640,"name":"Lime Juice","category":"Juice Shop","description":"100% Pure Fresh Juices, No Water Added","cloudinaryImageId":"udoijcwgskygmkhlmtvi","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685262","name":"Potion","variations":[{"name":"300ml","price":55,"default":1,"id":"71452755","inStock":1,"isVeg":1,"variant_group_id":"21685262","order":100},{"name":"1Ltr","price":155,"default":0,"id":"71452756","inStock":1,"isVeg":1,"variant_group_id":"21685262","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685262","variation_id":"71452755"}],"price":5500,"addon_combinations":[]},{"variations":[{"group_id":"21685262","variation_id":"71452756"}],"price":15500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":5500,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822642":{"id":47822642,"name":"Mutton Brain Dry Fry","category":"Empire Special Mutton (Dry)","description":"","cloudinaryImageId":"yjktl5fctf4g4solnqcy","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810908","name":"Portion","variations":[{"name":"Full","price":680,"default":0,"id":"18814085","inStock":1,"isVeg":0,"variant_group_id":"5810908","order":0},{"name":"Half","price":340,"default":0,"id":"18814084","inStock":1,"isVeg":0,"variant_group_id":"5810908","order":0},{"name":"Qtr","price":170,"default":1,"id":"18814083","inStock":1,"isVeg":0,"variant_group_id":"5810908","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810908","variation_id":"18814085"}],"price":68000,"addon_combinations":[{"group_id":"67839876","addon_id":"54156425"},{"group_id":"67839876","addon_id":"54156426"},{"group_id":"67839876","addon_id":"54156427"},{"group_id":"67839876","addon_id":"54156428"},{"group_id":"67839876","addon_id":"54156429"}]},{"variations":[{"group_id":"5810908","variation_id":"18814084"}],"price":34000,"addon_combinations":[{"group_id":"67839876","addon_id":"54156425"},{"group_id":"67839876","addon_id":"54156426"},{"group_id":"67839876","addon_id":"54156427"},{"group_id":"67839876","addon_id":"54156428"},{"group_id":"67839876","addon_id":"54156429"}]},{"variations":[{"group_id":"5810908","variation_id":"18814083"}],"price":17000,"addon_combinations":[{"group_id":"67839876","addon_id":"54156425"},{"group_id":"67839876","addon_id":"54156426"},{"group_id":"67839876","addon_id":"54156427"},{"group_id":"67839876","addon_id":"54156428"},{"group_id":"67839876","addon_id":"54156429"}]}]},"addons":[{"group_id":67839876,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":17000,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822649":{"id":47822649,"name":"Boiled Egg (2 Nos)","category":"Egg Item","description":"","cloudinaryImageId":"ruywk7pf1yvmzeb9jnv3","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":4000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67840216,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822651":{"id":47822651,"name":"Mix Fried Rice Non Veg","category":"Fried Rice & Noodles","description":"","cloudinaryImageId":"nhyk8elhcalzcdybca75","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":23000,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67840241,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840275,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822658":{"id":47822658,"name":"Aloo Jeera","category":"North Indian Veg (dry)","description":"","cloudinaryImageId":"rpjyleakcpl5rs1e8zne","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810924","name":"Portion","variations":[{"name":"Half","price":169,"default":0,"id":"18814126","inStock":1,"isVeg":1,"variant_group_id":"5810924","order":0},{"name":"Qtr","price":99,"default":1,"id":"18814125","inStock":1,"isVeg":1,"variant_group_id":"5810924","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810924","variation_id":"18814126"}],"price":16900,"addon_combinations":[{"group_id":"67840706","addon_id":"54156416"},{"group_id":"67840706","addon_id":"54156417"},{"group_id":"67840706","addon_id":"54156418"},{"group_id":"67840727","addon_id":"54156419"},{"group_id":"67840727","addon_id":"54156420"},{"group_id":"67840727","addon_id":"54156421"},{"group_id":"67840727","addon_id":"54156422"},{"group_id":"67840727","addon_id":"54156423"},{"group_id":"67840727","addon_id":"54156424"},{"group_id":"67840719","addon_id":"54156436"},{"group_id":"67840719","addon_id":"54156437"},{"group_id":"67840719","addon_id":"54156438"},{"group_id":"67840771","addon_id":"54156457"},{"group_id":"67840771","addon_id":"54156458"},{"group_id":"67840771","addon_id":"54156459"},{"group_id":"67840771","addon_id":"54156460"},{"group_id":"67840771","addon_id":"54156461"},{"group_id":"67840771","addon_id":"54156462"},{"group_id":"67840714","addon_id":"54156450"},{"group_id":"67840714","addon_id":"54156451"},{"group_id":"67840714","addon_id":"54156452"},{"group_id":"67840704","addon_id":"17505976"},{"group_id":"67840704","addon_id":"54156510"},{"group_id":"67840799","addon_id":"54156425"},{"group_id":"67840799","addon_id":"54156426"},{"group_id":"67840799","addon_id":"54156427"},{"group_id":"67840799","addon_id":"54156428"},{"group_id":"67840799","addon_id":"54156429"}]},{"variations":[{"group_id":"5810924","variation_id":"18814125"}],"price":9900,"addon_combinations":[{"group_id":"67840706","addon_id":"54156416"},{"group_id":"67840706","addon_id":"54156417"},{"group_id":"67840706","addon_id":"54156418"},{"group_id":"67840727","addon_id":"54156419"},{"group_id":"67840727","addon_id":"54156420"},{"group_id":"67840727","addon_id":"54156421"},{"group_id":"67840727","addon_id":"54156422"},{"group_id":"67840727","addon_id":"54156423"},{"group_id":"67840727","addon_id":"54156424"},{"group_id":"67840719","addon_id":"54156436"},{"group_id":"67840719","addon_id":"54156437"},{"group_id":"67840719","addon_id":"54156438"},{"group_id":"67840771","addon_id":"54156457"},{"group_id":"67840771","addon_id":"54156458"},{"group_id":"67840771","addon_id":"54156459"},{"group_id":"67840771","addon_id":"54156460"},{"group_id":"67840771","addon_id":"54156461"},{"group_id":"67840771","addon_id":"54156462"},{"group_id":"67840714","addon_id":"54156450"},{"group_id":"67840714","addon_id":"54156451"},{"group_id":"67840714","addon_id":"54156452"},{"group_id":"67840704","addon_id":"17505976"},{"group_id":"67840704","addon_id":"54156510"},{"group_id":"67840799","addon_id":"54156425"},{"group_id":"67840799","addon_id":"54156426"},{"group_id":"67840799","addon_id":"54156427"},{"group_id":"67840799","addon_id":"54156428"},{"group_id":"67840799","addon_id":"54156429"}]}]},"addons":[{"group_id":67840706,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67840727,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840719,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67840771,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67840714,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67840704,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67840799,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822660":{"id":47822660,"name":"Tandoori Chicken","category":"Tandoori(dry)","description":"","cloudinaryImageId":"gb5pcoodwyyssr9fjgjl","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810925","name":"Portion ","variations":[{"name":"Full","price":422,"default":0,"id":"18814130","inStock":1,"isVeg":0,"variant_group_id":"5810925","order":0},{"name":"Half","price":240,"default":0,"id":"18814129","inStock":1,"isVeg":0,"variant_group_id":"5810925","order":0},{"name":"Qtr","price":135,"default":1,"id":"18814128","inStock":1,"isVeg":0,"variant_group_id":"5810925","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810925","variation_id":"18814130"}],"price":42200,"addon_combinations":[{"group_id":"67840877","addon_id":"54156436"},{"group_id":"67840877","addon_id":"54156437"},{"group_id":"67840877","addon_id":"54156438"},{"group_id":"67840857","addon_id":"54156450"},{"group_id":"67840857","addon_id":"54156451"},{"group_id":"67840857","addon_id":"54156452"},{"group_id":"67840890","addon_id":"54156425"},{"group_id":"67840890","addon_id":"54156426"},{"group_id":"67840890","addon_id":"54156427"},{"group_id":"67840890","addon_id":"54156428"},{"group_id":"67840890","addon_id":"54156429"},{"group_id":"67866563","addon_id":"54168863"}]},{"variations":[{"group_id":"5810925","variation_id":"18814129"}],"price":24000,"addon_combinations":[{"group_id":"67840877","addon_id":"54156436"},{"group_id":"67840877","addon_id":"54156437"},{"group_id":"67840877","addon_id":"54156438"},{"group_id":"67840857","addon_id":"54156450"},{"group_id":"67840857","addon_id":"54156451"},{"group_id":"67840857","addon_id":"54156452"},{"group_id":"67840890","addon_id":"54156425"},{"group_id":"67840890","addon_id":"54156426"},{"group_id":"67840890","addon_id":"54156427"},{"group_id":"67840890","addon_id":"54156428"},{"group_id":"67840890","addon_id":"54156429"},{"group_id":"67866563","addon_id":"54168863"}]},{"variations":[{"group_id":"5810925","variation_id":"18814128"}],"price":13500,"addon_combinations":[{"group_id":"67840877","addon_id":"54156436"},{"group_id":"67840877","addon_id":"54156437"},{"group_id":"67840877","addon_id":"54156438"},{"group_id":"67840857","addon_id":"54156450"},{"group_id":"67840857","addon_id":"54156451"},{"group_id":"67840857","addon_id":"54156452"},{"group_id":"67840890","addon_id":"54156425"},{"group_id":"67840890","addon_id":"54156426"},{"group_id":"67840890","addon_id":"54156427"},{"group_id":"67840890","addon_id":"54156428"},{"group_id":"67840890","addon_id":"54156429"},{"group_id":"67866563","addon_id":"54168863"}]}]},"addons":[{"group_id":67840877,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67840857,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67840890,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93},{"group_id":67866563,"group_name":"Bread","choices":[{"id":54168863,"name":"Kuboos","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":92}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13500,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822661":{"id":47822661,"name":"Dal Tadka","category":"Veg Gravy","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"5810926","name":"Portion ","variations":[{"name":"Full","price":232,"default":0,"id":"18814133","inStock":1,"isVeg":1,"variant_group_id":"5810926","order":0},{"name":"Half","price":125,"default":0,"id":"18814132","inStock":1,"isVeg":1,"variant_group_id":"5810926","order":0},{"name":"Qtr","price":75,"default":1,"id":"18814131","inStock":1,"isVeg":1,"variant_group_id":"5810926","order":0}]}],"pricing_models":[{"variations":[{"group_id":"5810926","variation_id":"18814133"}],"price":23200,"addon_combinations":[{"group_id":"68923954","addon_id":"54935012"},{"group_id":"67840942","addon_id":"54156416"},{"group_id":"67840942","addon_id":"54156417"},{"group_id":"67840942","addon_id":"54156418"},{"group_id":"67840950","addon_id":"54156419"},{"group_id":"67840950","addon_id":"54156420"},{"group_id":"67840950","addon_id":"54156421"},{"group_id":"67840950","addon_id":"54156422"},{"group_id":"67840950","addon_id":"54156423"},{"group_id":"67840950","addon_id":"54156424"},{"group_id":"67840979","addon_id":"54156425"},{"group_id":"67840979","addon_id":"54156426"},{"group_id":"67840979","addon_id":"54156427"},{"group_id":"67840979","addon_id":"54156428"},{"group_id":"67840979","addon_id":"54156429"}]},{"variations":[{"group_id":"5810926","variation_id":"18814132"}],"price":12500,"addon_combinations":[{"group_id":"68923954","addon_id":"54935012"},{"group_id":"67840942","addon_id":"54156416"},{"group_id":"67840942","addon_id":"54156417"},{"group_id":"67840942","addon_id":"54156418"},{"group_id":"67840950","addon_id":"54156419"},{"group_id":"67840950","addon_id":"54156420"},{"group_id":"67840950","addon_id":"54156421"},{"group_id":"67840950","addon_id":"54156422"},{"group_id":"67840950","addon_id":"54156423"},{"group_id":"67840950","addon_id":"54156424"},{"group_id":"67840979","addon_id":"54156425"},{"group_id":"67840979","addon_id":"54156426"},{"group_id":"67840979","addon_id":"54156427"},{"group_id":"67840979","addon_id":"54156428"},{"group_id":"67840979","addon_id":"54156429"}]},{"variations":[{"group_id":"5810926","variation_id":"18814131"}],"price":7500,"addon_combinations":[{"group_id":"68923954","addon_id":"54935012"},{"group_id":"67840942","addon_id":"54156416"},{"group_id":"67840942","addon_id":"54156417"},{"group_id":"67840942","addon_id":"54156418"},{"group_id":"67840950","addon_id":"54156419"},{"group_id":"67840950","addon_id":"54156420"},{"group_id":"67840950","addon_id":"54156421"},{"group_id":"67840950","addon_id":"54156422"},{"group_id":"67840950","addon_id":"54156423"},{"group_id":"67840950","addon_id":"54156424"},{"group_id":"67840979","addon_id":"54156425"},{"group_id":"67840979","addon_id":"54156426"},{"group_id":"67840979","addon_id":"54156427"},{"group_id":"67840979","addon_id":"54156428"},{"group_id":"67840979","addon_id":"54156429"}]}]},"addons":[{"group_id":68923954,"group_name":"Rice","choices":[{"id":54935012,"name":"Ghee Rice","price":9900,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67840942,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67840950,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67840979,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7500,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822672":{"id":47822672,"name":"Lassi Sweet","category":"Juice Shop","description":"","cloudinaryImageId":"tnh0qj18zqdtpx5neqvc","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":7700,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"47822681":{"id":47822681,"name":"Tawa Shawarma","category":"Shawarma","description":"","cloudinaryImageId":"lknei9tpqykfvudty8ax","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":15900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":72802152,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"54867885":{"id":54867885,"name":"Ghee Rice With Dal Fry","category":"Empire Special Combo Meals","description":"Ghee Rice, Dal Fry.","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":14900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67843725,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67843732,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67843778,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67843709,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843800,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"65669680":{"id":65669680,"name":"Chicken Bucket Biriyani","category":"Bucket Biriyani","description":"","cloudinaryImageId":"o3md7bihfchbxxrcfbgu","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":119900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924013,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67842130,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842149,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67842126,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67842122,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67842154,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67842158,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 7","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"65669682":{"id":65669682,"name":"Bucket Biriyani With Grilled Chicken","category":"Bucket Biriyani","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":148900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924023,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67842237,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842257,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67842229,"group_name":"Dips","choices":[{"id":54156438,"name":"Mint Chutney 50Ml","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156437,"name":"Grill Chutney 50Ml","price":2000,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156436,"name":"Mayonnaise 50Ml","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67842216,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67842187,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67842299,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67842302,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93},{"group_id":67891844,"group_name":"Bread","choices":[{"id":54168863,"name":"Kuboos","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":92}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 7","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"65669684":{"id":65669684,"name":"Bucket Biriyani With Chicken Kabab","category":"Bucket Biriyani Combos","description":"","cloudinaryImageId":"ivjkz6qcirckeynmccj1","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":149900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924037,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67842345,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842369,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67842342,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67842338,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67842390,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67842393,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 7","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"65669685":{"id":65669685,"name":"Bucket Biriyani With Fiery Wings","category":"Bucket Biriyani Combos","description":"","cloudinaryImageId":"qvnrbktvk7whi0qzcoau","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":159900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924045,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67842447,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842459,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67842443,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67842440,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67842472,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67842475,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 7","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"65669686":{"id":65669686,"name":"Bucket Biriyani With Kalmi Kabab","category":"Bucket Biriyani Combos","description":"","cloudinaryImageId":"kmz6vppi99urueddhba4","recommended":1,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":159900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924051,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67842505,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842545,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67842499,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67842495,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67842562,"group_name":"Dessert","choices":[{"id":54156512,"name":"Tender Coconut Pudding","price":7100,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":94},{"group_id":67842565,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 7","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"79335727":{"id":79335727,"name":"Tawa Paneer","category":"North Indian Veg (gravy)","description":"","cloudinaryImageId":"nlfkcvfulkz0iionu9om","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":19900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67842693,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67842717,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842746,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"79335728":{"id":79335728,"name":"Tawa Veg","category":"North Indian Veg (gravy)","description":"","cloudinaryImageId":"k1bsgnny2kert0wxj8ab","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":19900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67842770,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67842776,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842802,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"83973556":{"id":83973556,"name":"Tender Coconut Pudding","category":"Desserts","description":"A refreshing delight with delicate flavors made from tender coconut, all set to melt in your mouth.(100gms)","cloudinaryImageId":"kfjnsxwv02iiquqaykvc","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":7100,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67842866,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"83982171":{"id":83982171,"name":"Pepsi (750ml)","category":"Soft Drink","description":"","cloudinaryImageId":"jabuzj9cy8kwmapilkwd","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":3810,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"85624502":{"id":85624502,"name":"2 Coin Parotta, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab","category":"Empire Special Combo Meals","description":"Coin Parotta (2 Nos), Hyderabadi Chicken Boneless (5 Pcs), Popcorn Kebab (5 Pcs)","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":18900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67842919,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67842930,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67842970,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67842917,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843025,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"85624505":{"id":85624505,"name":"2 Naan, Paneer Butter Masala, Gobi Manchurian","category":"Empire Special Combo Meals","description":"2Naan,Paneer Butter Masala (5 pcs),Gobi Manchurian","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":16900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67843065,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67843070,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67843093,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67843063,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843115,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"85624506":{"id":85624506,"name":"Biriyani Rice, Raitha & Pepper Chicken Boneless","category":"Empire Special Combo Meals","description":"Biriyani Rice, Raitha, Pepper Chicken Bonless (5 Pcs)","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":16900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924069,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67843182,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67843204,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67843233,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67843187,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67843167,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843253,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"85624507":{"id":85624507,"name":"Chicken Biriyani (Regular), Raitha &Popcorn Kebab","category":"Empire Special Combo Meals","description":"Chicken Biriyani (Regular), Raitha, Popcorn Kebab (5 Pcs)","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":19900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":68924078,"group_name":"Egg","choices":[{"id":54935061,"name":"Boiled Egg","price":2000,"inStock":1,"isVeg":0,"order":100,"default":0}],"maxAddons":1,"maxFreeAddons":-1,"minAddons":0,"order":100},{"group_id":67843313,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67843333,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67843354,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67843325,"group_name":"Salad","choices":[{"id":54156452,"name":"Green Salad","price":9500,"inStock":0,"isVeg":1,"order":100,"default":0},{"id":54156451,"name":"Mini Salad","price":3000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156450,"name":"Pappad","price":2000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":96},{"group_id":67843309,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843383,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"85624508":{"id":85624508,"name":"Ghee Rice Butter Chicken Combo","category":"Empire Special Combo Meals","description":"Ghee Rice, Butter Chicken Boneless (5 Pcs).","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":14900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67843426,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67843450,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67843491,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67843423,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843520,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"85624509":{"id":85624509,"name":"Ghee Rice, Butter Chicken Combo & Chicken Manchurian Dry","category":"Empire Special Combo Meals","description":"Ghee Rice, Butter Chicken Boneless (5 Pcs), Manchurian Dry (5 Pcs)","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":18900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67843583,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67843595,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67843631,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67843557,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843649,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"attributes":{"portionSize":"","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":true,"itemNudgeType":"","isGuiltFree":false},"85624514":{"id":85624514,"name":"Ghee Rice with Paneer Butter Masala & Gobi Manchurian","category":"Empire Special Combo Meals","description":"Ghee Rice, Paneer Butter Masala (5 pcs), Gobi Manchurian","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":16900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67891925,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67891926,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67891927,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67891924,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67891928,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"85624515":{"id":85624515,"name":"Veg Fried Rice & Gobi Manchurian","category":"Empire Special Combo Meals","description":"Veg Fried Rice, Gobi Manchurian.","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":14900,"variants_new":{"exclude_list":[],"variant_groups":[]},"addons":[{"group_id":67843844,"group_name":"Parotta","choices":[{"id":54156417,"name":"Empire Spl Parotta","price":4700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156416,"name":"Coin Parotta","price":2700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156418,"name":"Kerala Parotta","price":3600,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":3,"maxFreeAddons":-1,"minAddons":0,"order":99},{"group_id":67843851,"group_name":"Starters","choices":[{"id":54156423,"name":"Paneer Chilly Dry","price":10000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156419,"name":"Empire spl Chicken Kebab (qtr)","price":10500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156422,"name":"Pepper Mutton Dry (Qtr)","price":17500,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156421,"name":"Murg Tikka (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156420,"name":"Chilly Chicken Boneless (qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156424,"name":"Gobi Manchurian (Qtr)","price":9500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":98},{"group_id":67843869,"group_name":"Gravy","choices":[{"id":54156457,"name":"Butter Chicken Boneless (Qtr)","price":15000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156460,"name":"Mutton Varuval (Qtr)","price":17000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156459,"name":"Kadai Chicken (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156462,"name":"Kadai Veg","price":13500,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156458,"name":"Pepper Chicken Masala (Qtr)","price":14000,"inStock":1,"isVeg":0,"order":100,"default":0},{"id":54156461,"name":"Paneer Butter Masala (Qtr)","price":11000,"inStock":1,"isVeg":1,"order":100,"default":0}],"maxAddons":6,"maxFreeAddons":-1,"minAddons":0,"order":97},{"group_id":67843841,"group_name":"Curd","choices":[{"id":17505976,"name":"Curd","price":4000,"inStock":1,"isVeg":1,"order":3,"default":0},{"id":54156510,"name":"Raitha","price":3500,"inStock":1,"isVeg":1,"order":0,"default":0}],"maxAddons":2,"maxFreeAddons":-1,"minAddons":0,"order":95},{"group_id":67843922,"group_name":"Beverage / Fresh Juice","choices":[{"id":54156429,"name":"Watermelon Juice","price":7700,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156428,"name":"Pulpy Grape Juice","price":9000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156427,"name":"Lime Soda","price":6000,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156426,"name":"Pepsi 750 ML","price":3800,"inStock":1,"isVeg":1,"order":100,"default":0},{"id":54156425,"name":"Pepsi 250 ML","price":1900,"inStock":0,"isVeg":1,"order":100,"default":0}],"maxAddons":5,"maxFreeAddons":-1,"minAddons":0,"order":93}],"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519251":{"id":86519251,"name":"Pulpy Grape juice","category":"Juice Shop","description":"100% Pure Fresh Juices, No Water Added","cloudinaryImageId":"olvadzot3td2gpamufru","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685339","name":"Potion","variations":[{"name":"300ml","price":99,"default":1,"id":"71452911","inStock":1,"isVeg":1,"variant_group_id":"21685339","order":100},{"name":"1Ltr","price":267,"default":0,"id":"71452912","inStock":1,"isVeg":1,"variant_group_id":"21685339","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685339","variation_id":"71452911"}],"price":9900,"addon_combinations":[]},{"variations":[{"group_id":"21685339","variation_id":"71452912"}],"price":26700,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519265":{"id":86519265,"name":"Fig & Honey","category":"Juice Shop","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21698388","name":"Scoops","variations":[{"name":"Single","price":70,"default":1,"id":"71481573","inStock":1,"isVeg":1,"variant_group_id":"21698388","order":99},{"name":"Double","price":135,"default":0,"id":"71481574","inStock":1,"isVeg":1,"variant_group_id":"21698388","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21698388","variation_id":"71481573"}],"price":7000,"addon_combinations":[]},{"variations":[{"group_id":"21698388","variation_id":"71481574"}],"price":13500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519267":{"id":86519267,"name":"Butterscotch Ice Cream","category":"Juice Shop","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21698389","name":"Scoops","variations":[{"name":"Single","price":70,"default":1,"id":"71481575","inStock":1,"isVeg":1,"variant_group_id":"21698389","order":99},{"name":"Double","price":135,"default":0,"id":"71481576","inStock":1,"isVeg":1,"variant_group_id":"21698389","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21698389","variation_id":"71481575"}],"price":7000,"addon_combinations":[]},{"variations":[{"group_id":"21698389","variation_id":"71481576"}],"price":13500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519270":{"id":86519270,"name":"Black Currant Ice Cream","category":"Juice Shop","description":"","cloudinaryImageId":"","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21698390","name":"Scoops","variations":[{"name":"Single","price":70,"default":1,"id":"71481577","inStock":1,"isVeg":1,"variant_group_id":"21698390","order":99},{"name":"Double","price":135,"default":0,"id":"71481578","inStock":1,"isVeg":1,"variant_group_id":"21698390","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21698390","variation_id":"71481577"}],"price":7000,"addon_combinations":[]},{"variations":[{"group_id":"21698390","variation_id":"71481578"}],"price":13500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":7000,"attributes":{"portionSize":"","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519287":{"id":86519287,"name":"Fig (Anjeer)Thick Shakes","category":"Juice Shop","description":"Boasting a delightfully creamy and luxurious texture, our Anjeer Thick shake is a treat for all your senses. You'll love the distinctive flavour of figs, ice cold milk, chocolate sauce, and velvety ice cream.","cloudinaryImageId":"qlwu3dhy80nvz5ny4nhr","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685340","name":"Potion","variations":[{"name":"300ml","price":99,"default":1,"id":"71452913","inStock":1,"isVeg":1,"variant_group_id":"21685340","order":100},{"name":"1Ltr","price":290,"default":0,"id":"71452914","inStock":1,"isVeg":1,"variant_group_id":"21685340","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685340","variation_id":"71452913"}],"price":9900,"addon_combinations":[]},{"variations":[{"group_id":"21685340","variation_id":"71452914"}],"price":29000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519297":{"id":86519297,"name":"Chocolate Thick Shake","category":"Juice Shop","description":"Made with rich chocolate flavour ice cream and syrup, and blended with chilled milk and crushed ice cubes, this thick shake is a choco-lover’s dream.","cloudinaryImageId":"pf4dqma3zk99y0qbmkcf","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685342","name":"Potion","variations":[{"name":"300ml","price":88,"default":1,"id":"71452917","inStock":1,"isVeg":1,"variant_group_id":"21685342","order":100},{"name":"1Ltr","price":255,"default":0,"id":"71452918","inStock":1,"isVeg":1,"variant_group_id":"21685342","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685342","variation_id":"71452917"}],"price":8800,"addon_combinations":[]},{"variations":[{"group_id":"21685342","variation_id":"71452918"}],"price":25500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":8800,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519299":{"id":86519299,"name":"Empire Special Falooda","category":"Juice Shop","description":"This Signature Falooda is made with fresh cut pieces of Kiwi and Bananas mixed together with our special homemade rose milk mixture and a combination of jelly, poppy seeds, vermicelli, cereals and dry fruit mixture that is all topped off with rainbow ice cream and red cherry.","cloudinaryImageId":"ogahlaofpbpzwrcot0n6","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":19800,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519302":{"id":86519302,"name":"Tender Coconut Falooda","category":"Juice Shop","description":"For those with a sweet tooth, the Tender Falooda Ice Cream is a delicious treat. This traditional dessert is made with tender coconut flavors combined with layers of jelly, poppy seeds, vermicelli, dry fruit mixture, and topped with red cherry.","cloudinaryImageId":"ccfzjuihtwly6azwyvyo","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":18700,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519340":{"id":86519340,"name":"Blueberry Mojito","category":"Juice Shop","description":"A mojito with a wild berry twist, this drink is perfect for sharing to celebrate any occasion.","cloudinaryImageId":"r7qz7q0jmrwggrp0wquq","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685344","name":"Potion","variations":[{"name":"300ml","price":104.5,"default":1,"id":"71452921","inStock":1,"isVeg":1,"variant_group_id":"21685344","order":100},{"name":"1Ltr","price":305.5,"default":0,"id":"71452922","inStock":1,"isVeg":1,"variant_group_id":"21685344","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685344","variation_id":"71452921"}],"price":10450,"addon_combinations":[]},{"variations":[{"group_id":"21685344","variation_id":"71452922"}],"price":30550,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":10450,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519344":{"id":86519344,"name":"Green Apple Mojito","category":"Juice Shop","description":"Our Green Apple Mojito is a comforting drink made from muddling fresh lime and fresh mint leaves combined with green apple syrup and chilled soda pour over crushed ice cubes.","cloudinaryImageId":"ompoano0xaald9fikep5","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685345","name":"Potion","variations":[{"name":"300ml","price":99,"default":1,"id":"71452923","inStock":1,"isVeg":1,"variant_group_id":"21685345","order":100},{"name":"1Ltr","price":290,"default":0,"id":"71452924","inStock":1,"isVeg":1,"variant_group_id":"21685345","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685345","variation_id":"71452923"}],"price":9900,"addon_combinations":[]},{"variations":[{"group_id":"21685345","variation_id":"71452924"}],"price":29000,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":9900,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519376":{"id":86519376,"name":"Chocolate Splash","category":"Juice Shop","description":"Delicious, lush and satisfying Chocolate Splash is our specialty thick shake that is blended with rich creamy ice cream, chunks of chocolate cake sponge with cold milk, crushed ice cubes and topped off with chocolate syrup.","cloudinaryImageId":"yy7rt105kynal6krzj8u","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685346","name":"Potion","variations":[{"name":"300ml","price":121,"default":1,"id":"71452925","inStock":1,"isVeg":1,"variant_group_id":"21685346","order":100},{"name":"1Ltr","price":355,"default":0,"id":"71452926","inStock":1,"isVeg":1,"variant_group_id":"21685346","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685346","variation_id":"71452925"}],"price":12100,"addon_combinations":[]},{"variations":[{"group_id":"21685346","variation_id":"71452926"}],"price":35500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":12100,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519382":{"id":86519382,"name":"Kit Kat Thick Shake","category":"Juice Shop","description":"Treat yourself to this rich, thick Kit Kat chocolate shake at Empire Juice Shop. Made with chilled milk and ice cream mixed with crushed Kit Kat and chocolate syrup, you really can't beat this combination!","cloudinaryImageId":"sl00qfxotvsasoajelyg","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685347","name":"Potion","variations":[{"name":"300ml","price":137.5,"default":1,"id":"71452927","inStock":1,"isVeg":1,"variant_group_id":"21685347","order":100},{"name":"1Ltr","price":399.5,"default":0,"id":"71452928","inStock":1,"isVeg":1,"variant_group_id":"21685347","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685347","variation_id":"71452927"}],"price":13750,"addon_combinations":[]},{"variations":[{"group_id":"21685347","variation_id":"71452928"}],"price":39950,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13750,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519390":{"id":86519390,"name":"Oreo Thick Shake","category":"Juice Shop","description":"Oreo lovers know the deal. Made with chunks of Oreo Biscuits and a layer of rich, creamy ice cream that is topped off with chocolate syrup, this treat is loved by all.","cloudinaryImageId":"s7we1y34hpfywovxabhy","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685348","name":"Potion","variations":[{"name":"300ml","price":137.5,"default":1,"id":"71452929","inStock":1,"isVeg":1,"variant_group_id":"21685348","order":100},{"name":"1Ltr","price":398.5,"default":0,"id":"71452930","inStock":1,"isVeg":1,"variant_group_id":"21685348","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685348","variation_id":"71452929"}],"price":13750,"addon_combinations":[]},{"variations":[{"group_id":"21685348","variation_id":"71452930"}],"price":39850,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":13750,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519396":{"id":86519396,"name":"Gudbud","category":"Juice Shop","description":"A refreshing combination scoops of Vanilla, Strawberry and Mango Ice Creams. With every bite you will experience the flavor adventures of fresh fruit salad and dry fruits. Because our Gudbud isn't just a treat, it's an experience.","cloudinaryImageId":"awmh6lks9jjpdtdxcqfj","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":14300,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519416":{"id":86519416,"name":"Mudpot","category":"Juice Shop","description":"Indulge your sweet tooth with this heavenly dessert. It's made of vanilla custard with bits of chocolate cake sponge, chocolate sauce, dry fruits and topped with rich and creamy scoop of vanilla ice cream.","cloudinaryImageId":"irvle0rfgkcsnjrzaykf","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":14300,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519419":{"id":86519419,"name":"Red Velvet Pot","category":"Juice Shop","description":"A melt in mouth Red Velvet Pot made with red velvet cake sponge, a layer of luscious fruit custard topped with scoop of strawberry ice cream.","cloudinaryImageId":"zwkm2liumpaxeo73unz6","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":14300,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"86519441":{"id":86519441,"name":"Fruit Custard","category":"Juice Shop","description":"A delightful change in your regular fruit salad. Made with the freshest seasonal fruits and crowned with layers vanilla and strawberry custard.","cloudinaryImageId":"x2nmqlzuckjqdvqpjjx2","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":10450,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"92429975":{"id":92429975,"name":"Mango punch","category":"Juice Shop","description":"","cloudinaryImageId":"n3fqhimakmqfja67mxsy","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":7500,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"96906011":{"id":96906011,"name":"Avocado Thick Shake","category":"Juice Shop","description":"","cloudinaryImageId":"pxyhxnyqzsqrfrddomo6","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":13500,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"100217612":{"id":100217612,"name":"Matka Kulfi","category":"Juice Shop","description":"","cloudinaryImageId":"knpo2manobuiagemdkib","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":8900,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"101418733":{"id":101418733,"name":"Black Current Kulfi","category":"Juice Shop","description":"","cloudinaryImageId":"u5xlpe6jfhjuknzqjlps","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":7000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"101418735":{"id":101418735,"name":"Dry Fruits Kulfi","category":"Juice Shop","description":"","cloudinaryImageId":"leumcfclqrcwoyregzzy","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":7000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"103547845":{"id":103547845,"name":"Strawberry Thick Shake","category":"Juice Shop","description":"","cloudinaryImageId":"c9cczsfbshesboawhpxa","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685014","name":"Potion","variations":[{"name":"300ml","price":88,"default":1,"id":"71452257","inStock":1,"isVeg":1,"variant_group_id":"21685014","order":100},{"name":"1Ltr","price":255,"default":0,"id":"71452259","inStock":1,"isVeg":1,"variant_group_id":"21685014","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685014","variation_id":"71452257"}],"price":8800,"addon_combinations":[]},{"variations":[{"group_id":"21685014","variation_id":"71452259"}],"price":25500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":8800,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"103547846":{"id":103547846,"name":"Vanilla Thick Shake","category":"Juice Shop","description":"","cloudinaryImageId":"ga66rsafo2nekfbppjam","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":0,"variantsV2":{"variant_groups":[{"group_id":"21685016","name":"Potion","variations":[{"name":"300ml","price":88,"default":1,"id":"71452262","inStock":1,"isVeg":1,"variant_group_id":"21685016","order":100},{"name":"1Ltr","price":255,"default":0,"id":"71452263","inStock":1,"isVeg":1,"variant_group_id":"21685016","order":98}]}],"pricing_models":[{"variations":[{"group_id":"21685016","variation_id":"71452262"}],"price":8800,"addon_combinations":[]},{"variations":[{"group_id":"21685016","variation_id":"71452263"}],"price":25500,"addon_combinations":[]}]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"defaultPrice":8800,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"104035813":{"id":104035813,"name":"Hot Chocolate Fudge","category":"Juice Shop","description":"","cloudinaryImageId":"l6sxj0dmltdp1yaoeaym","recommended":1,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":14500,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"108277408":{"id":108277408,"name":"Calzone Butter Chicken","category":"Juice Shop","description":"Oven Baked folded bun filled with the signature Empire Butter Chicken Gravy.","cloudinaryImageId":"5595f80229ea30209ac233cd5b9f890d","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":9900,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"108277409":{"id":108277409,"name":"Calzone Paneer Tika","category":"Juice Shop","description":"Oven Baked folded bun filled with the paneer tikka masala.","cloudinaryImageId":"8af98a72f38167cd1b1d6e2a6c8a9b03","recommended":0,"inStock":1,"isVeg":1,"enabled":1,"displayOrder":0,"price":9000,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"VEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"108277410":{"id":108277410,"name":"Calzone Pepper Chicken","category":"Juice Shop","description":"Oven Baked folded bun filled with the signature Empire Pepper Chicken masala.","cloudinaryImageId":"813e98a7bcdb215dad5f46bed0d5402f","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":9900,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false},"108277411":{"id":108277411,"name":"Calzone Chilly Chicken","category":"Juice Shop","description":"Oven Baked folded bun filled with the signature Empire Chilly Chicken masala","cloudinaryImageId":"4b6cb39678f69531d8933aa2f2bc8877","recommended":0,"inStock":1,"isVeg":0,"enabled":1,"displayOrder":0,"price":9900,"variants_new":{"exclude_list":[],"variant_groups":[]},"cropChoices":2,"itemScore":0,"itemDiscount":0,"isPopular":0,"restId":"425","showMC":0,"attributes":{"portionSize":"Serves 1","vegClassifier":"NONVEG","accompaniments":""},"isHealthy":false,"isBestSeller":false,"itemNudgeType":"","isGuiltFree":false}},"widgets":[{"name":"Recommended","subTitle":"","type":"recommended","entities":[{"id":47822532,"type":"item","showImg":true,"showRibbon":false},{"id":4300494,"type":"item","showImg":true,"showRibbon":false},{"id":215037,"type":"item","showImg":true,"showRibbon":false},{"id":47822505,"type":"item","showImg":true,"showRibbon":false},{"id":65669680,"type":"item","showImg":true,"showRibbon":false},{"id":65669684,"type":"item","showImg":true,"showRibbon":false},{"id":65669685,"type":"item","showImg":true,"showRibbon":false},{"id":65669686,"type":"item","showImg":true,"showRibbon":false},{"id":215110,"type":"item","showImg":true,"showRibbon":false},{"id":47822601,"type":"item","showImg":true,"showRibbon":false},{"id":47822617,"type":"item","showImg":true,"showRibbon":false},{"id":215167,"type":"item","showImg":true,"showRibbon":false},{"id":215186,"type":"item","showImg":true,"showRibbon":false},{"id":215187,"type":"item","showImg":true,"showRibbon":false},{"id":215175,"type":"item","showImg":true,"showRibbon":false},{"id":47822628,"type":"item","showImg":true,"showRibbon":false},{"id":215089,"type":"item","showImg":true,"showRibbon":false},{"id":215084,"type":"item","showImg":true,"showRibbon":false},{"id":104035813,"type":"item","showImg":true,"showRibbon":false},{"id":28309444,"type":"item","showImg":true,"showRibbon":false},{"id":96906011,"type":"item","showImg":true,"showRibbon":false},{"id":100217612,"type":"item","showImg":true,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Empire Special Chicken (Dry)","subTitle":"","type":"category","entities":[{"id":47822614,"type":"item","showImg":false,"showRibbon":false},{"id":47822532,"type":"item","showImg":false,"showRibbon":false},{"id":215032,"type":"item","showImg":false,"showRibbon":false},{"id":47822578,"type":"item","showImg":false,"showRibbon":false},{"id":4300494,"type":"item","showImg":false,"showRibbon":false},{"id":215037,"type":"item","showImg":false,"showRibbon":false},{"id":47822492,"type":"item","showImg":false,"showRibbon":false},{"id":47822505,"type":"item","showImg":false,"showRibbon":false},{"id":47822547,"type":"item","showImg":false,"showRibbon":false},{"id":47822573,"type":"item","showImg":false,"showRibbon":false},{"id":47822609,"type":"item","showImg":false,"showRibbon":false},{"id":47822635,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Bucket Biriyani","subTitle":"","type":"category","entities":[{"id":65669680,"type":"item","showImg":false,"showRibbon":false},{"id":65669682,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Desserts","subTitle":"","type":"category","entities":[{"id":83973556,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Bucket Biriyani Combos","subTitle":"","type":"category","entities":[{"id":65669684,"type":"item","showImg":false,"showRibbon":false},{"id":65669685,"type":"item","showImg":false,"showRibbon":false},{"id":65669686,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Empire Special Combo Meals","subTitle":"","type":"category","entities":[{"id":54867885,"type":"item","showImg":false,"showRibbon":false},{"id":85624502,"type":"item","showImg":false,"showRibbon":false},{"id":85624505,"type":"item","showImg":false,"showRibbon":false},{"id":85624506,"type":"item","showImg":false,"showRibbon":false},{"id":85624507,"type":"item","showImg":false,"showRibbon":false},{"id":85624508,"type":"item","showImg":false,"showRibbon":false},{"id":85624509,"type":"item","showImg":false,"showRibbon":false},{"id":85624514,"type":"item","showImg":false,"showRibbon":false},{"id":85624515,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Empire Special Chicken (Gravy)","subTitle":"","type":"category","entities":[{"id":47822543,"type":"item","showImg":false,"showRibbon":false},{"id":215100,"type":"item","showImg":false,"showRibbon":false},{"id":215108,"type":"item","showImg":false,"showRibbon":false},{"id":215110,"type":"item","showImg":false,"showRibbon":false},{"id":215111,"type":"item","showImg":false,"showRibbon":false},{"id":47822498,"type":"item","showImg":false,"showRibbon":false},{"id":47822535,"type":"item","showImg":false,"showRibbon":false},{"id":47822601,"type":"item","showImg":false,"showRibbon":false},{"id":47822617,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Biriyani And Rice","subTitle":"","type":"category","entities":[{"id":215169,"type":"item","showImg":false,"showRibbon":false},{"id":47822517,"type":"item","showImg":false,"showRibbon":false},{"id":47822514,"type":"item","showImg":false,"showRibbon":false},{"id":215160,"type":"item","showImg":false,"showRibbon":false},{"id":215166,"type":"item","showImg":false,"showRibbon":false},{"id":215167,"type":"item","showImg":false,"showRibbon":false},{"id":215168,"type":"item","showImg":false,"showRibbon":false},{"id":47822519,"type":"item","showImg":false,"showRibbon":false},{"id":47822520,"type":"item","showImg":false,"showRibbon":false},{"id":47822522,"type":"item","showImg":false,"showRibbon":false},{"id":47822576,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Empire Special Mutton (Dry)","subTitle":"","type":"category","entities":[{"id":215045,"type":"item","showImg":false,"showRibbon":false},{"id":47822574,"type":"item","showImg":false,"showRibbon":false},{"id":47822610,"type":"item","showImg":false,"showRibbon":false},{"id":47822642,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Empire Special Mutton (Gravy)","subTitle":"","type":"category","entities":[{"id":47822493,"type":"item","showImg":false,"showRibbon":false},{"id":215135,"type":"item","showImg":false,"showRibbon":false},{"id":215129,"type":"item","showImg":false,"showRibbon":false},{"id":215131,"type":"item","showImg":false,"showRibbon":false},{"id":47822482,"type":"item","showImg":false,"showRibbon":false},{"id":47822549,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Parottas","subTitle":"","type":"category","entities":[{"id":215180,"type":"item","showImg":false,"showRibbon":false},{"id":47822584,"type":"item","showImg":false,"showRibbon":false},{"id":215184,"type":"item","showImg":false,"showRibbon":false},{"id":215185,"type":"item","showImg":false,"showRibbon":false},{"id":215186,"type":"item","showImg":false,"showRibbon":false},{"id":215187,"type":"item","showImg":false,"showRibbon":false},{"id":215188,"type":"item","showImg":false,"showRibbon":false},{"id":215192,"type":"item","showImg":false,"showRibbon":false},{"id":47822589,"type":"item","showImg":false,"showRibbon":false},{"id":47822629,"type":"item","showImg":false,"showRibbon":false},{"id":47822630,"type":"item","showImg":false,"showRibbon":false},{"id":47822632,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Thali","subTitle":"","type":"category","entities":[{"id":215218,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Rotis","subTitle":"","type":"category","entities":[{"id":215171,"type":"item","showImg":false,"showRibbon":false},{"id":215173,"type":"item","showImg":false,"showRibbon":false},{"id":215175,"type":"item","showImg":false,"showRibbon":false},{"id":215176,"type":"item","showImg":false,"showRibbon":false},{"id":215177,"type":"item","showImg":false,"showRibbon":false},{"id":1395450,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"North Indian Veg (dry)","subTitle":"","type":"category","entities":[{"id":47822658,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"North Indian Veg (gravy)","subTitle":"","type":"category","entities":[{"id":79335727,"type":"item","showImg":false,"showRibbon":false},{"id":79335728,"type":"item","showImg":false,"showRibbon":false},{"id":215075,"type":"item","showImg":false,"showRibbon":false},{"id":47822560,"type":"item","showImg":false,"showRibbon":false},{"id":47822622,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Egg Item","subTitle":"","type":"category","entities":[{"id":47822495,"type":"item","showImg":false,"showRibbon":false},{"id":47822484,"type":"item","showImg":false,"showRibbon":false},{"id":47822497,"type":"item","showImg":false,"showRibbon":false},{"id":215092,"type":"item","showImg":false,"showRibbon":false},{"id":215091,"type":"item","showImg":false,"showRibbon":false},{"id":47822649,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Tandoori(dry)","subTitle":"","type":"category","entities":[{"id":47822501,"type":"item","showImg":false,"showRibbon":false},{"id":47822570,"type":"item","showImg":false,"showRibbon":false},{"id":47822628,"type":"item","showImg":false,"showRibbon":false},{"id":47822660,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Empire Special Tawa Dishes","subTitle":"","type":"category","entities":[{"id":47822506,"type":"item","showImg":false,"showRibbon":false},{"id":47822533,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Fried Rice & Noodles","subTitle":"","type":"category","entities":[{"id":215233,"type":"item","showImg":false,"showRibbon":false},{"id":215228,"type":"item","showImg":false,"showRibbon":false},{"id":215224,"type":"item","showImg":false,"showRibbon":false},{"id":215230,"type":"item","showImg":false,"showRibbon":false},{"id":215223,"type":"item","showImg":false,"showRibbon":false},{"id":215225,"type":"item","showImg":false,"showRibbon":false},{"id":215226,"type":"item","showImg":false,"showRibbon":false},{"id":215229,"type":"item","showImg":false,"showRibbon":false},{"id":215231,"type":"item","showImg":false,"showRibbon":false},{"id":47822651,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Shawarma","subTitle":"","type":"category","entities":[{"id":47822681,"type":"item","showImg":false,"showRibbon":false},{"id":1794387,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"North Indian Non Veg (gravy)","subTitle":"","type":"category","entities":[{"id":215113,"type":"item","showImg":false,"showRibbon":false},{"id":215123,"type":"item","showImg":false,"showRibbon":false},{"id":47822621,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Salads","subTitle":"","type":"category","entities":[{"id":215067,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Soup","subTitle":"","type":"category","entities":[{"id":215004,"type":"item","showImg":false,"showRibbon":false},{"id":24685892,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Veg Dry","subTitle":"","type":"category","entities":[{"id":47822592,"type":"item","showImg":false,"showRibbon":false},{"id":215007,"type":"item","showImg":false,"showRibbon":false},{"id":24685899,"type":"item","showImg":false,"showRibbon":false},{"id":47822582,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Veg Gravy","subTitle":"","type":"category","entities":[{"id":47822563,"type":"item","showImg":false,"showRibbon":false},{"id":47822661,"type":"item","showImg":false,"showRibbon":false},{"id":215089,"type":"item","showImg":false,"showRibbon":false},{"id":215068,"type":"item","showImg":false,"showRibbon":false},{"id":215084,"type":"item","showImg":false,"showRibbon":false},{"id":47822555,"type":"item","showImg":false,"showRibbon":false},{"id":47822599,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false},{"name":"Juice Shop","subTitle":"","type":"category","widgets":[{"name":"Falooda","type":"subcategory","entities":[{"id":86519299,"type":"item","showImg":false,"showRibbon":false},{"id":86519302,"type":"item","showImg":false,"showRibbon":false},{"id":28308865,"type":"item","showImg":false,"showRibbon":false},{"id":28309643,"type":"item","showImg":false,"showRibbon":false},{"id":28309677,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Chocolate Fest","type":"subcategory","entities":[{"id":104035813,"type":"item","showImg":false,"showRibbon":false},{"id":28309444,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Calzone","type":"subcategory","entities":[{"id":108277408,"type":"item","showImg":false,"showRibbon":false},{"id":108277409,"type":"item","showImg":false,"showRibbon":false},{"id":108277410,"type":"item","showImg":false,"showRibbon":false},{"id":108277411,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Desserts & Sundaes","type":"subcategory","entities":[{"id":86519416,"type":"item","showImg":false,"showRibbon":false},{"id":86519419,"type":"item","showImg":false,"showRibbon":false},{"id":86519441,"type":"item","showImg":false,"showRibbon":false},{"id":28309455,"type":"item","showImg":false,"showRibbon":false},{"id":47822550,"type":"item","showImg":false,"showRibbon":false},{"id":47822607,"type":"item","showImg":false,"showRibbon":false},{"id":86519396,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Empire Special Thick Shakes","type":"subcategory","entities":[{"id":86519287,"type":"item","showImg":false,"showRibbon":false},{"id":86519297,"type":"item","showImg":false,"showRibbon":false},{"id":96906011,"type":"item","showImg":false,"showRibbon":false},{"id":103547845,"type":"item","showImg":false,"showRibbon":false},{"id":103547846,"type":"item","showImg":false,"showRibbon":false},{"id":215259,"type":"item","showImg":false,"showRibbon":false},{"id":215260,"type":"item","showImg":false,"showRibbon":false},{"id":215298,"type":"item","showImg":false,"showRibbon":false},{"id":215301,"type":"item","showImg":false,"showRibbon":false},{"id":215304,"type":"item","showImg":false,"showRibbon":false},{"id":86519376,"type":"item","showImg":false,"showRibbon":false},{"id":86519382,"type":"item","showImg":false,"showRibbon":false},{"id":86519390,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Cold Press Fresh Juices","type":"subcategory","entities":[{"id":47822509,"type":"item","showImg":false,"showRibbon":false},{"id":47822534,"type":"item","showImg":false,"showRibbon":false},{"id":47822540,"type":"item","showImg":false,"showRibbon":false},{"id":47822591,"type":"item","showImg":false,"showRibbon":false},{"id":47822640,"type":"item","showImg":false,"showRibbon":false},{"id":86519251,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Mojitos & Coolers","type":"subcategory","entities":[{"id":86519340,"type":"item","showImg":false,"showRibbon":false},{"id":86519344,"type":"item","showImg":false,"showRibbon":false},{"id":92429975,"type":"item","showImg":false,"showRibbon":false},{"id":215289,"type":"item","showImg":false,"showRibbon":false},{"id":215291,"type":"item","showImg":false,"showRibbon":false},{"id":28309058,"type":"item","showImg":false,"showRibbon":false},{"id":47822488,"type":"item","showImg":false,"showRibbon":false},{"id":47822542,"type":"item","showImg":false,"showRibbon":false},{"id":47822626,"type":"item","showImg":false,"showRibbon":false},{"id":47822672,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Kulfis","type":"subcategory","entities":[{"id":28309278,"type":"item","showImg":false,"showRibbon":false},{"id":28309296,"type":"item","showImg":false,"showRibbon":false},{"id":100217612,"type":"item","showImg":false,"showRibbon":false},{"id":101418733,"type":"item","showImg":false,"showRibbon":false},{"id":101418735,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true},{"name":"Scoop Ice Creams","type":"subcategory","entities":[{"id":28309135,"type":"item","showImg":false,"showRibbon":false},{"id":86519265,"type":"item","showImg":false,"showRibbon":false},{"id":86519267,"type":"item","showImg":false,"showRibbon":false},{"id":86519270,"type":"item","showImg":false,"showRibbon":false},{"id":28309026,"type":"item","showImg":false,"showRibbon":false},{"id":47822494,"type":"item","showImg":false,"showRibbon":false},{"id":47822606,"type":"item","showImg":false,"showRibbon":false}],"collapsible":true}],"perRow":2,"collapsible":false},{"name":"Soft Drink","subTitle":"","type":"category","entities":[{"id":83982171,"type":"item","showImg":false,"showRibbon":false}],"perRow":2,"collapsible":false}],"layoutType":"normal","healthyCollection":[]},"aggregatedDiscountInfo":{"header":"10% off","shortDescriptionList":[{"meta":"10% off | Use TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"Free Tender Coconut Pudding on orders above ₹499","discountType":"Freebie","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"10% off up to ₹40 | Use code TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"Free Tender Coconut Pudding on orders above ₹499","discountType":"Freebie","operationType":"RESTAURANT"}]},"offerMeta":[{"header":"10% OFF UPTO ₹40","offer_tag":"","offer_logo":"offers/generic","top_logo":"","bottom_logo":"","offer_info":{"offer_ids":["4cf4f1c3-2a4f-482f-8721-c20a08f4be8d"],"type":"offers"},"expiry_time":0,"coupon_code":"USE TRYNEW","description":"ABOVE ₹159","secondary_discount_callout":"","show_expiry_timer":false},{"header":"Free Tender Coconut Pudding","offer_tag":"","offer_logo":"offers/generic","top_logo":"","bottom_logo":"","offer_info":{"offer_ids":["689677fb-b372-43cf-85d0-bbc0c60ebe76"],"type":"offers"},"expiry_time":0,"coupon_code":"NO CODE REQUIRED","description":"ABOVE ₹499","secondary_discount_callout":"","show_expiry_timer":false},{"header":"FLAT 10% OFF","offer_tag":"FLAT DEAL","offer_logo":"offers/generic","top_logo":"","bottom_logo":"","offer_info":{"offer_ids":["094075e0-21a6-4ca8-aadb-6d9288ec5162"],"type":"offers"},"expiry_time":0,"coupon_code":"USE PARTY","description":"ABOVE ₹500","secondary_discount_callout":"","show_expiry_timer":false},{"header":"20% OFF UPTO ₹120","offer_tag":"","offer_logo":"rng/md/ads/production/1acdb97aadcb61b323307845bda86535","top_logo":"","bottom_logo":"rng/md/ads/production/1acdb97aadcb61b323307845bda86535","offer_info":{"offer_ids":["68d41a53-c297-48e9-b3e0-054e3fd05845"],"type":"offers"},"expiry_time":0,"coupon_code":"USE FEDERALCC","description":"ABOVE ₹249","secondary_discount_callout":"","show_expiry_timer":false},{"header":"FLAT ₹100 OFF","offer_tag":"","offer_logo":"rng/md/ads/production/3a937ddacd3adb70c4543c4895213123","top_logo":"","bottom_logo":"rng/md/ads/production/3a937ddacd3adb70c4543c4895213123","offer_info":{"offer_ids":["db599105-a5bd-481a-988f-ede0670a6b16"],"type":"offers"},"expiry_time":0,"coupon_code":"USE AUDC100","description":"ABOVE ₹299","secondary_discount_callout":"","show_expiry_timer":false}],"itemNudgeBanners":{},"aggregatedDiscountInfoV2":{"header":"10% off","shortDescriptionList":[{"meta":"10% off | Use TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"Free Tender Coconut Pudding on orders above ₹499","discountType":"Freebie","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"10% off up to ₹40 | Use code TRYNEW","discountType":"Percentage","operationType":"RESTAURANT"},{"meta":"Free Tender Coconut Pudding on orders above ₹499","discountType":"Freebie","operationType":"RESTAURANT"}],"couponDetailsCTAText":"View coupon details","visible":false},"nudgeBanners":[{"minValue":350,"maxValue":500,"priority":3,"couponCode":"PARTY","discountInfo":{"discountType":"Percentage","value":10,"operationType":"RESTAURANT"},"lockedMessage":"Add items worth ₹<amount> to unlock flat 10% off | Code PARTY","unlockedMessage":"PARTY Coupon Unlocked! Use it to save flat 10% off","minItemCount":0,"maxItemCount":0,"type":"","cta":{"link":"","text":"","type":"","color":""}},{"minValue":104.3,"maxValue":149,"priority":4,"couponCode":"","discountInfo":{"discountType":"FREE_DELIVERY","value":0,"operationType":"RESTAURANT"},"lockedMessage":"","unlockedMessage":"","minItemCount":0,"maxItemCount":0,"type":"","cta":{"link":"","text":"","type":"","color":""}}],"restaurantLicenses":[{"type":"FSSAI","imageId":"fssai_final_edss9i","text":["License No. 11219334001702"]}],"menuTabs":[{"title":"Order Now","type":"menu","selected":true}],"vegOnlyDetails":{"imageId":"AutoVegOnly_qkjowj","title":"Showing only vegetarian options.","description":"Tap on the VEG ONLY button to turn off the setting"},"gpInfoList":[{"text":"","imageId":"","fontColor":""}],"expectationNotifiers":[],"menuCategory":[{"name":"Full Menu","identifier":"REGULAR","icon":"v1594205104/fullMenuActive_qcsdzt.png","unselectedIcon":"v1594205107/fullMenuInactive_fbdtp2.png","selected":true}],"xpConfigParams":{"isNewHealthMenu":"false"},"cafe":false,"select":false,"preorderable":false,"slotInvalid":false,"requestId":"1e174bd2-947c-4d28-b0b9-2d10283446ae","timeStamp":"1677493355379"},"tid":"2a5033da-edf5-489a-96b0-931a8e58ffce","sid":"5n211b87-98d1-4a76-819c-4d9187d7812b","deviceId":"c56d8f15-b692-9898-54d3-d5aef48c537a","csrfToken":"e3pvWNkzG1mQ-zMJPn0UE31ldQcLxnAewpoUcimk"},
  {
    statusCode: 0,
    data: {
      experiments: [
        {
          experimentId: "menu_via_timeline",
          variantId: "true",
        },
      ],
      restaurantAttributes: [],
      id: "229",
      name: "Meghana Foods",
      uuid: "4fdd19e2-5d0f-4bde-9c7f-dc3e8d36021f",
      slug: "meghana-foods-5th-block-koramangala",
      latLong: "12.934581,77.61628199999996",
      city: "Bangalore",
      area: "Koramangala",
      areaPostalCode: "560034",
      areaSlug: "koramangala",
      restaurantSlug: {
        restaurant: "meghana-foods-5th-block-koramangala",
        city: "bangalore",
      },
      type: "F",
      locality: "5th Block",
      avgRating: 4.4,
      totalRatings: 1000,
      avgRatingString: "4.4",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "xqwpuhgnsaf18te7zvtv",
      costForTwo: 50000,
      costForTwoMsg: "₹500 for two",
      cuisines: ["Biryani", "Andhra"],
      minimumOrder: 0,
      opened: 1,
      parentId: 635,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "23 MINS",
        lastMileDistanceString: "1.4 kms",
        restaurantId: "229",
        deliveryTime: 23,
        minDeliveryTime: 23,
        maxDeliveryTime: 23,
        lastMileTravel: 1.4,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.7309430241584778,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.5,
          components: {
            de: 0.5,
          },
        },
        surge: {
          applicable: false,
          components: [
            {
              value: 0,
              type: "STRESS",
            },
          ],
        },
        zoneId: 1,
      },
      availability: {
        nextCloseTime: "2023-02-27 23:59:00",
        nextChangeTime: 1677522540000,
        visibility: true,
        opened: true,
      },
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      labels: [
        {
          title: "Timings",
          message: "null",
        },
        {
          title: "Address",
          message:
            "124, Near Jyothi Nivas College, 1st Cross, KHB Colony, Koramangala 5th Block, Bangalore",
        },
        {
          title: "Cuisines",
          message: "Biryani,Andhra",
        },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "14413513": {
            id: 14413513,
            name: "Plain Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879033,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554708,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554709,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554710,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420099": {
            id: 86420099,
            name: "Paneer 65",
            category: "Veg Starter",
            description:
              "E: 723. 82 kcal (241. 27 kcal), c: 30. 89 grams (10. 30 grams), p: 32. 95 grams (10. 98 grams), f: 51. 82 grams (17. 27 grams) [Serving info: 1 Serve, Serving size: 300 grams, Energy: 723.82 kcal, Protein: 32.95g, Carbohydrates: 30.89g, Fat: 51.82g]",
            cloudinaryImageId: "druwjzmfmz7qvepq3bkr",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878017,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551665,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551667,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551668,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "300 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420100": {
            id: 86420100,
            name: "Chilly Paneer",
            category: "Veg Starter",
            description:
              "E: 871. 69 kcal (272. 40 kcal), c: 21. 54 grams (6. 73 grams), p: 51. 90 grams (16. 22 grams), f: 64. 36 grams (20. 11 grams) [Serving info: 1 Serve, Serving size: 320 grams, Energy: 871.69 kcal, Protein: 51.9g, Carbohydrates: 21.54g, Fat: 64.36g]",
            cloudinaryImageId: "byonwwb8mzxyqluxlqpq",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878024,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551691,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551685,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551688,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "320 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420101": {
            id: 86420101,
            name: "Golden Baby Corn",
            category: "Veg Starter",
            description:
              "E: 325. 18 kcal (108. 39 kcal), c: 40. 60 grams (13. 53 grams), p: 9. 84 grams (3. 28 grams), f: 13. 76 grams (4. 59 grams) [Serving info: 1 Serve, Serving size: 300 grams, Energy: 325.18 kcal, Protein: 9.84g, Carbohydrates: 40.6g, Fat: 13.76g]",
            cloudinaryImageId: "ocgjpnijydsughgjnkk0",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878033,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551718,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551714,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551715,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "300 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420106": {
            id: 86420106,
            name: "Chilly Gobi",
            category: "Veg Starter",
            description:
              "E: 192. 99 kcal (55. 14 kcal), c: 15. 54 grams (4. 44 grams), p: 8. 11 grams (2. 32 grams), f: 10. 39 grams (2. 97 grams) [Serving info: 1 Serve, Serving size: 350 grams, Energy: 192.99 kcal, Protein: 8.11g, Carbohydrates: 15.54g, Fat: 10.39g]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878043,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551750,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551744,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551747,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "350 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420107": {
            id: 86420107,
            name: "Gobi 65",
            category: "Veg Starter",
            description:
              "E: 187. 49 kcal (58. 59 kcal), c: 16. 90 grams (5. 28 grams), p: 7. 79 grams (2. 43 grams), f: 9. 06 grams (2. 83 grams) [Serving info: 1 Serve, Serving size: 320 grams, Energy: 187.49 kcal, Protein: 7.79g, Carbohydrates: 16.9g, Fat: 9.06g]",
            cloudinaryImageId: "q8kk1xz0w0l8oxmcyxdc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878055,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551780,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551781,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551782,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "320 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420108": {
            id: 86420108,
            name: "Mushroom 65",
            category: "Veg Starter",
            description:
              "E: 196. 76 kcal (65. 59 kcal), c: 16. 97 grams (5. 66 grams), p: 10. 27 grams (3. 42 grams), f: 9. 35 grams (3. 12 grams) [Serving info: 1 Serve, Serving size: 300 grams, Energy: 196.76 kcal, Protein: 10.27g, Carbohydrates: 16.97g, Fat: 9.35g]",
            cloudinaryImageId: "buclixrr4jwtcemyrz68",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878065,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551815,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551810,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551811,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "300 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420110": {
            id: 86420110,
            name: "Chilly Mushroom",
            category: "Veg Starter",
            description:
              "E: 203. 43 kcal (63. 57 kcal), c: 15. 55 grams (4. 86 grams), p: 11. 25 grams (3. 52 grams), f: 10. 64 grams (3. 33 grams) [Serving info: 1 Serve, Serving size: 320 grams, Energy: 203.43 kcal, Protein: 11.25g, Carbohydrates: 15.55g, Fat: 10.64g]",
            cloudinaryImageId: "bof3doctupomf223xpzz",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878078,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551851,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551846,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551847,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "320 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420112": {
            id: 86420112,
            name: "Chilly Babycorn",
            category: "Veg Starter",
            description:
              "E: 308. 05 kcal (96. 27 kcal), c: 39. 35 grams (12. 30 grams), p: 8. 85 grams (2. 77 grams), f: 12. 97 grams (4. 05 grams) [Serving info: 1 Serve, Serving size: 320 grams, Energy: 308.05 kcal, Protein: 8.85g, Carbohydrates: 39.35g, Fat: 12.97g]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 26000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878103,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551926,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551929,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551922,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "320 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420113": {
            id: 86420113,
            name: "Gobi Manchurian",
            category: "Veg Starter",
            description:
              "E: 194. 60 kcal (60. 81 kcal), c: 15. 56 grams (4. 86 grams), p: 7. 96 grams (2. 49 grams), f: 10. 89 grams (3. 40 grams) [Serving info: 1 Serve, Serving size: 320 grams, Energy: 194.6 kcal, Protein: 7.96g, Carbohydrates: 15.56g, Fat: 10.89g]",
            cloudinaryImageId: "rzh4qydjkaurrpecaxc2",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878110,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551942,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551943,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551945,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "320 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420115": {
            id: 86420115,
            name: "Paneer Manchurian",
            category: "Veg Starter",
            description:
              "E: 706. 01 kcal (282. 40 kcal), c: 18. 14 grams (7. 26 grams), p: 41. 58 grams (16. 63 grams), f: 52. 24 grams (20. 90 grams) [Serving info: 1 Serve, Serving size: 250 grams, Energy: 706.01 kcal, Protein: 41.58g, Carbohydrates: 18.14g, Fat: 52.24g]",
            cloudinaryImageId: "xafpkamsf7oz2ae8lgil",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878121,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52551972,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551973,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52551974,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "250 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420116": {
            id: 86420116,
            name: "Baby Corn Manchurian",
            category: "Veg Starter",
            description:
              "E: 258. 72 kcal (103. 49 kcal), c: 32. 28 grams (12. 91 grams), p: 7. 42 grams (2. 97 grams), f: 11. 45 grams (4. 58 grams) [Serving info: 1 Serve, Serving size: 250 grams, Energy: 258.72 kcal, Protein: 7.42g, Carbohydrates: 32.28g, Fat: 11.45g]",
            cloudinaryImageId: "qkg8efaxbjjgx5cpkuax",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878135,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552015,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552014,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552016,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "250 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420118": {
            id: 86420118,
            name: "Mushroom Manchurian",
            category: "Veg Starter",
            description: "",
            cloudinaryImageId: "soz7jm21okoxcltrobge",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878144,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552041,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552043,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552045,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420120": {
            id: 86420120,
            name: "Chilly Chicken (Boneless)",
            category: "Non-veg Starter",
            description:
              "E: 604. 42 kcal (163. 36 kcal), c: 29. 67 grams (8. 02 grams), p: 50. 63 grams (13. 68 grams), f: 30. 94 grams (8. 36 grams) [Serving info: 1 Serve, Serving size: 370 grams, Energy: 604.42 kcal, Protein: 50.63g, Carbohydrates: 29.67g, Fat: 30.94g]",
            cloudinaryImageId: "ry3c3f518z10t4olu4l7",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878163,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552098,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552111,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552103,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "370 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420121": {
            id: 86420121,
            name: "Chilly Chicken (Andhra Style)",
            category: "Non-veg Starter",
            description:
              "E: 912. 22 kcal (202. 72 kcal), c: 5. 35 grams (1. 19 grams), p: 68. 75 grams (15. 28 grams), f: 67. 98 grams (15. 11 grams) [Serving info: 1 Serve, Serving size: 450 grams, Energy: 912.22 kcal, Protein: 68.75g, Carbohydrates: 5.35g, Fat: 67.98g]",
            cloudinaryImageId: "gitnmufvwguqai831dlc",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878187,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552175,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552177,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552172,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "450 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420123": {
            id: 86420123,
            name: "Chicken 65",
            category: "Non-veg Starter",
            description:
              "E: 544. 39 kcal (155. 54 kcal), c: 25. 11 grams (7. 17 grams), p: 45. 15 grams (12. 90 grams), f: 27. 91 grams (7. 97 grams) [Serving info: 1 Serve, Serving size: 350 grams, Energy: 544.39 kcal, Protein: 45.15g, Carbohydrates: 25.11g, Fat: 27.91g]",
            cloudinaryImageId: "x0jegvlf4h7wrgaaqdqi",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878198,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552204,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552203,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552206,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "350 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420125": {
            id: 86420125,
            name: "Meghana Chicken 555",
            category: "Non-veg Starter",
            description:
              "E: 585. 13 kcal (195. 04 kcal), c: 26. 88 grams (8. 96 grams), p: 32. 48 grams (10. 83 grams), f: 39. 36 grams (13. 12 grams) [Serving info: 1 Serve, Serving size: 300 grams, Energy: 585.13 kcal, Protein: 32.48g, Carbohydrates: 26.88g, Fat: 39.36g]",
            cloudinaryImageId: "irnwr59vlrmciau11or0",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878211,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552242,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552243,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552245,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "300 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420127": {
            id: 86420127,
            name: "Lemon Chicken",
            category: "Non-veg Starter",
            description:
              "E: 582. 12 kcal (157. 33 kcal), c: 31. 16 grams (8. 42 grams), p: 44. 58 grams (12. 05 grams), f: 30. 79 grams (8. 32 grams) [Serving info: 1 Serve, Serving size: 370 grams, Energy: 582.12 kcal, Protein: 44.58g, Carbohydrates: 31.16g, Fat: 30.79g]",
            cloudinaryImageId: "vnotaq2k5i2nqdigafon",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878226,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552288,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552287,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552290,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "370 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420128": {
            id: 86420128,
            name: "Chicken Kabab",
            category: "Non-veg Starter",
            description: "",
            cloudinaryImageId: "lxj1uvdkng7zu0npvnsu",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878235,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552314,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552315,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552317,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420129": {
            id: 86420129,
            name: "Chicken Lollypop",
            category: "Non-veg Starter",
            description:
              "E: 389. 14 kcal (155. 66 kcal), c: 7. 31 grams (2. 92 grams), p: 36. 13 grams (14. 45 grams), f: 23. 92 grams (9. 57 grams) [Serving info: 1 Serve, Serving size: 250 grams, Energy: 389.14 kcal, Protein: 36.13g, Carbohydrates: 7.31g, Fat: 23.92g]",
            cloudinaryImageId: "ldqyxnhlfylhymnsopzc",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878243,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552341,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552337,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552339,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "250 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420130": {
            id: 86420130,
            name: "Chicken Pakoda",
            category: "Non-veg Starter",
            description:
              "E: 269. 97 kcal (107. 99 kcal), c: 7. 54 grams (3. 02 grams), p: 38. 25 grams (15. 30 grams), f: 8. 70 grams (3. 48 grams) [Serving info: 1 Serve, Serving size: 250 grams, Energy: 269.97 kcal, Protein: 38.25g, Carbohydrates: 7.54g, Fat: 8.7g]",
            cloudinaryImageId: "txnhcbhyu0kkltnqxyyu",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878253,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552371,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552366,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552369,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "250 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420131": {
            id: 86420131,
            name: "Pepper Chicken",
            category: "Non-veg Starter",
            description:
              "E: 609. 63 kcal (174. 18 kcal), c: 25. 62 grams (7. 32 grams), p: 47. 42 grams (13. 55 grams), f: 33. 70 grams (9. 63 grams) [Serving info: 1 Serve, Serving size: 350 grams, Energy: 609.63 kcal, Protein: 47.42g, Carbohydrates: 25.62g, Fat: 33.7g]",
            cloudinaryImageId: "rlcjzwkysumyh28nxuaq",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878283,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552460,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552464,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552466,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "350 gram",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420132": {
            id: 86420132,
            name: "Chicken Fry",
            category: "Non-veg Starter",
            description:
              "E: 585. 85 kcal (234. 34 kcal), c: 17. 29 grams (6. 92 grams), p: 29. 63 grams (11. 85 grams), f: 44. 88 grams (17. 95 grams) [Serving info: 1 Serve, Serving size: 250 grams, Energy: 585.85 kcal, Protein: 29.63g, Carbohydrates: 17.29g, Fat: 44.88g]",
            cloudinaryImageId: "fxzktf2iv07u8iqufivx",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878293,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552492,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552486,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552490,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "250 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420135": {
            id: 86420135,
            name: "Chicken Maharaja",
            category: "Non-veg Starter",
            description:
              "E: 601. 09 kcal (171. 74 kcal), c: 31. 60 grams (9. 03 grams), p: 49. 21 grams (14. 06 grams), f: 30. 39 grams (8. 68 grams) [Serving info: 1 Serve, Serving size: 350 grams, Energy: 601.09 kcal, Protein: 49.21g, Carbohydrates: 31.6g, Fat: 30.39g]",
            cloudinaryImageId: "qbvnd4eezzybx9dj38xv",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878316,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552560,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552558,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552557,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "350 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420136": {
            id: 86420136,
            name: "Chicken Rayalaseema",
            category: "Non-veg Starter",
            description:
              "E: 555. 52 kcal (202. 01 kcal), c: 9. 71 grams (3. 53 grams), p: 48. 05 grams (17. 47 grams), f: 36. 10 grams (13. 13 grams) [Serving info: 1 Serve, Serving size: 275 grams, Energy: 555.52 kcal, Protein: 48.05g, Carbohydrates: 9.71g, Fat: 36.1g]",
            cloudinaryImageId: "amlh8ivjrwgcx4lxrki8",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878326,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552592,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552584,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552588,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "275 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420139": {
            id: 86420139,
            name: "Mutton Fry",
            category: "Non-veg Starter",
            description: "",
            cloudinaryImageId: "ezj9gf9w0fcf1ipklggw",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 39400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878338,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552620,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552624,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552626,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420140": {
            id: 86420140,
            name: "Today's Andhra Spl",
            category: "Non-veg Starter",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878347,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552650,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552653,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552656,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420149": {
            id: 86420149,
            name: "Mutton Kheema Fry",
            category: "Non-veg Starter",
            description: "",
            cloudinaryImageId: "duelwcrkh4piecqicjxk",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 39400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878391,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552781,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552783,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552784,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420150": {
            id: 86420150,
            name: "Mutton Pepper Fry",
            category: "Non-veg Starter",
            description:
              "E: 452. 55 kcal (226. 28 kcal), c: 23. 89 grams (11. 95 grams), p: 34. 31 grams (17. 16 grams), f: 24. 17 grams (12. 09 grams) [Serving info: 1 Serve, Serving size: 200 grams, Energy: 452.55 kcal, Protein: 34.31g, Carbohydrates: 23.89g, Fat: 24.17g]",
            cloudinaryImageId: "o2gtnh4ixf24wbvkhgtp",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 40900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878402,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552817,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552816,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552813,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "200 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420151": {
            id: 86420151,
            name: "Chilly Fish",
            category: "Sea Food Starter",
            description:
              "E: 348. 16 kcal (116. 05 kcal), c: 12. 57 grams (4. 19 grams), p: 43. 21 grams (14. 40 grams), f: 14. 27 grams (4. 76 grams) [Serving info: 1 Serve, Serving size: 300 grams, Energy: 348.16 kcal, Protein: 43.21g, Carbohydrates: 12.57g, Fat: 14.27g]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878419,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552865,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552868,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552867,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "300 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420153": {
            id: 86420153,
            name: "Apollo Fish",
            category: "Sea Food Starter",
            description:
              "E: 293. 75 kcal (108. 80 kcal), c: 15. 07 grams (5. 58 grams), p: 24. 80 grams (9. 19 grams), f: 15. 38 grams (5. 70 grams) [Serving info: 1 Serve, Serving size: 270 grams, Energy: 293.75 kcal, Protein: 24.8g, Carbohydrates: 15.07g, Fat: 15.38g]",
            cloudinaryImageId: "ywwqavlqhhhwrpzu3nle",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878426,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552892,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552887,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552889,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "270 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420222": {
            id: 86420222,
            name: "Chilli Prawns",
            category: "Sea Food Starter",
            description:
              "E: 289. 89 kcal (103. 53 kcal), c: 12. 99 grams (4. 64 grams), p: 28. 51 grams (10. 18 grams), f: 13. 85 grams (4. 95 grams) [Serving info: 1 Serve, Serving size: 280 grams, Energy: 289.89 kcal, Protein: 28.51g, Carbohydrates: 12.99g, Fat: 13.85g]",
            cloudinaryImageId: "gbowveie1vh3zrxegqqb",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878474,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553031,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553033,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553035,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "280 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420234": {
            id: 86420234,
            name: "Prawns Fry",
            category: "Sea Food Starter",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878482,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553056,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553055,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553057,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420238": {
            id: 86420238,
            name: "Chicken Boneless Curry",
            category: "Non-veg Curries",
            description:
              "E: 651. 37 kcal (130. 27 kcal), c: 26. 52 grams (5. 30 grams), p: 44. 85 grams (8. 97 grams), f: 39. 17 grams (7. 83 grams) [Serving info: 1 Serve, Serving size: 500 grams, Energy: 651.37 kcal, Protein: 44.85g, Carbohydrates: 26.52g, Fat: 39.17g]",
            cloudinaryImageId: "ybxkminvzggpmjfbecu8",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878496,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553098,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553097,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553099,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "500 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420240": {
            id: 86420240,
            name: "Butter Chicken Curry",
            category: "Non-veg Curries",
            description:
              "E: 910. 32 kcal (151. 72 kcal), c: 32. 44 grams (5. 41 grams), p: 50. 28 grams (8. 38 grams), f: 63. 47 grams (10. 58 grams) [Serving info: 1 Serve, Serving size: 600 grams, Energy: 910.32 kcal, Protein: 50.28g, Carbohydrates: 32.44g, Fat: 63.47g]",
            cloudinaryImageId: "mqfjzwea48recubya6or",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878503,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553121,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553119,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553118,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "600 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420242": {
            id: 86420242,
            name: "Chicken Curry",
            category: "Non-veg Curries",
            description:
              "E: 661. 19 kcal (143. 74 kcal), c: 33. 26 grams (7. 23 grams), p: 35. 00 grams (7. 61 grams), f: 42. 53 grams (9. 25 grams) [Serving info: 1 Serve, Serving size: 460 grams, Energy: 661.19 kcal, Protein: 35g, Carbohydrates: 33.26g, Fat: 42.53g]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878512,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553143,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553145,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553147,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "460 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420244": {
            id: 86420244,
            name: "Mutton Curry",
            category: "Non-veg Curries",
            description:
              "E: 687. 42 kcal (149. 44 kcal), c: 8. 12 grams (1. 77 grams), p: 97. 57 grams (21. 21 grams), f: 26. 64 grams (5. 79 grams) [Serving info: 1 Serve, Serving size: 460 grams, Energy: 687.42 kcal, Protein: 97.57g, Carbohydrates: 8.12g, Fat: 26.64g]",
            cloudinaryImageId: "f7ckmzlbdykejeqlmjbh",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 39400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878531,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553203,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553202,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553204,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "460 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420246": {
            id: 86420246,
            name: "Fish Curry",
            category: "Non-veg Curries",
            description:
              "E: 489. 84 kcal (111. 33 kcal), c: 26. 33 grams (5. 98 grams), p: 26. 83 grams (6. 10 grams), f: 30. 55 grams (6. 94 grams) [Serving info: 1 Serve, Serving size: 440 grams, Energy: 489.84 kcal, Protein: 26.83g, Carbohydrates: 26.33g, Fat: 30.55g]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878541,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553230,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553233,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553226,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "440 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420271": {
            id: 86420271,
            name: "Prawns Curry",
            category: "Non-veg Curries",
            description:
              "E: 468. 91 kcal (106. 57 kcal), c: 26. 95 grams (6. 12 grams), p: 19. 92 grams (4. 53 grams), f: 30. 84 grams (7. 01 grams) [Serving info: 1 Serve, Serving size: 440 grams, Energy: 468.91 kcal, Protein: 19.92g, Carbohydrates: 26.95g, Fat: 30.84g]",
            cloudinaryImageId: "x28cgy0rmpxluhsv0lzr",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878550,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553262,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553259,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553260,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "440 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420292": {
            id: 86420292,
            name: "Egg Masala Curry",
            category: "Non-veg Curries",
            description:
              "E: 721. 81 kcal (160. 40 kcal), c: 34. 03 grams (7. 56 grams), p: 24. 15 grams (5. 37 grams), f: 54. 89 grams (12. 20 grams) [Serving info: 1 Serve, Serving size: 450 grams, Energy: 721.81 kcal, Protein: 24.15g, Carbohydrates: 34.03g, Fat: 54.89g]",
            cloudinaryImageId: "xqpvlqbixniguvhqvdzb",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878561,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553290,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553292,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553294,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "450 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420310": {
            id: 86420310,
            name: "Tomato Egg Curry",
            category: "Non-veg Curries",
            description:
              "E: 545. 12 kcal (121. 14 kcal), c: 25. 14 grams (5. 59 grams), p: 16. 69 grams (3. 71 grams), f: 41. 96 grams (9. 32 grams) [Serving info: 1 Serve, Serving size: 450 grams, Energy: 545.12 kcal, Protein: 16.69g, Carbohydrates: 25.14g, Fat: 41.96g]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878568,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553313,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553315,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553314,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "450 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420339": {
            id: 86420339,
            name: "Chicken Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1615. 27 kcal (153. 84 kcal), c: 190. 89 grams (18. 18 grams), p: 61. 82 grams (5. 89 grams), f: 64. 63 grams (6. 16 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1615.27 kcal, Protein: 61.82g, Carbohydrates: 190.89g, Fat: 64.63g]",
            cloudinaryImageId: "zbrpxvywfsrrb7os11jf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055357,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234069,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234068,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234071,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234067,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234070,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878685,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553667,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553665,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553664,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420340": {
            id: 86420340,
            name: "Chicken Boneless Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1446. 5 kcal (137. 76 kcal), c: 189. 62 grams (18. 06 grams), p: 64. 22 grams (6. 12 grams), f: 44. 20 grams (4. 21 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1446.5 kcal, Protein: 64.22g, Carbohydrates: 189.62g, Fat: 44.2g]",
            cloudinaryImageId: "iivuhjc2mswi9lublktf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055358,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234072,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234074,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234073,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234076,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234075,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878701,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553714,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553713,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553712,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420342": {
            id: 86420342,
            name: "Meghana Special Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1456. 21 kcal (138. 69 kcal), c: 190. 89 grams (18. 18 grams), p: 64. 65 grams (6. 16 grams), f: 44. 50 grams (4. 24 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1456.21 kcal, Protein: 64.65g, Carbohydrates: 190.89g, Fat: 44.5g]",
            cloudinaryImageId: "zuthvcwjjvdjmo6n1pbl",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055359,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234078,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234077,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234079,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234081,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234080,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878717,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553760,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553762,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553761,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420359": {
            id: 86420359,
            name: "Mutton Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1586. 02 kcal (158. 60 kcal), c: 185. 36 grams (18. 54 grams), p: 66. 69 grams (6. 67 grams), f: 61. 78 grams (6. 18 grams) [Serving info: 1 Serve, Serving size: 1000 grams, Energy: 1586.02 kcal, Protein: 66.69g, Carbohydrates: 185.36g, Fat: 61.78g]",
            cloudinaryImageId: "wqvc9jnr4vhjmkkjiir0",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 41500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055364,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234094,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234093,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234096,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234095,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234092,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878790,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553979,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553981,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553980,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1000 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420360": {
            id: 86420360,
            name: "Mutton Keema Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1551. 26 kcal (147. 74 kcal), c: 200. 46 grams (19. 09 grams), p: 42. 47 grams (4. 04 grams), f: 61. 10 grams (5. 82 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1551.26 kcal, Protein: 42.47g, Carbohydrates: 200.46g, Fat: 61.1g]",
            cloudinaryImageId: "bsswvqauvfo1qg4lqblz",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 40900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055365,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234101,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234098,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234097,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234100,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234099,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878801,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554014,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554013,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554012,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420363": {
            id: 86420363,
            name: "Fish Biriyani",
            category: "Non-veg Biriyani",
            description:
              "E: 1429. 30 kcal (136. 12 kcal), c: 189. 62 grams (18. 06 grams), p: 55. 02 grams (5. 24 grams), f: 47. 60 grams (4. 53 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1429.3 kcal, Protein: 55.02g, Carbohydrates: 189.62g, Fat: 47.6g]",
            cloudinaryImageId: "cfrtq4lrtjrollvuwyb3",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055367,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234102,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234104,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234103,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234106,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234105,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878808,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554033,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554037,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554035,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420364": {
            id: 86420364,
            name: "Prawns Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1431. 95 kcal (136. 38 kcal), c: 213. 40 grams (20. 32 grams), p: 37. 34 grams (3. 56 grams), f: 43. 56 grams (4. 15 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1431.95 kcal, Protein: 37.34g, Carbohydrates: 213.4g, Fat: 43.56g]",
            cloudinaryImageId: "pxqhnjvdhm3nyqkhxute",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 36500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055369,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234109,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234108,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234111,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234107,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234110,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878817,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554062,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554060,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554064,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420372": {
            id: 86420372,
            name: "Egg Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1421. 92 kcal (142. 19 kcal), c: 196. 91 grams (19. 69 grams), p: 38. 82 grams (3. 88 grams), f: 50. 86 grams (5. 09 grams) [Serving info: 1 Serve, Serving size: 1000 grams, Energy: 1421.92 kcal, Protein: 38.82g, Carbohydrates: 196.91g, Fat: 50.86g]",
            cloudinaryImageId: "wcvun7u8l0jzkzcf8zap",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055371,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234113,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234112,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234115,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234114,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234116,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878827,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554088,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554087,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554089,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1000 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420383": {
            id: 86420383,
            name: "Chicken Fry Pc Biriyani",
            category: "Non-veg Biriyani",
            description:
              "E: 1576. 65 kcal (150. 16 kcal), c: 197. 77 grams (18. 84 grams), p: 55. 24 grams (5. 26 grams), f: 59. 33 grams (5. 65 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1576.65 kcal, Protein: 55.24g, Carbohydrates: 197.77g, Fat: 59.33g]",
            cloudinaryImageId: "o6eblssnt4tjn9zzufs0",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055373,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234117,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234120,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234119,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234118,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234121,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878836,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554114,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554116,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554115,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420391": {
            id: 86420391,
            name: "Aloo Dum Biryani",
            category: "Veg Biriyani",
            description:
              "E: 1415. 98 kcal (134. 86 kcal), c: 226. 97 grams (21. 62 grams), p: 25. 46 grams (2. 42 grams), f: 42. 15 grams (4. 01 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1415.98 kcal, Protein: 25.46g, Carbohydrates: 226.97g, Fat: 42.15g]",
            cloudinaryImageId: "mtuzvgdmipuikj6pxllr",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055374,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234124,
                    name: "Paneer Pcs",
                    price: 17000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234123,
                    name: "Extra Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234122,
                    name: "Extra Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234125,
                    name: "Extra Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878879,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554245,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554244,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554243,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420393": {
            id: 86420393,
            name: "Paneer Biryani",
            category: "Veg Biriyani",
            description:
              "E: 1800. 51 kcal (171. 48 kcal), c: 198. 62 grams (18. 92 grams), p: 61. 42 grams (5. 85 grams), f: 82. 00 grams (7. 81 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1800.51 kcal, Protein: 61.42g, Carbohydrates: 198.62g, Fat: 82g]",
            cloudinaryImageId: "gehax5kizfwncsgkris2",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055375,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234126,
                    name: "Extra Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234128,
                    name: "Paneer Pcs",
                    price: 17000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234127,
                    name: "Extra Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234129,
                    name: "Extra Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878889,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554275,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554274,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554273,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420395": {
            id: 86420395,
            name: "Veg Biryani Rice",
            category: "Veg Biriyani",
            description: "",
            cloudinaryImageId: "yiiln3ntc7cwm51l9lhi",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055377,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234131,
                    name: "Extra Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234130,
                    name: "Extra Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234133,
                    name: "Extra Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234132,
                    name: "Paneer Pcs",
                    price: 17000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878897,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554297,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554299,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554302,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420398": {
            id: 86420398,
            name: "Spl Veg Biryani",
            category: "Veg Biriyani",
            description:
              "E: 1327. 35 kcal (126. 41 kcal), c: 213. 24 grams (20. 31 grams), p: 26. 99 grams (2. 57 grams), f: 38. 46 grams (3. 66 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1327.35 kcal, Protein: 26.99g, Carbohydrates: 213.24g, Fat: 38.46g]",
            cloudinaryImageId: "fsitbray4gq1kxcndqqx",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 26000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055378,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234135,
                    name: "Extra Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234134,
                    name: "Extra Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234137,
                    name: "Extra Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234136,
                    name: "Paneer Pcs",
                    price: 17000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878906,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554322,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554326,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554325,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420400": {
            id: 86420400,
            name: "Mushroom Biryani",
            category: "Veg Biriyani",
            description:
              "E: 1225. 8 kcal (116. 74 kcal), c: 186. 92 grams (17. 80 grams), p: 29. 42 grams (2. 80 grams), f: 37. 51 grams (3. 57 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1225.8 kcal, Protein: 29.42g, Carbohydrates: 186.92g, Fat: 37.51g]",
            cloudinaryImageId: "ujngpmxwklmqpruqhx9h",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055380,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234139,
                    name: "Extra Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234138,
                    name: "Extra Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234141,
                    name: "Extra Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234140,
                    name: "Paneer Pcs",
                    price: 17000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878916,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554356,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554355,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554354,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420401": {
            id: 86420401,
            name: "Phulka",
            category: "Indian Breads",
            description: "",
            cloudinaryImageId: "myutirf3a1ntipvekpif",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878931,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554400,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554399,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554401,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420403": {
            id: 86420403,
            name: "Butter Phulka",
            category: "Indian Breads",
            description: "",
            cloudinaryImageId: "iqxgdadddhc2zntkzyma",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878951,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554460,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554464,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554462,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420404": {
            id: 86420404,
            name: "Chapati",
            category: "Indian Breads",
            description: "",
            cloudinaryImageId: "mjv5a7anxypulyerfibr",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4200,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878955,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554475,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554472,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554473,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420417": {
            id: 86420417,
            name: "Boiled Egg (2nos)",
            category: "Egg",
            description:
              "E: 161. 75 kcal (134. 79 kcal), c: 0. 00 grams (0. 00 grams), p: 15. 94 grams (13. 28 grams), f: 10. 98 grams (9. 15 grams) [Serving info: 1 Serve, Serving size: 120 grams, Energy: 161.75 kcal, Protein: 15.94g, Carbohydrates: 0g, Fat: 10.98g]",
            cloudinaryImageId: "cu8lzfhxtzgzcd0c0wga",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 3700,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879003,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554620,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554618,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554619,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "120 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420569": {
            id: 86420569,
            name: "Chilly Egg",
            category: "Egg",
            description:
              "E: 753. 36 kcal (279. 02 kcal), c: 36. 97 grams (13. 69 grams), p: 17. 51 grams (6. 49 grams), f: 60. 84 grams (22. 53 grams) [Serving info: 1 Serve, Serving size: 270 grams, Energy: 753.36 kcal, Protein: 17.51g, Carbohydrates: 36.97g, Fat: 60.84g]",
            cloudinaryImageId: "txicrqgqrl1nmgj4iay6",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879013,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554650,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554648,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554649,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "270 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420570": {
            id: 86420570,
            name: "Veg Kadai",
            category: "Veg Curries",
            description:
              "E: 729. 09 kcal (132. 56 kcal), c: 37. 87 grams (6. 89 grams), p: 20. 61 grams (3. 75 grams), f: 54. 45 grams (9. 90 grams) [Serving info: 1 Serve, Serving size: 550 grams, Energy: 729.09 kcal, Protein: 20.61g, Carbohydrates: 37.87g, Fat: 54.45g]",
            cloudinaryImageId: "iffbbbz435xq2c0uzxxt",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878585,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553364,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553366,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553365,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "550 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420571": {
            id: 86420571,
            name: "Palak Paneer Curry",
            category: "Veg Curries",
            description:
              "E: 833. 69 kcal (151. 58 kcal), c: 33. 75 grams (6. 14 grams), p: 30. 72 grams (5. 59 grams), f: 64. 01 grams (11. 64 grams) [Serving info: 1 Serve, Serving size: 550 grams, Energy: 833.69 kcal, Protein: 30.72g, Carbohydrates: 33.75g, Fat: 64.01g]",
            cloudinaryImageId: "slaicd3fv71xcsxblb2w",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878600,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553410,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553411,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553408,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "550 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420573": {
            id: 86420573,
            name: "Green Peas Curry",
            category: "Veg Curries",
            description:
              "E: 675. 07 kcal (127. 37 kcal), c: 52. 47 grams (9. 90 grams), p: 22. 48 grams (4. 24 grams), f: 40. 67 grams (7. 67 grams) [Serving info: 1 Serve, Serving size: 530 grams, Energy: 675.07 kcal, Protein: 22.48g, Carbohydrates: 52.47g, Fat: 40.67g]",
            cloudinaryImageId: "izr6y2zxm2o7j8bgj9s2",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878603,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553420,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553416,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553418,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "530 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420574": {
            id: 86420574,
            name: "Aloo Matar Curry",
            category: "Veg Curries",
            description:
              "E: 658. 32 kcal (119. 6 kcal), c: 57. 86 grams (10. 52 grams), p: 18. 86 grams (3. 43 grams), f: 38. 08 grams (6. 92 grams) [Serving info: 1 Serve, Serving size: 550 grams, Energy: 658.32 kcal, Protein: 18.86g, Carbohydrates: 57.86g, Fat: 38.08g]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878610,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553440,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553437,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553439,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "550 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420604": {
            id: 86420604,
            name: "Paneer Butter Masala",
            category: "Veg Curries",
            description:
              "E: 1156. 81 kcal (210. 33 kcal), c: 37. 93 grams (6. 90 grams), p: 43. 54 grams (7. 92 grams), f: 92. 60 grams (16. 84 grams) [Serving info: 1 Serve, Serving size: 550 grams, Energy: 1156.81 kcal, Protein: 43.54g, Carbohydrates: 37.93g, Fat: 92.6g]",
            cloudinaryImageId: "ksjxi61s8xqlj8cqp4zs",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878614,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553452,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553451,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553453,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "550 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420641": {
            id: 86420641,
            name: "Mushroom Masala",
            category: "Veg Curries",
            description:
              "E: 537. 70 kcal (119. 49 kcal), c: 34. 48 grams (7. 66 grams), p: 13. 09 grams (2. 91 grams), f: 38. 75 grams (8. 61 grams) [Serving info: 1 Serve, Serving size: 450 grams, Energy: 537.7 kcal, Protein: 13.09g, Carbohydrates: 34.48g, Fat: 38.75g]",
            cloudinaryImageId: "gqjbuq7xoyuxolxsprjp",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878621,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553472,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553471,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553474,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "450 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420740": {
            id: 86420740,
            name: "Tomato Curry",
            category: "Veg Curries",
            description:
              "E: 509. 47 kcal (113. 22 kcal), c: 25. 05 grams (5. 57 grams), p: 6. 93 grams (1. 54 grams), f: 42. 21 grams (9. 38 grams) [Serving info: 1 Serve, Serving size: 450 grams, Energy: 509.47 kcal, Protein: 6.93g, Carbohydrates: 25.05g, Fat: 42.21g]",
            cloudinaryImageId: "thpbu9owje2ut4r7gk0d",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878629,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553496,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553498,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553497,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "450 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420742": {
            id: 86420742,
            name: "Dal Fry",
            category: "Veg Curries",
            description:
              "E: 471. 22 kcal (104. 72 kcal), c: 52. 05 grams (11. 57 grams), p: 18. 00 grams (4. 00 grams), f: 20. 93 grams (4. 65 grams) [Serving info: 1 Serve, Serving size: 450 grams, Energy: 471.22 kcal, Protein: 18g, Carbohydrates: 52.05g, Fat: 20.93g]",
            cloudinaryImageId: "czmhxhzvc8lqklawenrv",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878634,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553509,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553510,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553512,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "450 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420744": {
            id: 86420744,
            name: "Mix Vegetable Curry",
            category: "Veg Curries",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878663,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553597,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553601,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553604,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420745": {
            id: 86420745,
            name: "Chicken Fried Rice",
            category: "Rice",
            description:
              "E: 1142. 26 kcal (163. 18 kcal), c: 125. 05 grams (17. 86 grams), p: 40. 11 grams (5. 73 grams), f: 51. 37 grams (7. 34 grams) [Serving info: 1 Serve, Serving size: 700 grams, Energy: 1142.26 kcal, Protein: 40.11g, Carbohydrates: 125.05g, Fat: 51.37g]",
            cloudinaryImageId: "akmx533z73jjbq8avy6v",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879016,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554658,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554659,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554657,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "700 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420747": {
            id: 86420747,
            name: "Egg Fried Rice",
            category: "Rice",
            description:
              "E: 1729. 51 kcal (164. 72 kcal), c: 204. 54 grams (19. 48 grams), p: 44. 03 grams (4. 19 grams), f: 79. 02 grams (7. 53 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1729.51 kcal, Protein: 44.03g, Carbohydrates: 204.54g, Fat: 79.02g]",
            cloudinaryImageId: "lv6jl9qdscekjmwkxm9l",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879021,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554672,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554673,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554674,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420748": {
            id: 86420748,
            name: "Veg Fried Rice",
            category: "Rice",
            description:
              "E: 1477. 00 kcal (140. 67 kcal), c: 204. 14 grams (19. 44 grams), p: 22. 90 grams (2. 18 grams), f: 59. 95 grams (5. 71 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1477 kcal, Protein: 22.9g, Carbohydrates: 204.14g, Fat: 59.95g]",
            cloudinaryImageId: "pycpbzawueci1dvhmkr3",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879023,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554678,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554679,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554680,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420772": {
            id: 86420772,
            name: "Ghee Rice",
            category: "Rice",
            description:
              "E: 1824. 40 kcal (173. 75 kcal), c: 246. 60 grams (23. 49 grams), p: 25. 93 grams (2. 47 grams), f: 78. 23 grams (7. 45 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1824.4 kcal, Protein: 25.93g, Carbohydrates: 246.6g, Fat: 78.23g]",
            cloudinaryImageId: "wm9rg7kwm8ujpcal9u2z",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879024,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554683,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554681,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554682,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420773": {
            id: 86420773,
            name: "Jeera Rice",
            category: "Rice",
            description:
              "E: 1832. 30 kcal (174. 50 kcal), c: 246. 73 grams (23. 50 grams), p: 27. 51 grams (2. 62 grams), f: 78. 15 grams (7. 44 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1832.3 kcal, Protein: 27.51g, Carbohydrates: 246.73g, Fat: 78.15g]",
            cloudinaryImageId: "xukq8swrwct8usmg4cjv",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879027,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554692,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554690,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554691,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420775": {
            id: 86420775,
            name: "Curd Rice",
            category: "Rice",
            description:
              "E: 569. 98 kcal (95. 00 kcal), c: 58. 63 grams (9. 77 grams), p: 24. 32 grams (4. 05 grams), f: 25. 64 grams (4. 27 grams) [Serving info: 1 Serve, Serving size: 600 grams, Energy: 569.98 kcal, Protein: 24.32g, Carbohydrates: 58.63g, Fat: 25.64g]",
            cloudinaryImageId: "ojyjwksfduvct4jrqglo",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879031,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554702,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554703,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554704,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "600 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86420783": {
            id: 86420783,
            name: "Paneer Pcs",
            category: "Extra",
            description: "",
            cloudinaryImageId: "y2umnx7fqzcl6vtf3mad",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879056,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554779,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554777,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554778,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86421153": {
            id: 86421153,
            name: "Kaju Masala",
            category: "Veg Curries",
            description:
              "E: 780. 95 kcal (211. 07 kcal), c: 39. 30 grams (10. 62 grams), p: 15. 53 grams (4. 20 grams), f: 62. 27 grams (16. 83 grams) [Serving info: 1 Serve, Serving size: 370 grams, Energy: 780.95 kcal, Protein: 15.53g, Carbohydrates: 39.3g, Fat: 62.27g]",
            cloudinaryImageId: "jwcsply1spuntwiy6ory",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878672,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553624,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553626,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553629,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "370 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86421277": {
            id: 86421277,
            name: "Veg Manchurian Biryani",
            category: "Veg Biriyani",
            description:
              "E: 1218. 09 kcal (116. 01 kcal), c: 176. 93 grams (16. 85 grams), p: 42. 53 grams (4. 05 grams), f: 35. 32 grams (3. 36 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1218.09 kcal, Protein: 42.53g, Carbohydrates: 176.93g, Fat: 35.32g]",
            cloudinaryImageId: "x6hqabmwan7pfwhshqhj",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878924,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554378,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554379,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554380,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86421291": {
            id: 86421291,
            name: "Prawns Ghee Roast",
            category: "Day Special",
            description:
              "E: 368. 92 kcal (122. 97 kcal), c: 13. 26 grams (4. 42 grams), p: 40. 59 grams (13. 53 grams), f: 17. 01 grams (5. 67 grams) [Serving info: 1 Serve, Serving size: 300 grams, Energy: 368.92 kcal, Protein: 40.59g, Carbohydrates: 13.26g, Fat: 17.01g]",
            cloudinaryImageId: "gbowveie1vh3zrxegqqb",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 37500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879048,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554753,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554754,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554755,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "300 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86427972": {
            id: 86427972,
            name: "Today's Chinese Spl",
            category: "Non-veg Starter",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878382,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552756,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552755,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552757,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86427973": {
            id: 86427973,
            name: "Lollipop Biryani",
            category: "Non-veg Biriyani",
            description:
              "E: 1673. 09 kcal (159. 34 kcal), c: 217. 95 grams (20. 76 grams), p: 45. 42 grams (4. 33 grams), f: 65. 98 grams (6. 28 grams) [Serving info: 1 Serve, Serving size: 1050 grams, Energy: 1673.09 kcal, Protein: 45.42g, Carbohydrates: 217.95g, Fat: 65.98g]",
            cloudinaryImageId: "tscwxqko4pabme8gj2ty",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055362,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234083,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234082,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234085,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234084,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234086,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878734,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52553813,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553812,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52553811,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "1050 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86427974": {
            id: 86427974,
            name: "Egg Bhurji",
            category: "Egg",
            description:
              "E: 693. 05 kcal (288. 77 kcal), c: 7. 51 grams (3. 13 grams), p: 16. 77 grams (6. 99 grams), f: 66. 09 grams (27. 54 grams) [Serving info: 1 Serve, Serving size: 240 grams, Energy: 693.05 kcal, Protein: 16.77g, Carbohydrates: 7.51g, Fat: 66.09g]",
            cloudinaryImageId: "vqpjju0lyjawwrbbpo8q",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879007,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554632,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554630,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554631,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "240 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86427977": {
            id: 86427977,
            name: "Smart Water",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5238,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86427983": {
            id: 86427983,
            name: "Chicken Boneless Pcs",
            category: "Extra",
            description: "",
            cloudinaryImageId: "apypbgt1qvkqjvjkkmkg",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 48055389,
                group_name: "Extra",
                choices: [
                  {
                    id: 34234142,
                    name: "Extra Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234145,
                    name: "Extra Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234144,
                    name: "Paneer Pcs",
                    price: 17000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 34234143,
                    name: "Extra Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65879060,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554790,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554791,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554789,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86427986": {
            id: 86427986,
            name: "Meghana Chicken Spl Pcs",
            category: "Extra",
            description: "",
            cloudinaryImageId: "z0nhfbn5wz2ckwqzoedm",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879061,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554793,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554794,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554792,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86432150": {
            id: 86432150,
            name: "Meghana Special Fried Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879036,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554719,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554717,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554718,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86437318": {
            id: 86437318,
            name: "Curd",
            category: "Extra",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879050,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554760,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554761,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554759,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86437321": {
            id: 86437321,
            name: "Mineral Water 1l",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1905,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86482930": {
            id: 86482930,
            name: "Paper Plates",
            category: "Extra",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879054,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554771,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554772,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554773,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86536665": {
            id: 86536665,
            name: "Egg Omelet",
            category: "Egg",
            description:
              "E: 550. 65 kcal (289. 82 kcal), c: 9. 81 grams (5. 16 grams), p: 10. 69 grams (5. 63 grams), f: 51. 98 grams (27. 36 grams) [Serving info: 1 Serve, Serving size: 190 grams, Energy: 550.65 kcal, Protein: 10.69g, Carbohydrates: 9.81g, Fat: 51.98g]",
            cloudinaryImageId: "mh6dcglihfsln9lwftgi",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 8800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65879010,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554640,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554641,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554639,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "190 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92604374": {
            id: 92604374,
            name: "Coke Tin 330 Ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6667,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94321821": {
            id: 94321821,
            name: "Thums Up Tin 330 Ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6667,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94322126": {
            id: 94322126,
            name: "Sprite Tin 330 Ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6667,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94331847": {
            id: 94331847,
            name: "Veg Manchurian",
            category: "Veg Starter",
            description:
              "E: 240. 61 kcal (104. 61 kcal), c: 18. 83 grams (8. 19 grams), p: 12. 72 grams (5. 53 grams), f: 12. 39 grams (5. 39 grams) [Serving info: 1 Serve, Serving size: 230 grams, Energy: 240.61 kcal, Protein: 12.72g, Carbohydrates: 18.83g, Fat: 12.39g]",
            cloudinaryImageId: "etnsehnoylzjgipeapde",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 65878151,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52552064,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552063,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52552062,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "230 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "95469130": {
            id: 95469130,
            name: "Non Veg Biryani Rice",
            category: "Non-veg Biriyani",
            description: "",
            cloudinaryImageId: "yiiln3ntc7cwm51l9lhi",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 54453533,
                group_name: "Extra",
                choices: [
                  {
                    id: 44726451,
                    name: "Masala Pack",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44726450,
                    name: "Gravy",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44726453,
                    name: "Raita",
                    price: 800,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44726449,
                    name: "Chicken Boneless Pcs",
                    price: 18000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44726452,
                    name: "Meghana Chicken Spl Pcs",
                    price: 18500,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 65878848,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 52554150,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554152,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 52554151,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "103801790": {
            id: 103801790,
            name: "Chicken Hyd Curry With Bone",
            category: "Non-veg Curries",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 68877773,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 54885574,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 54885573,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 54885572,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "103801791": {
            id: 103801791,
            name: "Veg Hyderabadi Curry",
            category: "Veg Curries",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 68877774,
                group_name: "Choice Of Beverage (600ml)",
                choices: [
                  {
                    id: 54885577,
                    name: "Thums Up 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 54885576,
                    name: "Sprite 600ml",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 54885575,
                    name: "Coke 600 Ml",
                    price: 3620,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "104456690": {
            id: 104456690,
            name: "Chicken Hyd Curry Boneless",
            category: "Non-veg Curries",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108286224": {
            id: 108286224,
            name: "500 Ml Water Bottle",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 955,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "229",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 86420099,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420101,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420120,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420121,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420125,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420127,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420129,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420240,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420604,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420339,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420340,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420342,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86427973,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420360,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420364,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420391,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420393,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86420398,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Starter",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420099,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420100,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420101,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420106,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420107,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420108,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420110,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420112,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420113,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420115,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420116,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420118,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94331847,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Non-veg Starter",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420120,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420121,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420123,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420125,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420127,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420128,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420129,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420130,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420131,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420132,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420135,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420136,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420139,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420140,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86427972,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420149,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420150,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Sea Food Starter",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420151,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420153,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420222,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420234,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Non-veg Curries",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420238,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420240,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420242,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420244,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420246,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420271,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420292,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420310,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 103801790,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 104456690,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Curries",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420570,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420571,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420573,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420574,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420604,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420641,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420740,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420742,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420744,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 103801791,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86421153,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Non-veg Biriyani",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420339,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420340,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420342,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86427973,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420359,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420360,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420363,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420364,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420372,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420383,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 95469130,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Biriyani",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420391,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420393,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420395,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420398,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420400,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86421277,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Indian Breads",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420401,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420403,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420404,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Egg",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420417,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86427974,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86536665,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420569,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86420745,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420747,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420748,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420772,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420773,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420775,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 14413513,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86432150,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Beverages",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86427977,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86437321,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92604374,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94321821,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94322126,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108286224,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Day Special",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86421291,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Extra",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 86437318,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86482930,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86420783,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86427983,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86427986,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "menu_merchandise",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "FREE DELIVERY",
        shortDescriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off up to ₹120 | Use FEDERALCC Above ₹249",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "FREE DELIVERY",
        shortDescriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off up to ₹120 | Use FEDERALCC Above ₹249",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 1,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: {
            link: "",
            text: "",
            type: "",
            color: "",
          },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11214334001313"],
        },
      ],
      menuTabs: [
        {
          title: "Order Now",
          type: "menu",
          selected: true,
        },
      ],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [
        {
          text: "",
          imageId: "",
          fontColor: "",
        },
      ],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: {
        isNewHealthMenu: "false",
      },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "c7e2bd6f-ef97-42fe-a7fe-1aeff0be6a91",
      timeStamp: "1677488633245",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "OMFVlqpgtKw4-TjA0t6KWkkoN8ZscQrGU0Ui1bCk",
  },
  {
    statusCode: 0,
    data: {
      experiments: [
        {
          experimentId: "menu_via_timeline",
          variantId: "true",
        },
      ],
      restaurantAttributes: [],
      id: "121603",
      name: "Kannur Food Point",
      uuid: "51983905-e698-4e31-b0d7-e376eca56320",
      slug: "kannur-food-point-btm",
      latLong: "12.9312742,77.60804910000002",
      city: "Bangalore",
      area: "Tavarekere",
      areaPostalCode: "560068",
      areaSlug: "BTM",
      restaurantSlug: {
        restaurant: "kannur-food-point-btm",
        city: "bangalore",
      },
      type: "F",
      locality: "SG Palya",
      avgRating: 3.8,
      totalRatings: 5000,
      avgRatingString: "3.8",
      totalRatingsString: "5K+ ratings",
      cloudinaryImageId: "bmwn4n4bn6n1tcpc8x2h",
      costForTwo: 30000,
      costForTwoMsg: "₹300 for two",
      cuisines: ["Kerala", "Chinese"],
      minimumOrder: 0,
      opened: 1,
      parentId: 20974,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: false,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "28 MINS",
        lastMileDistanceString: "3 kms",
        restaurantId: "121603",
        deliveryTime: 28,
        minDeliveryTime: 28,
        maxDeliveryTime: 28,
        lastMileTravel: 3,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.5769065022468567,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: {
            de: 0.3333333432674408,
          },
        },
        surge: {
          applicable: false,
          components: [
            {
              value: 0,
              type: "STRESS",
            },
          ],
        },
        zoneId: 4,
      },
      availability: {
        nextCloseTime: "2023-02-28 03:00:00",
        nextChangeTime: 1677533400000,
        visibility: true,
        opened: true,
      },
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      labels: [
        {
          title: "Timings",
          message: "null",
        },
        {
          title: "Address",
          message:
            "6/21,9TH CROSS ,1ST MAIN, VENKATESHWARA LAYOUT,SG PALYA, BENGALURU, - 560093",
        },
        {
          title: "Cuisines",
          message: "Kerala,Chinese",
        },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "32557080": {
            id: 32557080,
            name: "Poth Biryani",
            category: "Beef Items",
            description:
              "Wholesome special prepration with succulent Beef pieces make kerala style.",
            cloudinaryImageId: "n95dglulqnrj8lt6h0lh",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "3034145",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "10151335",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034145",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 7500,
                      default: 1,
                      id: "10151336",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034145",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648230,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "750 gm",
              spiceLevel: "VERYSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557081": {
            id: 32557081,
            name: "Ginger Lime(250ml)",
            category: "Lime",
            description: "serves 1",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557082": {
            id: 32557082,
            name: "Mushroom Manchurian",
            category: "Veg Chinese",
            description:
              "Crispy fried mushroom, tossed in a sweet and spicy thick Manchurian sauce along with onions and chopped garlics.",
            cloudinaryImageId: "ocxmgxmkrmyytfvojapj",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 9300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557085": {
            id: 32557085,
            name: "Strawberry Lime",
            category: "Lime",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557086": {
            id: 32557086,
            name: "Mushroom 65",
            category: "Veg Chinese",
            description:
              "Tender chicken pakodas tossed in spiced yoghurt sauce with curry leaves.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 9300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557088": {
            id: 32557088,
            name: "Pineapple Lime",
            category: "Lime",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557091": {
            id: 32557091,
            name: "Poth Curry",
            category: "Beef Items",
            description:
              "A delicious, authentic and tasty popular Kerala curry made with pieces of Beef.",
            cloudinaryImageId: "nih3hlqqjjplxz7vxgtn",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            final_price: 12500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957540",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893905",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957540",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 19000,
                      default: 1,
                      id: "9893906",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957540",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557092": {
            id: 32557092,
            name: "Paneer 65",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 9300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557093": {
            id: 32557093,
            name: "Chicken Fried Rice   ",
            category: "Chinese Items",
            description:
              "A delicious dish of cooked rice that has been stir-fried in a wok with veggies and chicken.",
            cloudinaryImageId: "oqs4ywhg5rpzsostq3wi",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            final_price: 10500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with tomato sauce",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557094": {
            id: 32557094,
            name: "Paneer Chilli [ 6 pcs ](Served with Slice Onion)",
            category: "Veg Chinese",
            description:
              "A Indo Chinese starter or appetizer made by tossing fried paneer in sweet sour and spicy chilli sauce.serves 1",
            cloudinaryImageId: "w5kkgnpfi8gexbi6hzyl",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 9300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557095": {
            id: 32557095,
            name: "Egg Fried Rice",
            category: "Chinese Items",
            description:
              "A delicious dish of cooked rice that has been stir-fried in a wok with veggies and egg.",
            cloudinaryImageId: "mrnlctkjxbq5dmbul07u",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557096": {
            id: 32557096,
            name: "Poth Roast",
            category: "Beef Items",
            description:
              "|Semigravy|A fiery Beef roast is a treat for all the spicy food lovers, this is a spice rich traditional Kerala style dish.",
            cloudinaryImageId: "qymgppyk0imcswfkofgr",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            final_price: 12300,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957541",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893907",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957541",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 19500,
                      default: 1,
                      id: "9893908",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957541",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557097": {
            id: 32557097,
            name: "Veg Fried Rice",
            category: "Chinese Items",
            description:
              "A delicious dish of cooked rice that has been stir-fried in a wok with veggies.(serves1)",
            cloudinaryImageId: "beiztoftylnkpg49csw9",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            final_price: 9000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557098": {
            id: 32557098,
            name: "Kadala Curry",
            category: "Veg Curry",
            description: "",
            cloudinaryImageId: "cucdhfjvhtdwyenzj9eu",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            final_price: 4500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557099": {
            id: 32557099,
            name: "Mushroom Fried Rice",
            category: "Chinese Items",
            description:
              "A delicious dish of cooked rice that has been stir-fried in a wok with veggies and mushroom.",
            cloudinaryImageId: "gkdhtpvyokpvlofxhrdx",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            final_price: 9800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557100": {
            id: 32557100,
            name: "Cherupayar Curry",
            category: "Veg Curry",
            description: "|Moong Dal|",
            cloudinaryImageId: "rd9qzwwtep4ouq9jqz5s",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            final_price: 4500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557101": {
            id: 32557101,
            name: "Poth Fry",
            category: "Beef Items",
            description:
              "A fiery Beef fry is a treat for all the food lovers, this is a spice rich traditional Kerala style dish.",
            cloudinaryImageId: "g0ouljeutq0onjuho5jt",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            final_price: 12300,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957542",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893909",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957542",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 19500,
                      default: 1,
                      id: "9893910",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957542",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557102": {
            id: 32557102,
            name: "Paneer Fried Rice",
            category: "Chinese Items",
            description:
              "A delicious dish of cooked rice that has been stir-fried in a wok with veggies and paneer.(serves1)",
            cloudinaryImageId: "jb4335agdeik93soltpr",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            final_price: 9800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557103": {
            id: 32557103,
            name: "Veg Korma",
            category: "Veg Curry",
            description: "",
            cloudinaryImageId: "xie2ukb1vce2g7nroyqj",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            final_price: 4500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557104": {
            id: 32557104,
            name: "Gobi Fried Rice",
            category: "Chinese Items",
            description:
              "A deicious mix of stir fried rice with cauliflower florets mixed with special Chinese sauces.(serves1)",
            cloudinaryImageId: "94a0b1585615baa02161c1c5f905e802",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            final_price: 9800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557105": {
            id: 32557105,
            name: "Poth Chilli",
            category: "Beef Items",
            description:
              "A tasty preparation with juicy Beef chunks, with bell peppers and special spices.",
            cloudinaryImageId: "lpsjfuu0xtkd77alzwfy",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957543",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half (200 gms)",
                      price: 0,
                      default: 0,
                      id: "9893911",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957543",
                      order: 999,
                    },
                    {
                      name: "Full (350 gms)",
                      price: 16500,
                      default: 1,
                      id: "9893912",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957543",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557106": {
            id: 32557106,
            name: "Green Peas Curry",
            category: "Veg Curry",
            description:
              "A delicious fresh green peas based gravy made with onion and variety of spices.",
            cloudinaryImageId: "jhxv7amlobpxr1nit7ws",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            final_price: 4500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557107": {
            id: 32557107,
            name: "Poth Pepper",
            category: "Beef Items",
            description:
              "A delicious dish made with Beef sautaed, chillies and fresh ground pepper.",
            cloudinaryImageId: "a9zgxsrvlgguxa8terco",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957544",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half [200 gms ] serves 1",
                      price: 0,
                      default: 0,
                      id: "9893913",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957544",
                      order: 999,
                    },
                    {
                      name: "Full [350 gms] serves 2",
                      price: 16500,
                      default: 1,
                      id: "9893914",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957544",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557108": {
            id: 32557108,
            name: "Chicken Noodles",
            category: "Noodles",
            description:
              "Delectable stands of soft noodles tossed with assorted chopped chicken and veggies and sauces , perfect entre to satiate your cravings",
            cloudinaryImageId: "meyyfnbukombadfwbva2",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            final_price: 10500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15648298,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with tomato sauce",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557109": {
            id: 32557109,
            name: "Poth Garlic",
            category: "Beef Items",
            description:
              "Tender pieces of meat with garlic wrapped up in a banana leaf, a delicious treat.",
            cloudinaryImageId: "i9lcwbqgsk8d10st86oe",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957545",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893915",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957545",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893916",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957545",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557110": {
            id: 32557110,
            name: "Egg Noodles",
            category: "Noodles",
            description:
              "Delicious wok-tossed noodles, tossed with fresh veggies, egg and sauces.",
            cloudinaryImageId: "fpfreziymdfmyv8cfgqz",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15649406,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557111": {
            id: 32557111,
            name: "Veg Noodles",
            category: "Noodles",
            description:
              "A deliciously hearty scrumptious stir fried noodles with mixed vegetables.",
            cloudinaryImageId: "co7vl7milbtbom5j70pc",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            final_price: 9000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15648421,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557112": {
            id: 32557112,
            name: "Poth Ginger",
            category: "Beef Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957546",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893917",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957546",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893918",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957546",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557113": {
            id: 32557113,
            name: "Mushroom Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            final_price: 6500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557114": {
            id: 32557114,
            name: "Paneer Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "001d854c49454e859a78008d5467b7cd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            final_price: 9800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15648892,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557116": {
            id: 32557116,
            name: "Gobi Noodles",
            category: "Noodles",
            description:
              "A deicious mix of boiled noodles with cauliflower florets mixed with special Chinese sauces.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            final_price: 9800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15648913,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557118": {
            id: 32557118,
            name: "Chicken Puttu Biryani",
            category: "Kfp Special",
            description:
              "Wholesome biryani prepared with succulent chicken, white rice puttu and whole spices.(serves1)",
            cloudinaryImageId: "n9jk6xswoio2oghnmjpq",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15649396,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557121": {
            id: 32557121,
            name: "Egg Biryani",
            category: "Biryani",
            description:
              "Fragrant basmati rice cooked with aromatic biryani spices, herbs & boiled eggs.",
            cloudinaryImageId: "hldpw4jywyw5nytet3x2",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            final_price: 10500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15649379,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557122": {
            id: 32557122,
            name: "Thalassery Chicken Biriyani",
            category: "Biryani",
            description:
              "Long grain basmati rice flavored with fragrant spices, saffron and topped with caramalised onion",
            cloudinaryImageId: "dvfempk88bepceby8laz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "23275299",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "75817001",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23275299",
                      order: 0,
                    },
                    {
                      name: "Full",
                      price: 7000,
                      default: 0,
                      id: "75817002",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23275299",
                      order: 0,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648390,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "750 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Raita",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557124": {
            id: 32557124,
            name: "Ghee Rice",
            category: "Biryani",
            description:
              "A one pot rice dish made with desi ghee, rice, spices & nuts",
            cloudinaryImageId: "ky69vpv8au7fa0bxcfze",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            final_price: 7800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "Served with Raita",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557125": {
            id: 32557125,
            name: "Chicken Kothu Parotta",
            category: "Kfp Special",
            description:
              "A dish prepared with paratto to golden brown and stirred with gravy and chicken",
            cloudinaryImageId: "vfgx1kmuo916i0gquzle",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "750 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with onion",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557127": {
            id: 32557127,
            name: "Egg Bhurji",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "bmzir4apsxbjphvlfjzl",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            final_price: 4500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557131": {
            id: 32557131,
            name: "Chicken Kappa Mix",
            category: "Kfp Special",
            description:
              "A special biryani made with Beef pieces, a delicious and yummy treat.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            final_price: 10000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15649435,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557132": {
            id: 32557132,
            name: "Egg Roast",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "tbui18exivkct8k0cqr4",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            final_price: 4500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557134": {
            id: 32557134,
            name: "Egg Curry",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "tw3km63siuxxck7iaxan",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            final_price: 4300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "Served with onion",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557136": {
            id: 32557136,
            name: "Egg Chilli",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "tv2c0jlevajvlmx6gito",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            final_price: 7000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557138": {
            id: 32557138,
            name: "Chilli Chicken",
            category: "Chicken Items",
            description:
              "|Semigravy|Crispy marinated chicken is sauteed in a spicy sweet sauce along with onions and bell peppers.",
            cloudinaryImageId: "x8shbjz2uptworqyumr4",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957547",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893919",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957547",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893920",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957547",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648280,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557140": {
            id: 32557140,
            name: "Chicken Manchurian",
            category: "Chicken Items",
            description:
              "|Semigravy|A popular Indo-Chinese dish where crispy chicken chunks are tossed in a manchurian sauce.",
            cloudinaryImageId: "whwqvi3vursrlwpar9cr",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957548",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893921",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957548",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893922",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957548",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15649387,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557143": {
            id: 32557143,
            name: "Pepper Chicken",
            category: "Chicken Items",
            description:
              "Spicy dish where chicken and chopped onion are stir-fried in aromatic spices freshly grounded black pepper.",
            cloudinaryImageId: "dz542yhayc3pejherjix",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957549",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893923",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957549",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893924",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957549",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648416,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557146": {
            id: 32557146,
            name: "Salt Soda",
            category: "Soda",
            description:
              "A refreshing drink made with lemon, salt and soda water.",
            cloudinaryImageId: "iu5guz0mh3fv3bcevbm8",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557147": {
            id: 32557147,
            name: "Chicken 65 Dry ",
            category: "Chicken Items",
            description:
              "Deep-fried chicken that is marinated in ginger, lemon, red chiles, and a variety of other spices and tossed a chef special tangy and spicy sauce.",
            cloudinaryImageId: "fz0pfxx0ffsm6bt5pjev",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957551",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half [ 4 pcs ] serves 1",
                      price: 0,
                      default: 0,
                      id: "9893927",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957551",
                      order: 999,
                    },
                    {
                      name: "Full [8 pcs] serves 2",
                      price: 16500,
                      default: 1,
                      id: "9893928",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957551",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557148": {
            id: 32557148,
            name: "Sweet Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557149": {
            id: 32557149,
            name: "Pepper Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557150": {
            id: 32557150,
            name: "Garlic Chicken",
            category: "Chicken Items",
            description:
              "Succulent chunks of chicken coated in a sticky base of flavours it is all subtle, yet finely balanced with a lot of garlic.",
            cloudinaryImageId: "mcodpwvsmoaewrxnvzkv",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957552",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half(4pcs)",
                      price: 0,
                      default: 0,
                      id: "9893929",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957552",
                      order: 999,
                    },
                    {
                      name: "Full(8 pcs)",
                      price: 16500,
                      default: 1,
                      id: "9893930",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957552",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557151": {
            id: 32557151,
            name: "Masala Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557152": {
            id: 32557152,
            name: "Sweet & Salt Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557153": {
            id: 32557153,
            name: "Ginger Chicken",
            category: "Chicken Items",
            description:
              "Succulent chunks of chicken coated in a sticky base of flavours it is all subtle, yet finely balanced with a lot of ginger.",
            cloudinaryImageId: "gsxnbqsj5j3zsdnkntig",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957553",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893931",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957553",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893932",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957553",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557155": {
            id: 32557155,
            name: "Lemon Chicken",
            category: "Chicken Items",
            description:
              "Crispy fried chicken fillet marinated in spicy lemon sauce, tossed with fresh and cruncy capsicum and onion cubes.",
            cloudinaryImageId: "v8g0xftakmb3mf5gdn3f",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957554",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893933",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957554",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893934",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957554",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557158": {
            id: 32557158,
            name: "Chicken Korma",
            category: "Chicken Kannur",
            description:
              "A rich and creamy dish, in a super creamy cashew based gravy with tender chicken.",
            cloudinaryImageId: "g1ghunjt8h2u9pjssr7x",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957555",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half(3pcs)",
                      price: 0,
                      default: 0,
                      id: "9893935",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957555",
                      order: 999,
                    },
                    {
                      name: "Full(6pcs)",
                      price: 16500,
                      default: 1,
                      id: "9893936",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957555",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557161": {
            id: 32557161,
            name: "Chicken Kannur",
            category: "Chicken Kannur",
            description:
              "|Semigravy|A delicious treat of chicken made with home made special spice mix, a special at kannur food point.",
            cloudinaryImageId: "r1xjy1hqgiiqqdmktzdy",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957556",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893937",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957556",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893938",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957556",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557163": {
            id: 32557163,
            name: "Chicken Curry",
            category: "Chicken Kannur",
            description:
              "A typical and simple curry consists of chicken stewed in an onion and tomato based gravy.",
            cloudinaryImageId: "o3bjpmvlsxie3bho8dpd",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957557",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893939",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957557",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893940",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957557",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557170": {
            id: 32557170,
            name: "Chicken Masala",
            category: "Chicken Kannur",
            description:
              "Amazingly tasty chicken curry masala cooked with whole spices, onion, ginger, garlic based brown gravy.",
            cloudinaryImageId: "aincytx7lpqpnmmtv4ff",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957559",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893943",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957559",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893944",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957559",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557173": {
            id: 32557173,
            name: "Strawberry Lassi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            final_price: 3800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557174": {
            id: 32557174,
            name: "Mango Lassi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            final_price: 3800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557177": {
            id: 32557177,
            name: "Chicken Fry",
            category: "Chicken Kannur",
            description:
              "Chicken will be fried with the combination of onion, curry leaves, chillies, ginger garlic paste and andhra special gharam masala.",
            cloudinaryImageId: "nutsnvht8zc2dbxaurjp",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2957563",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9893951",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957563",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "9893952",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2957563",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648428,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557178": {
            id: 32557178,
            name: "Puttu (1 Pc)",
            category: "All Day Breakfast",
            description:
              "Made of steamed cylinders of ground rice layered with coconut shavings, sometimes with a sweet or savory filling on the inside.",
            cloudinaryImageId: "k0qxcnxz1iqgeoim7lud",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            final_price: 3000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557179": {
            id: 32557179,
            name: "Ney Pathiri",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "b58hjmbpdw7hgdaqezin",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2700,
            final_price: 1400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557181": {
            id: 32557181,
            name: "Idiyappam (1 Pc)",
            category: "All Day Breakfast",
            description:
              "A traditional Kerala food consisting of rice flour pressed into noodle form and then steamed.",
            cloudinaryImageId: "amrh5vuubfct9qvpaf0c",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2700,
            final_price: 1400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557183": {
            id: 32557183,
            name: "Chapati (1 Pc)",
            category: "All Day Breakfast",
            description:
              "A round flat unleavened bread of India that is usually made of whole wheat flour and cooked on a griddle.",
            cloudinaryImageId: "w9ve4a5segfjivxgr6we",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2700,
            final_price: 1400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557185": {
            id: 32557185,
            name: "Gobi 65",
            category: "Veg Chinese",
            description:
              "Wok tossed cubes of deep fried cauliflower, coated with tangy and spicy chilli sauce.",
            cloudinaryImageId: "djm2nb5eyahlejxlfzpr",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            final_price: 9000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32557186": {
            id: 32557186,
            name: "Gobi Chilli",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            final_price: 9000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672443": {
            id: 32672443,
            name: "Papaya Milkshake",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "pyv29i8dizl1elvzrb3t",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672445": {
            id: 32672445,
            name: "Mango Milkshake",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "jvq7rps22bqqty7tpppb",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672446": {
            id: 32672446,
            name: "Apple Milkshake(250ml)",
            category: "Milkshakes",
            description: "(serves1)",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672447": {
            id: 32672447,
            name: "Oreo Milkshake",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "xxhzgn1x8ippluq0tvoq",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672448": {
            id: 32672448,
            name: "Strawberry Milkshake",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "vra0y44igubesgyiux2b",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672449": {
            id: 32672449,
            name: "Anar Milkshakes",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672450": {
            id: 32672450,
            name: "Kiwi Milkshake",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32672452": {
            id: 32672452,
            name: "Mint Soda(250ml)",
            category: "Soda",
            description: "serves 1",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217237": {
            id: 33217237,
            name: "Mosambi Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217238": {
            id: 33217238,
            name: "Pineapple Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217240": {
            id: 33217240,
            name: "Orange Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217241": {
            id: 33217241,
            name: "Poth Fried Rice",
            category: "Chinese Items",
            description:
              "A delicious dish made with Beef sautaed with rice and veggies tossed in special sauces",
            cloudinaryImageId: "rjvk4jkyfwbbfquzjl3d",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            final_price: 10500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with tomato sauce",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217243": {
            id: 33217243,
            name: "Apple Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217244": {
            id: 33217244,
            name: "Papaya Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217245": {
            id: 33217245,
            name: "Musk Melon Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217246": {
            id: 33217246,
            name: "Water Melon Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "ivb684f2cj4tsglnqfcs",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217247": {
            id: 33217247,
            name: "Anar Fresh Juice(250ml)",
            category: "Fresh Juice",
            description: "serves 1",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217248": {
            id: 33217248,
            name: "Sweet Lassi(250ml)",
            category: "Lassi",
            description: "serves 1",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            final_price: 3000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217249": {
            id: 33217249,
            name: "Chicken Roast Dry",
            category: "Chicken Kannur",
            description:
              "Marinated and parboiled tender chicken sauteed in oil seasoned with hand pound masala and spices.",
            cloudinaryImageId: "w4vfrknwzvbey1e8qajy",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "3034141",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half [ 3 pcs ] serves 1",
                      price: 0,
                      default: 0,
                      id: "10151327",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034141",
                      order: 999,
                    },
                    {
                      name: "Full [ 6 pcs ] serves 2",
                      price: 16500,
                      default: 1,
                      id: "10151328",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034141",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648412,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217250": {
            id: 33217250,
            name: "Salt Lassi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            final_price: 3000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217251": {
            id: 33217251,
            name: "Chicken Roast Gravy",
            category: "Chicken Kannur",
            description:
              "Marinated and parboiled tender chicken sauteed in oil seasoned with hand pound masala and spices.",
            cloudinaryImageId: "izojro3dbiuhqmesvgta",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "3034142",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "10151329",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034142",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "10151330",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034142",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217252": {
            id: 33217252,
            name: "Pothu Noodles",
            category: "Noodles",
            description:
              "A flavor-packed dish with noodles and juicy Buff pieces tossed in a soy, celery, chilli and vinegar based sauce.",
            cloudinaryImageId: "fiquq89xkveznpurin6b",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            final_price: 10500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15648406,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217255": {
            id: 33217255,
            name: "Fresh Lime(250ml)",
            category: "Lime",
            description:
              "A refreshing drink made with fresh lime and water.(serves1)",
            cloudinaryImageId: "bdyuo9kpcvaiiyviktbw",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217256": {
            id: 33217256,
            name: "Egg Pepper",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            final_price: 7000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15648904,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217257": {
            id: 33217257,
            name: "Egg Manchurian",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            final_price: 7000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217258": {
            id: 33217258,
            name: "Egg 65",
            category: "Egg Items",
            description:
              "A tangy and spicy taste gives a great kick of flavours and goes perfectly as a starter.",
            cloudinaryImageId: "wryzit1bxyakmtidigjy",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            final_price: 7000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217259": {
            id: 33217259,
            name: "Egg Garlic",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            final_price: 7000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217261": {
            id: 33217261,
            name: "Muskmelon Milkshakes",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9800,
            final_price: 4900,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217263": {
            id: 33217263,
            name: "Poth Kappa Mix",
            category: "Beef Items",
            description:
              "A flavor-packed combo of perfectly cooked kappa (tapioca) mixed with tasty Beef curry for an authentic Kerala experience",
            cloudinaryImageId: "mzgtf4awwqytkmx8v735",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            final_price: 10000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            addons: [
              {
                group_id: 15649414,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "750 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with onion",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217265": {
            id: 33217265,
            name: "Poth Ney Pathiri Mix",
            category: "Beef Items",
            description:
              "Beef roast served with deep fried roties, a delicious and yummy treat.",
            cloudinaryImageId: "7e8eaa1026563ad520f0c9019beb489d",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217266": {
            id: 33217266,
            name: "Poth Dry Fry",
            category: "Beef Items",
            description:
              "A fiery Beef fry is a treat for all the food lovers, this is a spice rich traditional Kerala style dish.",
            cloudinaryImageId: "duf1argx41tnxismry7n",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            final_price: 12300,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "3034146",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "10151337",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034146",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 19500,
                      default: 1,
                      id: "10151338",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3034146",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648254,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217273": {
            id: 33217273,
            name: "Chicken Ney Pathiri",
            category: "Kfp Special",
            description: "",
            cloudinaryImageId: "2199c4c35a95b33b19f23661a69b7b4d",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217274": {
            id: 33217274,
            name: "Onion Dosa",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217278": {
            id: 33217278,
            name: "Egg Kothu Parotta",
            category: "Kfp Special",
            description:
              "A mouthwatering dish prepared with porotta fried to golden brown and stir with fried eggs and spicy sauces with gravy.",
            cloudinaryImageId: "knl17ptvaerenh4wopic",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            final_price: 10000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217282": {
            id: 33217282,
            name: "Chicken Kanthari",
            category: "Kfp Special",
            description:
              "|Semigravy|A delicious chicken curry gets its unique flavour and heat from fresh bird eye chillies.",
            cloudinaryImageId: "jfigu476p0knue53gmwz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "11368282",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half(3pcs)",
                      price: 0,
                      default: 1,
                      id: "37400726",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11368282",
                      order: 999,
                    },
                    {
                      name: "Full(6pcs)",
                      price: 16500,
                      default: 0,
                      id: "37400727",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11368282",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217286": {
            id: 33217286,
            name: "Chicken Biryani ",
            category: "Kfp Special",
            description:
              "A tasty preparation with juicy chicken chunks, fragranced rice, and homemade spices- perfect to fulfill your hunger pangs.",
            cloudinaryImageId: "lkxhpthgqnuq1dcah1ub",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "15948192",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "53069982",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "15948192",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 7000,
                      default: 0,
                      id: "53069983",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "15948192",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 15648395,
                group_name: "Addons",
                choices: [
                  {
                    id: 15663535,
                    name: "Papaya Milkshake",
                    price: 5500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663533,
                    name: "Apple Milkshake",
                    price: 6500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663534,
                    name: "Sweet Lassi",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663531,
                    name: "Pineapple Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 15663532,
                    name: "Orange Fresh Juice",
                    price: 4500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "500 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with pickle",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33217289": {
            id: 33217289,
            name: "Gobi Manchurian",
            category: "Veg Chinese",
            description:
              "Crispy fried cauliflower florets, tossed in a sweet and spicy thick Manchurian sauce along with onions and chopped garlics",
            cloudinaryImageId: "wyerqjojrmz6fyrreoyq",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            final_price: 9000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "Served with onion",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "43656770": {
            id: 43656770,
            name: "Thalassery Chicken Biryani ",
            category: "All Day Breakfast",
            description:
              "Kerala style special chicken biryani, aromatic rice with aromatic spices. A delicious treat.",
            cloudinaryImageId: "qljw2bxbtcmbzogrck9f",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "23270700",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "75806587",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23270700",
                      order: 0,
                    },
                    {
                      name: "Full",
                      price: 7000,
                      default: 1,
                      id: "75806588",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23270700",
                      order: 0,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "750 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Raita",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64281909": {
            id: 64281909,
            name: "Mushroom Chilly [ 280 gms ]",
            category: "Chinese Items",
            description: "serves 1",
            cloudinaryImageId: "umhjkaznrsyw0x4zd7ov",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611224": {
            id: 65611224,
            name: "Butter chicken",
            category: "Chicken Items",
            description:
              "|Semigravy|Rich & creamy, mildly sweet chicken curry made with onions, fresh tomato puree, spices, cream and butter.",
            cloudinaryImageId: "urpzfgarxgnnq5cymj39",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9226297",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "30505630",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226297",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "30505631",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226297",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "400 ml",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611225": {
            id: 65611225,
            name: "Kadai chicken",
            category: "Chicken Items",
            description:
              "Succulent tender chicken cooked in a deliciously flavorful freshly pounded kadai masala.",
            cloudinaryImageId: "radjtcdzxcpj8s2lvcrx",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9226298",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "30505632",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226298",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "30505633",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226298",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611226": {
            id: 65611226,
            name: "Chicken do Pyaza",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "yfcfewkdgvezlz3lknzb",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9226299",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "30505634",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226299",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "30505635",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226299",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611227": {
            id: 65611227,
            name: "Chicken Kholapuri",
            category: "Chicken Items",
            description:
              "Minced chicken pieces are fried and cooked with kolhapuri style spicy gravy.",
            cloudinaryImageId: "k9aocsygripbw9mj6yl8",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9226300",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "30505636",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226300",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "30505637",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226300",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611228": {
            id: 65611228,
            name: "Punjabi Chicken",
            category: "Chicken Items",
            description:
              "Amazingly tasty chicken curry masala cooked with whole spices, onion, ginger, garlic based brown gravy.",
            cloudinaryImageId: "pw4xty2ffdwnswzqjuoq",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9226301",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "30505638",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226301",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "30505639",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226301",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611229": {
            id: 65611229,
            name: "Hyderabadi Chicken",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "etgw7bbyhzlpbt7df8ts",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9226302",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "30505640",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226302",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 1,
                      id: "30505641",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9226302",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611230": {
            id: 65611230,
            name: "Egg Masala",
            category: "Kfp Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            final_price: 7300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611231": {
            id: 65611231,
            name: "Paneer Butter Masala",
            category: "Kfp Special",
            description:
              "A popular paneer delight, creamy and indulgent dish cooked in a onion tomato gravy.(serves1)",
            cloudinaryImageId: "jodq0fyqrf056qpz7ope",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611232": {
            id: 65611232,
            name: "Paneer Kadai",
            category: "Kfp Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611234": {
            id: 65611234,
            name: "Mushroom Masala",
            category: "Kfp Special",
            description: "",
            cloudinaryImageId: "ylte3oargq68dakzu3ql",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "65611235": {
            id: 65611235,
            name: "Paneer Kolapuri",
            category: "Kfp Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75328239": {
            id: 75328239,
            name: "Mashroom Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            final_price: 9800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75329216": {
            id: 75329216,
            name: "Paneer Garlic ",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 9300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75329708": {
            id: 75329708,
            name: "Tender Coconut Shake(250ml)",
            category: "Milkshakes",
            description: "serves 1",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            final_price: 5800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75329709": {
            id: 75329709,
            name: "Chiken Malabar",
            category: "Chicken Kannur",
            description: "",
            cloudinaryImageId: "ai69bfoi5pdgckxuy3t2",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "11368280",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "37400722",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11368280",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16500,
                      default: 0,
                      id: "37400723",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11368280",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76868519": {
            id: 76868519,
            name: "Chicken Mandi Biryani (quarter)",
            category: "Mandi",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "vyfuqkjqxuvpxuhdxcji",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34500,
            final_price: 17300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "750 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76899632": {
            id: 76899632,
            name: "Poth Mandi Biryani (quarter)",
            category: "Mandi",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "n7c50uvdit6vxcy2p37n",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "750 gm",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76899638": {
            id: 76899638,
            name: "Poth Mandi Biryani (half)",
            category: "Mandi",
            description:
              "Arabian special dish\nkannur food point special(serves2)",
            cloudinaryImageId: "ogts9hgtkbgtjvusvnej",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 69000,
            final_price: 34500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76899639": {
            id: 76899639,
            name: "Poth Mandi Biriyani.(full)",
            category: "Mandi",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "dirrtyulml0bvvln17k4",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 139000,
            final_price: 69500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76899642": {
            id: 76899642,
            name: "Chicken Mandi Biryani (half)",
            category: "Mandi",
            description: "Kannur food point special(serves2)",
            cloudinaryImageId: "kj8qnslucegyo6ckmydd",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 67000,
            final_price: 33500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76899645": {
            id: 76899645,
            name: "Chicken Mandi Biryani (full)",
            category: "Mandi",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "sg1rrkqrllwatvtzku3r",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 137000,
            final_price: 68500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "77011005": {
            id: 77011005,
            name: "Poth Kondatam ",
            category: "Kfp Special",
            description: "Kannur food point special",
            cloudinaryImageId: "ag7gzw8bphhzu1rzni60",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "15921296",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "52993394",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "15921296",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16000,
                      default: 0,
                      id: "52993395",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "15921296",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "86192753": {
            id: 86192753,
            name: "Rumali Roti (1piece)",
            category: "All Day Breakfast",
            description:
              "an exotic thin Indian flatbread recipe made with plain flour or maida atta.",
            cloudinaryImageId: "b6a512ff5d50bf307877960b26bb6ed8",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            final_price: 1500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "93783989": {
            id: 93783989,
            name: "Grill Chicken ",
            category: "Bbq & Grill",
            description: "",
            cloudinaryImageId: "d557f2b516e5a5479635f5233641c692",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "16028828",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "53277464",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16028828",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 21000,
                      default: 0,
                      id: "53277465",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16028828",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 58000,
                      default: 0,
                      id: "53277466",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16028828",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "93840421": {
            id: 93840421,
            name: "Egg Kholapuri (serves 2egg)",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "mhj2zc4zmcbnttuhkcxy",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            final_price: 7300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "93840423": {
            id: 93840423,
            name: "Egg Kadai.   (2egg)",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "d2fp6duef5grb1npxhwa",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            final_price: 7300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "93903270": {
            id: 93903270,
            name: "Paneer Hyderabadi",
            category: "Kfp Special",
            description: "",
            cloudinaryImageId: "inkxr3glerneiee94udw",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "95679970": {
            id: 95679970,
            name: "Puttu  ",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6500,
            final_price: 3300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "96206915": {
            id: 96206915,
            name: "Parotta ",
            category: "All Day Breakfast",
            description: "Parotta",
            cloudinaryImageId: "d85269711659710e7c35f4d0904d5006",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            final_price: 1500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "96214047": {
            id: 96214047,
            name: "Appam               ",
            category: "All Day Breakfast",
            description:
              "A type of pancake, originating from South India, made with fermented rice batter and coconut milk",
            cloudinaryImageId: "7cf4ec8af90d9c1b8d5f2792807bc8e7",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2700,
            final_price: 1400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "96219881": {
            id: 96219881,
            name: "Plain Dosa",
            category: "All Day Breakfast",
            description: "Plain dosa.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            final_price: 3800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "96219882": {
            id: 96219882,
            name: "Onion Dosa    ",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            final_price: 3800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "96219884": {
            id: 96219884,
            name: "Dosa Egg",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "96318144": {
            id: 96318144,
            name: "Alfaham Chicken ",
            category: "Bbq & Grill",
            description:
              "Succulentlty marinated, slow roasted on a grill. A delicacy at KFP",
            cloudinaryImageId: "sxhf9umcdcafp3j9mvhu",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23000,
            final_price: 11500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "17164282",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Hhaf",
                      price: 20000,
                      default: 1,
                      id: "57507308",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "17164282",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 59000,
                      default: 0,
                      id: "57507309",
                      inStock: 0,
                      isVeg: 0,
                      variant_group_id: "17164282",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97535129": {
            id: 97535129,
            name: "Dosa Plain",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7300,
            final_price: 3700,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97535579": {
            id: 97535579,
            name: "Dosa Set",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7300,
            final_price: 3700,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97535719": {
            id: 97535719,
            name: "Gobi  Fried Rice",
            category: "Chinese Items",
            description: "",
            cloudinaryImageId: "0d9931bb7158e75ad30b1ae292ec27cf",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 9300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97675845": {
            id: 97675845,
            name: "Tender Coconut Pudding ",
            category: "Pudding",
            description:
              "Like a soft piece of heaven, melting in your mouth, a delicacy at KFP",
            cloudinaryImageId: "pexmyswkttvoqpbyikan",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            final_price: 7300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97893831": {
            id: 97893831,
            name: "Poth Mandi Biriyani (half)",
            category: "Mandi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 61000,
            final_price: 30500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98156443": {
            id: 98156443,
            name: "Chicken Fried Rice",
            category: "Chinese Items",
            description:
              "Wholesome stir-fried rice topped with juicy chicken chunks and grated vegetables.",
            cloudinaryImageId: "2688d6c36dde72adb86039a7e5e477da",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20800,
            final_price: 10400,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98821733": {
            id: 98821733,
            name: "Chicken Kappa Biriyani",
            category: "Kfp Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98821737": {
            id: 98821737,
            name: "Pothu Kondatam",
            category: "Beef Items",
            description: "",
            cloudinaryImageId: "a5cbbd0759f4f9da768c8d1fb4ed0b77",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            final_price: 12300,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "18443790",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "61912168",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "18443790",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 19500,
                      default: 0,
                      id: "61912169",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "18443790",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98821738": {
            id: 98821738,
            name: "Kothu Parotta Pothu",
            category: "Beef Items",
            description: "",
            cloudinaryImageId: "02d01cb61651cc6b3f0b9e20bc39723e",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98821739": {
            id: 98821739,
            name: "Kappa Mix Pothu",
            category: "Beef Items",
            description: "",
            cloudinaryImageId: "9d17158e0a2f457893d0f22cce413a1a",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98821740": {
            id: 98821740,
            name: "Kothu Parotta Chicken",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "0fa1a8f5173f62255dff175ea5c4846b",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98821741": {
            id: 98821741,
            name: "Kappa Mix Chicken",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21600,
            final_price: 10800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98821757": {
            id: 98821757,
            name: "Alfaham ",
            category: "Bbq & Grill",
            description: "",
            cloudinaryImageId: "wgj1kerqiofccmaqnhdl",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "18443797",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "61912209",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "18443797",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 20000,
                      default: 0,
                      id: "61912211",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "18443797",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 58000,
                      default: 0,
                      id: "61912214",
                      inStock: 0,
                      isVeg: 0,
                      variant_group_id: "18443797",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "99157862": {
            id: 99157862,
            name: "Apple Pudding",
            category: "Pudding",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "99157864": {
            id: 99157864,
            name: "Mango Lessi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "99157865": {
            id: 99157865,
            name: "Strawberry Lessi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            final_price: 2800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102580564": {
            id: 102580564,
            name: "Chicken Kanthari             ",
            category: "Chicken Kannur",
            description: "",
            cloudinaryImageId: "83b54472d2b89ac3ac2c6279dfb6a861",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "21163121",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "69832592",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21163121",
                      order: 0,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "69832593",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21163121",
                      order: 0,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102638890": {
            id: 102638890,
            name: " Chikku Milkshake",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            final_price: 5000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102638891": {
            id: 102638891,
            name: "Anar Milkshake ",
            category: "Milkshakes",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            final_price: 5000,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102639296": {
            id: 102639296,
            name: "Pineapple Fresh Juice ",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            final_price: 3800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102639297": {
            id: 102639297,
            name: "Muskmelon Fresh Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            final_price: 3800,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105474855": {
            id: 105474855,
            name: "Poth Mandi Biryani (Quarter)      ",
            category: "FIFA Specials",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "750 gm",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105474856": {
            id: 105474856,
            name: "Chicken Mandi Biryani (Quarter)      ",
            category: "FIFA Specials",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34500,
            final_price: 17300,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "750 gm",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105474857": {
            id: 105474857,
            name: "Poth Mandi Biriyani.(Full)      ",
            category: "FIFA Specials",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 139000,
            final_price: 69500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105474858": {
            id: 105474858,
            name: "Chicken Mandi Biryani (Half)      ",
            category: "FIFA Specials",
            description: "Kannur food point special(serves2)",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 67000,
            final_price: 33500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105474859": {
            id: 105474859,
            name: "Poth Mandi Biryani (Half)      ",
            category: "FIFA Specials",
            description:
              "Arabian special dish\nkannur food point special(serves2)",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 69000,
            final_price: 34500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105474860": {
            id: 105474860,
            name: "Chicken Mandi Biryani (Full)      ",
            category: "FIFA Specials",
            description: "Arabian special dish\nkannur food point special",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 137000,
            final_price: 68500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105474861": {
            id: 105474861,
            name: "Poth Mandi Biriyani (Half)      ",
            category: "FIFA Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 61000,
            final_price: 30500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110863197": {
            id: 110863197,
            name: "Paneer Pepper",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "121603",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 32557185,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557082,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557094,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33217289,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 93903270,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611231,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611234,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 77011005,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 93783989,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 76899639,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 76899638,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 76899645,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98156443,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64281909,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557095,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557097,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557099,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33217241,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557104,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557093,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 97535719,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557110,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557111,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557114,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33217252,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 93840421,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557127,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557134,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 93840423,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557136,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557143,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557147,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557153,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557155,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611224,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611225,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611226,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611227,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611228,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 65611229,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 96206915,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 86192753,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 43656770,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 96214047,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557098,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557100,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557106,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557103,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102580564,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557158,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557161,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557163,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33217249,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 75329709,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557080,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557091,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557107,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32557109,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33217266,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98821737,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33217246,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33217255,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32672443,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32672445,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32672447,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32672448,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Chinese",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 110863197,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75329216,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557185,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557186,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557082,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557086,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557094,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557092,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217289,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Kfp Special",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 93903270,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611230,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611231,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611232,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611235,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611234,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 77011005,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217282,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217286,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557118,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557125,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217278,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557131,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217273,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98821733,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Pudding",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 99157862,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97675845,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "FIFA Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 105474855,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 105474856,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 105474857,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 105474859,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 105474858,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 105474861,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 105474860,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Bbq & Grill",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 93783989,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 96318144,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98821757,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Mandi",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 76868519,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76899639,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76899642,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76899638,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76899645,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76899632,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97893831,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Chinese Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 98156443,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64281909,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557095,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557097,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557099,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557102,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217241,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557104,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557093,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97535719,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75328239,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557108,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557110,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557111,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557114,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557116,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217252,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557113,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Biryani",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 32557121,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557122,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557124,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Egg Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 93840421,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557127,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557134,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217256,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217257,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217258,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217259,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 93840423,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557136,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557132,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Chicken Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 32557138,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557140,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557143,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557147,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557150,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557153,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557155,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611224,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611225,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611226,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611227,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611228,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 65611229,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98821741,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98821740,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "All Day Breakfast",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 96206915,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557183,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 86192753,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 43656770,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 96214047,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557181,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557178,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557179,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 96219884,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 96219881,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 96219882,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97535579,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217274,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 95679970,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97535129,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Curry",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 32557098,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557100,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557106,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557103,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Chicken Kannur",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102580564,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557158,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557161,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557163,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217249,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557170,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557177,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217251,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75329709,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Beef Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 32557080,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557091,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557105,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557107,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557109,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557112,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557096,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557101,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217266,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98821737,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98821738,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217265,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217263,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98821739,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fresh Juice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102639297,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102639296,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217244,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217246,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217237,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217240,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217238,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217243,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217245,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217247,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Lassi",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 33217248,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217250,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557173,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 99157865,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 99157864,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557174,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Soda",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 32557146,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557148,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557149,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557151,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32672452,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557152,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Lime",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 33217255,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557081,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557085,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32557088,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Milkshakes",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 32672443,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32672445,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32672446,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32672447,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32672448,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32672450,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75329708,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32672449,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33217261,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102638891,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102638890,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "normal",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "50% off",
        shortDescriptionList: [
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "FLAT 50% OFF",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["3936f7de-47a7-4d3d-8043-a2fa7e1fa026"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "NO CODE REQUIRED",
          description: "",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "50% off",
        shortDescriptionList: [
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 2,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: {
            link: "",
            text: "",
            type: "",
            color: "",
          },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11221334001649"],
        },
      ],
      menuTabs: [
        {
          title: "Order Now",
          type: "menu",
          selected: true,
        },
      ],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: {
        isNewHealthMenu: "false",
      },
      cafe: false,
      select: false,
      preorderable: false,
      slotInvalid: false,
      requestId: "b607a19a-147f-4b18-b05a-9edad6695318",
      timeStamp: "1677488772875",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "wrpLa8evp9TL-1H7J5qLBrPKe77QTQkn93UAkks0",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "492159",
      name: "Roti Wala",
      uuid: "ada41f9b-cca3-4197-805c-8c43798919e9",
      slug: "new-roti-wala-koramangala-koramangala",
      latLong: "12.9378085,77.6176803",
      city: "Bangalore",
      area: "Koramangala",
      areaPostalCode: "560034",
      areaSlug: "koramangala",
      restaurantSlug: {
        restaurant: "new-roti-wala-koramangala-koramangala",
        city: "bangalore",
      },
      type: "F",
      locality: "5th Block",
      avgRating: 4.2,
      totalRatings: 100,
      avgRatingString: "4.2",
      totalRatingsString: "100+ ratings",
      cloudinaryImageId: "51f52730c0a08dc89dca3df021370477",
      costForTwo: 20000,
      costForTwoMsg: "₹200 for two",
      cuisines: ["Home Food", "North Indian"],
      minimumOrder: 0,
      opened: 1,
      parentId: 171678,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "31 MINS",
        lastMileDistanceString: "1 kms",
        restaurantId: "492159",
        deliveryTime: 31,
        minDeliveryTime: 31,
        maxDeliveryTime: 31,
        lastMileTravel: 1,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.784564197063446,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 1,
      },
      availability: {
        nextCloseTime: "2023-02-27 16:15:00",
        nextChangeTime: 1677494700000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "No 18 ,MIG, KHB Colony, 5th Block, Koramangala, Bengaluru, Karnataka 560095, India",
        },
        { title: "Cuisines", message: "Home Food,North Indian" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "85349639": {
            id: 85349639,
            name: "Veg Meal",
            category: "Veg Meals",
            description: "Rice+2Tawa Roti Dal+Veg Curry+Salad+Pickle+Sweet.",
            cloudinaryImageId: "14f3c8c57fc51a22c60250894c048c29",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075969,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349640": {
            id: 85349640,
            name: "Paneer Meal",
            category: "Veg Meals",
            description: "Rice+2Tawaroti+Dal+Paneer Masala+Sweet+Salad+Pickle.",
            cloudinaryImageId: "282346f02f29e7031565182375ea8018",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075970,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349641": {
            id: 85349641,
            name: "Chole Masala Meal",
            category: "Veg Meals",
            description: "Rice+2Tawaroti+Dal+Chole Masala+Sweet+Salad+Pickle.",
            cloudinaryImageId: "ec8bb7b2fe8661a21dc9f1bcef1b16ef",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075971,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349642": {
            id: 85349642,
            name: "Mushroom Meal",
            category: "Veg Meals",
            description: "Rice+2Tawaroti+Dal+Mushroom Masala+Sweet+Salad.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075972,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349643": {
            id: 85349643,
            name: "Rajma Meal",
            category: "Veg Meals",
            description: "Rice+2Roti+Rajma Masala+Dal+Sweet+Salad+Pickle.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075973,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349644": {
            id: 85349644,
            name: "Special Veg Meal",
            category: "Veg Meals",
            description:
              "Ghee Rice+Veg Curry+Chole Masala+Dal+3Phulka+Sweet+Pickle.",
            cloudinaryImageId: "nhqplegk41n2jooxk1sn",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075974,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349645": {
            id: 85349645,
            name: "Special Paneer Meal",
            category: "Veg Meals",
            description:
              "Rice+3Phulka+Dal+Paneer Curry+Sweet+Coke200Ml+Salad+Rajma Masala.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075975,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349646": {
            id: 85349646,
            name: "Chicken Meal",
            category: "Non Veg Meals",
            description: "Rice+2Roti+Dal+Chicken Curry+Gulab Jamun+Salad.",
            cloudinaryImageId: "d88376713eb58f2258830389354cd8cb",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075976,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349647": {
            id: 85349647,
            name: "Egg Masala Meal",
            category: "Non Veg Meals",
            description: "Rice+2Roti+Dal+Egg Curry+Gulabjamun+Salad.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075977,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349648": {
            id: 85349648,
            name: "Special Egg Meal",
            category: "Non Veg Meals",
            description:
              "Ghee Rice+3Roti+Dal+Egg Curry+Egg Burji+Sweet+Sprite 200Ml.",
            cloudinaryImageId: "96d1c2e86f822404b306b3ffb7d63c1a",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075978,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349649": {
            id: 85349649,
            name: "Special Chicken Meal",
            category: "Non Veg Meals",
            description: "Rice+3Phulka+Dal+Chicken Curry+Kabab+Sweet+Coke.",
            cloudinaryImageId: "16a5173a643dcdcce21c1c799689dae2",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075979,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103108,
                    name: "Butter Phulka",
                    price: 1500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103119,
                    name: "Plain Phulka",
                    price: 1200,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103112,
                    name: "Egg Omelette",
                    price: 4000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103124,
                    name: "Sweat Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103115,
                    name: "Gher Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103116,
                    name: "Golab Jamun",
                    price: 3500,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349650": {
            id: 85349650,
            name: "Plain Phulka",
            category: "Roti",
            description: "",
            cloudinaryImageId: "c6de9821d0a6a5bc15c7a3784c12ec20",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1200,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349651": {
            id: 85349651,
            name: "Butter Phulka",
            category: "Roti",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349653": {
            id: 85349653,
            name: "Ghee Phulka",
            category: "Roti",
            description: "",
            cloudinaryImageId: "c6223f5e0f645033950b7c8db5d299ed",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349660": {
            id: 85349660,
            name: "Plain Paratha",
            category: "Parathas",
            description: "",
            cloudinaryImageId: "6069d29f3e1fb20ff0abae3cb7aa1cda",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1700,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349661": {
            id: 85349661,
            name: "Ghee Paratha",
            category: "Parathas",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349662": {
            id: 85349662,
            name: "Alu Paratha",
            category: "Parathas",
            description: "",
            cloudinaryImageId: "2c9e6b745229b1a45d49836fca38f54e",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4300,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349663": {
            id: 85349663,
            name: "Phulka 4 Nos+Dal Fry",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "b1d49fae8b3c1265f385f9047ad25dcb",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075876,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075875,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349664": {
            id: 85349664,
            name: "Paneer Butter Masala+Phulka 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "2fa6420eb54e828c377de058fc7af238",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075878,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075879,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349665": {
            id: 85349665,
            name: "Mushroom Masala+Phulka 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "a783ce316144f3717e7c6e7e74be4ed4",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075881,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075882,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349666": {
            id: 85349666,
            name: "Chole Masala+Phulka 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "2c62dee9d6050a6d8db91f09dc83b3e5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075877,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075880,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349667": {
            id: 85349667,
            name: "Rajma Masala+ Phulka 4Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "0b6696dea5a4d19759584b8148ce46ed",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075883,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075886,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349668": {
            id: 85349668,
            name: "Mix Veg+Phula 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "7e110afe655771c6c130719c816559cd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075889,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075891,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349671": {
            id: 85349671,
            name: "Chicken Masala+Phulka 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075898,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075895,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349672": {
            id: 85349672,
            name: "Chicken Butter Masala+Phulka 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075900,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075899,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349674": {
            id: 85349674,
            name: "Kadai Chicken+Roti 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075912,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075914,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349675": {
            id: 85349675,
            name: "Egg Curry 2 Nos +Phulka 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "270d8c0b3e024c37b08abdd88357880a",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075922,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075918,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349676": {
            id: 85349676,
            name: "Egg Bhurji +Masala+Phulka 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075911,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075909,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349677": {
            id: 85349677,
            name: "Egg Bhurji+Phulka 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "b351cfcb50b5435f3b8ec670eec24234",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075917,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075919,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349678": {
            id: 85349678,
            name: "Dal Fry",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "19f13e7ae4c16dd7928373970a4c2f80",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075935,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075938,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349679": {
            id: 85349679,
            name: "Paneer Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "d81eb017554dd9ecba962f54f6afcd53",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075943,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075945,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349680": {
            id: 85349680,
            name: "Paneer Butter Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "9a6c472fd77f5f65fa53eecb5381ca4a",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075951,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075954,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349681": {
            id: 85349681,
            name: "Chana Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "963a4da04b10caa32575fced43d19680",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075957,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075960,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349682": {
            id: 85349682,
            name: "Mushroom Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "a3d1edf407d01e83223e32902ac9a47f",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075931,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075934,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349683": {
            id: 85349683,
            name: "Aloo Gobi Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "c021bb7edb7a63376300567a95578a02",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075939,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075941,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349684": {
            id: 85349684,
            name: "Green Pea Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "9b6f5ab43729dba803352b208ba8ed3d",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075948,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075947,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349685": {
            id: 85349685,
            name: "Bhindi Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "a325b2571c8b90915a5957b6d85ecc7d",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075953,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075955,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349686": {
            id: 85349686,
            name: "Mix Veg Curry",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "06feefd01d1bf259d50d4f050a0929fd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075959,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075961,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349688": {
            id: 85349688,
            name: "Rajma Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "32124e764434f5a6606dcf614786ac7c",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075962,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075963,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349689": {
            id: 85349689,
            name: "Chicken Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "87de2c06ccedb5adc9b9c11238506f2c",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075964,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075965,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349690": {
            id: 85349690,
            name: "Chicken Butter Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "e3d0e04c9ae348dd072901f9168ad4dd",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075966,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075967,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349691": {
            id: 85349691,
            name: "Chilli Chicken",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "8a89e87f2ecdde3bc4a91b9924876b44",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075902,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075901,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349692": {
            id: 85349692,
            name: "Chicken Manchurian",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075903,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075905,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349693": {
            id: 85349693,
            name: "Chicken Kabab (5Pcs)",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "473fe482f45dd997b07c1127d1e97511",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075908,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075907,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349694": {
            id: 85349694,
            name: "Chicken 65",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "edb0a04ba668780166ae4f1707ef7faf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075913,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075910,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349695": {
            id: 85349695,
            name: "Lemon Chicken",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075915,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075916,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349696": {
            id: 85349696,
            name: "Kadai Chicken",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "4a5fd638bb254ae2d55d048f6851cc2d",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075920,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075921,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349701": {
            id: 85349701,
            name: "Gobi Manchurian",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "1348b94943e4cb6a47d5edf66be31cac",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075933,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075932,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349702": {
            id: 85349702,
            name: "Mashroom Manchurian",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075937,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075936,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349703": {
            id: 85349703,
            name: "Paneer Chilli",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075940,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075942,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349704": {
            id: 85349704,
            name: "Egg Omelette",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075944,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075946,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349705": {
            id: 85349705,
            name: "Boil Egg 2 Nos",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075949,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075950,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349706": {
            id: 85349706,
            name: "Plain Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "c3782d890544ee799ed13852d6a428a2",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349707": {
            id: 85349707,
            name: "Jeera Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "a681e8e400e0fc98098d97088a53518a",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349708": {
            id: 85349708,
            name: "Ghee Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "0a143747229f0ec4bae7c9118303d81d",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349709": {
            id: 85349709,
            name: "Green Pea Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349710": {
            id: 85349710,
            name: "Curd Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "fdacb802d7be9f34e3a18e9c6497159c",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349711": {
            id: 85349711,
            name: "Veg Fried Rice",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "yegeumuesfzcleeqcl3b",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349713": {
            id: 85349713,
            name: "Paneer Fried Rice",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349714": {
            id: 85349714,
            name: "Mushroom Fried Rice",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349715": {
            id: 85349715,
            name: "Chicken Fried Rice",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "mwzhpca4fqmba1bbuvik",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349717": {
            id: 85349717,
            name: "Egg Fried Rice",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "nxrrodhxbmbdoipnjqdf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349723": {
            id: 85349723,
            name: "Chicken Noodles",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "nq1ksitefxzirrhxvd9e",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349725": {
            id: 85349725,
            name: "Egg Noodles",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "j7qew1o6latlxbsia7iu",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349726": {
            id: 85349726,
            name: "Egg Noodles [Double]",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349727": {
            id: 85349727,
            name: "Egg Chicken Fried Rice",
            category: "Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349728": {
            id: 85349728,
            name: "Plain Phulka (Pack Of 5)",
            category: "Rotis Paratha'S",
            description: "",
            cloudinaryImageId: "c69owwljae0icechoffc",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349729": {
            id: 85349729,
            name: "Plain Phulka (Pack Of 10)",
            category: "Rotis Paratha'S",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349730": {
            id: 85349730,
            name: "Butter Phulka (Pack Of 5)",
            category: "Rotis Paratha'S",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349731": {
            id: 85349731,
            name: "Plain Paratha (Pack Of 3)",
            category: "Rotis Paratha'S",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4600,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349732": {
            id: 85349732,
            name: "Ghee Paratha (Pack Of 3)",
            category: "Rotis Paratha'S",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349734": {
            id: 85349734,
            name: "Aloo Paratha (Pack Of 2)",
            category: "Rotis Paratha'S",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85349735": {
            id: 85349735,
            name: "Ghee Phulka (Pack Of 4)",
            category: "Rotis Paratha'S",
            description: "",
            cloudinaryImageId: "jhikrawpqnspjn3sjbn8",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7200,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299646": {
            id: 102299646,
            name: "Sukha Aloo Sabzi (Dry Aloo)",
            category: "Fresh Sabzi",
            description: "",
            cloudinaryImageId: "b9a4bc445648995957971cd7442e40d8",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299647": {
            id: 102299647,
            name: "Paneer Burzi",
            category: "Fresh Sabzi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299650": {
            id: 102299650,
            name: "Kadai Panner",
            category: "Fresh Sabzi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299651": {
            id: 102299651,
            name: "Palak Paneer",
            category: "Fresh Sabzi",
            description: "",
            cloudinaryImageId: "bc7c24cc244e67746ef2763f4c2ad9e6",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299652": {
            id: 102299652,
            name: "Dal Makhini",
            category: "Fresh Sabzi",
            description: "",
            cloudinaryImageId: "54f059a7a647742cab71a4e8bbaa7162",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299653": {
            id: 102299653,
            name: "Jeera Aloo",
            category: "Fresh Sabzi",
            description: "",
            cloudinaryImageId: "69799b95b1c33a849db08e2ce39a10b4",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299654": {
            id: 102299654,
            name: "Rajasthani Dal Tadaka",
            category: "Fresh Sabzi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299655": {
            id: 102299655,
            name: "Rajasthani Dal Tadka + Paneer Burzi + Rice (500 Gm)",
            category: "North Indian Rice Combo",
            description: "",
            cloudinaryImageId: "75bf8b9cecda293170a1dbd18d04bee5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299656": {
            id: 102299656,
            name: "Rajma Masala + Dal Makhini + Rice (500 Gm)",
            category: "North Indian Rice Combo",
            description: "",
            cloudinaryImageId: "e29404ca2950d42bfb32f2085ccd5c58",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299657": {
            id: 102299657,
            name: "Rajasthani Dal Tadka + Paneer Masala + Rice (500Gm)",
            category: "North Indian Rice Combo",
            description: "",
            cloudinaryImageId: "394da971e9c632b19da72322b68eabd7",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299658": {
            id: 102299658,
            name: "Dal Makhini + Egg Masala + Rice (500Gm)",
            category: "North Indian Rice Combo",
            description: "",
            cloudinaryImageId: "d73673c29c2240b256016635d52a956a",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299659": {
            id: 102299659,
            name: "Mumbai Mushroom Masala + Rajasthani Dal Tadka Rice (500Gm)",
            category: "North Indian Rice Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299660": {
            id: 102299660,
            name: "Dhaba Style Methi Malai Mutar +Dal Mukhi Rice (500Gm)",
            category: "North Indian Rice Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299662": {
            id: 102299662,
            name: "Butter Chicken + Paneer Burzi + Rice ( 500Gm)",
            category: "North Indian Rice Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299666": {
            id: 102299666,
            name: "Mix Vegitable Pulav",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299667": {
            id: 102299667,
            name: "Rajasthani Dal Tadak + 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075885,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075884,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299668": {
            id: 102299668,
            name: "Mumbai Mushroom Masala +Gheet Phulka 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075887,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075888,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299669": {
            id: 102299669,
            name: "Dal Makhini + Ghee Phulka 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "a0f05cfd9597618693676e07ecb713ee",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075890,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075892,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299670": {
            id: 102299670,
            name: "Purani Dilli Chole + Plain Phula 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075894,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075893,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299671": {
            id: 102299671,
            name: "Dhaba Style Methi Malai Mutar + Ghee Phulka Roti 4 Nos",
            category: "Veg Combo-1",
            description: "",
            cloudinaryImageId: "828661f6a999ec6a91a821f12ff52c89",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075896,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075897,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299675": {
            id: 102299675,
            name: "Gulab Jamun",
            category: "Extra",
            description: "",
            cloudinaryImageId: "e9eb4338b9b1fcc20b6034117d27a552",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299676": {
            id: 102299676,
            name: "Chicken Curry 4 Nos Phulka",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "643f846b79dc63e471d931e0c5fd2470",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075904,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075906,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299677": {
            id: 102299677,
            name: "Sweet Lassi",
            category: "Extra",
            description: "",
            cloudinaryImageId: "96513fe588e6659f6de95e7df56729ab",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299678": {
            id: 102299678,
            name: "Slice Cucumber",
            category: "Extra",
            description: "",
            cloudinaryImageId: "a883adf3c9ba361647a296cc2a0d6f8a",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299679": {
            id: 102299679,
            name: "Slice Onion",
            category: "Extra",
            description: "",
            cloudinaryImageId: "e3a5318ab1d87afc6967ef9b08ad83f0",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299680": {
            id: 102299680,
            name: "Sweet Lassi  200 Ml",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299681": {
            id: 102299681,
            name: "Salt Lassi 200 Ml",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299682": {
            id: 102299682,
            name: "Masala Lassi 200 Ml",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299683": {
            id: 102299683,
            name: "Butter Chicken Masala + Plain Phulka 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075924,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075926,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299684": {
            id: 102299684,
            name: "Dahi Vada",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "324c02f11ebf002397df8128d8c9cfc9",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299685": {
            id: 102299685,
            name: "Egg Masala + Ghee Phulka 4 Nos",
            category: "Non Veg Combo",
            description: "",
            cloudinaryImageId: "edc14f47eabcd645fba92f1b811e8da5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77075929,
                group_name: "Phulka 4 Nos+Dal Fry",
                choices: [
                  {
                    id: 62103118,
                    name: "Plain Paratha",
                    price: 1700,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103113,
                    name: "Ghee Paratha",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103114,
                    name: "Ghee Phulka",
                    price: 2000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103106,
                    name: "Aloo Paratha",
                    price: 4300,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103120,
                    name: "Plain Phulka (Pack Of 5)",
                    price: 5500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 77075930,
                group_name: "New Year Special 2023 Meal 1",
                choices: [
                  {
                    id: 62103107,
                    name: "Boil Egg (2 Nos)",
                    price: 3000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103110,
                    name: "Coke (750 Ml)",
                    price: 6500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103121,
                    name: "Slice Cucumber",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103111,
                    name: "Dahi Vada",
                    price: 8500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103122,
                    name: "Slice Onion",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103109,
                    name: "Coke (250 Ml)",
                    price: 3500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103123,
                    name: "Spoon",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 62103117,
                    name: "Masala Lassi",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102299686": {
            id: 102299686,
            name: "Corn Bhel",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "492159",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 85349639,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349640,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349641,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349644,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349646,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349648,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349649,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349650,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349653,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349660,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349662,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349663,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349664,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349665,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299669,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299671,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349666,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349667,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349668,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299676,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349675,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349677,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299685,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349678,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349679,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349680,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349681,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349682,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349683,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349684,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349685,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349686,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349688,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349689,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349690,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349691,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349693,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349694,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349696,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349701,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349706,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349707,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349708,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349710,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349711,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349715,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349717,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349723,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349725,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299675,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299677,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299678,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299679,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299684,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349728,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85349735,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299646,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299651,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299652,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299653,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299655,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299656,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299657,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102299658,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Meals",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349639,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349640,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349641,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349642,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349643,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349644,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349645,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Non Veg Meals",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349646,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349647,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349648,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349649,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Roti",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349650,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349651,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349653,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Parathas",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349660,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349661,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349662,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Combo-1",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349663,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349664,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349665,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299667,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299668,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299669,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299670,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299671,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349666,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349667,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349668,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Non Veg Combo",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349671,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349672,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299676,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349674,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349675,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349676,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349677,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299683,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299685,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Main Course",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349678,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349679,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349680,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349681,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349682,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349683,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349684,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349685,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349686,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349688,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349689,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349690,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349691,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349692,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349693,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349694,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349695,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349696,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349701,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349702,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349703,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349704,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349705,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349706,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349707,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349708,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349709,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349710,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299666,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Chinese",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349711,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349713,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349714,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349715,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349717,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349723,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349725,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349726,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349727,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Extra",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102299675,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299677,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299678,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299679,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Cold Beverages",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102299680,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299681,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299682,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299684,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299686,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rotis Paratha'S",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 85349728,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349729,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349730,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349731,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349732,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349734,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 85349735,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fresh Sabzi",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102299646,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299647,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299650,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299651,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299652,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299653,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299654,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "North Indian Rice Combo",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102299655,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299656,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299657,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299658,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299659,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299660,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102299662,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "normal",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "20% OFF UPTO ₹50",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["074466e6-8392-499a-9263-be4634a1b644"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE TRYNEW",
          description: "ABOVE ₹159",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 2,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 21221010000792"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      select: false,
      slotInvalid: false,
      cafe: false,
      preorderable: false,
      requestId: "e3b6887b-9cc1-4778-825a-f4633baf4a1b",
      timeStamp: "1677488973263",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "9ZProVbOxps6-B9hlQ1SP0BFFb2c6Ll9tUQ3a8yg",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "428",
      name: "Biryani Pot",
      uuid: "6db20a8b-dd85-4148-b750-107169f7f826",
      slug: "biryani-pot-madiwala-junction-btm",
      latLong: "12.921991,77.6165291",
      city: "Bangalore",
      area: "Btm Layout",
      areaPostalCode: "560068",
      areaSlug: "BTM",
      restaurantSlug: {
        restaurant: "biryani-pot-madiwala-junction-btm",
        city: "bangalore",
      },
      type: "F",
      locality: "Maruti Nagar",
      avgRating: 3.8,
      totalRatings: 1000,
      avgRatingString: "3.8",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "mdipoyzfzsa7n7igskht",
      costForTwo: 50000,
      costForTwoMsg: "₹500 for two",
      cuisines: ["North Indian", "Biryani"],
      minimumOrder: 0,
      opened: 1,
      parentId: 21798,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "22 MINS",
        lastMileDistanceString: "1.9 kms",
        restaurantId: "428",
        deliveryTime: 22,
        minDeliveryTime: 22,
        maxDeliveryTime: 22,
        lastMileTravel: 1.9,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.6457593441009521,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 4,
      },
      availability: {
        nextCloseTime: "2023-02-28 03:00:00",
        nextChangeTime: 1677533400000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "14th  Cross, 4th link Road Maruthi Nagar Madiwala Bangalore 68",
        },
        { title: "Cuisines", message: "North Indian,Biryani" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "922803": {
            id: 922803,
            name: "Mixed Veg Curry",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "kwdp3x0dhelnrb6xirt0",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922804": {
            id: 922804,
            name: "Egg Curry",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "ixx3h4q6xyggkgllivnt",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922810": {
            id: 922810,
            name: "Veg Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            cloudinaryImageId: "tmygtt8zkkqa3ppzxcxg",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149833",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive [500 Ml]",
                      price: 148,
                      default: 1,
                      id: "28438023",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "149833",
                      order: 997,
                    },
                    {
                      name: "Regular [1000 Ml]",
                      price: 239,
                      default: 0,
                      id: "28438024",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "149833",
                      order: 996,
                    },
                    {
                      name: "Large",
                      price: 469,
                      default: 0,
                      id: "414831",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "149833",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "149833", variation_id: "28438023" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "149833", variation_id: "28438024" },
                  ],
                  price: 23900,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149833", variation_id: "414831" }],
                  price: 46900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922812": {
            id: 922812,
            name: "Egg Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml |",
            cloudinaryImageId: "hkih2vrobujncsh5vnhh",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149834",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive",
                      price: 148,
                      default: 1,
                      id: "28438030",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149834",
                      order: 999,
                    },
                    {
                      name: "Regular",
                      price: 239,
                      default: 0,
                      id: "414832",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149834",
                      order: 998,
                    },
                    {
                      name: "Large",
                      price: 509,
                      default: 0,
                      id: "414833",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149834",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "149834", variation_id: "28438030" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149834", variation_id: "414832" }],
                  price: 23900,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149834", variation_id: "414833" }],
                  price: 50900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922814": {
            id: 922814,
            name: "Chicken Dum Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            cloudinaryImageId: "stcwjsd9zpxnbi8nnq8t",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149835",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive [500 Ml]",
                      price: 148,
                      default: 1,
                      id: "28438033",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149835",
                      order: 997,
                    },
                    {
                      name: "Regular [1000 Ml]",
                      price: 299,
                      default: 0,
                      id: "28438034",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149835",
                      order: 996,
                    },
                    {
                      name: "Large",
                      price: 609,
                      default: 0,
                      id: "414835",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149835",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "149835", variation_id: "28438033" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "149835", variation_id: "28438034" },
                  ],
                  price: 29900,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149835", variation_id: "414835" }],
                  price: 60900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922816": {
            id: 922816,
            name: "Boneless Special Chicken Biryanispecial Chicken Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            cloudinaryImageId: "o5x0ovrs7pu30dz9hidl",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149836",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive",
                      price: 148,
                      default: 1,
                      id: "28438031",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149836",
                      order: 999,
                    },
                    {
                      name: "Regular [1000 Ml]",
                      price: 309,
                      default: 0,
                      id: "28438032",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149836",
                      order: 996,
                    },
                    {
                      name: "Large",
                      price: 629,
                      default: 0,
                      id: "414837",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149836",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "149836", variation_id: "28438031" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "149836", variation_id: "28438032" },
                  ],
                  price: 30900,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149836", variation_id: "414837" }],
                  price: 62900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922818": {
            id: 922818,
            name: "Chicken Fry Piece Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149837",
                  name: "Size",
                  variations: [
                    {
                      name: "Regular",
                      price: 279,
                      default: 1,
                      id: "414838",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149837",
                      order: 998,
                    },
                    {
                      name: "Executive [500 Ml]",
                      price: 148,
                      default: 0,
                      id: "58197891",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149837",
                      order: 997,
                    },
                    {
                      name: "Large",
                      price: 599,
                      default: 0,
                      id: "414839",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149837",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [{ group_id: "149837", variation_id: "414838" }],
                  price: 27900,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "149837", variation_id: "58197891" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149837", variation_id: "414839" }],
                  price: 59900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 27900,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922822": {
            id: 922822,
            name: "Mutton Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            cloudinaryImageId: "sccqbaicntqpuhz3qmus",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149838",
                  name: "Size",
                  variations: [
                    {
                      name: "Regular",
                      price: 319,
                      default: 1,
                      id: "414840",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149838",
                      order: 998,
                    },
                    {
                      name: "Large",
                      price: 629,
                      default: 0,
                      id: "414841",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149838",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [{ group_id: "149838", variation_id: "414840" }],
                  price: 31900,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149838", variation_id: "414841" }],
                  price: 62900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 31900,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922828": {
            id: 922828,
            name: "Fish Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149840",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive",
                      price: 148,
                      default: 1,
                      id: "28956852",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149840",
                      order: 999,
                    },
                    {
                      name: "Regular",
                      price: 299,
                      default: 0,
                      id: "414844",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149840",
                      order: 998,
                    },
                    {
                      name: "Large",
                      price: 589,
                      default: 0,
                      id: "414845",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149840",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "149840", variation_id: "28956852" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149840", variation_id: "414844" }],
                  price: 29900,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149840", variation_id: "414845" }],
                  price: 58900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922832": {
            id: 922832,
            name: "Curd Rice",
            category: "Biryani And Rice",
            description: "",
            cloudinaryImageId: "dchfdev5kec3vlddpmwy",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922847": {
            id: 922847,
            name: "Lassi",
            category: "Desserts And Beverages",
            description: "",
            cloudinaryImageId: "fmkdxbg2vorao3nyfqzp",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "922851": {
            id: 922851,
            name: "Mineral Water",
            category: "Desserts And Beverages",
            description: "| 1 ltr |",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296057": {
            id: 2296057,
            name: "Mixed Veg Jumbo Roll",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296058": {
            id: 2296058,
            name: "Veg Cheese Jumbo Roll",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296060": {
            id: 2296060,
            name: "Paneer Kalimirch Jumbo Roll",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296061": {
            id: 2296061,
            name: "Egg Jumbo Roll",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296062": {
            id: 2296062,
            name: "Chicken Jumbo Roll",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296078": {
            id: 2296078,
            name: "Veg Red Sauce Pasta",
            category: "Pastas",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296081": {
            id: 2296081,
            name: "Peanut Masala",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296082": {
            id: 2296082,
            name: "Onion Pakoda",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296084": {
            id: 2296084,
            name: "Paneer 65",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296085": {
            id: 2296085,
            name: "Paneer Manchurian",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296086": {
            id: 2296086,
            name: "Chilli Paneer",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296087": {
            id: 2296087,
            name: "Paneer Pakoda",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296091": {
            id: 2296091,
            name: "Crispy Corn",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296092": {
            id: 2296092,
            name: "Chilli Mushroom",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296093": {
            id: 2296093,
            name: "Mushroom 65",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296094": {
            id: 2296094,
            name: "Mushroom Manchurian",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296095": {
            id: 2296095,
            name: "Gobi Manchurian",
            category: "Starters",
            description: "| Serve 1 |",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296096": {
            id: 2296096,
            name: "Gobi 65",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296156": {
            id: 2296156,
            name: "Italian Chicken Pasta",
            category: "Pastas",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296157": {
            id: 2296157,
            name: "Chicken Red Sauce Pasta",
            category: "Pastas",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296237": {
            id: 2296237,
            name: "French Fry",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296256": {
            id: 2296256,
            name: "Chicken Manchurian",
            category: "Starters",
            description: "| Serve 1 |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296257": {
            id: 2296257,
            name: "Chicken Pakoda",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296258": {
            id: 2296258,
            name: "Chilli Chicken",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296260": {
            id: 2296260,
            name: "Ginger Chicken",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296261": {
            id: 2296261,
            name: "Pepper Chicken",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296262": {
            id: 2296262,
            name: "Dragon Chicken",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296263": {
            id: 2296263,
            name: "Schezwan Chicken",
            category: "Starters",
            description: "| Serve 1 |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296264": {
            id: 2296264,
            name: "Chicken 555",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296266": {
            id: 2296266,
            name: "Grilled Chicken Sausage",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296269": {
            id: 2296269,
            name: "Chilli Mutton Fry",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296271": {
            id: 2296271,
            name: "Pepper Mutton",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296276": {
            id: 2296276,
            name: "Apollo Fish",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296279": {
            id: 2296279,
            name: "Schezwan Fish",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296280": {
            id: 2296280,
            name: "Dal Fry",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296281": {
            id: 2296281,
            name: "Dal Tadka",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296283": {
            id: 2296283,
            name: "Green Peas Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296288": {
            id: 2296288,
            name: "Kaju Paneer",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296292": {
            id: 2296292,
            name: "Kadai Paneer",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296293": {
            id: 2296293,
            name: "Palak Paneer",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296294": {
            id: 2296294,
            name: "Paneer Tikka Makhani",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296295": {
            id: 2296295,
            name: "Paneer Butter Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296303": {
            id: 2296303,
            name: "Paneer Tikka",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 25900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296305": {
            id: 2296305,
            name: "Butter Chicken",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296306": {
            id: 2296306,
            name: "Kadai Chicken",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296307": {
            id: 2296307,
            name: "Chicken Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296308": {
            id: 2296308,
            name: "Chicken Kolhapuri",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296310": {
            id: 2296310,
            name: "Achari Chicken",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296311": {
            id: 2296311,
            name: "Punjabi Chicken",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296312": {
            id: 2296312,
            name: "Chicken Tikka Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296314": {
            id: 2296314,
            name: "Andhra Chicken Curry",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296315": {
            id: 2296315,
            name: "Mutton Keema Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296316": {
            id: 2296316,
            name: "Spicy Mutton Curry",
            category: "Main Course",
            description: "| 500 Ml |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296317": {
            id: 2296317,
            name: "Mutton Do Pyaza",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296318": {
            id: 2296318,
            name: "Andhra Mutton Curry",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296319": {
            id: 2296319,
            name: "Mutton Rogan Josh",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296320": {
            id: 2296320,
            name: "Andhra Fish Curry",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296321": {
            id: 2296321,
            name: "Goan Fish Curry",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296325": {
            id: 2296325,
            name: "Kadai Prawn",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296326": {
            id: 2296326,
            name: "Chicken Tikka",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296424": {
            id: 2296424,
            name: "Paprika Grilled Chicken",
            category: "Starters",
            description: "| Serve 1 |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296425": {
            id: 2296425,
            name: "Barbeque Chicken",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296435": {
            id: 2296435,
            name: "Cashew Rice",
            category: "Biryani And Rice",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296436": {
            id: 2296436,
            name: "Ghee Rice",
            category: "Biryani And Rice",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296437": {
            id: 2296437,
            name: "Jeera Rice",
            category: "Biryani And Rice",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296441": {
            id: 2296441,
            name: "Veg Hakka Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296443": {
            id: 2296443,
            name: "Egg Fried Rice",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296444": {
            id: 2296444,
            name: "Egg Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296445": {
            id: 2296445,
            name: "Chicken Fried Rice",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296447": {
            id: 2296447,
            name: "Schezwan Chicken Fried Rice",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296449": {
            id: 2296449,
            name: "Chicken Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296450": {
            id: 2296450,
            name: "Chicken Chowmein",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296451": {
            id: 2296451,
            name: "Chicken Hakka Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296453": {
            id: 2296453,
            name: "Phulka",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296454": {
            id: 2296454,
            name: "Butter Phulka",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296455": {
            id: 2296455,
            name: "Roti",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296459": {
            id: 2296459,
            name: "Tawa Parotta",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296460": {
            id: 2296460,
            name: "Malabar Parotta",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296461": {
            id: 2296461,
            name: "Butter Parotta",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2296488": {
            id: 2296488,
            name: "Mango Lassi",
            category: "Desserts And Beverages",
            description: "| 250 Ml |",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653745": {
            id: 3653745,
            name: "Veg Grilled Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653746": {
            id: 3653746,
            name: "Paneer Burji Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653747": {
            id: 3653747,
            name: "Cheese Corn Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653748": {
            id: 3653748,
            name: "Triple Cheese Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653749": {
            id: 3653749,
            name: "Veg Burger",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653751": {
            id: 3653751,
            name: "Garlic Chicken Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653752": {
            id: 3653752,
            name: "Masala Chicken Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653753": {
            id: 3653753,
            name: "Chicken Cheese Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653754": {
            id: 3653754,
            name: "Chicken Tikka Sandwich",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653755": {
            id: 3653755,
            name: "Special Chicken Burger",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653758": {
            id: 3653758,
            name: "Grilled Chicken Burger",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653765": {
            id: 3653765,
            name: "Murgh Tandoori",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "149831",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 239,
                      default: 1,
                      id: "414826",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149831",
                      order: 994,
                    },
                    {
                      name: "Full",
                      price: 399,
                      default: 0,
                      id: "414827",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "149831",
                      order: 993,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [{ group_id: "149831", variation_id: "414826" }],
                  price: 23900,
                  addon_combinations: [],
                },
                {
                  variations: [{ group_id: "149831", variation_id: "414827" }],
                  price: 39900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 23900,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653774": {
            id: 3653774,
            name: "Chicken Ghee Roast",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653775": {
            id: 3653775,
            name: "Mutton Ghee Roast",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3653776": {
            id: 3653776,
            name: "Paneer Pudina Tikka",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 25900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205029": {
            id: 7205029,
            name: "Butter Roti",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205030": {
            id: 7205030,
            name: "Methi Roti",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205031": {
            id: 7205031,
            name: "Naan",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205032": {
            id: 7205032,
            name: "Butter Naan",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205033": {
            id: 7205033,
            name: "Cheese Naan",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205034": {
            id: 7205034,
            name: "Garlic Naan",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205035": {
            id: 7205035,
            name: "Kulcha",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205036": {
            id: 7205036,
            name: "Butter Kulcha",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "7205038": {
            id: 7205038,
            name: "Methi Parotta",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "44557368": {
            id: 44557368,
            name: "Jeera Rice With Chilli Chicken",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "44557369": {
            id: 44557369,
            name: "Jeera Rice With Gobi Manchurian",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "44557372": {
            id: 44557372,
            name: "Roti With Dal Fry",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "44557373": {
            id: 44557373,
            name: "Roti With Paneer Butter Masala",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52083730": {
            id: 52083730,
            name: "Kalmi Chicken",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "6863327",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 160,
                      default: 1,
                      id: "23101761",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "6863327",
                      order: 994,
                    },
                    {
                      name: "Full",
                      price: 280,
                      default: 0,
                      id: "23101760",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "6863327",
                      order: 993,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "6863327", variation_id: "23101761" },
                  ],
                  price: 16000,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "6863327", variation_id: "23101760" },
                  ],
                  price: 28000,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 16000,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52083731": {
            id: 52083731,
            name: "Tangdi Chicken",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "6863328",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 180,
                      default: 1,
                      id: "23101763",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "6863328",
                      order: 994,
                    },
                    {
                      name: "Full",
                      price: 300,
                      default: 0,
                      id: "23101762",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "6863328",
                      order: 993,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "6863328", variation_id: "23101763" },
                  ],
                  price: 18000,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "6863328", variation_id: "23101762" },
                  ],
                  price: 30000,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 18000,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357197": {
            id: 62357197,
            name: "Paneer Fried Momos [6 Pieces]",
            category: "MOMOS",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357198": {
            id: 62357198,
            name: "Paneer Steamed Momos [6 Pieces]",
            category: "MOMOS",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357199": {
            id: 62357199,
            name: "Veg Fried Momos [6 Pieces]",
            category: "MOMOS",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357200": {
            id: 62357200,
            name: "Veg Steamed Momos [6 Pieces]",
            category: "MOMOS",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357202": {
            id: 62357202,
            name: "Mutter Paneer Jumbo Roll",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357203": {
            id: 62357203,
            name: "Chicken Fried Momos [6 Pieces]",
            category: "MOMOS",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357204": {
            id: 62357204,
            name: "Chicken Steamed Momos [6 Pieces]",
            category: "MOMOS",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357205": {
            id: 62357205,
            name: "Grilled Prawn Jumbo Roll",
            category: "Snack Time Specials",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357209": {
            id: 62357209,
            name: "Steam Rice",
            category: "Biryani And Rice",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357210": {
            id: 62357210,
            name: "Biryani Rice",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "8538865",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive",
                      price: 148,
                      default: 1,
                      id: "28438020",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538865",
                      order: 999,
                    },
                    {
                      name: "Regular",
                      price: 219,
                      default: 0,
                      id: "28438021",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538865",
                      order: 998,
                    },
                    {
                      name: "Large",
                      price: 409,
                      default: 0,
                      id: "28438022",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538865",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "8538865", variation_id: "28438020" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538865", variation_id: "28438021" },
                  ],
                  price: 21900,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538865", variation_id: "28438022" },
                  ],
                  price: 40900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357211": {
            id: 62357211,
            name: "Paneer Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            cloudinaryImageId: "bgrlmo2dimscjguibgpc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "8538866",
                  name: "Size",
                  variations: [
                    {
                      name: "Regular",
                      price: 259,
                      default: 1,
                      id: "28438026",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538866",
                      order: 998,
                    },
                    {
                      name: "Executive [500 Ml]",
                      price: 148,
                      default: 0,
                      id: "28438025",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538866",
                      order: 997,
                    },
                    {
                      name: "Large",
                      price: 499,
                      default: 0,
                      id: "28438027",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538866",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "8538866", variation_id: "28438026" },
                  ],
                  price: 25900,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538866", variation_id: "28438025" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538866", variation_id: "28438027" },
                  ],
                  price: 49900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 25900,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357212": {
            id: 62357212,
            name: "Mushroom Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            cloudinaryImageId: "actpr4mk8kkbc4xxvdlh",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "8538867",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive",
                      price: 148,
                      default: 1,
                      id: "28956851",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538867",
                      order: 999,
                    },
                    {
                      name: "Regular",
                      price: 259,
                      default: 0,
                      id: "28438028",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538867",
                      order: 998,
                    },
                    {
                      name: "Large",
                      price: 499,
                      default: 0,
                      id: "28438029",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "8538867",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "8538867", variation_id: "28956851" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538867", variation_id: "28438028" },
                  ],
                  price: 25900,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538867", variation_id: "28438029" },
                  ],
                  price: 49900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357214": {
            id: 62357214,
            name: "Prawn Biryani",
            category: "Biryani And Rice",
            description: "| 500 Ml | Served with Raita |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "8538869",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Executive",
                      price: 148,
                      default: 1,
                      id: "28956853",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8538869",
                      order: 999,
                    },
                    {
                      name: "Regular",
                      price: 309,
                      default: 0,
                      id: "28438037",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8538869",
                      order: 998,
                    },
                    {
                      name: "Large",
                      price: 619,
                      default: 0,
                      id: "28438038",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8538869",
                      order: 995,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "8538869", variation_id: "28956853" },
                  ],
                  price: 14800,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538869", variation_id: "28438037" },
                  ],
                  price: 30900,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8538869", variation_id: "28438038" },
                  ],
                  price: 61900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            defaultPrice: 14800,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357215": {
            id: 62357215,
            name: "Curd Rice With Gobi Manchurian",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357218": {
            id: 62357218,
            name: "Steam Rice + Dal Fry + Dry Papad + Pickle",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357219": {
            id: 62357219,
            name: "Steam Rice + Mix Veg Curry + Dry Papad + Pickle",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357221": {
            id: 62357221,
            name: "Veg Biryani With Coke [250 Ml]",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357222": {
            id: 62357222,
            name: "Mushroom Biryani Regular With Coke [750 Ml]",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 25400,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357223": {
            id: 62357223,
            name: "Paneer Biryani  Regular With Coke[750 Ml]",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 29400,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357224": {
            id: 62357224,
            name: "Steam Rice + Egg Curry + Dry Papad + Pickle",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357225": {
            id: 62357225,
            name: "Egg Biryani Regular With Coke[750 Ml]",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357226": {
            id: 62357226,
            name: "2 Piece Roti With Butter Chicken",
            category: "Combos",
            description: "| Serve 1 | Served with Bread |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357227": {
            id: 62357227,
            name: "2 Pieces Roti With Chicken Masala",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357228": {
            id: 62357228,
            name: "Curd Rice With Chicken Kebab [2 Pieces]",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357229": {
            id: 62357229,
            name: "Executive Biryani Rice + Chicken Wings",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357230": {
            id: 62357230,
            name: "Biryani Rice + Chicken Kebab",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357231": {
            id: 62357231,
            name: "Executive Biryani Rice + Chicken Lollipop",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357233": {
            id: 62357233,
            name: "Boneless Special Chicken Biryani Regular With Coke[750 Ml]",
            category: "Combos",
            description: "| Serve 1 | Served with Raita |",
            cloudinaryImageId: "hwskozgx6no4ftfsqzlk",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357234": {
            id: 62357234,
            name: "Chicken Fry Piece Biryani Regular With Coke[750 Ml]",
            category: "Combos",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357235": {
            id: 62357235,
            name: "Chilli Baby Corn",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357237": {
            id: 62357237,
            name: "Crispy Baby Corn",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357239": {
            id: 62357239,
            name: "Roasted Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "czciffsarraaszlvu9ac",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357242": {
            id: 62357242,
            name: "Chicken Six Five",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357256": {
            id: 62357256,
            name: "Chicken Lollipop",
            category: "Starters",
            description: "| Serve 1 |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357259": {
            id: 62357259,
            name: "Chicken Kabab",
            category: "Starters",
            description: "| Serve 1 |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357265": {
            id: 62357265,
            name: "Chilly Mutton",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357266": {
            id: 62357266,
            name: "Murgh Malai Kabab",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357268": {
            id: 62357268,
            name: "Bhuna Gosht",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357269": {
            id: 62357269,
            name: "Fish Kabab",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357270": {
            id: 62357270,
            name: "Prawn 65",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357271": {
            id: 62357271,
            name: "Prawn Chilli",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357272": {
            id: 62357272,
            name: "Prawn Manchurian",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357274": {
            id: 62357274,
            name: "Prawn Kabab",
            category: "Starters",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357275": {
            id: 62357275,
            name: "Aloo Gobhi Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357276": {
            id: 62357276,
            name: "Aloo Gobi Matar Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357277": {
            id: 62357277,
            name: "Matar Makhani",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357278": {
            id: 62357278,
            name: "Baby Corn Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357280": {
            id: 62357280,
            name: "Veg Kadai",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357281": {
            id: 62357281,
            name: "Vegetable Chat Phat",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357283": {
            id: 62357283,
            name: "Paneer Chat Phat",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357284": {
            id: 62357284,
            name: "Punjabi Paneer",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357285": {
            id: 62357285,
            name: "Paneer Bhurji",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357286": {
            id: 62357286,
            name: "Chicken Do Pyaaza",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357287": {
            id: 62357287,
            name: "Hariyali Chicken",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357288": {
            id: 62357288,
            name: "Bengal Fish Curry",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357289": {
            id: 62357289,
            name: "Mutton Masala",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "dwyt9a6n3ii3w8js1qnc",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357290": {
            id: 62357290,
            name: "Prawn Do Pyaza",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357293": {
            id: 62357293,
            name: "Prawn Masala",
            category: "Main Course",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357294": {
            id: 62357294,
            name: "Vegetable Fried Rice",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357296": {
            id: 62357296,
            name: "Vegetable Chowmein",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357297": {
            id: 62357297,
            name: "Schezwan Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357304": {
            id: 62357304,
            name: "Non Veg Mixed Fried Rice",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357311": {
            id: 62357311,
            name: "Chicken Schezwan Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357313": {
            id: 62357313,
            name: "Special Prawn Fried Rice",
            category: "Fried Rice And Noodles",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357314": {
            id: 62357314,
            name: "Veg Italian Pasta",
            category: "Pastas",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357316": {
            id: 62357316,
            name: "Chapati",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357320": {
            id: 62357320,
            name: "Plain Parotta",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357321": {
            id: 62357321,
            name: "Lachha Parotta",
            category: "Breads",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357322": {
            id: 62357322,
            name: "1 Boiled Egg",
            category: "Egg Preparations",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 1900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357323": {
            id: 62357323,
            name: "Omelette",
            category: "Egg Preparations",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357324": {
            id: 62357324,
            name: "Egg Bhurji",
            category: "Egg Preparations",
            description: "| Serve 1 |",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 6900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357325": {
            id: 62357325,
            name: "Chilli Egg",
            category: "Egg Preparations",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357326": {
            id: 62357326,
            name: "Veg Grilled Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357328": {
            id: 62357328,
            name: "Cheese Corn Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357329": {
            id: 62357329,
            name: "Mixed Veg Jumbo Roll",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357330": {
            id: 62357330,
            name: "Mutter Paneer Jumbo Roll",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357331": {
            id: 62357331,
            name: "Paneer Burji Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357332": {
            id: 62357332,
            name: "Paneer Kalimirch Jumbo Roll",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357333": {
            id: 62357333,
            name: "Veg Burger",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357334": {
            id: 62357334,
            name: "Veg Cheese Jumbo Roll",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357337": {
            id: 62357337,
            name: "Triple Cheese Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357338": {
            id: 62357338,
            name: "Egg Jumbo Roll",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357339": {
            id: 62357339,
            name: "Chicken Jumbo Roll",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357340": {
            id: 62357340,
            name: "Chicken Cheese Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357341": {
            id: 62357341,
            name: "Garlic Chicken Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357342": {
            id: 62357342,
            name: "Grilled Chicken Burger",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357343": {
            id: 62357343,
            name: "Masala Chicken Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357345": {
            id: 62357345,
            name: "Special Chicken Burger",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357346": {
            id: 62357346,
            name: "Chicken Tikka Sandwich",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:48 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357347": {
            id: 62357347,
            name: "Grilled Prawn Jumbo Roll",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357352": {
            id: 62357352,
            name: "Prawn Pakoda",
            category: "Quick Bites",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357353": {
            id: 62357353,
            name: "Mineral Water [1 Litre]",
            category: "Desserts And Beverages",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357354": {
            id: 62357354,
            name: "Butter Milk",
            category: "Desserts And Beverages",
            description: "",
            cloudinaryImageId: "iwnt1jgl3nabwnwdznl5",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357355": {
            id: 62357355,
            name: "Gulab Jamun [2 Pieces]",
            category: "Desserts And Beverages",
            description: "",
            cloudinaryImageId: "zn0faob6tc4am4ohvfka",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357356": {
            id: 62357356,
            name: "Coke [750 Ml]",
            category: "Desserts And Beverages",
            description: "| 750 Ml |",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357358": {
            id: 62357358,
            name: "Sprite [750 Ml]",
            category: "Desserts And Beverages",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62357359": {
            id: 62357359,
            name: "Thums Up [750 Ml]",
            category: "Desserts And Beverages",
            description: "| 750 Ml |",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "78911541": {
            id: 78911541,
            name: "Gongura Chicken Biryani",
            category: "Biryani And Rice",
            description: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "428",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 62357212,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Quick Bites",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 2296082,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357329,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357330,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357332,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357333,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357334,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357338,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357339,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357342,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357345,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357347,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296257,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357352,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357326,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357328,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357331,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357337,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296087,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357340,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357341,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357343,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357346,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Snack Time Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 2296057,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357202,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296060,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653749,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296058,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296061,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296062,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653758,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653755,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357205,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653745,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653747,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653746,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653748,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653753,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653751,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653752,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653754,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Starters",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 2296081,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296237,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357235,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296086,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296095,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296084,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296085,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296092,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296091,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296096,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296093,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296094,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357237,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653776,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296303,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296256,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 52083730,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357239,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296264,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357242,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296258,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296262,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296260,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296261,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296263,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 52083731,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296276,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357256,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296279,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357259,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296269,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357265,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296266,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357266,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296424,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296271,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296326,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653765,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357268,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653774,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357269,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357270,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357271,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357272,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296425,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357274,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 3653775,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Biryani And Rice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 78911541,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357209,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357210,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922832,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922810,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357211,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296436,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296437,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296435,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357212,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922812,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922816,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922814,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922818,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922828,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922822,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357214,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Combos",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 44557369,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 44557372,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357215,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 44557373,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357218,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357219,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357221,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357222,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357223,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357224,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357225,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 44557368,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357226,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357227,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357228,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357229,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357230,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357231,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357233,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357234,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Main Course",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 2296280,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296281,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357275,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357276,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296283,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357277,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357278,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922803,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357280,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357281,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296292,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296293,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296295,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357283,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296294,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357284,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296288,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357285,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922804,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296305,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296308,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296307,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296306,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296310,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296314,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357286,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296312,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296321,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357287,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296311,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296320,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357288,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296317,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296315,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296316,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296318,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357289,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296319,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296325,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357290,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357293,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fried Rice And Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 62357294,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296441,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357296,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357297,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296443,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296444,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296445,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296447,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357304,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296449,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296450,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296451,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357311,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357313,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Pastas",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 62357314,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296078,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296156,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296157,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Breads",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 2296453,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357316,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205035,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296455,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205036,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296454,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205029,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296460,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205038,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205030,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357320,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357321,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205031,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296459,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205032,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296461,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205034,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 7205033,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Egg Preparations",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 62357322,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357323,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357324,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357325,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Desserts And Beverages",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 922851,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357353,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357354,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357355,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 922847,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357356,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357358,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357359,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2296488,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "MOMOS",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 62357197,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357198,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357199,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357200,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357203,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62357204,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "menu_merchandise",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "20% OFF UPTO ₹50",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["8510c7db-0767-47f2-9bca-6e626b2584c7"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE TRYNEW",
          description: "ABOVE ₹159",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "FLAT DEAL",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["bf7301f0-505d-4cbc-9073-0e6df13835cb"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FLATDEAL",
          description: "ABOVE ₹499",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 3,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11222334001522"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "50e9ac55-475b-4248-b3a8-6de8e51130df",
      timeStamp: "1677489005594",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "XSvFhM25f5vZ-y_za2DsDvuN1C93l_D0ZuR4Wso0",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "592285",
      name: "Shyamji's Chole Bhature",
      uuid: "cf0fce9a-f4a2-4880-9985-7a35480404ae",
      slug: "shyamji's-chole-bhature-koramangala-koramangala",
      latLong: "12.935482,77.621205",
      city: "Bangalore",
      area: "Koramangala",
      areaPostalCode: "560034",
      areaSlug: "koramangala",
      restaurantSlug: {
        restaurant: "shyamji's-chole-bhature-koramangala-koramangala",
        city: "bangalore",
      },
      type: "F",
      locality: "5th Block",
      avgRating: 4.3,
      totalRatings: 100,
      avgRatingString: "4.3",
      totalRatingsString: "100+ ratings",
      cloudinaryImageId: "ugxnshnc5dctksihttvq",
      costForTwo: 40000,
      costForTwoMsg: "₹400 for two",
      cuisines: ["North Indian", "Beverages"],
      minimumOrder: 0,
      opened: 1,
      parentId: 255424,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "19 MINS",
        lastMileDistanceString: "0.4 kms",
        restaurantId: "592285",
        deliveryTime: 19,
        minDeliveryTime: 19,
        maxDeliveryTime: 19,
        lastMileTravel: 0.4,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.8921691179275513,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 1,
      },
      availability: {
        nextCloseTime: "2023-02-27 16:00:00",
        nextChangeTime: 1677493800000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "No. 3, 70/1, 17th Cross, B Main, 5th Block, Koramangla, Bengaluru, 560095",
        },
        { title: "Cuisines", message: "North Indian,Beverages" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "98877180": {
            id: 98877180,
            name: "Bedmi Poori (3 Pcs Poori)",
            category: "Main Course",
            description:
              "Bedmi puri is a very famous breakfast usually eaten in Delhi and some parts of Uttar Pradesh. It is paired with jeera hing aloo sabji and is quite filling.",
            cloudinaryImageId: "hina4z5hfvbbnugdvttj",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 59545135,
                group_name: "Add On",
                choices: [
                  {
                    id: 47983549,
                    name: "Sweet Malai Lassi",
                    price: 9000,
                    inStock: 0,
                    isVeg: 1,
                    order: 999,
                    default: 0,
                  },
                  {
                    id: 47983550,
                    name: "Chaas",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 997,
                    default: 0,
                  },
                  {
                    id: 47983551,
                    name: "Gulab Jamun",
                    price: 4000,
                    inStock: 1,
                    isVeg: 1,
                    order: 996,
                    default: 0,
                  },
                  {
                    id: 47983552,
                    name: "Malai Rabdi",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 995,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 999,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98877181": {
            id: 98877181,
            name: "Chole Bhature",
            category: "Main Course",
            description:
              "Purely Delhi style light, soft and fluffy bhature served with spicy and tangy cholle, carrot pickle, onions plus coriander and mint chutney. This will surely tantalize your taste buds as we serve the staple food of Delhi.",
            cloudinaryImageId: "rziiuo9r9ia6esikvqvg",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "18475504",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half (1 Pc)",
                      price: 120,
                      default: 1,
                      id: "61958561",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "18475504",
                      order: 999,
                    },
                    {
                      name: "Full (2 Pcs)",
                      price: 170,
                      default: 0,
                      id: "61958562",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "18475504",
                      order: 998,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "18475504", variation_id: "61958561" },
                  ],
                  price: 12000,
                  addon_combinations: [
                    { group_id: "59545136", addon_id: "47983549" },
                    { group_id: "59545136", addon_id: "47983550" },
                    { group_id: "59545136", addon_id: "47983551" },
                    { group_id: "59545136", addon_id: "47983552" },
                  ],
                },
                {
                  variations: [
                    { group_id: "18475504", variation_id: "61958562" },
                  ],
                  price: 17000,
                  addon_combinations: [
                    { group_id: "59545136", addon_id: "47983549" },
                    { group_id: "59545136", addon_id: "47983550" },
                    { group_id: "59545136", addon_id: "47983551" },
                    { group_id: "59545136", addon_id: "47983552" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 59545136,
                group_name: "Add On",
                choices: [
                  {
                    id: 47983549,
                    name: "Sweet Malai Lassi",
                    price: 9000,
                    inStock: 0,
                    isVeg: 1,
                    order: 999,
                    default: 0,
                  },
                  {
                    id: 47983550,
                    name: "Chaas",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 997,
                    default: 0,
                  },
                  {
                    id: 47983551,
                    name: "Gulab Jamun",
                    price: 4000,
                    inStock: 1,
                    isVeg: 1,
                    order: 996,
                    default: 0,
                  },
                  {
                    id: 47983552,
                    name: "Malai Rabdi",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 995,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 999,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            defaultPrice: 12000,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98877182": {
            id: 98877182,
            name: "Extra Aloo Sabji",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "cz6gzdhiuizjxlhprjhe",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 59545137,
                group_name: "Add On",
                choices: [
                  {
                    id: 47983549,
                    name: "Sweet Malai Lassi",
                    price: 9000,
                    inStock: 0,
                    isVeg: 1,
                    order: 999,
                    default: 0,
                  },
                  {
                    id: 47983550,
                    name: "Chaas",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 997,
                    default: 0,
                  },
                  {
                    id: 47983551,
                    name: "Gulab Jamun",
                    price: 4000,
                    inStock: 1,
                    isVeg: 1,
                    order: 996,
                    default: 0,
                  },
                  {
                    id: 47983552,
                    name: "Malai Rabdi",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 995,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 999,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98877183": {
            id: 98877183,
            name: "Extra Bhatura",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "uxtvyq6nfgmvgoxwqmok",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 59545138,
                group_name: "Add On",
                choices: [
                  {
                    id: 47983549,
                    name: "Sweet Malai Lassi",
                    price: 9000,
                    inStock: 0,
                    isVeg: 1,
                    order: 999,
                    default: 0,
                  },
                  {
                    id: 47983550,
                    name: "Chaas",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 997,
                    default: 0,
                  },
                  {
                    id: 47983551,
                    name: "Gulab Jamun",
                    price: 4000,
                    inStock: 1,
                    isVeg: 1,
                    order: 996,
                    default: 0,
                  },
                  {
                    id: 47983552,
                    name: "Malai Rabdi",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 995,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 999,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98877184": {
            id: 98877184,
            name: "Extra Chole",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "uyku0onsdfxpf082o14s",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 59545139,
                group_name: "Add On",
                choices: [
                  {
                    id: 47983549,
                    name: "Sweet Malai Lassi",
                    price: 9000,
                    inStock: 0,
                    isVeg: 1,
                    order: 999,
                    default: 0,
                  },
                  {
                    id: 47983550,
                    name: "Chaas",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 997,
                    default: 0,
                  },
                  {
                    id: 47983551,
                    name: "Gulab Jamun",
                    price: 4000,
                    inStock: 1,
                    isVeg: 1,
                    order: 996,
                    default: 0,
                  },
                  {
                    id: 47983552,
                    name: "Malai Rabdi",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 995,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 999,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98877185": {
            id: 98877185,
            name: "Extra Poori [1 Pc]",
            category: "Main Course",
            description: "",
            cloudinaryImageId: "c00b6364bc6ee2be5c5be3c0422c1e6e",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 59545140,
                group_name: "Add On",
                choices: [
                  {
                    id: 47983549,
                    name: "Sweet Malai Lassi",
                    price: 9000,
                    inStock: 0,
                    isVeg: 1,
                    order: 999,
                    default: 0,
                  },
                  {
                    id: 47983550,
                    name: "Chaas",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 997,
                    default: 0,
                  },
                  {
                    id: 47983551,
                    name: "Gulab Jamun",
                    price: 4000,
                    inStock: 1,
                    isVeg: 1,
                    order: 996,
                    default: 0,
                  },
                  {
                    id: 47983552,
                    name: "Malai Rabdi",
                    price: 7000,
                    inStock: 1,
                    isVeg: 1,
                    order: 995,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 999,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98904135": {
            id: 98904135,
            name: "Gulab Jamun (1 Pc)",
            category: "Sweets",
            description:
              "Melt in mouth gulab jamun that will fulfill your sweet cravings for the day sure. This is a real treat for the sweet lovers.",
            cloudinaryImageId: "axqdnmrbl5npbr924jza",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98904136": {
            id: 98904136,
            name: "Malai Rabdi",
            category: "Sweets",
            description:
              "Rich and thick rabdi made from full cream milk. You will definitely crave for more. Qty (100 gms).",
            cloudinaryImageId: "nyxtk8ixlr10lxlirmrd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98904138": {
            id: 98904138,
            name: "Malai Rabdi Gulab Jamun",
            category: "Sweets",
            description: "",
            cloudinaryImageId: "t49r8edilagrv8h9hdtk",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98904139": {
            id: 98904139,
            name: "Chaas",
            category: "Drinks",
            description:
              "Creamy summer drink made of Curd with blend of Dhania & Roasted Jeera, toped with Khara Boondi.",
            cloudinaryImageId: "qrf9bdcdfqyzxi9qzq8y",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98904140": {
            id: 98904140,
            name: "Sweet Malai Lassi",
            category: "Drinks",
            description:
              "Creamy thick lassi with a layer of malai. You need to try this which is a delicacy of Punjab. Balle balle.",
            cloudinaryImageId: "i00pbdg7cw5oqbzn96ak",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102194266": {
            id: 102194266,
            name: "Chole Bhature + 1 Malai Lassi",
            category: "  Combos ",
            description: "",
            cloudinaryImageId: "zv5acjaniegsgjx8zvxp",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102194267": {
            id: 102194267,
            name: "Chole Bhature + 1 Pc Gulab Jamun",
            category: "  Combos ",
            description: "",
            cloudinaryImageId: "vmv6tdwvm4swqejl0iwg",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102194268": {
            id: 102194268,
            name: "Chole Bhature + 1 Malai Lassi + 1 Pc Gulab Jamun",
            category: "  Combos ",
            description: "",
            cloudinaryImageId: "fdfni2kdw6c7ooqah8gf",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 28500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "592285",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 102194266,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102194267,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 102194268,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98877180,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98877181,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98877182,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98877183,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98877184,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98904135,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98904136,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98904138,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98904139,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98904140,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "  Combos ",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102194266,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102194267,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102194268,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Main Course",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 98877180,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98877181,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98877182,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98877183,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98877184,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98877185,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Sweets",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 98904135,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98904136,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98904138,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Drinks",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 98904139,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98904140,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "normal",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "FLAT100 off",
        shortDescriptionList: [
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off | Use PARTY",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off | Use code PARTY",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "FLAT DEAL",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["b97cad11-5d94-4809-9b89-352e1826938d"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FLATDEAL",
          description: "ABOVE ₹499",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT 20% OFF",
          offer_tag: "FLAT DEAL",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["cc9fc61d-a84d-43a8-81bc-15c88a0de609"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE PARTY",
          description: "ABOVE ₹800",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "FLAT100 off",
        shortDescriptionList: [
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off | Use PARTY",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off | Use code PARTY",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 560,
          maxValue: 800,
          priority: 2,
          couponCode: "PARTY",
          discountInfo: {
            discountType: "Percentage",
            value: 20,
            operationType: "RESTAURANT",
          },
          lockedMessage:
            "Add items worth ₹<amount> to unlock flat 20% off | Code PARTY",
          unlockedMessage: "PARTY Coupon Unlocked! Use it to save flat 20% off",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 3,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11222334001293"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      select: false,
      slotInvalid: false,
      cafe: false,
      preorderable: false,
      requestId: "3929debe-9baa-45f9-a39d-ac864e5d58ee",
      timeStamp: "1677489141513",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "Q1NzgKw67a9M-S7RKr3QegMRic0hIJ--UbOddyto",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "337335",
      name: "Kannur food kitchen",
      uuid: "c70b61bc-0f68-4e24-996b-749fbf295c35",
      slug: "kannur-food-kitchen-btm-btm",
      latLong: "12.923859,77.611183",
      city: "Bangalore",
      area: "BTM Layout",
      areaPostalCode: "560068",
      areaSlug: "BTM",
      restaurantSlug: {
        restaurant: "kannur-food-kitchen-btm-btm",
        city: "bangalore",
      },
      type: "F",
      locality: "1st  Stage",
      avgRating: 3.8,
      totalRatings: 1000,
      avgRatingString: "3.8",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "a27weqanhnszqiuzsoik",
      costForTwo: 20000,
      costForTwoMsg: "₹200 for two",
      cuisines: ["Kerala", "Biryani"],
      minimumOrder: 0,
      opened: 1,
      parentId: 114756,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: false,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "25 MINS",
        lastMileDistanceString: "2.5 kms",
        restaurantId: "337335",
        deliveryTime: 25,
        minDeliveryTime: 25,
        maxDeliveryTime: 25,
        lastMileTravel: 2.5,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.5902301073074341,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 4,
      },
      availability: {
        nextCloseTime: "2023-02-28 04:00:00",
        nextChangeTime: 1677537000000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "kannur food point, Chocolate Factory Road, Tavarekere, Cashier Layout, 1st Stage, BTM Layout, thavrakharea, Karnataka, India",
        },
        { title: "Cuisines", message: "Kerala,Biryani" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "63403650": {
            id: 63403650,
            name: "Kadala Curry.[can not provied salad and chutney]",
            category: "Veg Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            final_price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79092342,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092341,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092340,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403651": {
            id: 63403651,
            name: "Cherupayar Curry[can not provied salad and chutney]",
            category: "Veg Curry",
            description: "[serves1]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            final_price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79092353,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092352,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092355,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403652": {
            id: 63403652,
            name: "Veg Kurma",
            category: "Veg Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79092343,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092345,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092344,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403653": {
            id: 63403653,
            name: "Green Peas Curry[can not provied salad and chutney]",
            category: "Veg Curry",
            description: "[serves1]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            final_price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79092336,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092339,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092337,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403654": {
            id: 63403654,
            name: "Egg Keema[can not provied salad and chutney]",
            category: "Egg Items",
            description: "[serves1]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            final_price: 6300,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403655": {
            id: 63403655,
            name: "Gobi Manchurian",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "98a258ca96780ff034c1590a6e6acffd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929182",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792976",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929182",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792977",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929182",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403656": {
            id: 63403656,
            name: "Veg Kadai.[can not provied salad and chutney]",
            category: "Veg Curry",
            description: "[serves1]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            final_price: 6500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79092347,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092350,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092348,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403657": {
            id: 63403657,
            name: "Egg Roast[can not provied salad and chutney]",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403658": {
            id: 63403658,
            name: "Gobi 65",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929181",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792974",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929181",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792975",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929181",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403659": {
            id: 63403659,
            name: "Dal Curry",
            category: "Veg Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79092329,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092326,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092333,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403660": {
            id: 63403660,
            name: "Egg Curry[can not provied salad and chutney]",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "11171298",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half (1 Pc)",
                      price: 0,
                      default: 1,
                      id: "36796670",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11171298",
                      order: 999,
                    },
                    {
                      name: "Full (2 Pcs)",
                      price: 3000,
                      default: 0,
                      id: "36796671",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11171298",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403661": {
            id: 63403661,
            name: "Gobi Chilli",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929178",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792966",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929178",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792967",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929178",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403662": {
            id: 63403662,
            name: "Egg Chilli",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403663": {
            id: 63403663,
            name: "Mushroom Chilli",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929177",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792964",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929177",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792965",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929177",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403664": {
            id: 63403664,
            name: "Chicken Puttu Mix",
            category: "KFK Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403665": {
            id: 63403665,
            name: "Egg Pepper",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403666": {
            id: 63403666,
            name: "Mushroom Manchurian",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929176",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792962",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929176",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792963",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929176",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403667": {
            id: 63403667,
            name: "Egg Puttu Mix",
            category: "KFK Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403668": {
            id: 63403668,
            name: "Egg Manchurain",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403669": {
            id: 63403669,
            name: "Mushroom 65",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929175",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792960",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929175",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792961",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929175",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403670": {
            id: 63403670,
            name: "Veg Puttu Mix",
            category: "KFK Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20500,
            final_price: 10300,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403672": {
            id: 63403672,
            name: "Egg 65",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403674": {
            id: 63403674,
            name: "Egg Garlic",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403675": {
            id: 63403675,
            name: "Paneer 65",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929174",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792958",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929174",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792959",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929174",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403677": {
            id: 63403677,
            name: "Paneer Chilli",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "6f9515e821c9dc2f8bcdba74f6c97597",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929173",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792956",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929173",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792957",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929173",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403678": {
            id: 63403678,
            name: "Neypathiri Egg Mix",
            category: "KFK Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403679": {
            id: 63403679,
            name: "Puttu",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403680": {
            id: 63403680,
            name: "Chicken Neypathiri.[can not provied salad and chutney]",
            category: "KFK Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403682": {
            id: 63403682,
            name: "Chicken Kappa Mix",
            category: "KFK Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403683": {
            id: 63403683,
            name: "Appam",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            final_price: 1000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "1 piece",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403685": {
            id: 63403685,
            name: "Idiyappam",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            final_price: 1000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403689": {
            id: 63403689,
            name: "Chapati",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            final_price: 1000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "1 piece",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403697": {
            id: 63403697,
            name: "Salt Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403699": {
            id: 63403699,
            name: "Sweet Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403700": {
            id: 63403700,
            name: "Mint Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403701": {
            id: 63403701,
            name: "Chicken Kondattam",
            category: "KFK Special Chicken Curry",
            description:
              "Famous dish of malabar cooked with red chillies and spices marinated in chicken chunks and it is very spicy in taste.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790480",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217484",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790480",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217485",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790480",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 79092512,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092508,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092507,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403702": {
            id: 63403702,
            name: "Pepper Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403704": {
            id: 63403704,
            name: "Masala Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403705": {
            id: 63403705,
            name: "Sweet & Salt Soda",
            category: "Soda",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403707": {
            id: 63403707,
            name: "Mosambi Juice",
            category: "Fresh Juice",
            description: "Vitamin C rich juice made with fresh mosambis.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403708": {
            id: 63403708,
            name: "Chicken 2020",
            category: "KFK Special Chicken Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790483",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "29217490",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790483",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "29217491",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790483",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "32793067",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790483",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 79092497,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092501,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092498,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403709": {
            id: 63403709,
            name: "Pineapple Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403712": {
            id: 63403712,
            name: "Orange Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403714": {
            id: 63403714,
            name: "Chicken Kooval",
            category: "KFK Special Chicken Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790485",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217494",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790485",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217495",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790485",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 79092492,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092490,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092494,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403715": {
            id: 63403715,
            name: "Apple Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403716": {
            id: 63403716,
            name: "Chicken Palai",
            category: "KFK Special Chicken Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790486",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "29217496",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790486",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "29217497",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790486",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "32793062",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790486",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403717": {
            id: 63403717,
            name: "Papaya Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403718": {
            id: 63403718,
            name: "Muskmelon Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403720": {
            id: 63403720,
            name: "Watermelon Juice",
            category: "Fresh Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403721": {
            id: 63403721,
            name: "Anar Juice",
            category: "Fresh Juice",
            description:
              "Pineapple juice is a liquid made from pressing the pulp of pomegranate.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403722": {
            id: 63403722,
            name: "Chicken Chukka",
            category: "KFK Special Chicken Curry",
            description:
              "Chicken sukka is an intensely flavourful dish, made with host of spices, fresh coconut and just two tablespoons of oil.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790488",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217500",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790488",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217501",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790488",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 79092463,
                group_name: "Beverage in Curry",
                choices: [
                  {
                    id: 63920270,
                    name: "Fresh Lime Juice",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092467,
                group_name: "Indian Breads in Curry",
                choices: [
                  {
                    id: 63920272,
                    name: "Rumali Roti (1 Pc)",
                    price: 3000,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 79092466,
                group_name: "Rice in Curry",
                choices: [
                  {
                    id: 63920271,
                    name: "Ghee Rice (Half)",
                    price: 13500,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403723": {
            id: 63403723,
            name: "Lassi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403724": {
            id: 63403724,
            name: "Strawberry Lassi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403725": {
            id: 63403725,
            name: "Chilli Chicken",
            category: "Chicken Items",
            description:
              "A mouthwatering dish prepared with chicken fried to golden brown and stir fried with assorted vegetables and spicy sauces.",
            cloudinaryImageId: "2e37addbacdc14b753213336d0b0bfd2",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790489",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217502",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790489",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217503",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790489",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403726": {
            id: 63403726,
            name: "Mango Lassi",
            category: "Lassi",
            description:
              "A creamy and rich lassi made from yogurt and pulpy mangos - refreshing drink for your thirst.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403727": {
            id: 63403727,
            name: "Pineapple Lassi",
            category: "Lassi",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403728": {
            id: 63403728,
            name: "Chicken Manchurian",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "992ada23b3af4f3af47e9e93d4ab8c97",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790490",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217504",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790490",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217505",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790490",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403729": {
            id: 63403729,
            name: "Fresh Lime  Juice",
            category: "Lime Juice",
            description: "",
            cloudinaryImageId: "lmjf4h5nvkldwghxhdri",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            final_price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403730": {
            id: 63403730,
            name: "Pepper Chicken",
            category: "Chicken Items",
            description:
              "Chicken pieces tossed in pepper and prepared using traditional spices.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790491",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217506",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790491",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217507",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790491",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403731": {
            id: 63403731,
            name: "Mint Lime  Juice",
            category: "Lime Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            final_price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403732": {
            id: 63403732,
            name: "Ginger Lime  Juice",
            category: "Lime Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            final_price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403734": {
            id: 63403734,
            name: "Strawberry Lime  Juice",
            category: "Lime Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403735": {
            id: 63403735,
            name: "Pineapple Lime  Juice",
            category: "Lime Juice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403736": {
            id: 63403736,
            name: "Chicken 65",
            category: "Chicken Items",
            description:
              "Juicy chicken chunks dipped in seasoned batter and fried to perfection.",
            cloudinaryImageId: "epsjyntp9vnjd0b4gp8j",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790493",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217510",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790493",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217511",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790493",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403737": {
            id: 63403737,
            name: "Chikku  Shake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "f602d0b0a7a5717febf101db75dd1c6e",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403738": {
            id: 63403738,
            name: "Garlic Chicken",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "0e8ceb7e6e75ff14cc48a43ba53130d4",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790494",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217512",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790494",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217513",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790494",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403739": {
            id: 63403739,
            name: "Papaya Milkshake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403740": {
            id: 63403740,
            name: "Butter Fruit Shake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403741": {
            id: 63403741,
            name: "Ginger Chicken",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790495",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217514",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790495",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217515",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790495",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403743": {
            id: 63403743,
            name: "Apple Milkshake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403744": {
            id: 63403744,
            name: "Lemon Chicken",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790496",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217516",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790496",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217517",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790496",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403745": {
            id: 63403745,
            name: "Chicken Kurma",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790497",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "29217518",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790497",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "29217519",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790497",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "32793046",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790497",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403747": {
            id: 63403747,
            name: "Chicken Curry",
            category: "Chicken Items",
            description:
              "A tomato-based gravy with hint of tamarind, ginger, green chilies, and coconut milk with tender chicken.",
            cloudinaryImageId: "hwqldexj4x7jwbgcekam",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790499",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "29217522",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790499",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "29217523",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790499",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "32793025",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790499",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403748": {
            id: 63403748,
            name: "Chicken Roast",
            category: "Chicken Items",
            description:
              "A semi dry chicken dish made with a delicious blend of marinated and fried chicken sauteed with a spicy tangy masala.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790500",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217524",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790500",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217525",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790500",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403749": {
            id: 63403749,
            name: "Chicken Masala",
            category: "Chicken Items",
            description:
              "Soft chicken soaked in a rich and creamy gravy an all time favourite dish.",
            cloudinaryImageId: "4d4d002af1ead90e41ad62e1a52ba5c0",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790501",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "29217526",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790501",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "29217527",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790501",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "32793024",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790501",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403751": {
            id: 63403751,
            name: "Oreo Shake",
            category: "Milk Shake",
            description:
              "A refreshing milkshake prepared with chocolate, Oreo crumbs and wholesome milk - perfect to satisfy your cravings.",
            cloudinaryImageId: "1eb7e1ce351f98b89be269474c447257",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403753": {
            id: 63403753,
            name: "Chicken Keema",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790504",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217532",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790504",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217533",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790504",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403754": {
            id: 63403754,
            name: "Strawberry Shake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "da1cdf80ee1669c0c1d7e3e70e06b90a",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403756": {
            id: 63403756,
            name: "Anar Shake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403758": {
            id: 63403758,
            name: "Chicken Fry",
            category: "Chicken Items",
            description:
              "Tender chicken marinated in flavoured spices and deep fried in oil.",
            cloudinaryImageId: "sxnpepmwg2atrrrizkbd",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790507",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217538",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790507",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 15900,
                      default: 0,
                      id: "29217539",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790507",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403761": {
            id: 63403761,
            name: "Musk Melon Milkshake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403762": {
            id: 63403762,
            name: "Kozhi Kooval",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790509",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217542",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790509",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 20000,
                      default: 0,
                      id: "29217543",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790509",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403763": {
            id: 63403763,
            name: "Cold Boost Milkshake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403765": {
            id: 63403765,
            name: "Cold Coffee Milkshake",
            category: "Milk Shake",
            description:
              "A soothing shake made by blending cold coffee and ice cream together.",
            cloudinaryImageId: "130cb6de391977a8304948572993d76e",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403766": {
            id: 63403766,
            name: "Cold Horlicks Milkshake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            final_price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403767": {
            id: 63403767,
            name: "Appam + Egg Roast",
            category: "Combos",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403768": {
            id: 63403768,
            name: "Appam + Egg Curry",
            category: "Combos",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403769": {
            id: 63403769,
            name: "Appam + Fish Curry",
            category: "Combos",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            final_price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403770": {
            id: 63403770,
            name: "Idiyappam + Egg Roast",
            category: "Combos",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            final_price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403773": {
            id: 63403773,
            name: "Ghee Rice + Chicken Curry",
            category: "Combos",
            description:
              "A delightfully wholesome combo with aromatic ghee rice and our special chicken curry.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            final_price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403774": {
            id: 63403774,
            name: "Ghee Rice + Chicken Fry",
            category: "Combos",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            final_price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403777": {
            id: 63403777,
            name: "Ghee Rice + Dal Curry + Chicken Kabab",
            category: "Combos",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            final_price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403778": {
            id: 63403778,
            name: "Meals + Fish Fry",
            category: "Combos",
            description:
              "Boiled Rice + Cocount Fish Gravy + Sambar + Papad + Thoran",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            final_price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403779": {
            id: 63403779,
            name: "Meals + Fish Curry",
            category: "Combos",
            description:
              "Boiled Rice + Cocount Fish Gravy + Sambar + Papad + Thoran",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            final_price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403780": {
            id: 63403780,
            name: "Meals + Chicken Curry",
            category: "Combos",
            description:
              "Boiled Rice + Cocount Fish Gravy + Sambar + Papad + Thoran",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            final_price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403781": {
            id: 63403781,
            name: "Meals + Chicken Fry",
            category: "Combos",
            description:
              "Boiled Rice + Cocount Fish Gravy + Sambar + Papad + Thoran",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            final_price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403783": {
            id: 63403783,
            name: "Meals + Omelette",
            category: "Combos",
            description:
              "Boiled Rice + Cocount Fish Gravy + Sambar + Papad + Thoran",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 9500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403784": {
            id: 63403784,
            name: "Kerala Meals",
            category: "Combos",
            description:
              "Boiled Rice + Cocount Fish Gravy + Sambar + Papad + Thoran",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403785": {
            id: 63403785,
            name: "Chicken Fried Rice",
            category: "Fried Rice",
            description:
              "Delectable rice tossed along with assorted fresh veggies, chicken and sauce and spices perfect to satisfy your hunger.",
            cloudinaryImageId: "2b5cfc889442ea59d339d26909130bdb",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 8000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929232",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793103",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929232",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 7000,
                      default: 0,
                      id: "32793104",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929232",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403786": {
            id: 63403786,
            name: "Egg Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "47cfe6d7c5a4fc058bfc757f2de5dc18",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            final_price: 7800,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929231",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793101",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929231",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 4400,
                      default: 0,
                      id: "32793102",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929231",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403787": {
            id: 63403787,
            name: "Veg Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            final_price: 6500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929230",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793099",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929230",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 6000,
                      default: 0,
                      id: "32793100",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929230",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403788": {
            id: 63403788,
            name: "Mushroom Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            final_price: 6500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929229",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793097",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929229",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 6000,
                      default: 0,
                      id: "32793098",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929229",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403789": {
            id: 63403789,
            name: "Paneer Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            final_price: 6500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929228",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793095",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929228",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 6000,
                      default: 0,
                      id: "32793096",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929228",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403790": {
            id: 63403790,
            name: "Gobi Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "54da171e9ced4dedd8131f750d9f7414",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            final_price: 6500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929227",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793093",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929227",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 6000,
                      default: 0,
                      id: "32793094",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929227",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403792": {
            id: 63403792,
            name: "Chicken Noodles",
            category: "Noodles",
            description:
              "Chinese style dish cooked with noodles are tossed with vegetables, chicken, and Chinese sauces.",
            cloudinaryImageId: "a52ermvqfpltrvb4ovzs",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929226",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793091",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929226",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32793092",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929226",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403793": {
            id: 63403793,
            name: "Egg Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 8000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929225",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793089",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929225",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 3000,
                      default: 0,
                      id: "32793090",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929225",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403794": {
            id: 63403794,
            name: "Veg Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            final_price: 6500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929224",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Full",
                      price: 6000,
                      default: 0,
                      id: "32793088",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929224",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793087",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929224",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403795": {
            id: 63403795,
            name: "Mushroom Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 8000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929223",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793085",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929223",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 3000,
                      default: 0,
                      id: "32793086",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929223",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403796": {
            id: 63403796,
            name: "Paneer Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 8000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929222",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793083",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929222",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 3000,
                      default: 0,
                      id: "32793084",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929222",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403797": {
            id: 63403797,
            name: "Gobi Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 8000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929221",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793081",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929221",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 3000,
                      default: 0,
                      id: "32793082",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929221",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403799": {
            id: 63403799,
            name: "Thalassery Chicken Biryani",
            category: "Biryani",
            description:
              "Thalassery biriyani is a delicious mix of fragrant rice, spices, and chicken in a soulful gravy, married together by slow Kerala style cooking to absorb the flavours.",
            cloudinaryImageId: "watevctlyqwgjz0qkbr7",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790511",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217546",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790511",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 8000,
                      default: 0,
                      id: "29217547",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790511",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403800": {
            id: 63403800,
            name: "Hyderabadi Chicken Dum Biryani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            final_price: 11000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8790512",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "29217548",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790512",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 8000,
                      default: 0,
                      id: "29217549",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8790512",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Served with Salan",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403801": {
            id: 63403801,
            name: "Egg Biryani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "de256d11febad4dffe00364d3816911a",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            final_price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403802": {
            id: 63403802,
            name: "Biryani Rice",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "a8a7010124a129107a65ddd3d2c32313",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            final_price: 6800,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929220",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793079",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929220",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 6400,
                      default: 0,
                      id: "32793080",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929220",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403803": {
            id: 63403803,
            name: "Ghee Rice",
            category: "Biryani",
            description:
              "Basmati ghee rice with cashew and mild spices made to aroma.",
            cloudinaryImageId: "a840a3a7f15f6defd64b8c947b0fceef",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            final_price: 6800,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929219",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32793077",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929219",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 6400,
                      default: 0,
                      id: "32793078",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929219",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403804": {
            id: 63403804,
            name: "Plain White Rice",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10900,
            final_price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403807": {
            id: 63403807,
            name: "Chicken Kabsa",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "e8b940172d202d633ec51fc6b4207f0a",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28900,
            final_price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63403808": {
            id: 63403808,
            name: "Egg Bhurji",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63487005": {
            id: 63487005,
            name: "Chicken Mandhi",
            category: "Chicken Items",
            description:
              "Big pieces of chicken are cooked in dry roasted whole spices and served over a layer of fragrant basmati rice.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28900,
            final_price: 14500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8810048",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "29272266",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8810048",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 33000,
                      default: 0,
                      id: "29272267",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8810048",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 86000,
                      default: 0,
                      id: "29272268",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8810048",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63487006": {
            id: 63487006,
            name: "Chicken Alfaham",
            category: "Chicken Items",
            description:
              "A delightfully wholesome combo of succulent chicken alfaham.",
            cloudinaryImageId: "865c3b0f87fb59fa8639478c9eb22b84",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            final_price: 11500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "8810049",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "29272269",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8810049",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 20000,
                      default: 0,
                      id: "29272270",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8810049",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 62000,
                      default: 0,
                      id: "29272271",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8810049",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "68836145": {
            id: 68836145,
            name: "Paneer Manchurian",
            category: "Veg Chinese",
            description: "",
            cloudinaryImageId: "645dac59efbf265810fbba74bff651a3",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929166",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "32792936",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929166",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "32792937",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "9929166",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "68836211": {
            id: 68836211,
            name: "Chicken Kuruma",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "9929184",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "32792981",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929184",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "32792982",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929184",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "32792983",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "9929184",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "69400561": {
            id: 69400561,
            name: "Pepsi [750 ml]",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "zeynfwknduz0tsowgolt",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "69400563": {
            id: 69400563,
            name: "Mountain Dew 750 Ml",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "a8naapai3cuncqvaposi",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040175": {
            id: 70040175,
            name: "Al Fahm Mandi",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "pt4eh1xzu3jkid2qeqcg",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31200,
            final_price: 15600,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "10165563",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "33521962",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165563",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 32000,
                      default: 0,
                      id: "33521963",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165563",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 108000,
                      default: 0,
                      id: "33521964",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165563",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 4 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040176": {
            id: 70040176,
            name: "Chicken Mandi",
            category: "Arabian Special",
            description:
              "Delicious preparation of chicken cooked with flavours served over a layer of basmati rice. It is packed with flavours and taste of the perfect blend of spices.",
            cloudinaryImageId: "gwe5dhtlcpe9pudv8uuy",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31200,
            final_price: 15600,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "10165564",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "33521965",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165564",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 32000,
                      default: 0,
                      id: "33521966",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165564",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 108000,
                      default: 0,
                      id: "33521967",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165564",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040178": {
            id: 70040178,
            name: "Al Fham",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "yglcakdonkpf1t9fuukb",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            final_price: 12500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "10165566",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "33521971",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165566",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 20000,
                      default: 0,
                      id: "33521972",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165566",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 63000,
                      default: 0,
                      id: "33521973",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "10165566",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040179": {
            id: 70040179,
            name: "Soda Bottle 600 Ml",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            final_price: 2800,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040180": {
            id: 70040180,
            name: "Mineral Water Bottle [2 litre]",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            final_price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040181": {
            id: 70040181,
            name: "Water Bottle",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            final_price: 2300,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "1 litre",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040182": {
            id: 70040182,
            name: "Water Bottle 500 Ml",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            final_price: 1300,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040184": {
            id: 70040184,
            name: "Mountain Dew 250 Ml",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "h6xntqi1baii7odbsfql",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70040270": {
            id: 70040270,
            name: "Pepsi .",
            category: "Coldrinks And Drinking Water",
            description: "",
            cloudinaryImageId: "xuiji3qcfqn3hovzxoz9",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "250 ml",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70041896": {
            id: 70041896,
            name: "Kuboos ",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            final_price: 1000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "1 piece",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70041902": {
            id: 70041902,
            name: "Al Fham Combo",
            category: "Combos",
            description:
              "Quarter al fham + 2 kubus/parota/chapati +250 ml pepsi",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            final_price: 15000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "10166562",
                  name: "Choice of Breads",
                  variations: [
                    {
                      name: "2 kubus",
                      price: 0,
                      default: 1,
                      id: "33525796",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "10166562",
                      order: 999,
                    },
                    {
                      name: "Paratha",
                      price: 0,
                      default: 0,
                      id: "33525797",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "10166562",
                      order: 998,
                    },
                    {
                      name: "Chapati",
                      price: 0,
                      default: 0,
                      id: "33525798",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "10166562",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70041905": {
            id: 70041905,
            name: "Quarter Grill Chicken Combo",
            category: "Combos",
            description:
              "Quarter grill chicken + 2 kubus/parotta/chapatti +250 ml pepsi",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28900,
            final_price: 14500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "10166561",
                  name: "Choice of Breads",
                  variations: [
                    {
                      name: "2 kubus",
                      price: 0,
                      default: 1,
                      id: "33525793",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "10166561",
                      order: 999,
                    },
                    {
                      name: "Paratha",
                      price: 0,
                      default: 0,
                      id: "33525794",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "10166561",
                      order: 998,
                    },
                    {
                      name: "Chapati",
                      price: 0,
                      default: 0,
                      id: "33525795",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "10166561",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70286631": {
            id: 70286631,
            name: "Kannur Special Cocktail",
            category: "Milk Shake",
            description: "[Non Alcoholic]",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            final_price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768352": {
            id: 81768352,
            name: "Mutton Thalssery Biriyani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32000,
            final_price: 16000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "12772199",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "41505782",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "12772199",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 16000,
                      default: 0,
                      id: "41505783",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "12772199",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768354": {
            id: 81768354,
            name: "Fish Biryani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "ff61bceeafbd3e86ad2453f17d8dea8e",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32900,
            final_price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768355": {
            id: 81768355,
            name: "Mathi Fish Fry",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768356": {
            id: 81768356,
            name: "Ayala Fish Fry",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 9500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768357": {
            id: 81768357,
            name: "Fish Masala",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 9500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768358": {
            id: 81768358,
            name: "Fish Curry Ayala",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            final_price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768359": {
            id: 81768359,
            name: "Fish Curry Mathi ",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            final_price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "2 pieces",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768360": {
            id: 81768360,
            name: "Fish Fry Slice",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            final_price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81768361": {
            id: 81768361,
            name: "Fish Curry Slice",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            final_price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "83083304": {
            id: 83083304,
            name: "Rumali Roti ",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            final_price: 1500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "1 piece",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "83448998": {
            id: 83448998,
            name: "Tender Coconut Milk Shake",
            category: "Milk Shake",
            description: "",
            cloudinaryImageId: "1ccb1ef877cf56c33ec02022ca3ad3b4",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            final_price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "83773254": {
            id: 83773254,
            name: "Neymeen Fry",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "83773255": {
            id: 83773255,
            name: "Neymeen Curry",
            category: "Fish Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92697332": {
            id: 92697332,
            name: "Chicken Shawarma in Khubus",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "dd32b43c80dbc53752a4dd0338c2b138",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            final_price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92697333": {
            id: 92697333,
            name: "Chicken Shawarma in Rumali",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "d0ed9b861400e5686f25cf8ab2eea941",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 9500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92697335": {
            id: 92697335,
            name: "Special Shawarma Plate( With Khubus)",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            final_price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92697336": {
            id: 92697336,
            name: "Specail Shawarma Plate(With Rumali Roti)",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25900,
            final_price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94099009": {
            id: 94099009,
            name: "Butter Chicken",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "3352a1560cbe8a6013f3b26b995ddb2e",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            final_price: 15000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "16091043",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "53438258",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091043",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 10000,
                      default: 0,
                      id: "53438259",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091043",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94099010": {
            id: 94099010,
            name: "Chicken Kolhapuri",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "0a2e9c3c1adec6cb06a43cf8a879859d",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            final_price: 15000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "16091044",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "53438260",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091044",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 10000,
                      default: 0,
                      id: "53438261",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091044",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94099011": {
            id: 94099011,
            name: "Chicken Punjabi",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            final_price: 15000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "16091045",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "53438262",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091045",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 10000,
                      default: 0,
                      id: "53438263",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091045",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94099012": {
            id: 94099012,
            name: "Chicken Hyderabadi",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            final_price: 15000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "16091046",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "53438264",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091046",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 10000,
                      default: 0,
                      id: "53438265",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091046",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94099013": {
            id: 94099013,
            name: "Chicken Mughlai",
            category: "Chicken Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            final_price: 15000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "16091047",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "53438266",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091047",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 10000,
                      default: 0,
                      id: "53438267",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "16091047",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97660084": {
            id: 97660084,
            name: "White Rice Meals",
            category: "Combo",
            description:
              "Fish Curry+Sambar+Vegetable Mix+papad+Pickle+Puttu Curry",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97660085": {
            id: 97660085,
            name: "Egg Kolhapuri",
            category: "Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97660086": {
            id: 97660086,
            name: "Egg Punjabi",
            category: "Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97660087": {
            id: 97660087,
            name: "Egg kadai",
            category: "Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97660088": {
            id: 97660088,
            name: "Egg Hyderabadi",
            category: "Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "97660089": {
            id: 97660089,
            name: "Egg Butter Masala",
            category: "Curry",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543801": {
            id: 102543801,
            name: "Thalassery Chicken Biryani         ",
            category: "Breakfast Specials",
            description:
              "Thalassery biriyani is a delicious mix of fragrant rice, spices, and chicken in a soulful gravy, married together by slow Kerala style cooking to absorb the flavours.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 9500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "21157425",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "69818090",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157425",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 8000,
                      default: 0,
                      id: "69818091",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157425",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543802": {
            id: 102543802,
            name: "Chicken Fry         ",
            category: "Breakfast Specials",
            description:
              "Tender chicken marinated in flavoured spices and deep fried in oil.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24000,
            final_price: 12000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "21157427",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "69818098",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157427",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 15900,
                      default: 0,
                      id: "69818099",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157427",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543803": {
            id: 102543803,
            name: "Chicken Curry         ",
            category: "Breakfast Specials",
            description:
              "A tomato-based gravy with hint of tamarind, ginger, green chilies, and coconut milk with tender chicken.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "21157428",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "69818103",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157428",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "69818104",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157428",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "69818105",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157428",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543805": {
            id: 102543805,
            name: "Chicken Masala         ",
            category: "Breakfast Specials",
            description:
              "Soft chicken soaked in a rich and creamy gravy an all time favourite dish.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            final_price: 7500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "21157430",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "69818108",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157430",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 7000,
                      default: 0,
                      id: "69818110",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157430",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 27000,
                      default: 0,
                      id: "69818112",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157430",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543808": {
            id: 102543808,
            name: "Ghee Rice + Chicken Curry         ",
            category: "Breakfast Specials",
            description:
              "A delightfully wholesome combo with aromatic ghee rice and our special chicken curry.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            final_price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543811": {
            id: 102543811,
            name: "Ghee Rice + Dal Curry + Chicken Kabab         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            final_price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543813": {
            id: 102543813,
            name: "Meals + Chicken Curry         ",
            category: "Breakfast Specials",
            description:
              "Boiled Rice + Cocount Fish Gravy + Sambar + Papad + Thoran",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            final_price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543816": {
            id: 102543816,
            name: "Appam + Egg Curry         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543817": {
            id: 102543817,
            name: "Chicken Noodles         ",
            category: "Breakfast Specials",
            description:
              "Chinese style dish cooked with noodles are tossed with vegetables, chicken, and Chinese sauces.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "21157441",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 1,
                      id: "69818148",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157441",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 5000,
                      default: 0,
                      id: "69818149",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "21157441",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543822": {
            id: 102543822,
            name: "Mountain Dew 250 Ml         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543823": {
            id: 102543823,
            name: "Mountain Dew 750 Ml         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543824": {
            id: 102543824,
            name: "Coke         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "750 ml",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543825": {
            id: 102543825,
            name: "Pepsi         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            final_price: 4800,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "750 ml",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543827": {
            id: 102543827,
            name: "Pepsi ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            final_price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "250 ml",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543828": {
            id: 102543828,
            name: "Dal Curry         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            final_price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543829": {
            id: 102543829,
            name: "Fresh Lime  Juice         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            final_price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "102543831": {
            id: 102543831,
            name: "Egg Butter Masala         ",
            category: "Breakfast Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108222458": {
            id: 108222458,
            name: "Fit Thalassery Chicken Biryani",
            category: "Guiltfree",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108222459": {
            id: 108222459,
            name: "Fit Hyderabadi Chicken Biryani",
            category: "Guiltfree",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108222460": {
            id: 108222460,
            name: "Fit Fish Biryani",
            category: "Guiltfree",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108222461": {
            id: 108222461,
            name: "Fit Mutton Thalassery Biryani",
            category: "Guiltfree",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108222462": {
            id: 108222462,
            name: "Fit Chicken Kabsa",
            category: "Guiltfree",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108245459": {
            id: 108245459,
            name: "Peri Peri Al Faham",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            final_price: 12500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "23621187",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "76672286",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23621187",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 45000,
                      default: 0,
                      id: "76672287",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23621187",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 88000,
                      default: 0,
                      id: "76672288",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23621187",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108245461": {
            id: 108245461,
            name: "Peri Peri Al Faham Mandi",
            category: "Arabian Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            final_price: 17500,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "23621188",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Quarter",
                      price: 0,
                      default: 1,
                      id: "76672289",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23621188",
                      order: 999,
                    },
                    {
                      name: "Half",
                      price: 68000,
                      default: 0,
                      id: "76672290",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23621188",
                      order: 998,
                    },
                    {
                      name: "Full",
                      price: 135000,
                      default: 0,
                      id: "76672291",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23621188",
                      order: 997,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 9 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "337335",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 63403799,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403803,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403802,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403801,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 81768354,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403807,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403737,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403754,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 83448998,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403751,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403765,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403747,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403736,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403725,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403728,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403749,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403738,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 94099009,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 94099010,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63487006,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403792,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 70040176,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 70040178,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 70040184,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 70040270,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 69400563,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403729,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403785,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403786,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403790,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403655,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 68836145,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63403677,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "KFK Special",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403682,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403664,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403667,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403670,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403680,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403678,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Biryani",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403799,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403800,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403803,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403802,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403801,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403804,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768354,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403807,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768352,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Breakfast",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403689,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403679,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403683,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70041896,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403685,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Guiltfree",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 108222458,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108222459,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108222460,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108222461,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108222462,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Lassi",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403723,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403726,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403724,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403727,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Milk Shake",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403737,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403739,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403743,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403761,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403763,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403754,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403766,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70286631,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403756,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403740,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 83448998,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403751,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403765,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Chicken Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403747,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63487005,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403736,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403758,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403725,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403728,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403749,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403744,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403748,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403730,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403738,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403753,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403741,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94099009,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94099010,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94099011,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94099012,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94099013,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63487006,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 68836211,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403762,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403745,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fresh Juice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403707,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403720,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403709,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403717,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403721,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403715,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403718,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403712,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403792,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403794,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403793,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403797,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403796,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403795,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Arabian Special",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 70040176,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040178,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040175,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108245461,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108245459,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92697333,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92697335,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92697336,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92697332,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Coldrinks And Drinking Water",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 69400561,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040184,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040270,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 69400563,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040181,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040180,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040182,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70040179,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Curry",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 97660085,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97660089,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97660086,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97660087,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 97660088,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "KFK Special Chicken Curry",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403714,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403708,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403722,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403701,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403716,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Combos",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Ghee Rice",
                type: "subcategory",
                entities: [
                  {
                    id: 63403773,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403777,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403774,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Kerala Meals",
                type: "subcategory",
                entities: [
                  {
                    id: 63403778,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403780,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403781,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403779,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403783,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Others",
                type: "subcategory",
                entities: [
                  {
                    id: 63403784,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Breakfast",
                type: "subcategory",
                entities: [
                  {
                    id: 63403768,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 70041902,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403767,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403769,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 63403770,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 70041905,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Curry",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403650,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403659,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403652,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403653,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403651,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403656,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Lime Juice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403729,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403731,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403735,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403732,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403734,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Egg Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403657,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403660,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403808,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403665,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403668,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403654,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403662,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403672,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403674,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fried Rice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403785,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403786,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403787,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403789,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403788,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403790,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Breads",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 83083304,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Chinese",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403655,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 68836145,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403677,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403658,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403666,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403669,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403675,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403661,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403663,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Soda",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 63403699,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403700,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403697,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403704,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403702,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63403705,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fish Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 81768355,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768356,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768358,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768359,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768361,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768360,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81768357,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 83773254,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 83773255,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Combo",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 97660084,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Breakfast Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 102543801,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543822,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543824,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543802,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543823,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543817,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543805,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543825,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543827,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543828,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543808,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543811,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543831,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543816,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543829,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543803,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 102543813,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "normal",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "Free Limesoda",
        shortDescriptionList: [
          {
            meta: "Free Limesoda on orders above ₹499",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "Free Limesoda on orders above ₹499",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "Free Limesoda",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["1f1daf03-6c96-42dd-bb75-694210b96b81"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "NO CODE REQUIRED",
          description: "ABOVE ₹499",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT 50% OFF",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["ec112e1b-2810-44ec-8117-6651d8f9a75a"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "NO CODE REQUIRED",
          description: "",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "Free Limesoda",
        shortDescriptionList: [
          {
            meta: "Free Limesoda on orders above ₹499",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "Free Limesoda on orders above ₹499",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
          {
            meta: "50% off on all orders",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 3,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11221334001753"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      select: false,
      slotInvalid: false,
      cafe: false,
      preorderable: false,
      requestId: "270eff1a-dfb4-4a2f-88ef-3cde5d265ddf",
      timeStamp: "1677489172605",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "y1QQLxdRpmFy-xD8SW_jf-GF9P2ZnF4dDU_Vxnm4",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "108158",
      name: "Kabab magic",
      uuid: "2fc26cdc-f642-4459-9888-6661c142e8b7",
      slug: "kabab-magic-btm-2",
      latLong: "12.926549,77.61588499999993",
      city: "Bangalore",
      area: "Btm Layout",
      areaPostalCode: "560068",
      areaSlug: "BTM",
      restaurantSlug: {
        restaurant: "kabab-magic-btm-2",
        city: "bangalore",
      },
      type: "F",
      locality: "Maruti Nagar",
      avgRating: 3.9,
      totalRatings: 100,
      avgRatingString: "3.8",
      totalRatingsString: "100+ ratings",
      cloudinaryImageId: "aagnmdkdxshwhhtzl7vk",
      costForTwo: 30000,
      costForTwoMsg: "₹300 for two",
      cuisines: ["Chinese", "South Indian"],
      minimumOrder: 0,
      opened: 1,
      parentId: 527,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "22 MINS",
        lastMileDistanceString: "2.1 kms",
        restaurantId: "108158",
        deliveryTime: 22,
        minDeliveryTime: 22,
        maxDeliveryTime: 22,
        lastMileTravel: 2.1,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.6349644660949707,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 4,
      },
      availability: {
        nextCloseTime: "2023-02-27 23:30:00",
        nextChangeTime: 1677520800000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "3/1, 1st main road 2 nd cross,Maruthi nagar ,Madiwala,Bangalore",
        },
        { title: "Cuisines", message: "Chinese,South Indian" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "31241261": {
            id: 31241261,
            name: "Paneer Manchurian Gravy",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241263": {
            id: 31241263,
            name: "Grilled Combo",
            category: "Thalis",
            description: "1 Biryani Rice + Grilled Chicken (1 Pc)",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241266": {
            id: 31241266,
            name: "Magic Special",
            category: "Thalis",
            description: "Biryani rice + Kebab (1 Pc) + Boiled egg (1 Pc)",
            cloudinaryImageId: "hymwf7jifiy6a7husiok",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241269": {
            id: 31241269,
            name: "Magic Thali",
            category: "Thalis",
            description: "",
            cloudinaryImageId: "fosrjqulp1mnnxzioagp",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241270": {
            id: 31241270,
            name: "Gobi Chilli",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241271": {
            id: 31241271,
            name: "New Grilled Special",
            category: "Thalis",
            description:
              "1 Biryani Rice +Grilled Chicken (1 Pc) + 1 Grape Juice.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241273": {
            id: 31241273,
            name: "Non Veg Thali",
            category: "Thalis",
            description:
              "Kebab (1 Pc) + Parotta (1 Pc) + Half Biryani Rice + Boiled egg (1 Pc) + Grape juice",
            cloudinaryImageId: "hberm8ltxncnpm5y94qu",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241274": {
            id: 31241274,
            name: "Andar Bahar",
            category: "Kebab & Tandoori",
            description: "",
            cloudinaryImageId: "qfe5zlca8jwqrshaa7cp",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241278": {
            id: 31241278,
            name: "Special Thali",
            category: "Thalis",
            description:
              "Parotta (3 Pcs) + Kabab (1 Pc) + Boiled egg (1 Pc) + Grape juice",
            cloudinaryImageId: "zpga4hivs1cs4kswa1a7",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241279": {
            id: 31241279,
            name: "Chicken Kebab",
            category: "Kebab & Tandoori",
            description:
              "|This tandoor grilled delicious chicken kebab is marinated with yogurt, spices and Indian masalas. It is juicy on the inside and crisp outside., Half serving of Chicken Kebab|",
            cloudinaryImageId: "ihh9us6dpik6dnq2zdqu",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2827278",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9406924",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827278",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 28000,
                      default: 1,
                      id: "9406925",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827278",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241280": {
            id: 31241280,
            name: "Special Offer",
            category: "Thalis",
            description: "Paratha (3 Pc) + Chicken Curry (1 Pc)",
            cloudinaryImageId: "fzobzmbcrweqrlh2mwuc",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241287": {
            id: 31241287,
            name: "Tandoori Raan",
            category: "Kebab & Tandoori",
            description: "",
            cloudinaryImageId: "btiaurryfpy7xnrr8ira",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241288": {
            id: 31241288,
            name: "Chicken Fried Rice",
            category: "Rice & Noodles",
            description:
              "Wholesome stir-fried rice tossed with juicy chicken chunks and grated vegetables.",
            cloudinaryImageId: "iyg7qaifq74eix9x4lmd",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241290": {
            id: 31241290,
            name: "Chicken Noodles",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "kzi4lplbcknaybytys1o",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241294": {
            id: 31241294,
            name: "Egg Fried Rice",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "jqqjqpuyixmwxvevnqlr",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241295": {
            id: 31241295,
            name: "Egg Noodles",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "svcmef16yl9jpfgsk3y1",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241296": {
            id: 31241296,
            name: "Al Faham Chicken",
            category: "Grilled & Broasted",
            description: "",
            cloudinaryImageId: "flkzbnmz39p5kt9xnay9",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2827281",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9406930",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827281",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 44000,
                      default: 1,
                      id: "9406931",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827281",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241299": {
            id: 31241299,
            name: "Bbq Chicken",
            category: "Grilled & Broasted",
            description: "",
            cloudinaryImageId: "r8ix3awkrzys0t9km8ua",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241301": {
            id: 31241301,
            name: "Paneer Fried Rice",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241304": {
            id: 31241304,
            name: "Paneer Noodles",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241306": {
            id: 31241306,
            name: "Veg Fried Rice",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "khl73bhrqaiftc38uptz",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241307": {
            id: 31241307,
            name: "Veg Noodles",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "jcd2pzlenkgfguhxagn0",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241309": {
            id: 31241309,
            name: "Grilled Chicken (4 pcs)",
            category: "Grilled & Broasted",
            description:
              "|Aromatic recipe of chicken marianted with yogurt, masalas and herbs, which is the slow grilled and coated with zesty spices, Half portion of perfectly grilled chicken|",
            cloudinaryImageId: "gexsnwrdvoevxfdfctdd",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2827284",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9406936",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827284",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 44000,
                      default: 1,
                      id: "9406937",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827284",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241310": {
            id: 31241310,
            name: "Tandoori Chicken (4 pcs)",
            category: "Grilled & Broasted",
            description:
              "|The famous Punjabi appetiser marinated in a rich, spicy gravy and cooked in tandoor, this Tandoori Chicken is tender beyond imagination., Half serving of tandoori chicken|",
            cloudinaryImageId: "cod9349bdbrwhmzt4x91",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "2827285",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "9406938",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827285",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 44000,
                      default: 1,
                      id: "9406939",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "2827285",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241319": {
            id: 31241319,
            name: "Special Grape Juice",
            category: "Fruit Juices & Cool Drinks",
            description: "",
            cloudinaryImageId: "yrdmj5takeevnqpa9rna",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241326": {
            id: 31241326,
            name: "Egg Roll",
            category: "Rolls",
            description:
              "A simple egg roll with egg and vegetable mix stuffing",
            cloudinaryImageId: "vlni8l0ihtzt0y02ezog",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241328": {
            id: 31241328,
            name: "Paneer Roll",
            category: "Rolls",
            description:
              "Wholesome rolls stuffed with seasoned cottage cheese cubes",
            cloudinaryImageId: "ffcastix6cl0a7siu9f4",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241333": {
            id: 31241333,
            name: "Veg Roll",
            category: "Rolls",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241336": {
            id: 31241336,
            name: "Rumali Roti",
            category: "Roti",
            description:
              "|Soft and extremely thin flatbread served in the shape of a handkerchief|",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241339": {
            id: 31241339,
            name: "Chicken Masala",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241340": {
            id: 31241340,
            name: "Butter Chicken",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "rhoknrzn8klwhp3jh95i",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241344": {
            id: 31241344,
            name: "Chicken Pepper Dry",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "h0lci51oozmlzex3i8qz",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241346": {
            id: 31241346,
            name: "Chilli Chicken",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "lool1juqsvosk6xiidet",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241348": {
            id: 31241348,
            name: "Chicken Tikka Masala",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241350": {
            id: 31241350,
            name: "Lemon Chicken",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "wulrzuedzuu510fl4zkn",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241351": {
            id: 31241351,
            name: "Egg Masala",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241352": {
            id: 31241352,
            name: "Egg Omelette",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241353": {
            id: 31241353,
            name: "Gobi Manchurian Dry",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241359": {
            id: 31241359,
            name: "Paneer Butter Masala",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241360": {
            id: 31241360,
            name: "Paneer Chilli Dry",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241361": {
            id: 31241361,
            name: "Paneer Chilli Gravy",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "31241362": {
            id: 31241362,
            name: "Paneer Manchurian Dry",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643698": {
            id: 35643698,
            name: "Butter Chicken ( 2Pc )",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "zlgm5llxcfrrmltdcuhc",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643703": {
            id: 35643703,
            name: "Chicken Manchurian Dry",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643708": {
            id: 35643708,
            name: "Chicken Manchurian Gravy",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643717": {
            id: 35643717,
            name: "Chicken Pepper Gravy",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643726": {
            id: 35643726,
            name: "Shawarma Roll(With Out Onion)",
            category: "Rolls",
            description:
              "Get all the healthy vegetables and delectable meat wrapped in a soft Shawarma Roll without onion!",
            cloudinaryImageId: "uuzipkcqtnsdtqcfzsay",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643732": {
            id: 35643732,
            name: "Paratha",
            category: "Roti",
            description:
              "|A crispy flatbread smothered with oil on both sides|",
            cloudinaryImageId: "iucmi7nwddvmxook0fap",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643755": {
            id: 35643755,
            name: "Gobi Manchurian Gravy",
            category: "Dry / Gravy",
            description: "",
            cloudinaryImageId: "dkozssbu15o9ybwskyrt",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643756": {
            id: 35643756,
            name: "Paratha Chilli",
            category: "Thalis",
            description: "Paratha (3 Pc) +  1/2 Chilli Chicken",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643757": {
            id: 35643757,
            name: "Chicken Tikka(Boneless)",
            category: "Kebab & Tandoori",
            description: "",
            cloudinaryImageId: "afozk4jblcjka9jbyyli",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "3443439",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "11438369",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3443439",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 12000,
                      default: 1,
                      id: "11438370",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3443439",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643759": {
            id: 35643759,
            name: "Paratha Grill",
            category: "Thalis",
            description: "Paratha (2 Pcs) + Grilled Chicken (Half)",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643761": {
            id: 35643761,
            name: "Chicken Lollipop ",
            category: "Kebab & Tandoori",
            description: "",
            cloudinaryImageId: "uarj2zc4oxizr2czoxsq",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "3443442",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "11438375",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3443442",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 14000,
                      default: 1,
                      id: "11438376",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3443442",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643793": {
            id: 35643793,
            name: "Chicken Dum Biryani",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "tozwplcrvbflkbmrxn5x",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643826": {
            id: 35643826,
            name: "Egg Biryani",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643830": {
            id: 35643830,
            name: "Biryani Rice",
            category: "Rice & Noodles",
            description:
              "Steamed Basmati rice with saffron and other rich spices, this Biryani rice is an exciting dish",
            cloudinaryImageId: "pyfd1kke2bxtecmf43tl",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643835": {
            id: 35643835,
            name: "Tandoori Kebab  (4 pcs)",
            category: "Kebab & Tandoori",
            description:
              "|Tandoor-cooked chicken chunks marinated in a yogurt and chilli based masala|",
            cloudinaryImageId: "fo8fkcozahsi5kvf74tl",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: {
              exclude_list: [],
              variant_groups: [
                {
                  group_id: "3443459",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Half",
                      price: 0,
                      default: 0,
                      id: "11438412",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3443459",
                      order: 999,
                    },
                    {
                      name: "Full",
                      price: 14000,
                      default: 1,
                      id: "11438413",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3443459",
                      order: 998,
                    },
                  ],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643843": {
            id: 35643843,
            name: "Chicken Biryani",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "dfdx1bm50fjunixrnjyi",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643852": {
            id: 35643852,
            name: "Chicken Biryani + Kebab (1 Pc)",
            category: "Rice & Noodles",
            description: "",
            cloudinaryImageId: "uht7nujot77fujg0isgj",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643863": {
            id: 35643863,
            name: "Chicken Wings Fry",
            category: "Kebab & Tandoori",
            description:
              "A darling to all, these delicious Chicken Wings Fry is delightfully crunchy outside and soft inside. A perfect treat!.",
            cloudinaryImageId: "pnl4wxgxdvitiib9hhks",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643944": {
            id: 35643944,
            name: "Chicken Tikka Roll",
            category: "Rolls",
            description:
              "Exquisite chicken doused in creamy sauces and crunchy vegetables wrapped in soft chapati",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643948": {
            id: 35643948,
            name: "Shawarma Plate",
            category: "Rolls",
            description:
              "A popular Arabic street snack traditionally Served with chicken wrapped in pita bread Served with exotic vegetables and French fries on the side",
            cloudinaryImageId: "glekj2hwx7bwfbec7xry",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643949": {
            id: 35643949,
            name: "Shawarma Plate(With Out Onion)",
            category: "Rolls",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643951": {
            id: 35643951,
            name: "Shawarma Roll",
            category: "Rolls",
            description:
              "A Shawarma Roll meant to play spice games with your tastebuds and take you to food heaven",
            cloudinaryImageId: "xjezsxhtflxkw0z5shxw",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35643957": {
            id: 35643957,
            name: "Executive Kebab Biryani",
            category: "Thalis",
            description:
              "Biryani Rice + Paratha (1 Pc) + Leg (1 Pc )+ Kebab (1 Pc) + Boiled Egg (1 Pc) + Grape Juice",
            cloudinaryImageId: "il1r1jgrbpfjop6g5yva",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "46481112": {
            id: 46481112,
            name: "Mayonnaise",
            category: "Grilled & Broasted",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "46521218": {
            id: 46521218,
            name: "Lemon Soda",
            category: "Fruit Juices & Cool Drinks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "108158",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 31241280,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643757,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643863,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643761,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643843,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643852,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643793,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241288,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241290,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643830,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241294,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241295,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241306,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241307,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241296,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241299,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241344,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241350,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643755,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241340,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643698,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241326,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241328,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 31241319,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35643732,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Thalis",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 31241266,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241273,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643957,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241269,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643756,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241280,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241278,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241263,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241271,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643759,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Kebab & Tandoori",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 35643757,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643863,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241279,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643761,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241287,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241274,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643835,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rice & Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 35643843,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643852,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643793,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241288,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241290,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643830,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241294,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241295,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643826,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241301,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241304,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241306,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241307,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Grilled & Broasted",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 31241296,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 46481112,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241310,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241299,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241309,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Dry / Gravy",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 31241339,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643703,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643708,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241344,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643717,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241346,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241348,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241350,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241351,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241352,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241353,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643755,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241359,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241360,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241361,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241362,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241261,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241270,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241340,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643698,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rolls",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 35643944,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241326,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241328,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241333,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643948,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643951,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643726,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35643949,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fruit Juices & Cool Drinks",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 31241319,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 46521218,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Roti",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 35643732,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 31241336,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "menu_merchandise",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "FREE DELIVERY",
        shortDescriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off up to ₹120 | Use FEDERALCC Above ₹249",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "FREE DELIVERY",
        shortDescriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off up to ₹120 | Use FEDERALCC Above ₹249",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 1,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11218334000238"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "661af3ea-d37e-4db0-8c09-b81035d012b5",
      timeStamp: "1677489198021",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "L8JNN0IIAuW6-C-3wHdnQAlB5b0qpSQBtiU-yeDY",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "92389",
      name: "Muthashy's",
      uuid: "1e47bc36-13c4-45af-a29d-9c2417a383cb",
      slug: "muthashy39s-btm",
      latLong: "12.920855212014166,77.61321812868118",
      city: "Bangalore",
      area: "Btm Layout",
      areaPostalCode: "560068",
      areaSlug: "BTM",
      restaurantSlug: {
        restaurant: "muthashy39s-btm",
        city: "bangalore",
      },
      type: "F",
      locality: "Maruti Nagar",
      avgRating: 4.3,
      totalRatings: 1000,
      avgRatingString: "4.3",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "fifv8bhm4mzqausmynfa",
      costForTwo: 30000,
      costForTwoMsg: "₹300 for two",
      cuisines: ["Chinese", "South Indian"],
      minimumOrder: 0,
      opened: 1,
      parentId: 21429,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: false,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "24 MINS",
        lastMileDistanceString: "2.5 kms",
        restaurantId: "92389",
        deliveryTime: 24,
        minDeliveryTime: 24,
        maxDeliveryTime: 24,
        lastMileTravel: 2.5,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.5992732048034668,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 4,
      },
      availability: {
        nextCloseTime: "2023-02-27 22:45:00",
        nextChangeTime: 1677518100000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "3, Brindavan Complex, 20th Main, Maruthi Nagar Main Road, 1st Stage, BTM Layout",
        },
        { title: "Cuisines", message: "Chinese,South Indian" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "26307337": {
            id: 26307337,
            name: "Appam",
            category: "All Day Breakfast",
            description:
              "Appam is a type of pancake, originating from South India, made with fermented rice batter and coconut milk, common in Kerala, Sri Lanka, Tamil Nadu.",
            cloudinaryImageId: "xwe0w4siim3k6ag3e5cm",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:49 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307338": {
            id: 26307338,
            name: "Ginger Chicken",
            category: "Gravy Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307340": {
            id: 26307340,
            name: "Egg Appam",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307342": {
            id: 26307342,
            name: "Fish Kebab",
            category: "Squids",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307343": {
            id: 26307343,
            name: "Puttu",
            category: "All Day Breakfast",
            description:
              "This delicious steamed rice cake cooked with coconut shavings",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307344": {
            id: 26307344,
            name: "Chicken Sukka",
            category: "Chicken",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307345": {
            id: 26307345,
            name: "Idiyappam",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "lfasm5jlsmzhfgefmzdg",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 39609529,
                group_name: "Add on ",
                choices: [
                  {
                    id: 27122301,
                    name: "Extra chutney ",
                    price: 1000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: -1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307347": {
            id: 26307347,
            name: "Nadan Chicken Curry",
            category: "Gravy Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307348": {
            id: 26307348,
            name: "Upma",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307353": {
            id: 26307353,
            name: "Dosa",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "h8xqgsjc4fd04vi13fei",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307356": {
            id: 26307356,
            name: "Plain Dosa",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "ihjtt1khchvx7jrnhblj",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307357": {
            id: 26307357,
            name: "Squid Roast",
            category: "Squids",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307359": {
            id: 26307359,
            name: "Ghee Roast",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307360": {
            id: 26307360,
            name: "Squid Pepper Fry",
            category: "Squids",
            description:
              "A spicy southern flavoured dry of your choice with prominent flavors of black pepper.",
            cloudinaryImageId: "swtiastusf2u2rj5mqqt",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307362": {
            id: 26307362,
            name: "Masala Dosa (1 Pc)",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "yzeby7xfeegt2wgysntj",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307365": {
            id: 26307365,
            name: "Kallappam",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307368": {
            id: 26307368,
            name: "Wheat Parotta",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2300,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307369": {
            id: 26307369,
            name: "Egg Biryani",
            category: "Biryani",
            description:
              "Wholesome biryani prepared with eggs, aromatic biryani rice and whole spices; served with raita.",
            cloudinaryImageId: "kl1tpwklh4agt8t1p434",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307370": {
            id: 26307370,
            name: "Parotta",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307372": {
            id: 26307372,
            name: "Banana",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 9:55 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307374": {
            id: 26307374,
            name: "Kadala Curry",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307376": {
            id: 26307376,
            name: "Egg Curry",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "uf43agiegzrnf0yvs6h4",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307377": {
            id: 26307377,
            name: "White Rice Meals",
            category: "Meals",
            description:
              "Palaya, sambhar, koottu curry, moru curry, pickle & white rice.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307378": {
            id: 26307378,
            name: "Payaru Curry",
            category: "All Day Breakfast",
            description:
              "Green moong dal curry also known as cherupayar curry or pachai payar curry",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307379": {
            id: 26307379,
            name: "Boiled Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "vgzgemyz8upapnj0wvlq",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307380": {
            id: 26307380,
            name: "Veg Korma",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307381": {
            id: 26307381,
            name: "Fish Curry Meals",
            category: "Meals",
            description:
              "Authentic Kerala style rice meals served with special and delicious fish curry.",
            cloudinaryImageId: "z6lmzl0emjesf4tjqzgp",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307382": {
            id: 26307382,
            name: "Fish Curry",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "u8henkjbcv4q87liurjy",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307383": {
            id: 26307383,
            name: "Chicken Curry",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307384": {
            id: 26307384,
            name: "Ghee Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307385": {
            id: 26307385,
            name: "Kerala Parotta (1 Pc)",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2300,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307387": {
            id: 26307387,
            name: "Chapati (1 Pc)",
            category: "Breads",
            description: "",
            cloudinaryImageId: "eopy0c5lslbpsn7zjzlq",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307388": {
            id: 26307388,
            name: "Jeera Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307390": {
            id: 26307390,
            name: "Tomato Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307391": {
            id: 26307391,
            name: "Kappa",
            category: "Breads",
            description: "",
            cloudinaryImageId: "fcqj0zz4gt9vugomklv4",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307393": {
            id: 26307393,
            name: "Kappa Kozha",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307394": {
            id: 26307394,
            name: "Egg Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307396": {
            id: 26307396,
            name: "Mushroom Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307398": {
            id: 26307398,
            name: "Mixed Fried Rice",
            category: "Fried Rice",
            description: "Contains egg, chicken & prawns.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307400": {
            id: 26307400,
            name: "Veg Stew",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307401": {
            id: 26307401,
            name: "Chicken Fried Rice",
            category: "Fried Rice",
            description:
              "Wholesome stir-fried rice topped with juicy chicken chunks and grated vegetables",
            cloudinaryImageId: "albhhexn5ojbjx9nwt1x",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Boneless chicken curry",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307403": {
            id: 26307403,
            name: "Chicken Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307404": {
            id: 26307404,
            name: "Chana Masala",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307405": {
            id: 26307405,
            name: "Egg Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307406": {
            id: 26307406,
            name: "Veg Kadai",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307407": {
            id: 26307407,
            name: "Veg Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307409": {
            id: 26307409,
            name: "Kanji",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307411": {
            id: 26307411,
            name: "Double Omelette",
            category: "Egg",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307412": {
            id: 26307412,
            name: "Tomato Fry",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307415": {
            id: 26307415,
            name: "Egg Masala",
            category: "Egg",
            description: "",
            cloudinaryImageId: "yfaxrwutdwo3l8xxcn4s",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307416": {
            id: 26307416,
            name: "Egg Roast",
            category: "Egg",
            description: "",
            cloudinaryImageId: "wq4jkik5rn9eb2kdwq6i",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307418": {
            id: 26307418,
            name: "Egg Chilli",
            category: "Egg",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307421": {
            id: 26307421,
            name: "Mushroom Masala",
            category: "Mushroom Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307423": {
            id: 26307423,
            name: "Mushroom Pepper Fry",
            category: "Mushroom Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307424": {
            id: 26307424,
            name: "Chicken Leg Fry",
            category: "Chicken",
            description:
              "It is a simple chicken legs recipe which is cooked on stove top by marinating the chicken in some spices.",
            cloudinaryImageId: "qb1ukq7ndtljgw3e8voq",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307426": {
            id: 26307426,
            name: "Chicken Pepper Fry",
            category: "Chicken",
            description:
              "Chicken pepper fry is a juicy and delicious appetizer cooked with Indian spices, onion, curry leaves , pepper and juicy tender chicken.",
            cloudinaryImageId: "gsdy50cov8x7f8kgoed9",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307427": {
            id: 26307427,
            name: "Paneer Manchurian",
            category: "Paneer Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307429": {
            id: 26307429,
            name: "Paneer Butter Masala",
            category: "Paneer Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307430": {
            id: 26307430,
            name: "Kadai Paneer",
            category: "Paneer Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307432": {
            id: 26307432,
            name: "Paneer Pepper Fry",
            category: "Paneer Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307433": {
            id: 26307433,
            name: "Chicken Masala",
            category: "Gravy Items",
            description:
              "A flavor-packed combo of delectable chicken masala served with choice between rice or roti and salad. (Serves 1).",
            cloudinaryImageId: "tyausgtd1c826soy8si3",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307435": {
            id: 26307435,
            name: "Chicken Roast",
            category: "Gravy Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307436": {
            id: 26307436,
            name: "Butter Chicken",
            category: "Gravy Items",
            description:
              "A mildly sweet chicken gravy preapared with pieces of chicken simmered in tomato gravy, spices along with fresh cream and butter.",
            cloudinaryImageId: "pd9ekmu3sq0w5ixil7q1",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307438": {
            id: 26307438,
            name: "Chicken Ularthiyathu",
            category: "Gravy Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307439": {
            id: 26307439,
            name: "Prawns Pepper Fry",
            category: "Prawns",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307440": {
            id: 26307440,
            name: "Chicken Stew",
            category: "Gravy Items",
            description:
              "An authentic chicken stew with amzing combination coconut milk and spices.",
            cloudinaryImageId: "pbwookp4hro4gqnwgwsx",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307442": {
            id: 26307442,
            name: "Chicken Mappas",
            category: "Gravy Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307443": {
            id: 26307443,
            name: "Prawns Masala",
            category: "Prawns",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307444": {
            id: 26307444,
            name: "Chilli Chicken",
            category: "Gravy Items",
            description: "",
            cloudinaryImageId: "lwgvwiwmbor1ha4rbmpf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307445": {
            id: 26307445,
            name: "Prawns Roast",
            category: "Prawns",
            description:
              "This delicious dish of succulent chicken roasted to perfection with an array of spices will make your mouth water.",
            cloudinaryImageId: "gw77mnjhjnmq0gi9n7fb",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307446": {
            id: 26307446,
            name: "Chicken Manchurian",
            category: "Gravy Items",
            description:
              "Chicken chunks marinated in authentic spices and cooked in tandoor flames served along onion and chutney.",
            cloudinaryImageId: "deed65ed1c690ec037b40282a63c59d9",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "26307447": {
            id: 26307447,
            name: "Garlic Chicken",
            category: "Gravy Items",
            description:
              "Garlic chicken chunks tossed with onions & housemade sauce served with dry gravy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722549": {
            id: 64722549,
            name: "Ullivada",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722551": {
            id: 64722551,
            name: "Uzhunu Vada",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722552": {
            id: 64722552,
            name: "Veg Cutlet",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722553": {
            id: 64722553,
            name: "Chicken Cutlet",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722556": {
            id: 64722556,
            name: "Pothu Kothu Parotta",
            category: "Breads",
            description:
              "Malabar porotas stuffed with chicken varattiyathu, spicy gravy covered inside banana leaf and tawa grilled to get the perfect aroma and authentic taste.",
            cloudinaryImageId: "bqxqj8y4guek5miqxsxp",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722558": {
            id: 64722558,
            name: "Idly (1 Pc)",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722559": {
            id: 64722559,
            name: "Boiled Egg [Double]",
            category: "Egg",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722562": {
            id: 64722562,
            name: "Veg Kuruma",
            category: "All Day Breakfast",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722564": {
            id: 64722564,
            name: "Boiled Rice Meals",
            category: "Meals",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722566": {
            id: 64722566,
            name: "Chicken Pothichoru",
            category: "Pothichoru",
            description:
              "Traditional meals style in smoked plantain leaf served with single omelette and as the name mentioned",
            cloudinaryImageId: "jomqpmsoqwsa7dirdgkz",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Chicken curry or fry",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722567": {
            id: 64722567,
            name: "Fish Pothichoru",
            category: "Pothichoru",
            description:
              "Traditional meals wrapped in banana leaves, with vegetable side dishes ( coconut chutney, thoran, pickle, sambar and curd curry)",
            cloudinaryImageId: "sqx7zdcgbwx4btbwmxki",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Single fish fry",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722569": {
            id: 64722569,
            name: "Pothu Pothichoru",
            category: "Pothichoru",
            description:
              "Enjoy the flavours of Kerala wraped in a roll for you. It's bunch of nostalgic memories , mother's love, and our source of energy to take us through the memory lane.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722570": {
            id: 64722570,
            name: "Veg Pothichoru",
            category: "Pothichoru",
            description:
              "It is a set of authentic Kerala dishes combined and wraped in banana leaves.",
            cloudinaryImageId: "qvlw1bxqxsn6rbvy3kob",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722572": {
            id: 64722572,
            name: "Pothu Fry",
            category: "Pothu Special",
            description:
              "Pacha kappa chendan puzhungiyathinte kude pothu fry. Enjoy the delicious meal.",
            cloudinaryImageId: "lfrqnkn8kjis8k5ct8fg",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722573": {
            id: 64722573,
            name: "Biriyani Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "VEG",
              accompaniments: "Served with Raita",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722576": {
            id: 64722576,
            name: "Pothu Roast",
            category: "Pothu Special",
            description:
              "Enjoy the Kerala style pothu roast with pepper roasted. A finger licious dish you dont wanna miss.",
            cloudinaryImageId: "p69ibmu3igcsclsvfzul",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722577": {
            id: 64722577,
            name: "Pothu Ularthiyathu",
            category: "Pothu Special",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722580": {
            id: 64722580,
            name: "Chicken 65 [Six, Five]",
            category: "Chicken",
            description: "",
            cloudinaryImageId: "xia7sruuwkjr7hkc1vvf",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722583": {
            id: 64722583,
            name: "Chicken Kabab",
            category: "Chicken",
            description:
              "Marinated tender chicken pieces batter fried, richly flavoured with hand-pound masala",
            cloudinaryImageId: "turozs7ecbhbyowpc6tt",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Onion & Lemon wedge",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722585": {
            id: 64722585,
            name: "Chemballi Polichathu [Snapper]",
            category: "Fish Pollichuthu",
            description:
              "Chemballi fish fry made in Kerala style. Chemballi fish is known as northern red snapper in english.",
            cloudinaryImageId: "e2bfb222a9f75c69941a56f23835f9c2",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722589": {
            id: 64722589,
            name: "Karimeen Polichathu",
            category: "Fish Pollichuthu",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 39500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722592": {
            id: 64722592,
            name: "Kilimeen Polichathu [Pink Perch]",
            category: "Fish Pollichuthu",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722596": {
            id: 64722596,
            name: "Neymeen Polichathu [Seerfish]",
            category: "Fish Pollichuthu",
            description:
              "Seerfish wrapped & grilled in banana leaf with authentic Kerala spices.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722599": {
            id: 64722599,
            name: "Kada Fry (Quail Fry)",
            category: "Chicken",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722600": {
            id: 64722600,
            name: "Prawns Fry",
            category: "Prawns",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722601": {
            id: 64722601,
            name: "Crab Roast",
            category: "Squids",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722602": {
            id: 64722602,
            name: "Chicken Pepper Fry Gravy",
            category: "Gravy Items",
            description:
              "It is a juicy and delicious gravy cooked with Indian spices, onion, curry leaves , pepper and juicy tender chicken.",
            cloudinaryImageId: "aj7ls0fw8sanvabacf3x",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722603": {
            id: 64722603,
            name: "Mathi Peera",
            category: "Squids",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722604": {
            id: 64722604,
            name: "Mussels Fry [Kakka]",
            category: "Squids",
            description:
              "Mussel fry is a popular dish in coastal districts of Kerala prepared with malabar spices .",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Rice or parotta",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722605": {
            id: 64722605,
            name: "Chicken Thoran",
            category: "Gravy Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722606": {
            id: 64722606,
            name: "Chicken Varatharachathu",
            category: "Gravy Items",
            description:
              "Chicken varatharachathu or chicken cooked in grated coconut and fried gravy is a very tasty dish which has a blend of spices. It goes well with rice, puttu, appam or porotta/chapati.",
            cloudinaryImageId: "tgbwlg3qf32fm5zxivcm",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722607": {
            id: 64722607,
            name: "Chilly Gobi Dry",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722608": {
            id: 64722608,
            name: "Chilly Gobi Gravy",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722609": {
            id: 64722609,
            name: "Gobi Manchurian Dry",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "33e0b819a7239e9325d58f3555c6d082",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722610": {
            id: 64722610,
            name: "Gobi Manchurian Gravy",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722611": {
            id: 64722611,
            name: "Chicken Kadai",
            category: "Gravy Items",
            description:
              "Diced chicken combined with onions capsicum and tomatoes in a midly spiced kadai gravy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722612": {
            id: 64722612,
            name: "Green Pease Masla",
            category: "Veg Main Course",
            description: "",
            cloudinaryImageId: "qkdlzsldt7h9m9xq2okb",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722613": {
            id: 64722613,
            name: "Avoli Fry [Pomfret Fry]",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722615": {
            id: 64722615,
            name: "Ayala Fry [Mackaral Fry]",
            category: "Sea Food",
            description:
              "Anjal / king fish slices wrapped in a spicy marinade and rawa-fried until crisp and tasty.",
            cloudinaryImageId: "yfhedhmj9lasddjukgf6",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722617": {
            id: 64722617,
            name: "Chemballi Fry [Snapper]",
            category: "Sea Food",
            description:
              "Chemballi fish fry made in Kerala style. Chemballi fish is known as northern red snapper in english.",
            cloudinaryImageId: "zkbaqe8xgcva9kodvk1w",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722618": {
            id: 64722618,
            name: "Karimeen Fry [Pealspot]",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722619": {
            id: 64722619,
            name: "Kilimeen Fry [Pink Perch]",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722620": {
            id: 64722620,
            name: "Chilly Mushroom Dry",
            category: "Mushroom Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722621": {
            id: 64722621,
            name: "Mandal [Sole Fish Fry]",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722622": {
            id: 64722622,
            name: "Mushroom Kadai",
            category: "Mushroom Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722623": {
            id: 64722623,
            name: "Mathi Fry (2 Pcs)",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722624": {
            id: 64722624,
            name: "Mushroom Manchurian Dry",
            category: "Mushroom Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722625": {
            id: 64722625,
            name: "Natholi Fry [Silver Fish]",
            category: "Sea Food",
            description:
              "A delightfully wholesome combo of spicy fish fry, along with types of veggies.",
            cloudinaryImageId: "441058f344b9eb09552867957d41eaf6",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722626": {
            id: 64722626,
            name: "Neymeen Fry [Seer Fish]",
            category: "Sea Food",
            description:
              "Seerfish wrapped & fried in banana leaf with authentic Kerala spices.",
            cloudinaryImageId: "xnhiqnyvrfkv5xw79ba0",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722627": {
            id: 64722627,
            name: "Avoli Masala [Pomfret]",
            category: "Fish Masala",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 42500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722628": {
            id: 64722628,
            name: "Chilly Paneer",
            category: "Paneer Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722629": {
            id: 64722629,
            name: "Ayala Masala [Mackaral]",
            category: "Fish Masala",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722630": {
            id: 64722630,
            name: "Chemballi Masala [Snapper]",
            category: "Fish Masala",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722631": {
            id: 64722631,
            name: "Karimeen Masala [Pealspot])",
            category: "Fish Masala",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 39500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722632": {
            id: 64722632,
            name: "Neymeen Masala( Seerfish)",
            category: "Fish Masala",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722634": {
            id: 64722634,
            name: "Veg Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722635": {
            id: 64722635,
            name: "Mutton Kuruma",
            category: "Mutton Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722636": {
            id: 64722636,
            name: "Mutton Pepper Roast",
            category: "Mutton Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722637": {
            id: 64722637,
            name: "Mutton Roast",
            category: "Mutton Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722638": {
            id: 64722638,
            name: "Mutton Stew",
            category: "Mutton Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722639": {
            id: 64722639,
            name: "Duck Kuruma",
            category: "Duck Specials",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722640": {
            id: 64722640,
            name: "Duck Roast",
            category: "Duck Specials",
            description:
              "Roasted duck withfreshly crushed pepper and freshly squeezed coconut milk to enhance the taste.",
            cloudinaryImageId: "ea241a1e07178d8ad2d30febdc79ecfa",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722641": {
            id: 64722641,
            name: "Ela Ada",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722642": {
            id: 64722642,
            name: "Kozhakatta",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722643": {
            id: 64722643,
            name: "Parippuvada",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722644": {
            id: 64722644,
            name: "Pazham Pori",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722645": {
            id: 64722645,
            name: "Avoli Polichathu [Pomfret]",
            category: "Fish Pollichuthu",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 42500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722646": {
            id: 64722646,
            name: "Ayala Polichathu [Mackaral]",
            category: "Fish Pollichuthu",
            description:
              "Deep cut fish marinated with spices and deep fried to satisfy your soul.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722650": {
            id: 64722650,
            name: "Pothu Coconut Fry",
            category: "Pothu Special",
            description:
              "Roasted beef in a spicy aromatic masala with coconut bites and curry leaves.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722688": {
            id: 64722688,
            name: "Curd Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722689": {
            id: 64722689,
            name: "Plain White Rice",
            category: "Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722690": {
            id: 64722690,
            name: "Chicken Biryani",
            category: "Biryani",
            description:
              "A delightfully wholesome combo with aromatic biryani rice",
            cloudinaryImageId: "k4stgbpayhtv78frzgaz",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Raita",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722691": {
            id: 64722691,
            name: "Fish Biriyani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722692": {
            id: 64722692,
            name: "Kappa Biryani",
            category: "Biryani",
            description:
              "Traditional Kerala preparation of Kappa Biryani with long rice and authentic masala flavour.",
            cloudinaryImageId: "ajnmqiznncgu3j5smeti",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722693": {
            id: 64722693,
            name: "Kizhi Biriyani (Chicken)",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722694": {
            id: 64722694,
            name: "Kizhi Biriyani (Fish)",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722695": {
            id: 64722695,
            name: "Mutton Biriyani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722696": {
            id: 64722696,
            name: "Pothu Biryani",
            category: "Biryani",
            description:
              "In spicy masala gravy and layered with cooked rice. A very tasty and delicious biriyani.",
            cloudinaryImageId: "doiv3irdjfxpoe1kha5y",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "Serves 1",
              spiceLevel: "MEDIUMSPICY",
              vegClassifier: "NONVEG",
              accompaniments: "Served with Raita",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722697": {
            id: 64722697,
            name: "Prawns Biriyani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722698": {
            id: 64722698,
            name: "Veg Biriyani",
            category: "Biryani",
            description:
              "Rice and assorted veggies cooked in a fragrant and flavorful masala seasoned with Indian whole spices; served with raita and katta.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722699": {
            id: 64722699,
            name: "Chicken Kothu Parota",
            category: "Breads",
            description:
              "Crispy parotta minced and mixed with curry masala, onion, egg and stir fried with chicken on a hot tawa. A totally different way of enjoying the famous traditional prata.",
            cloudinaryImageId: "n8etsk7wysoztvxm0zoo",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64722700": {
            id: 64722700,
            name: "Egg Kothu Parota",
            category: "Breads",
            description:
              "A delightfully scrumptious combo of egg kothu parotta plain, enjoy the flavoured meal.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "67877972": {
            id: 67877972,
            name: "Sadhya (Special)",
            category: "Meals",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 43500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "67877973": {
            id: 67877973,
            name: "Sukhiyan",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "67877975": {
            id: 67877975,
            name: "Elanji",
            category: "Snacks",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "68222179": {
            id: 68222179,
            name: "Palada Payasum",
            category: "Snacks",
            description: "Sweet Dish.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 35500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "68222180": {
            id: 68222180,
            name: "Adapradaman Payasumn",
            category: "Snacks",
            description: "Sweet Dish.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 45500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "69665972": {
            id: 69665972,
            name: "Pothu Kizhi Parotta",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "69665973": {
            id: 69665973,
            name: "Chicken Kizhi Parotta",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70773125": {
            id: 70773125,
            name: "Fish Mullakitta Curry [Spicy]",
            category: "Sea Food",
            description:
              "A gravy mixed with traditional fish masala added with chillies to nourish with few pieces of fish.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70773126": {
            id: 70773126,
            name: "Neymeen Curry (Seer Fish)",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70773127": {
            id: 70773127,
            name: "Ayala Curry (Mackerel)",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70773128": {
            id: 70773128,
            name: "Mathi Curry (Sardine)",
            category: "Sea Food",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "73639568": {
            id: 73639568,
            name: "Chicken Kappa Biryani",
            category: "Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "73639569": {
            id: 73639569,
            name: "Pothu Kizhi Biryani",
            category: "Biryani",
            description: "Chicken.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767670": {
            id: 75767670,
            name: "Egg Bhurji",
            category: "Egg Items",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767671": {
            id: 75767671,
            name: "Hakka Noodles Veg",
            category: "Hakka Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767672": {
            id: 75767672,
            name: "Mushroom Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767673": {
            id: 75767673,
            name: "Chichen Butter Garlic Noodles",
            category: "Chilly Garlic Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767674": {
            id: 75767674,
            name: "Chilly Garlic Prawns Noodles",
            category: "Chilly Garlic Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767675": {
            id: 75767675,
            name: "Chilly Garlic Chicken Noodles",
            category: "Chilly Garlic Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767676": {
            id: 75767676,
            name: "Chilly Garlic Egg Noodles",
            category: "Chilly Garlic Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767677": {
            id: 75767677,
            name: "Chilly Garlic Veg Noodles",
            category: "Chilly Garlic Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767678": {
            id: 75767678,
            name: "Hakka Noodles Chicken",
            category: "Hakka Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767679": {
            id: 75767679,
            name: "Hakka Noodles Egg",
            category: "Hakka Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767680": {
            id: 75767680,
            name: "Schezwan Chicken Noodles",
            category: "Schezwan Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767681": {
            id: 75767681,
            name: "Schezwan Egg Noodles",
            category: "Schezwan Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767682": {
            id: 75767682,
            name: "Schezwan Veg Noodles",
            category: "Schezwan Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767683": {
            id: 75767683,
            name: "Prawns Noodles",
            category: "Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767684": {
            id: 75767684,
            name: "Mixed Noodles",
            category: "Noodles",
            description: "Contains egg, chicken & prawns.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767685": {
            id: 75767685,
            name: "Schezwan Chicken Fried Rice",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767686": {
            id: 75767686,
            name: "Schezwan Fried Rice Egg",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "EGG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75767687": {
            id: 75767687,
            name: "Schezwan Fried Rice Veg",
            category: "Fried Rice",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7:35 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "92389",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 26307382,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307379,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307381,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722556,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307401,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307415,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722583,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307426,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307436,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307444,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307446,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722606,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 26307433,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722602,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722566,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722572,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722576,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722612,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722609,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 64722690,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "All Day Breakfast",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307382,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722562,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307337,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307343,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307345,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307372,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307348,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307353,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307383,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307374,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722558,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307376,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307378,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307340,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307362,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307359,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307365,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307370,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307356,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307368,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307379,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722573,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307409,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722688,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307384,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307388,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722689,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307390,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Meals",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307381,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722564,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307377,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 67877972,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Breads",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722556,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722699,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722700,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307385,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307387,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307391,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307393,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 69665972,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 69665973,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fried Rice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307401,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307394,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307396,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767685,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767686,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767687,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307398,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722634,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Egg",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307415,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722559,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307411,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307416,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307418,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Chicken",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307424,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722583,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307426,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722580,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307344,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722599,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Gravy Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307435,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307436,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307444,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307446,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722606,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307433,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307447,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722602,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307338,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722611,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307440,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307442,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722605,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307438,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307347,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Pothichoru",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722566,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722569,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722567,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722570,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Pothu Special",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722572,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722576,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722650,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722577,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Veg Main Course",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 26307404,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722612,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722607,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722608,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722609,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722610,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307412,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307406,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307380,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307400,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Biryani",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722690,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722692,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722696,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307369,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 73639568,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 73639569,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722691,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722693,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722694,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722695,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722697,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722698,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Mushroom Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722624,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307421,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307423,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722620,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722622,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Paneer Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722628,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307430,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307429,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307427,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307432,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Snacks",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Veg Snacks",
                type: "subcategory",
                entities: [
                  {
                    id: 64722641,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 64722642,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 64722643,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 64722644,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 64722549,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 64722551,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 64722552,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 67877973,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 67877975,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 68222179,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 68222180,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non Veg Snacks",
                type: "subcategory",
                entities: [
                  {
                    id: 64722553,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Egg Items",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75767670,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Hakka Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75767671,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767678,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767679,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75767672,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767683,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767684,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307407,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307405,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307403,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Chilly Garlic Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75767673,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767674,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767675,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767676,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767677,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Schezwan Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75767680,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767681,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75767682,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Squids",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722601,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722604,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307342,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722603,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307360,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307357,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Sea Food",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722613,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722615,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722617,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722623,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722618,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722619,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722621,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722625,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722626,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70773125,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70773126,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70773127,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 70773128,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fish Pollichuthu",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722645,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722646,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722585,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722589,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722592,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722596,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fish Masala",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722627,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722629,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722630,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722631,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722632,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Prawns",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722600,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307443,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307439,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 26307445,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Mutton Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722635,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722636,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722637,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722638,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Duck Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 64722639,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 64722640,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "normal",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "FREE DELIVERY",
        shortDescriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off up to ₹120 | Use FEDERALCC Above ₹249",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "FREE DELIVERY",
        shortDescriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
          {
            meta: "20% off up to ₹120 | Use FEDERALCC Above ₹249",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 1,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11222334002221"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      select: false,
      slotInvalid: false,
      cafe: false,
      preorderable: false,
      requestId: "a623acfd-7f45-490d-9e0f-d310779a5aed",
      timeStamp: "1677489223956",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "uOQ5qNfDauwk-eUiF9MPvHC95oseRBFGjDtB78dY",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "223",
      name: "Truffles",
      uuid: "8250cc38-4752-4f42-928b-4da5f01e5cbe",
      slug: "truffles-ice-spice-5th-block-koramangala",
      latLong: "12.933416243159748,77.61433422338291",
      city: "Bangalore",
      area: "Koramangala",
      areaPostalCode: "560034",
      areaSlug: "koramangala",
      restaurantSlug: {
        restaurant: "truffles-ice-spice-5th-block-koramangala",
        city: "bangalore",
      },
      type: "F",
      locality: "5th Block",
      avgRating: 4.4,
      totalRatings: 1000,
      avgRatingString: "4.4",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "cd832b6167eb9f88aeb1ccdebf38d942",
      costForTwo: 45000,
      costForTwoMsg: "₹450 for two",
      cuisines: ["American", "Continental"],
      minimumOrder: 0,
      opened: 1,
      parentId: 218065,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "28 MINS",
        lastMileDistanceString: "1.6 kms",
        restaurantId: "223",
        deliveryTime: 28,
        minDeliveryTime: 28,
        maxDeliveryTime: 28,
        lastMileTravel: 1.6,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.6437175273895264,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 1,
      },
      availability: {
        nextCloseTime: "2023-02-27 23:00:00",
        nextChangeTime: 1677519000000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "93/A, Appek Building, 'A' Wing,  4th 'B' Cross,  Koramangala Industrial Layout, 5th Block, Koramangala, Bangalore - 560 095",
        },
        { title: "Cuisines", message: "American,Continental" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "545224": {
            id: 545224,
            name: "Crunchy Chicken Salad",
            category: "Salad",
            description:
              "Crunchy fried chicken strips tossed with iceberg lettuce, bell pepper, chilli flakes with our inhouse aoili dressing and garnished with toasted sesame seeds serving size: 250gms energy per 100 gms: 209. 96kcal contains: milk, gluten, soy",
            cloudinaryImageId: "aamifrc2ksbquveymamo",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545230": {
            id: 545230,
            name: "Classic Fries",
            category: "Fries & Wedges",
            description:
              "French fries serving size: 170gms energy per 100 gms: 177kcal contains: gluten",
            cloudinaryImageId: "lkckevg87hk0jsx4yfly",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11429,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545233": {
            id: 545233,
            name: "Stuffed Fungi",
            category: "Starters",
            description:
              "Crumb fried mushrooms stuffed with spiced cheese serving size: 245gms energy per 100 gms: 275. 15kcal contains: milk, gluten, soy",
            cloudinaryImageId: "eron6p0yy11aejzodbvr",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545237": {
            id: 545237,
            name: "Cheesy Mex Fries",
            category: "Fries & Wedges",
            description:
              "Fries topped with fiery salsa, mexican beans & cheese serving size: 300gms energy per 100 gms: 255. 86kcal contains: milk, gluten",
            cloudinaryImageId: "oel7az0zzfztxrofr16j",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545241": {
            id: 545241,
            name: "Fried Mozzarella Stix",
            category: "Starters",
            description:
              "Crumb fried cheese sticks serving size: 310gms energy per 100 gms: 292. 42kcal contains: milk, gluten, soy",
            cloudinaryImageId: "lflhvex0px6ocsofpkwg",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545248": {
            id: 545248,
            name: "Devil's Chicken",
            category: "Starters",
            description:
              "You read it right! stir fried chicken with a soya chilli marinade and caramelized onion serving size: 250gms energy per 100 gms: 196. 45kcal contains: gluten, sulphite, soy",
            cloudinaryImageId: "o6z8ikz1ilvyvy2hdur8",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545249": {
            id: 545249,
            name: "Chicken Wings",
            category: "Starters",
            description:
              "Deep fried juicy chicken wings. (choice of bbq/ schezwan/ peri peri sauce/ dusted peri peri seasoning/ buffalo sauce/ honey chilli bbq) serving size: 150gms energy per 100 gms: 208. 19kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "ztvdo6mx3dxkfe9dybep",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21429,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78804541,
                group_name: "Wings Option",
                choices: [
                  {
                    id: 63573220,
                    name: "Schezwan Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63573218,
                    name: "Honey Chilli Bbq",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63573217,
                    name: "Dusted Peri Peri Seasoning",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63573219,
                    name: "Peri Peri Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63573216,
                    name: "Buffalo Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63573215,
                    name: "Bbq Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545251": {
            id: 545251,
            name: "Chicken Rocky Road",
            category: "Starters",
            description:
              "Seasoned panko fried chicken served with our chilli mayo and buffalo sauce serving size: 300gms energy per 100 gms: 260. 7kcal contains: gluten, soy",
            cloudinaryImageId: "n98znvqvxhpryliep7ig",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545253": {
            id: 545253,
            name: "Thai Fried Chicken",
            category: "Starters",
            description:
              "Crunchy fried diced chicken tossed in a tangy thai sauce serving size: 200gms energy per 100 gms: 235. 84kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "nv6hpk1osd6inpovryri",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545257": {
            id: 545257,
            name: "Peri Peri Chicken",
            category: "Starters",
            description:
              "Chicken supreme in our inhouse fiery peri peri sauce with a side salad serving size: 350gms energy per 100 gms: 190. 32kcal contains: milk, gluten, sulphite, egg",
            cloudinaryImageId: "xoz2uo7pfo4ck6xr0pmm",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545258": {
            id: 545258,
            name: "Peri Peri Fish",
            category: "Starters",
            description:
              "Fish in our inhouse fiery peri peri sauce with a side salad serving size: 220gms energy per 100 gms: 168. 84kcal contains: milk, gluten, sulphite",
            cloudinaryImageId: "kozfmt6jiovramvuuddb",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545265": {
            id: 545265,
            name: "Veg Burger",
            category: "Burger",
            description:
              "Truffles og! tangy vegetable patty serving size: 250gms energy per 100 gms: 219. 23kcal contains: soy, gluten",
            cloudinaryImageId: "bjmsrpelu21yncn9idr1",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129393",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172678",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129393",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172679",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129393",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172680",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129393",
                      order: 98,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172681",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129393",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129393", variation_id: "55172678" },
                  ],
                  price: 14762,
                  addon_combinations: [
                    { group_id: "47701873", addon_id: "33690322" },
                    { group_id: "47701873", addon_id: "33690323" },
                    { group_id: "47701873", addon_id: "33690324" },
                    { group_id: "47701874", addon_id: "33690325" },
                    { group_id: "47701874", addon_id: "33690326" },
                    { group_id: "47701874", addon_id: "33690327" },
                    { group_id: "47701874", addon_id: "33690328" },
                    { group_id: "47701874", addon_id: "33690329" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129393", variation_id: "55172679" },
                  ],
                  price: 22381,
                  addon_combinations: [
                    { group_id: "47701873", addon_id: "33690322" },
                    { group_id: "47701873", addon_id: "33690323" },
                    { group_id: "47701873", addon_id: "33690324" },
                    { group_id: "47701874", addon_id: "33690325" },
                    { group_id: "47701874", addon_id: "33690326" },
                    { group_id: "47701874", addon_id: "33690327" },
                    { group_id: "47701874", addon_id: "33690328" },
                    { group_id: "47701874", addon_id: "33690329" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129393", variation_id: "55172680" },
                  ],
                  price: 26667,
                  addon_combinations: [
                    { group_id: "47701873", addon_id: "33690322" },
                    { group_id: "47701873", addon_id: "33690323" },
                    { group_id: "47701873", addon_id: "33690324" },
                    { group_id: "47701874", addon_id: "33690325" },
                    { group_id: "47701874", addon_id: "33690326" },
                    { group_id: "47701874", addon_id: "33690327" },
                    { group_id: "47701874", addon_id: "33690328" },
                    { group_id: "47701874", addon_id: "33690329" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129393", variation_id: "55172681" },
                  ],
                  price: 30953,
                  addon_combinations: [
                    { group_id: "47701873", addon_id: "33690322" },
                    { group_id: "47701873", addon_id: "33690323" },
                    { group_id: "47701873", addon_id: "33690324" },
                    { group_id: "47701874", addon_id: "33690325" },
                    { group_id: "47701874", addon_id: "33690326" },
                    { group_id: "47701874", addon_id: "33690327" },
                    { group_id: "47701874", addon_id: "33690328" },
                    { group_id: "47701874", addon_id: "33690329" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701873,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690324,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690323,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690322,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701874,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33690325,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690327,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690326,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690329,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690328,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 14762,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545269": {
            id: 545269,
            name: "Butter Paneer Burger",
            category: "Burger",
            description:
              "Slow cooked butter paneer inside soft burger buns serving size: 200gms energy per 100 gms: 257. 31kcal contains: milk, soy, gluten",
            cloudinaryImageId: "ckmrgwgwuidhpaikhx3n",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129394",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172033",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129394",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172034",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129394",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129394", variation_id: "55172033" },
                  ],
                  price: 16667,
                  addon_combinations: [
                    { group_id: "47700915", addon_id: "33689254" },
                    { group_id: "47700915", addon_id: "33689255" },
                    { group_id: "47700915", addon_id: "33689256" },
                    { group_id: "47700916", addon_id: "33689257" },
                    { group_id: "47700916", addon_id: "33689258" },
                    { group_id: "47700916", addon_id: "33689259" },
                    { group_id: "47700916", addon_id: "33689260" },
                    { group_id: "47700916", addon_id: "33689261" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129394", variation_id: "55172034" },
                  ],
                  price: 27143,
                  addon_combinations: [
                    { group_id: "47700915", addon_id: "33689254" },
                    { group_id: "47700915", addon_id: "33689255" },
                    { group_id: "47700915", addon_id: "33689256" },
                    { group_id: "47700916", addon_id: "33689257" },
                    { group_id: "47700916", addon_id: "33689258" },
                    { group_id: "47700916", addon_id: "33689259" },
                    { group_id: "47700916", addon_id: "33689260" },
                    { group_id: "47700916", addon_id: "33689261" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700915,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689255,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689254,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689256,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700916,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33689259,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689258,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689261,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689257,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689260,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 16667,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545273": {
            id: 545273,
            name: "Cheese Burger",
            category: "Burger",
            description:
              "Crumb fried cheese burst patty serving size: 230gms energy per 100 gms: 276. 13kcal contains: milk, soy, gluten",
            cloudinaryImageId: "uclbw6lhtk7cv71dahq8",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129396",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172403",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129396",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172404",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129396",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172405",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129396",
                      order: 98,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172406",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129396",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129396", variation_id: "55172403" },
                  ],
                  price: 15715,
                  addon_combinations: [
                    { group_id: "47700911", addon_id: "33689246" },
                    { group_id: "47700911", addon_id: "33689247" },
                    { group_id: "47700911", addon_id: "33689248" },
                    { group_id: "47700912", addon_id: "33689249" },
                    { group_id: "47700912", addon_id: "33689250" },
                    { group_id: "47700912", addon_id: "33689251" },
                    { group_id: "47700912", addon_id: "33689252" },
                    { group_id: "47700912", addon_id: "33689253" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129396", variation_id: "55172404" },
                  ],
                  price: 23334,
                  addon_combinations: [
                    { group_id: "47700911", addon_id: "33689246" },
                    { group_id: "47700911", addon_id: "33689247" },
                    { group_id: "47700911", addon_id: "33689248" },
                    { group_id: "47700912", addon_id: "33689249" },
                    { group_id: "47700912", addon_id: "33689250" },
                    { group_id: "47700912", addon_id: "33689251" },
                    { group_id: "47700912", addon_id: "33689252" },
                    { group_id: "47700912", addon_id: "33689253" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129396", variation_id: "55172405" },
                  ],
                  price: 28096,
                  addon_combinations: [
                    { group_id: "47700911", addon_id: "33689246" },
                    { group_id: "47700911", addon_id: "33689247" },
                    { group_id: "47700911", addon_id: "33689248" },
                    { group_id: "47700912", addon_id: "33689249" },
                    { group_id: "47700912", addon_id: "33689250" },
                    { group_id: "47700912", addon_id: "33689251" },
                    { group_id: "47700912", addon_id: "33689252" },
                    { group_id: "47700912", addon_id: "33689253" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129396", variation_id: "55172406" },
                  ],
                  price: 32858,
                  addon_combinations: [
                    { group_id: "47700911", addon_id: "33689246" },
                    { group_id: "47700911", addon_id: "33689247" },
                    { group_id: "47700911", addon_id: "33689248" },
                    { group_id: "47700912", addon_id: "33689249" },
                    { group_id: "47700912", addon_id: "33689250" },
                    { group_id: "47700912", addon_id: "33689251" },
                    { group_id: "47700912", addon_id: "33689252" },
                    { group_id: "47700912", addon_id: "33689253" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700911,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689248,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689247,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689246,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700912,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33689251,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689250,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689253,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689249,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689252,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 15715,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545277": {
            id: 545277,
            name: "Cottage Cheese Burger",
            category: "Burger",
            description:
              "Cottage cheese in a jacket of mash potato serving size: 240gms energy per 100 gms: 216. 45kcal contains: milk, gluten",
            cloudinaryImageId: "u8mr5adsynky5bn5txos",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129397",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172296",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129397",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172297",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129397",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172298",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129397",
                      order: 98,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172300",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129397",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129397", variation_id: "55172296" },
                  ],
                  price: 15715,
                  addon_combinations: [
                    { group_id: "47700992", addon_id: "33689460" },
                    { group_id: "47700992", addon_id: "33689461" },
                    { group_id: "47700992", addon_id: "33689462" },
                    { group_id: "47700995", addon_id: "33689463" },
                    { group_id: "47700995", addon_id: "33689464" },
                    { group_id: "47700995", addon_id: "33689465" },
                    { group_id: "47700995", addon_id: "33689466" },
                    { group_id: "47700995", addon_id: "33689467" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129397", variation_id: "55172297" },
                  ],
                  price: 23334,
                  addon_combinations: [
                    { group_id: "47700992", addon_id: "33689460" },
                    { group_id: "47700992", addon_id: "33689461" },
                    { group_id: "47700992", addon_id: "33689462" },
                    { group_id: "47700995", addon_id: "33689463" },
                    { group_id: "47700995", addon_id: "33689464" },
                    { group_id: "47700995", addon_id: "33689465" },
                    { group_id: "47700995", addon_id: "33689466" },
                    { group_id: "47700995", addon_id: "33689467" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129397", variation_id: "55172298" },
                  ],
                  price: 26667,
                  addon_combinations: [
                    { group_id: "47700992", addon_id: "33689460" },
                    { group_id: "47700992", addon_id: "33689461" },
                    { group_id: "47700992", addon_id: "33689462" },
                    { group_id: "47700995", addon_id: "33689463" },
                    { group_id: "47700995", addon_id: "33689464" },
                    { group_id: "47700995", addon_id: "33689465" },
                    { group_id: "47700995", addon_id: "33689466" },
                    { group_id: "47700995", addon_id: "33689467" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129397", variation_id: "55172300" },
                  ],
                  price: 29524,
                  addon_combinations: [
                    { group_id: "47700992", addon_id: "33689460" },
                    { group_id: "47700992", addon_id: "33689461" },
                    { group_id: "47700992", addon_id: "33689462" },
                    { group_id: "47700995", addon_id: "33689463" },
                    { group_id: "47700995", addon_id: "33689464" },
                    { group_id: "47700995", addon_id: "33689465" },
                    { group_id: "47700995", addon_id: "33689466" },
                    { group_id: "47700995", addon_id: "33689467" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700992,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689460,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689462,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689461,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700995,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33689467,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689466,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689465,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689464,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689463,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 15715,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545281": {
            id: 545281,
            name: "Mexican Bean Burger",
            category: "Burger",
            description:
              "Tangy veg patty with mexican beans serving size: 240gms energy per 100 gms: 239. 19kcal contains: soy, gluten",
            cloudinaryImageId: "rqwvdwjsia3hs7itv21k",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129398",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172627",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129398",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172628",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129398",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172629",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129398",
                      order: 98,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172630",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129398",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129398", variation_id: "55172627" },
                  ],
                  price: 15239,
                  addon_combinations: [
                    { group_id: "47701527", addon_id: "33689982" },
                    { group_id: "47701527", addon_id: "33689983" },
                    { group_id: "47701527", addon_id: "33689984" },
                    { group_id: "47701531", addon_id: "33689985" },
                    { group_id: "47701531", addon_id: "33689986" },
                    { group_id: "47701531", addon_id: "33689987" },
                    { group_id: "47701531", addon_id: "33689988" },
                    { group_id: "47701531", addon_id: "33689989" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129398", variation_id: "55172628" },
                  ],
                  price: 22858,
                  addon_combinations: [
                    { group_id: "47701527", addon_id: "33689982" },
                    { group_id: "47701527", addon_id: "33689983" },
                    { group_id: "47701527", addon_id: "33689984" },
                    { group_id: "47701531", addon_id: "33689985" },
                    { group_id: "47701531", addon_id: "33689986" },
                    { group_id: "47701531", addon_id: "33689987" },
                    { group_id: "47701531", addon_id: "33689988" },
                    { group_id: "47701531", addon_id: "33689989" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129398", variation_id: "55172629" },
                  ],
                  price: 26191,
                  addon_combinations: [
                    { group_id: "47701527", addon_id: "33689982" },
                    { group_id: "47701527", addon_id: "33689983" },
                    { group_id: "47701527", addon_id: "33689984" },
                    { group_id: "47701531", addon_id: "33689985" },
                    { group_id: "47701531", addon_id: "33689986" },
                    { group_id: "47701531", addon_id: "33689987" },
                    { group_id: "47701531", addon_id: "33689988" },
                    { group_id: "47701531", addon_id: "33689989" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129398", variation_id: "55172630" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701527", addon_id: "33689982" },
                    { group_id: "47701527", addon_id: "33689983" },
                    { group_id: "47701527", addon_id: "33689984" },
                    { group_id: "47701531", addon_id: "33689985" },
                    { group_id: "47701531", addon_id: "33689986" },
                    { group_id: "47701531", addon_id: "33689987" },
                    { group_id: "47701531", addon_id: "33689988" },
                    { group_id: "47701531", addon_id: "33689989" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701527,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689984,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689983,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689982,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701531,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33689985,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689989,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689988,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689987,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689986,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 15239,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545285": {
            id: 545285,
            name: "Soya Burger",
            category: "Burger",
            description:
              "Minced soya chunks crumbed in broken wheat serving size: 240gms energy per 100 gms: 245. 44kcal contains: soy, gluten",
            cloudinaryImageId: "snfsxfdesf8tmnb4xqt6",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129399",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172702",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129399",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172703",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129399",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172705",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129399",
                      order: 98,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172704",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129399",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129399", variation_id: "55172702" },
                  ],
                  price: 15239,
                  addon_combinations: [
                    { group_id: "47701879", addon_id: "33690330" },
                    { group_id: "47701879", addon_id: "33690331" },
                    { group_id: "47701879", addon_id: "33690332" },
                    { group_id: "47701882", addon_id: "33690333" },
                    { group_id: "47701882", addon_id: "33690334" },
                    { group_id: "47701882", addon_id: "33690335" },
                    { group_id: "47701882", addon_id: "33690336" },
                    { group_id: "47701882", addon_id: "33690337" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129399", variation_id: "55172703" },
                  ],
                  price: 22858,
                  addon_combinations: [
                    { group_id: "47701879", addon_id: "33690330" },
                    { group_id: "47701879", addon_id: "33690331" },
                    { group_id: "47701879", addon_id: "33690332" },
                    { group_id: "47701882", addon_id: "33690333" },
                    { group_id: "47701882", addon_id: "33690334" },
                    { group_id: "47701882", addon_id: "33690335" },
                    { group_id: "47701882", addon_id: "33690336" },
                    { group_id: "47701882", addon_id: "33690337" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129399", variation_id: "55172705" },
                  ],
                  price: 26191,
                  addon_combinations: [
                    { group_id: "47701879", addon_id: "33690330" },
                    { group_id: "47701879", addon_id: "33690331" },
                    { group_id: "47701879", addon_id: "33690332" },
                    { group_id: "47701882", addon_id: "33690333" },
                    { group_id: "47701882", addon_id: "33690334" },
                    { group_id: "47701882", addon_id: "33690335" },
                    { group_id: "47701882", addon_id: "33690336" },
                    { group_id: "47701882", addon_id: "33690337" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129399", variation_id: "55172704" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701879", addon_id: "33690330" },
                    { group_id: "47701879", addon_id: "33690331" },
                    { group_id: "47701879", addon_id: "33690332" },
                    { group_id: "47701882", addon_id: "33690333" },
                    { group_id: "47701882", addon_id: "33690334" },
                    { group_id: "47701882", addon_id: "33690335" },
                    { group_id: "47701882", addon_id: "33690336" },
                    { group_id: "47701882", addon_id: "33690337" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701879,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690332,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690331,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690330,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701882,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33690336,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690335,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690337,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690334,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690333,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 15239,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545297": {
            id: 545297,
            name: "Tex Mex Chicken Burger",
            category: "Burger",
            description:
              "Viva la burger! mexican marinated minced chicken with salsa and jalapenos. Served with tomatoes and chopped onions serving size: 240gms energy per 100 gms: 210. 67kcal contains: egg, soy, gluten",
            cloudinaryImageId: "j3iotbq8iyf5ze7psmsq",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129405",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55173184",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129405",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55173185",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129405",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129405", variation_id: "55173184" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47701920", addon_id: "33690373" },
                    { group_id: "47701920", addon_id: "33690374" },
                    { group_id: "47701920", addon_id: "33690375" },
                    { group_id: "47701921", addon_id: "33690376" },
                    { group_id: "47701921", addon_id: "33690377" },
                    { group_id: "47701921", addon_id: "33690378" },
                    { group_id: "47701922", addon_id: "33690379" },
                    { group_id: "47701922", addon_id: "33690380" },
                    { group_id: "47701922", addon_id: "33690381" },
                    { group_id: "47701922", addon_id: "33690382" },
                    { group_id: "47701922", addon_id: "33690383" },
                    { group_id: "47701922", addon_id: "33690384" },
                    { group_id: "47701922", addon_id: "33690385" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129405", variation_id: "55173185" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "47701920", addon_id: "33690373" },
                    { group_id: "47701920", addon_id: "33690374" },
                    { group_id: "47701920", addon_id: "33690375" },
                    { group_id: "47701921", addon_id: "33690376" },
                    { group_id: "47701921", addon_id: "33690377" },
                    { group_id: "47701921", addon_id: "33690378" },
                    { group_id: "47701922", addon_id: "33690379" },
                    { group_id: "47701922", addon_id: "33690380" },
                    { group_id: "47701922", addon_id: "33690381" },
                    { group_id: "47701922", addon_id: "33690382" },
                    { group_id: "47701922", addon_id: "33690383" },
                    { group_id: "47701922", addon_id: "33690384" },
                    { group_id: "47701922", addon_id: "33690385" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701920,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690375,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690374,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690373,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701921,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690376,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690378,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690377,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701922,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690383,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690379,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690382,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690385,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690384,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690381,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690380,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19048,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545299": {
            id: 545299,
            name: "Chicken Peri Peri Burger",
            category: "Burger",
            description:
              "Supremes of chicken sauteed in a truffles peri peri sauce. Served with tomatoes and chopped onions serving size: 240gms energy per 100 gms: 240. 29kcal contains: milk, gluten",
            cloudinaryImageId: "ppxql5kvdcyzm01cu9el",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129406",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172515",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129406",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172517",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129406",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129406", variation_id: "55172515" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47701730", addon_id: "33690154" },
                    { group_id: "47701730", addon_id: "33690155" },
                    { group_id: "47701730", addon_id: "33690156" },
                    { group_id: "47701731", addon_id: "33690157" },
                    { group_id: "47701731", addon_id: "33690158" },
                    { group_id: "47701731", addon_id: "33690159" },
                    { group_id: "47701734", addon_id: "33690160" },
                    { group_id: "47701734", addon_id: "33690161" },
                    { group_id: "47701734", addon_id: "33690162" },
                    { group_id: "47701734", addon_id: "33690163" },
                    { group_id: "47701734", addon_id: "33690164" },
                    { group_id: "47701734", addon_id: "33690165" },
                    { group_id: "47701734", addon_id: "33690166" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129406", variation_id: "55172517" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701730", addon_id: "33690154" },
                    { group_id: "47701730", addon_id: "33690155" },
                    { group_id: "47701730", addon_id: "33690156" },
                    { group_id: "47701731", addon_id: "33690157" },
                    { group_id: "47701731", addon_id: "33690158" },
                    { group_id: "47701731", addon_id: "33690159" },
                    { group_id: "47701734", addon_id: "33690160" },
                    { group_id: "47701734", addon_id: "33690161" },
                    { group_id: "47701734", addon_id: "33690162" },
                    { group_id: "47701734", addon_id: "33690163" },
                    { group_id: "47701734", addon_id: "33690164" },
                    { group_id: "47701734", addon_id: "33690165" },
                    { group_id: "47701734", addon_id: "33690166" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701730,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690156,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690155,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690154,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701731,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690159,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690158,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690157,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701734,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690163,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690162,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690165,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690164,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690166,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690161,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690160,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19048,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545301": {
            id: 545301,
            name: "Tandoori Chicken Burger",
            category: "Burger",
            description:
              "Juicy fillet of tandoori chicken smeared with garlic butter, lettuce, onion & gherkins serving size: 190gms energy per 100 gms: 233. 2kcal contains: egg, gluten, sulphite",
            cloudinaryImageId: "ymjhmoqeohrahryxhlpc",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129407",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172728",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129407",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172729",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129407",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172730",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129407",
                      order: 98,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172731",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129407",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129407", variation_id: "55172728" },
                  ],
                  price: 17620,
                  addon_combinations: [
                    { group_id: "47701915", addon_id: "33690360" },
                    { group_id: "47701915", addon_id: "33690361" },
                    { group_id: "47701915", addon_id: "33690362" },
                    { group_id: "47701916", addon_id: "33690363" },
                    { group_id: "47701916", addon_id: "33690364" },
                    { group_id: "47701916", addon_id: "33690365" },
                    { group_id: "47701918", addon_id: "33690366" },
                    { group_id: "47701918", addon_id: "33690367" },
                    { group_id: "47701918", addon_id: "33690368" },
                    { group_id: "47701918", addon_id: "33690369" },
                    { group_id: "47701918", addon_id: "33690370" },
                    { group_id: "47701918", addon_id: "33690371" },
                    { group_id: "47701918", addon_id: "33690372" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129407", variation_id: "55172729" },
                  ],
                  price: 26667,
                  addon_combinations: [
                    { group_id: "47701915", addon_id: "33690360" },
                    { group_id: "47701915", addon_id: "33690361" },
                    { group_id: "47701915", addon_id: "33690362" },
                    { group_id: "47701916", addon_id: "33690363" },
                    { group_id: "47701916", addon_id: "33690364" },
                    { group_id: "47701916", addon_id: "33690365" },
                    { group_id: "47701918", addon_id: "33690366" },
                    { group_id: "47701918", addon_id: "33690367" },
                    { group_id: "47701918", addon_id: "33690368" },
                    { group_id: "47701918", addon_id: "33690369" },
                    { group_id: "47701918", addon_id: "33690370" },
                    { group_id: "47701918", addon_id: "33690371" },
                    { group_id: "47701918", addon_id: "33690372" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129407", variation_id: "55172730" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701915", addon_id: "33690360" },
                    { group_id: "47701915", addon_id: "33690361" },
                    { group_id: "47701915", addon_id: "33690362" },
                    { group_id: "47701916", addon_id: "33690363" },
                    { group_id: "47701916", addon_id: "33690364" },
                    { group_id: "47701916", addon_id: "33690365" },
                    { group_id: "47701918", addon_id: "33690366" },
                    { group_id: "47701918", addon_id: "33690367" },
                    { group_id: "47701918", addon_id: "33690368" },
                    { group_id: "47701918", addon_id: "33690369" },
                    { group_id: "47701918", addon_id: "33690370" },
                    { group_id: "47701918", addon_id: "33690371" },
                    { group_id: "47701918", addon_id: "33690372" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129407", variation_id: "55172731" },
                  ],
                  price: 38572,
                  addon_combinations: [
                    { group_id: "47701915", addon_id: "33690360" },
                    { group_id: "47701915", addon_id: "33690361" },
                    { group_id: "47701915", addon_id: "33690362" },
                    { group_id: "47701916", addon_id: "33690363" },
                    { group_id: "47701916", addon_id: "33690364" },
                    { group_id: "47701916", addon_id: "33690365" },
                    { group_id: "47701918", addon_id: "33690366" },
                    { group_id: "47701918", addon_id: "33690367" },
                    { group_id: "47701918", addon_id: "33690368" },
                    { group_id: "47701918", addon_id: "33690369" },
                    { group_id: "47701918", addon_id: "33690370" },
                    { group_id: "47701918", addon_id: "33690371" },
                    { group_id: "47701918", addon_id: "33690372" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701915,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690361,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690360,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690362,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701916,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690365,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690364,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690363,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701918,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690369,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690372,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690368,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690371,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690367,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690370,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690366,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 17620,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545312": {
            id: 545312,
            name: "Crispy Cross Chicken Burger",
            category: "Burger",
            description:
              "Truffles signature! sesame fried chicken breast with a tangy, spicy mustardy twist. Served with tomatoes and chopped onions serving size: 190gms energy per 100 gms: 218. 98kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "aotity8gcut42xgjiyl2",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129414",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172333",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129414",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172334",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129414",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129414", variation_id: "55172333" },
                  ],
                  price: 20000,
                  addon_combinations: [
                    { group_id: "47701182", addon_id: "33689770" },
                    { group_id: "47701182", addon_id: "33689771" },
                    { group_id: "47701182", addon_id: "33689772" },
                    { group_id: "47701185", addon_id: "33689773" },
                    { group_id: "47701185", addon_id: "33689774" },
                    { group_id: "47701185", addon_id: "33689775" },
                    { group_id: "47701187", addon_id: "33689776" },
                    { group_id: "47701187", addon_id: "33689777" },
                    { group_id: "47701187", addon_id: "33689778" },
                    { group_id: "47701187", addon_id: "33689779" },
                    { group_id: "47701187", addon_id: "33689780" },
                    { group_id: "47701187", addon_id: "33689781" },
                    { group_id: "47701187", addon_id: "33689782" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129414", variation_id: "55172334" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701182", addon_id: "33689770" },
                    { group_id: "47701182", addon_id: "33689771" },
                    { group_id: "47701182", addon_id: "33689772" },
                    { group_id: "47701185", addon_id: "33689773" },
                    { group_id: "47701185", addon_id: "33689774" },
                    { group_id: "47701185", addon_id: "33689775" },
                    { group_id: "47701187", addon_id: "33689776" },
                    { group_id: "47701187", addon_id: "33689777" },
                    { group_id: "47701187", addon_id: "33689778" },
                    { group_id: "47701187", addon_id: "33689779" },
                    { group_id: "47701187", addon_id: "33689780" },
                    { group_id: "47701187", addon_id: "33689781" },
                    { group_id: "47701187", addon_id: "33689782" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701182,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689772,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689771,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689770,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701185,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689775,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689774,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689773,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701187,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689776,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689779,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689782,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689778,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689781,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689777,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689780,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20000,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545326": {
            id: 545326,
            name: "Lamb Burger",
            category: "Burger",
            description:
              "Grilled lamb patty served with onions and tomatoes serving size: 185gms energy per 100 gms: 254. 36kcal contains: egg, gluten",
            cloudinaryImageId: "ab862e9dc07f89dc6db37a8befff289e",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129421",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172642",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129421",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172643",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129421",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172644",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129421",
                      order: 98,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172645",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129421",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129421", variation_id: "55172642" },
                  ],
                  price: 20953,
                  addon_combinations: [
                    { group_id: "47701585", addon_id: "33690017" },
                    { group_id: "47701585", addon_id: "33690018" },
                    { group_id: "47701585", addon_id: "33690019" },
                    { group_id: "47701586", addon_id: "33690020" },
                    { group_id: "47701586", addon_id: "33690021" },
                    { group_id: "47701586", addon_id: "33690022" },
                    { group_id: "47701590", addon_id: "33690023" },
                    { group_id: "47701590", addon_id: "33690024" },
                    { group_id: "47701590", addon_id: "33690025" },
                    { group_id: "47701590", addon_id: "33690026" },
                    { group_id: "47701590", addon_id: "33690027" },
                    { group_id: "47701590", addon_id: "33690028" },
                    { group_id: "47701590", addon_id: "33690029" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129421", variation_id: "55172643" },
                  ],
                  price: 33334,
                  addon_combinations: [
                    { group_id: "47701585", addon_id: "33690017" },
                    { group_id: "47701585", addon_id: "33690018" },
                    { group_id: "47701585", addon_id: "33690019" },
                    { group_id: "47701586", addon_id: "33690020" },
                    { group_id: "47701586", addon_id: "33690021" },
                    { group_id: "47701586", addon_id: "33690022" },
                    { group_id: "47701590", addon_id: "33690023" },
                    { group_id: "47701590", addon_id: "33690024" },
                    { group_id: "47701590", addon_id: "33690025" },
                    { group_id: "47701590", addon_id: "33690026" },
                    { group_id: "47701590", addon_id: "33690027" },
                    { group_id: "47701590", addon_id: "33690028" },
                    { group_id: "47701590", addon_id: "33690029" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129421", variation_id: "55172644" },
                  ],
                  price: 37143,
                  addon_combinations: [
                    { group_id: "47701585", addon_id: "33690017" },
                    { group_id: "47701585", addon_id: "33690018" },
                    { group_id: "47701585", addon_id: "33690019" },
                    { group_id: "47701586", addon_id: "33690020" },
                    { group_id: "47701586", addon_id: "33690021" },
                    { group_id: "47701586", addon_id: "33690022" },
                    { group_id: "47701590", addon_id: "33690023" },
                    { group_id: "47701590", addon_id: "33690024" },
                    { group_id: "47701590", addon_id: "33690025" },
                    { group_id: "47701590", addon_id: "33690026" },
                    { group_id: "47701590", addon_id: "33690027" },
                    { group_id: "47701590", addon_id: "33690028" },
                    { group_id: "47701590", addon_id: "33690029" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129421", variation_id: "55172645" },
                  ],
                  price: 52381,
                  addon_combinations: [
                    { group_id: "47701585", addon_id: "33690017" },
                    { group_id: "47701585", addon_id: "33690018" },
                    { group_id: "47701585", addon_id: "33690019" },
                    { group_id: "47701586", addon_id: "33690020" },
                    { group_id: "47701586", addon_id: "33690021" },
                    { group_id: "47701586", addon_id: "33690022" },
                    { group_id: "47701590", addon_id: "33690023" },
                    { group_id: "47701590", addon_id: "33690024" },
                    { group_id: "47701590", addon_id: "33690025" },
                    { group_id: "47701590", addon_id: "33690026" },
                    { group_id: "47701590", addon_id: "33690027" },
                    { group_id: "47701590", addon_id: "33690028" },
                    { group_id: "47701590", addon_id: "33690029" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701585,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690017,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690019,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690018,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701586,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690020,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690022,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690021,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701590,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690028,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690027,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690029,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690024,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690023,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690026,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690025,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20953,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545330": {
            id: 545330,
            name: "Fish Fillet Burger",
            category: "Burger",
            description:
              "Crunchy crumb fried fillet of fish served with tomatoes, chopped onions and tartar sauce serving size: 200gms energy per 100 gms: 213. 26kcal contains: seafood, egg, gluten",
            cloudinaryImageId: "f713854593a8f2585f11d21c15ed0e33",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129423",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172496",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129423",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172497",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129423",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172498",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129423",
                      order: 98,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129423", variation_id: "55172496" },
                  ],
                  price: 17620,
                  addon_combinations: [
                    { group_id: "47701156", addon_id: "33689742" },
                    { group_id: "47701156", addon_id: "33689743" },
                    { group_id: "47701156", addon_id: "33689744" },
                    { group_id: "47701158", addon_id: "33689745" },
                    { group_id: "47701158", addon_id: "33689747" },
                    { group_id: "47701158", addon_id: "33689748" },
                    { group_id: "47701161", addon_id: "33689750" },
                    { group_id: "47701161", addon_id: "33689751" },
                    { group_id: "47701161", addon_id: "33689752" },
                    { group_id: "47701161", addon_id: "33689753" },
                    { group_id: "47701161", addon_id: "33689754" },
                    { group_id: "47701161", addon_id: "33689755" },
                    { group_id: "47701161", addon_id: "33689756" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129423", variation_id: "55172497" },
                  ],
                  price: 26667,
                  addon_combinations: [
                    { group_id: "47701156", addon_id: "33689742" },
                    { group_id: "47701156", addon_id: "33689743" },
                    { group_id: "47701156", addon_id: "33689744" },
                    { group_id: "47701158", addon_id: "33689745" },
                    { group_id: "47701158", addon_id: "33689747" },
                    { group_id: "47701158", addon_id: "33689748" },
                    { group_id: "47701161", addon_id: "33689750" },
                    { group_id: "47701161", addon_id: "33689751" },
                    { group_id: "47701161", addon_id: "33689752" },
                    { group_id: "47701161", addon_id: "33689753" },
                    { group_id: "47701161", addon_id: "33689754" },
                    { group_id: "47701161", addon_id: "33689755" },
                    { group_id: "47701161", addon_id: "33689756" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129423", variation_id: "55172498" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701156", addon_id: "33689742" },
                    { group_id: "47701156", addon_id: "33689743" },
                    { group_id: "47701156", addon_id: "33689744" },
                    { group_id: "47701158", addon_id: "33689745" },
                    { group_id: "47701158", addon_id: "33689747" },
                    { group_id: "47701158", addon_id: "33689748" },
                    { group_id: "47701161", addon_id: "33689750" },
                    { group_id: "47701161", addon_id: "33689751" },
                    { group_id: "47701161", addon_id: "33689752" },
                    { group_id: "47701161", addon_id: "33689753" },
                    { group_id: "47701161", addon_id: "33689754" },
                    { group_id: "47701161", addon_id: "33689755" },
                    { group_id: "47701161", addon_id: "33689756" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701156,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689743,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689742,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689744,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701158,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689747,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689745,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689748,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701161,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689754,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689753,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689752,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689751,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689750,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689756,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689755,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 17620,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545350": {
            id: 545350,
            name: "Cottage Cheese Sub",
            category: "Submarine",
            description:
              "Medium spicy paneer masala in either a reg/xl sized sub serving size: 280gms energy per 100 gms: 243. 21kcal contains: milk, gluten, soy",
            cloudinaryImageId: "qud8ktpeubbqfp83euxc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129439",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172254",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "129439",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172252",
                      inStock: 0,
                      isVeg: 1,
                      variant_group_id: "129439",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129439", variation_id: "55172254" },
                  ],
                  price: 20000,
                  addon_combinations: [
                    { group_id: "47700880", addon_id: "33689218" },
                    { group_id: "47700880", addon_id: "33689219" },
                    { group_id: "47700880", addon_id: "33689220" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129439", variation_id: "55172252" },
                  ],
                  price: 13334,
                  addon_combinations: [
                    { group_id: "47700880", addon_id: "33689218" },
                    { group_id: "47700880", addon_id: "33689219" },
                    { group_id: "47700880", addon_id: "33689220" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700880,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689220,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689219,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689218,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20000,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545355": {
            id: 545355,
            name: "Devil's Chicken Sub",
            category: "Submarine",
            description:
              "That's right! stir fried chicken with a soya chilli marinade and caramelized onion served in a reg/ xl sub serving size: 310gms energy per 100 gms: 244. 09kcal contains: egg, gluten, sulphite",
            cloudinaryImageId: "dqtuubj8mqs7rhxb92tk",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129441",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172319",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129441",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172321",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129441",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129441", variation_id: "55172319" },
                  ],
                  price: 15715,
                  addon_combinations: [
                    { group_id: "47700999", addon_id: "33689468" },
                    { group_id: "47700999", addon_id: "33689469" },
                    { group_id: "47700999", addon_id: "33689470" },
                    { group_id: "47701000", addon_id: "33689471" },
                    { group_id: "47701000", addon_id: "33689472" },
                    { group_id: "47701000", addon_id: "33689473" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129441", variation_id: "55172321" },
                  ],
                  price: 23334,
                  addon_combinations: [
                    { group_id: "47700999", addon_id: "33689468" },
                    { group_id: "47700999", addon_id: "33689469" },
                    { group_id: "47700999", addon_id: "33689470" },
                    { group_id: "47701000", addon_id: "33689471" },
                    { group_id: "47701000", addon_id: "33689472" },
                    { group_id: "47701000", addon_id: "33689473" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700999,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689468,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689470,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689469,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701000,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689471,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689473,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689472,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 15715,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545357": {
            id: 545357,
            name: "Chicken Mayo Sub",
            category: "Submarine",
            description:
              "Creamy chicken with generous amounts of seasoned mayo served in either a reg/ xl sized sub serving size: 280gms energy per 100 gms: 242. 27kcal contains: egg, gluten, soy",
            cloudinaryImageId: "fyig9nepb0krulbitunc",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129442",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172271",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129442",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172270",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129442",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129442", variation_id: "55172271" },
                  ],
                  price: 23334,
                  addon_combinations: [
                    { group_id: "47700971", addon_id: "33689414" },
                    { group_id: "47700971", addon_id: "33689415" },
                    { group_id: "47700971", addon_id: "33689416" },
                    { group_id: "47700972", addon_id: "33689417" },
                    { group_id: "47700972", addon_id: "33689418" },
                    { group_id: "47700972", addon_id: "33689419" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129442", variation_id: "55172270" },
                  ],
                  price: 14762,
                  addon_combinations: [
                    { group_id: "47700971", addon_id: "33689414" },
                    { group_id: "47700971", addon_id: "33689415" },
                    { group_id: "47700971", addon_id: "33689416" },
                    { group_id: "47700972", addon_id: "33689417" },
                    { group_id: "47700972", addon_id: "33689418" },
                    { group_id: "47700972", addon_id: "33689419" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700971,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689416,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689415,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689414,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700972,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689417,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689419,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689418,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 23334,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545359": {
            id: 545359,
            name: "Crispy Cross Chicken Sub",
            category: "Submarine",
            description:
              "Crispy fried chicken with mustard sauce serving size: 250gms energy per 100 gms: 256. 12kcal contains: egg, gluten, sulphite",
            cloudinaryImageId: "x2w1dslp4c7wp9qnvbvv",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129443",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55731551",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129443",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55731550",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129443",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129443", variation_id: "55731551" },
                  ],
                  price: 20953,
                  addon_combinations: [
                    { group_id: "54456811", addon_id: "44729388" },
                    { group_id: "54456811", addon_id: "44729389" },
                    { group_id: "54456811", addon_id: "44729390" },
                    { group_id: "54456812", addon_id: "44729391" },
                    { group_id: "54456812", addon_id: "44729392" },
                    { group_id: "54456812", addon_id: "44729393" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129443", variation_id: "55731550" },
                  ],
                  price: 13334,
                  addon_combinations: [
                    { group_id: "54456811", addon_id: "44729388" },
                    { group_id: "54456811", addon_id: "44729389" },
                    { group_id: "54456811", addon_id: "44729390" },
                    { group_id: "54456812", addon_id: "44729391" },
                    { group_id: "54456812", addon_id: "44729392" },
                    { group_id: "54456812", addon_id: "44729393" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 54456811,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 44729389,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44729390,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44729388,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 54456812,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 44729392,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44729393,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 44729391,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20953,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545361": {
            id: 545361,
            name: "Chicken Ham Sub",
            category: "Submarine",
            description:
              "Coldcuts of smoked chicken ham served in either a reg/ double/ xl/ xxl sized sub serving size: 200gms energy per 100 gms: 270. 66kcal contains: egg, gluten, sulphite",
            cloudinaryImageId: "djolossc5lwerox91qxt",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129446",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172288",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129446",
                      order: 100,
                    },
                    {
                      name: "XXL",
                      price: 0,
                      default: 0,
                      id: "55172289",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129446",
                      order: 99,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172287",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129446",
                      order: 98,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172286",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129446",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129446", variation_id: "55172288" },
                  ],
                  price: 22381,
                  addon_combinations: [
                    { group_id: "47700977", addon_id: "33689426" },
                    { group_id: "47700977", addon_id: "33689427" },
                    { group_id: "47700977", addon_id: "33689428" },
                    { group_id: "47700978", addon_id: "33689429" },
                    { group_id: "47700978", addon_id: "33689430" },
                    { group_id: "47700978", addon_id: "33689431" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129446", variation_id: "55172289" },
                  ],
                  price: 28572,
                  addon_combinations: [
                    { group_id: "47700977", addon_id: "33689426" },
                    { group_id: "47700977", addon_id: "33689427" },
                    { group_id: "47700977", addon_id: "33689428" },
                    { group_id: "47700978", addon_id: "33689429" },
                    { group_id: "47700978", addon_id: "33689430" },
                    { group_id: "47700978", addon_id: "33689431" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129446", variation_id: "55172287" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "47700977", addon_id: "33689426" },
                    { group_id: "47700977", addon_id: "33689427" },
                    { group_id: "47700977", addon_id: "33689428" },
                    { group_id: "47700978", addon_id: "33689429" },
                    { group_id: "47700978", addon_id: "33689430" },
                    { group_id: "47700978", addon_id: "33689431" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129446", variation_id: "55172286" },
                  ],
                  price: 15239,
                  addon_combinations: [
                    { group_id: "47700977", addon_id: "33689426" },
                    { group_id: "47700977", addon_id: "33689427" },
                    { group_id: "47700977", addon_id: "33689428" },
                    { group_id: "47700978", addon_id: "33689429" },
                    { group_id: "47700978", addon_id: "33689430" },
                    { group_id: "47700978", addon_id: "33689431" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700977,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689428,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689427,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689426,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700978,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689431,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689430,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689429,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 22381,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545362": {
            id: 545362,
            name: "Chicken Salami Sub",
            category: "Submarine",
            description:
              "Coldcuts of chicken salami served in either a reg/ double/ xl/ xxl sized sub serving size: 220  273. 24kcal contains: gluten, soy, egg, sulphite",
            cloudinaryImageId: "jeqotyu0pul38pguvnco",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129444",
                  name: "Size",
                  variations: [
                    {
                      name: "XXL",
                      price: 0,
                      default: 1,
                      id: "55172295",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129444",
                      order: 100,
                    },
                    {
                      name: "Double",
                      price: 0,
                      default: 0,
                      id: "55172293",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129444",
                      order: 99,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172294",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129444",
                      order: 98,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172292",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129444",
                      order: 97,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129444", variation_id: "55172295" },
                  ],
                  price: 28572,
                  addon_combinations: [
                    { group_id: "47700980", addon_id: "33689432" },
                    { group_id: "47700980", addon_id: "33689433" },
                    { group_id: "47700980", addon_id: "33689434" },
                    { group_id: "47700981", addon_id: "33689435" },
                    { group_id: "47700981", addon_id: "33689436" },
                    { group_id: "47700981", addon_id: "33689437" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129444", variation_id: "55172293" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "47700980", addon_id: "33689432" },
                    { group_id: "47700980", addon_id: "33689433" },
                    { group_id: "47700980", addon_id: "33689434" },
                    { group_id: "47700981", addon_id: "33689435" },
                    { group_id: "47700981", addon_id: "33689436" },
                    { group_id: "47700981", addon_id: "33689437" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129444", variation_id: "55172294" },
                  ],
                  price: 23334,
                  addon_combinations: [
                    { group_id: "47700980", addon_id: "33689432" },
                    { group_id: "47700980", addon_id: "33689433" },
                    { group_id: "47700980", addon_id: "33689434" },
                    { group_id: "47700981", addon_id: "33689435" },
                    { group_id: "47700981", addon_id: "33689436" },
                    { group_id: "47700981", addon_id: "33689437" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129444", variation_id: "55172292" },
                  ],
                  price: 15239,
                  addon_combinations: [
                    { group_id: "47700980", addon_id: "33689432" },
                    { group_id: "47700980", addon_id: "33689433" },
                    { group_id: "47700980", addon_id: "33689434" },
                    { group_id: "47700981", addon_id: "33689435" },
                    { group_id: "47700981", addon_id: "33689436" },
                    { group_id: "47700981", addon_id: "33689437" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700980,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689434,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689433,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689432,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700981,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689435,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689437,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689436,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 28572,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545381": {
            id: 545381,
            name: "Great Dane",
            category: "Hot Dog",
            description:
              "A double chicken sausage with caramelized onion, gherkins & jalapenos serving size: 390gms energy per 100 gms: 291. 01kcal contains: sulphite, gluten, milk, soy",
            cloudinaryImageId: "ykh6wodn5rmk3qmylt36",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22858,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425565,
                group_name: "Hot Dog Option",
                choices: [
                  {
                    id: 61950950,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545382": {
            id: 545382,
            name: "Mushroom & Cheese Wrap",
            category: "Wraps",
            description:
              "Sauteed mushroom, lettuce, tomatoes, onions, inhouse tangy mayo and cheese in flour tortilla serving size: 230gms energy per 100 gms: 210. 14kcal contains: milk, gluten, soy",
            cloudinaryImageId: "i39frpizu1o3mf4i7hex",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887957,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545383": {
            id: 545383,
            name: "Butter Paneer Wrap",
            category: "Wraps",
            description:
              "Indian spiced paneer masala, lettuce, tomatoes, onions and our inhouse tangy mayo wrapped in a flour tortilla serving size: 245gms energy per 100 gms: 220. 13kcal contains: milk, gluten, soy",
            cloudinaryImageId: "fao9ptewmafjbn4vapww",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887956,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545385": {
            id: 545385,
            name: "Egg Wrap",
            category: "Wraps",
            description:
              "Masala omelette, lettuce, tomatoes, onions and inhouse tangy mayo wrapped in a flour tortilla serving size: 230gms energy per 100 gms: 188. 48kcal contains: egg, gluten, soy",
            cloudinaryImageId: "p4o5nwtmmlyohkkp2qcf",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12381,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887950,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887951,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545428": {
            id: 545428,
            name: "Cottage Cheese Steak",
            category: "Maincourse",
            description:
              "Slices of cottage cheese sandwich with cajun spice, spiced veggies, panko crumbed & served with a caribbean sauce accompanied by sauteed vegetables & mashed potatoes serving size: 375gms energy per 100 gms: 227. 58kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701383,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689862,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689863,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545430": {
            id: 545430,
            name: "Veg Paprika",
            category: "Maincourse",
            description:
              "Sautéed garden fresh veggies paired with a reddish-brown paprika sauce serving size: 500gms energy per 100 gms: 165. 27kcal contains: gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47702053,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690539,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690540,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545433": {
            id: 545433,
            name: "Sauteed Veggies",
            category: "Maincourse",
            description:
              "A garden on a plate. Assorted sauteed veggies paired with a garlic infused sauce serving size: 200gms energy per 100 gms: 209. 06kcal contains: soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701944,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690417,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690418,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545435": {
            id: 545435,
            name: "Mac & Cheese",
            category: "Pasta",
            description:
              "Gooey goodness! macaroni pasta in our ultra creamy cheese sauce serving size: 380gms energy per 100 gms: 186. 61kcal contains: gluten, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545437": {
            id: 545437,
            name: "Chicken Lasagna",
            category: "Maincourse",
            description:
              "A feast to remember! herb infused minced chicken slow cooked in a rich tomato sauce, layered between sheets of fresh pasta with a drizzle of cheese sauce serving size: 500gms energy per 100 gms: 166. 19kcal contains: milk, gluten, soy",
            cloudinaryImageId: "xub4awqbkyqzqep6o9pu",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545438": {
            id: 545438,
            name: "Chicken Paprika",
            category: "Maincourse",
            description:
              "A spicy symphony of tender chicken strips, coloured bell pepper and mushrooms tossed in our reddish brown paprika sauce serving size: 550gms energy per 100 gms: 164. 21kcal contains: gluten, milk",
            cloudinaryImageId: "p7gzesdbyzitiutepddb",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29048,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701104,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689659,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689658,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545440": {
            id: 545440,
            name: "Chicken Diane",
            category: "Maincourse",
            description:
              "Char grilled fillet of chicken slapped with herb minced chicken and served with an option of mushroom or pepper sauce serving size: 450gms energy per 100 gms: 164. 01kcal contains: gluten, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31910,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425254,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545442": {
            id: 545442,
            name: "3 Pepper Chicken Steak",
            category: "Maincourse",
            description:
              "A truffles favourite! char grilled chicken breast, tossed in a country style peppery sauce with coloured bell pepper & a twist of curry leaves serving size: 465gms energy per 100 gms: 164. 47kcal contains: gluten, milk, soy",
            cloudinaryImageId: "clztlczl7legnu8wm42q",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700967,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689411,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689410,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545448": {
            id: 545448,
            name: "Poulet Champignon",
            category: "Maincourse",
            description:
              "Grilled chicken breast served with thyme infused creamy mushrooms and sautéed spinach serving size: 500gms energy per 100 gms: 154. 89kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545451": {
            id: 545451,
            name: "Classic Chicken Steak",
            category: "Maincourse",
            description:
              "Truffles signature! herb infused chicken breast grilled to perfection with choice of sauce serving size: 460gms energy per 100 gms: 166. 68kcal contains: gluten, soy, milk",
            cloudinaryImageId: "s8a8uajarfcypcmxjkt2",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701390,
                group_name: "Steak Option",
                choices: [
                  {
                    id: 33689868,
                    name: "Pepper Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689867,
                    name: "Mushroom Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689866,
                    name: "Bbq Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689869,
                    name: "Teriyaki Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 47701391,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689871,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689870,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545456": {
            id: 545456,
            name: "Chicken Stroganoff",
            category: "Maincourse",
            description:
              "Diced chunks of chicken in a creamy sauce infused with herbs and garlic, mushrooms and garden fresh vegetables, served on a bed of herb rice serving size: 550gms energy per 100 gms: 167. 75kcal contains: milk, gluten",
            cloudinaryImageId: "vvtdc9duazd8xfdumfaz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425256,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545459": {
            id: 545459,
            name: "Baked Chicken Bavarian",
            category: "Maincourse",
            description:
              "Diced season chicken in a creamy cheese sauce, garnished with browned barista onions serving size: 350gms energy per 100 gms: 182. 16kcal contains: milk, gluten",
            cloudinaryImageId: "adlrvbn89e7kf3fghdvs",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26667,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700961,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689394,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689393,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545461": {
            id: 545461,
            name: "Chicken Marengo",
            category: "Maincourse",
            description:
              "Grilled chicken diced and sautéed with mushrooms in a tomato concasse topped with a fried egg serving size: 530gms energy per 100 gms: 162. 28kcal contains: milk, gluten, egg",
            cloudinaryImageId: "naycmjqm7f7qeupfc18c",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425255,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545463": {
            id: 545463,
            name: "Roast Lamb",
            category: "Maincourse",
            description:
              "Chunks of slow roasted lamb, seasoned with herbs and spices and tossed in a demi glaze sauce serving size: 475gms energy per 100 gms: 196. 97kcal contains: gluten, soy, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 39048,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701840,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690305,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690306,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545464": {
            id: 545464,
            name: "Minced Lamb Steak",
            category: "Maincourse",
            description:
              "Minced steak of tender lamb served with a fried egg sunny side up with choice of sauce serving size: 420gms energy per 100 gms: 269. 21kcal contains: egg, gluten, soy, milk",
            cloudinaryImageId: "ukmvmnuagshauuqwpv9n",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 37143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701644,
                group_name: "Steak Option",
                choices: [
                  {
                    id: 33690109,
                    name: "Mushroom Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690108,
                    name: "Bbq Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690111,
                    name: "Teriyaki Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690110,
                    name: "Pepper Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 47701648,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690112,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690113,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545471": {
            id: 545471,
            name: "Grilled Norwegian Fish Steak",
            category: "Maincourse",
            description:
              "Grilled steak of fish in a shitake mushrooms sauce, served on a bed of zucchini, a side of cucumber salad, herb rice and mashed potato serving size: 450gms energy per 100 gms: 137. 25kcal contains: seafood, gluten, soy, sulphite",
            cloudinaryImageId: "xyxklo60p5kupk3xojgu",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32381,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701342,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689828,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689827,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545472": {
            id: 545472,
            name: "Oriental Grilled Fish",
            category: "Maincourse",
            description:
              "Marinated fillets of fish simmered in a hot garlic sauce, served with sautéed mushrooms and mashed potatoes serving size: 375gms energy per 100 gms: 137. 33kcal contains: seafood, gluten, soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30477,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701845,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690307,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690308,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "545473": {
            id: 545473,
            name: "Fish Grand Milan",
            category: "Maincourse",
            description:
              "Grilled fillet of fish, served on a bed of aglio olio spaghetti and topped with prawns cooked in a bianca sauce serving size: 475gms energy per 100 gms: 147. 13kcal contains: seafood, gluten, milk, crustacean",
            cloudinaryImageId: "qvbiiiba8sa1op2l7zoc",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 38096,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79429115,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1624955": {
            id: 1624955,
            name: "Pesto Grilled Chicken",
            category: "Starters",
            description:
              "Smoky grilled pesto marinated chicken with a side salad serving size: 220gms energy per 100 gms: 188. 1kcal contains: nuts, gluten, milk, egg",
            cloudinaryImageId: "xywjly5qz7txfjtxrpm3",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1624956": {
            id: 1624956,
            name: "Pesto Grilled Fish",
            category: "Starters",
            description:
              "Smoky grilled pesto marinated fish with a side salad serving size: 210gms energy per 100 gms: 144. 85kcal contains: nuts, gluten, milk, seafood",
            cloudinaryImageId: "skri9ujhmnt0vu2zum9o",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1624967": {
            id: 1624967,
            name: "Mediterranean Chicken",
            category: "Maincourse",
            description:
              "Marinated chicken breast grilled to perfection and tossed in our housemade pesto, served on a bed of mashed potatoes with a side of pasta serving size: 475gms energy per 100 gms: 177. 86kcal contains: milk, gluten, nuts",
            cloudinaryImageId: "vwzngtzhicsteuiitw5c",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 33334,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78675882,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1624968": {
            id: 1624968,
            name: "Chicken Milanese",
            category: "Maincourse",
            description:
              "Grilled chicken breast with a creamy cheese sauce, served on a bed of herbed rice and garnished with olives serving size: 475gms energy per 100 gms: 138. 83kcal contains: milk, gluten",
            cloudinaryImageId: "nmkmsjtpmm8kj9cgqkjl",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 33334,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701133,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689668,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689669,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1814956": {
            id: 1814956,
            name: "Chocolate Truffle Cake",
            category: "Desserts",
            description:
              "A slice rich chocolate paired with a silky chocolate ganache frosting serving size: 111gms energy per 100 gms: 317. 18kcal contains: milk, gluten, egg",
            cloudinaryImageId: "yocobfm27pttmszdh5gn",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1814968": {
            id: 1814968,
            name: "Red Velvet",
            category: "Desserts",
            description:
              "Serving size: 72gms energy per 100 gms: 316. 01kcal contains: gluten, milk",
            cloudinaryImageId: "wvicrixu9kz0avx0yy3c",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1814978": {
            id: 1814978,
            name: "Chocolate Lava Cake",
            category: "Truffles Special",
            description:
              "Molten chocolate within a cupcake serving size: 125gms energy per 100 gms: 422. 22kcal contains: gluten, milk",
            cloudinaryImageId: "kihpzibkwljwpnegqwzj",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8572,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1814981": {
            id: 1814981,
            name: "Mississippi Mud Pie",
            category: "Desserts",
            description:
              "A slice of chocolate based dessert pie filled with gooey chocolate having a crumbly crust. Serving size: 100gms energy per 100 gms: 295. 61kcal contains: gluten, milk, egg",
            cloudinaryImageId: "f1wbvtwb1dk1l8wq439d",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1814983": {
            id: 1814983,
            name: "Chocolate Tart",
            category: "Desserts",
            description:
              "Best served warm serving size: 60gms energy per 100 gms: 412. 97kcal contains: gluten, milk",
            cloudinaryImageId: "lnbjbh6htvfoktup5yos",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1814985": {
            id: 1814985,
            name: "Apple Pie",
            category: "Desserts",
            description:
              "Best served warm serving size: 145gms energy per 100 gms: 282. 4kcal contains: gluten, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "1814986": {
            id: 1814986,
            name: "Lemon Tart",
            category: "Desserts",
            description:
              "Fresh and zingy! serving size: 50gms energy per 100 gms: 398. 58kcal contains: gluten, milk, egg",
            cloudinaryImageId: "pdt08aaq17ahaw6ga52o",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 5715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2847156": {
            id: 2847156,
            name: "The Hotty Chicken Burger",
            category: "Burger",
            description:
              "A spicy killer! a truffles burger with an oriental twist serving size: 250gms energy per 100 gms: 235. 84kcal contains: egg, gluten",
            cloudinaryImageId: "8b250fb6ed55bba30bddb41635fe6cf5",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129427",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55173206",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129427",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55173207",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129427",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129427", variation_id: "55173206" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47701930", addon_id: "33690386" },
                    { group_id: "47701930", addon_id: "33690387" },
                    { group_id: "47701930", addon_id: "33690388" },
                    { group_id: "47701931", addon_id: "33690389" },
                    { group_id: "47701931", addon_id: "33690390" },
                    { group_id: "47701931", addon_id: "33690391" },
                    { group_id: "47701933", addon_id: "33690392" },
                    { group_id: "47701933", addon_id: "33690393" },
                    { group_id: "47701933", addon_id: "33690394" },
                    { group_id: "47701933", addon_id: "33690395" },
                    { group_id: "47701933", addon_id: "33690396" },
                    { group_id: "47701933", addon_id: "33690397" },
                    { group_id: "47701933", addon_id: "33690398" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129427", variation_id: "55173207" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "47701930", addon_id: "33690386" },
                    { group_id: "47701930", addon_id: "33690387" },
                    { group_id: "47701930", addon_id: "33690388" },
                    { group_id: "47701931", addon_id: "33690389" },
                    { group_id: "47701931", addon_id: "33690390" },
                    { group_id: "47701931", addon_id: "33690391" },
                    { group_id: "47701933", addon_id: "33690392" },
                    { group_id: "47701933", addon_id: "33690393" },
                    { group_id: "47701933", addon_id: "33690394" },
                    { group_id: "47701933", addon_id: "33690395" },
                    { group_id: "47701933", addon_id: "33690396" },
                    { group_id: "47701933", addon_id: "33690397" },
                    { group_id: "47701933", addon_id: "33690398" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701930,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690387,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690386,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690388,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701931,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690390,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690389,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690391,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701933,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690394,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690393,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690396,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690395,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690398,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690397,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690392,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19048,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2847158": {
            id: 2847158,
            name: "Pesto Fried Chicken Burger",
            category: "Burger",
            description:
              "Panko fried pesto marinated chicken. Served with onions and tomatoes serving size: 210gms energy per 100 gms: 242. 09kcal contains: egg, nuts, gluten",
            cloudinaryImageId: "ccaie9rdbtro5vbupndm",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129429",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172822",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129429",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172824",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129429",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129429", variation_id: "55172822" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47701737", addon_id: "33690167" },
                    { group_id: "47701737", addon_id: "33690168" },
                    { group_id: "47701737", addon_id: "33690169" },
                    { group_id: "47701740", addon_id: "33690170" },
                    { group_id: "47701740", addon_id: "33690171" },
                    { group_id: "47701740", addon_id: "33690172" },
                    { group_id: "47701741", addon_id: "33690173" },
                    { group_id: "47701741", addon_id: "33690174" },
                    { group_id: "47701741", addon_id: "33690175" },
                    { group_id: "47701741", addon_id: "33690176" },
                    { group_id: "47701741", addon_id: "33690177" },
                    { group_id: "47701741", addon_id: "33690178" },
                    { group_id: "47701741", addon_id: "33690179" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129429", variation_id: "55172824" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701737", addon_id: "33690167" },
                    { group_id: "47701737", addon_id: "33690168" },
                    { group_id: "47701737", addon_id: "33690169" },
                    { group_id: "47701740", addon_id: "33690170" },
                    { group_id: "47701740", addon_id: "33690171" },
                    { group_id: "47701740", addon_id: "33690172" },
                    { group_id: "47701741", addon_id: "33690173" },
                    { group_id: "47701741", addon_id: "33690174" },
                    { group_id: "47701741", addon_id: "33690175" },
                    { group_id: "47701741", addon_id: "33690176" },
                    { group_id: "47701741", addon_id: "33690177" },
                    { group_id: "47701741", addon_id: "33690178" },
                    { group_id: "47701741", addon_id: "33690179" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701737,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690167,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690169,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690168,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701740,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690170,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690172,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690171,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701741,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690174,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690173,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690176,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690175,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690178,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690177,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690179,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19048,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2847160": {
            id: 2847160,
            name: "Pesto Fried Fish Burger",
            category: "Burger",
            description:
              "Panko fried pesto marinated fish. Served with onions and tomatoes serving size: 275gms energy per 100 gms: 233. 89kcal contains: egg, nuts, gluten",
            cloudinaryImageId: "3fb7b6ad960587b471f6252f27447ec1",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129430",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172850",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129430",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172851",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129430",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129430", variation_id: "55172850" },
                  ],
                  price: 20000,
                  addon_combinations: [
                    { group_id: "47701755", addon_id: "33690193" },
                    { group_id: "47701755", addon_id: "33690194" },
                    { group_id: "47701755", addon_id: "33690195" },
                    { group_id: "47701756", addon_id: "33690196" },
                    { group_id: "47701756", addon_id: "33690197" },
                    { group_id: "47701756", addon_id: "33690198" },
                    { group_id: "47701758", addon_id: "33690199" },
                    { group_id: "47701758", addon_id: "33690200" },
                    { group_id: "47701758", addon_id: "33690201" },
                    { group_id: "47701758", addon_id: "33690202" },
                    { group_id: "47701758", addon_id: "33690203" },
                    { group_id: "47701758", addon_id: "33690204" },
                    { group_id: "47701758", addon_id: "33690205" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129430", variation_id: "55172851" },
                  ],
                  price: 31429,
                  addon_combinations: [
                    { group_id: "47701755", addon_id: "33690193" },
                    { group_id: "47701755", addon_id: "33690194" },
                    { group_id: "47701755", addon_id: "33690195" },
                    { group_id: "47701756", addon_id: "33690196" },
                    { group_id: "47701756", addon_id: "33690197" },
                    { group_id: "47701756", addon_id: "33690198" },
                    { group_id: "47701758", addon_id: "33690199" },
                    { group_id: "47701758", addon_id: "33690200" },
                    { group_id: "47701758", addon_id: "33690201" },
                    { group_id: "47701758", addon_id: "33690202" },
                    { group_id: "47701758", addon_id: "33690203" },
                    { group_id: "47701758", addon_id: "33690204" },
                    { group_id: "47701758", addon_id: "33690205" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701755,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690195,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690194,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690193,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701756,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690196,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690198,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690197,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701758,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690204,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690203,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690205,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690200,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690199,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690202,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690201,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20000,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2847162": {
            id: 2847162,
            name: "Peri Peri Fish Burger",
            category: "Burger",
            description:
              "Fish fillet sauteed in truffles peri peri sauce. Served with tomatoes and chopped onions serving size: 210gms energy per 100 gms: 209. 54kcal contains: milk, gluten, seafood",
            cloudinaryImageId: "8a3615106ff7fa1fffbf8f2f982a9bbe",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129431",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172838",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129431",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172839",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129431",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129431", variation_id: "55172838" },
                  ],
                  price: 20000,
                  addon_combinations: [
                    { group_id: "47701746", addon_id: "33690180" },
                    { group_id: "47701746", addon_id: "33690181" },
                    { group_id: "47701746", addon_id: "33690182" },
                    { group_id: "47701750", addon_id: "33690183" },
                    { group_id: "47701750", addon_id: "33690184" },
                    { group_id: "47701750", addon_id: "33690185" },
                    { group_id: "47701751", addon_id: "33690186" },
                    { group_id: "47701751", addon_id: "33690187" },
                    { group_id: "47701751", addon_id: "33690188" },
                    { group_id: "47701751", addon_id: "33690189" },
                    { group_id: "47701751", addon_id: "33690190" },
                    { group_id: "47701751", addon_id: "33690191" },
                    { group_id: "47701751", addon_id: "33690192" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129431", variation_id: "55172839" },
                  ],
                  price: 31429,
                  addon_combinations: [
                    { group_id: "47701746", addon_id: "33690180" },
                    { group_id: "47701746", addon_id: "33690181" },
                    { group_id: "47701746", addon_id: "33690182" },
                    { group_id: "47701750", addon_id: "33690183" },
                    { group_id: "47701750", addon_id: "33690184" },
                    { group_id: "47701750", addon_id: "33690185" },
                    { group_id: "47701751", addon_id: "33690186" },
                    { group_id: "47701751", addon_id: "33690187" },
                    { group_id: "47701751", addon_id: "33690188" },
                    { group_id: "47701751", addon_id: "33690189" },
                    { group_id: "47701751", addon_id: "33690190" },
                    { group_id: "47701751", addon_id: "33690191" },
                    { group_id: "47701751", addon_id: "33690192" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701746,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690181,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690180,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690182,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701750,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690185,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690184,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690183,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701751,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690187,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690190,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690186,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690189,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690192,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690188,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690191,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20000,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2847191": {
            id: 2847191,
            name: "Ferrero Rocher",
            category: "Full Cakes",
            description: "",
            cloudinaryImageId: "wt36roeucghh0a9k7eyx",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "8819329",
                  name: "Size",
                  variations: [
                    {
                      name: "1/2 Kg",
                      price: 0,
                      default: 1,
                      id: "55172600",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8819329",
                      order: 100,
                    },
                    {
                      name: "1 kg",
                      price: 0,
                      default: 0,
                      id: "55172601",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "8819329",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "8819329", variation_id: "55172600" },
                  ],
                  price: 66667,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "8819329", variation_id: "55172601" },
                  ],
                  price: 123810,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 66667,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "2847193": {
            id: 2847193,
            name: "Baked Chocolate Cheese Cake",
            category: "Desserts",
            description:
              "Can't decide between a cheesecake and something chocolate? we got you! serving size: 160gms energy per 100 gms: 338. 54kcal contains: milk, gluten, egg",
            cloudinaryImageId: "qnw36hywqecw4evm91pa",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3489722": {
            id: 3489722,
            name: "Chicken, Jalapeno & Cheese Poppers",
            category: "Starters",
            description:
              "Crispy cheesy heaven! fried poppers filled with chicken, cheese & jalapenos serving size: 112 gms energy per 100 gms: 229. 93kcal contains: milk, gluten, soy, sulphite",
            cloudinaryImageId: "cfimbewidafntncblcwu",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23810,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3489734": {
            id: 3489734,
            name: "Chicken Rocky Road Burger",
            category: "Burger",
            description:
              "Panko fried chicken with a special sauce serving size: 275gms energy per 100 gms: 236. 26kcal contains: egg, gluten",
            cloudinaryImageId: "yjrzoiiouusejt4wvoz2",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "129391",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172531",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129391",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172532",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "129391",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "129391", variation_id: "55172531" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47701034", addon_id: "33689553" },
                    { group_id: "47701034", addon_id: "33689554" },
                    { group_id: "47701034", addon_id: "33689555" },
                    { group_id: "47701036", addon_id: "33689556" },
                    { group_id: "47701036", addon_id: "33689557" },
                    { group_id: "47701036", addon_id: "33689558" },
                    { group_id: "47701037", addon_id: "33689559" },
                    { group_id: "47701037", addon_id: "33689560" },
                    { group_id: "47701037", addon_id: "33689561" },
                    { group_id: "47701037", addon_id: "33689562" },
                    { group_id: "47701037", addon_id: "33689563" },
                    { group_id: "47701037", addon_id: "33689564" },
                    { group_id: "47701037", addon_id: "33689565" },
                  ],
                },
                {
                  variations: [
                    { group_id: "129391", variation_id: "55172532" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "47701034", addon_id: "33689553" },
                    { group_id: "47701034", addon_id: "33689554" },
                    { group_id: "47701034", addon_id: "33689555" },
                    { group_id: "47701036", addon_id: "33689556" },
                    { group_id: "47701036", addon_id: "33689557" },
                    { group_id: "47701036", addon_id: "33689558" },
                    { group_id: "47701037", addon_id: "33689559" },
                    { group_id: "47701037", addon_id: "33689560" },
                    { group_id: "47701037", addon_id: "33689561" },
                    { group_id: "47701037", addon_id: "33689562" },
                    { group_id: "47701037", addon_id: "33689563" },
                    { group_id: "47701037", addon_id: "33689564" },
                    { group_id: "47701037", addon_id: "33689565" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701034,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689555,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689554,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689553,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701036,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689556,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689558,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689557,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701037,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689565,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689564,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689563,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689559,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689562,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689561,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689560,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19048,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "3489816": {
            id: 3489816,
            name: "Pineapple Cake",
            category: "Desserts",
            description:
              "Serving size: 116gms energy per 100 gms: 300. 24kcal contains: milk, gluten, egg",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11905,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107023": {
            id: 5107023,
            name: "Peri Peri Fries (Saucy)",
            category: "Fries & Wedges",
            description:
              "Coated fries sauteed in our inhouse peri peri sauce along with coloured bell pepper and onion serving size: 265gms energy per 100 gms: 253. 47kcal contains: milk, gluten, sulphite",
            cloudinaryImageId: "672b94b7401e462991c3a415b3a20db4",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107024": {
            id: 5107024,
            name: "Peri Peri Paneer",
            category: "Starters",
            description:
              "Paneer tossed in truffles peri peri sauce serving size: 240gms energy per 100 gms: 192. 15kcal contains: milk, gluten, sulphite",
            cloudinaryImageId: "grgredqwpbxgejgvj4i2",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107026": {
            id: 5107026,
            name: "Devil's Paneer",
            category: "Starters",
            description:
              "Fried paneer cubes in a soya chilli sauce with bell peppers & caramelised onions serving size: 225gms energy per 100 gms: 202. 44kcal contains: milk, gluten, soy, sulphite",
            cloudinaryImageId: "kao3ykdlp4fbu7xki3qq",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107027": {
            id: 5107027,
            name: "Rocky Road Paneer",
            category: "Starters",
            description:
              "Panko coated, fried crunchy paneer served with dip serving size: 360gms energy per 100 gms: 277. 42kcal contains: milk, soy, gluten",
            cloudinaryImageId: "r5nfiozyio06wmb3knwh",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21905,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107029": {
            id: 5107029,
            name: "Chicken Popcorn",
            category: "Starters",
            description:
              "Fried morsels of seasoned chicken, dusted with spicy seasoning & served with a chilli mayo dip serving size: 240gms energy per 100 gms: 253. 39kcal contains: egg, gluten, soy, sulphite",
            cloudinaryImageId: "syktls87779um795lvxz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19048,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107030": {
            id: 5107030,
            name: "Tandoori Paneer Burger",
            category: "Burger",
            description:
              "Juicy tandoori paneer smeared with garlic butter serving size: 240gms energy per 100 gms: 265. 75kcal contains: milk, soy, gluten",
            cloudinaryImageId: "xe2twsy7oaupchwvgcjl",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "389655",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172720",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "389655",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172721",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "389655",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "389655", variation_id: "55172720" },
                  ],
                  price: 16667,
                  addon_combinations: [
                    { group_id: "47701907", addon_id: "33690352" },
                    { group_id: "47701907", addon_id: "33690353" },
                    { group_id: "47701907", addon_id: "33690354" },
                    { group_id: "47701908", addon_id: "33690355" },
                    { group_id: "47701908", addon_id: "33690356" },
                    { group_id: "47701908", addon_id: "33690357" },
                    { group_id: "47701908", addon_id: "33690358" },
                    { group_id: "47701908", addon_id: "33690359" },
                  ],
                },
                {
                  variations: [
                    { group_id: "389655", variation_id: "55172721" },
                  ],
                  price: 27143,
                  addon_combinations: [
                    { group_id: "47701907", addon_id: "33690352" },
                    { group_id: "47701907", addon_id: "33690353" },
                    { group_id: "47701907", addon_id: "33690354" },
                    { group_id: "47701908", addon_id: "33690355" },
                    { group_id: "47701908", addon_id: "33690356" },
                    { group_id: "47701908", addon_id: "33690357" },
                    { group_id: "47701908", addon_id: "33690358" },
                    { group_id: "47701908", addon_id: "33690359" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701907,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690354,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690353,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690352,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701908,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33690358,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690357,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690359,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690356,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690355,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 16667,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107031": {
            id: 5107031,
            name: "Peri Peri Paneer Burger",
            category: "Burger",
            description:
              "Paneer sautéed in a tangy & spicy peri peri sauce serving size: 200gms energy per 100 gms: 263. 31kcal contains: milk, gluten, soy",
            cloudinaryImageId: "roq3hzwun1viers7ubdb",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "389656",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172804",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "389656",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172805",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "389656",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "389656", variation_id: "55172804" },
                  ],
                  price: 16667,
                  addon_combinations: [
                    { group_id: "47701699", addon_id: "33690128" },
                    { group_id: "47701699", addon_id: "33690129" },
                    { group_id: "47701699", addon_id: "33690130" },
                    { group_id: "47701702", addon_id: "33690131" },
                    { group_id: "47701702", addon_id: "33690132" },
                    { group_id: "47701702", addon_id: "33690133" },
                    { group_id: "47701705", addon_id: "33690134" },
                    { group_id: "47701705", addon_id: "33690135" },
                    { group_id: "47701705", addon_id: "33690136" },
                    { group_id: "47701705", addon_id: "33690137" },
                    { group_id: "47701705", addon_id: "33690138" },
                    { group_id: "47701705", addon_id: "33690139" },
                    { group_id: "47701705", addon_id: "33690140" },
                  ],
                },
                {
                  variations: [
                    { group_id: "389656", variation_id: "55172805" },
                  ],
                  price: 27143,
                  addon_combinations: [
                    { group_id: "47701699", addon_id: "33690128" },
                    { group_id: "47701699", addon_id: "33690129" },
                    { group_id: "47701699", addon_id: "33690130" },
                    { group_id: "47701702", addon_id: "33690131" },
                    { group_id: "47701702", addon_id: "33690132" },
                    { group_id: "47701702", addon_id: "33690133" },
                    { group_id: "47701705", addon_id: "33690134" },
                    { group_id: "47701705", addon_id: "33690135" },
                    { group_id: "47701705", addon_id: "33690136" },
                    { group_id: "47701705", addon_id: "33690137" },
                    { group_id: "47701705", addon_id: "33690138" },
                    { group_id: "47701705", addon_id: "33690139" },
                    { group_id: "47701705", addon_id: "33690140" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701699,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690130,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690129,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690128,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701702,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690133,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690132,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690131,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701705,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690138,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690137,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690140,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690139,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690134,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690136,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690135,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 16667,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107032": {
            id: 5107032,
            name: "Rocky Road Paneer Burger",
            category: "Burger",
            description:
              "Spiced paneer strips panko fried serving size: 290gms energy per 100 gms: 256. 42kcal contains: milk, gluten, soy",
            cloudinaryImageId: "vb92ceukp70sh5gsfkbb",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "389657",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172714",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "389657",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172715",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "389657",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "389657", variation_id: "55172714" },
                  ],
                  price: 16667,
                  addon_combinations: [
                    { group_id: "47701898", addon_id: "33690344" },
                    { group_id: "47701898", addon_id: "33690345" },
                    { group_id: "47701898", addon_id: "33690346" },
                    { group_id: "47701899", addon_id: "33690347" },
                    { group_id: "47701899", addon_id: "33690348" },
                    { group_id: "47701899", addon_id: "33690349" },
                    { group_id: "47701899", addon_id: "33690350" },
                    { group_id: "47701899", addon_id: "33690351" },
                  ],
                },
                {
                  variations: [
                    { group_id: "389657", variation_id: "55172715" },
                  ],
                  price: 27143,
                  addon_combinations: [
                    { group_id: "47701898", addon_id: "33690344" },
                    { group_id: "47701898", addon_id: "33690345" },
                    { group_id: "47701898", addon_id: "33690346" },
                    { group_id: "47701899", addon_id: "33690347" },
                    { group_id: "47701899", addon_id: "33690348" },
                    { group_id: "47701899", addon_id: "33690349" },
                    { group_id: "47701899", addon_id: "33690350" },
                    { group_id: "47701899", addon_id: "33690351" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701898,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690346,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690345,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690344,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701899,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33690347,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690350,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690349,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690348,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690351,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 16667,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107109": {
            id: 5107109,
            name: "Peri Peri Paneer Wrap",
            category: "Wraps",
            description:
              "Paneer tossed with truffles peri peri sauce, lettuce, tomatoes, onions and inhouse tangy mayo in flour tortilla serving size: 245gms energy per 100 gms: 248. 34kcal contains: milk, gluten, soy, sulphite",
            cloudinaryImageId: "w5pll9idti7pknhvfpvj",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887958,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107112": {
            id: 5107112,
            name: "Peri Peri Chicken Wrap",
            category: "Wraps",
            description:
              "Truffles peri peri sauce tossed supreme of chicken, lettuce, tomatoes, onions and inhouse tangy mayo in egg coated flour tortilla serving size: 310gms energy per 100 gms: 197. 85kcal contains: egg, gluten, soy, sulphite",
            cloudinaryImageId: "fe7xjvppsc7bqndcp8py",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887954,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887955,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107115": {
            id: 5107115,
            name: "Tandoori Paneer Wrap",
            category: "Wraps",
            description:
              "Tandoori spiced paneer, lettuce, tomatoes, onions, inhouse tangy mayo and mint chutney in flour tortilla serving size: 275gms energy per 100 gms: 251. 47kcal contains: milk, gluten, nuts, soy",
            cloudinaryImageId: "pw6bof8c9kb7ilwzjfao",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887959,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107147": {
            id: 5107147,
            name: "Tandoori Paneer Steak",
            category: "Maincourse",
            description:
              "Char grilled chunky slices of paneer in our special tandoori marinade serving size: 350gms energy per 100 gms: 226. 61kcal contains: milk, nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701977,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690453,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690452,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5107148": {
            id: 5107148,
            name: "Cottage Cheese Twister",
            category: "Maincourse",
            description:
              "A tortilla wrap loaded with our desi spiked malai paneer with a fusion dressing of thai & indian flavours serving size: 350gms energy per 100 gms: 160. 58kcal contains: milk, gluten",
            cloudinaryImageId: "rfzrticft7l1r6exqs75",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701395,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689873,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689872,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5773769": {
            id: 5773769,
            name: "Butter Chicken Burger",
            category: "Burger",
            description:
              "Shout out to the north! a crowd pleaser across india serving size: 280gms energy per 100 gms: 229. 33kcal contains: milk, soy, gluten",
            cloudinaryImageId: "o1zcp66e6hxnzmg2gwdi",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "487499",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172045",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "487499",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172046",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "487499",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "487499", variation_id: "55172045" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47700925", addon_id: "33689271" },
                    { group_id: "47700925", addon_id: "33689272" },
                    { group_id: "47700925", addon_id: "33689273" },
                    { group_id: "47700926", addon_id: "33689274" },
                    { group_id: "47700926", addon_id: "33689275" },
                    { group_id: "47700926", addon_id: "33689276" },
                    { group_id: "47700928", addon_id: "33689277" },
                    { group_id: "47700928", addon_id: "33689278" },
                    { group_id: "47700928", addon_id: "33689279" },
                    { group_id: "47700928", addon_id: "33689280" },
                    { group_id: "47700928", addon_id: "33689281" },
                    { group_id: "47700928", addon_id: "33689282" },
                    { group_id: "47700928", addon_id: "33689283" },
                  ],
                },
                {
                  variations: [
                    { group_id: "487499", variation_id: "55172046" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "47700925", addon_id: "33689271" },
                    { group_id: "47700925", addon_id: "33689272" },
                    { group_id: "47700925", addon_id: "33689273" },
                    { group_id: "47700926", addon_id: "33689274" },
                    { group_id: "47700926", addon_id: "33689275" },
                    { group_id: "47700926", addon_id: "33689276" },
                    { group_id: "47700928", addon_id: "33689277" },
                    { group_id: "47700928", addon_id: "33689278" },
                    { group_id: "47700928", addon_id: "33689279" },
                    { group_id: "47700928", addon_id: "33689280" },
                    { group_id: "47700928", addon_id: "33689281" },
                    { group_id: "47700928", addon_id: "33689282" },
                    { group_id: "47700928", addon_id: "33689283" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700925,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689273,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689272,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689271,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700926,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689276,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689275,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689274,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47700928,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689283,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689279,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689282,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689278,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689281,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689277,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689280,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19048,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5773781": {
            id: 5773781,
            name: "Italian Prawns Pasta",
            category: "Pasta",
            description:
              "Seafood amanti (lovers) rejoice! grilled prawns swimming in a delectable cream sauce infused with garlic, fresh parsley and sundried tomatoes. Choice of penne/ spaghetti serving size: gms energy per 100 gms: kcal contains: gluten, milk, custacean, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493362",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407772",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493362",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407773",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493362",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493362", variation_id: "76407772" },
                  ],
                  price: 32858,
                  addon_combinations: [
                    { group_id: "74389358", addon_id: "59227054" },
                    { group_id: "74389358", addon_id: "59227055" },
                    { group_id: "74389358", addon_id: "59227056" },
                    { group_id: "74389359", addon_id: "59227057" },
                    { group_id: "74389359", addon_id: "59227058" },
                    { group_id: "74389359", addon_id: "59227059" },
                    { group_id: "74389360", addon_id: "59227060" },
                    { group_id: "74389360", addon_id: "59227061" },
                    { group_id: "74389360", addon_id: "59227062" },
                    { group_id: "74389360", addon_id: "59227063" },
                    { group_id: "74389360", addon_id: "59227064" },
                    { group_id: "74389361", addon_id: "59227065" },
                    { group_id: "74389361", addon_id: "59227066" },
                    { group_id: "74389361", addon_id: "59227067" },
                    { group_id: "74389361", addon_id: "59227068" },
                    { group_id: "74389361", addon_id: "59227069" },
                    { group_id: "74389361", addon_id: "59227070" },
                    { group_id: "74389361", addon_id: "59227071" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493362", variation_id: "76407773" },
                  ],
                  price: 32858,
                  addon_combinations: [
                    { group_id: "74389358", addon_id: "59227054" },
                    { group_id: "74389358", addon_id: "59227055" },
                    { group_id: "74389358", addon_id: "59227056" },
                    { group_id: "74389359", addon_id: "59227057" },
                    { group_id: "74389359", addon_id: "59227058" },
                    { group_id: "74389359", addon_id: "59227059" },
                    { group_id: "74389360", addon_id: "59227060" },
                    { group_id: "74389360", addon_id: "59227061" },
                    { group_id: "74389360", addon_id: "59227062" },
                    { group_id: "74389360", addon_id: "59227063" },
                    { group_id: "74389360", addon_id: "59227064" },
                    { group_id: "74389361", addon_id: "59227065" },
                    { group_id: "74389361", addon_id: "59227066" },
                    { group_id: "74389361", addon_id: "59227067" },
                    { group_id: "74389361", addon_id: "59227068" },
                    { group_id: "74389361", addon_id: "59227069" },
                    { group_id: "74389361", addon_id: "59227070" },
                    { group_id: "74389361", addon_id: "59227071" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389358,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 59227056,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227054,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227055,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389359,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227057,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227058,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227059,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 74389360,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 59227060,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227063,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227064,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227061,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227062,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 74389361,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 59227067,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227070,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227068,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227071,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227065,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227066,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227069,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 32858,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "5935757": {
            id: 5935757,
            name: "All American Veg Burger",
            category: "Burger",
            description:
              "The living legend! crunchy veg patty slammed with an additional cheese burst patty serving size: 230gms energy per 100 gms: 228. 32kcal contains: gluten, soy, milk",
            cloudinaryImageId: "umqlmm1ltapmcbbyvxnu",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "514239",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172132",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "514239",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172134",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "514239",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "514239", variation_id: "55172132" },
                  ],
                  price: 21429,
                  addon_combinations: [
                    { group_id: "47700941", addon_id: "33689318" },
                    { group_id: "47700941", addon_id: "33689319" },
                    { group_id: "47700941", addon_id: "33689320" },
                    { group_id: "47700942", addon_id: "33689321" },
                    { group_id: "47700942", addon_id: "33689322" },
                    { group_id: "47700942", addon_id: "33689323" },
                    { group_id: "47700942", addon_id: "33689324" },
                    { group_id: "47700942", addon_id: "33689325" },
                  ],
                },
                {
                  variations: [
                    { group_id: "514239", variation_id: "55172134" },
                  ],
                  price: 30953,
                  addon_combinations: [
                    { group_id: "47700941", addon_id: "33689318" },
                    { group_id: "47700941", addon_id: "33689319" },
                    { group_id: "47700941", addon_id: "33689320" },
                    { group_id: "47700942", addon_id: "33689321" },
                    { group_id: "47700942", addon_id: "33689322" },
                    { group_id: "47700942", addon_id: "33689323" },
                    { group_id: "47700942", addon_id: "33689324" },
                    { group_id: "47700942", addon_id: "33689325" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700941,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689318,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689320,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689319,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700942,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33689325,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689324,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689323,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689322,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689321,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 21429,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "8157514": {
            id: 8157514,
            name: "Chocolate Caramel",
            category: "Desserts",
            description:
              "Bold fusion of caramel sauce and chocolate fudge! serving size: 200gms energy per 100 gms: 430. 1kcal contains: milk, gluten",
            cloudinaryImageId: "kte9kfkfvlr0ytwxfazg",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "8157516": {
            id: 8157516,
            name: "Red Velvet Muffin",
            category: "Desserts",
            description:
              "Tastes as beautiful as it look! serving size: 75gms energy per 100 gms: 362. 81kcal contains: gluten, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8572,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "8157576": {
            id: 8157576,
            name: "Oreo Cookies Fudge",
            category: "Desserts",
            description:
              "Crushed oreos, icecream, chocolate sauce, whipped cream serving size: 265gms energy per 100 gms: 342. 63kcal contains: milk, gluten, nuts",
            cloudinaryImageId: "wiflt3c2elvb6hhdoeq4",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21910,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930204": {
            id: 35930204,
            name: "Chicken Steak S/w",
            category: "Sandwiches",
            description:
              "Non grilled sandwich serving size: 245gms energy per 100 gms: 235. 48kcal contains: milk, gluten, egg",
            cloudinaryImageId: "dooaccpf6bplup01czwk",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425563,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 79425564,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930205": {
            id: 35930205,
            name: "Chicken Salami Cheese S/w",
            category: "Sandwiches",
            description:
              "Cold cuts of chicken salami & cheese in grilled bread serving size: 185gms energy per 100 gms: 294. 37kcal contains: milk, gluten, sulphite, egg",
            cloudinaryImageId: "ezghrbaa9fqxm2lp61rj",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700988,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689452,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689451,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689450,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700989,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689453,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689455,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689454,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930206": {
            id: 35930206,
            name: "Mushroom Cheese S/w",
            category: "Sandwiches",
            description:
              "Sauteed mushroom and cheese served in grilled breads serving size: 180gms energy per 100 gms: 259. 07kcal contains: milk, gluten, soy",
            cloudinaryImageId: "r0thfdafbj8okqswtydo",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12858,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425252,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930208": {
            id: 35930208,
            name: "Butter Paneer S/w",
            category: "Sandwiches",
            description:
              "Creamy & delicious butter paneer served in grilled bread serving size: 175gms energy per 100 gms: 280. 11kcal contains: milk, gluten, soy",
            cloudinaryImageId: "p78ktcrzpetw3ljuctck",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700904,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689236,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689235,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689234,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930209": {
            id: 35930209,
            name: "Chicken Cheese S/w",
            category: "Sandwiches",
            description:
              "Need we say more? serving size: 230gms energy per 100 gms: 281. 41kcal contains: milk, gluten, soy, egg",
            cloudinaryImageId: "kuuyqbnpl5gb76ylcmad",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700900,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689229,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689228,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689230,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700902,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689233,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689232,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689231,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930210": {
            id: 35930210,
            name: "Spinach Corn Cheese S/w",
            category: "Sandwiches",
            description:
              "Perfect for our protein conscious folks who love good food serving size: 170gms  285. 43kcal contains: milk, gluten, soy",
            cloudinaryImageId: "rt117eposvf1oy2zpfta",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79429114,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930212": {
            id: 35930212,
            name: "Chicken Ham Cheese S/w",
            category: "Sandwiches",
            description:
              "Cold cuts of chicken ham & cheese in grilled bread serving size: 195gms energy per 100 gms: 302. 78kcal contains: milk, gluten, sulphite, egg",
            cloudinaryImageId: "vxgc1s5091ljkazokv1p",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700985,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689446,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689445,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689444,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700987,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689449,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689448,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689447,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930213": {
            id: 35930213,
            name: "Non Veg Club S/w",
            category: "Sandwiches",
            description:
              "Chicken strips, chicken salami, fried egg, cheese, tomato & jalapenos serving size: 330gms energy per 100 gms: 246. 95kcal contains: milk, gluten, soy, egg",
            cloudinaryImageId: "ihirlshytfegle1mhzpm",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701578,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690013,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690012,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690011,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701581,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690016,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690015,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690014,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930214": {
            id: 35930214,
            name: "Devil's Chicken S/w",
            category: "Sandwiches",
            description:
              "Shredded chicken stir fried in a soya chilli sauce ‘w’ bell pepper & caramelized onion serving size: 210gms energy per 100 gms: 235. 27kcal contains: gluten, soy, sulphite, egg",
            cloudinaryImageId: "rspw4pxh1lfhnzmmw4pg",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887937,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887938,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930215": {
            id: 35930215,
            name: "Chicken Crispy S/w",
            category: "Sandwiches",
            description:
              "Contains mustard serving size: 210gms energy per 100 gms: 254. 81kcal contains: milk, gluten, sulphite, egg",
            cloudinaryImageId: "rgrajdnuo8zluzfbqgmf",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700983,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689439,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689438,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689440,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700984,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689442,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689441,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689443,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930216": {
            id: 35930216,
            name: "Cheese S/w",
            category: "Sandwiches",
            description:
              'If "does the trick" was a sandwich serving size: 220gms energy per 100 gms: 227. 83kcal contains: milk, gluten, soy',
            cloudinaryImageId: "lk53ys7ojsehdlcoburv",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10953,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47700860,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689211,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689210,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689209,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930217": {
            id: 35930217,
            name: "Roast Lamb S/w",
            category: "Sandwiches",
            description:
              "Non grilled. A hidden jewel in the truffles menu! order before it's sold out. Slow cooked tender slices of lamb with a desi kick! serving size: 200gms energy per 100 gms: 245. 45kcal contains: gluten, egg, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22858,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887933,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887934,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930218": {
            id: 35930218,
            name: "Veg Club S/w",
            category: "Sandwiches",
            description:
              "Tomato, cheese, sautéed mushoom, jalapenos & a veggie salad filling serving size: 300gms energy per 100 gms: 204. 74kcal contains: milk, gluten, soy",
            cloudinaryImageId: "yp6z2oqfzlmwbaeesd4q",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425253,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930219": {
            id: 35930219,
            name: "Chicken Sausages",
            category: "Starters",
            description:
              "Chicken sausages tossed in a tangy bbq sauce. Serving size: 130gms energy per 100 gms: 292. 74kcal contains: sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930220": {
            id: 35930220,
            name: "Spicy Chicken Finger",
            category: "Starters",
            description:
              "Chicken fingers with a twist and a southern bang! serving size: 200gms energy per 100 gms: 189. 13kcal contains: gluten, sulphite, milk, egg",
            cloudinaryImageId: "aoqyn0d8i4oiuco1qirt",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930221": {
            id: 35930221,
            name: "Corn Hi Corn",
            category: "Starters",
            description:
              "Skewered baby corn marinated in bbq sauce, crumb fried & served with salsa & mustard mayo serving size: 300gms energy per 100 gms: 240. 56kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "ryjub14xntx7bnbwxkye",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19048,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930238": {
            id: 35930238,
            name: "Nachos W Cheese",
            category: "Starters",
            description:
              "Nacho chips served with salsa and cheese separately serving size: 180gms energy per 100 gms: 235. 07kcal contains: milk, gluten, soy",
            cloudinaryImageId: "l0pzqt7kkwxy0uijmaj9",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930239": {
            id: 35930239,
            name: "Spaghetti Cheese Ball",
            category: "Starters",
            description:
              "Fried long pasta cheese ball served with spicy mayo serving size: 350gms energy per 100 gms: 238. 85kcal contains: gluten, soy, milk",
            cloudinaryImageId: "fbfi29achtvp96udfegc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930240": {
            id: 35930240,
            name: "Fish Finger",
            category: "Starters",
            description:
              "Evergreen classic! crumb fried fish served with inhouse tartar sauce serving size: 250gms energy per 100 gms: 66. 7kcal contains: seafood, gluten, soy, sulphite",
            cloudinaryImageId: "bqbf3nybmshrvscwrmfy",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25239,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930242": {
            id: 35930242,
            name: "Jalapeno Poppers",
            category: "Starters",
            description:
              "Cheesy jalapeno pops served with dip serving size: 265gms energy per 100 gms: 469. 06kcal contains: milk, gluten, soy",
            cloudinaryImageId: "kfmva7dv9fqvoxeebsf4",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930243": {
            id: 35930243,
            name: "Butter Garlic Prawn",
            category: "Starters",
            description:
              "Nacked prawns tossed in butter, along with diced bell pepper & a hint of soya and chilli serving size: 130gms energy per 100 gms: 133kcal contains: seafood, soy, sulphite",
            cloudinaryImageId: "s7lkw1oumkrtfmcunmnr",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 33810,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930244": {
            id: 35930244,
            name: "Fire & Spice Dry",
            category: "Starters",
            description:
              "A spicy soy based dish with tossed with onion, garlic and bell pepper serving size: 220 to 250gms energy per 100 gms:  chicken: 204. 17kcal (gluten, soy) prawn: 168. 67 kcal (soy, crustacean, gluten) fish: (gluten, soy, seafood)",
            cloudinaryImageId: "vaarnfeoudmixnfskmvg",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491906",
                  name: "Flavour",
                  variations: [
                    {
                      name: "Fish",
                      price: 0,
                      default: 1,
                      id: "55172550",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491906",
                      order: 100,
                    },
                    {
                      name: "Chicken",
                      price: 0,
                      default: 0,
                      id: "55172549",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491906",
                      order: 99,
                    },
                    {
                      name: "Prawn",
                      price: 0,
                      default: 0,
                      id: "55172551",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491906",
                      order: 98,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491906", variation_id: "55172550" },
                  ],
                  price: 28096,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491906", variation_id: "55172549" },
                  ],
                  price: 26667,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491906", variation_id: "55172551" },
                  ],
                  price: 34286,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 28096,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930245": {
            id: 35930245,
            name: "Peri Peri Prawn",
            category: "Starters",
            description:
              "Prawn in our inhouse fiery peri peri sauce with a side salad serving size: 230gms energy per 100 gms: 154. 63kcal contains: milk, gluten, sulphite, crustacean",
            cloudinaryImageId: "onyfc1jzwyjtuuiirrkv",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930246": {
            id: 35930246,
            name: "Cheese Rissole",
            category: "Starters",
            description:
              "An italian entreé of pastry rolls loaded with cheese and deep fried. A truffles original serving size: 355gms energy per 100 gms: 269. 33kcal contains: milk, gluten, soy",
            cloudinaryImageId: "xsfmxacvcoo8iacjovel",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930247": {
            id: 35930247,
            name: "Fiery Potato",
            category: "Starters",
            description:
              "French fries tossed in a soya chilli sauce serving size: 225gms energy per 100 gms: 223. 89kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "y7rhononbthgbebikixf",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930248": {
            id: 35930248,
            name: "Fiery Baby Corn",
            category: "Starters",
            description:
              "Fried baby corn in a soya chilli sauce serving size: 255gms energy per 100 gms: 208. 49kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "whk4dtpcnbvxldogzq0g",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930251": {
            id: 35930251,
            name: "Russian Salad(veg)",
            category: "Salad",
            description:
              "Blanched diced carrots, beans, potatoes and peas, tossed with pineapple and seasoned mayo serving size: 435gms energy per 100 gms: 118. 6kcal contains: soy",
            cloudinaryImageId: "bzchppeny5jvbbpufpfo",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930252": {
            id: 35930252,
            name: "Non Veg Pasta Salad",
            category: "Salad",
            description:
              "Mamma mia! macaroni, diced chicken, penne, coloured bell pepper and lettuce tossed in our own tangy and creamy mayo dressing serving size: gms energy per 100 gms: kcal contains: gluten, soy",
            cloudinaryImageId: "qrds1cqeqcadequpifuc",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930253": {
            id: 35930253,
            name: "Caesar Salad(non Veg)",
            category: "Salad",
            description:
              "Truffles take on a global classic! grilled seasoned chicken, fresh assorted lettuce, pesto croutons and bell pepper tossed in our housemade caesar dressing serving size: gms energy per 100 gms: kcal contains: soy, milk",
            cloudinaryImageId: "e6dx6yknwszazj92pqyl",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930254": {
            id: 35930254,
            name: "Mexican Nachos Grande(non-veg)",
            category: "Salad",
            description:
              "Grilled chicken, flavoured nachos, jullienne onion, bell pepper, olives, iceberg lettuce, tossed in a spicy mexican flavoured bbq sauce & garnished with our own inhouse seasoned mayo serving size: gms energy per 100 gms: kcal contains: milk, soy",
            cloudinaryImageId: "oroqccu9y4av8kjh0fln",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930283": {
            id: 35930283,
            name: "Russian Salad(non-veg)",
            category: "Salad",
            description:
              "Diced chicken, blanched diced carrots, beans, potatoes and peas, tossed with pineapple and seasoned mayo serving size: gms energy per 100 gms: kcal contains: soy",
            cloudinaryImageId: "fc5ej9gtp8iravk8w3nc",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930313": {
            id: 35930313,
            name: "Caesar Salad(veg)",
            category: "Salad",
            description:
              "Truffles take on a global classic! fresh assorted lettuce, pesto croutons and bell pepper tossed in our housemade caesar dressing serving size: 240gms energy per 100 gms: 152. 12kcal contains: soy, milk",
            cloudinaryImageId: "ehdayuvmh1kuaub0omhj",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930330": {
            id: 35930330,
            name: "Veg Pasta Salad",
            category: "Salad",
            description:
              "Mamma mia! macaroni, penne, coloured bell pepper and lettuce tossed in our own tangy and creamy mayo dressing serving size: gms energy per 100 gms: kcal contains: gluten, soy",
            cloudinaryImageId: "cnjaev1uaavzeanfnlms",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930346": {
            id: 35930346,
            name: "Greek Salad(non Veg)",
            category: "Salad",
            description:
              "Grilled chicken breast, iceberg lettuce, coloured bell pepper, onion, cucumber, tossed with pineapple & our inhouse vinaigrette dressing serving size: gms energy per 100 gms: kcal contains: milk",
            cloudinaryImageId: "qz26hnylmnib4w9xl60g",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930365": {
            id: 35930365,
            name: "Greek Salad(veg)",
            category: "Salad",
            description:
              "A cool crunchy salad with fresh iceberg lettuce, bell peppers, sliced pineapple & cucumber. Tangy vinaigrette dressing served separately serving size: gms energy per 100 gms: kcal contains: milk",
            cloudinaryImageId: "aqbodv5b4ubg1ysisxwa",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930381": {
            id: 35930381,
            name: "Mexican Nachos Grande(veg)",
            category: "Salad",
            description:
              "Flavoured nachos, jullienne onion, bell pepper, olives, iceberg lettuce, tossed in a spicy mexican flavoured bbq sauce & garnished with our own inhouse seasoned mayo serving size: gms energy per 100 gms: kcal contains: milk, soy",
            cloudinaryImageId: "uevyulrrffgantoodgja",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930440": {
            id: 35930440,
            name: "Lamb Kheema Wrap",
            category: "Wraps",
            description:
              "Minced lamb, lettuce, tomatoes, onions and inhouse tangy mayo cooked with indian herbs & spices, wrapped in flour tortilla serving size: 250gms energy per 100 gms: 188. 95kcal contains: gluten, soy, egg",
            cloudinaryImageId: "gdgg5u6ka9wybzcerc1k",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887952,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887953,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930449": {
            id: 35930449,
            name: "Chicken Wrap",
            category: "Wraps",
            description:
              "Chicken tikka/ chicken masala, onion, mint chutney in egg coated flour tortilla serving size: 295gms energy per 100 gms: 200kcal contains: gluten, soy, egg, sulphite",
            cloudinaryImageId: "ckkoanjoauyyvkgoebvl",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491910",
                  name: "Flavour",
                  variations: [
                    {
                      name: "Masala",
                      price: 0,
                      default: 1,
                      id: "55172329",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491910",
                      order: 100,
                    },
                    {
                      name: "Tikka",
                      price: 0,
                      default: 0,
                      id: "55172330",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491910",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491910", variation_id: "55172329" },
                  ],
                  price: 16191,
                  addon_combinations: [
                    { group_id: "47701004", addon_id: "33689479" },
                    { group_id: "47701004", addon_id: "33689480" },
                    { group_id: "47701004", addon_id: "33689481" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491910", variation_id: "55172330" },
                  ],
                  price: 17143,
                  addon_combinations: [
                    { group_id: "47701004", addon_id: "33689479" },
                    { group_id: "47701004", addon_id: "33689480" },
                    { group_id: "47701004", addon_id: "33689481" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701004,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689479,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689481,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689480,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 16191,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930476": {
            id: 35930476,
            name: "Pesto Pasta Veg",
            category: "Pasta",
            description:
              "A choice of pasta (penne or spaghetti) in a vibrant sauce of basil, garlic, parmesan & nuts blended with olive oil, crushed pepper & a touch of fresh cream. Serving size: 400gms energy per 100 gms: 129. 74kcal contains: gluten, milk, nuts, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493363",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407774",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493363",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407775",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493363",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493363", variation_id: "76407774" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389362", addon_id: "59227072" },
                    { group_id: "74389362", addon_id: "59227073" },
                    { group_id: "74389362", addon_id: "59227074" },
                    { group_id: "74389363", addon_id: "63510326" },
                    { group_id: "74389363", addon_id: "59227075" },
                    { group_id: "74389363", addon_id: "59227076" },
                    { group_id: "74389363", addon_id: "59227077" },
                    { group_id: "74389363", addon_id: "59227078" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493363", variation_id: "76407775" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389362", addon_id: "59227072" },
                    { group_id: "74389362", addon_id: "59227073" },
                    { group_id: "74389362", addon_id: "59227074" },
                    { group_id: "74389363", addon_id: "63510326" },
                    { group_id: "74389363", addon_id: "59227075" },
                    { group_id: "74389363", addon_id: "59227076" },
                    { group_id: "74389363", addon_id: "59227077" },
                    { group_id: "74389363", addon_id: "59227078" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389362,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227074,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227072,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227073,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389363,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227078,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227076,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227077,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227075,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510326,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20477,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930482": {
            id: 35930482,
            name: "Arrabiata Pasta Veg",
            category: "Pasta",
            description:
              "Choice of pasta (penne/ spaghetti) with a spiced tomato concasse, fresh basil and assorted veggies finished with olive oil and cheese serving size: 450gms energy per 100 gms: 136. 21kcal contains: gluten, soy, suplhite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493358",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407764",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493358",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407765",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493358",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493358", variation_id: "76407764" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389348", addon_id: "59227015" },
                    { group_id: "74389348", addon_id: "59227016" },
                    { group_id: "74389348", addon_id: "59227017" },
                    { group_id: "74389349", addon_id: "63510342" },
                    { group_id: "74389349", addon_id: "59227018" },
                    { group_id: "74389349", addon_id: "59227019" },
                    { group_id: "74389349", addon_id: "59227020" },
                    { group_id: "74389349", addon_id: "59227021" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493358", variation_id: "76407765" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389348", addon_id: "59227015" },
                    { group_id: "74389348", addon_id: "59227016" },
                    { group_id: "74389348", addon_id: "59227017" },
                    { group_id: "74389349", addon_id: "63510342" },
                    { group_id: "74389349", addon_id: "59227018" },
                    { group_id: "74389349", addon_id: "59227019" },
                    { group_id: "74389349", addon_id: "59227020" },
                    { group_id: "74389349", addon_id: "59227021" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389348,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227016,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227017,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227015,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389349,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227018,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227021,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227019,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227020,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510342,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20477,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930492": {
            id: 35930492,
            name: "Creamy Cheese Sauce Pasta Veg",
            category: "Pasta",
            description:
              "Copious amounts of cheddar and mozarella added to our truffles original creamy white sauce. A choice of pasta (penne or spaghetti), finished with golden garlic, sautéed spinach, olive oil and yes. . . . . More cheese! serving size: 420gms energy per 100 gms: 163. 65kcal contains: gluten, milk, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491913",
                  name: "Option",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "55172369",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491913",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "55172370",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491913",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491913", variation_id: "55172369" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "47701196", addon_id: "33689783" },
                    { group_id: "47701196", addon_id: "33689784" },
                    { group_id: "47701196", addon_id: "33689785" },
                    { group_id: "47701197", addon_id: "63510325" },
                    { group_id: "47701197", addon_id: "33689786" },
                    { group_id: "47701197", addon_id: "33689787" },
                    { group_id: "47701197", addon_id: "33689788" },
                    { group_id: "47701197", addon_id: "33689789" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491913", variation_id: "55172370" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "47701196", addon_id: "33689783" },
                    { group_id: "47701196", addon_id: "33689784" },
                    { group_id: "47701196", addon_id: "33689785" },
                    { group_id: "47701197", addon_id: "63510325" },
                    { group_id: "47701197", addon_id: "33689786" },
                    { group_id: "47701197", addon_id: "33689787" },
                    { group_id: "47701197", addon_id: "33689788" },
                    { group_id: "47701197", addon_id: "33689789" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701196,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689783,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689785,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689784,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701197,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 33689787,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510325,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689786,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689789,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689788,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20477,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930501": {
            id: 35930501,
            name: "Pinky Pasta Veg",
            category: "Pasta",
            description:
              "When an arrabiata and cream cheese hook-up! made with your choice of pasta (penne or spaghetti) serving size: 450gms energy per 100 gms: 221. 87kcal contains: gluten, soy, milk, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493364",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407776",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493364",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407777",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493364",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493364", variation_id: "76407776" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389364", addon_id: "59227079" },
                    { group_id: "74389364", addon_id: "59227080" },
                    { group_id: "74389364", addon_id: "59227081" },
                    { group_id: "74389365", addon_id: "63510344" },
                    { group_id: "74389365", addon_id: "59227082" },
                    { group_id: "74389365", addon_id: "59227083" },
                    { group_id: "74389365", addon_id: "59227084" },
                    { group_id: "74389365", addon_id: "59227085" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493364", variation_id: "76407777" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389364", addon_id: "59227079" },
                    { group_id: "74389364", addon_id: "59227080" },
                    { group_id: "74389364", addon_id: "59227081" },
                    { group_id: "74389365", addon_id: "63510344" },
                    { group_id: "74389365", addon_id: "59227082" },
                    { group_id: "74389365", addon_id: "59227083" },
                    { group_id: "74389365", addon_id: "59227084" },
                    { group_id: "74389365", addon_id: "59227085" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389364,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227081,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227079,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227080,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389365,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227082,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510344,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227085,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227083,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227084,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20477,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930519": {
            id: 35930519,
            name: "Italian Pasta Alfredo Veg",
            category: "Pasta",
            description:
              "Another take on a white sauce pasta. Housemade mushroom sauce infused with garlic and celery tossed with green and yellow zucchini & a sprinkle of parmesan. Available with choice of pasta (penne or spaghetti) serving size: 400gms energy per 100 gms: 148. 96kcal contains: gluten, milk, sulphite",
            cloudinaryImageId: "gifhwgdszkvkcfmgquxq",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493361",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407770",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493361",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407771",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493361",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493361", variation_id: "76407770" },
                  ],
                  price: 22381,
                  addon_combinations: [
                    { group_id: "74389356", addon_id: "59227046" },
                    { group_id: "74389356", addon_id: "59227047" },
                    { group_id: "74389356", addon_id: "59227048" },
                    { group_id: "74389357", addon_id: "59227049" },
                    { group_id: "74389357", addon_id: "59227050" },
                    { group_id: "74389357", addon_id: "59227051" },
                    { group_id: "74389357", addon_id: "59227052" },
                    { group_id: "74389357", addon_id: "59227053" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493361", variation_id: "76407771" },
                  ],
                  price: 22381,
                  addon_combinations: [
                    { group_id: "74389356", addon_id: "59227046" },
                    { group_id: "74389356", addon_id: "59227047" },
                    { group_id: "74389356", addon_id: "59227048" },
                    { group_id: "74389357", addon_id: "59227049" },
                    { group_id: "74389357", addon_id: "59227050" },
                    { group_id: "74389357", addon_id: "59227051" },
                    { group_id: "74389357", addon_id: "59227052" },
                    { group_id: "74389357", addon_id: "59227053" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389356,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227046,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227047,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227048,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389357,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 59227049,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227052,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227053,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227050,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227051,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 22381,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930528": {
            id: 35930528,
            name: "Pesto Pasta Non-veg",
            category: "Pasta",
            description:
              "A choice of pasta (penne or spaghetti) in a vibrant sauce of basil, garlic, parmesan & nuts blended with olive oil, diced chicken, crushed pepper & a touch of fresh cream. Serving size: 400gms energy per 100 gms: 157. 25kcal contains: gluten, milk, nuts, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491917",
                  name: "Option",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "55172940",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491917",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "55172941",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491917",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491917", variation_id: "55172940" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47701802", addon_id: "33690262" },
                    { group_id: "47701802", addon_id: "33690263" },
                    { group_id: "47701802", addon_id: "33690264" },
                    { group_id: "47701805", addon_id: "33690265" },
                    { group_id: "47701805", addon_id: "33690266" },
                    { group_id: "47701805", addon_id: "33690267" },
                    { group_id: "47701807", addon_id: "63510320" },
                    { group_id: "47701807", addon_id: "33690268" },
                    { group_id: "47701807", addon_id: "33690269" },
                    { group_id: "47701807", addon_id: "33690270" },
                    { group_id: "47701807", addon_id: "33690271" },
                    { group_id: "47701809", addon_id: "33690272" },
                    { group_id: "47701809", addon_id: "33690273" },
                    { group_id: "47701809", addon_id: "33690274" },
                    { group_id: "47701809", addon_id: "33690275" },
                    { group_id: "47701809", addon_id: "33690276" },
                    { group_id: "47701809", addon_id: "33690277" },
                    { group_id: "47701809", addon_id: "33690278" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491917", variation_id: "55172941" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47701802", addon_id: "33690262" },
                    { group_id: "47701802", addon_id: "33690263" },
                    { group_id: "47701802", addon_id: "33690264" },
                    { group_id: "47701805", addon_id: "33690265" },
                    { group_id: "47701805", addon_id: "33690266" },
                    { group_id: "47701805", addon_id: "33690267" },
                    { group_id: "47701807", addon_id: "63510320" },
                    { group_id: "47701807", addon_id: "33690268" },
                    { group_id: "47701807", addon_id: "33690269" },
                    { group_id: "47701807", addon_id: "33690270" },
                    { group_id: "47701807", addon_id: "33690271" },
                    { group_id: "47701809", addon_id: "33690272" },
                    { group_id: "47701809", addon_id: "33690273" },
                    { group_id: "47701809", addon_id: "33690274" },
                    { group_id: "47701809", addon_id: "33690275" },
                    { group_id: "47701809", addon_id: "33690276" },
                    { group_id: "47701809", addon_id: "33690277" },
                    { group_id: "47701809", addon_id: "33690278" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701802,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690262,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690264,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690263,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701805,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690266,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690265,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690267,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701807,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 33690269,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510320,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690268,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690271,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690270,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 47701809,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690273,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690272,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690275,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690274,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690277,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690276,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690278,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 23810,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930532": {
            id: 35930532,
            name: "Aglio-olio Pasta Veg",
            category: "Pasta",
            description:
              "The connoisseur's choice! choice of pasta (penne/ spaghetti) tossed with extra virgin olive oil infused with herbs, garlic, red chillies, parmesan, sundried tomatoes and assorted vegetables. Serving size: 300gms energy per 100 gms: 187. 31kcal contains: gluten, sulphite",
            cloudinaryImageId: "fjyyklhpsxtch3fqaqfy",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493357",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407762",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493357",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407763",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493357",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493357", variation_id: "76407762" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389345", addon_id: "59227007" },
                    { group_id: "74389345", addon_id: "59227008" },
                    { group_id: "74389345", addon_id: "59227009" },
                    { group_id: "74389346", addon_id: "59227010" },
                    { group_id: "74389346", addon_id: "59227011" },
                    { group_id: "74389346", addon_id: "59227012" },
                    { group_id: "74389346", addon_id: "59227013" },
                    { group_id: "74389346", addon_id: "59227014" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493357", variation_id: "76407763" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389345", addon_id: "59227007" },
                    { group_id: "74389345", addon_id: "59227008" },
                    { group_id: "74389345", addon_id: "59227009" },
                    { group_id: "74389346", addon_id: "59227010" },
                    { group_id: "74389346", addon_id: "59227011" },
                    { group_id: "74389346", addon_id: "59227012" },
                    { group_id: "74389346", addon_id: "59227013" },
                    { group_id: "74389346", addon_id: "59227014" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389345,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227009,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227007,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227008,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389346,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 59227012,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227013,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227010,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227011,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227014,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20477,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930533": {
            id: 35930533,
            name: "Creamy Cheese Sauce Pasta Non-veg",
            category: "Pasta",
            description:
              "Copious amounts of cheddar and mozarella added to our truffles original creamy white sauce. A choice of pasta (penne or spaghetti), finished with diced chicken, golden garlic, sautéed spinach, olive oil and yes. . . . . More cheese! serving size: 420gms energy per 100 gms: 151. 36kcal contains: gluten, milk, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491919",
                  name: "Option",
                  variations: [
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 1,
                      id: "55172380",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491919",
                      order: 100,
                    },
                    {
                      name: "Penne",
                      price: 0,
                      default: 0,
                      id: "55172377",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491919",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491919", variation_id: "55172380" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47701363", addon_id: "33689832" },
                    { group_id: "47701363", addon_id: "33689833" },
                    { group_id: "47701363", addon_id: "33689834" },
                    { group_id: "47701364", addon_id: "33689835" },
                    { group_id: "47701364", addon_id: "33689836" },
                    { group_id: "47701364", addon_id: "33689837" },
                    { group_id: "47701365", addon_id: "63510297" },
                    { group_id: "47701365", addon_id: "33689838" },
                    { group_id: "47701365", addon_id: "33689839" },
                    { group_id: "47701365", addon_id: "33689840" },
                    { group_id: "47701365", addon_id: "33689841" },
                    { group_id: "47701366", addon_id: "33689842" },
                    { group_id: "47701366", addon_id: "33689843" },
                    { group_id: "47701366", addon_id: "33689844" },
                    { group_id: "47701366", addon_id: "33689845" },
                    { group_id: "47701366", addon_id: "33689846" },
                    { group_id: "47701366", addon_id: "33689847" },
                    { group_id: "47701366", addon_id: "33689848" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491919", variation_id: "55172377" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47701363", addon_id: "33689832" },
                    { group_id: "47701363", addon_id: "33689833" },
                    { group_id: "47701363", addon_id: "33689834" },
                    { group_id: "47701364", addon_id: "33689835" },
                    { group_id: "47701364", addon_id: "33689836" },
                    { group_id: "47701364", addon_id: "33689837" },
                    { group_id: "47701365", addon_id: "63510297" },
                    { group_id: "47701365", addon_id: "33689838" },
                    { group_id: "47701365", addon_id: "33689839" },
                    { group_id: "47701365", addon_id: "33689840" },
                    { group_id: "47701365", addon_id: "33689841" },
                    { group_id: "47701366", addon_id: "33689842" },
                    { group_id: "47701366", addon_id: "33689843" },
                    { group_id: "47701366", addon_id: "33689844" },
                    { group_id: "47701366", addon_id: "33689845" },
                    { group_id: "47701366", addon_id: "33689846" },
                    { group_id: "47701366", addon_id: "33689847" },
                    { group_id: "47701366", addon_id: "33689848" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701363,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689834,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689833,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689832,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701364,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689835,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689837,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689836,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701365,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 33689839,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689838,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689841,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689840,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510297,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 47701366,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689842,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689848,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689847,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689846,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689845,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689844,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689843,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 23810,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930534": {
            id: 35930534,
            name: "Bianca Pasta Non-veg",
            category: "Pasta",
            description:
              "A choice of pasta (penne or spaghetti) in truffles signature housemade spicy tomato sauce with notes of garlic, celery and basil, tossed with diced chicken, cream and topped with cheese and jalapenos serving size: 450gms energy per 100 gms: 159. 31kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491921",
                  name: "Option",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "55172200",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491921",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "55172202",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491921",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491921", variation_id: "55172200" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47700951", addon_id: "33689360" },
                    { group_id: "47700951", addon_id: "33689361" },
                    { group_id: "47700951", addon_id: "33689362" },
                    { group_id: "47700952", addon_id: "33689363" },
                    { group_id: "47700952", addon_id: "33689364" },
                    { group_id: "47700952", addon_id: "33689365" },
                    { group_id: "47700953", addon_id: "63510296" },
                    { group_id: "47700953", addon_id: "33689366" },
                    { group_id: "47700953", addon_id: "33689367" },
                    { group_id: "47700953", addon_id: "33689368" },
                    { group_id: "47700953", addon_id: "33689369" },
                    { group_id: "47700954", addon_id: "33689370" },
                    { group_id: "47700954", addon_id: "33689371" },
                    { group_id: "47700954", addon_id: "33689372" },
                    { group_id: "47700954", addon_id: "33689373" },
                    { group_id: "47700954", addon_id: "33689374" },
                    { group_id: "47700954", addon_id: "33689375" },
                    { group_id: "47700954", addon_id: "33689376" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491921", variation_id: "55172202" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47700951", addon_id: "33689360" },
                    { group_id: "47700951", addon_id: "33689361" },
                    { group_id: "47700951", addon_id: "33689362" },
                    { group_id: "47700952", addon_id: "33689363" },
                    { group_id: "47700952", addon_id: "33689364" },
                    { group_id: "47700952", addon_id: "33689365" },
                    { group_id: "47700953", addon_id: "63510296" },
                    { group_id: "47700953", addon_id: "33689366" },
                    { group_id: "47700953", addon_id: "33689367" },
                    { group_id: "47700953", addon_id: "33689368" },
                    { group_id: "47700953", addon_id: "33689369" },
                    { group_id: "47700954", addon_id: "33689370" },
                    { group_id: "47700954", addon_id: "33689371" },
                    { group_id: "47700954", addon_id: "33689372" },
                    { group_id: "47700954", addon_id: "33689373" },
                    { group_id: "47700954", addon_id: "33689374" },
                    { group_id: "47700954", addon_id: "33689375" },
                    { group_id: "47700954", addon_id: "33689376" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700951,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689361,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689360,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689362,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700952,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689365,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689364,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689363,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47700953,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 33689369,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689368,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689367,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689366,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510296,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 47700954,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689372,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689371,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689370,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689376,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689375,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689374,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689373,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 23810,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930535": {
            id: 35930535,
            name: "Bianca Pasta Veg",
            category: "Pasta",
            description:
              "A choice of pasta (penne or spaghetti) in truffles signature housemade spicy tomato sauce with notes of garlic, celery and basil, tossed with cream and topped with cheese and jalapenos serving size: 500gms energy per 100 gms: 155. 49kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493359",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407766",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493359",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407767",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493359",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493359", variation_id: "76407766" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389350", addon_id: "59227022" },
                    { group_id: "74389350", addon_id: "59227023" },
                    { group_id: "74389350", addon_id: "59227024" },
                    { group_id: "74389351", addon_id: "63510343" },
                    { group_id: "74389351", addon_id: "59227025" },
                    { group_id: "74389351", addon_id: "59227026" },
                    { group_id: "74389351", addon_id: "59227027" },
                    { group_id: "74389351", addon_id: "59227028" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493359", variation_id: "76407767" },
                  ],
                  price: 20477,
                  addon_combinations: [
                    { group_id: "74389350", addon_id: "59227022" },
                    { group_id: "74389350", addon_id: "59227023" },
                    { group_id: "74389350", addon_id: "59227024" },
                    { group_id: "74389351", addon_id: "63510343" },
                    { group_id: "74389351", addon_id: "59227025" },
                    { group_id: "74389351", addon_id: "59227026" },
                    { group_id: "74389351", addon_id: "59227027" },
                    { group_id: "74389351", addon_id: "59227028" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389350,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227023,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227024,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227022,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389351,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227027,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510343,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227028,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227025,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227026,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 20477,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930536": {
            id: 35930536,
            name: "Aglio-olio Pasta(non Veg)",
            category: "Pasta",
            description:
              "The connoisseur's choice! choice of pasta (penne/ spaghetti) tossed with diced chicken, extra virgin olive oil infused with herbs, garlic, red chillies, parmesan, sundried tomatoes and assorted vegetables. Serving size: 250gms energy per 100 gms: 173. 13kcal contains: gluten, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491923",
                  name: "Option",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "55172149",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491923",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "55172150",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491923",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491923", variation_id: "55172149" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47700943", addon_id: "33689326" },
                    { group_id: "47700943", addon_id: "33689327" },
                    { group_id: "47700943", addon_id: "33689328" },
                    { group_id: "47700944", addon_id: "33689329" },
                    { group_id: "47700944", addon_id: "33689330" },
                    { group_id: "47700944", addon_id: "33689331" },
                    { group_id: "47700945", addon_id: "63510295" },
                    { group_id: "47700945", addon_id: "33689332" },
                    { group_id: "47700945", addon_id: "33689333" },
                    { group_id: "47700945", addon_id: "33689334" },
                    { group_id: "47700945", addon_id: "33689335" },
                    { group_id: "47700946", addon_id: "33689336" },
                    { group_id: "47700946", addon_id: "33689337" },
                    { group_id: "47700946", addon_id: "33689338" },
                    { group_id: "47700946", addon_id: "33689339" },
                    { group_id: "47700946", addon_id: "33689340" },
                    { group_id: "47700946", addon_id: "33689341" },
                    { group_id: "47700946", addon_id: "33689342" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491923", variation_id: "55172150" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "47700943", addon_id: "33689326" },
                    { group_id: "47700943", addon_id: "33689327" },
                    { group_id: "47700943", addon_id: "33689328" },
                    { group_id: "47700944", addon_id: "33689329" },
                    { group_id: "47700944", addon_id: "33689330" },
                    { group_id: "47700944", addon_id: "33689331" },
                    { group_id: "47700945", addon_id: "63510295" },
                    { group_id: "47700945", addon_id: "33689332" },
                    { group_id: "47700945", addon_id: "33689333" },
                    { group_id: "47700945", addon_id: "33689334" },
                    { group_id: "47700945", addon_id: "33689335" },
                    { group_id: "47700946", addon_id: "33689336" },
                    { group_id: "47700946", addon_id: "33689337" },
                    { group_id: "47700946", addon_id: "33689338" },
                    { group_id: "47700946", addon_id: "33689339" },
                    { group_id: "47700946", addon_id: "33689340" },
                    { group_id: "47700946", addon_id: "33689341" },
                    { group_id: "47700946", addon_id: "33689342" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700943,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689328,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689327,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689326,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700944,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689329,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689331,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689330,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47700945,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 63510295,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689335,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689334,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689333,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689332,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 47700946,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689336,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689339,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689342,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689338,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689341,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689337,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689340,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 23810,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930537": {
            id: 35930537,
            name: "Arrabiata Pasta Non-veg",
            category: "Pasta",
            description:
              "Choice of pasta (penne/ spaghetti) with diced chicken, spiced tomato concasse, fresh basil and assorted veggies finished with olive oil and cheese serving size: 450gms energy per 100 gms: 150. 29kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493360",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407768",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493360",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407769",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493360",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493360", variation_id: "76407768" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "74389352", addon_id: "59227029" },
                    { group_id: "74389352", addon_id: "59227030" },
                    { group_id: "74389352", addon_id: "59227031" },
                    { group_id: "74389353", addon_id: "59227032" },
                    { group_id: "74389353", addon_id: "59227033" },
                    { group_id: "74389353", addon_id: "59227034" },
                    { group_id: "74389354", addon_id: "63510321" },
                    { group_id: "74389354", addon_id: "59227035" },
                    { group_id: "74389354", addon_id: "59227036" },
                    { group_id: "74389354", addon_id: "59227037" },
                    { group_id: "74389354", addon_id: "59227038" },
                    { group_id: "74389355", addon_id: "59227039" },
                    { group_id: "74389355", addon_id: "59227040" },
                    { group_id: "74389355", addon_id: "59227041" },
                    { group_id: "74389355", addon_id: "59227042" },
                    { group_id: "74389355", addon_id: "59227043" },
                    { group_id: "74389355", addon_id: "59227044" },
                    { group_id: "74389355", addon_id: "59227045" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493360", variation_id: "76407769" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "74389352", addon_id: "59227029" },
                    { group_id: "74389352", addon_id: "59227030" },
                    { group_id: "74389352", addon_id: "59227031" },
                    { group_id: "74389353", addon_id: "59227032" },
                    { group_id: "74389353", addon_id: "59227033" },
                    { group_id: "74389353", addon_id: "59227034" },
                    { group_id: "74389354", addon_id: "63510321" },
                    { group_id: "74389354", addon_id: "59227035" },
                    { group_id: "74389354", addon_id: "59227036" },
                    { group_id: "74389354", addon_id: "59227037" },
                    { group_id: "74389354", addon_id: "59227038" },
                    { group_id: "74389355", addon_id: "59227039" },
                    { group_id: "74389355", addon_id: "59227040" },
                    { group_id: "74389355", addon_id: "59227041" },
                    { group_id: "74389355", addon_id: "59227042" },
                    { group_id: "74389355", addon_id: "59227043" },
                    { group_id: "74389355", addon_id: "59227044" },
                    { group_id: "74389355", addon_id: "59227045" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389352,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 59227030,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227031,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227029,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389353,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227034,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227032,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227033,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 74389354,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227035,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227038,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510321,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227036,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227037,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 74389355,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 59227045,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227043,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227044,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227041,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227039,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227042,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227040,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 23810,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930538": {
            id: 35930538,
            name: "Olive Blasta Pasta Veg",
            category: "Pasta",
            description:
              "True to its name, a sinful italian tomato sauce exploding with flavours of fresh olives and basil. Finished with a dash of cream and garlic butter. A must try! a choice of pasta (penne or spaghetti) serving size: 410gms energy per 100 gms: 162. 23kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493365",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407778",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493365",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407779",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493365",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493365", variation_id: "76407778" },
                  ],
                  price: 24762,
                  addon_combinations: [
                    { group_id: "74389366", addon_id: "59227086" },
                    { group_id: "74389366", addon_id: "59227087" },
                    { group_id: "74389366", addon_id: "59227088" },
                    { group_id: "74389367", addon_id: "59227089" },
                    { group_id: "74389367", addon_id: "59227090" },
                    { group_id: "74389367", addon_id: "59227091" },
                    { group_id: "74389367", addon_id: "59227092" },
                    { group_id: "74389367", addon_id: "59227093" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493365", variation_id: "76407779" },
                  ],
                  price: 24762,
                  addon_combinations: [
                    { group_id: "74389366", addon_id: "59227086" },
                    { group_id: "74389366", addon_id: "59227087" },
                    { group_id: "74389366", addon_id: "59227088" },
                    { group_id: "74389367", addon_id: "59227089" },
                    { group_id: "74389367", addon_id: "59227090" },
                    { group_id: "74389367", addon_id: "59227091" },
                    { group_id: "74389367", addon_id: "59227092" },
                    { group_id: "74389367", addon_id: "59227093" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389366,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227086,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227087,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227088,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389367,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 59227089,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227092,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227093,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227090,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227091,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 24762,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930539": {
            id: 35930539,
            name: "Sun Dried Tomato Pasta Veg",
            category: "Pasta",
            description:
              "Enhanced tomato sauce infused with sundried tomato, garlic, olive oil, thyme, parsley & mushrooms serving size: 450gms energy per 100 gms: 160. 24kcal contains: gluten, milk, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493368",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407784",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493368",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407785",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23493368",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493368", variation_id: "76407784" },
                  ],
                  price: 24762,
                  addon_combinations: [
                    { group_id: "74389376", addon_id: "59227128" },
                    { group_id: "74389376", addon_id: "59227129" },
                    { group_id: "74389376", addon_id: "59227130" },
                    { group_id: "74389377", addon_id: "63510345" },
                    { group_id: "74389377", addon_id: "59227131" },
                    { group_id: "74389377", addon_id: "59227132" },
                    { group_id: "74389377", addon_id: "59227133" },
                    { group_id: "74389377", addon_id: "59227134" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493368", variation_id: "76407785" },
                  ],
                  price: 24762,
                  addon_combinations: [
                    { group_id: "74389376", addon_id: "59227128" },
                    { group_id: "74389376", addon_id: "59227129" },
                    { group_id: "74389376", addon_id: "59227130" },
                    { group_id: "74389377", addon_id: "63510345" },
                    { group_id: "74389377", addon_id: "59227131" },
                    { group_id: "74389377", addon_id: "59227132" },
                    { group_id: "74389377", addon_id: "59227133" },
                    { group_id: "74389377", addon_id: "59227134" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389376,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227130,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227128,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227129,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389377,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227133,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227134,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227131,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510345,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227132,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 24762,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930540": {
            id: 35930540,
            name: "Italian Pasta Alfredo Non-veg",
            category: "Pasta",
            description:
              "Another take on a white sauce pasta. Housemade mushroom sauce infused with garlic and celery tossed with diced chicken, green and yellow zucchini & a sprinkle of parmesan. Available with choice of pasta (penne or spaghetti) serving size: 510gms energy per 100 gms: 150. 49kcal contains: gluten, sulphite, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491931",
                  name: "Option",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "55172568",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491931",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "55172569",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491931",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491931", variation_id: "55172568" },
                  ],
                  price: 24762,
                  addon_combinations: [
                    { group_id: "47701226", addon_id: "33689798" },
                    { group_id: "47701226", addon_id: "33689799" },
                    { group_id: "47701226", addon_id: "33689800" },
                    { group_id: "47701229", addon_id: "33689801" },
                    { group_id: "47701229", addon_id: "33689802" },
                    { group_id: "47701229", addon_id: "33689803" },
                    { group_id: "47701232", addon_id: "63510298" },
                    { group_id: "47701232", addon_id: "33689804" },
                    { group_id: "47701232", addon_id: "33689805" },
                    { group_id: "47701232", addon_id: "33689806" },
                    { group_id: "47701232", addon_id: "33689807" },
                    { group_id: "47701234", addon_id: "33689808" },
                    { group_id: "47701234", addon_id: "33689809" },
                    { group_id: "47701234", addon_id: "33689810" },
                    { group_id: "47701234", addon_id: "33689811" },
                    { group_id: "47701234", addon_id: "33689812" },
                    { group_id: "47701234", addon_id: "33689813" },
                    { group_id: "47701234", addon_id: "33689814" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491931", variation_id: "55172569" },
                  ],
                  price: 24762,
                  addon_combinations: [
                    { group_id: "47701226", addon_id: "33689798" },
                    { group_id: "47701226", addon_id: "33689799" },
                    { group_id: "47701226", addon_id: "33689800" },
                    { group_id: "47701229", addon_id: "33689801" },
                    { group_id: "47701229", addon_id: "33689802" },
                    { group_id: "47701229", addon_id: "33689803" },
                    { group_id: "47701232", addon_id: "63510298" },
                    { group_id: "47701232", addon_id: "33689804" },
                    { group_id: "47701232", addon_id: "33689805" },
                    { group_id: "47701232", addon_id: "33689806" },
                    { group_id: "47701232", addon_id: "33689807" },
                    { group_id: "47701234", addon_id: "33689808" },
                    { group_id: "47701234", addon_id: "33689809" },
                    { group_id: "47701234", addon_id: "33689810" },
                    { group_id: "47701234", addon_id: "33689811" },
                    { group_id: "47701234", addon_id: "33689812" },
                    { group_id: "47701234", addon_id: "33689813" },
                    { group_id: "47701234", addon_id: "33689814" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701226,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689798,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689800,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689799,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701229,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689802,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689801,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689803,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701232,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 33689806,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689805,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689804,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510298,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689807,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 47701234,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689814,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689813,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689809,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689812,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689808,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689811,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689810,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 24762,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930541": {
            id: 35930541,
            name: "Spaghetti Carbonara Chicken",
            category: "Pasta",
            description:
              "A roman historic! choice of pasta paired with a mild creamy sauce of egg yolks, parmesan,cheese and chicken ham serving size: 450gms energy per 100 gms: 187. 65kcal contains: gluten, sulphite, milk, egg",
            cloudinaryImageId: "ogmk1nwowvfzkk4zbo31",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887962,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887963,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930542": {
            id: 35930542,
            name: "Spaghetti Bolognese Pasta (Lamb)",
            category: "Pasta",
            description:
              "For the mighty at heart! a bold meat sauce, infused with oregano and with grated parmesan serving size: 500gms energy per 100 gms: 177. 57kcal contains: gluten, milk",
            cloudinaryImageId: "pn9rib9i8hqvbmjitq26",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887960,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887961,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930543": {
            id: 35930543,
            name: "Olive Blasta Pasta Non-veg",
            category: "Pasta",
            description:
              "True to its name, a sinful italian tomato sauce exploding with flavours of fresh olives and basil. Finished with diced chicken, a dash of cream and garlic butter. A must try! a choice of pasta (penne or spaghetti) serving size: 450gms energy per 100 gms: 169. 79kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493366",
                  name: "Options",
                  variations: [
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 1,
                      id: "76407781",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493366",
                      order: 100,
                    },
                    {
                      name: "Penne",
                      price: 0,
                      default: 0,
                      id: "76407780",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493366",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493366", variation_id: "76407781" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "74389368", addon_id: "59227094" },
                    { group_id: "74389368", addon_id: "59227095" },
                    { group_id: "74389368", addon_id: "59227096" },
                    { group_id: "74389369", addon_id: "59227097" },
                    { group_id: "74389369", addon_id: "59227098" },
                    { group_id: "74389369", addon_id: "59227099" },
                    { group_id: "74389370", addon_id: "63510323" },
                    { group_id: "74389370", addon_id: "59227100" },
                    { group_id: "74389370", addon_id: "59227101" },
                    { group_id: "74389370", addon_id: "59227102" },
                    { group_id: "74389370", addon_id: "59227103" },
                    { group_id: "74389371", addon_id: "59227104" },
                    { group_id: "74389371", addon_id: "59227105" },
                    { group_id: "74389371", addon_id: "59227106" },
                    { group_id: "74389371", addon_id: "59227107" },
                    { group_id: "74389371", addon_id: "59227108" },
                    { group_id: "74389371", addon_id: "59227109" },
                    { group_id: "74389371", addon_id: "59227110" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493366", variation_id: "76407780" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "74389368", addon_id: "59227094" },
                    { group_id: "74389368", addon_id: "59227095" },
                    { group_id: "74389368", addon_id: "59227096" },
                    { group_id: "74389369", addon_id: "59227097" },
                    { group_id: "74389369", addon_id: "59227098" },
                    { group_id: "74389369", addon_id: "59227099" },
                    { group_id: "74389370", addon_id: "63510323" },
                    { group_id: "74389370", addon_id: "59227100" },
                    { group_id: "74389370", addon_id: "59227101" },
                    { group_id: "74389370", addon_id: "59227102" },
                    { group_id: "74389370", addon_id: "59227103" },
                    { group_id: "74389371", addon_id: "59227104" },
                    { group_id: "74389371", addon_id: "59227105" },
                    { group_id: "74389371", addon_id: "59227106" },
                    { group_id: "74389371", addon_id: "59227107" },
                    { group_id: "74389371", addon_id: "59227108" },
                    { group_id: "74389371", addon_id: "59227109" },
                    { group_id: "74389371", addon_id: "59227110" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389368,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 59227096,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227094,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227095,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389369,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227097,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227098,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227099,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 74389370,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227100,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227101,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510323,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227102,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227103,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 74389371,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 59227108,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227109,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227106,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227107,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227110,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227104,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227105,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 27620,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930544": {
            id: 35930544,
            name: "Sun Dried Tomato Pasta Non-veg",
            category: "Pasta",
            description:
              "Enhanced tomato sauce infused with sundried tomato, garlic, diced chicken, olive oil, thyme, parsley & mushrooms serving size: 450gms energy per 100 gms: 155. 65kcal contains: gluten, sulphite, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493369",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407786",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493369",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407787",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493369",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493369", variation_id: "76407786" },
                  ],
                  price: 28572,
                  addon_combinations: [
                    { group_id: "74389378", addon_id: "59227135" },
                    { group_id: "74389378", addon_id: "59227136" },
                    { group_id: "74389378", addon_id: "59227137" },
                    { group_id: "74389379", addon_id: "59227138" },
                    { group_id: "74389379", addon_id: "59227139" },
                    { group_id: "74389379", addon_id: "59227140" },
                    { group_id: "74389380", addon_id: "63510324" },
                    { group_id: "74389380", addon_id: "59227141" },
                    { group_id: "74389380", addon_id: "59227142" },
                    { group_id: "74389380", addon_id: "59227143" },
                    { group_id: "74389380", addon_id: "59227144" },
                    { group_id: "74389381", addon_id: "59227145" },
                    { group_id: "74389381", addon_id: "59227146" },
                    { group_id: "74389381", addon_id: "59227147" },
                    { group_id: "74389381", addon_id: "59227148" },
                    { group_id: "74389381", addon_id: "59227149" },
                    { group_id: "74389381", addon_id: "59227150" },
                    { group_id: "74389381", addon_id: "59227151" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493369", variation_id: "76407787" },
                  ],
                  price: 28572,
                  addon_combinations: [
                    { group_id: "74389378", addon_id: "59227135" },
                    { group_id: "74389378", addon_id: "59227136" },
                    { group_id: "74389378", addon_id: "59227137" },
                    { group_id: "74389379", addon_id: "59227138" },
                    { group_id: "74389379", addon_id: "59227139" },
                    { group_id: "74389379", addon_id: "59227140" },
                    { group_id: "74389380", addon_id: "63510324" },
                    { group_id: "74389380", addon_id: "59227141" },
                    { group_id: "74389380", addon_id: "59227142" },
                    { group_id: "74389380", addon_id: "59227143" },
                    { group_id: "74389380", addon_id: "59227144" },
                    { group_id: "74389381", addon_id: "59227145" },
                    { group_id: "74389381", addon_id: "59227146" },
                    { group_id: "74389381", addon_id: "59227147" },
                    { group_id: "74389381", addon_id: "59227148" },
                    { group_id: "74389381", addon_id: "59227149" },
                    { group_id: "74389381", addon_id: "59227150" },
                    { group_id: "74389381", addon_id: "59227151" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389378,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 59227137,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227135,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227136,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389379,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227140,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227138,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227139,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 74389380,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227144,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510324,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227142,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227143,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227141,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 74389381,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 59227145,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227148,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227151,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227149,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227146,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227147,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227150,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 28572,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930545": {
            id: 35930545,
            name: "Pinky Pasta Non-veg",
            category: "Pasta",
            description:
              "When an arrabiata and cream cheese hook-up! made with your choice of pasta (penne or spaghetti) and tossed diced chicken serving size: 450gms energy per 100 gms: 160. 38kcal contains: gluten, soy, milk, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23493367",
                  name: "Options",
                  variations: [
                    {
                      name: "Penne",
                      price: 0,
                      default: 1,
                      id: "76407782",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493367",
                      order: 100,
                    },
                    {
                      name: "Spaghetti",
                      price: 0,
                      default: 0,
                      id: "76407783",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23493367",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23493367", variation_id: "76407782" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "74389372", addon_id: "59227111" },
                    { group_id: "74389372", addon_id: "59227112" },
                    { group_id: "74389372", addon_id: "59227113" },
                    { group_id: "74389373", addon_id: "59227114" },
                    { group_id: "74389373", addon_id: "59227115" },
                    { group_id: "74389373", addon_id: "59227116" },
                    { group_id: "74389374", addon_id: "63510322" },
                    { group_id: "74389374", addon_id: "59227117" },
                    { group_id: "74389374", addon_id: "59227118" },
                    { group_id: "74389374", addon_id: "59227119" },
                    { group_id: "74389374", addon_id: "59227120" },
                    { group_id: "74389375", addon_id: "59227121" },
                    { group_id: "74389375", addon_id: "59227122" },
                    { group_id: "74389375", addon_id: "59227123" },
                    { group_id: "74389375", addon_id: "59227124" },
                    { group_id: "74389375", addon_id: "59227125" },
                    { group_id: "74389375", addon_id: "59227126" },
                    { group_id: "74389375", addon_id: "59227127" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23493367", variation_id: "76407783" },
                  ],
                  price: 23810,
                  addon_combinations: [
                    { group_id: "74389372", addon_id: "59227111" },
                    { group_id: "74389372", addon_id: "59227112" },
                    { group_id: "74389372", addon_id: "59227113" },
                    { group_id: "74389373", addon_id: "59227114" },
                    { group_id: "74389373", addon_id: "59227115" },
                    { group_id: "74389373", addon_id: "59227116" },
                    { group_id: "74389374", addon_id: "63510322" },
                    { group_id: "74389374", addon_id: "59227117" },
                    { group_id: "74389374", addon_id: "59227118" },
                    { group_id: "74389374", addon_id: "59227119" },
                    { group_id: "74389374", addon_id: "59227120" },
                    { group_id: "74389375", addon_id: "59227121" },
                    { group_id: "74389375", addon_id: "59227122" },
                    { group_id: "74389375", addon_id: "59227123" },
                    { group_id: "74389375", addon_id: "59227124" },
                    { group_id: "74389375", addon_id: "59227125" },
                    { group_id: "74389375", addon_id: "59227126" },
                    { group_id: "74389375", addon_id: "59227127" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 74389372,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 59227111,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227112,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227113,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 74389373,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 59227115,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227116,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227114,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 74389374,
                group_name: "Veg Option",
                choices: [
                  {
                    id: 59227119,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227117,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227120,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227118,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510322,
                    name: "Vegetables",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
              {
                group_id: 74389375,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 59227122,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227123,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227121,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227126,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227127,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227124,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 59227125,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 97,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 23810,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930546": {
            id: 35930546,
            name: "Roast Lamb Sub",
            category: "Submarine",
            description:
              "Our hidden jewel in the truffles menu! slow cooked tender slices of lamb with a desi kick, served in either a reg/ xl sub serving size: 280gms energy per 100 gms: 245. 5kcal contains: gluten, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491935",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172752",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491935",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172753",
                      inStock: 0,
                      isVeg: 0,
                      variant_group_id: "3491935",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491935", variation_id: "55172752" },
                  ],
                  price: 33334,
                  addon_combinations: [
                    { group_id: "47701834", addon_id: "33690299" },
                    { group_id: "47701834", addon_id: "33690300" },
                    { group_id: "47701834", addon_id: "33690301" },
                    { group_id: "47701835", addon_id: "33690302" },
                    { group_id: "47701835", addon_id: "33690303" },
                    { group_id: "47701835", addon_id: "33690304" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491935", variation_id: "55172753" },
                  ],
                  price: 22857,
                  addon_combinations: [
                    { group_id: "47701834", addon_id: "33690299" },
                    { group_id: "47701834", addon_id: "33690300" },
                    { group_id: "47701834", addon_id: "33690301" },
                    { group_id: "47701835", addon_id: "33690302" },
                    { group_id: "47701835", addon_id: "33690303" },
                    { group_id: "47701835", addon_id: "33690304" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701834,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690299,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690301,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690300,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701835,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690303,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690302,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690304,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 33334,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930547": {
            id: 35930547,
            name: "Crispy Lucy Chicken Sub(xl)",
            category: "Submarine",
            description:
              "Shredded chicken glazed in a bourbon sauce served on a bed of crisp spaghetti. Serving size: 400gms energy per 100 gms: 231. 37kcal contains: gluten, soy, egg, sulphite",
            cloudinaryImageId: "ijzfcddsgoq7slka31m9",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887939,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887940,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930548": {
            id: 35930548,
            name: "Schnitzel",
            category: "Submarine",
            description:
              "Crumb fried chicken on a bed of iceberg, garnished ‘w’ gherkin, smeared with relish serving size: 410gms energy per 100 gms: 270. 92kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "adrruk8ji7lcju6y2kar",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887943,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887944,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930552": {
            id: 35930552,
            name: "Smoked Chicken Sausage Sub",
            category: "Submarine",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491937",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172784",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491937",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172785",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491937",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491937", variation_id: "55172784" },
                  ],
                  price: 24286,
                  addon_combinations: [
                    { group_id: "47701952", addon_id: "33690419" },
                    { group_id: "47701952", addon_id: "33690420" },
                    { group_id: "47701952", addon_id: "33690421" },
                    { group_id: "47701953", addon_id: "33690422" },
                    { group_id: "47701953", addon_id: "33690423" },
                    { group_id: "47701953", addon_id: "33690424" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491937", variation_id: "55172785" },
                  ],
                  price: 16191,
                  addon_combinations: [
                    { group_id: "47701952", addon_id: "33690419" },
                    { group_id: "47701952", addon_id: "33690420" },
                    { group_id: "47701952", addon_id: "33690421" },
                    { group_id: "47701953", addon_id: "33690422" },
                    { group_id: "47701953", addon_id: "33690423" },
                    { group_id: "47701953", addon_id: "33690424" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701952,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690420,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690419,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690421,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701953,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690424,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690423,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690422,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 24286,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930556": {
            id: 35930556,
            name: "Chicken With Mint & Rosemary",
            category: "Maincourse",
            description:
              "Pan seared breast of chicken serving size: 475gms energy per 100 gms: 166. 01kcal contains: gluten, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701123,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689664,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689665,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930557": {
            id: 35930557,
            name: "Tandoori Chicken Steak [Bone]",
            category: "Maincourse",
            description:
              "Char grilled tandoori chicken with a side of sliced onions, mint sauce and mashed potatoes serving size: 415gms energy per 100 gms: 157. 82kcal contains: egg, gluten, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701992,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690477,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690476,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930558": {
            id: 35930558,
            name: "Mexican Chicken With Rice",
            category: "Maincourse",
            description:
              "Grilled chicken diced and sautéed with mushroom, green bell pepper & potato strips in a spicy mexican sauce. Served with a mexican flavoured rice and fries serving size: 575gms energy per 100 gms: 162. 92kcal contains: gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425257,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930559": {
            id: 35930559,
            name: "Fcuk Paneer",
            category: "Maincourse",
            description:
              "Skewers of cottage cheese glazed in a caramelized bourbon sauce. Served on a bed of creamy mashed potatoes and topped with crunchy noodles. Serving size: 500gms energy per 100 gms: 222. 72kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701387,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33689864,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689865,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930560": {
            id: 35930560,
            name: "Prawn In Lemon Cream Sauce",
            category: "Maincourse",
            description:
              "Prawn pan seared and tossed in our creamy lemon butter sauce served with herb rice serving size: 400gms energy per 100 gms: 160. 83kcal contains: crustacean, milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 40477,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79429116,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930561": {
            id: 35930561,
            name: "All American Nachos Chicken",
            category: "Starters",
            description:
              "Layers of nachos, coloured bell pepper, jalapeno, roast chicken, mexican refried beans, iceberg lettuce, smeared with a cheese sauce and served along side salsa & sour cream serving size: 270gms energy per 100 gms: 218. 44kcal contains: milk, gluten, sulphite, soy",
            cloudinaryImageId: "qdatxbg3wur61ynmrbjg",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930562": {
            id: 35930562,
            name: "Fish N Chips",
            category: "Maincourse",
            description:
              "Tribute to the british classic! crumb fried fillet of fish, served with house fries and tartar sauce serving size: 290gms energy per 100 gms: 228. 94kcal contains: seafood, gluten, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930563": {
            id: 35930563,
            name: "London Mix Grilled",
            category: "Maincourse",
            description:
              "Meat lovers paradise! grilled chicken steak, minced lamb patty, sausage and chicken ham in a chilli garlic flavoured tomato concasse topped with a fried egg serving size: 575gms energy per 100 gms: 170. 37kcal contains: egg, sulphite, gluten, soy",
            cloudinaryImageId: "qthisgvauvzwpnvhskh2",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 42858,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47701659,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690114,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690115,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930564": {
            id: 35930564,
            name: "Veg A-la King",
            category: "Maincourse",
            description:
              "A truly royal affair! sautéed garden fresh veggies in a herb infused creamy white sauce serving size: 425gms energy per 100 gms: 162. 11kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425566,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 63510347,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 63510346,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930566": {
            id: 35930566,
            name: "One Flew Over The Cuckoo's Nest",
            category: "Maincourse",
            description:
              "Skewers of chicken/ prawn glazed with a caramelized bourbon sauce. Served on a bed of creamy mashed potatoes and garnished with crunchy noodles serving size: 450gms energy per 100 gms: 198. 68kcal contains: milk, gluten, soy, crustacean",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491941",
                  name: "Size",
                  variations: [
                    {
                      name: "Chicken",
                      price: 0,
                      default: 1,
                      id: "55173086",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491941",
                      order: 100,
                    },
                    {
                      name: "Prawn",
                      price: 0,
                      default: 0,
                      id: "55173087",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491941",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491941", variation_id: "55173086" },
                  ],
                  price: 30953,
                  addon_combinations: [
                    { group_id: "47701638", addon_id: "33690104" },
                    { group_id: "47701638", addon_id: "33690105" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491941", variation_id: "55173087" },
                  ],
                  price: 42381,
                  addon_combinations: [
                    { group_id: "47701638", addon_id: "33690104" },
                    { group_id: "47701638", addon_id: "33690105" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701638,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690105,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690104,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 30953,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930567": {
            id: 35930567,
            name: "All American Nachos Veg",
            category: "Starters",
            description:
              "Nachos, layered with julienne of bell pepper, mexican refried beans, crispy lettuce with a double dressing of salsa and cheese sauce. Serving size: 255gms energy per 100 gms: 209. 41kcal contains: gluten, milk",
            cloudinaryImageId: "usm5qgwkpsnlhp80tupy",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930568": {
            id: 35930568,
            name: "Veg Lasagna",
            category: "Maincourse",
            description:
              "Read between the layers! sheets of fresh pasta layered with seasoned vegetables in a thick tomato sauce, topped with a creamy cheese sauce. Serving size: 500gms energy per 100 gms: 173. 83kcal contains: gluten, milk",
            cloudinaryImageId: "s1oittry0t910usivmym",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930569": {
            id: 35930569,
            name: "Very Veggies",
            category: "Maincourse",
            description:
              "Panko fried veg croquettes (fresh veggies, cottage cheese, minced soya & cheese) with a drizzle of bbq sauce. Serving size: 350gms energy per 100 gms: 229. 09kcal contains: milk, gluten, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 47702045,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 33690534,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690533,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930570": {
            id: 35930570,
            name: "Grilled Fish In Lemon Butter Sauce",
            category: "Maincourse",
            description:
              "Marinated fillet of fish, pan grilled with garlic, served with our house made lemon butter sauce, mashed potato and veggies serving size: 385gms energy per 100 gms: 158. 12kcal contains: seafood, gluten, milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31910,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930572": {
            id: 35930572,
            name: "Thai Basil With Rice(chicken)",
            category: "Oriental",
            description:
              "Diced chicken cooked in garlic, chillies & basil, served with steamed rice serving size: 660gms energy per 100 gms: 177. 68kcal contains: sulphite, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930573": {
            id: 35930573,
            name: "Fire & Spice With Rice(chicken)",
            category: "Oriental",
            description:
              "Diced chicken stir fried in a spicy soya chilly sauce served with steamed rice serving size: 685gms energy per 100 gms: 181. 08kcal contains: soy, gluten, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930574": {
            id: 35930574,
            name: "Thai Basil With Rice(fish)",
            category: "Oriental",
            description:
              "Batter fried fish cooked in garlic, chillies & basil, served with steamed rice serving size: gms energy per 100 gms: kcal contains: seafood, sulphite, gluten, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31429,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930575": {
            id: 35930575,
            name: "Fire & Spice With Rice(fish)",
            category: "Oriental",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31429,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930576": {
            id: 35930576,
            name: "Thai Green Curry With Rice (Veg)",
            category: "Oriental",
            description:
              "Sauteed veggies in a creamy coconut infused spicy thai green curry served with steamed rice serving size: gms energy per 100 gms: kcal contains: nuts, sulphite, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 28572,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930577": {
            id: 35930577,
            name: "Thai Green Curry With Rice (Prawn)",
            category: "Oriental",
            description:
              "Prawns in a creamy coconut infused spicy thai green curry served with steamed rice serving size: gms energy per 100 gms: kcal contains: crustacean, nuts, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 40477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930578": {
            id: 35930578,
            name: "Thai Green Curry With Rice (Chicken)",
            category: "Oriental",
            description:
              "Diced chicken in a creamy coconut infused spicy thai green curry served with steamed rice serving size: 570gms energy per 100 gms: 212. 77kcal contains: nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31429,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930579": {
            id: 35930579,
            name: "Thai Red Curry With Rice (Fish)",
            category: "Oriental",
            description:
              "Batter fried fish in a creamy coconut infused spicy thai red curry served with steamed rice serving size: gms energy per 100 gms: kcal contains: seafood, nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 37143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930580": {
            id: 35930580,
            name: "Thai Red Curry With Rice (Chicken)",
            category: "Oriental",
            description:
              "Diced chicken in a creamy coconut infused spicy red green curry served with steamed rice serving size: 650gms energy per 100 gms: 197. 47kcal contains: nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31429,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930581": {
            id: 35930581,
            name: "Thai Green Curry With Rice (Fish)",
            category: "Oriental",
            description:
              "Batter fried fish in a creamy coconut infused spicy thai green curry served with steamed rice serving size: gms energy per 100 gms: kcal contains: seafood, nuts, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 37143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930582": {
            id: 35930582,
            name: "Thai Basil With Rice(prawn)",
            category: "Oriental",
            description:
              "Sauteed prawns cooked in garlic, chillies & basil, served with steamed rice serving size: gms energy per 100 gms: kcal contains: crustacean, nuts, sulphite, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 40477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930583": {
            id: 35930583,
            name: "Fire & Spice With Rice(prawn)",
            category: "Oriental",
            description:
              "Prawns stir fried in a spicy soya chilly sauce served with steamed rice serving size: 650 gms energy per 100 gms: kcal contains: crustacean, soy, gluten, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 40477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930584": {
            id: 35930584,
            name: "Thai Red Curry With Rice (Prawn)",
            category: "Oriental",
            description:
              "Prawns in a creamy coconut infused spicy thai red curry served with steamed rice serving size: gms energy per 100 gms: kcal contains: crustacean, nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 40477,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930585": {
            id: 35930585,
            name: "Thai Red Curry With Rice (Veg)",
            category: "Oriental",
            description:
              "Sauteed veggies in a creamy coconut infused spicy thai red curry served with steamed rice serving size: gms energy per 100 gms: kcal contains: nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 28572,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930586": {
            id: 35930586,
            name: "Mutton Kheema Pav",
            category: "Pav",
            description:
              "A spicy aromatic mince of lamb, slow cooked and served with buttered pav serving size: 450gms energy per 100 gms: 197. 14kcal contains: milk, gluten, soy,",
            cloudinaryImageId: "ieego0rikaz4xtygr8wg",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930730": {
            id: 35930730,
            name: "All American Lamb Burger",
            category: "Burger",
            description:
              "The living legend! flame grilled lamb patty slammed with an additional cheese burst patty serving size: gms energy per 100 gms: kcal contains: milk, gluten, egg",
            cloudinaryImageId: "qq1stofguoxz3mfg3sjo",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491966",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172236",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491966",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172237",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491966",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491966", variation_id: "55172236" },
                  ],
                  price: 28572,
                  addon_combinations: [
                    { group_id: "47700963", addon_id: "33689395" },
                    { group_id: "47700963", addon_id: "33689396" },
                    { group_id: "47700963", addon_id: "33689397" },
                    { group_id: "47700964", addon_id: "33689398" },
                    { group_id: "47700964", addon_id: "33689399" },
                    { group_id: "47700964", addon_id: "33689400" },
                    { group_id: "47700965", addon_id: "33689401" },
                    { group_id: "47700965", addon_id: "33689402" },
                    { group_id: "47700965", addon_id: "33689403" },
                    { group_id: "47700965", addon_id: "33689404" },
                    { group_id: "47700965", addon_id: "33689405" },
                    { group_id: "47700965", addon_id: "33689406" },
                    { group_id: "47700965", addon_id: "33689407" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491966", variation_id: "55172237" },
                  ],
                  price: 42858,
                  addon_combinations: [
                    { group_id: "47700963", addon_id: "33689395" },
                    { group_id: "47700963", addon_id: "33689396" },
                    { group_id: "47700963", addon_id: "33689397" },
                    { group_id: "47700964", addon_id: "33689398" },
                    { group_id: "47700964", addon_id: "33689399" },
                    { group_id: "47700964", addon_id: "33689400" },
                    { group_id: "47700965", addon_id: "33689401" },
                    { group_id: "47700965", addon_id: "33689402" },
                    { group_id: "47700965", addon_id: "33689403" },
                    { group_id: "47700965", addon_id: "33689404" },
                    { group_id: "47700965", addon_id: "33689405" },
                    { group_id: "47700965", addon_id: "33689406" },
                    { group_id: "47700965", addon_id: "33689407" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700963,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689397,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689396,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689395,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700964,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689398,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689400,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689399,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47700965,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689402,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689401,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689407,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689406,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689405,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689404,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689403,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 28572,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930731": {
            id: 35930731,
            name: "All American Chicken Burger",
            category: "Burger",
            description:
              "The living legend! grilled chicken breast slammed with an additional cheese burst patty serving size: 375gms energy per 100 gms: 237. 78kcal contains: milk, gluten, egg",
            cloudinaryImageId: "bzfywxdvmkafjsakvhye",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491967",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172219",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491967",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172220",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491967",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491967", variation_id: "55172219" },
                  ],
                  price: 24762,
                  addon_combinations: [
                    { group_id: "47700955", addon_id: "33689377" },
                    { group_id: "47700955", addon_id: "33689378" },
                    { group_id: "47700955", addon_id: "33689379" },
                    { group_id: "47700956", addon_id: "33689380" },
                    { group_id: "47700956", addon_id: "33689381" },
                    { group_id: "47700956", addon_id: "33689382" },
                    { group_id: "47700957", addon_id: "33689383" },
                    { group_id: "47700957", addon_id: "33689384" },
                    { group_id: "47700957", addon_id: "33689385" },
                    { group_id: "47700957", addon_id: "33689386" },
                    { group_id: "47700957", addon_id: "33689387" },
                    { group_id: "47700957", addon_id: "33689388" },
                    { group_id: "47700957", addon_id: "33689389" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491967", variation_id: "55172220" },
                  ],
                  price: 36191,
                  addon_combinations: [
                    { group_id: "47700955", addon_id: "33689377" },
                    { group_id: "47700955", addon_id: "33689378" },
                    { group_id: "47700955", addon_id: "33689379" },
                    { group_id: "47700956", addon_id: "33689380" },
                    { group_id: "47700956", addon_id: "33689381" },
                    { group_id: "47700956", addon_id: "33689382" },
                    { group_id: "47700957", addon_id: "33689383" },
                    { group_id: "47700957", addon_id: "33689384" },
                    { group_id: "47700957", addon_id: "33689385" },
                    { group_id: "47700957", addon_id: "33689386" },
                    { group_id: "47700957", addon_id: "33689387" },
                    { group_id: "47700957", addon_id: "33689388" },
                    { group_id: "47700957", addon_id: "33689389" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47700955,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689379,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689378,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689377,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47700956,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689382,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689381,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689380,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47700957,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689383,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689389,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689388,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689387,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689386,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689385,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689384,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 24762,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930733": {
            id: 35930733,
            name: "Prawn & Slaw Burger",
            category: "Burger",
            description:
              "Crumb fried prawns sandwiched with coleslaw serving size: 205gms energy per 100 gms: 243. 04kcal contains: egg, soy, gluten, crustacean",
            cloudinaryImageId: "gqjio2csexsrcnffo1ut",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491968",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172863",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491968",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172862",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491968",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491968", variation_id: "55172863" },
                  ],
                  price: 30953,
                  addon_combinations: [
                    { group_id: "47701767", addon_id: "33690211" },
                    { group_id: "47701767", addon_id: "33690212" },
                    { group_id: "47701767", addon_id: "33690213" },
                    { group_id: "47701769", addon_id: "33690215" },
                    { group_id: "47701769", addon_id: "33690216" },
                    { group_id: "47701769", addon_id: "33690217" },
                    { group_id: "47701772", addon_id: "33690218" },
                    { group_id: "47701772", addon_id: "33690219" },
                    { group_id: "47701772", addon_id: "33690220" },
                    { group_id: "47701772", addon_id: "33690221" },
                    { group_id: "47701772", addon_id: "33690222" },
                    { group_id: "47701772", addon_id: "33690223" },
                    { group_id: "47701772", addon_id: "33690224" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491968", variation_id: "55172862" },
                  ],
                  price: 20000,
                  addon_combinations: [
                    { group_id: "47701767", addon_id: "33690211" },
                    { group_id: "47701767", addon_id: "33690212" },
                    { group_id: "47701767", addon_id: "33690213" },
                    { group_id: "47701769", addon_id: "33690215" },
                    { group_id: "47701769", addon_id: "33690216" },
                    { group_id: "47701769", addon_id: "33690217" },
                    { group_id: "47701772", addon_id: "33690218" },
                    { group_id: "47701772", addon_id: "33690219" },
                    { group_id: "47701772", addon_id: "33690220" },
                    { group_id: "47701772", addon_id: "33690221" },
                    { group_id: "47701772", addon_id: "33690222" },
                    { group_id: "47701772", addon_id: "33690223" },
                    { group_id: "47701772", addon_id: "33690224" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701767,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690211,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690213,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690212,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701769,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690215,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690217,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690216,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701772,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690220,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690219,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690222,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690218,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690221,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690224,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690223,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 30953,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930734": {
            id: 35930734,
            name: "The Hotty Veg Burger",
            category: "Burger",
            description:
              "A spicy killer! a truffles burger with an oriental twist serving size: 250gms energy per 100 gms: 235. 67kcal contains: soy, gluten",
            cloudinaryImageId: "z2fb01u0ecvzrzmnswey",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491969",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172674",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491969",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172675",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491969",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491969", variation_id: "55172674" },
                  ],
                  price: 14762,
                  addon_combinations: [
                    { group_id: "47701866", addon_id: "33690314" },
                    { group_id: "47701866", addon_id: "33690315" },
                    { group_id: "47701866", addon_id: "33690316" },
                    { group_id: "47701870", addon_id: "33690317" },
                    { group_id: "47701870", addon_id: "33690318" },
                    { group_id: "47701870", addon_id: "33690319" },
                    { group_id: "47701870", addon_id: "33690320" },
                    { group_id: "47701870", addon_id: "33690321" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491969", variation_id: "55172675" },
                  ],
                  price: 22381,
                  addon_combinations: [
                    { group_id: "47701866", addon_id: "33690314" },
                    { group_id: "47701866", addon_id: "33690315" },
                    { group_id: "47701866", addon_id: "33690316" },
                    { group_id: "47701870", addon_id: "33690317" },
                    { group_id: "47701870", addon_id: "33690318" },
                    { group_id: "47701870", addon_id: "33690319" },
                    { group_id: "47701870", addon_id: "33690320" },
                    { group_id: "47701870", addon_id: "33690321" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701866,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690314,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690316,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690315,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701870,
                group_name: "5.veg Option",
                choices: [
                  {
                    id: 33690318,
                    name: "Coleslaw",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690321,
                    name: "Mushroom",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690317,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690320,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690319,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 14762,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930735": {
            id: 35930735,
            name: "Chicken Steak Burger Teriyaki",
            category: "Burger",
            description:
              "Grilled chicken steak with teriyaki sauce, onion & tomato serving size: 190gms energy per 100 gms: 241. 94kcal contains: milk, gluten, soy",
            cloudinaryImageId: "247fb7899d2b7fdeefa1f2442374e887",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491970",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172473",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491970",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172474",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491970",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491970", variation_id: "55172473" },
                  ],
                  price: 17620,
                  addon_combinations: [
                    { group_id: "47701028", addon_id: "33689538" },
                    { group_id: "47701028", addon_id: "33689539" },
                    { group_id: "47701028", addon_id: "33689540" },
                    { group_id: "47701029", addon_id: "33689541" },
                    { group_id: "47701029", addon_id: "33689542" },
                    { group_id: "47701029", addon_id: "33689543" },
                    { group_id: "47701030", addon_id: "33689544" },
                    { group_id: "47701030", addon_id: "33689545" },
                    { group_id: "47701030", addon_id: "33689546" },
                    { group_id: "47701030", addon_id: "33689547" },
                    { group_id: "47701030", addon_id: "33689548" },
                    { group_id: "47701030", addon_id: "33689549" },
                    { group_id: "47701030", addon_id: "33689550" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491970", variation_id: "55172474" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701028", addon_id: "33689538" },
                    { group_id: "47701028", addon_id: "33689539" },
                    { group_id: "47701028", addon_id: "33689540" },
                    { group_id: "47701029", addon_id: "33689541" },
                    { group_id: "47701029", addon_id: "33689542" },
                    { group_id: "47701029", addon_id: "33689543" },
                    { group_id: "47701030", addon_id: "33689544" },
                    { group_id: "47701030", addon_id: "33689545" },
                    { group_id: "47701030", addon_id: "33689546" },
                    { group_id: "47701030", addon_id: "33689547" },
                    { group_id: "47701030", addon_id: "33689548" },
                    { group_id: "47701030", addon_id: "33689549" },
                    { group_id: "47701030", addon_id: "33689550" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701028,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689538,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689540,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689539,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701029,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689541,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689543,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689542,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701030,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689545,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689544,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689549,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689548,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689547,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689550,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689546,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 17620,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930738": {
            id: 35930738,
            name: "Tons Of Fun Lamb",
            category: "Burger",
            description:
              "Grilled lamb patty served with chicken salami, cheese, fried egg, tomatoes & chopped onions  serving size: gms energy per 100 gms: kcal contains: egg, gluten, soy, milk",
            cloudinaryImageId: "zr1qeaf7w6qico4n1ek9",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491972",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55173297",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491972",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55173298",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491972",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491972", variation_id: "55173297" },
                  ],
                  price: 30000,
                  addon_combinations: [
                    { group_id: "47702060", addon_id: "33690554" },
                    { group_id: "47702060", addon_id: "33690555" },
                    { group_id: "47702060", addon_id: "33690556" },
                    { group_id: "47702061", addon_id: "33690557" },
                    { group_id: "47702061", addon_id: "33690558" },
                    { group_id: "47702061", addon_id: "33690559" },
                    { group_id: "47702063", addon_id: "33690560" },
                    { group_id: "47702063", addon_id: "33690561" },
                    { group_id: "47702063", addon_id: "33690562" },
                    { group_id: "47702063", addon_id: "33690563" },
                    { group_id: "47702063", addon_id: "33690564" },
                    { group_id: "47702063", addon_id: "33690565" },
                    { group_id: "47702063", addon_id: "33690566" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491972", variation_id: "55173298" },
                  ],
                  price: 38572,
                  addon_combinations: [
                    { group_id: "47702060", addon_id: "33690554" },
                    { group_id: "47702060", addon_id: "33690555" },
                    { group_id: "47702060", addon_id: "33690556" },
                    { group_id: "47702061", addon_id: "33690557" },
                    { group_id: "47702061", addon_id: "33690558" },
                    { group_id: "47702061", addon_id: "33690559" },
                    { group_id: "47702063", addon_id: "33690560" },
                    { group_id: "47702063", addon_id: "33690561" },
                    { group_id: "47702063", addon_id: "33690562" },
                    { group_id: "47702063", addon_id: "33690563" },
                    { group_id: "47702063", addon_id: "33690564" },
                    { group_id: "47702063", addon_id: "33690565" },
                    { group_id: "47702063", addon_id: "33690566" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47702060,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690556,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690555,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690554,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47702061,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690559,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690558,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690557,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47702063,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690566,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690561,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690560,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690563,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690562,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690565,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690564,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 30000,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930739": {
            id: 35930739,
            name: "Tons Of Fun Chicken",
            category: "Burger",
            description:
              "Grilled chicken patty served with chicken salami, cheese, fried egg, tomatoes & chopped onions serving size: 300gms energy per 100 gms: 195. 56kcal contains: egg, gluten, soy, milk",
            cloudinaryImageId: "slnupkbrpbw2ucaixedz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491973",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55173280",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491973",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55173281",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491973",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491973", variation_id: "55173280" },
                  ],
                  price: 25715,
                  addon_combinations: [
                    { group_id: "47702054", addon_id: "33690541" },
                    { group_id: "47702054", addon_id: "33690542" },
                    { group_id: "47702054", addon_id: "33690543" },
                    { group_id: "47702055", addon_id: "33690544" },
                    { group_id: "47702055", addon_id: "33690545" },
                    { group_id: "47702055", addon_id: "33690546" },
                    { group_id: "47702056", addon_id: "33690547" },
                    { group_id: "47702056", addon_id: "33690548" },
                    { group_id: "47702056", addon_id: "33690549" },
                    { group_id: "47702056", addon_id: "33690550" },
                    { group_id: "47702056", addon_id: "33690551" },
                    { group_id: "47702056", addon_id: "33690552" },
                    { group_id: "47702056", addon_id: "33690553" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491973", variation_id: "55173281" },
                  ],
                  price: 33334,
                  addon_combinations: [
                    { group_id: "47702054", addon_id: "33690541" },
                    { group_id: "47702054", addon_id: "33690542" },
                    { group_id: "47702054", addon_id: "33690543" },
                    { group_id: "47702055", addon_id: "33690544" },
                    { group_id: "47702055", addon_id: "33690545" },
                    { group_id: "47702055", addon_id: "33690546" },
                    { group_id: "47702056", addon_id: "33690547" },
                    { group_id: "47702056", addon_id: "33690548" },
                    { group_id: "47702056", addon_id: "33690549" },
                    { group_id: "47702056", addon_id: "33690550" },
                    { group_id: "47702056", addon_id: "33690551" },
                    { group_id: "47702056", addon_id: "33690552" },
                    { group_id: "47702056", addon_id: "33690553" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47702054,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690541,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690543,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690542,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47702055,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690545,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690544,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690546,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47702056,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690547,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690550,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690549,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690552,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690548,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690551,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690553,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 25715,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930740": {
            id: 35930740,
            name: "The Hotty Prawn Burger",
            category: "Burger",
            description:
              "A spicy killer! a truffles burger with an oriental twist serving size: gms energy per 100 gms: kcal contains: egg, gluten, crustacean",
            cloudinaryImageId: "1fde539b0cdb8170200e3a844250770a",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491974",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55173219",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491974",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55173218",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491974",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491974", variation_id: "55173219" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "47701938", addon_id: "33690399" },
                    { group_id: "47701938", addon_id: "33690400" },
                    { group_id: "47701938", addon_id: "33690401" },
                    { group_id: "47701939", addon_id: "33690402" },
                    { group_id: "47701939", addon_id: "33690403" },
                    { group_id: "47701939", addon_id: "33690404" },
                    { group_id: "47701940", addon_id: "33690405" },
                    { group_id: "47701940", addon_id: "33690407" },
                    { group_id: "47701940", addon_id: "33690410" },
                    { group_id: "47701940", addon_id: "33690413" },
                    { group_id: "47701940", addon_id: "33690414" },
                    { group_id: "47701940", addon_id: "33690415" },
                    { group_id: "47701940", addon_id: "33690416" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491974", variation_id: "55173218" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47701938", addon_id: "33690399" },
                    { group_id: "47701938", addon_id: "33690400" },
                    { group_id: "47701938", addon_id: "33690401" },
                    { group_id: "47701939", addon_id: "33690402" },
                    { group_id: "47701939", addon_id: "33690403" },
                    { group_id: "47701939", addon_id: "33690404" },
                    { group_id: "47701940", addon_id: "33690405" },
                    { group_id: "47701940", addon_id: "33690407" },
                    { group_id: "47701940", addon_id: "33690410" },
                    { group_id: "47701940", addon_id: "33690413" },
                    { group_id: "47701940", addon_id: "33690414" },
                    { group_id: "47701940", addon_id: "33690415" },
                    { group_id: "47701940", addon_id: "33690416" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701938,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690401,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690400,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690399,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701939,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690402,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690404,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690403,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701940,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690413,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690415,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690414,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690405,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690416,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690407,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690410,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 27620,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930741": {
            id: 35930741,
            name: "The Truffles Rooster",
            category: "Burger",
            description:
              "Our signature burger with a char grilled chicken patty slapped with herb minced chicken. Served with lettuce, tomatoes and chopped onions serving size: 260gms energy per 100 gms: 230. 63kcal contains: egg, gluten, milk, sulphite",
            cloudinaryImageId: "nkaezqzzoptz7glutuuj",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491975",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55173235",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491975",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55173237",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491975",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491975", variation_id: "55173235" },
                  ],
                  price: 19048,
                  addon_combinations: [
                    { group_id: "47702037", addon_id: "33690520" },
                    { group_id: "47702037", addon_id: "33690521" },
                    { group_id: "47702037", addon_id: "33690522" },
                    { group_id: "47702040", addon_id: "33690523" },
                    { group_id: "47702040", addon_id: "33690524" },
                    { group_id: "47702040", addon_id: "33690525" },
                    { group_id: "47702042", addon_id: "33690526" },
                    { group_id: "47702042", addon_id: "33690527" },
                    { group_id: "47702042", addon_id: "33690528" },
                    { group_id: "47702042", addon_id: "33690529" },
                    { group_id: "47702042", addon_id: "33690530" },
                    { group_id: "47702042", addon_id: "33690531" },
                    { group_id: "47702042", addon_id: "33690532" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491975", variation_id: "55173237" },
                  ],
                  price: 27620,
                  addon_combinations: [
                    { group_id: "47702037", addon_id: "33690520" },
                    { group_id: "47702037", addon_id: "33690521" },
                    { group_id: "47702037", addon_id: "33690522" },
                    { group_id: "47702040", addon_id: "33690523" },
                    { group_id: "47702040", addon_id: "33690524" },
                    { group_id: "47702040", addon_id: "33690525" },
                    { group_id: "47702042", addon_id: "33690526" },
                    { group_id: "47702042", addon_id: "33690527" },
                    { group_id: "47702042", addon_id: "33690528" },
                    { group_id: "47702042", addon_id: "33690529" },
                    { group_id: "47702042", addon_id: "33690530" },
                    { group_id: "47702042", addon_id: "33690531" },
                    { group_id: "47702042", addon_id: "33690532" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47702037,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33690522,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690521,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690520,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47702040,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33690523,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690525,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690524,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47702042,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33690527,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690530,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690526,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690529,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690532,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690528,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33690531,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19048,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930743": {
            id: 35930743,
            name: "Chicken Steak Burger Bbq",
            category: "Burger",
            description:
              "Grilled chicken steak with bbq sauce, served with chopped onions & tomatoes serving size: 190gms energy per 100 gms: 241. 94kcal contains: egg, gluten, soy",
            cloudinaryImageId: "kujxlvsd7pvqqerumwdz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491977",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172424",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491977",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172425",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491977",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491977", variation_id: "55172424" },
                  ],
                  price: 17620,
                  addon_combinations: [
                    { group_id: "47701010", addon_id: "33689495" },
                    { group_id: "47701010", addon_id: "33689496" },
                    { group_id: "47701010", addon_id: "33689497" },
                    { group_id: "47701012", addon_id: "33689498" },
                    { group_id: "47701012", addon_id: "33689499" },
                    { group_id: "47701012", addon_id: "33689500" },
                    { group_id: "47701013", addon_id: "33689501" },
                    { group_id: "47701013", addon_id: "33689502" },
                    { group_id: "47701013", addon_id: "33689503" },
                    { group_id: "47701013", addon_id: "33689504" },
                    { group_id: "47701013", addon_id: "33689505" },
                    { group_id: "47701013", addon_id: "33689506" },
                    { group_id: "47701013", addon_id: "33689507" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491977", variation_id: "55172425" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701010", addon_id: "33689495" },
                    { group_id: "47701010", addon_id: "33689496" },
                    { group_id: "47701010", addon_id: "33689497" },
                    { group_id: "47701012", addon_id: "33689498" },
                    { group_id: "47701012", addon_id: "33689499" },
                    { group_id: "47701012", addon_id: "33689500" },
                    { group_id: "47701013", addon_id: "33689501" },
                    { group_id: "47701013", addon_id: "33689502" },
                    { group_id: "47701013", addon_id: "33689503" },
                    { group_id: "47701013", addon_id: "33689504" },
                    { group_id: "47701013", addon_id: "33689505" },
                    { group_id: "47701013", addon_id: "33689506" },
                    { group_id: "47701013", addon_id: "33689507" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701010,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689497,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689496,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689495,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701012,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689500,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689499,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689498,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701013,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689501,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689507,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689506,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689505,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689504,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689503,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689502,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 17620,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930765": {
            id: 35930765,
            name: "Chicken Steak Burger Mush",
            category: "Burger",
            description:
              "Grilled chicken steak with mushroom sauce, onion & tomato serving size: 190gms energy per 100 gms: 241. 94kcal contains: milk, gluten, soy",
            cloudinaryImageId: "kujxlvsd7pvqqerumwdz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491983",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172438",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491983",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172437",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491983",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491983", variation_id: "55172438" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701015", addon_id: "33689508" },
                    { group_id: "47701015", addon_id: "33689509" },
                    { group_id: "47701015", addon_id: "33689510" },
                    { group_id: "47701017", addon_id: "33689511" },
                    { group_id: "47701017", addon_id: "33689512" },
                    { group_id: "47701017", addon_id: "33689513" },
                    { group_id: "47701018", addon_id: "33689514" },
                    { group_id: "47701018", addon_id: "33689515" },
                    { group_id: "47701018", addon_id: "33689516" },
                    { group_id: "47701018", addon_id: "33689517" },
                    { group_id: "47701018", addon_id: "33689518" },
                    { group_id: "47701018", addon_id: "33689519" },
                    { group_id: "47701018", addon_id: "33689520" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491983", variation_id: "55172437" },
                  ],
                  price: 17620,
                  addon_combinations: [
                    { group_id: "47701015", addon_id: "33689508" },
                    { group_id: "47701015", addon_id: "33689509" },
                    { group_id: "47701015", addon_id: "33689510" },
                    { group_id: "47701017", addon_id: "33689511" },
                    { group_id: "47701017", addon_id: "33689512" },
                    { group_id: "47701017", addon_id: "33689513" },
                    { group_id: "47701018", addon_id: "33689514" },
                    { group_id: "47701018", addon_id: "33689515" },
                    { group_id: "47701018", addon_id: "33689516" },
                    { group_id: "47701018", addon_id: "33689517" },
                    { group_id: "47701018", addon_id: "33689518" },
                    { group_id: "47701018", addon_id: "33689519" },
                    { group_id: "47701018", addon_id: "33689520" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701015,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689509,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689508,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689510,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701017,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689512,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689511,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689513,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701018,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689519,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689518,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689517,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689520,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689516,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689515,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689514,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 30477,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930766": {
            id: 35930766,
            name: "Chicken Steak Burger Pepper",
            category: "Burger",
            description:
              "Grilled chicken steak with pepper sauce, onion & tomato serving size: 190gms energy per 100 gms: 241. 94kcal contains: milk, gluten, soy",
            cloudinaryImageId: "kujxlvsd7pvqqerumwdz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491984",
                  name: "Size",
                  variations: [
                    {
                      name: "Reg",
                      price: 0,
                      default: 1,
                      id: "55172455",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491984",
                      order: 100,
                    },
                    {
                      name: "XL",
                      price: 0,
                      default: 0,
                      id: "55172456",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "3491984",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491984", variation_id: "55172455" },
                  ],
                  price: 17620,
                  addon_combinations: [
                    { group_id: "47701023", addon_id: "33689525" },
                    { group_id: "47701023", addon_id: "33689526" },
                    { group_id: "47701023", addon_id: "33689527" },
                    { group_id: "47701024", addon_id: "33689528" },
                    { group_id: "47701024", addon_id: "33689529" },
                    { group_id: "47701024", addon_id: "33689530" },
                    { group_id: "47701026", addon_id: "33689531" },
                    { group_id: "47701026", addon_id: "33689532" },
                    { group_id: "47701026", addon_id: "33689533" },
                    { group_id: "47701026", addon_id: "33689534" },
                    { group_id: "47701026", addon_id: "33689535" },
                    { group_id: "47701026", addon_id: "33689536" },
                    { group_id: "47701026", addon_id: "33689537" },
                  ],
                },
                {
                  variations: [
                    { group_id: "3491984", variation_id: "55172456" },
                  ],
                  price: 30477,
                  addon_combinations: [
                    { group_id: "47701023", addon_id: "33689525" },
                    { group_id: "47701023", addon_id: "33689526" },
                    { group_id: "47701023", addon_id: "33689527" },
                    { group_id: "47701024", addon_id: "33689528" },
                    { group_id: "47701024", addon_id: "33689529" },
                    { group_id: "47701024", addon_id: "33689530" },
                    { group_id: "47701026", addon_id: "33689531" },
                    { group_id: "47701026", addon_id: "33689532" },
                    { group_id: "47701026", addon_id: "33689533" },
                    { group_id: "47701026", addon_id: "33689534" },
                    { group_id: "47701026", addon_id: "33689535" },
                    { group_id: "47701026", addon_id: "33689536" },
                    { group_id: "47701026", addon_id: "33689537" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 47701023,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 33689527,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689526,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689525,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 47701024,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 33689530,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689529,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689528,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 47701026,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 33689534,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689533,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689532,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689531,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689537,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689536,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 33689535,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 17620,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930768": {
            id: 35930768,
            name: "Chocolate Mousse Cake",
            category: "Desserts",
            description:
              "Serving size: 135gms energy per 100 gms: 348. 9kcal contains: milk, gluten",
            cloudinaryImageId: "xauvmnburrgnovvjgfsr",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930771": {
            id: 35930771,
            name: "White Hazelnut Bomb",
            category: "Desserts",
            description:
              "Serving size: 115gms energy per 100 gms: 316. 65kcal contains: milk, gluten, nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930775": {
            id: 35930775,
            name: "Red Velvet Sundae",
            category: "Desserts",
            description:
              "Red velvet pastry, strawberry syrup, icecream and topped with whipped cream serving size: 300gms energy per 100 gms: 258. 34kcal contains: milk, egg, gluten",
            cloudinaryImageId: "svuxyuzryeogdjo3syf6",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21910,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930777": {
            id: 35930777,
            name: "Dutch Truffle 1 Pc Eggless",
            category: "Desserts",
            description:
              "Dark chocolate pastry serving size: 195gms energy per 100 gms: 305. 4kcal contains: milk, gluten",
            cloudinaryImageId: "zm83jqsnd1jtxyavvihz",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930780": {
            id: 35930780,
            name: "Orange Peach Meringue",
            category: "Desserts",
            description:
              "Serving size: 165gms energy per 100 gms: 284. 82kcal contains: milk, gluten, egg, nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930782": {
            id: 35930782,
            name: "Ferrero Rocher Fudge Sundae",
            category: "Desserts",
            description:
              "Ferrero rocher pastry, icecream, chocolate sauce topped with whipped cream and a ferrero rocher chocolate for good measure serving size: 310gms energy per 100 gms: 308. 51kcal contains: nuts, milk, gluten, egg",
            cloudinaryImageId: "f0ilzw8ri8spapkxlxqu",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22858,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930783": {
            id: 35930783,
            name: "Brownie Fudge Sundae",
            category: "Desserts",
            description:
              "Walnut cappuccino brownie, chocolate sauce, heaps of icecream. Topped with whipped cream serving size: 250gms energy per 100 gms: 330. 81kcal contains: nuts, milk, gluten, egg",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21910,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930785": {
            id: 35930785,
            name: "Apple Fudge Sundae",
            category: "Desserts",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21910,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930786": {
            id: 35930786,
            name: "Kit Kat Sundae",
            category: "Desserts",
            description:
              "Kitkat pastry, icecream, chocolate sauce topped with whipped cream and a kitkat piece serving size: 260gms energy per 100 gms: 327. 96kcal contains: milk, egg, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21910,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930789": {
            id: 35930789,
            name: "Ferrero Rocher Pcs",
            category: "Desserts",
            description:
              "Classic ferrero rocher taste in a rich pastry serving size: 107gms energy per 100 gms: 304. 85kcal contains: milk, nuts, gluten",
            cloudinaryImageId: "wtshad1dpyp8pv6wvtrw",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13810,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930792": {
            id: 35930792,
            name: "Death By Chocolate Cake",
            category: "Desserts",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930793": {
            id: 35930793,
            name: "Lemon Cheesecake",
            category: "Desserts",
            description:
              "A lemon flavoured cheesecake topped with lemon curd in a bottle serving size: 125gms energy per 100 gms: 322. 39kcal contains: milk, gluten, egg",
            cloudinaryImageId: "dxjknc8w1uqc0kqlt7lp",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930794": {
            id: 35930794,
            name: "Kit Kat Cake Eggless",
            category: "Desserts",
            description:
              "All time favourite! serving size: 115gms energy per 100 gms: 291. 55kcal contains: milk, gluten",
            cloudinaryImageId: "zujprnbjiovzyqlr59kf",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930795": {
            id: 35930795,
            name: "Bulls Eye Eggless",
            category: "Desserts",
            description:
              "Chocolate and hazenut serving size: 105gms energy per 100 gms: 288. 82kcal contains: milk, gluten, nuts",
            cloudinaryImageId: "f3yvlowutxzamjfw3es0",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930796": {
            id: 35930796,
            name: "Tiramisu With Jar",
            category: "Desserts",
            description:
              "Italy in a jar! serving size: 110gms energy per 100 gms: 319. 08kcal contains: milk, gluten, egg",
            cloudinaryImageId: "fktvl1vwojey6lao8fwx",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930797": {
            id: 35930797,
            name: "Friazo Milano",
            category: "Beverages",
            description:
              "Orange meets espresso in this rare cold coffee serving size: 320gms energy per 100 gms: 146. 17kcal contains: milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930798": {
            id: 35930798,
            name: "Frozen Hazelnut",
            category: "Beverages",
            description:
              "Cold coffee with a hazelnut twist serving size: 325gms energy per 100 gms: 144. 85kcal contains: milk, nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930799": {
            id: 35930799,
            name: "Brownie Point",
            category: "Beverages",
            description:
              "Serving size: 395gms energy per 100 gms: 173. 37kcal contains: nuts, milk, gluten & expresso",
            cloudinaryImageId: "la1xmchdjlzxcd6z47m6",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930800": {
            id: 35930800,
            name: "Black Currant Granita (400ml)",
            category: "Beverages",
            description:
              "Crushed ice slushie with black currant syrup and a touch of lime jiuce serving size: 385gms energy per 100 gms: 77. 84kcal",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930801": {
            id: 35930801,
            name: "Oreo Shake (400ml)",
            category: "Beverages",
            description:
              "Oreo blended with icecream, whipped cream & expresso serving size: 360gms energy per 100 gms: 196. 99kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930802": {
            id: 35930802,
            name: "Green Apple Granita (400ml)",
            category: "Beverages",
            description:
              "Crushed ice slushie with green apple syrup and a touch of lime jiuce serving size: 415gms energy per 100 gms: 57. 72kcal",
            cloudinaryImageId: "pj27hljms0wwoa3ghcr6",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930803": {
            id: 35930803,
            name: "Iced Tea (400ml)",
            category: "Beverages",
            description:
              "Refreshing complement to our food! serving size: 400gms energy per 100 gms: 52. 04kcal",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491985",
                  name: "Flavour",
                  variations: [
                    {
                      name: "Lemon",
                      price: 0,
                      default: 1,
                      id: "55172027",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491985",
                      order: 100,
                    },
                    {
                      name: "Peach",
                      price: 0,
                      default: 0,
                      id: "55172028",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491985",
                      order: 99,
                    },
                    {
                      name: "Passion Fruit",
                      price: 0,
                      default: 0,
                      id: "55172029",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491985",
                      order: 98,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491985", variation_id: "55172027" },
                  ],
                  price: 12858,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491985", variation_id: "55172028" },
                  ],
                  price: 12858,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491985", variation_id: "55172029" },
                  ],
                  price: 12858,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 12858,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930805": {
            id: 35930805,
            name: "Blue Curacao Granita (400ml)",
            category: "Beverages",
            description:
              "Crushed ice slushie with blue curacao syrup and a touch of lime juice serving size: 380gms energy per 100 gms: 51. 24kcal",
            cloudinaryImageId: "ma5sigyw3eblgqv44orf",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930806": {
            id: 35930806,
            name: "Lime Granita (400ml)",
            category: "Beverages",
            description:
              "Crushed ice slushie with lime syrup and a touch of lime jiuce serving size: 395gms energy per 100 gms: 77. 72kcal",
            cloudinaryImageId: "wvtopx0bizqnqsz4300x",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930807": {
            id: 35930807,
            name: "Peanut Butter & Nutella Shake (400ml)",
            category: "Beverages",
            description:
              "Truffle original! peanut butter, nutella, vanilla and chocolate icecream serving size: 355gms energy per 100 gms: 239. 12kcal contains: nuts, milk, soy",
            cloudinaryImageId: "rwxkmw98tnp2raou485a",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17144,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930808": {
            id: 35930808,
            name: "Very Berry Blast (400ml)",
            category: "Beverages",
            description:
              "Strawberry and blueberry crush blended with vanilla icecream serving size: 335gms energy per 100 gms: 57. 28kcal contains: milk",
            cloudinaryImageId: "cvpukjdmlshptsrb6lrv",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17144,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930809": {
            id: 35930809,
            name: "Blueberry Shake (400ml)",
            category: "Beverages",
            description:
              "Blueberry crush with icecream serving size: 345gms energy per 100 gms: 145. 47kcal contains: milk",
            cloudinaryImageId: "ftjb9g8r3biu9551rjyn",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16668,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930810": {
            id: 35930810,
            name: "Irish Coffee Shake (400ml)",
            category: "Beverages",
            description:
              "Irish cream blended with our cold coffee recipe. A must try! serving size: 325gms energy per 100 gms: 143. 78kcal contains: milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930811": {
            id: 35930811,
            name: "Mocha Iced Berg Shake (400ml)",
            category: "Beverages",
            description:
              "Chocolate twist with our cold coffee serving size: 375gms energy per 100 gms: 155. 52kcal contains: milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930812": {
            id: 35930812,
            name: "Ferrero Rocher Shake (400ml)",
            category: "Beverages",
            description:
              "Serving size: 355 energy per 100 gms: 200. 47kcal contains: milk, nuts, gluten & expresso",
            cloudinaryImageId: "h3qmadfqvyoegqj4oqsp",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930813": {
            id: 35930813,
            name: "Friazzo Biscotti",
            category: "Beverages",
            description:
              "Italian icecream based cold coffee with crushed cookies serving size: 345gms energy per 100 gms: 132. 72kcal contains: milk, nuts, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930815": {
            id: 35930815,
            name: "Strawberry Granita (400ml)",
            category: "Beverages",
            description:
              "Crushed ice slushie with strawberry syrup and a touch of lime jiuce serving size: 365gms energy per 100 gms: 44kcal",
            cloudinaryImageId: "tcuku1bmraddz4w90asg",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12381,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930816": {
            id: 35930816,
            name: "Very Vanilla",
            category: "Beverages",
            description:
              "Vanilla at its purest serving size: 375gms energy per 100 gms: 135. 46kcal contains: milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930817": {
            id: 35930817,
            name: "Iced Latte Shake (400ml)",
            category: "Beverages",
            description:
              "Best selling cold coffee serving size: 315gms energy per 100 gms: 134. 68kcal contains: milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930818": {
            id: 35930818,
            name: "Choc Mocha",
            category: "Beverages",
            description:
              "Chocolate icecream blend with chocolate sauce serving size: 340gms energy per 100 gms: 177. 78kcal contains: milk",
            cloudinaryImageId: "vnuhhhyivylf9wz7em6s",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930819": {
            id: 35930819,
            name: "Frozen Mango (400ml)",
            category: "Beverages",
            description:
              "Mango crush with vanilla icecream serving size: 370gms energy per 100 gms: 164. 94kcal contains: milk",
            cloudinaryImageId: "imjdn1nebcunr9wqe4kt",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930820": {
            id: 35930820,
            name: "Frozen Strawberry (400ml)",
            category: "Beverages",
            description:
              "Strawberry crush with vanilla icecream. Must try! serving size: 365gms energy per 100 gms: 64. 8kcal contains: milk",
            cloudinaryImageId: "kwyqfjjp3dufeuooq2ex",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930823": {
            id: 35930823,
            name: "Kiwi Margarita (400ml)",
            category: "Beverages",
            description: "Serving size: 410gms energy per 100 gms: 56. 28kcal",
            cloudinaryImageId: "e6bc0imbatkfyejykh00",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930824": {
            id: 35930824,
            name: "Rainbow Granita (400ml)",
            category: "Beverages",
            description:
              "Crushed ice slushie with choice of two falvours and a touch of lime jiuce serving size: 415gms energy per 100 gms: 67. 76kcal",
            cloudinaryImageId: "w9ppusntqpacvqaybmwy",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930825": {
            id: 35930825,
            name: "Mango Margarita (400ml)",
            category: "Beverages",
            description: "Serving size: 430gms energy per 100 gms: 65. 48kcal",
            cloudinaryImageId: "d7ppoadtikfg1v0qre1w",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930826": {
            id: 35930826,
            name: "Mojito (400ml)",
            category: "Beverages",
            description:
              "Fizzy beverage with a mint and lime twist serving size: 350gms energy per 100 gms: 67. 8kcal",
            cloudinaryImageId: "mfjfq9zfifxigoqym3qm",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "3491986",
                  name: "Flavour",
                  variations: [
                    {
                      name: "Orange",
                      price: 0,
                      default: 1,
                      id: "55172620",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491986",
                      order: 100,
                    },
                    {
                      name: "Passion Fruit",
                      price: 0,
                      default: 0,
                      id: "55172621",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491986",
                      order: 99,
                    },
                    {
                      name: "Raspberry",
                      price: 0,
                      default: 0,
                      id: "55172622",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491986",
                      order: 98,
                    },
                    {
                      name: "Green Apple",
                      price: 0,
                      default: 0,
                      id: "55172623",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491986",
                      order: 97,
                    },
                    {
                      name: "Strawberry",
                      price: 0,
                      default: 0,
                      id: "55172624",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491986",
                      order: 96,
                    },
                    {
                      name: "Classic",
                      price: 0,
                      default: 0,
                      id: "55172625",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491986",
                      order: 95,
                    },
                    {
                      name: "Watermelon",
                      price: 0,
                      default: 0,
                      id: "55172626",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "3491986",
                      order: 94,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "3491986", variation_id: "55172620" },
                  ],
                  price: 14286,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491986", variation_id: "55172621" },
                  ],
                  price: 14286,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491986", variation_id: "55172622" },
                  ],
                  price: 14286,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491986", variation_id: "55172623" },
                  ],
                  price: 14286,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491986", variation_id: "55172624" },
                  ],
                  price: 14286,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491986", variation_id: "55172625" },
                  ],
                  price: 14286,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "3491986", variation_id: "55172626" },
                  ],
                  price: 14286,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 14286,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930827": {
            id: 35930827,
            name: "Chocolate Truffle [1/2 Kg]",
            category: "Full Cakes",
            description: "",
            cloudinaryImageId: "iyeg6yehdeomyemxirdh",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 57143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930829": {
            id: 35930829,
            name: "Dutch Truffle Cake 1/2 Kg",
            category: "Full Cakes",
            description: "",
            cloudinaryImageId: "qd37cehccndoptpatumd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 61905,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930830": {
            id: 35930830,
            name: "Masala Omelette Box (Egg)",
            category: "Breakfast",
            description:
              "Served with chicken sausage, sprouts salad, baked beans & toast",
            cloudinaryImageId: "dtcp4wfnevt0pusyf8ib",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930832": {
            id: 35930832,
            name: "Bulls Eye (Egg)",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "e6frfavgcdpzch3xmgcf",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930833": {
            id: 35930833,
            name: "Frittata(egg)",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "c7nt9khfxs7lsjmqhzb5",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930834": {
            id: 35930834,
            name: "Spinach Corn & Cheese Sandwich Box",
            category: "Breakfast",
            description:
              "Served with sauteed mushroom, baked beans & couscous salad",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930835": {
            id: 35930835,
            name: "Poached Egg",
            category: "Breakfast",
            description:
              "Served on toast with chicken cold cut, baked beans & grilled tomato",
            cloudinaryImageId: "j0hql0t1wkkwvywpcvl1",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930837": {
            id: 35930837,
            name: "Egg Scrambled Box",
            category: "Breakfast",
            description:
              "Served with chicken sausage, baked beans, toast & fruit salad",
            cloudinaryImageId: "dofo7vxtbnvljoyetvln",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930838": {
            id: 35930838,
            name: "Mac & Cheese Sandwich",
            category: "Breakfast",
            description: "",
            cloudinaryImageId: "u6kbuwx6oe0ndchhzqzw",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930839": {
            id: 35930839,
            name: "Whole Wheat Pita Veg",
            category: "Breakfast",
            description:
              "Our signature whole wheat pita stuffed with peri peri paneer, onion, tomato salad drizzled with house dressing. Served with sauteed vegetables, couscous salad & fresh fruit salad",
            cloudinaryImageId: "u6kdyyct7wtcelphsvce",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18571,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "35930841": {
            id: 35930841,
            name: "Whole Wheat Pita Non-veg",
            category: "Breakfast",
            description:
              "Our signature whole wheat pita stuffed with peri peri chicken and onion, tomato salad in house dressing. Served with chicken sausage, baked beans & fresh fruit salad",
            cloudinaryImageId: "drc09hhssfdr9dwroqyk",
            recommended: 1,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21429,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953671": {
            id: 41953671,
            name: "4 Cheese Pizza [6 inch]",
            category: "Pizza",
            description:
              "Seasoned white sauce, bocconcini, scamorza, ricotta, grana padano, basil and reduced vinegar",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18572,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937938,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937939,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953672": {
            id: 41953672,
            name: "Mushroom & Spinach Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, sauteed spinach, sauteed button mushrooms, red onions, bocconcini, black & green olives, quartered & grana padano and basil",
            cloudinaryImageId: "meozilwst2pp5pptnbgw",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937944,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937945,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953673": {
            id: 41953673,
            name: "Chicken Tikka Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, chicken tikka, bocconcini, spring onion and coriander",
            cloudinaryImageId: "j7wuuhuzsez8qxlvxwpf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19524,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937924,
                group_name: "Non Veg Toppings",
                choices: [
                  {
                    id: 61950942,
                    name: "Hot Dog",
                    price: 7619,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950941,
                    name: "Chicken Meatball",
                    price: 9524,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937925,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 76937926,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953674": {
            id: 41953674,
            name: "Bbq Chicken Pizza [6 inch]",
            category: "Pizza",
            description:
              "Bbq sauce, roast chicken, bocconcini, spring onion and coriander",
            cloudinaryImageId: "wrc06rqvbn1fvfbf9xcy",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19048,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937921,
                group_name: "Non Veg Toppings",
                choices: [
                  {
                    id: 61950942,
                    name: "Hot Dog",
                    price: 7619,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950941,
                    name: "Chicken Meatball",
                    price: 9524,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937922,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 76937923,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953675": {
            id: 41953675,
            name: "Fries & Chicken Sausage Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, dry mozzarella, fries, tossed with peri-peri seasoning, chicken sausage, bocconcini, sprinkle salt, masala powder, reduced balsamic vinegar and oregano seasoning",
            cloudinaryImageId: "hxi0szz1q8pwuqjb45ko",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937927,
                group_name: "Non Veg Toppings",
                choices: [
                  {
                    id: 61950942,
                    name: "Hot Dog",
                    price: 7619,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950941,
                    name: "Chicken Meatball",
                    price: 9524,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937928,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 76937929,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953676": {
            id: 41953676,
            name: "Chicken Meatball Pizza [6 inch]",
            category: "Pizza",
            description:
              "White sauce, onion jam, chicken meatballs, bocconcini, garlic, spring onion, coriander, sliced paprika, tapped with aioli and reduced balsamic vinegar",
            cloudinaryImageId: "icj9ijd3uy3fmjsz12cl",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19524,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937933,
                group_name: "Non Veg Toppings",
                choices: [
                  {
                    id: 61950942,
                    name: "Hot Dog",
                    price: 7619,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950941,
                    name: "Chicken Meatball",
                    price: 9524,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937934,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 76937935,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953681": {
            id: 41953681,
            name: "Margarita Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, bocconcini, basil, drizzled with extra virgin olive oil",
            cloudinaryImageId: "w2brf52bxdtmcdbp8sjw",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12858,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937940,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937941,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953682": {
            id: 41953682,
            name: "Mac & Cheese Pizza [6 inch]",
            category: "Pizza",
            description:
              "White sauce, macaroni, oregano seasoning, mozzarella, bocconcini, finely chopped red and yellow peppers, grana padano, thyme & basil drizzled with extra virgin olive oil",
            cloudinaryImageId: "hfdguwywt44urhjakyxp",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937946,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937947,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953683": {
            id: 41953683,
            name: "Lamb Meatball Pizza [6 inch]",
            category: "Pizza",
            description:
              "White sauce, onion jam, lamb meatballs, bocconcini, ricotta, garlic, spring onion, coriander, sliced paprika, tapped in aioli and reduced balsamic vinegar",
            cloudinaryImageId: "jzrsxvfdn3yeqna46npg",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19524,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937930,
                group_name: "Non Veg Toppings",
                choices: [
                  {
                    id: 61950942,
                    name: "Hot Dog",
                    price: 7619,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950941,
                    name: "Chicken Meatball",
                    price: 9524,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937931,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 76937932,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953684": {
            id: 41953684,
            name: "Paneer Tikka Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, paneer tikka, bocconcini, spring onion and coriander",
            cloudinaryImageId: "m9e1lkec2wrvlry9vviz",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16191,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937942,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937943,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "41953686": {
            id: 41953686,
            name: "3 Pepper & Sweet Corn Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, onion, three peppers, sweet corn, olives, bocconcini and basil",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76937936,
                group_name: "Toppings (Cheese)",
                choices: [
                  {
                    id: 61950949,
                    name: "Grated Mozzerella",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76937937,
                group_name: "Veg Toppings",
                choices: [
                  {
                    id: 61950948,
                    name: "Slice Paprika",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950946,
                    name: "Sauteed Red & Yellow Bell Peppers",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950947,
                    name: "Sauteed Spinach",
                    price: 5714,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950944,
                    name: "Oven Roast Garlic",
                    price: 3810,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950945,
                    name: "Sauteed Mushroom",
                    price: 3810,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950943,
                    name: "Fries Topping",
                    price: 5714,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "42219225": {
            id: 42219225,
            name: "Chicken Hot Dog [Single]",
            category: "Hot Dog",
            description:
              "Classic hot dog! single: 245gms, 270. 49 kcal double: 325gms, 262. 49 kcal contains: gluten, soy, sulphite",
            cloudinaryImageId: "bkgg6xtvzotxwovptsul",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13334,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887945,
                group_name: "Hot Dog Option",
                choices: [
                  {
                    id: 61950950,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887946,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 76887947,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "44572176": {
            id: 44572176,
            name: "Channa Masala Twist",
            category: "Breakfast",
            description:
              "Truffles twist to an original channa masala infused with thai flavour & enriched with spinach served along with pav",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13810,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "44572177": {
            id: 44572177,
            name: "Akuri With Toast",
            category: "Breakfast",
            description:
              "Parsi style scrambled egg served with watermelon & pineapple salad, sprout salad , saute veggies and bread slice",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14286,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "44572182": {
            id: 44572182,
            name: "Paneer Bhurji",
            category: "Breakfast",
            description:
              "Indian masala cottage cheese crumble served with bread slice, watermelon & pineapple salad, saute vegetables",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15715,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 8 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "50998539": {
            id: 50998539,
            name: "Butterscotch 1/2kg",
            category: "Full Cakes",
            description: "",
            cloudinaryImageId: "u8b3hbugrh0jkjhqgime",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 42858,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "56479618": {
            id: 56479618,
            name: "Blueberry Cheesecake Jar Eggless",
            category: "Desserts",
            description:
              "Perfect for your blueberry cravings on the go! serving size: 125gms energy per 100 gms: 312. 7kcal contains: milk, gluten",
            cloudinaryImageId: "ldb6grh1jy56owxn9lxy",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587880": {
            id: 57587880,
            name: "Veg Slider",
            category: "Healthy Twist",
            description:
              "Protein & fibre filled grilled chickpea patty sandwiched in whole wheat mini buns serving size: 280gms energy per 100 gms: 161. 55kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19524,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587886": {
            id: 57587886,
            name: "Sprout & Fruit Salad",
            category: "Healthy Twist",
            description:
              "Nutrient rich salad with sprouts, watermelon & pineapple served with a fruity dressing serving size: 235gms energy per 100 gms: 96. 17kcal",
            cloudinaryImageId: "rxuti87yuvcofgsru5uk",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16691,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587890": {
            id: 57587890,
            name: "Tandoori Paneer Slider",
            category: "Healthy Twist",
            description:
              "Grilled tandoori paneer sandwiched in whole wheat mini buns smeared with a mint yoghurt dip serving size: 285gms energy per 100 gms: 190. 47kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21905,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587901": {
            id: 57587901,
            name: "Grilled Veggies With Couscous",
            category: "Healthy Twist",
            description:
              "Seasoned grilled vegetables served with a portion of couscous serving size: 410gms energy per 100 gms: 97. 52kcal",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587904": {
            id: 57587904,
            name: "Tandoori Chicken Slider",
            category: "Healthy Twist",
            description:
              "Protein loaded tandoori chicken slider in whole wheat mini buns served with a mint yoghurt dressing serving size: 255gms energy per 100 gms: 186. 78kcal contains: milk, nuts, gluten",
            cloudinaryImageId: "dzq9vzllwfm32uhej14b",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22858,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587906": {
            id: 57587906,
            name: "Grilled Chicken Steak Salad",
            category: "Healthy Twist",
            description:
              "A combination of protein & nutrient packed veggies served with fresh salad serving size: 345gms energy per 100 gms: 129. 65kcal",
            cloudinaryImageId: "pkuvsez2f4bjyugf6rdf",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587912": {
            id: 57587912,
            name: "Grilled Chicken With Veggies",
            category: "Healthy Twist",
            description:
              "Served with sautéed vegetables serving size: 330gms energy per 100 gms: 223. 74kcal contains: milk",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57587914": {
            id: 57587914,
            name: "Protein Packed  Chicken Steak",
            category: "Healthy Twist",
            description:
              "Served with roast potatoes, fresh kachumber salad and mint chutney serving size: 290gms energy per 100 gms: 217. 98kcal contains: nuts",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "57638127": {
            id: 57638127,
            name: "Grilled Fish With Veggies",
            category: "Healthy Twist",
            description:
              "Fish fillet cooked to perfection served on a bed of veggies serving size: 345gms energy per 100 gms: 198. 15kcal contains: seafood",
            cloudinaryImageId: "yvd5wfys9agkekqmgvzf",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59037981": {
            id: 59037981,
            name: "Devil's Paneer Rice Bowl",
            category: "Rice Bowl",
            description:
              "Stir fried cottage cheese with coloured bell pepper, jullienned onion, tossed in spicy chilli sauce alongside veg fried rice serving size: 510gms energy per 100 gms: 191. 19kcal contains: milk, gluten, soy, sulphites",
            cloudinaryImageId: "jk9jzcie84xqnrziaehy",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23810,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59037982": {
            id: 59037982,
            name: "Peri Peri Paneer Rice Bowl",
            category: "Rice Bowl",
            description:
              "Cottage cheese marinated and tossed in our in-house fiery peri peri sauce served alongside herb rice serving size: 505gms energy per 100 gms: 211. 46kcal contains: milk, sulphite",
            cloudinaryImageId: "c6tsacf6ul7jcmxa1hic",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23810,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59037983": {
            id: 59037983,
            name: "Butter Paneer Rice Bowl",
            category: "Rice Bowl",
            description:
              "Cubes of cottage cheese cooked in delicious creamy, buttery, tomato, onion gravy infused with selected indian spices served alongside jeera rice serving size: 410gms energy per 100 gms: 230. 06kcal contains: milk, soy",
            cloudinaryImageId: "xyxn1r2oktc60rgkej7b",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23810,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59037984": {
            id: 59037984,
            name: "Peri Peri Chicken Rice Bowl",
            category: "Rice Bowl",
            description:
              "Grilled chicken tossed with our inhouse fiery peri peri sauce served alongside herb rice serving size: 450gms energy per 100 gms: 198. 86kcal contains: milk, sulphite",
            cloudinaryImageId: "cfdfaw5303bbkpte33eg",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59037985": {
            id: 59037985,
            name: "Spicy Chicken Rice Bowl",
            category: "Rice Bowl",
            description:
              "Wholesome meal of truffles' chicken 65 served alongside egg fried rice serving size: 460gms energy per 100 gms: 212. 48kcal contains: gluten, milk, sulphite",
            cloudinaryImageId: "ertoqovqigxdqf0arsit",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59037986": {
            id: 59037986,
            name: "Devil's Chicken Rice Bowl",
            category: "Rice Bowl",
            description:
              "Shredded stir fried chicken tossed in a spicy soya chilli garlic sauce serve along side egg fried rice serving size: 510gms energy per 100 gms: 195. 11kcal contains: gluten, egg, soy",
            cloudinaryImageId: "hmskevvtlc24k2dejryt",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59037987": {
            id: 59037987,
            name: "Butter Chicken Rice Bowl",
            category: "Rice Bowl",
            description:
              "Tender fillet of tandoori chicken cooked in a creamy, buttery tomato gravy flavored with indian spices served alongside jeera rice serving size: 440gms energy per 100 gms: 204. 5kcal contains: milk, soy",
            cloudinaryImageId: "bi4ixdmy9v6brmw6dmec",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "63531614": {
            id: 63531614,
            name: "Dutch Truffle Cake 1kg",
            category: "Full Cakes",
            description: "",
            cloudinaryImageId: "qd37cehccndoptpatumd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 123810,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "66672431": {
            id: 66672431,
            name: "Espresso Tart",
            category: "Desserts",
            description: "",
            cloudinaryImageId: "glq4ctnc0bnkuo6v7vre",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 6191,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "66672432": {
            id: 66672432,
            name: "Salted Caramel Cheesecake",
            category: "Desserts",
            description: "",
            cloudinaryImageId: "ukxtmzvryxyhz5w3p17k",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "71983660": {
            id: 71983660,
            name: "Mayo",
            category: "Add Ons",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 3334,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "73382574": {
            id: 73382574,
            name: "Mutton Kheema Sub [Reg]",
            category: "Submarine",
            description:
              "A spicy aromatic mince of lamb, slow cooked and served in either a reg/ xl sub serving size: 240gms energy per 100 gms: 259. 65kcal contains: egg, gluten",
            cloudinaryImageId: "dopuqzmf8q6qmsfejmaz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887941,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887942,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "73382575": {
            id: 73382575,
            name: "Cheese Burst Lamb Burger [Reg]",
            category: "Burger",
            description:
              "Cheese please! molten cheese poured over our og lamb burger serving size: 250gms energy per 100 gms: 220. 04kcal contains: milk, egg, gluten",
            cloudinaryImageId: "csrwv1g8s5pzyegxymt3",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 23810,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887926,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887927,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
              {
                group_id: 76887928,
                group_name: "6.non Veg Option",
                choices: [
                  {
                    id: 61950924,
                    name: "Chicken Salami",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950925,
                    name: "Sausage",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950922,
                    name: "C Ham",
                    price: 4286,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950923,
                    name: "Jalapenos",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950920,
                    name: "Fried Egg",
                    price: 3333,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950921,
                    name: "Gherkins",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950919,
                    name: "Cheese",
                    price: 3333,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 7,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 98,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "78643912": {
            id: 78643912,
            name: "Peri Peri Dusted Fries",
            category: "Fries & Wedges",
            description:
              "Crispy batter fried fries dusted with peri peri seasoning serving size: 150gms energy per 100 gms: 302. 24kcal contains: gluten, sulphite",
            cloudinaryImageId: "qkjvns0yr9dwhfdqlokw",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14762,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82464819": {
            id: 82464819,
            name: "Butter Paneer Fries",
            category: "Fries & Wedges",
            description:
              "Crispy fries topped with our classic butter paneer serving size: 250gms energy per 100 gms: 256. 63kcal contains: milk, gluten",
            cloudinaryImageId: "h6mexb25omwkhgyym52c",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18572,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82464820": {
            id: 82464820,
            name: "Butter Chicken Fries",
            category: "Fries & Wedges",
            description:
              "Crispy fries topped with our classic butter chicken serving size: 300gms energy per 100 gms: 255. 07kcal contains: milk, gluten",
            cloudinaryImageId: "oqkgcuobbzzrauwo4i7d",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82464821": {
            id: 82464821,
            name: "Fries With Cheesy Sauce",
            category: "Fries & Wedges",
            description:
              "Crispy coated french fries topped with molten cheesy sauce serving size: 250gms energy per 100 gms: 307. 52kcal contains: gluten, soy, milk",
            cloudinaryImageId: "tb2unrovrfuu9pizfmdo",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82464823": {
            id: 82464823,
            name: "Chicken Cheesy Fries",
            category: "Fries & Wedges",
            description:
              "Coated french fries topped with crispy fried chicken and molten cheese serving size: 320gms energy per 100 gms: 273kcal contains: milk, gluten, soy",
            cloudinaryImageId: "yetominjoh8jxrijhlau",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82464827": {
            id: 82464827,
            name: "Tandoori Chicken & Cheese Fries",
            category: "Fries & Wedges",
            description:
              "Fried coated potato fries topped with pan seared tandoori marinated chicken, molten cheese and mint chutney serving size: 300gms energy per 100 gms: 270. 6kcal contains: gluten, milk, soy",
            cloudinaryImageId: "bprdfvkksozsgp494ax7",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82531221": {
            id: 82531221,
            name: "Nutella Cheesecake",
            category: "Desserts",
            description:
              "The perfect union! serving size: 51. 57gms energy per 100 gms: 402. 68kcal contains: milk, egg, gluten",
            cloudinaryImageId: "zjgjcwr2bufcv9hyxddf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "84255069": {
            id: 84255069,
            name: "Nutella Cookie Dough Pie",
            category: "Desserts",
            description:
              "The gooey cookie dough with nutella in the middle will instantly melt in your mouth. Please heat for 15 sec before consumption serving size: 105gms energy per 100 gms: 282. 08kcal contains: milk, gluten",
            cloudinaryImageId: "twplmsuiy3syxkyhqp75",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85092644": {
            id: 85092644,
            name: "Macarons (6pcs)",
            category: "Desserts",
            description:
              "Melt in your mouth meringue base cookies made of egg white sandwiched together with a flavourful cream filling contains: egg, nuts",
            cloudinaryImageId: "ic7hj1ojm4wplge3fsub",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28572,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "87991263": {
            id: 87991263,
            name: "Banoffee Pie",
            category: "Truffles Special",
            description:
              "Buttery tart with a banana caramel filling and topped with rich cream serving size: 105gms energy per 100 gms: 360. 22kcal contains: milk, gluten",
            cloudinaryImageId: "fr7jgrbusm1lmzm7ovhv",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92167610": {
            id: 92167610,
            name: "Baked Mango Yogurt",
            category: "Truffles Special",
            description:
              "Wholesome mango pudding with a rich alphonso jelly serving size: 200gms energy per 100 gms: 305. 13kcal contains: milk",
            cloudinaryImageId: "wltfpsekjlbx7hqymmsh",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19048,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92392167": {
            id: 92392167,
            name: "Mango Tart",
            category: "Truffles Special",
            description:
              "Serving size: 195gms energy per 100 gms: 287. 65kcal contains: gluten",
            cloudinaryImageId: "igpw68pz1jkc1phvvcgt",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241965": {
            id: 94241965,
            name: "Buffalo Fries",
            category: "Fries & Wedges",
            description:
              "French fries served alongside our buffalo sauce serving size: 220gms energy per 100 gms: 289. 84kcal contains: milk, gluten",
            cloudinaryImageId: "uwgueamk76vxmtcozlau",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241966": {
            id: 94241966,
            name: "Chicken Buffalo Fries",
            category: "Fries & Wedges",
            description:
              "Serving size: 300gms energy per 100 gms: 290. 94kcal contains: milk, gluten",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241967": {
            id: 94241967,
            name: "Cblt S/w Toasted",
            category: "Sandwiches",
            description:
              "Chicken bacon, lettuce & tomato contains: gluten, soy",
            cloudinaryImageId: "xlcsnmulzwoudlp8tm9z",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21905,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887935,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887936,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241968": {
            id: 94241968,
            name: "Devil's Chicken Wrap",
            category: "Wraps",
            description:
              "Shredded chicken, tossed in our devil's sauce with lettuce, onions, tomatoes and tangy mayo serving size: 275gms energy per 100 gms: 193. 5kcal contains: gluten, egg, sulphite, soy",
            cloudinaryImageId: "oiphuleateiz0sssutsl",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 76887948,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 61950915,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950913,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950914,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 76887949,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 61950917,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950918,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 61950916,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241969": {
            id: 94241969,
            name: "Fire & Spice With Rice(veg)",
            category: "Oriental",
            description:
              "Mixed exotic veggies stir fried in a spicy soya chilli sauce served with steamed rice serving size: gms energy per 100 gms: kcal contains: soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241970": {
            id: 94241970,
            name: "Mushroom Burger",
            category: "Burger",
            description:
              "Crumb fried patty of slow cooked mushrooms served in between buns serving size: 210gms energy per 100 gms: 250. 21kcal contains: gluten, sulphite, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241971": {
            id: 94241971,
            name: "Spanish Omelette",
            category: "Egg To Order",
            description:
              "Omelette with bell pepper, cabbage & potatoes serving size: 280gms energy per 100 gms: 221. 33kcal contains: egg, gluten, soy",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 10:52 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94241972": {
            id: 94241972,
            name: "Tandoori Chicken S/w",
            category: "Sandwiches",
            description:
              "Sliced breast of tandoori marinated chicken serving size: 235gms energy per 100 gms: 256. 23kcal contains: gluten, egg, sulphite",
            cloudinaryImageId: "f4iduiw6rwsmyvrfjclw",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 53150636,
                group_name: "1.non Veg Sides",
                choices: [
                  {
                    id: 43652645,
                    name: "Bbq Wings (3pcs)",
                    price: 10000,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43652647,
                    name: "Rocky Road Chicken (2 Pcs)",
                    price: 8572,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43652646,
                    name: "Fish Fingers (3 Pcs)",
                    price: 10952,
                    inStock: 0,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 53150637,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 43652649,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43652648,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43652650,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 99,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94248269": {
            id: 94248269,
            name: "Caramelised Onion & Buttered Mushroom Pizza [6 inch]",
            category: "Pizza",
            description:
              "Blanched tomatoes infused with fresh basil, dressed with mozzeralla, sauteed mushroom, onion and roasted garlic",
            cloudinaryImageId: "bwcmjpstogfhpkl8o7hd",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 79425251,
                group_name: "Choice Of Crust",
                choices: [
                  {
                    id: 64176382,
                    name: "Classic Hand Tossed",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 64176383,
                    name: "Thin Crust",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94248270": {
            id: 94248270,
            name: "Cottage Cheese & Bell Pepper Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, cottage cheese, onion, 3 bell peppers, black olives and basil",
            cloudinaryImageId: "iv0chnybgjl1froxdy14",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94248271": {
            id: 94248271,
            name: "Chicken Pepperoni [6 inch]",
            category: "Pizza",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21905,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 53158173,
                group_name: "Choice Of Crust",
                choices: [
                  {
                    id: 43662974,
                    name: "Thin Crust",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43662973,
                    name: "Classic Hand Tossed",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94248272": {
            id: 94248272,
            name: "Spicy Overload Pizza [6 inch]",
            category: "Pizza",
            description:
              "Blanched tomatoes infused with fresh basil, mozzarella, green bell pepper, jalapeno, red paprika & chilliesssss",
            cloudinaryImageId: "pwyqliefsm1oreoexfra",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94248880": {
            id: 94248880,
            name: "Chicken Bacon Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, chicken bacon & mozzarella cheese",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94249343": {
            id: 94249343,
            name: "Meat Feast Pizza [6 inch]",
            category: "Pizza",
            description:
              "Fresh tomato sauce, roast chicken, chicken sausage, chicken bacon drilled with bbq sauce",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21905,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 53159109,
                group_name: "Choice Of Crust",
                choices: [
                  {
                    id: 43663930,
                    name: "Thin Crust",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43663929,
                    name: "Classic Hand Tossed",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94249787": {
            id: 94249787,
            name: "Chicken Mac & Cheese Pizza [6 inch]",
            category: "Pizza",
            description:
              "Molten cheese, mozzarella, macaroni, coloured bell pepper, crispy fried chicken & a hint of buffalo sauce serving size: 450gms energy per 100 gms: 196kcal contains: gluten, milk, soy, sulphite",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 53159188,
                group_name: "Choice Of Crust",
                choices: [
                  {
                    id: 43664029,
                    name: "Classic Hand Tossed",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43664030,
                    name: "Thin Crust",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94253149": {
            id: 94253149,
            name: "Tandoori Paneer S/w",
            category: "Sandwiches",
            description:
              "All time favourite! serving size: gms energy per 100 gms: kcal contains: gluten, milk, soy",
            cloudinaryImageId: "ntq620pragpjanyqcqgv",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15239,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 53160849,
                group_name: "2.veg Sides",
                choices: [
                  {
                    id: 43664795,
                    name: "Spaghetti Cheese Balls (3 Pcs)",
                    price: 8095,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43664793,
                    name: "Fried Mozarella Sticks (3 Pcs)",
                    price: 8172,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43664794,
                    name: "Small Fries",
                    price: 6191,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94314908": {
            id: 94314908,
            name: "Chicken Mac & Cheese",
            category: "Pasta",
            description:
              "Gooey goodness!! macaroni pasta in our ultra creamy cheese an crispy fried chicken serving size: gms energy per 100 gms: kcal contains: milk, soy, gluten",
            cloudinaryImageId: "pxkjwocpc0ltaagzudmq",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25715,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94314909": {
            id: 94314909,
            name: "Cheesy Chicken Fingers",
            category: "Fries & Wedges",
            description:
              "Panko fried chicken fingers topped with cheese & jalapeno serving size: 210gms energy per 100 gms: 256. 51kcal contains: gluten, soy, milk",
            cloudinaryImageId: "fcykg9ag71ufvegehxxs",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27620,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94314910": {
            id: 94314910,
            name: "Chicken Caesar's Salad Wrap",
            category: "Wraps",
            description:
              "Our classic chicken caesar's salad, now wrapped up for your convenience serving size: 235gms energy per 100 gms: 224. 32kcal contains: gluten, milk, soy",
            cloudinaryImageId: "mtcrwwlqqxy8rthuvnno",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16667,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94314912": {
            id: 94314912,
            name: "Tandoori Paneer Sub",
            category: "Submarine",
            description:
              "With onions, gherkins, jalapenos serving size: 250gms energy per 100 gms: 366. 31kcal contains: gluten, sulphite",
            cloudinaryImageId: "egnzojgthemg2vxcejgk",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "16244868",
                  name: "Size",
                  variations: [
                    {
                      name: "XL",
                      price: 0,
                      default: 1,
                      id: "55172611",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "16244868",
                      order: 100,
                    },
                    {
                      name: "Reg",
                      price: 0,
                      default: 0,
                      id: "55172610",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "16244868",
                      order: 99,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "16244868", variation_id: "55172611" },
                  ],
                  price: 19524,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "16244868", variation_id: "55172610" },
                  ],
                  price: 13334,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            defaultPrice: 19524,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94600071": {
            id: 94600071,
            name: "Fish In Lemon Cream Sauce",
            category: "Maincourse",
            description:
              "Fish pan seared and tossed in our creamy lemon butter sauce served with herb rice serving size: gms energy per 100 gms: kcal contains: seafood, milk, gluten",
            cloudinaryImageId: "skka9paln1rcag82zlbz",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 35239,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 53630149,
                group_name: "Maincourse Add Ons",
                choices: [
                  {
                    id: 43948082,
                    name: "Mash Potato",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 43948083,
                    name: "Vegetables",
                    price: 3809,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94913987": {
            id: 94913987,
            name: "Tandoori Chicken Salad",
            category: "Salad",
            description:
              "Tandoori chicken strips, iceberg lettuce, coloured bell pepper & onion tossed in a mint aoili dressing serving size: 215gms energy per 100 gms: 177. 84kcal contains: nuts, sulphite",
            cloudinaryImageId: "kwoo7iaw9yujhtlj5lb3",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21905,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94917138": {
            id: 94917138,
            name: "Devilled Eggs",
            category: "Starters",
            description:
              "A spicy soy based dish with batter fried eggs tossed with onion, garlic and bell pepper serving size: 320gms energy per 100 gms: 191. 15kcal contains: egg, soy, gluten",
            cloudinaryImageId: "vnl8rhqkgtiywngwkf41",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "95105795": {
            id: 95105795,
            name: "Tres Leches",
            category: "Truffles Special",
            description:
              "Dense cake soaked in a mixture of sweetened condensed milk, evaporated milk and cream. ",
            cloudinaryImageId: "mfwvs2dgchxfmwrcrtie",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19048,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "95563649": {
            id: 95563649,
            name: "Chicken Cheesy Mex Fries",
            category: "Fries & Wedges",
            description:
              "Chicken strips and fries topped with our medium spicy mexican sauce contains: milk, soy, gluten",
            cloudinaryImageId: "hdeklz5rqndi3r8cfx2b",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20953,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98126794": {
            id: 98126794,
            name: "Electric Fizz",
            category: "Beverages",
            description:
              "Green apple soda with mango bobas and nata de coco serving size: 335gms energy per 100 gms: 51. 72kcal",
            cloudinaryImageId: "ggl0kdbnxog50rsrwlog",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98126795": {
            id: 98126795,
            name: "Caffeine Overload",
            category: "Beverages",
            description:
              "Classic cold coffee with coffee bobas serving size: 325gms energy per 100 gms: 63. 44kcal",
            cloudinaryImageId: "jyoy9ndhdozbpxi1hxgk",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98126796": {
            id: 98126796,
            name: "Purple Blast",
            category: "Beverages",
            description:
              "Black currant beverage with lemon bobas and nata de coco serving size: 365gms energy per 100 gms: 51. 96kcal",
            cloudinaryImageId: "buoivwhncztxh00xu3gb",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98126797": {
            id: 98126797,
            name: "Sour Twist",
            category: "Beverages",
            description:
              "Lemon iced tea with green apple bobas and nata de coco serving size: 355gms energy per 100 gms: 50. 92kcal",
            cloudinaryImageId: "tkxgsbmmh6hiitx2ntuf",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18096,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "105117744": {
            id: 105117744,
            name: "Veg Baked Chocolate Cheese Cake",
            category: "Truffles Special",
            description: "",
            cloudinaryImageId: "o60mffeegreg7m67tr6w",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "106496052": {
            id: 106496052,
            name: "Veg Baked Strawberry Cheese Cake",
            category: "Truffles Special",
            description: "",
            cloudinaryImageId: "f3983cba961443288b857fd10d912c88",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17143,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110725601": {
            id: 110725601,
            name: "Mushy Berry Mousse",
            category: "Truffles Special",
            description:
              "A tempting strawberry and white chocolate fudge delicacy",
            cloudinaryImageId: "ba6474ab301926d175518e68a4e0d9b3",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "223",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 110725601,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 105117744,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 106496052,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 87991263,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 92167610,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 92392167,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 95105795,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 1814978,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930741,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930731,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545301,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545312,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545299,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545273,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545277,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545265,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 5935757,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953674,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953673,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953675,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953683,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953676,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953681,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953684,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953672,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 41953682,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930213,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930547,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 42219225,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930802,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930808,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930809,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930818,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930819,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930820,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930807,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930799,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930812,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930823,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930825,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930826,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545249,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930238,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545224,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930541,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 545437,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930827,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930829,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 63531614,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 2847191,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 85092644,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 1814981,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 8157576,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930782,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930775,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 56479618,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930793,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 1814968,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 8157514,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 1814956,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930777,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930796,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 66672432,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 82531221,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 84255069,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 35930789,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Truffles Special",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 110725601,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 105117744,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 106496052,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 87991263,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92167610,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92392167,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 95105795,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 1814978,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fries & Wedges",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 82464823,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 82464827,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 95563649,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 82464820,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94241966,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94314909,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 82464821,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 78643912,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 82464819,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94241965,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545237,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545230,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107023,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Burger",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 5773769,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930741,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930738,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930739,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545297,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 2847156,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930740,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930743,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930765,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930766,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930735,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930731,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 73382575,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 3489734,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930730,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545330,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545326,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545301,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545312,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545299,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 2847162,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 2847158,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 2847160,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930733,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 5107030,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930734,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545269,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545273,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94241970,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545277,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545281,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545285,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545265,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5935757,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107031,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107032,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Pizza",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 41953674,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953673,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953675,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953683,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953676,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94248880,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94249343,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94248271,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94249787,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 41953686,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953671,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953681,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953684,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953672,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94248272,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 41953682,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94248270,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94248269,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Sandwiches",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930209,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930215,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930212,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930205,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930204,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930213,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930217,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94241967,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94241972,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930214,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930216,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930208,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930206,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930210,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930218,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94253149,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Submarine",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 545361,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545357,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545362,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545359,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930547,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545355,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 73382574,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930546,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930548,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930552,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 545350,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94314912,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Hot Dog",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 42219225,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 545381,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Wraps",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 94241968,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930449,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545385,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930440,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107112,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 94314910,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 545383,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545382,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107109,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107115,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Beverages",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Granita",
                type: "subcategory",
                entities: [
                  {
                    id: 35930800,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930805,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930802,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930806,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930824,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930815,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Frappe",
                type: "subcategory",
                entities: [
                  {
                    id: 35930808,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930809,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930818,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930819,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930820,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930807,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930816,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Bubble Tea",
                type: "subcategory",
                entities: [
                  {
                    id: 98126797,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 98126794,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 98126796,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 98126795,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Cold Coffee",
                type: "subcategory",
                entities: [
                  {
                    id: 35930799,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930812,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930797,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930813,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930798,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930817,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930810,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930811,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930801,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Iced Tea",
                type: "subcategory",
                entities: [
                  {
                    id: 35930803,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930823,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930825,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Mojito",
                type: "subcategory",
                entities: [
                  {
                    id: 35930826,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Starters",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930219,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94917138,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930561,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930243,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 3489722,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107029,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545251,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545249,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545248,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930244,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930240,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545257,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545258,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930245,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1624955,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1624956,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930220,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545253,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930246,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107026,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930221,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930248,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930247,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545241,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930242,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107024,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107027,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930239,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545233,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930238,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930567,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Salad",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 94913987,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545224,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930253,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930346,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930254,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930252,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930283,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930313,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930365,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930381,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930330,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930251,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Pasta",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930542,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94314908,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930541,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930536,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930534,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930533,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930540,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930528,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5773781,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930537,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930545,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930543,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930544,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 545435,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930492,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930532,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930538,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930519,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930476,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930482,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930535,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930501,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930539,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rice Bowl",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 59037987,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 59037986,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 59037985,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 59037984,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 59037983,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 59037982,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 59037981,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Pav",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 35930586,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Maincourse",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Sea Food",
                type: "subcategory",
                entities: [
                  {
                    id: 545473,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 94600071,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930562,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930570,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545471,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545472,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930560,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Lamb",
                type: "subcategory",
                entities: [
                  {
                    id: 35930563,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545464,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545463,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Chicken",
                type: "subcategory",
                entities: [
                  {
                    id: 545442,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545459,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545440,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545461,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1624968,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545438,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545456,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930556,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545451,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1624967,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930558,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930566,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545448,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930557,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545437,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930568,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545428,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107148,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930559,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545433,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 5107147,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930564,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 545430,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930569,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Oriental",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930573,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930575,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930583,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930572,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930582,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930574,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930578,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930577,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930581,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930580,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930579,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930584,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 94241969,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930576,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930585,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Healthy Twist",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non Veg Sliders",
                type: "subcategory",
                entities: [
                  {
                    id: 57587904,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg Maincourse",
                type: "subcategory",
                entities: [
                  {
                    id: 57587901,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non Veg Maincourse",
                type: "subcategory",
                entities: [
                  {
                    id: 57587914,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 57587912,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 57638127,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg Sliders",
                type: "subcategory",
                entities: [
                  {
                    id: 57587880,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 57587890,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg Salads",
                type: "subcategory",
                entities: [
                  {
                    id: 57587886,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Keto Salads",
                type: "subcategory",
                entities: [
                  {
                    id: 57587906,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Add Ons",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 71983660,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Full Cakes",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 35930827,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 35930829,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 50998539,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 63531614,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 2847191,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Desserts",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Truffles Special",
                type: "subcategory",
                entities: [
                  {
                    id: 66672431,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 85092644,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1814985,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1814983,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1814986,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1814981,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 8157516,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Sundaes",
                type: "subcategory",
                entities: [
                  {
                    id: 8157576,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930785,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930783,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930782,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930786,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930775,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Cheesecake",
                type: "subcategory",
                entities: [
                  {
                    id: 2847193,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 56479618,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930793,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Cakes",
                type: "subcategory",
                entities: [
                  {
                    id: 35930792,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1814968,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930795,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 8157514,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930768,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 1814956,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930777,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930794,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930780,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 3489816,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930796,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930771,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 66672432,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 82531221,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 84255069,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930789,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Breakfast",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930833,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930832,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930830,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930841,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930835,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930837,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 44572177,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 35930838,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930839,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 35930834,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 44572176,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 44572182,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Egg To Order",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 94241971,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "menu_merchandise",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "20% OFF UPTO ₹50",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["e5abb0bb-d48e-461d-990a-88be7df159db"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE TRYNEW",
          description: "ABOVE ₹159",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 2,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11215334000294"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [{ text: "", imageId: "", fontColor: "" }],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "56362101-3702-4b24-aec0-1238c2d0f852",
      timeStamp: "1677489255334",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "wOcb9rb0Btle-jaZ_jPszHRQBs2zAsvYLQsxHX7Y",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "5934",
      bgColor: "#000000",
      logo: "rng/md/carousel/production/pkcgpsd4df6i5ud3eyuk",
      textColor: "#ffffff",
      name: "Burger King",
      uuid: "ac56f2ac-71d3-4978-9513-b3aa68e25463",
      slug: "burger-king-koramangala",
      latLong: "12.9352346,77.61327819999997",
      city: "Bangalore",
      area: "Koramangala",
      areaPostalCode: "560034",
      areaSlug: "koramangala",
      restaurantSlug: {
        restaurant: "burger-king-koramangala",
        city: "bangalore",
      },
      type: "F",
      locality: "7th Block",
      avgRating: 4.2,
      totalRatings: 1000,
      avgRatingString: "4.2",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "jpohkfkofao0hxez7vdh",
      costForTwo: 35000,
      costForTwoMsg: "₹350 for two",
      cuisines: ["Burgers", "American"],
      minimumOrder: 0,
      opened: 1,
      parentId: 166,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "23 MINS",
        lastMileDistanceString: "1.4 kms",
        restaurantId: "5934",
        deliveryTime: 23,
        minDeliveryTime: 23,
        maxDeliveryTime: 23,
        lastMileTravel: 1.4,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.7055980563163757,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 1,
      },
      availability: {
        nextCloseTime: "2023-02-28 05:00:00",
        nextChangeTime: 1677540600000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "Unit No. 1, Davar Atrium, Corporation No. 118, Koramangala Industrial Area 7th Block, Bangalore 560095",
        },
        { title: "Cuisines", message: "Burgers,American" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "98833607": {
            id: 98833607,
            name: "Chicken Fries - 5pc",
            category: "Sides & Beverage",
            description: "",
            cloudinaryImageId: "uxsw6rpennkcz6dddzb0",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "101198059": {
            id: 101198059,
            name: "Chicken Makhani Burst Burger",
            category: "Burger and Wrap.",
            description:
              "Enjoy rich makhani flavour with crispy chicken patty topped with fresh onion",
            cloudinaryImageId: "ajxjn6rht9vc8aplkvbw",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "101198097": {
            id: 101198097,
            name: "Tikki Twist Burger",
            category: "Burger and Wrap.",
            description:
              "Tikki bhi, Twist bhi! Our new signature burger with spicy sauce, onion, mix veg patty & a crunchy twist!",
            cloudinaryImageId: "mkrn3yyqufgqr7xc6i1n",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "101198101": {
            id: 101198101,
            name: "Veg Makhani Burst Burger",
            category: "Burger and Wrap.",
            description:
              "Enjoy rich makhani flavour with mix veg patty topped up with fresh onion",
            cloudinaryImageId: "rnljd0ea2zwgfbhkzwwh",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "101999767": {
            id: 101999767,
            name: "Veggie Strips - 5 Pcs",
            category: "Sides & Beverage",
            description: "Vegetarian's favourite finger food.",
            cloudinaryImageId: "jez2tqz2d0euumrrpvbn",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898938": {
            id: 108898938,
            name: "Crispy Veg Burger",
            category: "Burger and Wrap.",
            description:
              "Our best-selling burger with crispy veg patty, fresh onion and our signature sauce",
            cloudinaryImageId: "eqaon8guufklmil7ayhr",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898939": {
            id: 108898939,
            name: "Crispy Veg Double Patty Burger",
            category: "Burger and Wrap.",
            description:
              "Our best-selling burger with crispy veg Double patty, fresh onion and our signature sauce",
            cloudinaryImageId: "phm3t2g7v0lpczvtu6g7",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898940": {
            id: 108898940,
            name: "Crispy Veg Double Patty with Cheese",
            category: "Burger and Wrap.",
            description:
              "Our best-selling burger with crispy veg Double patty, Cheese slice, fresh onion and our signature sauce.",
            cloudinaryImageId: "ndp3akjkdainthdpugjp",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898941": {
            id: 108898941,
            name: "Crispy Veg with Cheese Burger",
            category: "Burger and Wrap.",
            description:
              "Our best-selling burger withcrispy veg patty, Cheese slice, fresh onion and our signature sauce.",
            cloudinaryImageId: "wr3o7gmsgcuf1x4zwcax",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898943": {
            id: 108898943,
            name: "BK Classic Veg Burger",
            category: "Burger and Wrap.",
            description:
              "Our tribute to classic american taste. BK veg patty, garden fresh crispy lettuce, juicy tomato(seasonal) & our signature sauce.",
            cloudinaryImageId: "uvfehwtz2fceyrtfjsoc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898944": {
            id: 108898944,
            name: "Bk Classic Veg with cheese",
            category: "Burger and Wrap.",
            description:
              "Our tribute to classic american taste. BK veg patty, garden fresh crispy lettuce, juicy tomato(seasonal), Cheese slice & our signature sauce.",
            cloudinaryImageId: "kgveyxjx6emnbque00xe",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14400,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898946": {
            id: 108898946,
            name: "Classic Veg Double Patty Burger",
            category: "Burger and Wrap.",
            description:
              "Our tribute to classic american taste. BK veg Double patty, garden fresh crispy lettuce, juicy tomato(seasonal) & our signature sauce.",
            cloudinaryImageId: "iajmq3xmw6cg13easydh",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898948": {
            id: 108898948,
            name: "Crispy Chicken Burger",
            category: "Burger and Wrap.",
            description:
              "Our best-selling burger with crispy chicken patty, onion and classic mayo sauce.",
            cloudinaryImageId: "mqr237klqgnu0w2pzd94",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898950": {
            id: 108898950,
            name: "Crispy Chicken Double Patty Burger",
            category: "Burger and Wrap.",
            description:
              "Our best-selling burger with crispy chicken patty, onion and classic mayo sauce.",
            cloudinaryImageId: "vfagr7gcirgouhiewq66",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898951": {
            id: 108898951,
            name: "Crispy Chicken with Cheese Burger",
            category: "Burger and Wrap.",
            description:
              "Our best-selling burger with crispy chicken patty, onion and classic mayo sauce.",
            cloudinaryImageId: "ieec9d9wdbunnpe98vun",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898952": {
            id: 108898952,
            name: "BK Classic Chicken Burger",
            category: "Burger and Wrap.",
            description:
              "Our tribute to classic american taste. BK chicken patty, garden fresh crispy lettuce, juicy tomato(seasonal) & our signature sauce.",
            cloudinaryImageId: "zo2ukigdl7xu15zkf4ml",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898953": {
            id: 108898953,
            name: "Tikki Twist Double Patty Burger",
            category: "Burger and Wrap.",
            description:
              "Tikki bhi, Twist bhi! Our new signature burger with spicy sauce, onion, mix veg double patty & a crunchy twist!",
            cloudinaryImageId: "yel6bfft4q4bux7kj2vw",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9500,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898954": {
            id: 108898954,
            name: "Veg Makhani Burst Double Patty Burger",
            category: "Burger and Wrap.",
            description:
              "Enjoy rich makhani flavour with mix veg double patty topped up with fresh onion",
            cloudinaryImageId: "izbi1dlua0sc3xmnpc3z",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898955": {
            id: 108898955,
            name: "Crispy Veg Wrap",
            category: "Burger and Wrap.",
            description:
              "Our crispy veg patty, topped with salad mix, our signature sauce wrapped in a grilled paratha",
            cloudinaryImageId: "hzuobdsfliv8vrrr2bef",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898957": {
            id: 108898957,
            name: "Chicken Makhani Burst Double Patty Burger",
            category: "Burger and Wrap.",
            description:
              "Enjoy rich makhani flavour with crispy chicken double patty topped with fresh onion",
            cloudinaryImageId: "rokqcyhjuovu0eysmjmu",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898963": {
            id: 108898963,
            name: "King Fries",
            category: "Sides & Beverage",
            description: "The perfect crispy partner.",
            cloudinaryImageId: "uttwq3j7gos3thsaposd",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898964": {
            id: 108898964,
            name: "Medium Peri Peri Fries",
            category: "Sides & Beverage",
            description: "Crispy fries with peri peri spice. Hot indeed",
            cloudinaryImageId: "mgipyyoulmma7rjwofoj",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13400,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108898965": {
            id: 108898965,
            name: "Hashbrown",
            category: "Sides & Beverage",
            description: "What every potato wants to be.",
            cloudinaryImageId: "acabmj60n7dctjg9un5q",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108899988": {
            id: 108899988,
            name: "Veg Crunchy Taco",
            category: "Burger and Wrap.",
            description:
              "Be ready for a crunchy, saucy, explosion. A crunchy volcano shell filled with beans & veg mix, chef's secret sauce, fresh onion & crisp lettuce.",
            cloudinaryImageId: "ljhtdtkkjocyjmczu994",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "109342037": {
            id: 109342037,
            name: "Whopper Jr Veg",
            category: "Burger and Wrap.",
            description:
              "Our signature Whopper with 7 layers between the buns in a convenient size. Extra crunchy veg Patty, fresh onion, crispy lettuce, juicy tomatoes(seasonal), tangy gherkins, creamy and smoky sauces.",
            cloudinaryImageId: "m3gjpg0hyws00wdkfncw",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "109731708": {
            id: 109731708,
            name: "Crispy Chicken Wrap",
            category: "Burger and Wrap.",
            description:
              "Wrap loaded with crispy chicken patty, crunchy onions and tangy sauce",
            cloudinaryImageId: "eef3cb854a765b20879d155db3933d6d",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "109731709": {
            id: 109731709,
            name: "Crunchy Chicken Taco",
            category: "Burger and Wrap.",
            description: "",
            cloudinaryImageId: "kzekifdu0vakjkebcxml",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 11000,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "109811239": {
            id: 109811239,
            name: "Pepsi Black Medium",
            category: "Sides & Beverage",
            description: "Pepsi Black",
            cloudinaryImageId: "f8320b1b518af3ccb404687e2e185e58",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842530": {
            id: 110842530,
            name: "Double Crispy Veg + Double Crispy Veg.",
            category: "Rs 129 Deal Of The Day",
            description: "crispy veg patty burger, our best seller! !",
            cloudinaryImageId: "n3xekdsgny6jdboxy4xw",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842532": {
            id: 110842532,
            name: "Veg Whopper.",
            category: "Rs 129 Deal Of The Day",
            description: "Our signature veg patty Whopper.",
            cloudinaryImageId: "sgnlylsa7gqijo2qydq3",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842534": {
            id: 110842534,
            name: "Crispy Chicken + Med Fries.",
            category: "Rs 129 Deal Of The Day",
            description: "Crispy Chicken patty burger with fries on the side.",
            cloudinaryImageId: "tx9dno3ojm5efz9ldwnm",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842536": {
            id: 110842536,
            name: "Chicken Whopper.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Our signature Whopper with 7 layers between the buns. Flame Grilled chicken Patty, fresh onion, crispy lettuce, juicy tomatoes(seasonal), tangy gherkins, creamy and smoky sauces with xxl buns. It’s Not A Burger, it’s a Whopper.",
            cloudinaryImageId: "xbcxtblwjmlj36kqkzjo",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842538": {
            id: 110842538,
            name: "Crispy Veg + Crispy Chicken.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Our best sellers - crispy veg patty burger and crispy chicken patty burger.",
            cloudinaryImageId: "vdvl37f0zttykfxrcweh",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842540": {
            id: 110842540,
            name: "Crispy Chicken + Crispy Chicken.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Crispy Chicken patty burger, our best seller. Enjoy Twice.",
            cloudinaryImageId: "kqxbihqpeimd5cxpinfn",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842541": {
            id: 110842541,
            name: "1Crispy Veg Double Patty + 1Med Fries.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Double up the crispy veg patty burger in our best selling burger with fries on the side",
            cloudinaryImageId: "slf6cyeqaixjqih3tm9j",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842544": {
            id: 110842544,
            name: "BK Classic Chicken + King Egg Burger.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Garden fresh chicken patty classic burger + egg patty burger",
            cloudinaryImageId: "hiumdo2s1atmic2cjqci",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842546": {
            id: 110842546,
            name: "Whopper Jr Veg+ Crispy Veg.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Our signature veg whopper in a smaller size + Crispy veg patty  burger",
            cloudinaryImageId: "mdf9cluo0plx8xtwbkhi",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842548": {
            id: 110842548,
            name: "2 Med Fries.",
            category: "Rs 129 Deal Of The Day",
            description: "The perfect crispy partner.",
            cloudinaryImageId: "vhhodglyalty92qtkobl",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842551": {
            id: 110842551,
            name: "Mango Shake.",
            category: "Rs 129 Deal Of The Day",
            description: "Our signature mango thick shake.",
            cloudinaryImageId: "e5fk28ospzzsy5a7m7hc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842553": {
            id: 110842553,
            name: "Chocolate Shake.",
            category: "Rs 129 Deal Of The Day",
            description: "Our signature chocolate thick shake.",
            cloudinaryImageId: "iixakii4wvkq3dgmpsvc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842554": {
            id: 110842554,
            name: "Boneless Wings Regular.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "qlpzsgwyrjwzd3g43iol",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842555": {
            id: 110842555,
            name: "Veg Makhani Burst Burger+ Medium Peri Peri Fries.",
            category: "Rs 129 Deal Of The Day",
            description: "Veg Makhani Burst Burger+ Medium Peri Peri Fries",
            cloudinaryImageId: "sn8nuhvffvflrb9pf5e1",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842559": {
            id: 110842559,
            name: "Chicken Makhani Burst Burger + Chicken Fries.",
            category: "Rs 129 Deal Of The Day",
            description: "Chicken Makhani Burst Burger + Chicken Fries",
            cloudinaryImageId: "bakdcemusy59zhnfsa4u",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842561": {
            id: 110842561,
            name: "King Egg Double Patty Burger + King Egg Double Patty Burger.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "q54u9yakbnyan9gwrf8f",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842563": {
            id: 110842563,
            name: "King Egg + Medium Fries.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "ca1e01fb0bd4a936468813b3157f0a78",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18500,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842565": {
            id: 110842565,
            name: "King Egg + Chicken Fries - 5Pcs.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "02a5cf58d7c2faa4ef1069133be13ccf",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842567": {
            id: 110842567,
            name: "Veggie Strips - 5Pcs + Choco Lava Cup.",
            category: "Rs 129 Deal Of The Day",
            description: "Veggie Strips - 5Pcs + Choco Lava Cup",
            cloudinaryImageId: "ixpymop2wkfiyiyj0ers",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842568": {
            id: 110842568,
            name: "Veggie Strips - 5Pcs + Chocolate Mousse Cup.",
            category: "Rs 129 Deal Of The Day",
            description: "Veggie Strips - 5Pcs + Chocolate Mousse cup",
            cloudinaryImageId: "pexbywbbp16gclzzfcog",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15800,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842569": {
            id: 110842569,
            name: "Cappuccino (S)+ Hashbrown.",
            category: "Rs 129 Deal Of The Day",
            description: "Cappuccino (S)+ Hashbrown",
            cloudinaryImageId: "vfcad3yhueluwpumfjix",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19800,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842573": {
            id: 110842573,
            name: "Classic Cold Coffee.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Our signature BK Café Coffee ice blended with milk & cream",
            cloudinaryImageId: "spupzyvwrsv4yjegs4gf",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842575": {
            id: 110842575,
            name: "BK Classic Veg Burger+Crispy Veg Burger.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "fa43c54f7dc66a9dac383948c30b3e33",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842577": {
            id: 110842577,
            name: "Choco Berry Shake.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "tetj5z7fy1r0rbdkj3ub",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842579": {
            id: 110842579,
            name: "Classic Veg + Veg Volcano.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "03f41a2ee9baf1e8f935ac3765993d3b",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842584": {
            id: 110842584,
            name: "Crispy Veg Burger+Med Fries.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "00b61e58b68eff61bf2f75a64625022f",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842585": {
            id: 110842585,
            name: "Crispy Veg Double Patty Burger+Veg Crunchy Taco.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "4f995277a0c990d41b542538a07b949a",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16500,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842586": {
            id: 110842586,
            name: "Tikki Twist Burger + Med Fries.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "00b61e58b68eff61bf2f75a64625022f",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842588": {
            id: 110842588,
            name: "Whopper Jr Chicken with Cheese Burger.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "3508a3fc00f82f05e64be380e04597b0",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19400,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110842589": {
            id: 110842589,
            name: "Whopper Jr Veg with Cheese Burger.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "6fbac1a74fc40652e9b8d88d944d74a2",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17400,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "111360812": {
            id: 111360812,
            name: "BK Chicken Burger + King Egg Burger.",
            category: "Rs 129 Deal Of The Day",
            description:
              "Garden fresh chicken patty classic burger + egg patty burger",
            cloudinaryImageId: "hiumdo2s1atmic2cjqci",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "111360813": {
            id: 111360813,
            name: "BK Veggie Burger + Crispy Veg Burger.",
            category: "Rs 129 Deal Of The Day",
            description: "",
            cloudinaryImageId: "fa43c54f7dc66a9dac383948c30b3e33",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            final_price: 12900,
            variants_new: {},
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "5934",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "",
                subTitle: "",
                textColor: "",
                backGroundColor: "",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 108898948,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rs 129 Deal Of The Day",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 110842544,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 111360812,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842569,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842577,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842575,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 111360813,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842530,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842532,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842534,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842536,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842538,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842540,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842541,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842546,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842548,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842551,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842553,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842554,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842555,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842559,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842561,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842563,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842565,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842567,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842568,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842573,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842586,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842589,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842579,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842588,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842584,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 110842585,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Burger and Wrap.",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 108898938,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898939,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898940,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898941,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898943,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898944,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898946,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 109342037,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898948,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898950,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898951,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898952,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 101198097,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898953,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 101198101,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898954,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898955,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108899988,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 101198059,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898957,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 109731708,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 109731709,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Sides & Beverage",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 98833607,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898963,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898964,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 101999767,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 108898965,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 109811239,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "menu_merchandise",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "Get every item under 129",
        shortDescriptionList: [
          {
            meta: "Get every item under 129",
            discountType: "FinalPrice",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "Get every item under 129",
            discountType: "FinalPrice",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "EVERY ITEM @ ₹129",
          offer_tag: "DEAL OF DAY",
          offer_logo: "offers/deal-of-day",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["6efadcd4-f55e-4264-949b-7a48639e9ed2"],
            type: "offers",
          },
          expiry_time: 47655000,
          coupon_code: "",
          description: "",
          secondary_discount_callout: "",
          show_expiry_timer: true,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "Get every item under 129",
        shortDescriptionList: [
          {
            meta: "Get every item under 129",
            discountType: "FinalPrice",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "Get every item under 129",
            discountType: "FinalPrice",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 62,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11220334001415"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [{ text: "", imageId: "", fontColor: "" }],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "2cb5aaa7-1020-44f0-8543-e83814469cd2",
      timeStamp: "1677489285467",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "O9e7gBfMT8R2-F6sXGNkf4G2Q0sQtkPoC5mlmUMo",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "410683",
      bgColor: "#ffffff",
      logo: "v1659437233/Brand logo/Soul_Rasa",
      textColor: "#000000",
      name: "Soul Rasa",
      uuid: "5fddc67b-5287-45a0-a252-c34eb9b290d1",
      slug: "hb-koramangala-koramangala",
      latLong: "12.925114189248,77.637063302099",
      city: "Bangalore",
      area: "Koramangala",
      areaPostalCode: "560034",
      areaSlug: "koramangala",
      restaurantSlug: {
        restaurant: "hb-koramangala-koramangala",
        city: "bangalore",
      },
      type: "F",
      locality: "Jakkasandra",
      avgRating: 4.4,
      totalRatings: 1000,
      avgRatingString: "4.4",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "xoth5ysuv2r6ctizaso5",
      costForTwo: 40000,
      costForTwoMsg: "₹400 for two",
      cuisines: ["Indian", "Healthy Food"],
      minimumOrder: 0,
      opened: 1,
      parentId: 239281,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "29 MINS",
        lastMileDistanceString: "2.4 kms",
        restaurantId: "410683",
        deliveryTime: 29,
        minDeliveryTime: 29,
        maxDeliveryTime: 29,
        lastMileTravel: 2.4,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.5760260820388794,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 1,
      },
      availability: {
        nextCloseTime: "2023-02-27 23:30:00",
        nextChangeTime: 1677520800000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "88/1,Ward No.66, Sajjapura Road, Madiwala, Jakkasandra Village Bangalore-South, 560034",
        },
        { title: "Cuisines", message: "Indian,Healthy Food" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "77097411": {
            id: 77097411,
            name: "Paneer Shimlamirch with Gajar Matar & Masoor Dal",
            category: "Welcome to Soul Rasa!! Try our Bestsellers",
            description:
              "Paneer chunks in a tomato-onion curry, accompanied with carrot-peas sabzi and whole masoor dal. A simple, yet wholesome meal served with your choice of grain or 3 chapati. Indulgence for one. Contains milk & wheat (Palak Chapati). Energy : 287.85 Kcal.",
            cloudinaryImageId: "5eefd223f07512c340af9e47f0ca1c98",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 25900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78441731,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441730,
                group_name: "Desserts",
                choices: [
                  {
                    id: 62188010,
                    name: "Ragi Coconut Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188011,
                    name: "Til & Jaggery Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188012,
                    name: "Moong Dal and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                  {
                    id: 62188013,
                    name: "Pumpkin and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441729,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78441732,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441733,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "77097418": {
            id: 77097418,
            name: "Moong Dal and Jaggery Halwa",
            category: "Guilt-Free Desserts",
            description:
              "Our take on the classic moong dal halwa; lighter and sweetened with the jaggery. Satisfy your sugar cravings, guilt-free! Contains milk & nut. Energy : 280.2 Kcal.",
            cloudinaryImageId: "59871196e130bf9d0ae61b4376f031c0",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "77097419": {
            id: 77097419,
            name: "Pumpkin and Jaggery Halwa",
            category: "Guilt-Free Desserts",
            description:
              "A classic pumpkin halwa sweetened with jaggery and garnished with dry fruits. End your meal on a sweet note! Contains milk & nut. Energy : 133.02 Kcal.",
            cloudinaryImageId: "8c94b4c3e1201c2ca8c7ffe54b366a03",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "77097427": {
            id: 77097427,
            name: "The Grain Free plate",
            category: "Make Your Own Plate",
            description:
              "Twice the goodness and zero grain! Make your own grain-free plate with double the protein and veggies by choosing from the options below. For food allergens and energy values, kindly look at the respective product on the menu.",
            cloudinaryImageId: "261a85a2ed9e58ffae2e797d19bfcf44",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149347,
                group_name: "Choose Your Protein",
                choices: [
                  {
                    id: 62188170,
                    name: "Chatpata Sprouts",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188171,
                    name: "Anda Masala",
                    price: 4900,
                    inStock: 1,
                    isVeg: 0,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188172,
                    name: "Paneer Shimlamirch",
                    price: 4900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188173,
                    name: "Palak Murgh",
                    price: 10900,
                    inStock: 1,
                    isVeg: 0,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188174,
                    name: "Palak-Coated Soya Chaap",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                  {
                    id: 62188175,
                    name: "Yam Kala Chana",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                  {
                    id: 62188176,
                    name: "Roasted Broccoli & Gobi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 94,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149348,
                group_name: "Choose your Sabzi",
                choices: [
                  {
                    id: 62188177,
                    name: "Beetroot Poriyal",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188178,
                    name: "Turai Chana dal",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188179,
                    name: "Kaddu Ki Sabzi",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188180,
                    name: "Gajar Matar",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188181,
                    name: "Methi Shakkarkand",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149346,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149349,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "78072194": {
            id: 78072194,
            name: "Buttermilk",
            category: "Beverages",
            description:
              "Beat the summer heat with our refreshing and tasty buttermilk . I am sure you would love it! Contains milk. Energy : 87 Kcal.",
            cloudinaryImageId: "7ed231c68ef39b990bd05d436131a5f8",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440819": {
            id: 81440819,
            name: "Turai Chana dal",
            category: "Mains - A la Carte",
            description:
              "Turai (ridge gourd) cooked in a tadka of jeera, mustard and turmeric along with slightly crunchy channa dal. A delicious side! Energy : 143.6 Kcal.",
            cloudinaryImageId: "fc0cd7a1eb9981024b8f9b6fad6f57d2",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149350,
                group_name: "Quantity - Turai Chana dal",
                choices: [
                  {
                    id: 62188182,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188183,
                    name: "Serves 2",
                    price: 7900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149354,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149353,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149355,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440820": {
            id: 81440820,
            name: "Chatpata Sprouts",
            category: "Mains - A la Carte",
            description:
              "A medley of crunchy sprouts cooked in a tomato-onion masala: simple and pro! Energy : 153.2 Kcal.",
            cloudinaryImageId: "712d20d101fa89d937db8f637818bc51",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149227,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149224,
                group_name: "Quantity - Chatpata Sprouts",
                choices: [
                  {
                    id: 62188147,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188148,
                    name: "Serves 2",
                    price: 7900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149228,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149229,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440821": {
            id: 81440821,
            name: "Methi Shakkarkand",
            category: "Mains - A la Carte",
            description:
              "Oven roasted sweet potatoes sauteed with fresh methi leaves with jeera, coriander and a few spices - this is a delicious side! Energy : 206.5 Kcal.",
            cloudinaryImageId: "6d6f7359852e1492cdee81839e05aef2",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149288,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149285,
                group_name: "Quantity - Methi Shakkarkand",
                choices: [
                  {
                    id: 62188154,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188155,
                    name: "Serves 2",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149289,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149290,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440822": {
            id: 81440822,
            name: "Roasted Broccoli & Gobi",
            category: "Mains - A la Carte",
            description:
              "Florets of broccoli and cauliflower, oven roasted till tender and topped with a mildly spiced yoghurt and nut gravy. Slightly creamy, packed with goodness! Contains milk & nut. Energy : 144.612 Kcal.",
            cloudinaryImageId: "f9073838f1bd418344af4617c0a0d7f9",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149332,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149333,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149334,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440823": {
            id: 81440823,
            name: "Yam Kala Chana",
            category: "Mains - A la Carte",
            description:
              "Boiled Kala chana and chunks of Yam cooked in a gravy of browned onion and spices. Wholesome and yum! Energy : 175.0 Kcal.",
            cloudinaryImageId: "bf7a7deed05b373b3fb14052e7c22c97",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149359,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149356,
                group_name: "Quantity - Yam Kala Chana",
                choices: [
                  {
                    id: 62188184,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188185,
                    name: "Serves 2",
                    price: 7900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149360,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149361,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440824": {
            id: 81440824,
            name: "Anda Masala",
            category: "Mains - A la Carte",
            description:
              "Hard boiled eggs simmered in a tomato-onion gravy and seasoned with classic spices. Packed with goodness, yum!  Contains egg. Energy : 269.44 Kcal.",
            cloudinaryImageId: "f9e8e783ed7f87bfc59087baf6002fd7",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 12900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149192,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149188,
                group_name: "Quantity - Anda Masala",
                choices: [
                  {
                    id: 62188006,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188007,
                    name: "Serves 2",
                    price: 8900,
                    inStock: 1,
                    isVeg: 0,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149191,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149193,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440832": {
            id: 81440832,
            name: "Kaddu Ki Sabzi",
            category: "Mains - A la Carte",
            description:
              "Chunks of pumpkin oven roasted till tender, tossed in a few spices and topped with a nuty onion gravy. Yum! Energy : 94.6 Kcal.",
            cloudinaryImageId: "b7cde764c0c565ca3e1591c20da8b22e",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149259,
                group_name: "Quantity -Kaddu Ki Sabzi",
                choices: [
                  {
                    id: 62188151,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149262,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149263,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149264,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81440833": {
            id: 81440833,
            name: "Gajar Matar",
            category: "Mains - A la Carte",
            description:
              "A classic for the ages; carrots and peas tossed in a mix of simple spices and oven roasted till tender. Energy : 151.4 Kcal.",
            cloudinaryImageId: "b38abdbd7b23e70cf40c97e4881da5e8",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149256,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149253,
                group_name: "Quantity - Gajar Matar",
                choices: [
                  {
                    id: 62188149,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188150,
                    name: "Serves 2",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149257,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149258,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85940253": {
            id: 85940253,
            name: "Beans Carrot Poriyal",
            category: "Mains - A la Carte",
            description:
              "Dices of carrots and beans cooked in a simple tadka of mustard seeds, curry leaves and fresh coconuts. Simple and comforting! Energy : 162.45 Kcal.",
            cloudinaryImageId: "f4f4785a15931293791513e2cee94935",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149215,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149212,
                group_name: "Quantity - Beans Carrot Poriyal",
                choices: [
                  {
                    id: 62188103,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188104,
                    name: "Serves 2",
                    price: 7900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149216,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149217,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85940255": {
            id: 85940255,
            name: "Palak Murgh",
            category: "Mains - A la Carte",
            description:
              "Chicken pieces tenderly cooked in a delicious gravy of spinach and spices. The perfect duo. Energy : 195.95 Kcal.",
            cloudinaryImageId: "102c51bd32acbbb78b34deb51e4e57ed",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149299,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149298,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149300,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85940256": {
            id: 85940256,
            name: "Palak-Coated Soya Chaap",
            category: "Mains - A la Carte",
            description:
              "Soya chaap chunks cooked in spinach, hung curd and spices make for you to love and enjoy. Contains milk & soy. Energy : 238.48 Kcal.",
            cloudinaryImageId: "1002bd3c1f2d2e538c045409f951a967",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149293,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149294,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149295,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "85940257": {
            id: 85940257,
            name: "Paneer Shimlamirch",
            category: "Mains - A la Carte",
            description:
              "Soft paneer and capsicum chunks cooked in a tomato-onion masala gravy. Simple, yet yum! Contains milk. Energy : 353.5 Kcal.",
            cloudinaryImageId: "630dc0952335fbfac821542ed7967596",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149321,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149322,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149323,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100024": {
            id: 91100024,
            name: "Palak Murgh & Masoor Dal",
            category: "Welcome to Soul Rasa!! Try our Bestsellers",
            description:
              "Chicken chunks in a mildly spiced spinach gravy, alongside whole masoor dal. Relish with your choice of grain or 3 chapatis. A simple and wholesome meal for one. Energy : 168.14 Kcal.",
            cloudinaryImageId: "6814cfbadda5dbd3dccad1a28a4f27c7",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78441727,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441724,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78441726,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441725,
                group_name: "Desserts",
                choices: [
                  {
                    id: 62188010,
                    name: "Ragi Coconut Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188011,
                    name: "Til & Jaggery Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188012,
                    name: "Moong Dal and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                  {
                    id: 62188013,
                    name: "Pumpkin and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441728,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100026": {
            id: 91100026,
            name: "Anda Masala & Masoor Dal",
            category: "Welcome to Soul Rasa!! Try our Bestsellers",
            description:
              "Two boiled eggs in tomato-onion gravy, alongside whole masoor dal. Served with your choice of grain or 3 chapatis. An egg protein-packed plate for one. Contains egg, milk & wheat (Palak Chapati). Energy : 281.4 Kcal.",
            cloudinaryImageId: "22711efb64669db1369b483d2b563f23",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78441720,
                group_name: "Desserts",
                choices: [
                  {
                    id: 62188010,
                    name: "Ragi Coconut Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188011,
                    name: "Til & Jaggery Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188012,
                    name: "Moong Dal and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                  {
                    id: 62188013,
                    name: "Pumpkin and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441719,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78441722,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441721,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78441723,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100029": {
            id: 91100029,
            name: "Masoor Dal Palak",
            category: "Mains - A la Carte",
            description:
              "Whole masoor dal cooked with spinach and a light tadka of jeera and chillies. A perfect side, indeed! Energy : 149.6 Kcal.",
            cloudinaryImageId: "28c8c4c3ae9439eb342c78c994e5f60d",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149278,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149275,
                group_name: "Quantity - Masoor Dal Palak",
                choices: [
                  {
                    id: 62188152,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188153,
                    name: "Serves 2",
                    price: 5900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149279,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149280,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100030": {
            id: 91100030,
            name: "Beetroot Poriyal\n",
            category: "Mains - A la Carte",
            description:
              "Crunchy beetroot cooked in a simple tadka of mustard seeds, curry leaves and coconuts. A refreshing side dish packed with goodness! Energy : 189.7 Kcal.",
            cloudinaryImageId: "e3529d56363e39db36671c778e91916c",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149222,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149218,
                group_name: "Quantity - Beetroot Poriyal",
                choices: [
                  {
                    id: 62188125,
                    name: "Serves 1",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188126,
                    name: "Serves 2",
                    price: 7900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 77149221,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149223,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100031": {
            id: 91100031,
            name: "Brown Rice Pulao",
            category: "Mains - A la Carte",
            description:
              "Aromatic pulao made of brown rice and garnished with fresh coriander and mint. Energy : 356.5 Kcal.",
            cloudinaryImageId: "cd231e5369a7b7d889bbbb87ab6c906a",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100032": {
            id: 91100032,
            name: "Jeera Millets",
            category: "Mains - A la Carte",
            description:
              "Fluffy kodo millet cooked with finely chopped beans, carrots and some whole spices. Wholesome and delicious. Energy : 316.7 Kcal.",
            cloudinaryImageId: "1ec63ccc15df5555d882a9a09021e975",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100033": {
            id: 91100033,
            name: "Ajwaini Chapati (2pcs)",
            category: "Mains - A la Carte",
            description:
              "Whole wheat rotis flavoured with Ajwain or carom seeds. Contains milk & wheat. Energy : 185.1 Kcal.",
            cloudinaryImageId: "cbd761db3bc96cf425404e4932c5d280",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100034": {
            id: 91100034,
            name: "Palak Chapati (2pcs)",
            category: "Mains - A la Carte",
            description:
              "Whole wheat rotis loaded with all the goodness of Palak. Contains milk & wheat. Energy : 180.1 Kcal.",
            cloudinaryImageId: "420deecd3ac87c9ab37038dc727b2b3f",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100035": {
            id: 91100035,
            name: "Whole Wheat Chapati (2pcs)",
            category: "Mains - A la Carte",
            description:
              "Classic rotis made of whole wheat flour. Contains wheat. Energy : 188.7 Kcal.",
            cloudinaryImageId: "ab567b499909d2c7a8eef1806d22b588",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100036": {
            id: 91100036,
            name: "Ragi Coconut Ladoo (3 Pcs)",
            category: "Guilt-Free Desserts",
            description:
              "Nutritious ladoos made of ragi, coconuts, cashewnuts and sweetened with jaggery. Good for your taste buds. Contains milk & nut. Energy : 334.52 Kcal.",
            cloudinaryImageId: "01002182ec08a4115d50ee12ac14c098",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "91100037": {
            id: 91100037,
            name: "Til & Jaggery Ladoo (3 Pcs)",
            category: "Guilt-Free Desserts",
            description:
              "Crunchy sesame seed laddos enriched with jaggery; a guilt-free treat for your sweet tooth! Contains milk & nut. Energy : 403.92 Kcal.",
            cloudinaryImageId: "f25018ead86b134e1515124d27a72e01",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 6900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92640688": {
            id: 92640688,
            name: "Classic Dal & Brown Rice Khichdi",
            category: "Light Plates",
            description:
              "Our take on a classic dal khichdi is made with whole masoor dal & brown rice, and tempered with hing & jeera. Served with Papad & Curd, this is a comforting meal for one. Contains milk. Energy : 312.8 Kcal.",
            cloudinaryImageId: "0343495461cfccd21f6f4a3b70889bd9",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149233,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149231,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149234,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "92640694": {
            id: 92640694,
            name: "Kala Chana & Sprouts Chaat",
            category: "Welcome to Soul Rasa!! Try our Bestsellers",
            description:
              "A mix of steamed Kala channa & sprouts, with onions, tomatoes, chillies tossed with chaat masala and lime. A nutritious & yummy snack! Contains nuts. Energy : 587.52 Kcal.",
            cloudinaryImageId: "16abf2a6e1fa49cf83d9c2291db2b01d",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149266,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149268,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149265,
                group_name: "Desserts",
                choices: [
                  {
                    id: 62188010,
                    name: "Ragi Coconut Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188011,
                    name: "Til & Jaggery Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188012,
                    name: "Moong Dal and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                  {
                    id: 62188013,
                    name: "Pumpkin and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149269,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94419686": {
            id: 94419686,
            name: "Cucumber Raita",
            category: "Extras",
            description: "Energy : 50.72 Kcal.",
            cloudinaryImageId: "be15a3645024f772784bd94875a1b8b2",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94419687": {
            id: 94419687,
            name: "Roasted Papad",
            category: "Extras",
            description: "Energy : 46.48 Kcal.",
            cloudinaryImageId: "d333361dc3cb83628ad82ebb1789a8b1",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "94419688": {
            id: 94419688,
            name: "Onion Circles",
            category: "Extras",
            description: "Energy : 14 Kcal.",
            cloudinaryImageId: "c92d884ecd6897d16bad4126c82abfd1",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "109851266": {
            id: 109851266,
            name: "Methi Palak Brown Rice Khichdi",
            category: "Welcome to Soul Rasa!! Try our Bestsellers",
            description:
              "A comforting khichdi made with whole masoor dal & brown rice, cooked with methi and spinach. Served with Papad & Curd, yum! Good for one. Contains milk. Energy : 296.7 Kcal.",
            cloudinaryImageId: "49cefac0bb0dff2fe9c163f52b5942fa",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 77149281,
                group_name: "Desserts",
                choices: [
                  {
                    id: 62188010,
                    name: "Ragi Coconut Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188011,
                    name: "Til & Jaggery Ladoo (3 Pcs)",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188012,
                    name: "Moong Dal and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                  {
                    id: 62188013,
                    name: "Pumpkin and Jaggery Halwa",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149282,
                group_name: "Grains",
                choices: [
                  {
                    id: 62188019,
                    name: "Jeera Millets",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188020,
                    name: "Brown Rice Pulao",
                    price: 8900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188021,
                    name: "Palak Chapathi (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188022,
                    name: "Ajwaini Chapathis (2 Pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188023,
                    name: "Whole Wheat Chapathi (2 pcs)",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 95,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149283,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 77149284,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568243": {
            id: 110568243,
            name: "Anda Masala & Kaddu!",
            category: "Nourishing Plates!",
            description:
              "Boiled eggs in a tomato-onion curry, accompanied with roasted pumpkin sabzi and whole masoor dal. Served with your choice of grain or 3 chapatis. Good for one! Contains egg, milk & wheat (Palak Chapati). Energy : 291.6 Kcal.",
            cloudinaryImageId: "e6e7c42285535ba1e221969d95bcb802",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423652,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423653,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423654,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423655,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568244": {
            id: 110568244,
            name: "Palak Soya Chaap with kaddu & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Perfectly cooked soya chaap in mildly spiced spinach gravy, alongside roasted pumpkin sabzi and whole masoor dal. This good for one meal is served with your choice of grain or 3 chapatis. Contains milk, soy & wheat (Palak Chapati). Energy : 225.04 Kcal.",
            cloudinaryImageId: "8b8fec1cfe7f4933d21c43e3cefa284f",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423656,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423657,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423658,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423659,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568248": {
            id: 110568248,
            name: "Palak Soya Chaap with Gajar Matar & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Soya chaap chunks cooked with spinach and spices, accompanied with carrot-peas sabzi and whole masoor dal. Enjoy with your choice of grain or 3 chapatis. Simple, wholesome and delicious! Good for one. Contains soy, milk & wheat (Palak Chapati). Energy : 234.08 Kcal.",
            cloudinaryImageId: "ce1f915618404c4f4b93254d9ca31bca",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 25900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423663,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423664,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423665,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423666,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568250": {
            id: 110568250,
            name: "Roasted Gobi & Broccoli with Methi Shakkarkand & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Roasted cauliflower and broccoli florets coated in a mildly spiced yoghurt mix, alongside sweet-potato and methi shakkarkand and whole masoor dal. Served with your choice of grain or 3 chapatis. Simple, hearty and delicious! Good for one. Contains milk, nut & wheat (Palak Chapati). Energy : 223.9 Kcal.",
            cloudinaryImageId: "bfb839ac2c9340f85b550689b47e4c11",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423677,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423678,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423676,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423679,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568277": {
            id: 110568277,
            name: "Roasted Gobi & Broccoli with Beetroot Poriyal & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Cauliflower and broccoli florets coated in a mildly spiced yoghurt mix and oven-roasted till tender. Served with beetroot sauteed with shredded coconuts, whole masoor dal, and your choice of grain or 3 chapatis. Wholesome and good for one. Contains milk & wheat (Palak Chapati). Energy : 229.43 Kcal.",
            cloudinaryImageId: "2b0ac489fd60a6ee95a382251ca47138",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423684,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423685,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423683,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423686,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568290": {
            id: 110568290,
            name: "Turai & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Turai (ridge gourd) and chana dal cooked in a simple tadka of jeera and spices, served along with palak-masoor dal. Comes with your choice of grain or 3 chapatis. Good for one. Energy : 158.72 Kcal.",
            cloudinaryImageId: "ee1726efdce1f3fd744b81c0efcb9fdc",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423691,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423689,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423690,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423692,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568366": {
            id: 110568366,
            name: "Paneer Shimlamirch with Kaddu & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Paneer and capsicum cooked in tomato-onion masala, alongside roasted pumpkin sabzi and whole masoor dal. Enjoy with your choice of grain or 3 chapatis. Perfect for one. Contains milk & wheat (Palak Chapati). Energy : 287.81 Kcal.",
            cloudinaryImageId: "5fb9ecf65249c8456b710612782d86e1",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423714,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423715,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423713,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423716,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568373": {
            id: 110568373,
            name: "Chatpata Sprouts with Beans Carrot Poriyal & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Crunchy sprouts in a spicy-tangy masala, paired with beans-carrot sauteed with shredded coconuts and whole masoor dal. This powerhouse meal for one is served with your choice of grain or 3 chapatis. Energy : 209.21 Kcal.",
            cloudinaryImageId: "5e268818f870e1f8a1a743cfafcaf3ea",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423718,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423719,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423717,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423720,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568386": {
            id: 110568386,
            name: "Anda Masala with Gajar Matar & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Boiled eggs in a tomato-onion curry, accompanied with carrot-peas sabzi and whole masoor dal. Served with your choice of grain or 3 chapatis. A delicious meal for one. Contains egg, milk & wheat (Palak Chapati). Energy : 320.9 Kcal.",
            cloudinaryImageId: "2ae03a07ec1f4fe3f44033f875cfb806",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423727,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423730,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423728,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423731,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568389": {
            id: 110568389,
            name: "Chatpata Sprouts with Beetroot Poriyal & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Crunchy sprouts in a tomato-onion masala, alongside beetroot sauteed with shredded coconuts and whole masoor dal. This wholesome good for one meal is served with your choice of grain or 3 chapatis. Energy : 231.5 Kcal.",
            cloudinaryImageId: "4439f7583536341d7439a9451ea12c45",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 21900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423737,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423738,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423739,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423740,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568393": {
            id: 110568393,
            name: "Coastal Chicken with Gajar Matar & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Chicken chunks cooked in coconuts and onion masala, accompanied with carrot-peas sabzi and whole masoor dal. Enjoy with your choice of grain or 3 chapatis. Ideal for one. Energy : 242.33 Kcal.",
            cloudinaryImageId: "16cb4c5675c8ab0d173ceb265a74b55c",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423747,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423745,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423746,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423748,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568394": {
            id: 110568394,
            name: "Coastal Chicken with Beans Carrot Poriyal & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Chicken chunks in creamy coconuts gravy, alongside beans-carrot poriyal and whole masoor dal. Enjoy with your choice of grain or 3 chapatis. Delicious coastal meal for one. Energy : 261.99 Kcal.",
            cloudinaryImageId: "8969ce5060abb2a35d8cfe011e4ead84",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423750,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423751,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423749,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423752,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568395": {
            id: 110568395,
            name: "Gajar Matar & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Classic carrot-peas sabzi, alongside whole masoor dal cooked with palak and simple spices. Enjoy with your choice of grain or 3 chapatis. This combination is good for one! Contains milk & wheat (Palak Chapati). Energy : 142.43 Kcal.",
            cloudinaryImageId: "2c9e23f55ef64dcee75a04ecdc8aa47b",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423754,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423755,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423753,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423756,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568396": {
            id: 110568396,
            name: "Coastal Chicken with Turai & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Chicken chunks in coconuts-onion masala gravy, alongside delicious turai (ridge gourd) - channa sabzi and whole masoor dal. Enjoy with your choice of grain or 3 chapatis. Delicious coastal meal for one. Energy : 245.45 Kcal.",
            cloudinaryImageId: "520b07741718f101091c920e7d58648a",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423758,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423759,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423757,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423760,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568398": {
            id: 110568398,
            name: "Kala Chana & Yam with Beetroot Poriyal!",
            category: "Nourishing Plates!",
            description:
              "Kala chana and yam chunks cooked in an onion spice mix, alongside beetroot sauteed with shredded coconuts and whole masoor dal. Enjoy with your choice of grain or 3 chapatis. Good for one. Energy : 247.19 Kcal.",
            cloudinaryImageId: "5446ab61a9d8cf8c6bbcc4d81ee02dde",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423761,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423762,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423763,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423764,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568399": {
            id: 110568399,
            name: "Kaddu & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Chunks of pumpkin oven roasted with simple spices and topped with nutsty onion gravy. Served with whole masoor dal and your choice of grain or 3 chapatis. This yummy fix is good for one! Contains milk, wheat (Palak Chapati). Energy : 137.09 Kcal.",
            cloudinaryImageId: "864ef8db3340b5f6e71781d8c3140510",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 16900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423769,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423767,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423768,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423770,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568400": {
            id: 110568400,
            name: "Palak Murgh with Kaddu & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Tender chicken pieces sauteed with spinach and spices, served alongside roasted pumpkin sabzi and whole masoor dal. Enjoy with your choice of grain or 3 chapatis. Perfect for one. Contains nuts, milk & wheat (Palak Chapati). Energy : 195.02 Kcal.",
            cloudinaryImageId: "d30a4e28705a2b5ce927390ba0bdf8bd",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423772,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423773,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423771,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423774,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110568402": {
            id: 110568402,
            name: "Palak Murgh with Gajar Matar & Masoor Dal!",
            category: "Nourishing Plates!",
            description:
              "Chicken pieces cooked in a mildly spiced spinach gravy, accompanied with carrot-peas sabzi and whole masoor dal. Relish with your choice of grain or 3 chapatis. A hearty meal for one. Energy : 204.06 Kcal.",
            cloudinaryImageId: "d0855a8d5cde3cb6eda7a5d59b4e3b58",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 26900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 78423813,
                group_name: "Choose your Grain",
                choices: [
                  {
                    id: 62188028,
                    name: "Jeera Millets",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188029,
                    name: "Brown Rice Pulao",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188030,
                    name: "Palak Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188031,
                    name: "Ajwaini Chapathis (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188032,
                    name: "Whole Wheat Chapathi (3 Pcs)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 100,
              },
              {
                group_id: 78423817,
                group_name: "Beverages",
                choices: [
                  {
                    id: 62188024,
                    name: "Buttermilk",
                    price: 6900,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423816,
                group_name: "Extra Veggies",
                choices: [
                  {
                    id: 62188014,
                    name: "Chatpata Sprouts",
                    price: 4500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188015,
                    name: "Gajar Matar Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188016,
                    name: "Kaddu Ki Sabzi",
                    price: 3900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                  {
                    id: 62188017,
                    name: "Turai Chana Dal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 97,
                    default: 0,
                  },
                  {
                    id: 62188018,
                    name: "Beetroot Poriyal",
                    price: 2900,
                    inStock: 1,
                    isVeg: 1,
                    order: 96,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 100,
              },
              {
                group_id: 78423818,
                group_name: "Add Ons",
                choices: [
                  {
                    id: 62188025,
                    name: "Cucumber Raita",
                    price: 2500,
                    inStock: 1,
                    isVeg: 1,
                    order: 100,
                    default: 0,
                  },
                  {
                    id: 62188026,
                    name: "Roasted Papad",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 99,
                    default: 0,
                  },
                  {
                    id: 62188027,
                    name: "Onion Circles",
                    price: 1900,
                    inStock: 1,
                    isVeg: 1,
                    order: 98,
                    default: 0,
                  },
                ],
                maxAddons: 6,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "410683",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Top Picks",
            subTitle: "",
            type: "menuCarousels",
            entities: [],
            widgets: [],
            collapsible: false,
          },
          {
            name: "Welcome to Soul Rasa!! Try our Bestsellers",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 91100026,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 109851266,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 91100024,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 77097411,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 92640694,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Guilt-Free Desserts",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 91100036,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 91100037,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 77097418,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 77097419,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Make Your Own Plate",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 77097427,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Mains - A la Carte",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Dal, Veggies & More",
                type: "subcategory",
                entities: [
                  {
                    id: 81440833,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81440832,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81440819,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81440821,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81440820,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81440822,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81440823,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 91100029,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 85940253,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 91100030,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 85940256,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 85940257,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81440824,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 85940255,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Grains",
                type: "subcategory",
                entities: [
                  {
                    id: 91100032,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 91100033,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 91100034,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 91100035,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 91100031,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Nourishing Plates!",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Vegetarian Nourishing Plates!",
                type: "subcategory",
                entities: [
                  {
                    id: 110568395,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568244,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568399,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568398,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568290,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568373,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568277,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568389,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568250,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568248,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568366,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non-vegetarian Nourishing plates!",
                type: "subcategory",
                entities: [
                  {
                    id: 110568386,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568394,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568396,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568243,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568402,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568393,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 110568400,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Light Plates",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 92640688,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Extras",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 94419686,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94419687,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 94419688,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Beverages",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 78072194,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [],
            perRow: 2,
            collapsible: false,
          },
        ],
        menuCarousels: [
          {
            type: "TopCarousel",
            subtype: "image",
            data: {
              bannerId: 842205,
              creativeId: "TopPicks/MPlkBrRceKchdi",
              creativeThumbnail: "",
              linkType: "item",
              link: "109851266",
              title: "Methi Palak Brown Rice Khichdi",
              description: " ",
              priority: -1,
              fontColor: "#FFFFFF",
            },
          },
          {
            type: "TopCarousel",
            subtype: "image",
            data: {
              bannerId: 842237,
              creativeId: "TopPicks/ GrnFreeplt",
              creativeThumbnail: "",
              linkType: "item",
              link: "77097427",
              title: "The Grain Free plate",
              description: " ",
              priority: -1,
              fontColor: "#FFFFFF",
            },
          },
          {
            type: "TopCarousel",
            subtype: "image",
            data: {
              bannerId: 842253,
              creativeId: "TopPicks/MDalJgryHlw",
              creativeThumbnail: "",
              linkType: "item",
              link: "77097418",
              title: "Moong Dal and Jaggery Halwa",
              description: " ",
              priority: -1,
              fontColor: "#FFFFFF",
            },
          },
          {
            type: "TopCarousel",
            subtype: "image",
            data: {
              bannerId: 842269,
              creativeId: "TopPicks/RagiCtLado",
              creativeThumbnail: "",
              linkType: "item",
              link: "91100036",
              title: "Ragi Coconut Ladoo (3 Pcs)",
              description: " ",
              priority: -1,
              fontColor: "#FFFFFF",
            },
          },
        ],
        layoutType: "menu_merchandise",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "60% off",
        shortDescriptionList: [
          {
            meta: "60% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "Free Til & Jaggery Ladoo (3 Pcs) on orders above ₹799",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "60% off up to ₹120 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "Free Til & Jaggery Ladoo (3 Pcs) on orders above ₹799",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "60% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["e206cb81-57fd-45c0-a29c-a1ab28028ce3"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE TRYNEW",
          description: "ABOVE ₹159",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "Free Til & Jaggery Ladoo (3 Pcs)",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["630ede44-0b97-44a2-bbf2-c1055aba5b65"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "NO CODE REQUIRED",
          description: "ABOVE ₹799",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹150 OFF",
          offer_tag: "FLAT DEAL",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["28e9bc81-3b91-4f34-a800-06b51fc85934"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FLATDEAL",
          description: "ABOVE ₹749",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT 10% OFF",
          offer_tag: "FLAT DEAL",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["61b1c24c-de58-4525-baab-ff242e136b5c"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE PARTY",
          description: "ABOVE ₹1500",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "60% off",
        shortDescriptionList: [
          {
            meta: "60% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "Free Til & Jaggery Ladoo (3 Pcs) on orders above ₹799",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "60% off up to ₹120 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "Free Til & Jaggery Ladoo (3 Pcs) on orders above ₹799",
            discountType: "Freebie",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 1050,
          maxValue: 1500,
          priority: 4,
          couponCode: "PARTY",
          discountInfo: {
            discountType: "Percentage",
            value: 10,
            operationType: "RESTAURANT",
          },
          lockedMessage:
            "Add items worth ₹<amount> to unlock flat 10% off | Code PARTY",
          unlockedMessage: "PARTY Coupon Unlocked! Use it to save flat 10% off",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 5,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11218334001531"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [{ text: "", imageId: "", fontColor: "" }],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "99467e30-f02d-4191-af32-adffef42fa69",
      timeStamp: "1677489323905",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "svam9qO9B1zS-pCzYdMS2QcgkiIRuFgDZjfsNp_Y",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "118278",
      name: "Namaste",
      uuid: "81f6e475-dc52-4954-aefa-1dbcc740227d",
      slug: "namaste-btm",
      latLong: "12.9106423,77.60651559999997",
      city: "Bangalore",
      area: "BTM Layout",
      areaPostalCode: "560068",
      areaSlug: "BTM",
      restaurantSlug: { restaurant: "namaste-btm", city: "bangalore" },
      type: "F",
      locality: "2nd Stage",
      avgRating: 4.3,
      totalRatings: 1000,
      avgRatingString: "4.3",
      totalRatingsString: "1K+ ratings",
      cloudinaryImageId: "wya5kg7wxvbh5opfpo1m",
      costForTwo: 10000,
      costForTwoMsg: "₹100 for two",
      cuisines: ["South Indian", "Thalis"],
      minimumOrder: 0,
      opened: 1,
      parentId: 366271,
      isNew: false,
      isVeg: true,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "30 MINS",
        lastMileDistanceString: "4.2 kms",
        restaurantId: "118278",
        deliveryTime: 30,
        minDeliveryTime: 30,
        maxDeliveryTime: 30,
        lastMileTravel: 4.2,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.5283735394477844,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 4,
      },
      availability: {
        nextCloseTime: "2023-02-28 02:00:00",
        nextChangeTime: 1677529800000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message: "69, 7th Main Road, BTM 2nd Stage, Bangalore - 76",
        },
        { title: "Cuisines", message: "South Indian,Thalis" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "32768617": {
            id: 32768617,
            name: "Idli (2pc) ",
            category: "South Indian",
            description:
              "Served with sambar and chutney. No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "ixlexdhrxpu2ir9cc6xr",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32768618": {
            id: 32768618,
            name: "Masala Dosa ",
            category: "South Indian",
            description:
              "[medium size] served with only chutney. No soda, artificial colour or any other chemical used in the preparation. (Serves 1)",
            cloudinaryImageId: "hprrkr2aghvcmk6ikjlk",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 32801416,
                group_name: "Add-ons",
                choices: [
                  {
                    id: 21937240,
                    name: "Breakfast Sambar",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 0,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32768619": {
            id: 32768619,
            name: "Kesari Bath ",
            category: "South Indian",
            description:
              "No soda, artificial colour or any other chemical used in the preparation. (Serves 1)",
            cloudinaryImageId: "dkkth0fk2t8l4oqsru79",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 3:30 pm, today",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32768621": {
            id: 32768621,
            name: "Vada (2pc)",
            category: "South Indian",
            description:
              "Served with sambar and chutney. No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "li6rjgyvt9a44byienf1",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "32768628": {
            id: 32768628,
            name: "Butter Milk [200 ml]",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "ucmcedcpzv2nfpylxbg7",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "33592756": {
            id: 33592756,
            name: "Cold Badam Milk",
            category: "Cold Beverages",
            description: "200 ml",
            cloudinaryImageId: "uvkpbdchqaz6khazrlbf",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "40601352": {
            id: 40601352,
            name: "Shavige Bath",
            category: "South Indian",
            description:
              "Served with chutney. Served at room temperature. No soda, artificial colour or any other chemical used in the preparation.  (Serves 1)",
            cloudinaryImageId: "qcgjwz9ownpmvrbhrogk",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "40761296": {
            id: 40761296,
            name: "Aloo Paratha (2pc) With Raita And Pickle",
            category: "Specials",
            description: "Served with raita and pickle",
            cloudinaryImageId: "fgboawqnkch0fspukm9f",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "40765104": {
            id: 40765104,
            name: "Plain dosa (served with only chutney)",
            category: "South Indian",
            description:
              "[medium size] served with only chutney. No soda, artificial colour or any other chemical used in the preparation.  (Serves -1)",
            cloudinaryImageId: "hprrkr2aghvcmk6ikjlk",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            addons: [
              {
                group_id: 32801422,
                group_name: "Add-ons",
                choices: [
                  {
                    id: 21937240,
                    name: "Breakfast Sambar",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 0,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 0,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "50773082": {
            id: 50773082,
            name: "Veg Dum Biryani ( Basmati Rice )",
            category: "Specials",
            description: "Dum biryani served with raita.",
            cloudinaryImageId: "hwhtgjpnxo1wozrt5yzl",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 18900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "50773083": {
            id: 50773083,
            name: "Tawa Paratha (2pc) With Curry And Dal",
            category: "Specials",
            description: "Served with curry and dal. (Serves 1)",
            cloudinaryImageId: "keb7eonjge0fhfxv9zfy",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51722671": {
            id: 51722671,
            name: "Rasam Rice",
            category: "Lunch",
            description: "",
            cloudinaryImageId: "scjrxnrmstsrsfhsjvo0",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51724656": {
            id: 51724656,
            name: "Curd Rice",
            category: "Lunch",
            description:
              "Soothing and tasty, the curd rice is a healthy meal choice garnished with nuts, curry leaves and green chillies. (Serves 1)",
            cloudinaryImageId: "mx5lahjmp63f4pr7axbj",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51752267": {
            id: 51752267,
            name: "Extra Chapati (1 Pc)",
            category: "Lunch",
            description: "",
            cloudinaryImageId: "uri9oxxewgonulqtbqbv",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51752268": {
            id: 51752268,
            name: "North Indian Meal",
            category: "Lunch",
            description:
              "Paratha (2 pc), dal, curry, veg biryani, curd rice, sweet, papad, salad, pickle (serves 1)",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51795960": {
            id: 51795960,
            name: "Extra Poori (2 Pc)",
            category: "Lunch",
            description: "",
            cloudinaryImageId: "ojep0u2yovrswvlfkogg",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51796017": {
            id: 51796017,
            name: "Mini Meal",
            category: "Lunch",
            description: "Steam rice, sambhar, rasam, curd, palya and papad",
            cloudinaryImageId: "tklrjk7bacvvsfdgfqr8",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51796217": {
            id: 51796217,
            name: "South Meal",
            category: "Lunch",
            description:
              "Steam rice, poori (3 pc), curry, palya, sambar, rasam, curd rice, sweet, papad, and pickle. (serves 1)",
            cloudinaryImageId: "sjyrg1plnpczxsj8n3d4",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51797077": {
            id: 51797077,
            name: "Rice Bhath",
            category: "Lunch",
            description:
              "A tasty preparation of rice made served with chutney. (Serves 1)",
            cloudinaryImageId: "bdhdwdy6rmoe4ravcjis",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51837141": {
            id: 51837141,
            name: "2 Idly + 2 Vada",
            category: "Combos",
            description:
              "Idly (2 pc) and vada (2 pc) served with coconut chutney and sambar",
            cloudinaryImageId: "ulinw05zmlwmlze41kcu",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51837618": {
            id: 51837618,
            name: "2 Idli + 1 Masala Dosa ",
            category: "Combos",
            description:
              "Idli (2 pc) and masala dosa (1 pc) served with coconut chutney and sambar",
            cloudinaryImageId: "nmgbk8uorovxrvvjyjqd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51906625": {
            id: 51906625,
            name: "Onion Dosa",
            category: "South Indian",
            description:
              "Served with saagu and chutney. No soda, artificial colour or any other chemical used in the preparation(Serves 1).",
            cloudinaryImageId: "ebs5kwwxtzf4j4ay916h",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "51909776": {
            id: 51909776,
            name: "Poori (3pc) Saagu",
            category: "South Indian",
            description:
              "Served with saagu and chutney. No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "rpe7j4awn4xfxrw1ztdt",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52277623": {
            id: 52277623,
            name: "Avalakki Bath",
            category: "South Indian",
            description:
              "Served with chutney. No soda, artificial colour or any other chemical used in the preparation. (Serves -1)",
            cloudinaryImageId: "fh5xeqhuqx4otq5n4k82",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52308322": {
            id: 52308322,
            name: "White Upma",
            category: "South Indian",
            description:
              "Served with chutney. No soda, artificial colour or any other chemical used in the preparation(Serves 1).",
            cloudinaryImageId: "s5wlzxkre6jjg6vtgomr",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52308591": {
            id: 52308591,
            name: "Veg Fried Rice",
            category: "Fried Rice",
            description:
              "No artificial colours, ajinomoto, msg or any other chemicals used in the preparation. (Serves 1)",
            cloudinaryImageId: "nuq10hzzzvolaoqu9y2o",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52329032": {
            id: 52329032,
            name: "Veg Noodles",
            category: "Noodles",
            description:
              "No artificial colours, ajinomoto, msg or any other chemicals used in the preparation. (Serves 1)",
            cloudinaryImageId: "cpqcgbp9ho8gyngogqjn",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52339833": {
            id: 52339833,
            name: "Gobi Manchurian Dry",
            category: "Starters",
            description:
              "No artificial colours, ajinomoto, msg or any other chemicals used in the preparation.",
            cloudinaryImageId: "snthyimv5uebf7ypkqbn",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52404890": {
            id: 52404890,
            name: "Akki Roti (2pc)",
            category: "South Indian",
            description:
              "Served with saagu and chutney. No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "bgaxzhovxv5omej27cwa",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "52405023": {
            id: 52405023,
            name: "Ragi Roti (2pc)",
            category: "South Indian",
            description:
              "Served with saagu and chutney. No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "qufs3dzyevxg9m64dqu5",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "56203252": {
            id: 56203252,
            name: "Gulab Jamun (2pc)",
            category: "Specials",
            description:
              "Fried dough balls that are soaked in a sweet, sticky sugar syrup",
            cloudinaryImageId: "ns7xqzcerojkc4yaytiu",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "56203256": {
            id: 56203256,
            name: "Sweet Lassi [200 ml]",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "rbe3d80mkd3sxuo86ddo",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59379261": {
            id: 59379261,
            name: "Baby Corn Manchurian Dry",
            category: "Starters",
            description:
              "No artificial colours, ajinomoto, msg or any other chemicals used in the preparation.",
            cloudinaryImageId: "krk87e2xc5jjwtbrhnbx",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "59582051": {
            id: 59582051,
            name: "Kayi Holige/obbattu (1 Pc)",
            category: "Festival Season Special",
            description:
              "A traditional south Indian dessert made with coconut and jaggery stuffing",
            cloudinaryImageId: "nkpnbl931zikzdqlepjs",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "60932578": {
            id: 60932578,
            name: "Extra Breakfast Sambar (250ml)",
            category: "South Indian",
            description:
              "No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "60932580": {
            id: 60932580,
            name: "Extra Chutney (250ml)",
            category: "South Indian",
            description:
              "No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "60979001": {
            id: 60979001,
            name: "Filter Coffee Mini Flask (250ml)",
            category: "Hot Beverages",
            description: "Serves 3-4",
            cloudinaryImageId: "qbjoqpjygtnbkuakhfri",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "60979003": {
            id: 60979003,
            name: "Chai Mini Flask (250ml)",
            category: "Hot Beverages",
            description: "Serves 3-4",
            cloudinaryImageId: "odeypfydw4ze1y4ankcl",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "60979004": {
            id: 60979004,
            name: "Ginger Chai Mini Flask (250ml)",
            category: "Hot Beverages",
            description: "Serves 3-4",
            cloudinaryImageId: "vuwwehartfeayjl1vrzf",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "61975884": {
            id: 61975884,
            name: "Mushroom Manchurian Dry",
            category: "Starters",
            description:
              "No artificial colours, ajinomoto, msg or any other chemicals used in the preparation.",
            cloudinaryImageId: "ei1gu1qwepdz6czvtbhb",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "61975885": {
            id: 61975885,
            name: "Schezwan Fried Rice (spicy)",
            category: "Fried Rice",
            description:
              "No artificial colours, ajinomoto, msg or any other chemicals used in the preparation. (Serves 1)",
            cloudinaryImageId: "nmnoxpo4zc5nvfqmyscy",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "62219277": {
            id: 62219277,
            name: "Schezwan Noodles (spicy)",
            category: "Noodles",
            description:
              "No artificial colours, ajinomoto, msg or any other chemicals used in the preparation.",
            cloudinaryImageId: "tddqttetiyiqcigojgj0",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "64737763": {
            id: 64737763,
            name: "Chapati (2 Pc) With Curry And Dal",
            category: "Lunch",
            description: "2 pc chapati served with dal and curry",
            cloudinaryImageId: "myedudqysqum6ftzvmim",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 7900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "68486354": {
            id: 68486354,
            name: "Kokum Juice [200 ml]",
            category: "Cold Beverages",
            description: "",
            cloudinaryImageId: "qfa6xkyfvtbyjqpwggyk",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "Serves 1",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "68576062": {
            id: 68576062,
            name: "Bisi Bele Bath",
            category: "South Indian",
            description:
              "Served with khara boondi. No soda, artificial colour or any other chemical used in the preparation(Serves 1).",
            cloudinaryImageId: "kjh3jzl4xla3ccp1d86p",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "68579104": {
            id: 68579104,
            name: "Maddur Vada (2pc)",
            category: "South Indian",
            description:
              "Served with chutney. No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "du4p9ex75erazwwgg7qy",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "70652120": {
            id: 70652120,
            name: "Chapati Currry Meal Combo",
            category: "Lunch",
            description:
              "Chapati (2pc), curry and dal served with rice bath. (Serves 1)",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "72993490": {
            id: 72993490,
            name: "Khara Bath",
            category: "South Indian",
            description:
              "No soda, artificial colour or any other chemical used in the preparation.",
            cloudinaryImageId: "soz1bkdu9dxf6qknznkq",
            recommended: 1,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 7 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "74013533": {
            id: 74013533,
            name: "Sugarless Filter Coffee ",
            category: "Hot Beverages",
            description: "",
            cloudinaryImageId: "ptkwtku7laz46vmhfsob",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "250 ml",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "74031579": {
            id: 74031579,
            name: "Kayi Holige/obbattu ( Box Of 4 )",
            category: "Festival Season Special",
            description:
              "[4 pcs] a traditional south indian dessert made with coconut and jaggery stuffing",
            cloudinaryImageId: "nkpnbl931zikzdqlepjs",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "98245489": {
            id: 98245489,
            name: "Pineapple Holige/obbattu (1 Pc)",
            category: "Festival Season Special",
            description:
              "A traditional south indian dessert made with pineapple, coconut and jaggery stuffing",
            cloudinaryImageId: "w1xkmlxjescxljvhpbgx",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "118278",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 32768617,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32768621,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 68579104,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32768618,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 52404890,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 40765104,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51724656,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51797077,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51796217,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51796017,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51795960,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51752267,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 40761296,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 59582051,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 98245489,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 68486354,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 32768628,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 33592756,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 62219277,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51837141,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 51837618,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "South Indian",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 32768617,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32768621,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 68579104,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32768618,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 51909776,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 52405023,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 52404890,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 51906625,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 60932580,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 60932578,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 40765104,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 72993490,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32768619,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 68576062,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 52308322,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 40601352,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 52277623,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Lunch",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Rice",
                type: "subcategory",
                entities: [
                  {
                    id: 51724656,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 51797077,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 51722671,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Meals",
                type: "subcategory",
                entities: [
                  {
                    id: 51752268,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 51796217,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 51796017,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 64737763,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 70652120,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Indian Breads",
                type: "subcategory",
                entities: [
                  {
                    id: 51795960,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 51752267,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Hot Beverages",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 60979001,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 74013533,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 60979003,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 60979004,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Specials",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 40761296,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 56203252,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 50773082,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 50773083,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Festival Season Special",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 74031579,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 59582051,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 98245489,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Cold Beverages",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 68486354,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 32768628,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 56203256,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 33592756,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fried Rice",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 52308591,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 61975885,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Starters",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 52339833,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 59379261,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 61975884,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Noodles",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 52329032,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 62219277,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Combos",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 51837141,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 51837618,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "normal",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "50% off",
        shortDescriptionList: [
          {
            meta: "50% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "50% off up to ₹100 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "50% OFF UPTO ₹100",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["481512a2-2864-480d-ba6a-cd0346da1b28"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE TRYNEW",
          description: "ABOVE ₹159",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "FLAT DEAL",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["3fb13d7e-9234-4a96-8f8d-8a44106d727c"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FLATDEAL",
          description: "ABOVE ₹499",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT 20% OFF",
          offer_tag: "FLAT DEAL",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["82935408-05cd-4ae0-b7a2-9e17f05fa48a"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE PARTY",
          description: "ABOVE ₹600",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "50% off",
        shortDescriptionList: [
          {
            meta: "50% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "50% off up to ₹100 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FLAT100 off | Use FLATDEAL",
            discountType: "Flat",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 420,
          maxValue: 600,
          priority: 3,
          couponCode: "PARTY",
          discountInfo: {
            discountType: "Percentage",
            value: 20,
            operationType: "RESTAURANT",
          },
          lockedMessage:
            "Add items worth ₹<amount> to unlock flat 20% off | Code PARTY",
          unlockedMessage: "PARTY Coupon Unlocked! Use it to save flat 20% off",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 4,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 21218194001490"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [
        { text: "", imageId: "trending_solid", fontColor: "#7E808C" },
      ],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      select: false,
      slotInvalid: false,
      cafe: false,
      preorderable: false,
      requestId: "46a1cc6f-703c-4b00-9d4a-43bfade40fef",
      timeStamp: "1677489355416",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "ilfDwnwnROUU-1NplrORdsYTu2_ylEob6WO7rGho",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "656392",
      bgColor: "#ffffff",
      logo: "v1675752975/Brand logo/Subway",
      textColor: "#000000",
      name: "Subway",
      uuid: "b649dc2d-8e82-4c70-b864-91ae31ba4739",
      slug: "subway-koramangala-koramangala-2",
      latLong: "12.928999,77.635218",
      city: "Bangalore",
      area: "CNA, Koramangla",
      areaPostalCode: "560034",
      areaSlug: "koramangala",
      restaurantSlug: {
        restaurant: "subway-koramangala-koramangala-2",
        city: "bangalore",
      },
      type: "F",
      locality: "1st Block",
      avgRating: 4.2,
      totalRatings: 100,
      avgRatingString: "4.2",
      totalRatingsString: "100+ ratings",
      cloudinaryImageId: "0bf19a82b109b40c2f5c56d00f071a33",
      costForTwo: 35000,
      costForTwoMsg: "₹350 for two",
      cuisines: ["Salads", "Snacks"],
      minimumOrder: 0,
      opened: 1,
      parentId: 2,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "21 MINS",
        lastMileDistanceString: "1.7 kms",
        restaurantId: "656392",
        deliveryTime: 21,
        minDeliveryTime: 21,
        maxDeliveryTime: 21,
        lastMileTravel: 1.7,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.6712349653244019,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 1,
      },
      availability: {
        nextCloseTime: "2023-02-27 23:00:00",
        nextChangeTime: 1677519000000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "CNA Arcade, Ground Floor, No. 37, 1st Main, 1st Block, Koramangala, Bangalore-560034",
        },
        { title: "Cuisines", message: "Salads,Snacks" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "107240457": {
            id: 107240457,
            name: "Chicken Slice Egg & Cheese Sandwich",
            category: "Sandwiches",
            description:
              "Start your day the fresh way with high protein fluffy eggs, chicken slices, and mouth-watering cheese on a freshly baked bread.",
            cloudinaryImageId: "ehhegmkygb67bt02rnmv",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271298",
                  name: "Choose from Chicken Slice Egg & Cheese Sandwich",
                  variations: [
                    {
                      name: "Chicken Slice Egg & Cheese 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808288",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271298",
                      order: 2,
                    },
                    {
                      name: "Chicken Slice Egg & Cheese 30cm (Footlong)",
                      price: 140,
                      default: 0,
                      id: "75808289",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271298",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271298", variation_id: "75808288" },
                  ],
                  price: 19500,
                  addon_combinations: [
                    { group_id: "73511916", addon_id: "58693189" },
                    { group_id: "73511916", addon_id: "58693190" },
                    { group_id: "73511916", addon_id: "58693191" },
                    { group_id: "73511914", addon_id: "58693179" },
                    { group_id: "73511914", addon_id: "58693180" },
                    { group_id: "73511914", addon_id: "58693181" },
                    { group_id: "73511914", addon_id: "58693182" },
                    { group_id: "73511914", addon_id: "58693183" },
                    { group_id: "75635828", addon_id: "58693259" },
                    { group_id: "73511918", addon_id: "58693195" },
                    { group_id: "73511912", addon_id: "58693169" },
                    { group_id: "73511912", addon_id: "58693170" },
                    { group_id: "73511912", addon_id: "58693171" },
                    { group_id: "73511912", addon_id: "58693172" },
                    { group_id: "73511912", addon_id: "58693173" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271298", variation_id: "75808289" },
                  ],
                  price: 33500,
                  addon_combinations: [
                    { group_id: "73511917", addon_id: "58693192" },
                    { group_id: "73511917", addon_id: "58693193" },
                    { group_id: "73511917", addon_id: "58693194" },
                    { group_id: "73511913", addon_id: "58693174" },
                    { group_id: "73511913", addon_id: "58693175" },
                    { group_id: "73511913", addon_id: "58693176" },
                    { group_id: "73511913", addon_id: "58693177" },
                    { group_id: "73511913", addon_id: "58693178" },
                    { group_id: "73511915", addon_id: "58693179" },
                    { group_id: "73511915", addon_id: "58693180" },
                    { group_id: "73511915", addon_id: "58693181" },
                    { group_id: "73511915", addon_id: "58693182" },
                    { group_id: "73511915", addon_id: "58693183" },
                    { group_id: "75635829", addon_id: "58693259" },
                    { group_id: "73511919", addon_id: "58693195" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511912,
                group_name:
                  "Choose From Choice of Bread for Chicken Slice Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511913,
                group_name:
                  "Choose From Choice of Bread for Chicken Slice Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511914,
                group_name:
                  "Choose From Choice of Preparation for Chicken Slice Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 73511915,
                group_name:
                  "Choose From Choice of Preparation for Chicken Slice Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 73511916,
                group_name:
                  "Choose From Add Ons for Chicken Slice Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693189,
                    name: "Extra Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511917,
                group_name:
                  "Choose From Add Ons for Chicken Slice Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693192,
                    name: "Extra Chicken Slice Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75635828,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Slice Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75635829,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Slice Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511919,
                group_name:
                  "Choose From Choice of Sauces for Chicken Slice Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 73511918,
                group_name:
                  "Choose From Choice of Sauces for Chicken Slice Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 19500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240458": {
            id: 107240458,
            name: "Egg & Cheese Sandwich",
            category: "Sandwiches",
            description:
              "A classic for a reason. our egg and cheese is simply delicious. Enjoy high protein fluffy egg omelet with cheese. Try it toasted - it's unbeatable.",
            cloudinaryImageId: "sej4xnxeaii1xlyxfxvw",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271299",
                  name: "Choose from Egg & Cheese Sandwich",
                  variations: [
                    {
                      name: "Egg & Cheese 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808290",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271299",
                      order: 2,
                    },
                    {
                      name: "Egg & Cheese 30cm (Footlong)",
                      price: 125,
                      default: 0,
                      id: "75808291",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271299",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271299", variation_id: "75808290" },
                  ],
                  price: 17500,
                  addon_combinations: [
                    { group_id: "73511924", addon_id: "58693190" },
                    { group_id: "73511924", addon_id: "58693191" },
                    { group_id: "73511924", addon_id: "58693219" },
                    { group_id: "73511922", addon_id: "58693179" },
                    { group_id: "73511922", addon_id: "58693180" },
                    { group_id: "73511922", addon_id: "58693181" },
                    { group_id: "73511922", addon_id: "58693182" },
                    { group_id: "73511922", addon_id: "58693183" },
                    { group_id: "78063960", addon_id: "58693259" },
                    { group_id: "73511926", addon_id: "58693195" },
                    { group_id: "73511920", addon_id: "58693169" },
                    { group_id: "73511920", addon_id: "58693170" },
                    { group_id: "73511920", addon_id: "58693171" },
                    { group_id: "73511920", addon_id: "58693172" },
                    { group_id: "73511920", addon_id: "58693173" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271299", variation_id: "75808291" },
                  ],
                  price: 30000,
                  addon_combinations: [
                    { group_id: "73511925", addon_id: "58693194" },
                    { group_id: "73511925", addon_id: "58693193" },
                    { group_id: "73511925", addon_id: "58693222" },
                    { group_id: "73511921", addon_id: "58693175" },
                    { group_id: "73511921", addon_id: "58693176" },
                    { group_id: "73511921", addon_id: "58693177" },
                    { group_id: "73511921", addon_id: "58693178" },
                    { group_id: "73511921", addon_id: "58693174" },
                    { group_id: "73511923", addon_id: "58693179" },
                    { group_id: "73511923", addon_id: "58693180" },
                    { group_id: "73511923", addon_id: "58693181" },
                    { group_id: "73511923", addon_id: "58693182" },
                    { group_id: "73511923", addon_id: "58693183" },
                    { group_id: "78063961", addon_id: "58693259" },
                    { group_id: "73511927", addon_id: "58693195" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511920,
                group_name:
                  "Choose From Choice of Bread for Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511921,
                group_name:
                  "Choose From Choice of Bread for Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511922,
                group_name:
                  "Choose From Choice of Preparation for Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 73511923,
                group_name:
                  "Choose From Choice of Preparation for Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 73511924,
                group_name:
                  "Choose From Add Ons for Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511925,
                group_name:
                  "Choose From Add Ons for Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 78063960,
                group_name:
                  "Choose From Choice of Vegetable for Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78063961,
                group_name:
                  "Choose From Choice of Vegetable for Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511926,
                group_name:
                  "Choose From Choice of Sauces for Egg & Cheese 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 73511927,
                group_name:
                  "Choose From Choice of Sauces for Egg & Cheese 30cm (Footlong)",
                choices: [
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 17500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240460": {
            id: 107240460,
            name: "Chatpata Chana Sandwich",
            category: "Sandwiches",
            description:
              "A chunky, flavourful and tangy mix of chatpata chana and bengal gram with aromatic indian spices and vegetables served on a freshly baked bread.",
            cloudinaryImageId: "vrbihislwi4i1vwwgigj",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271301",
                  name: "Choose from Chatpata Chana Sandwich",
                  variations: [
                    {
                      name: "Chatpata Chana 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808294",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271301",
                      order: 2,
                    },
                    {
                      name: "Chatpata Chana 30cm (Footlong)",
                      price: 145,
                      default: 0,
                      id: "75808295",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271301",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271301", variation_id: "75808294" },
                  ],
                  price: 20500,
                  addon_combinations: [
                    { group_id: "73511942", addon_id: "58693307" },
                    { group_id: "73511942", addon_id: "58693190" },
                    { group_id: "73511942", addon_id: "58693191" },
                    { group_id: "73511946", addon_id: "58693195" },
                    { group_id: "73511946", addon_id: "58693270" },
                    { group_id: "73511946", addon_id: "58693271" },
                    { group_id: "73511946", addon_id: "58693272" },
                    { group_id: "73511946", addon_id: "58693273" },
                    { group_id: "73511946", addon_id: "58693274" },
                    { group_id: "73511946", addon_id: "58693275" },
                    { group_id: "73511946", addon_id: "58693276" },
                    { group_id: "73511946", addon_id: "58693277" },
                    { group_id: "73511940", addon_id: "58693179" },
                    { group_id: "73511940", addon_id: "58693180" },
                    { group_id: "73511940", addon_id: "58693181" },
                    { group_id: "73511940", addon_id: "58693182" },
                    { group_id: "73511940", addon_id: "58693183" },
                    { group_id: "73511944", addon_id: "58693251" },
                    { group_id: "73511944", addon_id: "58693252" },
                    { group_id: "73511944", addon_id: "58693253" },
                    { group_id: "73511944", addon_id: "58693254" },
                    { group_id: "73511944", addon_id: "58693255" },
                    { group_id: "73511944", addon_id: "58693256" },
                    { group_id: "73511944", addon_id: "58693257" },
                    { group_id: "73511944", addon_id: "58693258" },
                    { group_id: "73511944", addon_id: "58693259" },
                    { group_id: "73511938", addon_id: "58693169" },
                    { group_id: "73511938", addon_id: "58693170" },
                    { group_id: "73511938", addon_id: "58693171" },
                    { group_id: "73511938", addon_id: "58693172" },
                    { group_id: "73511938", addon_id: "58693173" },
                    { group_id: "78063968", addon_id: "62937803" },
                    { group_id: "78063968", addon_id: "62937804" },
                    { group_id: "78063968", addon_id: "62937805" },
                    { group_id: "78063968", addon_id: "62937806" },
                    { group_id: "78063968", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271301", variation_id: "75808295" },
                  ],
                  price: 35000,
                  addon_combinations: [
                    { group_id: "73511943", addon_id: "58693310" },
                    { group_id: "73511943", addon_id: "58693193" },
                    { group_id: "73511943", addon_id: "58693194" },
                    { group_id: "73511947", addon_id: "58693195" },
                    { group_id: "73511947", addon_id: "58693270" },
                    { group_id: "73511947", addon_id: "58693271" },
                    { group_id: "73511947", addon_id: "58693272" },
                    { group_id: "73511947", addon_id: "58693273" },
                    { group_id: "73511947", addon_id: "58693274" },
                    { group_id: "73511947", addon_id: "58693275" },
                    { group_id: "73511947", addon_id: "58693276" },
                    { group_id: "73511947", addon_id: "58693277" },
                    { group_id: "73511939", addon_id: "58693174" },
                    { group_id: "73511939", addon_id: "58693175" },
                    { group_id: "73511939", addon_id: "58693176" },
                    { group_id: "73511939", addon_id: "58693177" },
                    { group_id: "73511939", addon_id: "58693178" },
                    { group_id: "73511941", addon_id: "58693179" },
                    { group_id: "73511941", addon_id: "58693180" },
                    { group_id: "73511941", addon_id: "58693181" },
                    { group_id: "73511941", addon_id: "58693182" },
                    { group_id: "73511941", addon_id: "58693183" },
                    { group_id: "73511945", addon_id: "58693251" },
                    { group_id: "73511945", addon_id: "58693252" },
                    { group_id: "73511945", addon_id: "58693253" },
                    { group_id: "73511945", addon_id: "58693254" },
                    { group_id: "73511945", addon_id: "58693255" },
                    { group_id: "73511945", addon_id: "58693256" },
                    { group_id: "73511945", addon_id: "58693257" },
                    { group_id: "73511945", addon_id: "58693258" },
                    { group_id: "73511945", addon_id: "58693259" },
                    { group_id: "78063969", addon_id: "62937803" },
                    { group_id: "78063969", addon_id: "62937804" },
                    { group_id: "78063969", addon_id: "62937805" },
                    { group_id: "78063969", addon_id: "62937806" },
                    { group_id: "78063969", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511938,
                group_name:
                  "Choose From Choice of Bread for Chatpata Chana 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511939,
                group_name:
                  "Choose From Choice of Bread for Chatpata Chana 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511940,
                group_name:
                  "Choose From Choice of Preparation for Chatpata Chana 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511941,
                group_name:
                  "Choose From Choice of Preparation for Chatpata Chana 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511942,
                group_name:
                  "Choose From Add Ons for Chatpata Chana 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511943,
                group_name:
                  "Choose From Add Ons for Chatpata Chana 30cm (Footlong)",
                choices: [
                  {
                    id: 58693310,
                    name: "Extra Chatpata Chana Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 11,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511944,
                group_name:
                  "Choose From Choice of Vegetable for Chatpata Chana 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511945,
                group_name:
                  "Choose From Choice of Vegetable for Chatpata Chana 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511946,
                group_name:
                  "Choose From Choice of Sauces for Chatpata Chana 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511947,
                group_name:
                  "Choose From Choice of Sauces for Chatpata Chana 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78063969,
                group_name:
                  "Choose From Offers @99 for Chatpata Chana 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78063968,
                group_name:
                  "Choose From Offers @99 for Chatpata Chana 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 20500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240461": {
            id: 107240461,
            name: "Corn & Peas Sandwich",
            category: "Sandwiches",
            description:
              "A delicious assortment of green peas, golden corn and diced carrots, dressed with a creamy mixture of eggless mayo sauce, and served on your favourite bread.",
            cloudinaryImageId: "vbm0zd4clcudhr8kieyn",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271302",
                  name: "Choose from Corn & Peas Sandwich",
                  variations: [
                    {
                      name: "Corn & Peas 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808296",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271302",
                      order: 2,
                    },
                    {
                      name: "Corn & Peas 30cm (Footlong)",
                      price: 145,
                      default: 0,
                      id: "75808297",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271302",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271302", variation_id: "75808296" },
                  ],
                  price: 20500,
                  addon_combinations: [
                    { group_id: "73511952", addon_id: "58693369" },
                    { group_id: "73511952", addon_id: "58693190" },
                    { group_id: "73511952", addon_id: "58693191" },
                    { group_id: "73511956", addon_id: "58693195" },
                    { group_id: "73511956", addon_id: "58693270" },
                    { group_id: "73511956", addon_id: "58693271" },
                    { group_id: "73511956", addon_id: "58693272" },
                    { group_id: "73511956", addon_id: "58693273" },
                    { group_id: "73511956", addon_id: "58693274" },
                    { group_id: "73511956", addon_id: "58693275" },
                    { group_id: "73511956", addon_id: "58693276" },
                    { group_id: "73511956", addon_id: "58693277" },
                    { group_id: "73511950", addon_id: "58693179" },
                    { group_id: "73511950", addon_id: "58693180" },
                    { group_id: "73511950", addon_id: "58693181" },
                    { group_id: "73511950", addon_id: "58693182" },
                    { group_id: "73511950", addon_id: "58693183" },
                    { group_id: "73511954", addon_id: "58693251" },
                    { group_id: "73511954", addon_id: "58693252" },
                    { group_id: "73511954", addon_id: "58693253" },
                    { group_id: "73511954", addon_id: "58693254" },
                    { group_id: "73511954", addon_id: "58693255" },
                    { group_id: "73511954", addon_id: "58693256" },
                    { group_id: "73511954", addon_id: "58693257" },
                    { group_id: "73511954", addon_id: "58693258" },
                    { group_id: "73511954", addon_id: "58693259" },
                    { group_id: "73511948", addon_id: "58693169" },
                    { group_id: "73511948", addon_id: "58693170" },
                    { group_id: "73511948", addon_id: "58693171" },
                    { group_id: "73511948", addon_id: "58693172" },
                    { group_id: "73511948", addon_id: "58693173" },
                    { group_id: "78063972", addon_id: "62937803" },
                    { group_id: "78063972", addon_id: "62937804" },
                    { group_id: "78063972", addon_id: "62937805" },
                    { group_id: "78063972", addon_id: "62937806" },
                    { group_id: "78063972", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271302", variation_id: "75808297" },
                  ],
                  price: 35000,
                  addon_combinations: [
                    { group_id: "73511953", addon_id: "58693372" },
                    { group_id: "73511953", addon_id: "58693193" },
                    { group_id: "73511953", addon_id: "58693194" },
                    { group_id: "73511957", addon_id: "58693195" },
                    { group_id: "73511957", addon_id: "58693270" },
                    { group_id: "73511957", addon_id: "58693271" },
                    { group_id: "73511957", addon_id: "58693272" },
                    { group_id: "73511957", addon_id: "58693273" },
                    { group_id: "73511957", addon_id: "58693274" },
                    { group_id: "73511957", addon_id: "58693275" },
                    { group_id: "73511957", addon_id: "58693276" },
                    { group_id: "73511957", addon_id: "58693277" },
                    { group_id: "73511949", addon_id: "58693174" },
                    { group_id: "73511949", addon_id: "58693175" },
                    { group_id: "73511949", addon_id: "58693176" },
                    { group_id: "73511949", addon_id: "58693177" },
                    { group_id: "73511949", addon_id: "58693178" },
                    { group_id: "73511951", addon_id: "58693179" },
                    { group_id: "73511951", addon_id: "58693180" },
                    { group_id: "73511951", addon_id: "58693181" },
                    { group_id: "73511951", addon_id: "58693182" },
                    { group_id: "73511951", addon_id: "58693183" },
                    { group_id: "73511955", addon_id: "58693251" },
                    { group_id: "73511955", addon_id: "58693252" },
                    { group_id: "73511955", addon_id: "58693253" },
                    { group_id: "73511955", addon_id: "58693254" },
                    { group_id: "73511955", addon_id: "58693255" },
                    { group_id: "73511955", addon_id: "58693256" },
                    { group_id: "73511955", addon_id: "58693257" },
                    { group_id: "73511955", addon_id: "58693258" },
                    { group_id: "73511955", addon_id: "58693259" },
                    { group_id: "78063973", addon_id: "62937803" },
                    { group_id: "78063973", addon_id: "62937804" },
                    { group_id: "78063973", addon_id: "62937805" },
                    { group_id: "78063973", addon_id: "62937806" },
                    { group_id: "78063973", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511948,
                group_name:
                  "Choose From Choice of Bread for Corn & Peas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511949,
                group_name:
                  "Choose From Choice of Bread for Corn & Peas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511950,
                group_name:
                  "Choose From Choice of Preparation for Corn & Peas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511951,
                group_name:
                  "Choose From Choice of Preparation for Corn & Peas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511952,
                group_name:
                  "Choose From Add Ons for Corn & Peas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511953,
                group_name:
                  "Choose From Add Ons for Corn & Peas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693372,
                    name: "Extra Corn & Peas Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511954,
                group_name:
                  "Choose From Choice of Vegetable for Corn & Peas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511955,
                group_name:
                  "Choose From Choice of Vegetable for Corn & Peas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511956,
                group_name:
                  "Choose From Choice of Sauces for Corn & Peas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511957,
                group_name:
                  "Choose From Choice of Sauces for Corn & Peas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78063973,
                group_name:
                  "Choose From Offers @99 for Corn & Peas 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78063972,
                group_name:
                  "Choose From Offers @99 for Corn & Peas 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 20500,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240462": {
            id: 107240462,
            name: "Hara Bhara Patty Sandwich",
            category: "Sandwiches",
            description:
              "The goodness of a nutritious spinach and green peas based kebab combined with your favourite veggies and sauces served on a bread of your choice.",
            cloudinaryImageId: "vedu6vn6zgtbfk9bggtv",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271303",
                  name: "Choose from Hara Bhara Patty Sandwich",
                  variations: [
                    {
                      name: "Hara Bhara Kabab 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808298",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271303",
                      order: 2,
                    },
                    {
                      name: "Hara Bhara Kabab 30cm (Footlong)",
                      price: 160,
                      default: 0,
                      id: "75808299",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271303",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271303", variation_id: "75808298" },
                  ],
                  price: 22500,
                  addon_combinations: [
                    { group_id: "73511962", addon_id: "58693431" },
                    { group_id: "73511962", addon_id: "58693190" },
                    { group_id: "73511962", addon_id: "58693191" },
                    { group_id: "73511966", addon_id: "58693195" },
                    { group_id: "73511966", addon_id: "58693270" },
                    { group_id: "73511966", addon_id: "58693271" },
                    { group_id: "73511966", addon_id: "58693272" },
                    { group_id: "73511966", addon_id: "58693273" },
                    { group_id: "73511966", addon_id: "58693274" },
                    { group_id: "73511966", addon_id: "58693275" },
                    { group_id: "73511966", addon_id: "58693276" },
                    { group_id: "73511966", addon_id: "58693277" },
                    { group_id: "73511960", addon_id: "58693179" },
                    { group_id: "73511960", addon_id: "58693180" },
                    { group_id: "73511960", addon_id: "58693181" },
                    { group_id: "73511960", addon_id: "58693182" },
                    { group_id: "73511960", addon_id: "58693183" },
                    { group_id: "73511964", addon_id: "58693251" },
                    { group_id: "73511964", addon_id: "58693252" },
                    { group_id: "73511964", addon_id: "58693253" },
                    { group_id: "73511964", addon_id: "58693254" },
                    { group_id: "73511964", addon_id: "58693255" },
                    { group_id: "73511964", addon_id: "58693256" },
                    { group_id: "73511964", addon_id: "58693257" },
                    { group_id: "73511964", addon_id: "58693258" },
                    { group_id: "73511964", addon_id: "58693259" },
                    { group_id: "73511958", addon_id: "58693169" },
                    { group_id: "73511958", addon_id: "58693170" },
                    { group_id: "73511958", addon_id: "58693171" },
                    { group_id: "73511958", addon_id: "58693172" },
                    { group_id: "73511958", addon_id: "58693173" },
                    { group_id: "78063976", addon_id: "62937803" },
                    { group_id: "78063976", addon_id: "62937804" },
                    { group_id: "78063976", addon_id: "62937805" },
                    { group_id: "78063976", addon_id: "62937806" },
                    { group_id: "78063976", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271303", variation_id: "75808299" },
                  ],
                  price: 38500,
                  addon_combinations: [
                    { group_id: "73511963", addon_id: "58693434" },
                    { group_id: "73511963", addon_id: "58693193" },
                    { group_id: "73511963", addon_id: "58693194" },
                    { group_id: "73511967", addon_id: "58693195" },
                    { group_id: "73511967", addon_id: "58693270" },
                    { group_id: "73511967", addon_id: "58693271" },
                    { group_id: "73511967", addon_id: "58693272" },
                    { group_id: "73511967", addon_id: "58693273" },
                    { group_id: "73511967", addon_id: "58693274" },
                    { group_id: "73511967", addon_id: "58693275" },
                    { group_id: "73511967", addon_id: "58693276" },
                    { group_id: "73511967", addon_id: "58693277" },
                    { group_id: "73511959", addon_id: "58693174" },
                    { group_id: "73511959", addon_id: "58693175" },
                    { group_id: "73511959", addon_id: "58693176" },
                    { group_id: "73511959", addon_id: "58693177" },
                    { group_id: "73511959", addon_id: "58693178" },
                    { group_id: "73511961", addon_id: "58693179" },
                    { group_id: "73511961", addon_id: "58693180" },
                    { group_id: "73511961", addon_id: "58693181" },
                    { group_id: "73511961", addon_id: "58693182" },
                    { group_id: "73511961", addon_id: "58693183" },
                    { group_id: "73511965", addon_id: "58693251" },
                    { group_id: "73511965", addon_id: "58693252" },
                    { group_id: "73511965", addon_id: "58693253" },
                    { group_id: "73511965", addon_id: "58693254" },
                    { group_id: "73511965", addon_id: "58693255" },
                    { group_id: "73511965", addon_id: "58693256" },
                    { group_id: "73511965", addon_id: "58693257" },
                    { group_id: "73511965", addon_id: "58693258" },
                    { group_id: "73511965", addon_id: "58693259" },
                    { group_id: "78063977", addon_id: "62937803" },
                    { group_id: "78063977", addon_id: "62937804" },
                    { group_id: "78063977", addon_id: "62937805" },
                    { group_id: "78063977", addon_id: "62937806" },
                    { group_id: "78063977", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511958,
                group_name:
                  "Choose From Choice of Bread for Hara Bhara Kabab 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511959,
                group_name:
                  "Choose From Choice of Bread for Hara Bhara Kabab 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511960,
                group_name:
                  "Choose From Choice of Preparation for Hara Bhara Kabab 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511961,
                group_name:
                  "Choose From Choice of Preparation for Hara Bhara Kabab 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511962,
                group_name:
                  "Choose From Add Ons for Hara Bhara Kabab 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693431,
                    name: "Extra Hara Bhara Kebab",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511963,
                group_name:
                  "Choose From Add Ons for Hara Bhara Kabab 30cm (Footlong)",
                choices: [
                  {
                    id: 58693434,
                    name: "Extra Hara Bhara Kebab Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511964,
                group_name:
                  "Choose From Choice of Vegetable for Hara Bhara Kabab 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511965,
                group_name:
                  "Choose From Choice of Vegetable for Hara Bhara Kabab 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511966,
                group_name:
                  "Choose From Choice of Sauces for Hara Bhara Kabab 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511967,
                group_name:
                  "Choose From Choice of Sauces for Hara Bhara Kabab 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78063977,
                group_name:
                  "Choose From Offers @99 for Hara Bhara Kabab 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78063976,
                group_name:
                  "Choose From Offers @99 for Hara Bhara Kabab 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 22500,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240463": {
            id: 107240463,
            name: "Mexican Patty Sandwich",
            category: "Sandwiches",
            description:
              "A refreshing filling of red and black kidney beans patty topped with aromatic seasoning along with your choice of veggies and sauces served on a freshly baked bread.",
            cloudinaryImageId: "ifrqxvdx0codj6e6afqr",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271304",
                  name: "Choose from Mexican Patty Sandwich",
                  variations: [
                    {
                      name: "Mexican Bean Patty 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808300",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271304",
                      order: 2,
                    },
                    {
                      name: "Mexican Bean Patty 30cm (Footlong)",
                      price: 160,
                      default: 0,
                      id: "75808301",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271304",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271304", variation_id: "75808300" },
                  ],
                  price: 22500,
                  addon_combinations: [
                    { group_id: "73511972", addon_id: "58693493" },
                    { group_id: "73511972", addon_id: "58693190" },
                    { group_id: "73511972", addon_id: "58693191" },
                    { group_id: "73511976", addon_id: "58693195" },
                    { group_id: "73511976", addon_id: "58693270" },
                    { group_id: "73511976", addon_id: "58693271" },
                    { group_id: "73511976", addon_id: "58693272" },
                    { group_id: "73511976", addon_id: "58693273" },
                    { group_id: "73511976", addon_id: "58693274" },
                    { group_id: "73511976", addon_id: "58693275" },
                    { group_id: "73511976", addon_id: "58693276" },
                    { group_id: "73511976", addon_id: "58693277" },
                    { group_id: "73511970", addon_id: "58693179" },
                    { group_id: "73511970", addon_id: "58693180" },
                    { group_id: "73511970", addon_id: "58693181" },
                    { group_id: "73511970", addon_id: "58693182" },
                    { group_id: "73511970", addon_id: "58693183" },
                    { group_id: "73511974", addon_id: "58693251" },
                    { group_id: "73511974", addon_id: "58693252" },
                    { group_id: "73511974", addon_id: "58693253" },
                    { group_id: "73511974", addon_id: "58693254" },
                    { group_id: "73511974", addon_id: "58693255" },
                    { group_id: "73511974", addon_id: "58693256" },
                    { group_id: "73511974", addon_id: "58693257" },
                    { group_id: "73511974", addon_id: "58693258" },
                    { group_id: "73511974", addon_id: "58693259" },
                    { group_id: "73511968", addon_id: "58693169" },
                    { group_id: "73511968", addon_id: "58693170" },
                    { group_id: "73511968", addon_id: "58693171" },
                    { group_id: "73511968", addon_id: "58693172" },
                    { group_id: "73511968", addon_id: "58693173" },
                    { group_id: "78063980", addon_id: "62937803" },
                    { group_id: "78063980", addon_id: "62937804" },
                    { group_id: "78063980", addon_id: "62937805" },
                    { group_id: "78063980", addon_id: "62937806" },
                    { group_id: "78063980", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271304", variation_id: "75808301" },
                  ],
                  price: 38500,
                  addon_combinations: [
                    { group_id: "73511973", addon_id: "58693496" },
                    { group_id: "73511973", addon_id: "58693193" },
                    { group_id: "73511973", addon_id: "58693194" },
                    { group_id: "73511977", addon_id: "58693195" },
                    { group_id: "73511977", addon_id: "58693270" },
                    { group_id: "73511977", addon_id: "58693271" },
                    { group_id: "73511977", addon_id: "58693272" },
                    { group_id: "73511977", addon_id: "58693273" },
                    { group_id: "73511977", addon_id: "58693274" },
                    { group_id: "73511977", addon_id: "58693275" },
                    { group_id: "73511977", addon_id: "58693276" },
                    { group_id: "73511977", addon_id: "58693277" },
                    { group_id: "73511969", addon_id: "58693174" },
                    { group_id: "73511969", addon_id: "58693175" },
                    { group_id: "73511969", addon_id: "58693176" },
                    { group_id: "73511969", addon_id: "58693177" },
                    { group_id: "73511969", addon_id: "58693178" },
                    { group_id: "73511971", addon_id: "58693179" },
                    { group_id: "73511971", addon_id: "58693180" },
                    { group_id: "73511971", addon_id: "58693181" },
                    { group_id: "73511971", addon_id: "58693182" },
                    { group_id: "73511971", addon_id: "58693183" },
                    { group_id: "73511975", addon_id: "58693251" },
                    { group_id: "73511975", addon_id: "58693252" },
                    { group_id: "73511975", addon_id: "58693253" },
                    { group_id: "73511975", addon_id: "58693254" },
                    { group_id: "73511975", addon_id: "58693255" },
                    { group_id: "73511975", addon_id: "58693256" },
                    { group_id: "73511975", addon_id: "58693257" },
                    { group_id: "73511975", addon_id: "58693258" },
                    { group_id: "73511975", addon_id: "58693259" },
                    { group_id: "78063981", addon_id: "62937803" },
                    { group_id: "78063981", addon_id: "62937804" },
                    { group_id: "78063981", addon_id: "62937805" },
                    { group_id: "78063981", addon_id: "62937806" },
                    { group_id: "78063981", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511968,
                group_name:
                  "Choose From Choice of Bread for Mexican Bean Patty 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511969,
                group_name:
                  "Choose From Choice of Bread for Mexican Bean Patty 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511970,
                group_name:
                  "Choose From Choice of Preparation for Mexican Bean Patty 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511971,
                group_name:
                  "Choose From Choice of Preparation for Mexican Bean Patty 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511972,
                group_name:
                  "Choose From Add Ons for Mexican Bean Patty 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511973,
                group_name:
                  "Choose From Add Ons for Mexican Bean Patty 30cm (Footlong)",
                choices: [
                  {
                    id: 58693496,
                    name: "Extra Mexican Bean Patty Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511974,
                group_name:
                  "Choose From Choice of Vegetable for Mexican Bean Patty 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511975,
                group_name:
                  "Choose From Choice of Vegetable for Mexican Bean Patty 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511976,
                group_name:
                  "Choose From Choice of Sauces for Mexican Bean Patty 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511977,
                group_name:
                  "Choose From Choice of Sauces for Mexican Bean Patty 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78063981,
                group_name:
                  "Choose From Offers @99 for Mexican Bean Patty 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78063980,
                group_name:
                  "Choose From Offers @99 for Mexican Bean Patty 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 22500,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240464": {
            id: 107240464,
            name: "Paneer Tikka Sandwich",
            category: "Sandwiches",
            description:
              "Your favourite cheese cubes marinated with tandoori sauce, spices and condiments, cooked in an oven to give a smoky taste. Served with a choice of nutritious veggies and a freshly baked bread.",
            cloudinaryImageId: "foahfvdyjahz4c0h84ou",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271305",
                  name: "Choose from Paneer Tikka Sandwich",
                  variations: [
                    {
                      name: "Paneer Tikka 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808302",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271305",
                      order: 2,
                    },
                    {
                      name: "Paneer Tikka 30cm (Footlong)",
                      price: 190,
                      default: 0,
                      id: "75808303",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271305",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271305", variation_id: "75808302" },
                  ],
                  price: 23500,
                  addon_combinations: [
                    { group_id: "73511982", addon_id: "58693535" },
                    { group_id: "73511982", addon_id: "58693190" },
                    { group_id: "73511982", addon_id: "58693191" },
                    { group_id: "73511986", addon_id: "58693195" },
                    { group_id: "73511986", addon_id: "58693270" },
                    { group_id: "73511986", addon_id: "58693271" },
                    { group_id: "73511986", addon_id: "58693272" },
                    { group_id: "73511986", addon_id: "58693273" },
                    { group_id: "73511986", addon_id: "58693274" },
                    { group_id: "73511986", addon_id: "58693275" },
                    { group_id: "73511986", addon_id: "58693276" },
                    { group_id: "73511986", addon_id: "58693277" },
                    { group_id: "73511980", addon_id: "58693179" },
                    { group_id: "73511980", addon_id: "58693180" },
                    { group_id: "73511980", addon_id: "58693181" },
                    { group_id: "73511980", addon_id: "58693182" },
                    { group_id: "73511980", addon_id: "58693183" },
                    { group_id: "73511984", addon_id: "58693251" },
                    { group_id: "73511984", addon_id: "58693252" },
                    { group_id: "73511984", addon_id: "58693253" },
                    { group_id: "73511984", addon_id: "58693254" },
                    { group_id: "73511984", addon_id: "58693255" },
                    { group_id: "73511984", addon_id: "58693256" },
                    { group_id: "73511984", addon_id: "58693257" },
                    { group_id: "73511984", addon_id: "58693258" },
                    { group_id: "73511984", addon_id: "58693259" },
                    { group_id: "73511978", addon_id: "58693169" },
                    { group_id: "73511978", addon_id: "58693170" },
                    { group_id: "73511978", addon_id: "58693171" },
                    { group_id: "73511978", addon_id: "58693172" },
                    { group_id: "73511978", addon_id: "58693173" },
                    { group_id: "78064016", addon_id: "62937803" },
                    { group_id: "78064016", addon_id: "62937804" },
                    { group_id: "78064016", addon_id: "62937805" },
                    { group_id: "78064016", addon_id: "62937806" },
                    { group_id: "78064016", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271305", variation_id: "75808303" },
                  ],
                  price: 42500,
                  addon_combinations: [
                    { group_id: "73511983", addon_id: "58693536" },
                    { group_id: "73511983", addon_id: "58693193" },
                    { group_id: "73511983", addon_id: "58693194" },
                    { group_id: "73511987", addon_id: "58693195" },
                    { group_id: "73511987", addon_id: "58693270" },
                    { group_id: "73511987", addon_id: "58693271" },
                    { group_id: "73511987", addon_id: "58693272" },
                    { group_id: "73511987", addon_id: "58693273" },
                    { group_id: "73511987", addon_id: "58693274" },
                    { group_id: "73511987", addon_id: "58693275" },
                    { group_id: "73511987", addon_id: "58693276" },
                    { group_id: "73511987", addon_id: "58693277" },
                    { group_id: "73511979", addon_id: "58693174" },
                    { group_id: "73511979", addon_id: "58693175" },
                    { group_id: "73511979", addon_id: "58693176" },
                    { group_id: "73511979", addon_id: "58693177" },
                    { group_id: "73511979", addon_id: "58693178" },
                    { group_id: "73511981", addon_id: "58693179" },
                    { group_id: "73511981", addon_id: "58693180" },
                    { group_id: "73511981", addon_id: "58693181" },
                    { group_id: "73511981", addon_id: "58693182" },
                    { group_id: "73511981", addon_id: "58693183" },
                    { group_id: "73511985", addon_id: "58693251" },
                    { group_id: "73511985", addon_id: "58693252" },
                    { group_id: "73511985", addon_id: "58693253" },
                    { group_id: "73511985", addon_id: "58693254" },
                    { group_id: "73511985", addon_id: "58693255" },
                    { group_id: "73511985", addon_id: "58693256" },
                    { group_id: "73511985", addon_id: "58693257" },
                    { group_id: "73511985", addon_id: "58693258" },
                    { group_id: "73511985", addon_id: "58693259" },
                    { group_id: "78064018", addon_id: "62937803" },
                    { group_id: "78064018", addon_id: "62937804" },
                    { group_id: "78064018", addon_id: "62937805" },
                    { group_id: "78064018", addon_id: "62937806" },
                    { group_id: "78064018", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511978,
                group_name:
                  "Choose From Choice of Bread for Paneer Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511979,
                group_name:
                  "Choose From Choice of Bread for Paneer Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511980,
                group_name:
                  "Choose From Choice of Preparation for Paneer Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511981,
                group_name:
                  "Choose From Choice of Preparation for Paneer Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511982,
                group_name:
                  "Choose From Add Ons for Paneer Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511983,
                group_name:
                  "Choose From Add Ons for Paneer Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693536,
                    name: "Extra Paneer Tikka Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511984,
                group_name:
                  "Choose From Choice of Vegetable for Paneer Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511985,
                group_name:
                  "Choose From Choice of Vegetable for Paneer Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511986,
                group_name:
                  "Choose From Choice of Sauces for Paneer Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511987,
                group_name:
                  "Choose From Choice of Sauces for Paneer Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064018,
                group_name:
                  "Choose From Offers @99 for Paneer Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064016,
                group_name:
                  "Choose From Offers @99 for Paneer Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 23500,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240465": {
            id: 107240465,
            name: "Tandoori Tofu Sandwich",
            category: "Sandwiches",
            description:
              "Soft diced tofu marinated with tandoori sauce, spices and condiments, cooked in an oven. Served with a choice of nutritious veggies on your favourite bread.",
            cloudinaryImageId: "nzeegsl6wlqyijo2ub8y",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271306",
                  name: "Choose from Tandoori Tofu Sandwich",
                  variations: [
                    {
                      name: "Tandoori Tofu 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808304",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271306",
                      order: 2,
                    },
                    {
                      name: "Tandoori Tofu 30cm (Footlong)",
                      price: 190,
                      default: 0,
                      id: "75808305",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271306",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271306", variation_id: "75808304" },
                  ],
                  price: 22500,
                  addon_combinations: [
                    { group_id: "73511992", addon_id: "58693537" },
                    { group_id: "73511992", addon_id: "58693190" },
                    { group_id: "73511992", addon_id: "58693191" },
                    { group_id: "73511997", addon_id: "58693195" },
                    { group_id: "73511997", addon_id: "58693270" },
                    { group_id: "73511997", addon_id: "58693271" },
                    { group_id: "73511997", addon_id: "58693272" },
                    { group_id: "73511997", addon_id: "58693273" },
                    { group_id: "73511997", addon_id: "58693274" },
                    { group_id: "73511997", addon_id: "58693275" },
                    { group_id: "73511997", addon_id: "58693276" },
                    { group_id: "73511997", addon_id: "58693277" },
                    { group_id: "73511990", addon_id: "58693179" },
                    { group_id: "73511990", addon_id: "58693180" },
                    { group_id: "73511990", addon_id: "58693181" },
                    { group_id: "73511990", addon_id: "58693182" },
                    { group_id: "73511990", addon_id: "58693183" },
                    { group_id: "73511995", addon_id: "58693251" },
                    { group_id: "73511995", addon_id: "58693252" },
                    { group_id: "73511995", addon_id: "58693253" },
                    { group_id: "73511995", addon_id: "58693254" },
                    { group_id: "73511995", addon_id: "58693255" },
                    { group_id: "73511995", addon_id: "58693256" },
                    { group_id: "73511995", addon_id: "58693257" },
                    { group_id: "73511995", addon_id: "58693258" },
                    { group_id: "73511995", addon_id: "58693259" },
                    { group_id: "73511988", addon_id: "58693169" },
                    { group_id: "73511988", addon_id: "58693170" },
                    { group_id: "73511988", addon_id: "58693171" },
                    { group_id: "73511988", addon_id: "58693172" },
                    { group_id: "73511988", addon_id: "58693173" },
                    { group_id: "78064020", addon_id: "62937803" },
                    { group_id: "78064020", addon_id: "62937804" },
                    { group_id: "78064020", addon_id: "62937805" },
                    { group_id: "78064020", addon_id: "62937806" },
                    { group_id: "78064020", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271306", variation_id: "75808305" },
                  ],
                  price: 41500,
                  addon_combinations: [
                    { group_id: "73511993", addon_id: "58693538" },
                    { group_id: "73511993", addon_id: "58693193" },
                    { group_id: "73511993", addon_id: "58693194" },
                    { group_id: "73511996", addon_id: "58693195" },
                    { group_id: "73511996", addon_id: "58693270" },
                    { group_id: "73511996", addon_id: "58693271" },
                    { group_id: "73511996", addon_id: "58693272" },
                    { group_id: "73511996", addon_id: "58693273" },
                    { group_id: "73511996", addon_id: "58693274" },
                    { group_id: "73511996", addon_id: "58693275" },
                    { group_id: "73511996", addon_id: "58693276" },
                    { group_id: "73511996", addon_id: "58693277" },
                    { group_id: "73511989", addon_id: "58693174" },
                    { group_id: "73511989", addon_id: "58693175" },
                    { group_id: "73511989", addon_id: "58693176" },
                    { group_id: "73511989", addon_id: "58693177" },
                    { group_id: "73511989", addon_id: "58693178" },
                    { group_id: "73511991", addon_id: "58693179" },
                    { group_id: "73511991", addon_id: "58693180" },
                    { group_id: "73511991", addon_id: "58693181" },
                    { group_id: "73511991", addon_id: "58693182" },
                    { group_id: "73511991", addon_id: "58693183" },
                    { group_id: "73511994", addon_id: "58693251" },
                    { group_id: "73511994", addon_id: "58693252" },
                    { group_id: "73511994", addon_id: "58693253" },
                    { group_id: "73511994", addon_id: "58693254" },
                    { group_id: "73511994", addon_id: "58693255" },
                    { group_id: "73511994", addon_id: "58693256" },
                    { group_id: "73511994", addon_id: "58693257" },
                    { group_id: "73511994", addon_id: "58693258" },
                    { group_id: "73511994", addon_id: "58693259" },
                    { group_id: "78064022", addon_id: "62937803" },
                    { group_id: "78064022", addon_id: "62937804" },
                    { group_id: "78064022", addon_id: "62937805" },
                    { group_id: "78064022", addon_id: "62937806" },
                    { group_id: "78064022", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511988,
                group_name:
                  "Choose From Choice of Bread for Tandoori Tofu 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511989,
                group_name:
                  "Choose From Choice of Bread for Tandoori Tofu 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511991,
                group_name:
                  "Choose From Choice of Preparation for Tandoori Tofu 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511990,
                group_name:
                  "Choose From Choice of Preparation for Tandoori Tofu 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73511992,
                group_name:
                  "Choose From Add Ons for Tandoori Tofu 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511993,
                group_name:
                  "Choose From Add Ons for Tandoori Tofu 30cm (Footlong)",
                choices: [
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693538,
                    name: "Extra Tandoori Tofu Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73511994,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Tofu 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511995,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Tofu 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73511996,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Tofu 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73511997,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Tofu 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064022,
                group_name:
                  "Choose From Offers @99 for Tandoori Tofu 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064020,
                group_name:
                  "Choose From Offers @99 for Tandoori Tofu 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 22500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240466": {
            id: 107240466,
            name: "Veg Shammi Sandwich",
            category: "Sandwiches",
            description:
              "Experience authentic flavours with a kebab made of lentils and enriched with mouth-watering hints of garlic and onion accompanied by nutritious veggies, in your favourite bread.",
            cloudinaryImageId: "ym6swckdq8jx4rifqqvc",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271307",
                  name: "Choose from Veg Shammi Sandwich",
                  variations: [
                    {
                      name: "Veg Shammi 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808306",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271307",
                      order: 2,
                    },
                    {
                      name: "Veg Shammi 30cm (Footlong)",
                      price: 190,
                      default: 0,
                      id: "75808307",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271307",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271307", variation_id: "75808306" },
                  ],
                  price: 22500,
                  addon_combinations: [
                    { group_id: "73512002", addon_id: "58693539" },
                    { group_id: "73512002", addon_id: "58693190" },
                    { group_id: "73512002", addon_id: "58693191" },
                    { group_id: "73512006", addon_id: "58693195" },
                    { group_id: "73512006", addon_id: "58693270" },
                    { group_id: "73512006", addon_id: "58693271" },
                    { group_id: "73512006", addon_id: "58693272" },
                    { group_id: "73512006", addon_id: "58693273" },
                    { group_id: "73512006", addon_id: "58693274" },
                    { group_id: "73512006", addon_id: "58693275" },
                    { group_id: "73512006", addon_id: "58693276" },
                    { group_id: "73512006", addon_id: "58693277" },
                    { group_id: "73512000", addon_id: "58693179" },
                    { group_id: "73512000", addon_id: "58693180" },
                    { group_id: "73512000", addon_id: "58693181" },
                    { group_id: "73512000", addon_id: "58693182" },
                    { group_id: "73512000", addon_id: "58693183" },
                    { group_id: "73512004", addon_id: "58693251" },
                    { group_id: "73512004", addon_id: "58693252" },
                    { group_id: "73512004", addon_id: "58693253" },
                    { group_id: "73512004", addon_id: "58693254" },
                    { group_id: "73512004", addon_id: "58693255" },
                    { group_id: "73512004", addon_id: "58693256" },
                    { group_id: "73512004", addon_id: "58693257" },
                    { group_id: "73512004", addon_id: "58693258" },
                    { group_id: "73512004", addon_id: "58693259" },
                    { group_id: "73511998", addon_id: "58693169" },
                    { group_id: "73511998", addon_id: "58693170" },
                    { group_id: "73511998", addon_id: "58693171" },
                    { group_id: "73511998", addon_id: "58693172" },
                    { group_id: "73511998", addon_id: "58693173" },
                    { group_id: "78064024", addon_id: "62937803" },
                    { group_id: "78064024", addon_id: "62937804" },
                    { group_id: "78064024", addon_id: "62937805" },
                    { group_id: "78064024", addon_id: "62937806" },
                    { group_id: "78064024", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271307", variation_id: "75808307" },
                  ],
                  price: 41500,
                  addon_combinations: [
                    { group_id: "73512003", addon_id: "58693540" },
                    { group_id: "73512003", addon_id: "58693193" },
                    { group_id: "73512003", addon_id: "58693194" },
                    { group_id: "73512007", addon_id: "58693195" },
                    { group_id: "73512007", addon_id: "58693270" },
                    { group_id: "73512007", addon_id: "58693271" },
                    { group_id: "73512007", addon_id: "58693272" },
                    { group_id: "73512007", addon_id: "58693273" },
                    { group_id: "73512007", addon_id: "58693274" },
                    { group_id: "73512007", addon_id: "58693275" },
                    { group_id: "73512007", addon_id: "58693276" },
                    { group_id: "73512007", addon_id: "58693277" },
                    { group_id: "73511999", addon_id: "58693174" },
                    { group_id: "73511999", addon_id: "58693175" },
                    { group_id: "73511999", addon_id: "58693176" },
                    { group_id: "73511999", addon_id: "58693177" },
                    { group_id: "73511999", addon_id: "58693178" },
                    { group_id: "73512001", addon_id: "58693179" },
                    { group_id: "73512001", addon_id: "58693180" },
                    { group_id: "73512001", addon_id: "58693181" },
                    { group_id: "73512001", addon_id: "58693182" },
                    { group_id: "73512001", addon_id: "58693183" },
                    { group_id: "73512005", addon_id: "58693251" },
                    { group_id: "73512005", addon_id: "58693252" },
                    { group_id: "73512005", addon_id: "58693253" },
                    { group_id: "73512005", addon_id: "58693254" },
                    { group_id: "73512005", addon_id: "58693255" },
                    { group_id: "73512005", addon_id: "58693256" },
                    { group_id: "73512005", addon_id: "58693257" },
                    { group_id: "73512005", addon_id: "58693258" },
                    { group_id: "73512005", addon_id: "58693259" },
                    { group_id: "78064025", addon_id: "62937803" },
                    { group_id: "78064025", addon_id: "62937804" },
                    { group_id: "78064025", addon_id: "62937805" },
                    { group_id: "78064025", addon_id: "62937806" },
                    { group_id: "78064025", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73511998,
                group_name:
                  "Choose From Choice of Bread for Veg Shammi 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73511999,
                group_name:
                  "Choose From Choice of Bread for Veg Shammi 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512001,
                group_name:
                  "Choose From Choice of Preparation for Veg Shammi 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512000,
                group_name:
                  "Choose From Choice of Preparation for Veg Shammi 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512003,
                group_name:
                  "Choose From Add Ons for Veg Shammi 30cm (Footlong)",
                choices: [
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693540,
                    name: "Extra Veg Shammi Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512002,
                group_name:
                  "Choose From Add Ons for Veg Shammi 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693539,
                    name: "Extra Veg Shammi",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512005,
                group_name:
                  "Choose From Choice of Vegetable for Veg Shammi 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512004,
                group_name:
                  "Choose From Choice of Vegetable for Veg Shammi 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512007,
                group_name:
                  "Choose From Choice of Sauces for Veg Shammi 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512006,
                group_name:
                  "Choose From Choice of Sauces for Veg Shammi 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064025,
                group_name:
                  "Choose From Offers @99 for Veg Shammi 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064024,
                group_name:
                  "Choose From Offers @99 for Veg Shammi 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 22500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240467": {
            id: 107240467,
            name: "Veggie Delite® Sandwich",
            category: "Sandwiches",
            description:
              "Delicious combination of fresh lettuce, tomatoes, green peppers, onions, olives and pickles served on a freshly baked bread.",
            cloudinaryImageId: "h87dzx0vlpmyvbcfahql",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271308",
                  name: "Choose from Veggie Delite® Sandwich",
                  variations: [
                    {
                      name: "Veggie Delite 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808308",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271308",
                      order: 2,
                    },
                    {
                      name: "Veggie Delite 30cm (Footlong)",
                      price: 140,
                      default: 0,
                      id: "75808309",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271308",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271308", variation_id: "75808308" },
                  ],
                  price: 19500,
                  addon_combinations: [
                    { group_id: "73512012", addon_id: "58693190" },
                    { group_id: "73512012", addon_id: "58693191" },
                    { group_id: "73512012", addon_id: "58693219" },
                    { group_id: "73512016", addon_id: "58693195" },
                    { group_id: "73512016", addon_id: "58693270" },
                    { group_id: "73512016", addon_id: "58693271" },
                    { group_id: "73512016", addon_id: "58693272" },
                    { group_id: "73512016", addon_id: "58693273" },
                    { group_id: "73512016", addon_id: "58693274" },
                    { group_id: "73512016", addon_id: "58693275" },
                    { group_id: "73512016", addon_id: "58693276" },
                    { group_id: "73512016", addon_id: "58693277" },
                    { group_id: "73512010", addon_id: "58693179" },
                    { group_id: "73512010", addon_id: "58693180" },
                    { group_id: "73512010", addon_id: "58693181" },
                    { group_id: "73512010", addon_id: "58693182" },
                    { group_id: "73512010", addon_id: "58693183" },
                    { group_id: "73512014", addon_id: "58693251" },
                    { group_id: "73512014", addon_id: "58693252" },
                    { group_id: "73512014", addon_id: "58693253" },
                    { group_id: "73512014", addon_id: "58693254" },
                    { group_id: "73512014", addon_id: "58693255" },
                    { group_id: "73512014", addon_id: "58693256" },
                    { group_id: "73512014", addon_id: "58693257" },
                    { group_id: "73512014", addon_id: "58693258" },
                    { group_id: "73512014", addon_id: "58693259" },
                    { group_id: "73512008", addon_id: "58693169" },
                    { group_id: "73512008", addon_id: "58693170" },
                    { group_id: "73512008", addon_id: "58693171" },
                    { group_id: "73512008", addon_id: "58693172" },
                    { group_id: "73512008", addon_id: "58693173" },
                    { group_id: "78064026", addon_id: "62937803" },
                    { group_id: "78064026", addon_id: "62937804" },
                    { group_id: "78064026", addon_id: "62937805" },
                    { group_id: "78064026", addon_id: "62937806" },
                    { group_id: "78064026", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271308", variation_id: "75808309" },
                  ],
                  price: 33500,
                  addon_combinations: [
                    { group_id: "73512013", addon_id: "58693222" },
                    { group_id: "73512013", addon_id: "58693193" },
                    { group_id: "73512013", addon_id: "58693194" },
                    { group_id: "73512017", addon_id: "58693195" },
                    { group_id: "73512017", addon_id: "58693270" },
                    { group_id: "73512017", addon_id: "58693271" },
                    { group_id: "73512017", addon_id: "58693272" },
                    { group_id: "73512017", addon_id: "58693273" },
                    { group_id: "73512017", addon_id: "58693274" },
                    { group_id: "73512017", addon_id: "58693275" },
                    { group_id: "73512017", addon_id: "58693276" },
                    { group_id: "73512017", addon_id: "58693277" },
                    { group_id: "73512009", addon_id: "58693174" },
                    { group_id: "73512009", addon_id: "58693175" },
                    { group_id: "73512009", addon_id: "58693176" },
                    { group_id: "73512009", addon_id: "58693177" },
                    { group_id: "73512009", addon_id: "58693178" },
                    { group_id: "73512011", addon_id: "58693179" },
                    { group_id: "73512011", addon_id: "58693180" },
                    { group_id: "73512011", addon_id: "58693181" },
                    { group_id: "73512011", addon_id: "58693182" },
                    { group_id: "73512011", addon_id: "58693183" },
                    { group_id: "73512015", addon_id: "58693251" },
                    { group_id: "73512015", addon_id: "58693252" },
                    { group_id: "73512015", addon_id: "58693253" },
                    { group_id: "73512015", addon_id: "58693254" },
                    { group_id: "73512015", addon_id: "58693255" },
                    { group_id: "73512015", addon_id: "58693256" },
                    { group_id: "73512015", addon_id: "58693257" },
                    { group_id: "73512015", addon_id: "58693258" },
                    { group_id: "73512015", addon_id: "58693259" },
                    { group_id: "78064027", addon_id: "62937803" },
                    { group_id: "78064027", addon_id: "62937804" },
                    { group_id: "78064027", addon_id: "62937805" },
                    { group_id: "78064027", addon_id: "62937806" },
                    { group_id: "78064027", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512009,
                group_name:
                  "Choose From Choice of Bread for Veggie Delite 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512008,
                group_name:
                  "Choose From Choice of Bread for Veggie Delite 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512010,
                group_name:
                  "Choose From Choice of Preparation for Veggie Delite 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512011,
                group_name:
                  "Choose From Choice of Preparation for Veggie Delite 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512013,
                group_name:
                  "Choose From Add Ons for Veggie Delite 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512012,
                group_name:
                  "Choose From Add Ons for Veggie Delite 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512014,
                group_name:
                  "Choose From Choice of Vegetable for Veggie Delite 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512015,
                group_name:
                  "Choose From Choice of Vegetable for Veggie Delite 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512016,
                group_name:
                  "Choose From Choice of Sauces for Veggie Delite 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512017,
                group_name:
                  "Choose From Choice of Sauces for Veggie Delite 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064026,
                group_name:
                  "Choose From Offers @99 for Veggie Delite 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064027,
                group_name:
                  "Choose From Offers @99 for Veggie Delite 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 19500,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240468": {
            id: 107240468,
            name: "Chicken Kofta Sandwich",
            category: "Sandwiches",
            description:
              "Authentic indian meatballs perfectly seasoned and spiced served along with wholesome veggies and packed in your choice of freshly baked bread.",
            cloudinaryImageId: "uad6w1rwurslzgvxxadm",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271309",
                  name: "Choose from Chicken Kofta Sandwich",
                  variations: [
                    {
                      name: "Chicken Koftas 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808310",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271309",
                      order: 2,
                    },
                    {
                      name: "Chicken Koftas 30cm (Footlong)",
                      price: 180,
                      default: 0,
                      id: "75808311",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271309",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271309", variation_id: "75808310" },
                  ],
                  price: 25000,
                  addon_combinations: [
                    { group_id: "73512022", addon_id: "58693541" },
                    { group_id: "73512022", addon_id: "58693190" },
                    { group_id: "73512022", addon_id: "58693191" },
                    { group_id: "73512022", addon_id: "58693219" },
                    { group_id: "73512026", addon_id: "58693195" },
                    { group_id: "73512026", addon_id: "58693270" },
                    { group_id: "73512026", addon_id: "58693271" },
                    { group_id: "73512026", addon_id: "58693272" },
                    { group_id: "73512026", addon_id: "58693273" },
                    { group_id: "73512026", addon_id: "58693274" },
                    { group_id: "73512026", addon_id: "58693275" },
                    { group_id: "73512026", addon_id: "58693276" },
                    { group_id: "73512026", addon_id: "58693277" },
                    { group_id: "73512020", addon_id: "58693179" },
                    { group_id: "73512020", addon_id: "58693180" },
                    { group_id: "73512020", addon_id: "58693181" },
                    { group_id: "73512020", addon_id: "58693182" },
                    { group_id: "73512020", addon_id: "58693183" },
                    { group_id: "73512024", addon_id: "58693251" },
                    { group_id: "73512024", addon_id: "58693252" },
                    { group_id: "73512024", addon_id: "58693253" },
                    { group_id: "73512024", addon_id: "58693254" },
                    { group_id: "73512024", addon_id: "58693255" },
                    { group_id: "73512024", addon_id: "58693256" },
                    { group_id: "73512024", addon_id: "58693257" },
                    { group_id: "73512024", addon_id: "58693258" },
                    { group_id: "73512024", addon_id: "58693259" },
                    { group_id: "73512018", addon_id: "58693169" },
                    { group_id: "73512018", addon_id: "58693170" },
                    { group_id: "73512018", addon_id: "58693171" },
                    { group_id: "73512018", addon_id: "58693172" },
                    { group_id: "73512018", addon_id: "58693173" },
                    { group_id: "78064030", addon_id: "62937803" },
                    { group_id: "78064030", addon_id: "62937804" },
                    { group_id: "78064030", addon_id: "62937805" },
                    { group_id: "78064030", addon_id: "62937806" },
                    { group_id: "78064030", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271309", variation_id: "75808311" },
                  ],
                  price: 43000,
                  addon_combinations: [
                    { group_id: "73512023", addon_id: "58693542" },
                    { group_id: "73512023", addon_id: "58693222" },
                    { group_id: "73512023", addon_id: "58693193" },
                    { group_id: "73512023", addon_id: "58693194" },
                    { group_id: "73512027", addon_id: "58693195" },
                    { group_id: "73512027", addon_id: "58693270" },
                    { group_id: "73512027", addon_id: "58693271" },
                    { group_id: "73512027", addon_id: "58693272" },
                    { group_id: "73512027", addon_id: "58693273" },
                    { group_id: "73512027", addon_id: "58693274" },
                    { group_id: "73512027", addon_id: "58693275" },
                    { group_id: "73512027", addon_id: "58693276" },
                    { group_id: "73512027", addon_id: "58693277" },
                    { group_id: "73512019", addon_id: "58693174" },
                    { group_id: "73512019", addon_id: "58693175" },
                    { group_id: "73512019", addon_id: "58693176" },
                    { group_id: "73512019", addon_id: "58693177" },
                    { group_id: "73512019", addon_id: "58693178" },
                    { group_id: "73512021", addon_id: "58693179" },
                    { group_id: "73512021", addon_id: "58693180" },
                    { group_id: "73512021", addon_id: "58693181" },
                    { group_id: "73512021", addon_id: "58693182" },
                    { group_id: "73512021", addon_id: "58693183" },
                    { group_id: "73512025", addon_id: "58693251" },
                    { group_id: "73512025", addon_id: "58693252" },
                    { group_id: "73512025", addon_id: "58693253" },
                    { group_id: "73512025", addon_id: "58693254" },
                    { group_id: "73512025", addon_id: "58693255" },
                    { group_id: "73512025", addon_id: "58693256" },
                    { group_id: "73512025", addon_id: "58693257" },
                    { group_id: "73512025", addon_id: "58693258" },
                    { group_id: "73512025", addon_id: "58693259" },
                    { group_id: "78064031", addon_id: "62937803" },
                    { group_id: "78064031", addon_id: "62937804" },
                    { group_id: "78064031", addon_id: "62937805" },
                    { group_id: "78064031", addon_id: "62937806" },
                    { group_id: "78064031", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512018,
                group_name:
                  "Choose From Choice of Bread for Chicken Koftas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512019,
                group_name:
                  "Choose From Choice of Bread for Chicken Koftas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512021,
                group_name:
                  "Choose From Choice of Preparation for Chicken Koftas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512020,
                group_name:
                  "Choose From Choice of Preparation for Chicken Koftas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512023,
                group_name:
                  "Choose From Add Ons for Chicken Koftas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693542,
                    name: "Extra Chicken Koftas Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512022,
                group_name:
                  "Choose From Add Ons for Chicken Koftas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693541,
                    name: "Extra Chicken Kofta",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 10,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512025,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Koftas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512024,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Koftas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512027,
                group_name:
                  "Choose From Choice of Sauces for Chicken Koftas 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512026,
                group_name:
                  "Choose From Choice of Sauces for Chicken Koftas 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064031,
                group_name:
                  "Choose From Offers @99 for Chicken Koftas 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064030,
                group_name:
                  "Choose From Offers @99 for Chicken Koftas 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 25000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240469": {
            id: 107240469,
            name: "Chicken Slice Sandwich",
            category: "Sandwiches",
            description:
              "Sliced smoked chicken with your choice of nutritious vegetables, served on a freshly baked bread.",
            cloudinaryImageId: "uwor6sf6ivixtnrjznog",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271310",
                  name: "Choose from Chicken Slice Sandwich",
                  variations: [
                    {
                      name: "Chicken Slice 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808312",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271310",
                      order: 2,
                    },
                    {
                      name: "Chicken Slice 30cm (Footlong)",
                      price: 180,
                      default: 0,
                      id: "75808313",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271310",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271310", variation_id: "75808312" },
                  ],
                  price: 25000,
                  addon_combinations: [
                    { group_id: "73512032", addon_id: "58693189" },
                    { group_id: "73512032", addon_id: "58693190" },
                    { group_id: "73512032", addon_id: "58693191" },
                    { group_id: "73512032", addon_id: "58693219" },
                    { group_id: "73512036", addon_id: "58693195" },
                    { group_id: "73512036", addon_id: "58693270" },
                    { group_id: "73512036", addon_id: "58693271" },
                    { group_id: "73512036", addon_id: "58693272" },
                    { group_id: "73512036", addon_id: "58693273" },
                    { group_id: "73512036", addon_id: "58693274" },
                    { group_id: "73512036", addon_id: "58693275" },
                    { group_id: "73512036", addon_id: "58693276" },
                    { group_id: "73512036", addon_id: "58693277" },
                    { group_id: "73512030", addon_id: "58693179" },
                    { group_id: "73512030", addon_id: "58693180" },
                    { group_id: "73512030", addon_id: "58693181" },
                    { group_id: "73512030", addon_id: "58693182" },
                    { group_id: "73512030", addon_id: "58693183" },
                    { group_id: "73512034", addon_id: "58693251" },
                    { group_id: "73512034", addon_id: "58693252" },
                    { group_id: "73512034", addon_id: "58693253" },
                    { group_id: "73512034", addon_id: "58693254" },
                    { group_id: "73512034", addon_id: "58693255" },
                    { group_id: "73512034", addon_id: "58693256" },
                    { group_id: "73512034", addon_id: "58693257" },
                    { group_id: "73512034", addon_id: "58693258" },
                    { group_id: "73512034", addon_id: "58693259" },
                    { group_id: "73512028", addon_id: "58693169" },
                    { group_id: "73512028", addon_id: "58693170" },
                    { group_id: "73512028", addon_id: "58693171" },
                    { group_id: "73512028", addon_id: "58693172" },
                    { group_id: "73512028", addon_id: "58693173" },
                    { group_id: "78064032", addon_id: "62937803" },
                    { group_id: "78064032", addon_id: "62937804" },
                    { group_id: "78064032", addon_id: "62937805" },
                    { group_id: "78064032", addon_id: "62937806" },
                    { group_id: "78064032", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271310", variation_id: "75808313" },
                  ],
                  price: 43000,
                  addon_combinations: [
                    { group_id: "73512033", addon_id: "58693248" },
                    { group_id: "73512033", addon_id: "58693192" },
                    { group_id: "73512033", addon_id: "58693310" },
                    { group_id: "73512033", addon_id: "58693194" },
                    { group_id: "73512033", addon_id: "58693193" },
                    { group_id: "73512033", addon_id: "58693222" },
                    { group_id: "73512033", addon_id: "58693372" },
                    { group_id: "73512033", addon_id: "58693434" },
                    { group_id: "73512033", addon_id: "58693496" },
                    { group_id: "73512033", addon_id: "58693536" },
                    { group_id: "73512033", addon_id: "58693559" },
                    { group_id: "73512033", addon_id: "58693538" },
                    { group_id: "73512033", addon_id: "58693540" },
                    { group_id: "73512037", addon_id: "58693195" },
                    { group_id: "73512037", addon_id: "58693270" },
                    { group_id: "73512037", addon_id: "58693271" },
                    { group_id: "73512037", addon_id: "58693272" },
                    { group_id: "73512037", addon_id: "58693273" },
                    { group_id: "73512037", addon_id: "58693274" },
                    { group_id: "73512037", addon_id: "58693275" },
                    { group_id: "73512037", addon_id: "58693276" },
                    { group_id: "73512037", addon_id: "58693277" },
                    { group_id: "73512029", addon_id: "58693174" },
                    { group_id: "73512029", addon_id: "58693175" },
                    { group_id: "73512029", addon_id: "58693176" },
                    { group_id: "73512029", addon_id: "58693177" },
                    { group_id: "73512029", addon_id: "58693178" },
                    { group_id: "73512031", addon_id: "58693179" },
                    { group_id: "73512031", addon_id: "58693180" },
                    { group_id: "73512031", addon_id: "58693181" },
                    { group_id: "73512031", addon_id: "58693182" },
                    { group_id: "73512031", addon_id: "58693183" },
                    { group_id: "73512035", addon_id: "58693251" },
                    { group_id: "73512035", addon_id: "58693252" },
                    { group_id: "73512035", addon_id: "58693253" },
                    { group_id: "73512035", addon_id: "58693254" },
                    { group_id: "73512035", addon_id: "58693255" },
                    { group_id: "73512035", addon_id: "58693256" },
                    { group_id: "73512035", addon_id: "58693257" },
                    { group_id: "73512035", addon_id: "58693258" },
                    { group_id: "73512035", addon_id: "58693259" },
                    { group_id: "78064033", addon_id: "62937803" },
                    { group_id: "78064033", addon_id: "62937804" },
                    { group_id: "78064033", addon_id: "62937805" },
                    { group_id: "78064033", addon_id: "62937806" },
                    { group_id: "78064033", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512029,
                group_name:
                  "Choose From Choice of Bread for Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512028,
                group_name:
                  "Choose From Choice of Bread for Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512030,
                group_name:
                  "Choose From Choice of Preparation for Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512031,
                group_name:
                  "Choose From Choice of Preparation for Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512032,
                group_name:
                  "Choose From Add Ons for Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693189,
                    name: "Extra Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512033,
                group_name:
                  "Choose From Add Ons for Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693192,
                    name: "Extra Chicken Slice Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693310,
                    name: "Extra Chatpata Chana Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 11,
                    default: 0,
                  },
                  {
                    id: 58693248,
                    name: "Extra Aloo Patty Footlong",
                    price: 12000,
                    inStock: 0,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693372,
                    name: "Extra Corn & Peas Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693434,
                    name: "Extra Hara Bhara Kebab Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693496,
                    name: "Extra Mexican Bean Patty Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693559,
                    name: "Extra Smoked Chicken Strips Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693536,
                    name: "Extra Paneer Tikka Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693538,
                    name: "Extra Tandoori Tofu Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693540,
                    name: "Extra Veg Shammi Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512035,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512034,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512036,
                group_name:
                  "Choose From Choice of Sauces for Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512037,
                group_name:
                  "Choose From Choice of Sauces for Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064033,
                group_name:
                  "Choose From Offers @99 for Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064032,
                group_name:
                  "Choose From Offers @99 for Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 25000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240470": {
            id: 107240470,
            name: "Chicken Teriyaki Sandwich",
            category: "Sandwiches",
            description:
              "Chicken strips glazed with teriyaki sauce, combined with your favourite veggies and topped with our signature sweet onion sauce served hot in a freshly baked bread of your choice.",
            cloudinaryImageId: "ctjnt5jy29j2xusbccde",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271311",
                  name: "Choose from Chicken Teriyaki Sandwich",
                  variations: [
                    {
                      name: "Chicken Teriyaki 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808314",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271311",
                      order: 2,
                    },
                    {
                      name: "Chicken Teriyaki 30cm (Footlong)",
                      price: 200,
                      default: 0,
                      id: "75808315",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271311",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271311", variation_id: "75808314" },
                  ],
                  price: 27500,
                  addon_combinations: [
                    { group_id: "73512042", addon_id: "58693543" },
                    { group_id: "73512042", addon_id: "58693190" },
                    { group_id: "73512042", addon_id: "58693191" },
                    { group_id: "73512042", addon_id: "58693219" },
                    { group_id: "73512046", addon_id: "58693195" },
                    { group_id: "73512046", addon_id: "58693270" },
                    { group_id: "73512046", addon_id: "58693271" },
                    { group_id: "73512046", addon_id: "58693272" },
                    { group_id: "73512046", addon_id: "58693273" },
                    { group_id: "73512046", addon_id: "58693274" },
                    { group_id: "73512046", addon_id: "58693275" },
                    { group_id: "73512046", addon_id: "58693276" },
                    { group_id: "73512046", addon_id: "58693277" },
                    { group_id: "73512040", addon_id: "58693179" },
                    { group_id: "73512040", addon_id: "58693180" },
                    { group_id: "73512040", addon_id: "58693181" },
                    { group_id: "73512040", addon_id: "58693182" },
                    { group_id: "73512040", addon_id: "58693183" },
                    { group_id: "73512044", addon_id: "58693251" },
                    { group_id: "73512044", addon_id: "58693252" },
                    { group_id: "73512044", addon_id: "58693253" },
                    { group_id: "73512044", addon_id: "58693254" },
                    { group_id: "73512044", addon_id: "58693255" },
                    { group_id: "73512044", addon_id: "58693256" },
                    { group_id: "73512044", addon_id: "58693257" },
                    { group_id: "73512044", addon_id: "58693258" },
                    { group_id: "73512044", addon_id: "58693259" },
                    { group_id: "73512038", addon_id: "58693169" },
                    { group_id: "73512038", addon_id: "58693170" },
                    { group_id: "73512038", addon_id: "58693171" },
                    { group_id: "73512038", addon_id: "58693172" },
                    { group_id: "73512038", addon_id: "58693173" },
                    { group_id: "78064036", addon_id: "62937803" },
                    { group_id: "78064036", addon_id: "62937804" },
                    { group_id: "78064036", addon_id: "62937805" },
                    { group_id: "78064036", addon_id: "62937806" },
                    { group_id: "78064036", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271311", variation_id: "75808315" },
                  ],
                  price: 47500,
                  addon_combinations: [
                    { group_id: "73512043", addon_id: "58693544" },
                    { group_id: "73512043", addon_id: "58693222" },
                    { group_id: "73512043", addon_id: "58693193" },
                    { group_id: "73512043", addon_id: "58693194" },
                    { group_id: "73512047", addon_id: "58693195" },
                    { group_id: "73512047", addon_id: "58693270" },
                    { group_id: "73512047", addon_id: "58693271" },
                    { group_id: "73512047", addon_id: "58693272" },
                    { group_id: "73512047", addon_id: "58693273" },
                    { group_id: "73512047", addon_id: "58693274" },
                    { group_id: "73512047", addon_id: "58693275" },
                    { group_id: "73512047", addon_id: "58693276" },
                    { group_id: "73512047", addon_id: "58693277" },
                    { group_id: "73512039", addon_id: "58693174" },
                    { group_id: "73512039", addon_id: "58693175" },
                    { group_id: "73512039", addon_id: "58693176" },
                    { group_id: "73512039", addon_id: "58693177" },
                    { group_id: "73512039", addon_id: "58693178" },
                    { group_id: "73512041", addon_id: "58693179" },
                    { group_id: "73512041", addon_id: "58693180" },
                    { group_id: "73512041", addon_id: "58693181" },
                    { group_id: "73512041", addon_id: "58693182" },
                    { group_id: "73512041", addon_id: "58693183" },
                    { group_id: "73512045", addon_id: "58693251" },
                    { group_id: "73512045", addon_id: "58693252" },
                    { group_id: "73512045", addon_id: "58693253" },
                    { group_id: "73512045", addon_id: "58693254" },
                    { group_id: "73512045", addon_id: "58693255" },
                    { group_id: "73512045", addon_id: "58693256" },
                    { group_id: "73512045", addon_id: "58693257" },
                    { group_id: "73512045", addon_id: "58693258" },
                    { group_id: "73512045", addon_id: "58693259" },
                    { group_id: "78064037", addon_id: "62937803" },
                    { group_id: "78064037", addon_id: "62937804" },
                    { group_id: "78064037", addon_id: "62937805" },
                    { group_id: "78064037", addon_id: "62937806" },
                    { group_id: "78064037", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512038,
                group_name:
                  "Choose From Choice of Bread for Chicken Teriyaki 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512039,
                group_name:
                  "Choose From Choice of Bread for Chicken Teriyaki 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512041,
                group_name:
                  "Choose From Choice of Preparation for Chicken Teriyaki 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512040,
                group_name:
                  "Choose From Choice of Preparation for Chicken Teriyaki 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512043,
                group_name:
                  "Choose From Add Ons for Chicken Teriyaki 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693544,
                    name: "Extra Chicken Teriyaki Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512042,
                group_name:
                  "Choose From Add Ons for Chicken Teriyaki 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693543,
                    name: "Extra Chicken Teriyaki",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512045,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Teriyaki 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512044,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Teriyaki 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512047,
                group_name:
                  "Choose From Choice of Sauces for Chicken Teriyaki 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512046,
                group_name:
                  "Choose From Choice of Sauces for Chicken Teriyaki 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064037,
                group_name:
                  "Choose From Offers @99 for Chicken Teriyaki 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064036,
                group_name:
                  "Choose From Offers @99 for Chicken Teriyaki 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 27500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240472": {
            id: 107240472,
            name: "Roasted Chicken Strip Sandwich",
            category: "Sandwiches",
            description:
              "Classic preparation of succulent strips of smoked chicken served with veggies, sauces and in your choice of freshly baked bread.",
            cloudinaryImageId: "itz7fgf2bski1s31zhff",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271312",
                  name: "Choose from Roasted Chicken Strip Sandwich",
                  variations: [
                    {
                      name: "Roasted Chicken Strips 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808316",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271312",
                      order: 2,
                    },
                    {
                      name: "Roasted Chicken Strips 30cm (Footlong)",
                      price: 200,
                      default: 0,
                      id: "75808317",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271312",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271312", variation_id: "75808316" },
                  ],
                  price: 25000,
                  addon_combinations: [
                    { group_id: "73512052", addon_id: "58693545" },
                    { group_id: "73512052", addon_id: "58693190" },
                    { group_id: "73512052", addon_id: "58693191" },
                    { group_id: "73512052", addon_id: "58693219" },
                    { group_id: "73512056", addon_id: "58693195" },
                    { group_id: "73512056", addon_id: "58693270" },
                    { group_id: "73512056", addon_id: "58693271" },
                    { group_id: "73512056", addon_id: "58693272" },
                    { group_id: "73512056", addon_id: "58693273" },
                    { group_id: "73512056", addon_id: "58693274" },
                    { group_id: "73512056", addon_id: "58693275" },
                    { group_id: "73512056", addon_id: "58693276" },
                    { group_id: "73512056", addon_id: "58693277" },
                    { group_id: "73512050", addon_id: "58693179" },
                    { group_id: "73512050", addon_id: "58693180" },
                    { group_id: "73512050", addon_id: "58693181" },
                    { group_id: "73512050", addon_id: "58693182" },
                    { group_id: "73512050", addon_id: "58693183" },
                    { group_id: "73512054", addon_id: "58693251" },
                    { group_id: "73512054", addon_id: "58693252" },
                    { group_id: "73512054", addon_id: "58693253" },
                    { group_id: "73512054", addon_id: "58693254" },
                    { group_id: "73512054", addon_id: "58693255" },
                    { group_id: "73512054", addon_id: "58693256" },
                    { group_id: "73512054", addon_id: "58693257" },
                    { group_id: "73512054", addon_id: "58693258" },
                    { group_id: "73512054", addon_id: "58693259" },
                    { group_id: "73512048", addon_id: "58693169" },
                    { group_id: "73512048", addon_id: "58693170" },
                    { group_id: "73512048", addon_id: "58693171" },
                    { group_id: "73512048", addon_id: "58693172" },
                    { group_id: "73512048", addon_id: "58693173" },
                    { group_id: "78064068", addon_id: "62937803" },
                    { group_id: "78064068", addon_id: "62937804" },
                    { group_id: "78064068", addon_id: "62937805" },
                    { group_id: "78064068", addon_id: "62937806" },
                    { group_id: "78064068", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271312", variation_id: "75808317" },
                  ],
                  price: 45000,
                  addon_combinations: [
                    { group_id: "73512053", addon_id: "58693559" },
                    { group_id: "73512053", addon_id: "58693222" },
                    { group_id: "73512053", addon_id: "58693193" },
                    { group_id: "73512053", addon_id: "58693194" },
                    { group_id: "73512057", addon_id: "58693195" },
                    { group_id: "73512057", addon_id: "58693270" },
                    { group_id: "73512057", addon_id: "58693271" },
                    { group_id: "73512057", addon_id: "58693272" },
                    { group_id: "73512057", addon_id: "58693273" },
                    { group_id: "73512057", addon_id: "58693274" },
                    { group_id: "73512057", addon_id: "58693275" },
                    { group_id: "73512057", addon_id: "58693276" },
                    { group_id: "73512057", addon_id: "58693277" },
                    { group_id: "73512049", addon_id: "58693174" },
                    { group_id: "73512049", addon_id: "58693175" },
                    { group_id: "73512049", addon_id: "58693176" },
                    { group_id: "73512049", addon_id: "58693177" },
                    { group_id: "73512049", addon_id: "58693178" },
                    { group_id: "73512051", addon_id: "58693179" },
                    { group_id: "73512051", addon_id: "58693180" },
                    { group_id: "73512051", addon_id: "58693181" },
                    { group_id: "73512051", addon_id: "58693182" },
                    { group_id: "73512051", addon_id: "58693183" },
                    { group_id: "73512055", addon_id: "58693251" },
                    { group_id: "73512055", addon_id: "58693252" },
                    { group_id: "73512055", addon_id: "58693253" },
                    { group_id: "73512055", addon_id: "58693254" },
                    { group_id: "73512055", addon_id: "58693255" },
                    { group_id: "73512055", addon_id: "58693256" },
                    { group_id: "73512055", addon_id: "58693257" },
                    { group_id: "73512055", addon_id: "58693258" },
                    { group_id: "73512055", addon_id: "58693259" },
                    { group_id: "78064069", addon_id: "62937803" },
                    { group_id: "78064069", addon_id: "62937804" },
                    { group_id: "78064069", addon_id: "62937805" },
                    { group_id: "78064069", addon_id: "62937806" },
                    { group_id: "78064069", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512049,
                group_name:
                  "Choose From Choice of Bread for Roasted Chicken Strips 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512048,
                group_name:
                  "Choose From Choice of Bread for Roasted Chicken Strips 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512050,
                group_name:
                  "Choose From Choice of Preparation for Roasted Chicken Strips 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512051,
                group_name:
                  "Choose From Choice of Preparation for Roasted Chicken Strips 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512052,
                group_name:
                  "Choose From Add Ons for Roasted Chicken Strips 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512053,
                group_name:
                  "Choose From Add Ons for Roasted Chicken Strips 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693559,
                    name: "Extra Smoked Chicken Strips Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512054,
                group_name:
                  "Choose From Choice of Vegetable for Roasted Chicken Strips 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512055,
                group_name:
                  "Choose From Choice of Vegetable for Roasted Chicken Strips 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512057,
                group_name:
                  "Choose From Choice of Sauces for Roasted Chicken Strips 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512056,
                group_name:
                  "Choose From Choice of Sauces for Roasted Chicken Strips 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064069,
                group_name:
                  "Choose From Offers @99 for Roasted Chicken Strips 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064068,
                group_name:
                  "Choose From Offers @99 for Roasted Chicken Strips 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 25000,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240473": {
            id: 107240473,
            name: "Tandoori Chicken Tikka Sandwich",
            category: "Sandwiches",
            description:
              "Hearty chicken marinated with flavorful ingredients like yogurt, garlic and ginger, oven cooked with trademark tandoori tikka taste and served with veggies, sauces and in your favourite bread.",
            cloudinaryImageId: "mv9tdhbktddqdallcdms",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271313",
                  name: "Choose from Tandoori Chicken Tikka Sandwich",
                  variations: [
                    {
                      name: "Tandoori Chicken Tikka 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808318",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271313",
                      order: 2,
                    },
                    {
                      name: "Tand Chicken Tikka 30cm (Footlong)",
                      price: 200,
                      default: 0,
                      id: "75808319",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271313",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271313", variation_id: "75808318" },
                  ],
                  price: 25000,
                  addon_combinations: [
                    { group_id: "73512062", addon_id: "58693547" },
                    { group_id: "73512062", addon_id: "58693190" },
                    { group_id: "73512062", addon_id: "58693191" },
                    { group_id: "73512062", addon_id: "58693219" },
                    { group_id: "73512066", addon_id: "58693195" },
                    { group_id: "73512066", addon_id: "58693270" },
                    { group_id: "73512066", addon_id: "58693271" },
                    { group_id: "73512066", addon_id: "58693272" },
                    { group_id: "73512066", addon_id: "58693273" },
                    { group_id: "73512066", addon_id: "58693274" },
                    { group_id: "73512066", addon_id: "58693275" },
                    { group_id: "73512066", addon_id: "58693276" },
                    { group_id: "73512066", addon_id: "58693277" },
                    { group_id: "73512060", addon_id: "58693179" },
                    { group_id: "73512060", addon_id: "58693180" },
                    { group_id: "73512060", addon_id: "58693181" },
                    { group_id: "73512060", addon_id: "58693182" },
                    { group_id: "73512060", addon_id: "58693183" },
                    { group_id: "73512064", addon_id: "58693251" },
                    { group_id: "73512064", addon_id: "58693252" },
                    { group_id: "73512064", addon_id: "58693253" },
                    { group_id: "73512064", addon_id: "58693254" },
                    { group_id: "73512064", addon_id: "58693255" },
                    { group_id: "73512064", addon_id: "58693256" },
                    { group_id: "73512064", addon_id: "58693257" },
                    { group_id: "73512064", addon_id: "58693258" },
                    { group_id: "73512064", addon_id: "58693259" },
                    { group_id: "73512058", addon_id: "58693169" },
                    { group_id: "73512058", addon_id: "58693170" },
                    { group_id: "73512058", addon_id: "58693171" },
                    { group_id: "73512058", addon_id: "58693172" },
                    { group_id: "73512058", addon_id: "58693173" },
                    { group_id: "78064072", addon_id: "62937803" },
                    { group_id: "78064072", addon_id: "62937804" },
                    { group_id: "78064072", addon_id: "62937805" },
                    { group_id: "78064072", addon_id: "62937806" },
                    { group_id: "78064072", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271313", variation_id: "75808319" },
                  ],
                  price: 45000,
                  addon_combinations: [
                    { group_id: "73512063", addon_id: "58693548" },
                    { group_id: "73512063", addon_id: "58693222" },
                    { group_id: "73512063", addon_id: "58693193" },
                    { group_id: "73512063", addon_id: "58693194" },
                    { group_id: "73512067", addon_id: "58693195" },
                    { group_id: "73512067", addon_id: "58693270" },
                    { group_id: "73512067", addon_id: "58693271" },
                    { group_id: "73512067", addon_id: "58693272" },
                    { group_id: "73512067", addon_id: "58693273" },
                    { group_id: "73512067", addon_id: "58693274" },
                    { group_id: "73512067", addon_id: "58693275" },
                    { group_id: "73512067", addon_id: "58693276" },
                    { group_id: "73512067", addon_id: "58693277" },
                    { group_id: "73512059", addon_id: "58693174" },
                    { group_id: "73512059", addon_id: "58693175" },
                    { group_id: "73512059", addon_id: "58693176" },
                    { group_id: "73512059", addon_id: "58693177" },
                    { group_id: "73512059", addon_id: "58693178" },
                    { group_id: "73512061", addon_id: "58693179" },
                    { group_id: "73512061", addon_id: "58693180" },
                    { group_id: "73512061", addon_id: "58693181" },
                    { group_id: "73512061", addon_id: "58693182" },
                    { group_id: "73512061", addon_id: "58693183" },
                    { group_id: "73512065", addon_id: "58693251" },
                    { group_id: "73512065", addon_id: "58693252" },
                    { group_id: "73512065", addon_id: "58693253" },
                    { group_id: "73512065", addon_id: "58693254" },
                    { group_id: "73512065", addon_id: "58693255" },
                    { group_id: "73512065", addon_id: "58693256" },
                    { group_id: "73512065", addon_id: "58693257" },
                    { group_id: "73512065", addon_id: "58693258" },
                    { group_id: "73512065", addon_id: "58693259" },
                    { group_id: "78064073", addon_id: "62937803" },
                    { group_id: "78064073", addon_id: "62937804" },
                    { group_id: "78064073", addon_id: "62937805" },
                    { group_id: "78064073", addon_id: "62937806" },
                    { group_id: "78064073", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512058,
                group_name:
                  "Choose From Choice of Bread for Tandoori Chicken Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512059,
                group_name:
                  "Choose From Choice of Bread for Tand Chicken Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512061,
                group_name:
                  "Choose From Choice of Preparation for Tand Chicken Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512060,
                group_name:
                  "Choose From Choice of Preparation for Tandoori Chicken Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512063,
                group_name:
                  "Choose From Add Ons for Tand Chicken Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693548,
                    name: "Extra Tandoori Chicken Tikka Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512062,
                group_name:
                  "Choose From Add Ons for Tandoori Chicken Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693547,
                    name: "Extra Tandoori Chicken Tikka",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 11,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512065,
                group_name:
                  "Choose From Choice of Vegetable for Tand Chicken Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512064,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Chicken Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512067,
                group_name:
                  "Choose From Choice of Sauces for Tand Chicken Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512066,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Chicken Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064073,
                group_name:
                  "Choose From Offers @99 for Tand Chicken Tikka 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064072,
                group_name:
                  "Choose From Offers @99 for Tandoori Chicken Tikka 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 25000,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240474": {
            id: 107240474,
            name: "Tuna Sandwich",
            category: "Sandwiches",
            description:
              "Flaked light tuna mixed with eggless mayo and heaped onto your choice of freshly baked bread. You will love every bite of our classic tuna sandwich.",
            cloudinaryImageId: "wvhbyrsuacf0chzfzql8",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271314",
                  name: "Choose from Tuna Sandwich",
                  variations: [
                    {
                      name: "Tuna 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808320",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271314",
                      order: 2,
                    },
                    {
                      name: "Tuna 30cm (Footlong)",
                      price: 200,
                      default: 0,
                      id: "75808321",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271314",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271314", variation_id: "75808320" },
                  ],
                  price: 27500,
                  addon_combinations: [
                    { group_id: "73512072", addon_id: "58693549" },
                    { group_id: "73512072", addon_id: "58693190" },
                    { group_id: "73512072", addon_id: "58693191" },
                    { group_id: "73512072", addon_id: "58693219" },
                    { group_id: "73512076", addon_id: "58693195" },
                    { group_id: "73512076", addon_id: "58693270" },
                    { group_id: "73512076", addon_id: "58693271" },
                    { group_id: "73512076", addon_id: "58693272" },
                    { group_id: "73512076", addon_id: "58693273" },
                    { group_id: "73512076", addon_id: "58693274" },
                    { group_id: "73512076", addon_id: "58693275" },
                    { group_id: "73512076", addon_id: "58693276" },
                    { group_id: "73512076", addon_id: "58693277" },
                    { group_id: "73512070", addon_id: "58693179" },
                    { group_id: "73512070", addon_id: "58693180" },
                    { group_id: "73512070", addon_id: "58693181" },
                    { group_id: "73512070", addon_id: "58693182" },
                    { group_id: "73512070", addon_id: "58693183" },
                    { group_id: "73512074", addon_id: "58693251" },
                    { group_id: "73512074", addon_id: "58693252" },
                    { group_id: "73512074", addon_id: "58693253" },
                    { group_id: "73512074", addon_id: "58693254" },
                    { group_id: "73512074", addon_id: "58693255" },
                    { group_id: "73512074", addon_id: "58693256" },
                    { group_id: "73512074", addon_id: "58693257" },
                    { group_id: "73512074", addon_id: "58693258" },
                    { group_id: "73512074", addon_id: "58693259" },
                    { group_id: "73512068", addon_id: "58693169" },
                    { group_id: "73512068", addon_id: "58693170" },
                    { group_id: "73512068", addon_id: "58693171" },
                    { group_id: "73512068", addon_id: "58693172" },
                    { group_id: "73512068", addon_id: "58693173" },
                    { group_id: "78064076", addon_id: "62937803" },
                    { group_id: "78064076", addon_id: "62937804" },
                    { group_id: "78064076", addon_id: "62937805" },
                    { group_id: "78064076", addon_id: "62937806" },
                    { group_id: "78064076", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271314", variation_id: "75808321" },
                  ],
                  price: 47500,
                  addon_combinations: [
                    { group_id: "73512073", addon_id: "58693550" },
                    { group_id: "73512073", addon_id: "58693222" },
                    { group_id: "73512073", addon_id: "58693193" },
                    { group_id: "73512073", addon_id: "58693194" },
                    { group_id: "73512077", addon_id: "58693195" },
                    { group_id: "73512077", addon_id: "58693270" },
                    { group_id: "73512077", addon_id: "58693271" },
                    { group_id: "73512077", addon_id: "58693272" },
                    { group_id: "73512077", addon_id: "58693273" },
                    { group_id: "73512077", addon_id: "58693274" },
                    { group_id: "73512077", addon_id: "58693275" },
                    { group_id: "73512077", addon_id: "58693276" },
                    { group_id: "73512077", addon_id: "58693277" },
                    { group_id: "73512069", addon_id: "58693174" },
                    { group_id: "73512069", addon_id: "58693175" },
                    { group_id: "73512069", addon_id: "58693176" },
                    { group_id: "73512069", addon_id: "58693177" },
                    { group_id: "73512069", addon_id: "58693178" },
                    { group_id: "73512071", addon_id: "58693179" },
                    { group_id: "73512071", addon_id: "58693180" },
                    { group_id: "73512071", addon_id: "58693181" },
                    { group_id: "73512071", addon_id: "58693182" },
                    { group_id: "73512071", addon_id: "58693183" },
                    { group_id: "73512075", addon_id: "58693251" },
                    { group_id: "73512075", addon_id: "58693252" },
                    { group_id: "73512075", addon_id: "58693253" },
                    { group_id: "73512075", addon_id: "58693254" },
                    { group_id: "73512075", addon_id: "58693255" },
                    { group_id: "73512075", addon_id: "58693256" },
                    { group_id: "73512075", addon_id: "58693257" },
                    { group_id: "73512075", addon_id: "58693258" },
                    { group_id: "73512075", addon_id: "58693259" },
                    { group_id: "78064077", addon_id: "62937803" },
                    { group_id: "78064077", addon_id: "62937804" },
                    { group_id: "78064077", addon_id: "62937805" },
                    { group_id: "78064077", addon_id: "62937806" },
                    { group_id: "78064077", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512069,
                group_name:
                  "Choose From Choice of Bread for Tuna 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512068,
                group_name:
                  "Choose From Choice of Bread for Tuna 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512070,
                group_name:
                  "Choose From Choice of Preparation for Tuna 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512071,
                group_name:
                  "Choose From Choice of Preparation for Tuna 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512072,
                group_name: "Choose From Add Ons for Tuna 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693549,
                    name: "Extra Tuna",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512073,
                group_name: "Choose From Add Ons for Tuna 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693550,
                    name: "Extra Tuna Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512074,
                group_name:
                  "Choose From Choice of Vegetable for Tuna 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512075,
                group_name:
                  "Choose From Choice of Vegetable for Tuna 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512076,
                group_name:
                  "Choose From Choice of Sauces for Tuna 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512077,
                group_name:
                  "Choose From Choice of Sauces for Tuna 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064077,
                group_name: "Choose From Offers @99 for Tuna 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064076,
                group_name: "Choose From Offers @99 for Tuna 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 27500,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240475": {
            id: 107240475,
            name: "Turkey & Chicken Slice Sandwich",
            category: "Sandwiches",
            description:
              "Delicious sliced turkey breast and sliced smoked chicken with your choice of your favourite vegetables served on a freshly baked bread.",
            cloudinaryImageId: "wloqy0m53zptonyqjmhl",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271315",
                  name: "Choose from Turkey & Chicken Slice Sandwich",
                  variations: [
                    {
                      name: "Turkey & Chicken Slice 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808322",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271315",
                      order: 2,
                    },
                    {
                      name: "Turkey & Chicken Slice 30cm (Footlong)",
                      price: 195,
                      default: 0,
                      id: "75808323",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271315",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271315", variation_id: "75808322" },
                  ],
                  price: 29000,
                  addon_combinations: [
                    { group_id: "73512082", addon_id: "58693551" },
                    { group_id: "73512082", addon_id: "58693190" },
                    { group_id: "73512082", addon_id: "58693191" },
                    { group_id: "73512082", addon_id: "58693219" },
                    { group_id: "73512086", addon_id: "58693195" },
                    { group_id: "73512086", addon_id: "58693270" },
                    { group_id: "73512086", addon_id: "58693271" },
                    { group_id: "73512086", addon_id: "58693272" },
                    { group_id: "73512086", addon_id: "58693273" },
                    { group_id: "73512086", addon_id: "58693274" },
                    { group_id: "73512086", addon_id: "58693275" },
                    { group_id: "73512086", addon_id: "58693276" },
                    { group_id: "73512086", addon_id: "58693277" },
                    { group_id: "73512080", addon_id: "58693179" },
                    { group_id: "73512080", addon_id: "58693180" },
                    { group_id: "73512080", addon_id: "58693181" },
                    { group_id: "73512080", addon_id: "58693182" },
                    { group_id: "73512080", addon_id: "58693183" },
                    { group_id: "73512084", addon_id: "58693251" },
                    { group_id: "73512084", addon_id: "58693252" },
                    { group_id: "73512084", addon_id: "58693253" },
                    { group_id: "73512084", addon_id: "58693254" },
                    { group_id: "73512084", addon_id: "58693255" },
                    { group_id: "73512084", addon_id: "58693256" },
                    { group_id: "73512084", addon_id: "58693257" },
                    { group_id: "73512084", addon_id: "58693258" },
                    { group_id: "73512084", addon_id: "58693259" },
                    { group_id: "73512078", addon_id: "58693169" },
                    { group_id: "73512078", addon_id: "58693170" },
                    { group_id: "73512078", addon_id: "58693171" },
                    { group_id: "73512078", addon_id: "58693172" },
                    { group_id: "73512078", addon_id: "58693173" },
                    { group_id: "78064080", addon_id: "62937803" },
                    { group_id: "78064080", addon_id: "62937804" },
                    { group_id: "78064080", addon_id: "62937805" },
                    { group_id: "78064080", addon_id: "62937806" },
                    { group_id: "78064080", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271315", variation_id: "75808323" },
                  ],
                  price: 48500,
                  addon_combinations: [
                    { group_id: "73512083", addon_id: "58693552" },
                    { group_id: "73512083", addon_id: "58693193" },
                    { group_id: "73512083", addon_id: "58693194" },
                    { group_id: "73512083", addon_id: "58693222" },
                    { group_id: "73512087", addon_id: "58693195" },
                    { group_id: "73512087", addon_id: "58693270" },
                    { group_id: "73512087", addon_id: "58693271" },
                    { group_id: "73512087", addon_id: "58693272" },
                    { group_id: "73512087", addon_id: "58693273" },
                    { group_id: "73512087", addon_id: "58693274" },
                    { group_id: "73512087", addon_id: "58693275" },
                    { group_id: "73512087", addon_id: "58693276" },
                    { group_id: "73512087", addon_id: "58693277" },
                    { group_id: "73512079", addon_id: "58693174" },
                    { group_id: "73512079", addon_id: "58693175" },
                    { group_id: "73512079", addon_id: "58693176" },
                    { group_id: "73512079", addon_id: "58693177" },
                    { group_id: "73512079", addon_id: "58693178" },
                    { group_id: "73512081", addon_id: "58693179" },
                    { group_id: "73512081", addon_id: "58693180" },
                    { group_id: "73512081", addon_id: "58693181" },
                    { group_id: "73512081", addon_id: "58693182" },
                    { group_id: "73512081", addon_id: "58693183" },
                    { group_id: "73512085", addon_id: "58693251" },
                    { group_id: "73512085", addon_id: "58693252" },
                    { group_id: "73512085", addon_id: "58693253" },
                    { group_id: "73512085", addon_id: "58693254" },
                    { group_id: "73512085", addon_id: "58693255" },
                    { group_id: "73512085", addon_id: "58693256" },
                    { group_id: "73512085", addon_id: "58693257" },
                    { group_id: "73512085", addon_id: "58693258" },
                    { group_id: "73512085", addon_id: "58693259" },
                    { group_id: "78064081", addon_id: "62937803" },
                    { group_id: "78064081", addon_id: "62937804" },
                    { group_id: "78064081", addon_id: "62937805" },
                    { group_id: "78064081", addon_id: "62937806" },
                    { group_id: "78064081", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512079,
                group_name:
                  "Choose From Choice of Bread for Turkey & Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512078,
                group_name:
                  "Choose From Choice of Bread for Turkey & Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512081,
                group_name:
                  "Choose From Choice of Preparation for Turkey & Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512080,
                group_name:
                  "Choose From Choice of Preparation for Turkey & Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512083,
                group_name:
                  "Choose From Add Ons for Turkey & Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693552,
                    name: "Extra Turkey & Chicken Slice Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512082,
                group_name:
                  "Choose From Add Ons for Turkey & Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693551,
                    name: "Extra Turkey & Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512085,
                group_name:
                  "Choose From Choice of Vegetable for Turkey & Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512084,
                group_name:
                  "Choose From Choice of Vegetable for Turkey & Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512087,
                group_name:
                  "Choose From Choice of Sauces for Turkey & Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512086,
                group_name:
                  "Choose From Choice of Sauces for Turkey & Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064081,
                group_name:
                  "Choose From Offers @99 for Turkey & Chicken Slice 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064080,
                group_name:
                  "Choose From Offers @99 for Turkey & Chicken Slice 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 29000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240476": {
            id: 107240476,
            name: "Turkey Sandwich",
            category: "Sandwiches",
            description:
              "If a classic is what you crave then our oven roasted turkey breast is the sandwich for you. Its full of flavour and enhanced with protein made to order with your choice of nutritious veggies served in our freshly baked bread.",
            cloudinaryImageId: "fhhqh2s3pu1ocpijjga5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271316",
                  name: "Choose from Turkey Sandwich",
                  variations: [
                    {
                      name: "Turkey 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808324",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271316",
                      order: 2,
                    },
                    {
                      name: "Turkey 30cm (Footlong)",
                      price: 195,
                      default: 0,
                      id: "75808325",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271316",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271316", variation_id: "75808324" },
                  ],
                  price: 29000,
                  addon_combinations: [
                    { group_id: "73512092", addon_id: "58693553" },
                    { group_id: "73512092", addon_id: "58693190" },
                    { group_id: "73512092", addon_id: "58693191" },
                    { group_id: "73512092", addon_id: "58693219" },
                    { group_id: "73512096", addon_id: "58693195" },
                    { group_id: "73512096", addon_id: "58693270" },
                    { group_id: "73512096", addon_id: "58693271" },
                    { group_id: "73512096", addon_id: "58693272" },
                    { group_id: "73512096", addon_id: "58693273" },
                    { group_id: "73512096", addon_id: "58693274" },
                    { group_id: "73512096", addon_id: "58693275" },
                    { group_id: "73512096", addon_id: "58693276" },
                    { group_id: "73512096", addon_id: "58693277" },
                    { group_id: "73512090", addon_id: "58693179" },
                    { group_id: "73512090", addon_id: "58693180" },
                    { group_id: "73512090", addon_id: "58693181" },
                    { group_id: "73512090", addon_id: "58693182" },
                    { group_id: "73512090", addon_id: "58693183" },
                    { group_id: "73512094", addon_id: "58693251" },
                    { group_id: "73512094", addon_id: "58693252" },
                    { group_id: "73512094", addon_id: "58693253" },
                    { group_id: "73512094", addon_id: "58693254" },
                    { group_id: "73512094", addon_id: "58693255" },
                    { group_id: "73512094", addon_id: "58693256" },
                    { group_id: "73512094", addon_id: "58693257" },
                    { group_id: "73512094", addon_id: "58693258" },
                    { group_id: "73512094", addon_id: "58693259" },
                    { group_id: "73512088", addon_id: "58693169" },
                    { group_id: "73512088", addon_id: "58693170" },
                    { group_id: "73512088", addon_id: "58693171" },
                    { group_id: "73512088", addon_id: "58693172" },
                    { group_id: "73512088", addon_id: "58693173" },
                    { group_id: "78064084", addon_id: "62937803" },
                    { group_id: "78064084", addon_id: "62937804" },
                    { group_id: "78064084", addon_id: "62937805" },
                    { group_id: "78064084", addon_id: "62937806" },
                    { group_id: "78064084", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271316", variation_id: "75808325" },
                  ],
                  price: 48500,
                  addon_combinations: [
                    { group_id: "73512093", addon_id: "58693558" },
                    { group_id: "73512093", addon_id: "58693222" },
                    { group_id: "73512093", addon_id: "58693193" },
                    { group_id: "73512093", addon_id: "58693194" },
                    { group_id: "73512097", addon_id: "58693195" },
                    { group_id: "73512097", addon_id: "58693270" },
                    { group_id: "73512097", addon_id: "58693271" },
                    { group_id: "73512097", addon_id: "58693272" },
                    { group_id: "73512097", addon_id: "58693273" },
                    { group_id: "73512097", addon_id: "58693274" },
                    { group_id: "73512097", addon_id: "58693275" },
                    { group_id: "73512097", addon_id: "58693276" },
                    { group_id: "73512097", addon_id: "58693277" },
                    { group_id: "73512089", addon_id: "58693174" },
                    { group_id: "73512089", addon_id: "58693175" },
                    { group_id: "73512089", addon_id: "58693176" },
                    { group_id: "73512089", addon_id: "58693177" },
                    { group_id: "73512089", addon_id: "58693178" },
                    { group_id: "73512091", addon_id: "58693179" },
                    { group_id: "73512091", addon_id: "58693180" },
                    { group_id: "73512091", addon_id: "58693181" },
                    { group_id: "73512091", addon_id: "58693182" },
                    { group_id: "73512091", addon_id: "58693183" },
                    { group_id: "73512095", addon_id: "58693251" },
                    { group_id: "73512095", addon_id: "58693252" },
                    { group_id: "73512095", addon_id: "58693253" },
                    { group_id: "73512095", addon_id: "58693254" },
                    { group_id: "73512095", addon_id: "58693255" },
                    { group_id: "73512095", addon_id: "58693256" },
                    { group_id: "73512095", addon_id: "58693257" },
                    { group_id: "73512095", addon_id: "58693258" },
                    { group_id: "73512095", addon_id: "58693259" },
                    { group_id: "78064085", addon_id: "62937803" },
                    { group_id: "78064085", addon_id: "62937804" },
                    { group_id: "78064085", addon_id: "62937805" },
                    { group_id: "78064085", addon_id: "62937806" },
                    { group_id: "78064085", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512089,
                group_name:
                  "Choose From Choice of Bread for Turkey 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512088,
                group_name:
                  "Choose From Choice of Bread for Turkey 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512090,
                group_name:
                  "Choose From Choice of Preparation for Turkey 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512091,
                group_name:
                  "Choose From Choice of Preparation for Turkey 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512092,
                group_name: "Choose From Add Ons for Turkey 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693553,
                    name: "Extra Turkey",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512093,
                group_name: "Choose From Add Ons for Turkey 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693558,
                    name: "Extra Turkey Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512094,
                group_name:
                  "Choose From Choice of Vegetable for Turkey 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512095,
                group_name:
                  "Choose From Choice of Vegetable for Turkey 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512096,
                group_name:
                  "Choose From Choice of Sauces for Turkey 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512097,
                group_name:
                  "Choose From Choice of Sauces for Turkey 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064085,
                group_name: "Choose From Offers @99 for Turkey 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064084,
                group_name: "Choose From Offers @99 for Turkey 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 29000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240477": {
            id: 107240477,
            name: "New B.M.T Sandwitch",
            category: "Sandwiches",
            description:
              "Protein-enriched classic Italian B.M.T. sub with a mix of tasty pepperoni, smoked chicken slice and lamb salami, topped with your fav sauce to deliver a flavour burst that is served in your choice of freshly baked bread.",
            cloudinaryImageId: "lsq20yevnkxuoripkq5z",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271317",
                  name: "Choose from New B.M.T Sandwitch",
                  variations: [
                    {
                      name: "New B.M.T. 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808326",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271317",
                      order: 2,
                    },
                    {
                      name: "New B.M.T. 30cm (Footlong)",
                      price: 200,
                      default: 0,
                      id: "75808327",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271317",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271317", variation_id: "75808326" },
                  ],
                  price: 27500,
                  addon_combinations: [
                    { group_id: "73512102", addon_id: "58693190" },
                    { group_id: "73512102", addon_id: "58693219" },
                    { group_id: "73512102", addon_id: "58693191" },
                    { group_id: "73512102", addon_id: "58693554" },
                    { group_id: "73512106", addon_id: "58693272" },
                    { group_id: "73512106", addon_id: "58693273" },
                    { group_id: "73512106", addon_id: "58693274" },
                    { group_id: "73512106", addon_id: "58693275" },
                    { group_id: "73512106", addon_id: "58693276" },
                    { group_id: "73512106", addon_id: "58693277" },
                    { group_id: "73512106", addon_id: "58693195" },
                    { group_id: "73512106", addon_id: "58693270" },
                    { group_id: "73512106", addon_id: "58693271" },
                    { group_id: "73512100", addon_id: "58693179" },
                    { group_id: "73512100", addon_id: "58693180" },
                    { group_id: "73512100", addon_id: "58693181" },
                    { group_id: "73512100", addon_id: "58693182" },
                    { group_id: "73512100", addon_id: "58693183" },
                    { group_id: "73512104", addon_id: "58693251" },
                    { group_id: "73512104", addon_id: "58693252" },
                    { group_id: "73512104", addon_id: "58693253" },
                    { group_id: "73512104", addon_id: "58693254" },
                    { group_id: "73512104", addon_id: "58693255" },
                    { group_id: "73512104", addon_id: "58693256" },
                    { group_id: "73512104", addon_id: "58693257" },
                    { group_id: "73512104", addon_id: "58693258" },
                    { group_id: "73512104", addon_id: "58693259" },
                    { group_id: "73512098", addon_id: "58693169" },
                    { group_id: "73512098", addon_id: "58693170" },
                    { group_id: "73512098", addon_id: "58693171" },
                    { group_id: "73512098", addon_id: "58693172" },
                    { group_id: "73512098", addon_id: "58693173" },
                    { group_id: "78064086", addon_id: "62937803" },
                    { group_id: "78064086", addon_id: "62937804" },
                    { group_id: "78064086", addon_id: "62937805" },
                    { group_id: "78064086", addon_id: "62937806" },
                    { group_id: "78064086", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271317", variation_id: "75808327" },
                  ],
                  price: 47500,
                  addon_combinations: [
                    { group_id: "73512103", addon_id: "58693194" },
                    { group_id: "73512103", addon_id: "58693222" },
                    { group_id: "73512103", addon_id: "58693193" },
                    { group_id: "73512103", addon_id: "58693565" },
                    { group_id: "73512107", addon_id: "58693272" },
                    { group_id: "73512107", addon_id: "58693273" },
                    { group_id: "73512107", addon_id: "58693274" },
                    { group_id: "73512107", addon_id: "58693275" },
                    { group_id: "73512107", addon_id: "58693276" },
                    { group_id: "73512107", addon_id: "58693277" },
                    { group_id: "73512107", addon_id: "58693195" },
                    { group_id: "73512107", addon_id: "58693270" },
                    { group_id: "73512107", addon_id: "58693271" },
                    { group_id: "73512099", addon_id: "58693174" },
                    { group_id: "73512099", addon_id: "58693175" },
                    { group_id: "73512099", addon_id: "58693176" },
                    { group_id: "73512099", addon_id: "58693177" },
                    { group_id: "73512099", addon_id: "58693178" },
                    { group_id: "73512101", addon_id: "58693179" },
                    { group_id: "73512101", addon_id: "58693180" },
                    { group_id: "73512101", addon_id: "58693181" },
                    { group_id: "73512101", addon_id: "58693182" },
                    { group_id: "73512101", addon_id: "58693183" },
                    { group_id: "73512105", addon_id: "58693251" },
                    { group_id: "73512105", addon_id: "58693252" },
                    { group_id: "73512105", addon_id: "58693253" },
                    { group_id: "73512105", addon_id: "58693254" },
                    { group_id: "73512105", addon_id: "58693255" },
                    { group_id: "73512105", addon_id: "58693256" },
                    { group_id: "73512105", addon_id: "58693257" },
                    { group_id: "73512105", addon_id: "58693258" },
                    { group_id: "73512105", addon_id: "58693259" },
                    { group_id: "78064087", addon_id: "62937803" },
                    { group_id: "78064087", addon_id: "62937804" },
                    { group_id: "78064087", addon_id: "62937805" },
                    { group_id: "78064087", addon_id: "62937806" },
                    { group_id: "78064087", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512098,
                group_name:
                  "Choose From Choice of Bread for New B.M.T. 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512099,
                group_name:
                  "Choose From Choice of Bread for New B.M.T. 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512101,
                group_name:
                  "Choose From Choice of Preparation for New B.M.T. 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512100,
                group_name:
                  "Choose From Choice of Preparation for New B.M.T. 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512102,
                group_name:
                  "Choose From Add Ons for New B.M.T. 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693554,
                    name: "Extra New B.M.T. Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512103,
                group_name:
                  "Choose From Add Ons for New B.M.T. 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693565,
                    name: "Extra New B.M.T. Add30",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512104,
                group_name:
                  "Choose From Choice of Vegetable for New B.M.T. 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512105,
                group_name:
                  "Choose From Choice of Vegetable for New B.M.T. 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512106,
                group_name:
                  "Choose From Choice of Sauces for New B.M.T. 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512107,
                group_name:
                  "Choose From Choice of Sauces for New B.M.T. 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064087,
                group_name:
                  "Choose From Offers @99 for New B.M.T. 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064086,
                group_name:
                  "Choose From Offers @99 for New B.M.T. 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 27500,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240478": {
            id: 107240478,
            name: "New Subway Club Sandwich",
            category: "Sandwiches",
            description:
              "Get ready for a truly all-star experience with sliced turkey breast, lamb salami and smoked chicken slices, combined with your favourite sauce and wholesome veggies served in a freshly baked bread of your choice.",
            cloudinaryImageId: "grwn2qkrad5lizes7gj6",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271318",
                  name: "Choose from New Subway Club Sandwich",
                  variations: [
                    {
                      name: "New Subway Club 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808328",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271318",
                      order: 2,
                    },
                    {
                      name: "New Subway Club 30cm (Footlong)",
                      price: 200,
                      default: 0,
                      id: "75808329",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271318",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271318", variation_id: "75808328" },
                  ],
                  price: 27500,
                  addon_combinations: [
                    { group_id: "73512112", addon_id: "58693190" },
                    { group_id: "73512112", addon_id: "58693219" },
                    { group_id: "73512112", addon_id: "58693191" },
                    { group_id: "73512112", addon_id: "58693551" },
                    { group_id: "73512112", addon_id: "58693555" },
                    { group_id: "73512116", addon_id: "58693272" },
                    { group_id: "73512116", addon_id: "58693273" },
                    { group_id: "73512116", addon_id: "58693274" },
                    { group_id: "73512116", addon_id: "58693275" },
                    { group_id: "73512116", addon_id: "58693276" },
                    { group_id: "73512116", addon_id: "58693277" },
                    { group_id: "73512116", addon_id: "58693195" },
                    { group_id: "73512116", addon_id: "58693270" },
                    { group_id: "73512116", addon_id: "58693271" },
                    { group_id: "73512110", addon_id: "58693179" },
                    { group_id: "73512110", addon_id: "58693180" },
                    { group_id: "73512110", addon_id: "58693181" },
                    { group_id: "73512110", addon_id: "58693182" },
                    { group_id: "73512110", addon_id: "58693183" },
                    { group_id: "73512114", addon_id: "58693251" },
                    { group_id: "73512114", addon_id: "58693252" },
                    { group_id: "73512114", addon_id: "58693253" },
                    { group_id: "73512114", addon_id: "58693254" },
                    { group_id: "73512114", addon_id: "58693255" },
                    { group_id: "73512114", addon_id: "58693256" },
                    { group_id: "73512114", addon_id: "58693257" },
                    { group_id: "73512114", addon_id: "58693258" },
                    { group_id: "73512114", addon_id: "58693259" },
                    { group_id: "73512108", addon_id: "58693169" },
                    { group_id: "73512108", addon_id: "58693170" },
                    { group_id: "73512108", addon_id: "58693171" },
                    { group_id: "73512108", addon_id: "58693172" },
                    { group_id: "73512108", addon_id: "58693173" },
                    { group_id: "78064088", addon_id: "62937803" },
                    { group_id: "78064088", addon_id: "62937804" },
                    { group_id: "78064088", addon_id: "62937805" },
                    { group_id: "78064088", addon_id: "62937806" },
                    { group_id: "78064088", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271318", variation_id: "75808329" },
                  ],
                  price: 47500,
                  addon_combinations: [
                    { group_id: "73512113", addon_id: "58693248" },
                    { group_id: "73512113", addon_id: "58693194" },
                    { group_id: "73512113", addon_id: "58693222" },
                    { group_id: "73512113", addon_id: "58693193" },
                    { group_id: "73512113", addon_id: "58693538" },
                    { group_id: "73512113", addon_id: "58693552" },
                    { group_id: "73512113", addon_id: "58693567" },
                    { group_id: "73512117", addon_id: "58693272" },
                    { group_id: "73512117", addon_id: "58693273" },
                    { group_id: "73512117", addon_id: "58693274" },
                    { group_id: "73512117", addon_id: "58693275" },
                    { group_id: "73512117", addon_id: "58693276" },
                    { group_id: "73512117", addon_id: "58693277" },
                    { group_id: "73512117", addon_id: "58693195" },
                    { group_id: "73512117", addon_id: "58693270" },
                    { group_id: "73512117", addon_id: "58693271" },
                    { group_id: "73512109", addon_id: "58693174" },
                    { group_id: "73512109", addon_id: "58693175" },
                    { group_id: "73512109", addon_id: "58693176" },
                    { group_id: "73512109", addon_id: "58693177" },
                    { group_id: "73512109", addon_id: "58693178" },
                    { group_id: "73512111", addon_id: "58693179" },
                    { group_id: "73512111", addon_id: "58693180" },
                    { group_id: "73512111", addon_id: "58693181" },
                    { group_id: "73512111", addon_id: "58693182" },
                    { group_id: "73512111", addon_id: "58693183" },
                    { group_id: "73512115", addon_id: "58693251" },
                    { group_id: "73512115", addon_id: "58693252" },
                    { group_id: "73512115", addon_id: "58693253" },
                    { group_id: "73512115", addon_id: "58693254" },
                    { group_id: "73512115", addon_id: "58693255" },
                    { group_id: "73512115", addon_id: "58693256" },
                    { group_id: "73512115", addon_id: "58693257" },
                    { group_id: "73512115", addon_id: "58693258" },
                    { group_id: "73512115", addon_id: "58693259" },
                    { group_id: "78064089", addon_id: "62937803" },
                    { group_id: "78064089", addon_id: "62937804" },
                    { group_id: "78064089", addon_id: "62937805" },
                    { group_id: "78064089", addon_id: "62937806" },
                    { group_id: "78064089", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512108,
                group_name:
                  "Choose From Choice of Bread for New Subway Club 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512109,
                group_name:
                  "Choose From Choice of Bread for New Subway Club 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512111,
                group_name:
                  "Choose From Choice of Preparation for New Subway Club 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512110,
                group_name:
                  "Choose From Choice of Preparation for New Subway Club 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512113,
                group_name:
                  "Choose From Add Ons for New Subway Club 30cm (Footlong)",
                choices: [
                  {
                    id: 58693248,
                    name: "Extra Aloo Patty Footlong",
                    price: 12000,
                    inStock: 0,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693538,
                    name: "Extra Tandoori Tofu Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693552,
                    name: "Extra Turkey & Chicken Slice Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693567,
                    name: "Extra New Subway Club Add30",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512112,
                group_name:
                  "Choose From Add Ons for New Subway Club 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693551,
                    name: "Extra Turkey & Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693555,
                    name: "Extra New Subway Club Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512115,
                group_name:
                  "Choose From Choice of Vegetable for New Subway Club 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512114,
                group_name:
                  "Choose From Choice of Vegetable for New Subway Club 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512117,
                group_name:
                  "Choose From Choice of Sauces for New Subway Club 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512116,
                group_name:
                  "Choose From Choice of Sauces for New Subway Club 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064089,
                group_name:
                  "Choose From Offers @99 for New Subway Club 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064088,
                group_name:
                  "Choose From Offers @99 for New Subway Club 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 27500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240479": {
            id: 107240479,
            name: "New Peri Peri Chicken Sandwich",
            category: "Sandwiches",
            description:
              "Let your tastebuds travel the world with african peri peri flavoured chicken served with nutritious veggies and packaged in your favourite bread of choice.",
            cloudinaryImageId: "m1ycfwqyybzqrwoemqfa",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271319",
                  name: "Choose from New Peri Peri Chicken Sandwich",
                  variations: [
                    {
                      name: "New Peri Peri Chicken 15cm [6 Inches]",
                      price: 0,
                      default: 1,
                      id: "75808330",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271319",
                      order: 2,
                    },
                    {
                      name: "New Peri Peri Chicken 30cm (Footlong)",
                      price: 180,
                      default: 0,
                      id: "75808331",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23271319",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271319", variation_id: "75808330" },
                  ],
                  price: 25000,
                  addon_combinations: [
                    { group_id: "73512122", addon_id: "58693190" },
                    { group_id: "73512122", addon_id: "58693219" },
                    { group_id: "73512122", addon_id: "58693191" },
                    { group_id: "73512122", addon_id: "58693556" },
                    { group_id: "73512126", addon_id: "58693272" },
                    { group_id: "73512126", addon_id: "58693273" },
                    { group_id: "73512126", addon_id: "58693274" },
                    { group_id: "73512126", addon_id: "58693275" },
                    { group_id: "73512126", addon_id: "58693276" },
                    { group_id: "73512126", addon_id: "58693277" },
                    { group_id: "73512126", addon_id: "58693195" },
                    { group_id: "73512126", addon_id: "58693270" },
                    { group_id: "73512126", addon_id: "58693271" },
                    { group_id: "73512120", addon_id: "58693179" },
                    { group_id: "73512120", addon_id: "58693180" },
                    { group_id: "73512120", addon_id: "58693181" },
                    { group_id: "73512120", addon_id: "58693182" },
                    { group_id: "73512120", addon_id: "58693183" },
                    { group_id: "73512124", addon_id: "58693251" },
                    { group_id: "73512124", addon_id: "58693252" },
                    { group_id: "73512124", addon_id: "58693253" },
                    { group_id: "73512124", addon_id: "58693254" },
                    { group_id: "73512124", addon_id: "58693255" },
                    { group_id: "73512124", addon_id: "58693256" },
                    { group_id: "73512124", addon_id: "58693257" },
                    { group_id: "73512124", addon_id: "58693258" },
                    { group_id: "73512124", addon_id: "58693259" },
                    { group_id: "73512118", addon_id: "58693169" },
                    { group_id: "73512118", addon_id: "58693170" },
                    { group_id: "73512118", addon_id: "58693171" },
                    { group_id: "73512118", addon_id: "58693172" },
                    { group_id: "73512118", addon_id: "58693173" },
                    { group_id: "78064120", addon_id: "62937803" },
                    { group_id: "78064120", addon_id: "62937804" },
                    { group_id: "78064120", addon_id: "62937805" },
                    { group_id: "78064120", addon_id: "62937806" },
                    { group_id: "78064120", addon_id: "62937807" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23271319", variation_id: "75808331" },
                  ],
                  price: 43000,
                  addon_combinations: [
                    { group_id: "73512123", addon_id: "58693194" },
                    { group_id: "73512123", addon_id: "58693222" },
                    { group_id: "73512123", addon_id: "58693193" },
                    { group_id: "73512123", addon_id: "58693562" },
                    { group_id: "73512127", addon_id: "58693272" },
                    { group_id: "73512127", addon_id: "58693273" },
                    { group_id: "73512127", addon_id: "58693274" },
                    { group_id: "73512127", addon_id: "58693275" },
                    { group_id: "73512127", addon_id: "58693276" },
                    { group_id: "73512127", addon_id: "58693277" },
                    { group_id: "73512127", addon_id: "58693195" },
                    { group_id: "73512127", addon_id: "58693270" },
                    { group_id: "73512127", addon_id: "58693271" },
                    { group_id: "73512119", addon_id: "58693174" },
                    { group_id: "73512119", addon_id: "58693175" },
                    { group_id: "73512119", addon_id: "58693176" },
                    { group_id: "73512119", addon_id: "58693177" },
                    { group_id: "73512119", addon_id: "58693178" },
                    { group_id: "73512121", addon_id: "58693179" },
                    { group_id: "73512121", addon_id: "58693180" },
                    { group_id: "73512121", addon_id: "58693181" },
                    { group_id: "73512121", addon_id: "58693182" },
                    { group_id: "73512121", addon_id: "58693183" },
                    { group_id: "73512125", addon_id: "58693251" },
                    { group_id: "73512125", addon_id: "58693252" },
                    { group_id: "73512125", addon_id: "58693253" },
                    { group_id: "73512125", addon_id: "58693254" },
                    { group_id: "73512125", addon_id: "58693255" },
                    { group_id: "73512125", addon_id: "58693256" },
                    { group_id: "73512125", addon_id: "58693257" },
                    { group_id: "73512125", addon_id: "58693258" },
                    { group_id: "73512125", addon_id: "58693259" },
                    { group_id: "78064122", addon_id: "62937803" },
                    { group_id: "78064122", addon_id: "62937804" },
                    { group_id: "78064122", addon_id: "62937805" },
                    { group_id: "78064122", addon_id: "62937806" },
                    { group_id: "78064122", addon_id: "62937807" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 73512119,
                group_name:
                  "Choose From Choice of Bread for New Peri Peri Chicken 30cm (Footlong)",
                choices: [
                  {
                    id: 58693174,
                    name: "White Italian Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693177,
                    name: "Roasted Garlic Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693178,
                    name: "Parmesan Oregano Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512118,
                group_name:
                  "Choose From Choice of Bread for New Peri Peri Chicken 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512120,
                group_name:
                  "Choose From Choice of Preparation for New Peri Peri Chicken 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512121,
                group_name:
                  "Choose From Choice of Preparation for New Peri Peri Chicken 30cm (Footlong)",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512123,
                group_name:
                  "Choose From Add Ons for New Peri Peri Chicken 30cm (Footlong)",
                choices: [
                  {
                    id: 58693222,
                    name: "Extra Double Egg Footlong",
                    price: 9000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693194,
                    name: "Extra Cheese Slice Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693193,
                    name: "Extra Mozzarella Cheese Footlong",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693562,
                    name: "Extra New Peri Peri Chicken Add30",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512122,
                group_name:
                  "Choose From Add Ons for New Peri Peri Chicken 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693556,
                    name: "Extra New Peri Peri Chicken Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 4,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512124,
                group_name:
                  "Choose From Choice of Vegetable for New Peri Peri Chicken 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512125,
                group_name:
                  "Choose From Choice of Vegetable for New Peri Peri Chicken 30cm (Footlong)",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512126,
                group_name:
                  "Choose From Choice of Sauces for New Peri Peri Chicken 15cm [6 Inches]",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 73512127,
                group_name:
                  "Choose From Choice of Sauces for New Peri Peri Chicken 30cm (Footlong)",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064122,
                group_name:
                  "Choose From Offers @99 for New Peri Peri Chicken 30cm (Footlong)",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 78064120,
                group_name:
                  "Choose From Offers @99 for New Peri Peri Chicken 15cm [6 Inches]",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 25000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240481": {
            id: 107240481,
            name: "Corn & Peas Salad",
            category: "Salads",
            description:
              "Experience a symphony of colours with the corn and peas salad. Green peas, golden corn and diced carrots, all held together with a smooth and creamy eggless mayonnaise sauce.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512128,
                group_name:
                  "Choose From Choice of Vegetable for Corn & Peas Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512129,
                group_name: "Choose From Add Ons for Corn & Peas Salad",
                choices: [
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512130,
                group_name:
                  "Choose From Choice of Sauces for Corn & Peas Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064123,
                group_name: "Choose From Offers @99 for Corn & Peas Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240483": {
            id: 107240483,
            name: "Veggie Delite® Salad",
            category: "Salads",
            description:
              "Enjoy the simpler things, the veggie delite salad is simply delish. a pile of your favourite veggies, finished with the dressing of your choice. nutritious. Delicious. All for you.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512134,
                group_name:
                  "Choose From Choice of Vegetable for Veggie Delite® Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512135,
                group_name: "Choose From Add Ons for Veggie Delite® Salad",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512136,
                group_name:
                  "Choose From Choice of Sauces for Veggie Delite® Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064126,
                group_name: "Choose From Offers @99 for Veggie Delite® Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240484": {
            id: 107240484,
            name: "Chatpata Chana Salad",
            category: "Salads",
            description:
              "Heres a taste to spice things up. This tasteful salad is a blend of spiced chickpeas and bengal gram combined with wonderful veggies and your choice of dressing.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512137,
                group_name:
                  "Choose From Choice of Vegetable for Chatpata Chana Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512138,
                group_name: "Choose From Add Ons for Chatpata Chana Salad",
                choices: [
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512139,
                group_name:
                  "Choose From Choice of Sauces for Chatpata Chana Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064127,
                group_name: "Choose From Offers @99 for Chatpata Chana Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240485": {
            id: 107240485,
            name: "Hara Bhara Kabab Salad",
            category: "Salads",
            description:
              "Want to go green, then go for the hara bhara kebab salad. A spicy spinach based kebab combined with the variety of veggies, and topped with your favourite dressing.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512140,
                group_name:
                  "Choose From Choice of Vegetable for Hara Bhara Kabab Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512141,
                group_name: "Choose From Add Ons for Hara Bhara Kabab Salad",
                choices: [
                  {
                    id: 58693431,
                    name: "Extra Hara Bhara Kebab",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512142,
                group_name:
                  "Choose From Choice of Sauces for Hara Bhara Kabab Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064129,
                group_name: "Choose From Offers @99 for Hara Bhara Kabab Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240486": {
            id: 107240486,
            name: "Tandoori Tofu Salad",
            category: "Salads",
            description:
              "Have something unique. Have the tandoori tofu salad. Soft tofu flavoured with tandoori marinade & cooked in the oven, paired with your favourite veggies and a wonderful dressing.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512143,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Tofu Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512144,
                group_name: "Choose From Add Ons for Tandoori Tofu Salad",
                choices: [
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512145,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Tofu Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064130,
                group_name: "Choose From Offers @99 for Tandoori Tofu Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240488": {
            id: 107240488,
            name: "Veg Shammi Kebab Salad",
            category: "Salads",
            description:
              "Experience authentic indian flavours with the veg shammi kebab salad. A delicious kebab made of lentils & aromatic spices combined with veggies and your favourite dressing.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512146,
                group_name:
                  "Choose From Choice of Vegetable for Veg Shammi Kebab Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512147,
                group_name: "Choose From Add Ons for Veg Shammi Kebab Salad",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693539,
                    name: "Extra Veg Shammi",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512148,
                group_name:
                  "Choose From Choice of Sauces for Veg Shammi Kebab Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064150,
                group_name: "Choose From Offers @99 for Veg Shammi Kebab Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240489": {
            id: 107240489,
            name: "Mexican Bean Patty Salad",
            category: "Salads",
            description:
              "Want to try something with a kick, then go for the mexican patty. A tasty patty made with red and black kidney beans, combined with your favourite veggies and dressing to give you a masterpiece.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512149,
                group_name:
                  "Choose From Choice of Vegetable for Mexican Bean Patty Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512150,
                group_name: "Choose From Add Ons for Mexican Bean Patty Salad",
                choices: [
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512151,
                group_name:
                  "Choose From Choice of Sauces for Mexican Bean Patty Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064151,
                group_name:
                  "Choose From Offers @99 for Mexican Bean Patty Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240490": {
            id: 107240490,
            name: "Paneer Tikka Salad",
            category: "Salads",
            description:
              "Want a familiar taste taken up a notch try the paneer tikka salad. Perfectly cooked paneer tikka combined with fresh veggies and a dressing of your choice.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27000,
            variants_new: {},
            addons: [
              {
                group_id: 73512152,
                group_name:
                  "Choose From Choice of Vegetable for Paneer Tikka Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512153,
                group_name: "Choose From Add Ons for Paneer Tikka Salad",
                choices: [
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512154,
                group_name:
                  "Choose From Choice of Sauces for Paneer Tikka Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064154,
                group_name: "Choose From Offers @99 for Paneer Tikka Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240491": {
            id: 107240491,
            name: "Chicken Slice Salad",
            category: "Salads",
            description:
              "Simple. Delicious. Smoked chicken slices topped on wholesome and nutritious veggies with your favourite sauce.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512155,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Slice Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512156,
                group_name: "Choose From Add Ons for Chicken Slice Salad",
                choices: [
                  {
                    id: 58693245,
                    name: "Extra Aloo Patty",
                    price: 6000,
                    inStock: 0,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693189,
                    name: "Extra Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693431,
                    name: "Extra Hara Bhara Kebab",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693539,
                    name: "Extra Veg Shammi",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512157,
                group_name:
                  "Choose From Choice of Sauces for Chicken Slice Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064157,
                group_name: "Choose From Offers @99 for Chicken Slice Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240492": {
            id: 107240492,
            name: "Smoked Chicken Strips Salad",
            category: "Salads",
            description:
              "Classic preparation of succulent smoked chicken strips, along with your favourite veggies and sauces.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512158,
                group_name:
                  "Choose From Choice of Vegetable for Smoked Chicken Strips Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512159,
                group_name:
                  "Choose From Add Ons for Smoked Chicken Strips Salad",
                choices: [
                  {
                    id: 58693245,
                    name: "Extra Aloo Patty",
                    price: 6000,
                    inStock: 0,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693431,
                    name: "Extra Hara Bhara Kebab",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693539,
                    name: "Extra Veg Shammi",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512160,
                group_name:
                  "Choose From Choice of Sauces for Smoked Chicken Strips Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064159,
                group_name:
                  "Choose From Offers @99 for Smoked Chicken Strips Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240493": {
            id: 107240493,
            name: "Chicken Teriyaki Salad",
            category: "Salads",
            description:
              "Enjoy our teriyaki flavours in a salad. Chicken strips glazed with teriyaki sauce, served with a generous pile of veggies and topped with sweet onion sauce.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512161,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Teriyaki Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512162,
                group_name: "Choose From Add Ons for Chicken Teriyaki Salad",
                choices: [
                  {
                    id: 58693543,
                    name: "Extra Chicken Teriyaki",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693551,
                    name: "Extra Turkey & Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512163,
                group_name:
                  "Choose From Choice of Sauces for Chicken Teriyaki Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064162,
                group_name: "Choose From Offers @99 for Chicken Teriyaki Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240494": {
            id: 107240494,
            name: "Turkey Salad",
            category: "Salads",
            description:
              "The turkey breast salad as a go-to salad choice. Our premium sliced turkey breast, tossed together with lettuce, tasty veggies and whatever dressing does it for you. Simply the best.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512164,
                group_name: "Choose From Choice of Vegetable for Turkey Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512165,
                group_name: "Choose From Add Ons for Turkey Salad",
                choices: [
                  {
                    id: 58693553,
                    name: "Extra Turkey",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693551,
                    name: "Extra Turkey & Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512166,
                group_name: "Choose From Choice of Sauces for Turkey Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064163,
                group_name: "Choose From Offers @99 for Turkey Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240495": {
            id: 107240495,
            name: "Chicken Koftas Salad",
            category: "Salads",
            description:
              "The chicken kofta salad is the ultimate cravings crusher. Authentic indian meatballs sitting on a bed of your favourite veggies along with your favourite dressing.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512167,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Koftas Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512168,
                group_name: "Choose From Add Ons for Chicken Koftas Salad",
                choices: [
                  {
                    id: 58693245,
                    name: "Extra Aloo Patty",
                    price: 6000,
                    inStock: 0,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693541,
                    name: "Extra Chicken Kofta",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 10,
                    default: 0,
                  },
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693431,
                    name: "Extra Hara Bhara Kebab",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693539,
                    name: "Extra Veg Shammi",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512169,
                group_name:
                  "Choose From Choice of Sauces for Chicken Koftas Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064181,
                group_name: "Choose From Offers @99 for Chicken Koftas Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240496": {
            id: 107240496,
            name: "Tuna Salad",
            category: "Salads",
            description:
              "Flaked light tuna mixed with eggless mayo and added to your choice of veggies. A classic.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512170,
                group_name: "Choose From Choice of Vegetable for Tuna Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512171,
                group_name: "Choose From Add Ons for Tuna Salad",
                choices: [
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693549,
                    name: "Extra Tuna",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512172,
                group_name: "Choose From Choice of Sauces for Tuna Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064183,
                group_name: "Choose From Offers @99 for Tuna Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240497": {
            id: 107240497,
            name: "Tandoori Chicken Tikka Salad",
            category: "Salads",
            description:
              "Hearty chicken marinated with indian spices and cooked to perfection. This hearty taste is combined with fresh veggies and your choice of dressing.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512173,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Chicken Tikka Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512174,
                group_name:
                  "Choose From Add Ons for Tandoori Chicken Tikka Salad",
                choices: [
                  {
                    id: 58693245,
                    name: "Extra Aloo Patty",
                    price: 6000,
                    inStock: 0,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693547,
                    name: "Extra Tandoori Chicken Tikka",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 11,
                    default: 0,
                  },
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693431,
                    name: "Extra Hara Bhara Kebab",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693539,
                    name: "Extra Veg Shammi",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512175,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Chicken Tikka Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064185,
                group_name:
                  "Choose From Offers @99 for Tandoori Chicken Tikka Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240498": {
            id: 107240498,
            name: "Turkey & Chicken Slice Salad",
            category: "Salads",
            description:
              "It takes two to tantalize your tastebuds! Delicious sliced turkey breast and smoked chicken slices served with your favourite veggies & sauce.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512176,
                group_name:
                  "Choose From Choice of Vegetable for Turkey & Chicken Slice Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512177,
                group_name:
                  "Choose From Add Ons for Turkey & Chicken Slice Salad",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693551,
                    name: "Extra Turkey & Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512178,
                group_name:
                  "Choose From Choice of Sauces for Turkey & Chicken Slice Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064187,
                group_name:
                  "Choose From Offers @99 for Turkey & Chicken Slice Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240499": {
            id: 107240499,
            name: "New B.M.T. Salad",
            category: "Salads",
            description:
              "Who said salads had to be boring! turn your favourite sub into a salad today for a lighter option than your usual sub. Load it up with all the crisp veggies and top it with a tasty sauce. Our salads will have you coming back for more.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512179,
                group_name:
                  "Choose From Choice of Vegetable for New B.M.T. Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512180,
                group_name: "Choose From Add Ons for New B.M.T. Salad",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693551,
                    name: "Extra Turkey & Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693554,
                    name: "Extra New B.M.T. Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512181,
                group_name: "Choose From Choice of Sauces for New B.M.T. Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064189,
                group_name: "Choose From Offers @99 for New B.M.T. Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240500": {
            id: 107240500,
            name: "New Peri Peri Chicken Salad",
            category: "Salads",
            description:
              "Let your tastebuds travel the world with african peri peri flavoured chicken served with tasty and your favourite veggies and a delicious dressing.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512182,
                group_name:
                  "Choose From Choice of Vegetable for New Peri Peri Chicken Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512183,
                group_name:
                  "Choose From Add Ons for New Peri Peri Chicken Salad",
                choices: [
                  {
                    id: 58693245,
                    name: "Extra Aloo Patty",
                    price: 6000,
                    inStock: 0,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 58693307,
                    name: "Extra Chatpata Chana",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 58693541,
                    name: "Extra Chicken Kofta",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 10,
                    default: 0,
                  },
                  {
                    id: 58693189,
                    name: "Extra Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693556,
                    name: "Extra New Peri Peri Chicken Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693431,
                    name: "Extra Hara Bhara Kebab",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693537,
                    name: "Extra Tandoori Tofu",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693539,
                    name: "Extra Veg Shammi",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                  {
                    id: 58693545,
                    name: "Extra Smoked Chicken Strips",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512184,
                group_name:
                  "Choose From Choice of Sauces for New Peri Peri Chicken Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064190,
                group_name:
                  "Choose From Offers @99 for New Peri Peri Chicken Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240501": {
            id: 107240501,
            name: "New Subway Club Salad",
            category: "Salads",
            description:
              "Get ready for a truly all-star experience with sliced turkey breast, lamb salami, and smoked chicken slices combined with the freshest sauces and veggies.",
            cloudinaryImageId: "tummkh3izaotrutlavn5",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 31000,
            variants_new: {},
            addons: [
              {
                group_id: 73512185,
                group_name:
                  "Choose From Choice of Vegetable for New Subway Club Salad",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512186,
                group_name: "Choose From Add Ons for New Subway Club Salad",
                choices: [
                  {
                    id: 58693219,
                    name: "Double Egg",
                    price: 4500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693551,
                    name: "Extra Turkey & Chicken Slice",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693555,
                    name: "Extra New Subway Club Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512187,
                group_name:
                  "Choose From Choice of Sauces for New Subway Club Salad",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064191,
                group_name: "Choose From Offers @99 for New Subway Club Salad",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240503": {
            id: 107240503,
            name: "Chatpata Chana Signature Wrap",
            category: "Signature Wraps",
            description:
              "Crave for more get double portion of chatpata chana with this wrap. A perfect blend of chickpeas and bengal gram along with nutritious vegetables and yummy sauces, packed inside a tortilla of your choice.",
            cloudinaryImageId: "vpcxnobuohoco3qxf3o7",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512188,
                group_name:
                  "Choose From Choice of Tortilla for Chatpata Chana Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512189,
                group_name:
                  "Choose From Choice of Preparation for Chatpata Chana Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512190,
                group_name:
                  "Choose From Add Ons for Chatpata Chana Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512191,
                group_name:
                  "Choose From Choice of Vegetable for Chatpata Chana Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512192,
                group_name:
                  "Choose From Choice of Sauces for Chatpata Chana Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064209,
                group_name:
                  "Choose From Offers @99 for Chatpata Chana Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240504": {
            id: 107240504,
            name: "Veggie Delite® Signature Wrap",
            category: "Signature Wraps",
            description:
              "A wholesome wrap that gives you double portion of nutritious veggies you love, with the best of sauces, packed inside a tortilla of your choice.",
            cloudinaryImageId: "xuudavtrz7yc8qtgf8yb",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512193,
                group_name:
                  "Choose From Choice of Tortilla for Veggie Delite® Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512194,
                group_name:
                  "Choose From Choice of Preparation for Veggie Delite® Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512195,
                group_name:
                  "Choose From Add Ons for Veggie Delite® Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512196,
                group_name:
                  "Choose From Choice of Vegetable for Veggie Delite® Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512197,
                group_name:
                  "Choose From Choice of Sauces for Veggie Delite® Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064211,
                group_name:
                  "Choose From Offers @99 for Veggie Delite® Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240505": {
            id: 107240505,
            name: "Mexican Patty Signature Wrap",
            category: "Signature Wraps",
            description:
              "Enjoy this serving filled with double portion of mexican patty you love, on a tortilla of your choice. Top it with your favourite veggies and sauces.",
            cloudinaryImageId: "ufyrwawz8evjbqdd1u8s",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512198,
                group_name:
                  "Choose From Choice of Tortilla for Mexican Patty Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512199,
                group_name:
                  "Choose From Choice of Preparation for Mexican Patty Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512200,
                group_name:
                  "Choose From Add Ons for Mexican Patty Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512201,
                group_name:
                  "Choose From Choice of Vegetable for Mexican Patty Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512202,
                group_name:
                  "Choose From Choice of Sauces for Mexican Patty Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064213,
                group_name:
                  "Choose From Offers @99 for Mexican Patty Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240506": {
            id: 107240506,
            name: "Hara Bhara Patty Signature Wrap",
            category: "Signature Wraps",
            description:
              "Enjoy a wrap that is filled with double portion of nutritious and spicy spinach based kebabs. Top it up with selected veggies and yummy sauces, packed inside a tortilla of your choice.",
            cloudinaryImageId: "k30an1bqbmwqizqhp0rt",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512203,
                group_name:
                  "Choose From Choice of Tortilla for Hara Bhara Patty Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512204,
                group_name:
                  "Choose From Choice of Preparation for Hara Bhara Patty Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512205,
                group_name:
                  "Choose From Add Ons for Hara Bhara Patty Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512206,
                group_name:
                  "Choose From Choice of Vegetable for Hara Bhara Patty Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512207,
                group_name:
                  "Choose From Choice of Sauces for Hara Bhara Patty Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064215,
                group_name:
                  "Choose From Offers @99 for Hara Bhara Patty Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240507": {
            id: 107240507,
            name: "Corn & Peas Signature Wrap",
            category: "Signature Wraps",
            description:
              "Not just colourful, but with double the filling. Double portion of nutritious green peas, golden corn, and diced carrots combined with a creamy eggless mayo sauces along with selected nutritious veggies and wrapped to perfection packed inside a tortilla of your choice.",
            cloudinaryImageId: "nznamoxinjksfa1ddsh6",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512208,
                group_name:
                  "Choose From Choice of Tortilla for Corn & Peas Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512209,
                group_name:
                  "Choose From Choice of Preparation for Corn & Peas Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512210,
                group_name:
                  "Choose From Add Ons for Corn & Peas Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512211,
                group_name:
                  "Choose From Choice of Vegetable for Corn & Peas Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512212,
                group_name:
                  "Choose From Choice of Sauces for Corn & Peas Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064217,
                group_name:
                  "Choose From Offers @99 for Corn & Peas Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240509": {
            id: 107240509,
            name: "Tandoori Tofu Signature Wrap",
            category: "Signature Wraps",
            description:
              "Get double portion of soft tofu marinated in tandoori sauces and cooked in an oven, combined with your choice of veggies, sauces, and wrapped inside a tortilla of your choice.",
            cloudinaryImageId: "xfe1d9kxwogw6xme1lch",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512218,
                group_name:
                  "Choose From Choice of Tortilla for Tandoori Tofu Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512219,
                group_name:
                  "Choose From Choice of Preparation for Tandoori Tofu Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512220,
                group_name:
                  "Choose From Add Ons for Tandoori Tofu Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512221,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Tofu Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512222,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Tofu Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064219,
                group_name:
                  "Choose From Offers @99 for Tandoori Tofu Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240510": {
            id: 107240510,
            name: "Veg Shammi Kebab Signature Wrap",
            category: "Signature Wraps",
            description:
              "Double your does of daily goodness. Enjoy mouth-watering kebab made of lentils, paired with selected veggies and a tasty sauces, packed inside a tortilla of your choice.",
            cloudinaryImageId: "t1o3liw6wakikxankcqg",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512223,
                group_name:
                  "Choose From Choice of Tortilla for Veg Shammi Kebab Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512224,
                group_name:
                  "Choose From Choice of Preparation for Veg Shammi Kebab Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512225,
                group_name:
                  "Choose From Add Ons for Veg Shammi Kebab Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512226,
                group_name:
                  "Choose From Choice of Vegetable for Veg Shammi Kebab Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512227,
                group_name:
                  "Choose From Choice of Sauces for Veg Shammi Kebab Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064231,
                group_name:
                  "Choose From Offers @99 for Veg Shammi Kebab Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240511": {
            id: 107240511,
            name: "Paneer Tikka Signature Wrap",
            category: "Signature Wraps",
            description:
              "Double the yum with double portion of roasted paneer tikka, along with nutritious veggies and your favourite sauces, inside a tortilla of your choice.",
            cloudinaryImageId: "t1hde63v01yjas867ia1",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 73512228,
                group_name:
                  "Choose From Choice of Tortilla for Paneer Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512229,
                group_name:
                  "Choose From Choice of Preparation for Paneer Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512230,
                group_name:
                  "Choose From Add Ons for Paneer Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512231,
                group_name:
                  "Choose From Choice of Vegetable for Paneer Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512232,
                group_name:
                  "Choose From Choice of Sauces for Paneer Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064234,
                group_name:
                  "Choose From Offers @99 for Paneer Tikka Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240512": {
            id: 107240512,
            name: "Smoked Chicken Strips Signature Wrap",
            category: "Signature Wraps",
            description:
              "A classic that packs the goodness of double the filling. Double portion of strips of smoked chicken, along with nutritious veggies and delicious sauces, served inside a tortilla of your choice.",
            cloudinaryImageId: "wbkuuomgbsvxmits9zgp",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512233,
                group_name:
                  "Choose From Choice of Tortilla for Smoked Chicken Strips Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512234,
                group_name:
                  "Choose From Choice of Preparation for Smoked Chicken Strips Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512235,
                group_name:
                  "Choose From Add Ons for Smoked Chicken Strips Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512236,
                group_name:
                  "Choose From Choice of Vegetable for Smoked Chicken Strips Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512237,
                group_name:
                  "Choose From Choice of Sauces for Smoked Chicken Strips Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064236,
                group_name:
                  "Choose From Offers @99 for Smoked Chicken Strips Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240513": {
            id: 107240513,
            name: "Chicken Slice Signature Wrap",
            category: "Signature Wraps",
            description:
              "Get an explosion of yumminess. Double portion of sliced chicken combined with selected nutritious veggies and tasty sauces, wrapped to perfection inside a tortilla.",
            cloudinaryImageId: "e1osrhdezin49lb2w5ty",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512238,
                group_name:
                  "Choose From Choice of Tortilla for Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512239,
                group_name:
                  "Choose From Choice of Preparation for Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512240,
                group_name:
                  "Choose From Add Ons for Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512241,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512242,
                group_name:
                  "Choose From Choice of Sauces for Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064238,
                group_name:
                  "Choose From Offers @99 for Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240515": {
            id: 107240515,
            name: "Chicken Kofta Signature Wrap",
            category: "Signature Wraps",
            description:
              "Enjoy twice the amount of filling with this wrap. Double portion of authentic indian chicken koftas combined with nutritious veggies, inside a tortilla of your choice.",
            cloudinaryImageId: "fp1y9xvo4ti2acngq3oc",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512243,
                group_name:
                  "Choose From Choice of Tortilla for Chicken Kofta Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512244,
                group_name:
                  "Choose From Choice of Preparation for Chicken Kofta Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512245,
                group_name:
                  "Choose From Add Ons for Chicken Kofta Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512246,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Kofta Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512247,
                group_name:
                  "Choose From Choice of Sauces for Chicken Kofta Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064240,
                group_name:
                  "Choose From Offers @99 for Chicken Kofta Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240516": {
            id: 107240516,
            name: "Chicken Teriyaki Signature Wrap",
            category: "Signature Wraps",
            description:
              "Get double the goodness. Double portion of teriyaki glazed chicken strips along with nutritious veggies and your choice of sauces, wrapped inside a tortilla that you desire.",
            cloudinaryImageId: "ucbrnmjeudf5lkf21fvi",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512248,
                group_name:
                  "Choose From Choice of Tortilla for Chicken Teriyaki Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512249,
                group_name:
                  "Choose From Choice of Preparation for Chicken Teriyaki Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512250,
                group_name:
                  "Choose From Add Ons for Chicken Teriyaki Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512251,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Teriyaki Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512252,
                group_name:
                  "Choose From Choice of Sauces for Chicken Teriyaki Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064242,
                group_name:
                  "Choose From Offers @99 for Chicken Teriyaki Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240517": {
            id: 107240517,
            name: "Turkey & Chicken Slice Signature Wrap",
            category: "Signature Wraps",
            description:
              "Get one and get double the filling! Double portion of sliced turkey breast and chicken along with select veggies and sauces, wrapped inside a tortilla of your choice.",
            cloudinaryImageId: "tkbjp94xtauncm15qlyq",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32500,
            variants_new: {},
            addons: [
              {
                group_id: 73512253,
                group_name:
                  "Choose From Choice of Tortilla for Turkey & Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512254,
                group_name:
                  "Choose From Choice of Preparation for Turkey & Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512255,
                group_name:
                  "Choose From Add Ons for Turkey & Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512256,
                group_name:
                  "Choose From Choice of Vegetable for Turkey & Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512257,
                group_name:
                  "Choose From Choice of Sauces for Turkey & Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064244,
                group_name:
                  "Choose From Offers @99 for Turkey & Chicken Slice Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240518": {
            id: 107240518,
            name: "Tuna Signature Wrap",
            category: "Signature Wraps",
            description:
              "Yummmy, its the tuna wrap! Double portion of flaked tuna mixed with mayo sauce, top it up with selected veggies and wrapped inside a tortilla of your choice.",
            cloudinaryImageId: "oa070j2igwga0eoqtybv",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512259,
                group_name:
                  "Choose From Choice of Tortilla for Tuna Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512260,
                group_name:
                  "Choose From Choice of Preparation for Tuna Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512261,
                group_name: "Choose From Add Ons for Tuna Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512262,
                group_name:
                  "Choose From Choice of Vegetable for Tuna Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512263,
                group_name:
                  "Choose From Choice of Sauces for Tuna Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064264,
                group_name: "Choose From Offers @99 for Tuna Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240519": {
            id: 107240519,
            name: "Tandoori Chicken Tikka Signature Wrap",
            category: "Signature Wraps",
            description:
              "Enjoy double the filling in this hearty wrap. Double portion of chicken paired with nutritious wonderful veggies and your choice of sauces, inside a tortilla. now thats a meal for the soul.",
            cloudinaryImageId: "xfxmp2cqkait8gsnkac8",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512264,
                group_name:
                  "Choose From Choice of Tortilla for Tandoori Chicken Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512265,
                group_name:
                  "Choose From Choice of Preparation for Tandoori Chicken Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512266,
                group_name:
                  "Choose From Add Ons for Tandoori Chicken Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512267,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Chicken Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512268,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Chicken Tikka Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064266,
                group_name:
                  "Choose From Offers @99 for Tandoori Chicken Tikka Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240520": {
            id: 107240520,
            name: "Turkey Signature Wrap",
            category: "Signature Wraps",
            description:
              "High on flavour with double the filling. Double portion of sliced turkey breast along with select veggies, a yummy sauces, wrapped inside a tortilla that you desire.",
            cloudinaryImageId: "gelma8913bdajqwdabu2",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 32500,
            variants_new: {},
            addons: [
              {
                group_id: 73512269,
                group_name:
                  "Choose From Choice of Tortilla for Turkey Signature Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512270,
                group_name:
                  "Choose From Choice of Preparation for Turkey Signature Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512271,
                group_name: "Choose From Add Ons for Turkey Signature Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512272,
                group_name:
                  "Choose From Choice of Vegetable for Turkey Signature Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512273,
                group_name:
                  "Choose From Choice of Sauces for Turkey Signature Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064267,
                group_name: "Choose From Offers @99 for Turkey Signature Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240521": {
            id: 107240521,
            name: "New B.M.T. Sig Wrap",
            category: "Signature Wraps",
            description:
              "A protein overload thats balanced to perfection. Get double portion of salami, pepperoni, smoked chicken and it up with nutritious veggies along with yummy sauces, all wrapped inside a tortilla of your choice.",
            cloudinaryImageId: "kzdlran9igeuts6jaslx",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512274,
                group_name:
                  "Choose From Choice of Tortilla for New B.M.T. Sig Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512275,
                group_name:
                  "Choose From Choice of Preparation for New B.M.T. Sig Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512276,
                group_name: "Choose From Add Ons for New B.M.T. Sig Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512277,
                group_name:
                  "Choose From Choice of Vegetable for New B.M.T. Sig Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512278,
                group_name:
                  "Choose From Choice of Sauces for New B.M.T. Sig Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064269,
                group_name: "Choose From Offers @99 for New B.M.T. Sig Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240522": {
            id: 107240522,
            name: "New Peri Peri Chicken Sig Wrap",
            category: "Signature Wraps",
            description:
              "Double portion of african peri-peri flavoured chicken, along with high protein nutritious veggies and sauces, inside a tortilla of your choice.",
            cloudinaryImageId: "ipqfu3sga6t70kluxj7n",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512279,
                group_name:
                  "Choose From Choice of Tortilla for New Peri Peri Chicken Sig Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512280,
                group_name:
                  "Choose From Choice of Preparation for New Peri Peri Chicken Sig Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512281,
                group_name:
                  "Choose From Add Ons for New Peri Peri Chicken Sig Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512282,
                group_name:
                  "Choose From Choice of Vegetable for New Peri Peri Chicken Sig Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512283,
                group_name:
                  "Choose From Choice of Sauces for New Peri Peri Chicken Sig Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064272,
                group_name:
                  "Choose From Offers @99 for New Peri Peri Chicken Sig Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240523": {
            id: 107240523,
            name: "New Subway Club Sig Wrap",
            category: "Signature Wraps",
            description:
              "Want something star-studded try this wrap. Double portion of sliced turkey breast, lamb, and chicken along with the nutritious veggies and sauces, all packed inside a tortilla of your choice.",
            cloudinaryImageId: "yobunsc2ya8auvbdjzqg",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 73512284,
                group_name:
                  "Choose From Choice of Tortilla for New Subway Club Sig Wrap",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 73512285,
                group_name:
                  "Choose From Choice of Preparation for New Subway Club Sig Wrap",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 73512286,
                group_name: "Choose From Add Ons for New Subway Club Sig Wrap",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 4,
              },
              {
                group_id: 73512287,
                group_name:
                  "Choose From Choice of Vegetable for New Subway Club Sig Wrap",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 73512288,
                group_name:
                  "Choose From Choice of Sauces for New Subway Club Sig Wrap",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064275,
                group_name:
                  "Choose From Offers @99 for New Subway Club Sig Wrap",
                choices: [
                  {
                    id: 62937803,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937804,
                    name: "2 Double Dark Choc Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937805,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937806,
                    name: "Veg Kebab (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937807,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 9900,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 5,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240524": {
            id: 107240524,
            name: "Lays American Style Cream And Onion",
            category: "Sides",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1429,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240525": {
            id: 107240525,
            name: "Sizzling Jalapeno Cornitos",
            category: "Sides",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2857,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240527": {
            id: 107240527,
            name: "Cheese & Herbs Cornitos",
            category: "Sides",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2857,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240528": {
            id: 107240528,
            name: "Barbeque Cornitos",
            category: "Sides",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2857,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 11:48 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240529": {
            id: 107240529,
            name: "Lays Magic Masala",
            category: "Sides",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 1429,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 11:48 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240530": {
            id: 107240530,
            name: "Butter Garlic Naan Chips",
            category: "Sides",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3330,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 11:48 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240531": {
            id: 107240531,
            name: "Chatpata Pudhina Naan Chips",
            category: "Sides",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3330,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 11:48 am, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240533": {
            id: 107240533,
            name: "Veg Kebab [5 Pieces]",
            category: "Sides",
            description:
              "Experience authentic flavours with a kebab made of lentils and enriched with mouth-watering hints of garlic and onion.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12400,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240534": {
            id: 107240534,
            name: "Chicken Meatballs [5 Pieces]",
            category: "Sides",
            description:
              "Authentic indian meatballs perfectly seasoned and flavoured with garlic, herbs and spices.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 13400,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240535": {
            id: 107240535,
            name: "Potato Wedges",
            category: "Sides",
            description:
              "These lightly spiced potato wedges evenly sprinkled with a delicious mixture of herbs and spices. Great as snacks or as supplements to meals.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23271363",
                  name: "Choose from Potato Wedges",
                  variations: [
                    {
                      name: "Potato Wedges Regular [80 Grams]",
                      price: 0,
                      default: 1,
                      id: "75808378",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271363",
                      order: 2,
                    },
                    {
                      name: "Large [120 Grams]",
                      price: 20,
                      default: 0,
                      id: "75808379",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23271363",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23271363", variation_id: "75808378" },
                  ],
                  price: 10500,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "23271363", variation_id: "75808379" },
                  ],
                  price: 12500,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 10500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240536": {
            id: 107240536,
            name: "Veggie & Cheese Toastie",
            category: "Sides",
            description:
              "The perfect on-the-go snack, enriched with mozzarella cheese, jalapenos, onions, and capsicum - on a toasted bread.",
            cloudinaryImageId: "k3z2qdw9ms1vouu059cr",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240537": {
            id: 107240537,
            name: "Chicken Slice Toastie",
            category: "Sides",
            description:
              "Sliced smoked chicken served with mozzarella cheese and seasoned perfectly. The ultimate snack.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240538": {
            id: 107240538,
            name: "Margherita Toastie",
            category: "Sides",
            description:
              "The perfect on-the-go snack! Topped with mozzarella cheese and sauce on each of the toasted bread.",
            cloudinaryImageId: "lac7a8pd0rxhcaodnhg1",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240539": {
            id: 107240539,
            name: "Chatpata Chana Subwrap",
            category: "Sides",
            description:
              "Multigrain tortilla filled with flavourful chatpata chana filling, lettuce, onion, tomato and sauces.",
            cloudinaryImageId: "vpcxnobuohoco3qxf3o7",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240540": {
            id: 107240540,
            name: "Chicken Kofta Subwrap",
            category: "Sides",
            description:
              "Multigrain tortilla filled with delectable chicken kofta, lettuce, onion, tomato and mint mayo sauce.",
            cloudinaryImageId: "on0ervxte8do2j1945sx",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14400,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240541": {
            id: 107240541,
            name: "Veg Shammi Subwrap",
            category: "Sides",
            description:
              "Multigrain tortilla filled with flavourful veg shammi kebab, lettuce, onion, tomato and mint mayo sauce.",
            cloudinaryImageId: "dh7scttdmuljals0ep6k",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 13000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240542": {
            id: 107240542,
            name: "New Chicken Strips Sub Wrap",
            category: "Sides",
            description:
              "Multigrain tortilla filled with high protein, delectable chicken strips, lettuce, onion, tomato and southwest mayo sauce.",
            cloudinaryImageId: "vgy5mnw4b0mab83m3uip",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14400,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240544": {
            id: 107240544,
            name: "Pepsi 330Ml Can",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5714,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240545": {
            id: 107240545,
            name: "7Up 330Ml Can",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5714,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240546": {
            id: 107240546,
            name: "Mirinda Orange 330Ml Can",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5714,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240547": {
            id: 107240547,
            name: "Lipton Lemon Ice Tea 350ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 5714,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240549": {
            id: 107240549,
            name: "Raw Valencia Orange 250ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9524,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240550": {
            id: 107240550,
            name: "Raw Sugarcane 250ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9524,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240551": {
            id: 107240551,
            name: "Raw Choco Mint Protein Shake 200ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240552": {
            id: 107240552,
            name: "Raw Mixed Fruit 200ml",
            category: "Beverages",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9524,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240553": {
            id: 107240553,
            name: "Raw Alphonso Mango Juice 175 ml",
            category: "Beverages",
            description: "Raw Alphonso Mango Juice 175 ml",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9524,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240554": {
            id: 107240554,
            name: "Oatmeal Raisin Cookie",
            category: "Desserts",
            description:
              "Like something extra and sweet add some sweetness with your favourite oatmeal raisin cookies.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240555": {
            id: 107240555,
            name: "Double Dark Chunk Chocolate Cookie",
            category: "Desserts",
            description:
              "Tasty & chocolatey. Now enjoy your favourite double dark chocolate chunk cookie.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107240556": {
            id: 107240556,
            name: "Dark Chunk Chocolate Cookie",
            category: "Desserts",
            description:
              "Craving for chocolate, now enjoy your favourite dark chunk chocolate cookie.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 7500,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923707": {
            id: 108923707,
            name: "Corn & Peas Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "359 Kcal I A delicious assortment of green peas, golden corn and diced carrots, dressed with a creamy mixture of eggless mayo sauce, and served on your favourite bread.",
            cloudinaryImageId: "f5fe8951da178d1b64843b87519d3978",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 20500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857286",
                  name: "Choose from Corn & Peas Sandwich Guiltfree",
                  variations: [
                    {
                      name: "Corn & Peas 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191223",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23857286",
                      order: 2,
                    },
                    {
                      name: "Corn & Peas 30cm (Footlong) Guiltfree",
                      price: 145,
                      default: 0,
                      id: "77191224",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23857286",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857286", variation_id: "77191223" },
                  ],
                  price: 20500,
                  addon_combinations: [
                    { group_id: "75646517", addon_id: "58693369" },
                    { group_id: "75646521", addon_id: "58693272" },
                    { group_id: "75646521", addon_id: "58693273" },
                    { group_id: "75646521", addon_id: "58693274" },
                    { group_id: "75646521", addon_id: "58693275" },
                    { group_id: "75646521", addon_id: "58693276" },
                    { group_id: "75646521", addon_id: "58693277" },
                    { group_id: "75646521", addon_id: "58693195" },
                    { group_id: "75646521", addon_id: "58693270" },
                    { group_id: "75646521", addon_id: "58693271" },
                    { group_id: "75646515", addon_id: "58693179" },
                    { group_id: "75646515", addon_id: "58693181" },
                    { group_id: "75646519", addon_id: "58693251" },
                    { group_id: "75646519", addon_id: "58693252" },
                    { group_id: "75646519", addon_id: "58693253" },
                    { group_id: "75646519", addon_id: "58693254" },
                    { group_id: "75646519", addon_id: "58693255" },
                    { group_id: "75646519", addon_id: "58693256" },
                    { group_id: "75646519", addon_id: "58693257" },
                    { group_id: "75646519", addon_id: "58693258" },
                    { group_id: "75646519", addon_id: "58693259" },
                    { group_id: "75646513", addon_id: "58693171" },
                    { group_id: "75646513", addon_id: "58693170" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857286", variation_id: "77191224" },
                  ],
                  price: 35000,
                  addon_combinations: [
                    { group_id: "75646518", addon_id: "58693372" },
                    { group_id: "75646522", addon_id: "58693272" },
                    { group_id: "75646522", addon_id: "58693273" },
                    { group_id: "75646522", addon_id: "58693274" },
                    { group_id: "75646522", addon_id: "58693275" },
                    { group_id: "75646522", addon_id: "58693276" },
                    { group_id: "75646522", addon_id: "58693277" },
                    { group_id: "75646522", addon_id: "58693195" },
                    { group_id: "75646522", addon_id: "58693270" },
                    { group_id: "75646522", addon_id: "58693271" },
                    { group_id: "75646514", addon_id: "58693175" },
                    { group_id: "75646514", addon_id: "58693176" },
                    { group_id: "75646516", addon_id: "58693179" },
                    { group_id: "75646516", addon_id: "58693181" },
                    { group_id: "75646520", addon_id: "58693251" },
                    { group_id: "75646520", addon_id: "58693252" },
                    { group_id: "75646520", addon_id: "58693253" },
                    { group_id: "75646520", addon_id: "58693254" },
                    { group_id: "75646520", addon_id: "58693255" },
                    { group_id: "75646520", addon_id: "58693256" },
                    { group_id: "75646520", addon_id: "58693257" },
                    { group_id: "75646520", addon_id: "58693258" },
                    { group_id: "75646520", addon_id: "58693259" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646514,
                group_name:
                  "Choose From Choice of Bread for Corn & Peas 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646513,
                group_name:
                  "Choose From Choice of Bread for Corn & Peas 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646516,
                group_name:
                  "Choose From Choice of Preparation for Corn & Peas 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646515,
                group_name:
                  "Choose From Choice of Preparation for Corn & Peas 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646518,
                group_name:
                  "Choose From Add Ons for Corn & Peas 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693372,
                    name: "Extra Corn & Peas Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646517,
                group_name:
                  "Choose From Add Ons for Corn & Peas 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693369,
                    name: "Extra Corn & Peas",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646519,
                group_name:
                  "Choose From Choice of Vegetable for Corn & Peas 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646520,
                group_name:
                  "Choose From Choice of Vegetable for Corn & Peas 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646521,
                group_name:
                  "Choose From Choice of Sauces for Corn & Peas 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646522,
                group_name:
                  "Choose From Choice of Sauces for Corn & Peas 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 20500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923709": {
            id: 108923709,
            name: "Tandoori Chicken Tikka Signature Wrap Guiltfree",
            category: "GuiltFree",
            description:
              "485 Kcal I Enjoy double the filling in this hearty wrap. Double portion of chicken paired with nutritious wonderful veggies and your choice of sauces, inside a tortilla. now thats a meal for the soul.",
            cloudinaryImageId: "dc78c594be8406ea9cae63fb9f9295cf",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 75646523,
                group_name:
                  "Choose From Choice of Tortilla for Tandoori Chicken Tikka Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 3,
              },
              {
                group_id: 75646524,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Chicken Tikka Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646525,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Chicken Tikka Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923710": {
            id: 108923710,
            name: "Italian B.M.T® Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "349 Kcal I Protein-enriched classic Italian B.M.T. sub with a mix of tasty chicken pepperoni & smoked chicken slice, topped with your fav sauce to deliver a flavour burst that is served in your choice of freshly baked bread.",
            cloudinaryImageId: "3c9d1a38b0e4661ce1d993e3d7740117",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857288",
                  name: "Choose from Italian B.M.T® Sandwich Guiltfree",
                  variations: [
                    {
                      name: "B.M.T. 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191226",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857288",
                      order: 2,
                    },
                    {
                      name: "B.M.T. 30cm (Footlong) Guiltfree",
                      price: 195,
                      default: 0,
                      id: "77191227",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857288",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857288", variation_id: "77191226" },
                  ],
                  price: 29000,
                  addon_combinations: [
                    { group_id: "75646534", addon_id: "58693272" },
                    { group_id: "75646534", addon_id: "58693273" },
                    { group_id: "75646534", addon_id: "58693274" },
                    { group_id: "75646534", addon_id: "58693275" },
                    { group_id: "75646534", addon_id: "58693276" },
                    { group_id: "75646534", addon_id: "58693277" },
                    { group_id: "75646534", addon_id: "58693195" },
                    { group_id: "75646534", addon_id: "58693270" },
                    { group_id: "75646534", addon_id: "58693271" },
                    { group_id: "75646528", addon_id: "58693179" },
                    { group_id: "75646528", addon_id: "58693181" },
                    { group_id: "75646532", addon_id: "58693251" },
                    { group_id: "75646532", addon_id: "58693252" },
                    { group_id: "75646532", addon_id: "58693253" },
                    { group_id: "75646532", addon_id: "58693254" },
                    { group_id: "75646532", addon_id: "58693255" },
                    { group_id: "75646532", addon_id: "58693256" },
                    { group_id: "75646532", addon_id: "58693257" },
                    { group_id: "75646532", addon_id: "58693258" },
                    { group_id: "75646532", addon_id: "58693259" },
                    { group_id: "75646526", addon_id: "58693171" },
                    { group_id: "75646526", addon_id: "58693170" },
                    { group_id: "75646530", addon_id: "58693554" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857288", variation_id: "77191227" },
                  ],
                  price: 48500,
                  addon_combinations: [
                    { group_id: "75646535", addon_id: "58693272" },
                    { group_id: "75646535", addon_id: "58693273" },
                    { group_id: "75646535", addon_id: "58693274" },
                    { group_id: "75646535", addon_id: "58693275" },
                    { group_id: "75646535", addon_id: "58693276" },
                    { group_id: "75646535", addon_id: "58693277" },
                    { group_id: "75646535", addon_id: "58693195" },
                    { group_id: "75646535", addon_id: "58693270" },
                    { group_id: "75646535", addon_id: "58693271" },
                    { group_id: "75646527", addon_id: "58693175" },
                    { group_id: "75646527", addon_id: "58693176" },
                    { group_id: "75646529", addon_id: "58693179" },
                    { group_id: "75646529", addon_id: "58693181" },
                    { group_id: "75646533", addon_id: "58693251" },
                    { group_id: "75646533", addon_id: "58693252" },
                    { group_id: "75646533", addon_id: "58693253" },
                    { group_id: "75646533", addon_id: "58693254" },
                    { group_id: "75646533", addon_id: "58693255" },
                    { group_id: "75646533", addon_id: "58693256" },
                    { group_id: "75646533", addon_id: "58693257" },
                    { group_id: "75646533", addon_id: "58693258" },
                    { group_id: "75646533", addon_id: "58693259" },
                    { group_id: "75646531", addon_id: "58693565" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646527,
                group_name:
                  "Choose From Choice of Bread for B.M.T. 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646526,
                group_name:
                  "Choose From Choice of Bread for B.M.T. 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646529,
                group_name:
                  "Choose From Choice of Preparation for B.M.T. 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646528,
                group_name:
                  "Choose From Choice of Preparation for B.M.T. 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646530,
                group_name:
                  "Choose From Add Ons for B.M.T. 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693554,
                    name: "Extra New B.M.T. Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646531,
                group_name:
                  "Choose From Add Ons for B.M.T. 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693565,
                    name: "Extra New B.M.T. Add30",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646532,
                group_name:
                  "Choose From Choice of Vegetable for B.M.T. 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646533,
                group_name:
                  "Choose From Choice of Vegetable for B.M.T. 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646534,
                group_name:
                  "Choose From Choice of Sauces for B.M.T. 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646535,
                group_name:
                  "Choose From Choice of Sauces for B.M.T. 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 29000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923712": {
            id: 108923712,
            name: "Paneer Tikka Signature Wrap Guiltfree",
            category: "GuiltFree",
            description:
              "623 Kcal I Double the yum with double portion of roasted paneer tikka, along with nutritious veggies and your favourite sauces, inside a tortilla of your choice.",
            cloudinaryImageId: "5e4c8075f62446a8c38cefc039199d9d",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 75646536,
                group_name:
                  "Choose From Choice of Tortilla for Paneer Tikka Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 3,
              },
              {
                group_id: 75646537,
                group_name:
                  "Choose From Choice of Vegetable for Paneer Tikka Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646538,
                group_name:
                  "Choose From Choice of Sauces for Paneer Tikka Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923715": {
            id: 108923715,
            name: "Paneer Tikka Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "410 Kcal I Your favourite cheese cubes marinated with tandoori sauce, spices and condiments, cooked in an oven to give a smoky taste. Served with a choice of nutritious veggies and a freshly baked bread.",
            cloudinaryImageId: "55f9f32cbcc92361da41c158cc9f1dbd",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 23500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857290",
                  name: "Choose from Paneer Tikka Sandwich Guiltfree",
                  variations: [
                    {
                      name: "Paneer Tikka 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191229",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23857290",
                      order: 2,
                    },
                    {
                      name: "Paneer Tikka 30cm (Footlong) Guiltfree",
                      price: 190,
                      default: 0,
                      id: "77191230",
                      inStock: 0,
                      isVeg: 1,
                      variant_group_id: "23857290",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857290", variation_id: "77191229" },
                  ],
                  price: 23500,
                  addon_combinations: [
                    { group_id: "75646543", addon_id: "58693535" },
                    { group_id: "75646547", addon_id: "58693272" },
                    { group_id: "75646547", addon_id: "58693273" },
                    { group_id: "75646547", addon_id: "58693274" },
                    { group_id: "75646547", addon_id: "58693275" },
                    { group_id: "75646547", addon_id: "58693276" },
                    { group_id: "75646547", addon_id: "58693277" },
                    { group_id: "75646547", addon_id: "58693195" },
                    { group_id: "75646547", addon_id: "58693270" },
                    { group_id: "75646547", addon_id: "58693271" },
                    { group_id: "75646541", addon_id: "58693179" },
                    { group_id: "75646541", addon_id: "58693181" },
                    { group_id: "75646545", addon_id: "58693251" },
                    { group_id: "75646545", addon_id: "58693252" },
                    { group_id: "75646545", addon_id: "58693253" },
                    { group_id: "75646545", addon_id: "58693254" },
                    { group_id: "75646545", addon_id: "58693255" },
                    { group_id: "75646545", addon_id: "58693256" },
                    { group_id: "75646545", addon_id: "58693257" },
                    { group_id: "75646545", addon_id: "58693258" },
                    { group_id: "75646545", addon_id: "58693259" },
                    { group_id: "75646539", addon_id: "58693171" },
                    { group_id: "75646539", addon_id: "58693170" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857290", variation_id: "77191230" },
                  ],
                  price: 42500,
                  addon_combinations: [
                    { group_id: "75646544", addon_id: "58693536" },
                    { group_id: "75646548", addon_id: "58693272" },
                    { group_id: "75646548", addon_id: "58693273" },
                    { group_id: "75646548", addon_id: "58693274" },
                    { group_id: "75646548", addon_id: "58693275" },
                    { group_id: "75646548", addon_id: "58693276" },
                    { group_id: "75646548", addon_id: "58693277" },
                    { group_id: "75646548", addon_id: "58693195" },
                    { group_id: "75646548", addon_id: "58693270" },
                    { group_id: "75646548", addon_id: "58693271" },
                    { group_id: "75646540", addon_id: "58693175" },
                    { group_id: "75646540", addon_id: "58693176" },
                    { group_id: "75646542", addon_id: "58693179" },
                    { group_id: "75646542", addon_id: "58693181" },
                    { group_id: "75646546", addon_id: "58693251" },
                    { group_id: "75646546", addon_id: "58693252" },
                    { group_id: "75646546", addon_id: "58693253" },
                    { group_id: "75646546", addon_id: "58693254" },
                    { group_id: "75646546", addon_id: "58693255" },
                    { group_id: "75646546", addon_id: "58693256" },
                    { group_id: "75646546", addon_id: "58693257" },
                    { group_id: "75646546", addon_id: "58693258" },
                    { group_id: "75646546", addon_id: "58693259" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646540,
                group_name:
                  "Choose From Choice of Bread for Paneer Tikka 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646539,
                group_name:
                  "Choose From Choice of Bread for Paneer Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646541,
                group_name:
                  "Choose From Choice of Preparation for Paneer Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646542,
                group_name:
                  "Choose From Choice of Preparation for Paneer Tikka 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646543,
                group_name:
                  "Choose From Add Ons for Paneer Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693535,
                    name: "Extra Paneer Tikka",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646544,
                group_name:
                  "Choose From Add Ons for Paneer Tikka 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693536,
                    name: "Extra Paneer Tikka Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646545,
                group_name:
                  "Choose From Choice of Vegetable for Paneer Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646546,
                group_name:
                  "Choose From Choice of Vegetable for Paneer Tikka 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646547,
                group_name:
                  "Choose From Choice of Sauces for Paneer Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646548,
                group_name:
                  "Choose From Choice of Sauces for Paneer Tikka 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 23500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923720": {
            id: 108923720,
            name: "Veggie Delite Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "242 kcal I Delicious combination of fresh lettuce, tomatoes, green peppers, onions, olives and pickles served on a freshly baked bread.",
            cloudinaryImageId: "17ce4fae041bee9dc908496f0b3c09c5",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857295",
                  name: "Choose from Veggie Delite Sandwich Guiltfree",
                  variations: [
                    {
                      name: "Veggie Delite 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191239",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23857295",
                      order: 2,
                    },
                    {
                      name: "Veggie Delite 30cm (Footlong) Guiltfree",
                      price: 140,
                      default: 0,
                      id: "77191240",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23857295",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857295", variation_id: "77191239" },
                  ],
                  price: 19500,
                  addon_combinations: [
                    { group_id: "75646575", addon_id: "58693272" },
                    { group_id: "75646575", addon_id: "58693273" },
                    { group_id: "75646575", addon_id: "58693274" },
                    { group_id: "75646575", addon_id: "58693275" },
                    { group_id: "75646575", addon_id: "58693276" },
                    { group_id: "75646575", addon_id: "58693277" },
                    { group_id: "75646575", addon_id: "58693195" },
                    { group_id: "75646575", addon_id: "58693270" },
                    { group_id: "75646575", addon_id: "58693271" },
                    { group_id: "75646571", addon_id: "58693179" },
                    { group_id: "75646571", addon_id: "58693181" },
                    { group_id: "75646573", addon_id: "58693251" },
                    { group_id: "75646573", addon_id: "58693252" },
                    { group_id: "75646573", addon_id: "58693253" },
                    { group_id: "75646573", addon_id: "58693254" },
                    { group_id: "75646573", addon_id: "58693255" },
                    { group_id: "75646573", addon_id: "58693256" },
                    { group_id: "75646573", addon_id: "58693257" },
                    { group_id: "75646573", addon_id: "58693258" },
                    { group_id: "75646573", addon_id: "58693259" },
                    { group_id: "75646569", addon_id: "58693171" },
                    { group_id: "75646569", addon_id: "58693170" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857295", variation_id: "77191240" },
                  ],
                  price: 33500,
                  addon_combinations: [
                    { group_id: "75646576", addon_id: "58693272" },
                    { group_id: "75646576", addon_id: "58693273" },
                    { group_id: "75646576", addon_id: "58693274" },
                    { group_id: "75646576", addon_id: "58693275" },
                    { group_id: "75646576", addon_id: "58693276" },
                    { group_id: "75646576", addon_id: "58693277" },
                    { group_id: "75646576", addon_id: "58693195" },
                    { group_id: "75646576", addon_id: "58693270" },
                    { group_id: "75646576", addon_id: "58693271" },
                    { group_id: "75646572", addon_id: "58693175" },
                    { group_id: "75646572", addon_id: "58693176" },
                    { group_id: "75646570", addon_id: "58693179" },
                    { group_id: "75646570", addon_id: "58693181" },
                    { group_id: "75646574", addon_id: "58693251" },
                    { group_id: "75646574", addon_id: "58693252" },
                    { group_id: "75646574", addon_id: "58693253" },
                    { group_id: "75646574", addon_id: "58693254" },
                    { group_id: "75646574", addon_id: "58693255" },
                    { group_id: "75646574", addon_id: "58693256" },
                    { group_id: "75646574", addon_id: "58693257" },
                    { group_id: "75646574", addon_id: "58693258" },
                    { group_id: "75646574", addon_id: "58693259" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646569,
                group_name:
                  "Choose From Choice of Bread for Veggie Delite 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646570,
                group_name:
                  "Choose From Choice of Preparation for Veggie Delite 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646572,
                group_name:
                  "Choose From Choice of Bread for Veggie Delite 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 3,
              },
              {
                group_id: 75646571,
                group_name:
                  "Choose From Choice of Preparation for Veggie Delite 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 3,
              },
              {
                group_id: 75646573,
                group_name:
                  "Choose From Choice of Vegetable for Veggie Delite 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646574,
                group_name:
                  "Choose From Choice of Vegetable for Veggie Delite 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646576,
                group_name:
                  "Choose From Choice of Sauces for Veggie Delite 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646575,
                group_name:
                  "Choose From Choice of Sauces for Veggie Delite 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 19500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923792": {
            id: 108923792,
            name: "Tandoori Chicken Tikka Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "341 Kcal I Hearty chicken marinated with flavorful ingredients like yogurt, garlic and ginger, oven cooked with trademark tandoori tikka taste and served with veggies, sauces and in your favourite bread",
            cloudinaryImageId: "26514a88e013febcb1bc618c29bdac25",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857318",
                  name: "Choose from Tandoori Chicken Tikka Sandwich Guiltfree",
                  variations: [
                    {
                      name: "Tandoori Chicken Tikka 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191285",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857318",
                      order: 2,
                    },
                    {
                      name: "Tandoori Tofu 30cm (Footlong) Guiltfree",
                      price: 200,
                      default: 0,
                      id: "77191286",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857318",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857318", variation_id: "77191285" },
                  ],
                  price: 25000,
                  addon_combinations: [
                    { group_id: "75646632", addon_id: "58693547" },
                    { group_id: "75646636", addon_id: "58693272" },
                    { group_id: "75646636", addon_id: "58693273" },
                    { group_id: "75646636", addon_id: "58693274" },
                    { group_id: "75646636", addon_id: "58693275" },
                    { group_id: "75646636", addon_id: "58693276" },
                    { group_id: "75646636", addon_id: "58693277" },
                    { group_id: "75646636", addon_id: "58693195" },
                    { group_id: "75646636", addon_id: "58693270" },
                    { group_id: "75646636", addon_id: "58693271" },
                    { group_id: "75646630", addon_id: "58693179" },
                    { group_id: "75646630", addon_id: "58693181" },
                    { group_id: "75646634", addon_id: "58693251" },
                    { group_id: "75646634", addon_id: "58693252" },
                    { group_id: "75646634", addon_id: "58693253" },
                    { group_id: "75646634", addon_id: "58693254" },
                    { group_id: "75646634", addon_id: "58693255" },
                    { group_id: "75646634", addon_id: "58693256" },
                    { group_id: "75646634", addon_id: "58693257" },
                    { group_id: "75646634", addon_id: "58693258" },
                    { group_id: "75646634", addon_id: "58693259" },
                    { group_id: "75646628", addon_id: "58693171" },
                    { group_id: "75646628", addon_id: "58693170" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857318", variation_id: "77191286" },
                  ],
                  price: 45000,
                  addon_combinations: [
                    { group_id: "75646633", addon_id: "58693548" },
                    { group_id: "75646637", addon_id: "58693272" },
                    { group_id: "75646637", addon_id: "58693273" },
                    { group_id: "75646637", addon_id: "58693274" },
                    { group_id: "75646637", addon_id: "58693275" },
                    { group_id: "75646637", addon_id: "58693276" },
                    { group_id: "75646637", addon_id: "58693277" },
                    { group_id: "75646637", addon_id: "58693195" },
                    { group_id: "75646637", addon_id: "58693270" },
                    { group_id: "75646637", addon_id: "58693271" },
                    { group_id: "75646629", addon_id: "58693175" },
                    { group_id: "75646629", addon_id: "58693176" },
                    { group_id: "75646631", addon_id: "58693179" },
                    { group_id: "75646631", addon_id: "58693181" },
                    { group_id: "75646635", addon_id: "58693251" },
                    { group_id: "75646635", addon_id: "58693252" },
                    { group_id: "75646635", addon_id: "58693253" },
                    { group_id: "75646635", addon_id: "58693254" },
                    { group_id: "75646635", addon_id: "58693255" },
                    { group_id: "75646635", addon_id: "58693256" },
                    { group_id: "75646635", addon_id: "58693257" },
                    { group_id: "75646635", addon_id: "58693258" },
                    { group_id: "75646635", addon_id: "58693259" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646628,
                group_name:
                  "Choose From Choice of Bread for Tandoori Chicken Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646629,
                group_name:
                  "Choose From Choice of Bread for Tandoori Tofu 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646631,
                group_name:
                  "Choose From Choice of Preparation for Tandoori Tofu 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646630,
                group_name:
                  "Choose From Choice of Preparation for Tandoori Chicken Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646633,
                group_name:
                  "Choose From Add Ons for Tandoori Tofu 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693548,
                    name: "Extra Tandoori Chicken Tikka Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646632,
                group_name:
                  "Choose From Add Ons for Tandoori Chicken Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693547,
                    name: "Extra Tandoori Chicken Tikka",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 11,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646635,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Tofu 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646634,
                group_name:
                  "Choose From Choice of Vegetable for Tandoori Chicken Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646637,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Tofu 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646636,
                group_name:
                  "Choose From Choice of Sauces for Tandoori Chicken Tikka 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 25000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923796": {
            id: 108923796,
            name: "Chicken Teriyaki Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "311 Kcal I Chicken strips glazed with teriyaki sauce, combined with your favourite veggies and topped with our signature sweet onion sauce served hot in a freshly baked bread of your choice.",
            cloudinaryImageId: "bb469ea001a91ebba2db3e5a57c21a98",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857326",
                  name: "Choose from Chicken Teriyaki Sandwich Guiltfree",
                  variations: [
                    {
                      name: "Chicken Teriyaki 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191300",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857326",
                      order: 2,
                    },
                    {
                      name: "Chicken Teriyaki 30cm (Footlong) Guiltfree",
                      price: 200,
                      default: 0,
                      id: "77191302",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857326",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857326", variation_id: "77191300" },
                  ],
                  price: 27500,
                  addon_combinations: [
                    { group_id: "75646648", addon_id: "58693543" },
                    { group_id: "75646653", addon_id: "58693272" },
                    { group_id: "75646653", addon_id: "58693273" },
                    { group_id: "75646653", addon_id: "58693274" },
                    { group_id: "75646653", addon_id: "58693275" },
                    { group_id: "75646653", addon_id: "58693276" },
                    { group_id: "75646653", addon_id: "58693277" },
                    { group_id: "75646653", addon_id: "58693195" },
                    { group_id: "75646653", addon_id: "58693270" },
                    { group_id: "75646653", addon_id: "58693271" },
                    { group_id: "75646645", addon_id: "58693179" },
                    { group_id: "75646645", addon_id: "58693181" },
                    { group_id: "75646650", addon_id: "58693251" },
                    { group_id: "75646650", addon_id: "58693252" },
                    { group_id: "75646650", addon_id: "58693253" },
                    { group_id: "75646650", addon_id: "58693254" },
                    { group_id: "75646650", addon_id: "58693255" },
                    { group_id: "75646650", addon_id: "58693256" },
                    { group_id: "75646650", addon_id: "58693257" },
                    { group_id: "75646650", addon_id: "58693258" },
                    { group_id: "75646650", addon_id: "58693259" },
                    { group_id: "75646643", addon_id: "58693171" },
                    { group_id: "75646643", addon_id: "58693170" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857326", variation_id: "77191302" },
                  ],
                  price: 47500,
                  addon_combinations: [
                    { group_id: "75646649", addon_id: "58693544" },
                    { group_id: "75646654", addon_id: "58693272" },
                    { group_id: "75646654", addon_id: "58693273" },
                    { group_id: "75646654", addon_id: "58693274" },
                    { group_id: "75646654", addon_id: "58693275" },
                    { group_id: "75646654", addon_id: "58693276" },
                    { group_id: "75646654", addon_id: "58693277" },
                    { group_id: "75646654", addon_id: "58693195" },
                    { group_id: "75646654", addon_id: "58693270" },
                    { group_id: "75646654", addon_id: "58693271" },
                    { group_id: "75646644", addon_id: "58693175" },
                    { group_id: "75646644", addon_id: "58693176" },
                    { group_id: "75646647", addon_id: "58693179" },
                    { group_id: "75646647", addon_id: "58693181" },
                    { group_id: "75646651", addon_id: "58693251" },
                    { group_id: "75646651", addon_id: "58693252" },
                    { group_id: "75646651", addon_id: "58693253" },
                    { group_id: "75646651", addon_id: "58693254" },
                    { group_id: "75646651", addon_id: "58693255" },
                    { group_id: "75646651", addon_id: "58693256" },
                    { group_id: "75646651", addon_id: "58693257" },
                    { group_id: "75646651", addon_id: "58693258" },
                    { group_id: "75646651", addon_id: "58693259" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646644,
                group_name:
                  "Choose From Choice of Bread for Chicken Teriyaki 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646643,
                group_name:
                  "Choose From Choice of Bread for Chicken Teriyaki 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646647,
                group_name:
                  "Choose From Choice of Preparation for Chicken Teriyaki 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646645,
                group_name:
                  "Choose From Choice of Preparation for Chicken Teriyaki 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646648,
                group_name:
                  "Choose From Add Ons for Chicken Teriyaki 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693543,
                    name: "Extra Chicken Teriyaki",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646649,
                group_name:
                  "Choose From Add Ons for Chicken Teriyaki 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693544,
                    name: "Extra Chicken Teriyaki Footlong",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646650,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Teriyaki 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646651,
                group_name:
                  "Choose From Choice of Vegetable for Chicken Teriyaki 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646653,
                group_name:
                  "Choose From Choice of Sauces for Chicken Teriyaki 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646654,
                group_name:
                  "Choose From Choice of Sauces for Chicken Teriyaki 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 27500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923808": {
            id: 108923808,
            name: "Smoked Chicken Strips Signature Wrap Guiltfree",
            category: "GuiltFree",
            description:
              "404 Kcal I A classic that packs the goodness of double the filling. Double portion of strips of smoked chicken, along with nutritious veggies and delicious sauces, served inside a tortilla of your choice.",
            cloudinaryImageId: "a0127c3575b9e91e27bdce4bfe32f561",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 75646672,
                group_name:
                  "Choose From Choice of Tortilla for Smoked Chicken Strips Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 3,
              },
              {
                group_id: 75646673,
                group_name:
                  "Choose From Choice of Vegetable for Smoked Chicken Strips Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646674,
                group_name:
                  "Choose From Choice of Sauces for Smoked Chicken Strips Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923816": {
            id: 108923816,
            name: "Mexican Patty Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "379 Kcal I A refreshing filling of red and black kidney beans patty topped with aromatic seasoning along with your choice of veggies and sauces served on a freshly baked bread.",
            cloudinaryImageId: "81facafdf6dad788583951f61aca6677",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 22500,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857359",
                  name: "Choose from Mexican Patty Sandwich Guiltfree",
                  variations: [
                    {
                      name: "Mexican Bean Patty 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191366",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23857359",
                      order: 2,
                    },
                    {
                      name: "Mexican Bean Patty 30cm (Footlong) Guiltfree",
                      price: 160,
                      default: 0,
                      id: "77191367",
                      inStock: 1,
                      isVeg: 1,
                      variant_group_id: "23857359",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857359", variation_id: "77191366" },
                  ],
                  price: 22500,
                  addon_combinations: [
                    { group_id: "75646691", addon_id: "58693493" },
                    { group_id: "75646695", addon_id: "58693272" },
                    { group_id: "75646695", addon_id: "58693273" },
                    { group_id: "75646695", addon_id: "58693274" },
                    { group_id: "75646695", addon_id: "58693275" },
                    { group_id: "75646695", addon_id: "58693276" },
                    { group_id: "75646695", addon_id: "58693277" },
                    { group_id: "75646695", addon_id: "58693195" },
                    { group_id: "75646695", addon_id: "58693270" },
                    { group_id: "75646695", addon_id: "58693271" },
                    { group_id: "75646689", addon_id: "58693179" },
                    { group_id: "75646689", addon_id: "58693181" },
                    { group_id: "75646693", addon_id: "58693251" },
                    { group_id: "75646693", addon_id: "58693252" },
                    { group_id: "75646693", addon_id: "58693253" },
                    { group_id: "75646693", addon_id: "58693254" },
                    { group_id: "75646693", addon_id: "58693255" },
                    { group_id: "75646693", addon_id: "58693256" },
                    { group_id: "75646693", addon_id: "58693257" },
                    { group_id: "75646693", addon_id: "58693258" },
                    { group_id: "75646693", addon_id: "58693259" },
                    { group_id: "75646687", addon_id: "58693171" },
                    { group_id: "75646687", addon_id: "58693170" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857359", variation_id: "77191367" },
                  ],
                  price: 38500,
                  addon_combinations: [
                    { group_id: "75646692", addon_id: "58693496" },
                    { group_id: "75646696", addon_id: "58693272" },
                    { group_id: "75646696", addon_id: "58693273" },
                    { group_id: "75646696", addon_id: "58693274" },
                    { group_id: "75646696", addon_id: "58693275" },
                    { group_id: "75646696", addon_id: "58693276" },
                    { group_id: "75646696", addon_id: "58693277" },
                    { group_id: "75646696", addon_id: "58693195" },
                    { group_id: "75646696", addon_id: "58693270" },
                    { group_id: "75646696", addon_id: "58693271" },
                    { group_id: "75646688", addon_id: "58693175" },
                    { group_id: "75646688", addon_id: "58693176" },
                    { group_id: "75646690", addon_id: "58693179" },
                    { group_id: "75646690", addon_id: "58693181" },
                    { group_id: "75646694", addon_id: "58693251" },
                    { group_id: "75646694", addon_id: "58693252" },
                    { group_id: "75646694", addon_id: "58693253" },
                    { group_id: "75646694", addon_id: "58693254" },
                    { group_id: "75646694", addon_id: "58693255" },
                    { group_id: "75646694", addon_id: "58693256" },
                    { group_id: "75646694", addon_id: "58693257" },
                    { group_id: "75646694", addon_id: "58693258" },
                    { group_id: "75646694", addon_id: "58693259" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646688,
                group_name:
                  "Choose From Choice of Bread for Mexican Bean Patty 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646687,
                group_name:
                  "Choose From Choice of Bread for Mexican Bean Patty 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646690,
                group_name:
                  "Choose From Choice of Preparation for Mexican Bean Patty 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646689,
                group_name:
                  "Choose From Choice of Preparation for Mexican Bean Patty 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646691,
                group_name:
                  "Choose From Add Ons for Mexican Bean Patty 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693493,
                    name: "Extra Mexican Bean Patty",
                    price: 6000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646692,
                group_name:
                  "Choose From Add Ons for Mexican Bean Patty 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693496,
                    name: "Extra Mexican Bean Patty Footlong",
                    price: 12000,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646693,
                group_name:
                  "Choose From Choice of Vegetable for Mexican Bean Patty 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646694,
                group_name:
                  "Choose From Choice of Vegetable for Mexican Bean Patty 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646695,
                group_name:
                  "Choose From Choice of Sauces for Mexican Bean Patty 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646696,
                group_name:
                  "Choose From Choice of Sauces for Mexican Bean Patty 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 22500,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923818": {
            id: 108923818,
            name: "Peri Peri Chicken Sandwich Guiltfree",
            category: "GuiltFree",
            description:
              "383 Kcal I Let your tastebuds travel the world with african peri peri flavoured chicken served with nutritious veggies and packaged in your favourite bread of choice.",
            cloudinaryImageId: "89470304ce28222973e71ed99ebc0a68",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "23857362",
                  name: "Choose from Peri Peri Chicken Sandwich Guiltfree",
                  variations: [
                    {
                      name: "Peri Peri Chicken 15cm [6 Inches] Guiltfree",
                      price: 0,
                      default: 1,
                      id: "77191372",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857362",
                      order: 2,
                    },
                    {
                      name: "Peri Peri Chicken 30cm (Footlong) Guiltfree",
                      price: 200,
                      default: 0,
                      id: "77191373",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "23857362",
                      order: 1,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "23857362", variation_id: "77191372" },
                  ],
                  price: 25000,
                  addon_combinations: [
                    { group_id: "75646705", addon_id: "58693272" },
                    { group_id: "75646705", addon_id: "58693273" },
                    { group_id: "75646705", addon_id: "58693274" },
                    { group_id: "75646705", addon_id: "58693275" },
                    { group_id: "75646705", addon_id: "58693276" },
                    { group_id: "75646705", addon_id: "58693277" },
                    { group_id: "75646705", addon_id: "58693195" },
                    { group_id: "75646705", addon_id: "58693270" },
                    { group_id: "75646705", addon_id: "58693271" },
                    { group_id: "75646699", addon_id: "58693179" },
                    { group_id: "75646699", addon_id: "58693181" },
                    { group_id: "75646703", addon_id: "58693251" },
                    { group_id: "75646703", addon_id: "58693252" },
                    { group_id: "75646703", addon_id: "58693253" },
                    { group_id: "75646703", addon_id: "58693254" },
                    { group_id: "75646703", addon_id: "58693255" },
                    { group_id: "75646703", addon_id: "58693256" },
                    { group_id: "75646703", addon_id: "58693257" },
                    { group_id: "75646703", addon_id: "58693258" },
                    { group_id: "75646703", addon_id: "58693259" },
                    { group_id: "75646697", addon_id: "58693171" },
                    { group_id: "75646697", addon_id: "58693170" },
                    { group_id: "75646701", addon_id: "58693556" },
                  ],
                },
                {
                  variations: [
                    { group_id: "23857362", variation_id: "77191373" },
                  ],
                  price: 45000,
                  addon_combinations: [
                    { group_id: "75646706", addon_id: "58693272" },
                    { group_id: "75646706", addon_id: "58693273" },
                    { group_id: "75646706", addon_id: "58693274" },
                    { group_id: "75646706", addon_id: "58693275" },
                    { group_id: "75646706", addon_id: "58693276" },
                    { group_id: "75646706", addon_id: "58693277" },
                    { group_id: "75646706", addon_id: "58693195" },
                    { group_id: "75646706", addon_id: "58693270" },
                    { group_id: "75646706", addon_id: "58693271" },
                    { group_id: "75646698", addon_id: "58693175" },
                    { group_id: "75646698", addon_id: "58693176" },
                    { group_id: "75646700", addon_id: "58693179" },
                    { group_id: "75646700", addon_id: "58693181" },
                    { group_id: "75646704", addon_id: "58693251" },
                    { group_id: "75646704", addon_id: "58693252" },
                    { group_id: "75646704", addon_id: "58693253" },
                    { group_id: "75646704", addon_id: "58693254" },
                    { group_id: "75646704", addon_id: "58693255" },
                    { group_id: "75646704", addon_id: "58693256" },
                    { group_id: "75646704", addon_id: "58693257" },
                    { group_id: "75646704", addon_id: "58693258" },
                    { group_id: "75646704", addon_id: "58693259" },
                    { group_id: "75646702", addon_id: "58693562" },
                  ],
                },
              ],
            },
            addons: [
              {
                group_id: 75646697,
                group_name:
                  "Choose From Choice of Bread for Peri Peri Chicken 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646698,
                group_name:
                  "Choose From Choice of Bread for Peri Peri Chicken 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693175,
                    name: "Multigrain Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693176,
                    name: "Multigrain Honey Oats Bread 30cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 75646699,
                group_name:
                  "Choose From Choice of Preparation for Peri Peri Chicken 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646700,
                group_name:
                  "Choose From Choice of Preparation for Peri Peri Chicken 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 75646701,
                group_name:
                  "Choose From Add Ons for Peri Peri Chicken 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693556,
                    name: "Extra New Peri Peri Chicken Add15",
                    price: 8000,
                    inStock: 1,
                    isVeg: 0,
                    order: 7,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646702,
                group_name:
                  "Choose From Add Ons for Peri Peri Chicken 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693562,
                    name: "Extra New Peri Peri Chicken Add30",
                    price: 16000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 75646703,
                group_name:
                  "Choose From Choice of Vegetable for Peri Peri Chicken 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646704,
                group_name:
                  "Choose From Choice of Vegetable for Peri Peri Chicken 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646705,
                group_name:
                  "Choose From Choice of Sauces for Peri Peri Chicken 15cm [6 Inches] Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
              {
                group_id: 75646706,
                group_name:
                  "Choose From Choice of Sauces for Peri Peri Chicken 30cm (Footlong) Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            defaultPrice: 25000,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923819": {
            id: 108923819,
            name: "Peri Peri Chicken Signature Wrap Guiltfree",
            category: "GuiltFree",
            description:
              "571 Kcal I Double portion of african peri-peri flavoured chicken, along with high protein nutritious veggies and sauces, inside a tortilla of your choice.",
            cloudinaryImageId: "6494e59781b0e9cacbc6c94012e47d23",
            recommended: 1,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 30000,
            variants_new: {},
            addons: [
              {
                group_id: 75646707,
                group_name:
                  "Choose From Choice of Tortilla for Peri Peri Chicken Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 3,
              },
              {
                group_id: 75646708,
                group_name:
                  "Choose From Choice of Vegetable for Peri Peri Chicken Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646709,
                group_name:
                  "Choose From Choice of Sauces for Peri Peri Chicken Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "108923821": {
            id: 108923821,
            name: "Mexican Patty Signature Wrap Guiltfree",
            category: "GuiltFree",
            description:
              "561 Kcal I Enjoy this serving filled with double portion of mexican patty you love, on a tortilla of your choice. Top it with your favourite veggies and sauces.",
            cloudinaryImageId: "eea81e778e56a63135d095a381ba94d0",
            recommended: 1,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 27500,
            variants_new: {},
            addons: [
              {
                group_id: 75646710,
                group_name:
                  "Choose From Choice of Tortilla for Mexican Patty Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 3,
              },
              {
                group_id: 75646711,
                group_name:
                  "Choose From Choice of Vegetable for Mexican Patty Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 75646712,
                group_name:
                  "Choose From Choice of Sauces for Mexican Patty Signature Wrap Guiltfree",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110349536": {
            id: 110349536,
            name: "Buy any Sub and Get a Side At Rs.99",
            category: "Offers",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: {},
            addons: [
              {
                group_id: 78064290,
                group_name: "Choose Sandwich",
                choices: [
                  {
                    id: 62937954,
                    name: "Aloo Patty 15cm [6 Inches]",
                    price: 20500,
                    inStock: 0,
                    isVeg: 1,
                    order: 22,
                    default: 0,
                  },
                  {
                    id: 62937955,
                    name: "Chatpata Chana 15cm [6 Inches]",
                    price: 20500,
                    inStock: 1,
                    isVeg: 1,
                    order: 21,
                    default: 0,
                  },
                  {
                    id: 62937956,
                    name: "Corn & Peas 15cm [6 Inches]",
                    price: 20500,
                    inStock: 1,
                    isVeg: 1,
                    order: 20,
                    default: 0,
                  },
                  {
                    id: 62937957,
                    name: "Hara Bhara Kabab 15cm [6 Inches]",
                    price: 22500,
                    inStock: 1,
                    isVeg: 1,
                    order: 19,
                    default: 0,
                  },
                  {
                    id: 62937958,
                    name: "Mexican Bean Patty 15cm [6 Inches]",
                    price: 22500,
                    inStock: 1,
                    isVeg: 1,
                    order: 18,
                    default: 0,
                  },
                  {
                    id: 62937959,
                    name: "Tandoori Tofu 15cm [6 Inches]",
                    price: 22500,
                    inStock: 1,
                    isVeg: 1,
                    order: 17,
                    default: 0,
                  },
                  {
                    id: 62937960,
                    name: "Paneer Tikka 15cm [6 Inches]",
                    price: 23500,
                    inStock: 0,
                    isVeg: 1,
                    order: 16,
                    default: 0,
                  },
                  {
                    id: 62937961,
                    name: "Veg Shammi 15cm [6 Inches]",
                    price: 22500,
                    inStock: 1,
                    isVeg: 1,
                    order: 15,
                    default: 0,
                  },
                  {
                    id: 62937962,
                    name: "Veggie Delite 15cm [6 Inches]",
                    price: 19500,
                    inStock: 1,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 62937963,
                    name: "Chicken Teriyaki 15cm [6 Inches]",
                    price: 27500,
                    inStock: 1,
                    isVeg: 0,
                    order: 13,
                    default: 0,
                  },
                  {
                    id: 62937964,
                    name: "Chicken Slice 15cm [6 Inches]",
                    price: 25000,
                    inStock: 1,
                    isVeg: 0,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 62937965,
                    name: "Chicken Koftas 15cm [6 Inches]",
                    price: 25000,
                    inStock: 1,
                    isVeg: 0,
                    order: 11,
                    default: 0,
                  },
                  {
                    id: 62937966,
                    name: "Egg & Cheese 15cm [6 Inches]",
                    price: 17500,
                    inStock: 1,
                    isVeg: 0,
                    order: 10,
                    default: 0,
                  },
                  {
                    id: 62937967,
                    name: "Chicken Slice Egg & Cheese 15cm [6 Inches]",
                    price: 19500,
                    inStock: 1,
                    isVeg: 0,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 62937968,
                    name: "Roasted Chicken Strips 15cm [6 Inches]",
                    price: 25000,
                    inStock: 1,
                    isVeg: 0,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 62937969,
                    name: "Tuna 15cm [6 Inches]",
                    price: 27500,
                    inStock: 1,
                    isVeg: 0,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 62937970,
                    name: "Tandoori Chicken Tikka 15cm [6 Inches]",
                    price: 25000,
                    inStock: 1,
                    isVeg: 0,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 62937971,
                    name: "Turkey & Chicken Slice 15cm [6 Inches]",
                    price: 29000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937972,
                    name: "Turkey 15cm [6 Inches]",
                    price: 29000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937973,
                    name: "New B.M.T. 15cm [6 Inches]",
                    price: 27500,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937974,
                    name: "New Subway Club 15cm [6 Inches]",
                    price: 27500,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937975,
                    name: "New Peri Peri Chicken 15cm [6 Inches]",
                    price: 25000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 7,
              },
              {
                group_id: 78064291,
                group_name: "Choice of Offers",
                choices: [
                  {
                    id: 62937976,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937977,
                    name: "2 Double Dark Choc Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937978,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937979,
                    name: "Veg Kebab (5 Pieces)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937980,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 78064292,
                group_name:
                  "Choose From Choice of Bread for Buy any Sub and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693169,
                    name: "White Italian Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693170,
                    name: "Multigrain Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693171,
                    name: "Multigrain Honey Oats Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693172,
                    name: "Roasted Garlic Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693173,
                    name: "Parmesan Oregano Bread 15cm",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 78064293,
                group_name:
                  "Choose From Choice of Preparation for Buy any Sub and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693179,
                    name: "Plain Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693180,
                    name: "Plain Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693181,
                    name: "Toasted Bread",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693182,
                    name: "Toasted Bread With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693183,
                    name: "Toasted Bread With Mozzarella Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 78064294,
                group_name:
                  "Choose From Add Ons for Buy any Sub and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 78064295,
                group_name:
                  "Choose From Choice of Vegetable for Buy any Sub and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064296,
                group_name:
                  "Choose From Choice of Sauces for Buy any Sub and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110349537": {
            id: 110349537,
            name: "Buy any Wrap and Get a Side At Rs.99",
            category: "Offers",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: {},
            addons: [
              {
                group_id: 78064297,
                group_name: "Choose Wrap",
                choices: [
                  {
                    id: 62937981,
                    name: "Aloo Patty Signature Wrap",
                    price: 27500,
                    inStock: 0,
                    isVeg: 1,
                    order: 20,
                    default: 0,
                  },
                  {
                    id: 62937982,
                    name: "Corn & Peas Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 19,
                    default: 0,
                  },
                  {
                    id: 62937983,
                    name: "Chatpata Chana Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 18,
                    default: 0,
                  },
                  {
                    id: 62937984,
                    name: "Hara Bhara Patty Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 17,
                    default: 0,
                  },
                  {
                    id: 62937985,
                    name: "Mexican Patty Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 16,
                    default: 0,
                  },
                  {
                    id: 62937986,
                    name: "Paneer Tikka Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 15,
                    default: 0,
                  },
                  {
                    id: 62937987,
                    name: "Tandoori Tofu Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 62937988,
                    name: "Veg Shammi Kebab Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 13,
                    default: 0,
                  },
                  {
                    id: 62937989,
                    name: "Veggie Delite® Signature Wrap",
                    price: 27500,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 62937990,
                    name: "Chicken Kofta Signature Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 11,
                    default: 0,
                  },
                  {
                    id: 62937991,
                    name: "Chicken Slice Signature Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 10,
                    default: 0,
                  },
                  {
                    id: 62937992,
                    name: "Chicken Teriyaki Signature Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 62937993,
                    name: "Smoked Chicken Strips Signature Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 62937994,
                    name: "Tuna Signature Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 62937995,
                    name: "Tandoori Chicken Tikka Signature Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 62937996,
                    name: "Turkey & Chicken Slice Signature Wrap",
                    price: 32500,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937997,
                    name: "Turkey Signature Wrap",
                    price: 32500,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937998,
                    name: "New B.M.T. Sig Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937999,
                    name: "New Peri Peri Chicken Sig Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62938000,
                    name: "New Subway Club Sig Wrap",
                    price: 30000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 7,
              },
              {
                group_id: 78064298,
                group_name: "Choice of Offers",
                choices: [
                  {
                    id: 62937976,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937977,
                    name: "2 Double Dark Choc Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937978,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937979,
                    name: "Veg Kebab (5 Pieces)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937980,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 6,
              },
              {
                group_id: 78064299,
                group_name:
                  "Choose From Choice of Tortilla for Buy any Wrap and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693568,
                    name: "Spinach Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693569,
                    name: "Multigrain Tortilla",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 78064300,
                group_name:
                  "Choose From Choice of Preparation for Buy any Wrap and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693570,
                    name: "Wrap Without Cheese",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693571,
                    name: "Wrap With Cheese Slice",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693572,
                    name: "Wrap With Mozzarella Cheese",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 78064301,
                group_name:
                  "Choose From Add Ons for Buy any Wrap and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 78064302,
                group_name:
                  "Choose From Choice of Vegetable for Buy any Wrap and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064303,
                group_name:
                  "Choose From Choice of Sauces for Buy any Wrap and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "110349538": {
            id: 110349538,
            name: "Buy any Salad and Get a Side At Rs.99",
            category: "Offers",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: {},
            addons: [
              {
                group_id: 78064304,
                group_name: "Choose Salad",
                choices: [
                  {
                    id: 62938006,
                    name: "Aloo Patty Salad",
                    price: 27000,
                    inStock: 0,
                    isVeg: 1,
                    order: 20,
                    default: 0,
                  },
                  {
                    id: 62938007,
                    name: "Chatpata Chana Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 19,
                    default: 0,
                  },
                  {
                    id: 62938008,
                    name: "Corn & Peas Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 18,
                    default: 0,
                  },
                  {
                    id: 62938009,
                    name: "Mexican Bean Patty Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 17,
                    default: 0,
                  },
                  {
                    id: 62938010,
                    name: "Hara Bhara Kabab Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 16,
                    default: 0,
                  },
                  {
                    id: 62938011,
                    name: "Tandoori Tofu Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 15,
                    default: 0,
                  },
                  {
                    id: 62938012,
                    name: "Paneer Tikka Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 14,
                    default: 0,
                  },
                  {
                    id: 62938013,
                    name: "Veg Shammi Kebab Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 13,
                    default: 0,
                  },
                  {
                    id: 62938014,
                    name: "Veggie Delite® Salad",
                    price: 27000,
                    inStock: 1,
                    isVeg: 1,
                    order: 12,
                    default: 0,
                  },
                  {
                    id: 62938015,
                    name: "Chicken Slice Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 11,
                    default: 0,
                  },
                  {
                    id: 62938016,
                    name: "Chicken Koftas Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 10,
                    default: 0,
                  },
                  {
                    id: 62938017,
                    name: "Chicken Teriyaki Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 62938018,
                    name: "Smoked Chicken Strips Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 62938019,
                    name: "Tandoori Chicken Tikka Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 62938020,
                    name: "Tuna Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 62938021,
                    name: "Turkey & Chicken Slice Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62938022,
                    name: "Turkey Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62938023,
                    name: "New B.M.T. Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62938024,
                    name: "New Peri Peri Chicken Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62938025,
                    name: "New Subway Club Salad",
                    price: 31000,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 5,
              },
              {
                group_id: 78064305,
                group_name: "Choice of Offers",
                choices: [
                  {
                    id: 62937976,
                    name: "2 Dark Chunk Choc Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 62937977,
                    name: "2 Double Dark Choc Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 62937978,
                    name: "2 Oatmeal Raisin Cookies",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 62937979,
                    name: "Veg Kebab (5 Pieces)",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 62937980,
                    name: "Chicken Meatballs (5 Pieces)",
                    price: 0,
                    inStock: 1,
                    isVeg: 0,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 1,
                maxFreeAddons: -1,
                minAddons: 1,
                order: 4,
              },
              {
                group_id: 78064306,
                group_name:
                  "Choose From Choice of Vegetable for Buy any Salad and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693251,
                    name: "Lettuce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693252,
                    name: "Tomato",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693253,
                    name: "Cucumber",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693254,
                    name: "Pickle",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693255,
                    name: "Capsicum",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693256,
                    name: "Olives",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693257,
                    name: "Onions",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693258,
                    name: "Jalapenos",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693259,
                    name: "Salt & Pepper",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 9,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 3,
              },
              {
                group_id: 78064307,
                group_name:
                  "Choose From Add Ons for Buy any Salad and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693190,
                    name: "Extra Cheese Slice",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693191,
                    name: "Extra Mozzarella Cheese",
                    price: 3000,
                    inStock: 1,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 2,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 2,
              },
              {
                group_id: 78064308,
                group_name:
                  "Choose From Choice of Sauces for Buy any Salad and Get a Side At Rs.99",
                choices: [
                  {
                    id: 58693272,
                    name: "Honey Mustard Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 9,
                    default: 0,
                  },
                  {
                    id: 58693273,
                    name: "Red Chilli Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 8,
                    default: 0,
                  },
                  {
                    id: 58693274,
                    name: "Tandoori Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 7,
                    default: 0,
                  },
                  {
                    id: 58693275,
                    name: "Barbeque Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 6,
                    default: 0,
                  },
                  {
                    id: 58693276,
                    name: "Marinara Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 5,
                    default: 0,
                  },
                  {
                    id: 58693277,
                    name: "Sweet Onion Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 4,
                    default: 0,
                  },
                  {
                    id: 58693195,
                    name: "Eggless Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 3,
                    default: 0,
                  },
                  {
                    id: 58693270,
                    name: "Mint Mayonnaise Sauce",
                    price: 0,
                    inStock: 1,
                    isVeg: 1,
                    order: 2,
                    default: 0,
                  },
                  {
                    id: 58693271,
                    name: "Southwest Chipotle Sauce",
                    price: 0,
                    inStock: 0,
                    isVeg: 1,
                    order: 1,
                    default: 0,
                  },
                ],
                maxAddons: 3,
                maxFreeAddons: -1,
                minAddons: 0,
                order: 1,
              },
            ],
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "656392",
            showMC: 0,
            attributes: {
              portionSize: "0 gram",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            offerTags: [
              {
                title: "20% OFF",
                subTitle: "USE TRYNEW",
                textColor: "#DB6742",
                backGroundColor: "#FAE8E3",
              },
            ],
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "Top Picks",
            subTitle: "",
            type: "menuCarousels",
            entities: [],
            widgets: [],
            collapsible: false,
          },
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [
              {
                id: 108923720,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923715,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923816,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923707,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923792,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923710,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923796,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923818,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923712,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923821,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923709,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923808,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 108923819,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240457,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240458,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240460,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240461,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240462,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240463,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240464,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240465,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240466,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240467,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240468,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240469,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240470,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240472,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240473,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240474,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240475,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240476,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240477,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240478,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240479,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240481,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240483,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240484,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240485,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240486,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240488,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240489,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240490,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240491,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240492,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240493,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240494,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240495,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240496,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240497,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240498,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240499,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240500,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240501,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240503,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240504,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240505,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240506,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240507,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240509,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240510,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240511,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240512,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240513,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240515,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240516,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240517,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240518,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240519,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240520,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240521,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240522,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240523,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240539,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240540,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240541,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240542,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240536,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
              {
                id: 107240538,
                type: "item",
                showImg: true,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Offers",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "UpYourSub At Rs 99",
                type: "subcategory",
                entities: [
                  {
                    id: 110349536,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "UpYourWrap At Rs 99",
                type: "subcategory",
                entities: [
                  {
                    id: 110349537,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "UpYourSalad At Rs 99",
                type: "subcategory",
                entities: [
                  {
                    id: 110349538,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "GuiltFree",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "GuiltFree Veg Sandwiches",
                type: "subcategory",
                entities: [
                  {
                    id: 108923720,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923715,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923816,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923707,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "GuiltFree Non Veg Sandwiches",
                type: "subcategory",
                entities: [
                  {
                    id: 108923792,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923710,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923796,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923818,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "GuiltFree Signature Wrap Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 108923712,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923821,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "GuiltFree Signature Wrap Non Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 108923709,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923808,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 108923819,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Sandwiches",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Breakfast Sandwiches",
                type: "subcategory",
                entities: [
                  {
                    id: 107240457,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240458,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg Sandwiches",
                type: "subcategory",
                entities: [
                  {
                    id: 107240460,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240461,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240462,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240463,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240464,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240465,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240466,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240467,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non Veg Sandwiches",
                type: "subcategory",
                entities: [
                  {
                    id: 107240468,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240469,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240470,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240472,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240473,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240474,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240475,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240476,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240477,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240478,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240479,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Salads",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Veg Salads",
                type: "subcategory",
                entities: [
                  {
                    id: 107240481,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240483,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240484,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240485,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240486,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240488,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240489,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240490,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non Veg Salads",
                type: "subcategory",
                entities: [
                  {
                    id: 107240491,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240492,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240493,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240494,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240495,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240496,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240497,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240498,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240499,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240500,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240501,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Signature Wraps",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Veg Signature Wraps",
                type: "subcategory",
                entities: [
                  {
                    id: 107240503,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240504,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240505,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240506,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240507,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240509,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240510,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240511,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non Veg Signature Wraps",
                type: "subcategory",
                entities: [
                  {
                    id: 107240512,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240513,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240515,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240516,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240517,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240518,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240519,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240520,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240521,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240522,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240523,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Sides",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Sub Wraps",
                type: "subcategory",
                entities: [
                  {
                    id: 107240539,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240540,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240541,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240542,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Snacks",
                type: "subcategory",
                entities: [
                  {
                    id: 107240533,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240534,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240535,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Toasties",
                type: "subcategory",
                entities: [
                  {
                    id: 107240536,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240537,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240538,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Chips",
                type: "subcategory",
                entities: [
                  {
                    id: 107240524,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240525,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240527,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240528,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240529,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240530,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240531,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Beverages",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Drinks",
                type: "subcategory",
                entities: [
                  {
                    id: 107240544,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240545,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240546,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240547,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Raw Pressery",
                type: "subcategory",
                entities: [
                  {
                    id: 107240549,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240550,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240551,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240552,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240553,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Desserts",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Cookies",
                type: "subcategory",
                entities: [
                  {
                    id: 107240554,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240555,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 107240556,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        menuCarousels: [
          {
            type: "TopCarousel",
            subtype: "image",
            data: {
              bannerId: 835392,
              creativeId: "TopPicks/ChknKftSnwch",
              creativeThumbnail: "",
              linkType: "item",
              link: "107240468",
              title: "Chicken Kofta Sandwich",
              description: " ",
              priority: -1,
              fontColor: "#FFFFFF",
            },
          },
          {
            type: "TopCarousel",
            subtype: "image",
            data: {
              bannerId: 836488,
              creativeId: "TopPicks/Pnrtkaswch",
              creativeThumbnail: "",
              linkType: "item",
              link: "107240464",
              title: "Paneer Tikka Sandwich",
              description: " ",
              priority: -1,
              fontColor: "#FFFFFF",
            },
          },
        ],
        layoutType: "menu_merchandise",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "20% OFF UPTO ₹50",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["14e08820-9850-4843-a23b-521a54cd3021"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE TRYNEW",
          description: "ON SELECT ITEMS",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "20% off",
        shortDescriptionList: [
          {
            meta: "20% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "20% off up to ₹50 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 106,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11222334001955"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "b90fa1ee-0e76-4c71-9dbb-26c922d0cab8",
      timeStamp: "1677489400335",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "8kfTizcvgVIp--Qoa6neZotcciUMjLvIOW57w-b4",
  },
  {
    statusCode: 0,
    data: {
      experiments: [{ experimentId: "menu_via_timeline", variantId: "true" }],
      restaurantAttributes: [],
      id: "419413",
      name: "MIRCHI MAHARAJ",
      uuid: "67181ec9-aa3e-4168-9e50-7b841c51b0ff",
      slug: "mirchi-maharaj-hsr-hsr",
      latLong: "12.912435,77.63855",
      city: "Bangalore",
      area: "HSR Layout",
      areaPostalCode: "560102",
      areaSlug: "hsr",
      restaurantSlug: {
        restaurant: "mirchi-maharaj-hsr-hsr",
        city: "bangalore",
      },
      type: "F",
      locality: "4th Sector",
      avgRating: 3.7,
      totalRatings: 100,
      avgRatingString: "3.7",
      totalRatingsString: "100+ ratings",
      cloudinaryImageId: "sh5gkksgojqf8jfey6my",
      costForTwo: 20000,
      costForTwoMsg: "₹200 for two",
      cuisines: ["Indian", "Chinese"],
      minimumOrder: 0,
      opened: 1,
      parentId: 233709,
      isNew: false,
      isVeg: false,
      favorite: false,
      multiOutlet: true,
      restaurantServiceLine: ["REGULAR"],
      sla: {
        slaString: "29 MINS",
        lastMileDistanceString: "3.9 kms",
        restaurantId: "419413",
        deliveryTime: 29,
        minDeliveryTime: 29,
        maxDeliveryTime: 29,
        lastMileTravel: 3.9,
        thirtyMinOrFree: false,
        serviceability: "SERVICEABLE",
        stressFactor: 0.5369791984558105,
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        batchable: false,
        stress: {
          value: 0.3333333432674408,
          components: { de: 0.3333333432674408 },
        },
        surge: {
          applicable: false,
          components: [{ value: 0, type: "STRESS" }],
        },
        zoneId: 3,
      },
      availability: {
        nextCloseTime: "2023-02-27 16:00:00",
        nextChangeTime: 1677493800000,
        visibility: true,
        opened: true,
      },
      badges: { imageBased: [], textBased: [], textExtendedBadges: [] },
      labels: [
        { title: "Timings", message: "null" },
        {
          title: "Address",
          message:
            "NO.89,14TH MAIN,17TH CROSS,SECTOR-4,HSR  LAYOUT,BANGALORE-560102, BTM Layout ,  B.B.M.P South, Karnataka-560102",
        },
        { title: "Cuisines", message: "Indian,Chinese" },
      ],
      thirdPartyAddress: false,
      menu: {
        items: {
          "75817796": {
            id: 75817796,
            name: "Butter Chicken",
            category: "Gravy",
            description:
              "One of the most popular Punjabi style chicken dishes in the world , cooked in tomato puree, cream, butter and a host of masalas.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817801": {
            id: 75817801,
            name: "Chicken Kolhapuri",
            category: "Gravy",
            description:
              "A perfectly seasoned dish with chicken pieces cooked with onions, tomatoes, green chillies and other vegetable.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817819": {
            id: 75817819,
            name: "Hyderabadi Chicken",
            category: "Gravy",
            description: "Spiceness of hyderabadi in chicken.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817823": {
            id: 75817823,
            name: "Chicken Tikka Masala",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817827": {
            id: 75817827,
            name: "Veg Biryani",
            category: "RECOMMENDED",
            description: "Veg biryani comes with fresh green veggies.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817828": {
            id: 75817828,
            name: "Chicken Keema Curry",
            category: "Gravy",
            description:
              "Chicken mince cooked with indian spices & dressed up with herbs.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 21000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817836": {
            id: 75817836,
            name: "Mutton Curry",
            category: "Gravy",
            description:
              "Much loved recipe of mutton morsels cooked in freshly ground spice blend, immaculately cooked, and simmered to perfection. Best savoured with rice or roti.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817844": {
            id: 75817844,
            name: "Mushroom Biryani",
            category: "RECOMMENDED",
            description:
              "A right-sized lunch with a flavour punch Enjoy 21 spice biryani rice with pepper mushroom, Served alongside refreshing raita.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817849": {
            id: 75817849,
            name: "Hyderabadi Mutton",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817854": {
            id: 75817854,
            name: "Kadai Mutton",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817859": {
            id: 75817859,
            name: "Mutton Kohlapuri",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817861": {
            id: 75817861,
            name: "Chicken Fry Biryani",
            category: "RECOMMENDED",
            description:
              '"A speciality of our kitchen, Hot and spicy tender bone chicken fried with spiced in-house masala with dum cooked long grain basmati rice with authentic hydeabadi style.',
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817864": {
            id: 75817864,
            name: "Mutton Keema Curry",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817870": {
            id: 75817870,
            name: "Mutton Mughlai",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817873": {
            id: 75817873,
            name: "Mutton Fry Biryani",
            category: "RECOMMENDED",
            description:
              '"A speciality of our kitchen, Hot and spicy tender bone chicken fried with spiced in-house masala with dum cooked long grain basmati rice with authentic hydeabadi style.',
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817878": {
            id: 75817878,
            name: "Chicken Boneless Biryani",
            category: "RECOMMENDED",
            description:
              "A Flavourful Combination Of Paneer Makhani, Nuts & Fragrant Saffron Rice. Served with Raita & Fryums",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817882": {
            id: 75817882,
            name: "Fish Masala",
            category: "Gravy",
            description:
              "Fish Fry masala is a meal containing battered or breaded fried fish.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817886": {
            id: 75817886,
            name: "Kadai Fish",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817894": {
            id: 75817894,
            name: "Prawns Curry",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817897": {
            id: 75817897,
            name: "Prawns Masala",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817899": {
            id: 75817899,
            name: "Mutton Chettinadu Biryani",
            category: "RECOMMENDED",
            description:
              "Made Horse gram, tamarind and spices to a thick soup - Mouthwatering combination of biryani with distinct tangy taste of horse gram gravy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817902": {
            id: 75817902,
            name: "Mutton Keema Biryani",
            category: "RECOMMENDED",
            description:
              "Chicken biryani served with keema of chicken with a fully cooked chicken.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817904": {
            id: 75817904,
            name: "Chilli Baby Corn",
            category: "Starters",
            description:
              "Baby corn is used in Asian salads, stir fry vegetables, Indian curries and chinese manchurian. Whether stirred or fried, baked or steamed, baby corn can turn your everyday meal around.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817910": {
            id: 75817910,
            name: "Baby Corn Manchurian",
            category: "Starters",
            description:
              "Baby corn is used in Asian salads, stir fry vegetables, Indian curries and chinese manchurian. Whether stirred or fried, baked or steamed, baby corn can turn your everyday meal around.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817914": {
            id: 75817914,
            name: "Chilli Mushroom",
            category: "Starters",
            description:
              "Chilli mushroom dry or mushroom chilli recipe is an exemplary indo-chinese recipe and a perfect snack or appetizer for any get together. In this preparation, crispy mushroom nuggets are tossed in spicy sweet and sour sauce with spring onion, garlic, onion and capsicum chunks.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817920": {
            id: 75817920,
            name: "Gobi Manchurian",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817922": {
            id: 75817922,
            name: "Gobi 65",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817934": {
            id: 75817934,
            name: "Chilli Paneer",
            category: "Starters",
            description:
              "Paneer (Indian cottage cheese) is tossed in a flavorful spicy sauce made with soy sauce, chili sauce, vinegar.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817936": {
            id: 75817936,
            name: "Paneer 65",
            category: "Starters",
            description:
              "Fresh cottage cheese cubes medium consistency batter with authentic flavorfull masala and deep fried.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817943": {
            id: 75817943,
            name: "Egg Boiled",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817945": {
            id: 75817945,
            name: "Egg Omelette",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 5000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817952": {
            id: 75817952,
            name: "Phulka",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817955": {
            id: 75817955,
            name: "Chilli Egg",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817962": {
            id: 75817962,
            name: "Chilli Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817965": {
            id: 75817965,
            name: "Chicken 65",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817969": {
            id: 75817969,
            name: "Ginger Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817971": {
            id: 75817971,
            name: "Lemon Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817975": {
            id: 75817975,
            name: "Pepper Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817983": {
            id: 75817983,
            name: "Chicken 555",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817984": {
            id: 75817984,
            name: "Chicken Majestic",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817986": {
            id: 75817986,
            name: "Dragon Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817990": {
            id: 75817990,
            name: "Crispy Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75817991": {
            id: 75817991,
            name: "Cashew Chicken",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818002": {
            id: 75818002,
            name: "Andhra Veg Meals",
            category: "Meals",
            description: "Eligible for one person.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818004": {
            id: 75818004,
            name: "Fish Fry",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 25000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818008": {
            id: 75818008,
            name: "Chilli Prawns",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818013": {
            id: 75818013,
            name: "Prawns Pepper Fry",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818014": {
            id: 75818014,
            name: "Dal Fry",
            category: "Gravy",
            description:
              "Dal fry is a popular Indian lentil recipe made with arhar dal, onions, tomatoes and spices.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818023": {
            id: 75818023,
            name: "Mix Veg Curry",
            category: "Gravy",
            description:
              "Family favourite mixed vegetable curry cooked in a traditional onion tomato gravy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818025": {
            id: 75818025,
            name: "Aloo Gobi Curry",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 9900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818026": {
            id: 75818026,
            name: "Kadai Veg",
            category: "Gravy",
            description:
              'Baltic dish with mixed vegetables in fiery masala cooked in traditional "karahi" vessel.',
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818027": {
            id: 75818027,
            name: "Curd Rice",
            category: "Rice And Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 8000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818029": {
            id: 75818029,
            name: "Veg Kolhapuri",
            category: "Gravy",
            description:
              "Veg kolhapuri, a mixed vegetable curry with thick and spicy gravy, is a popular dish of maharashtrian cuisine.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818033": {
            id: 75818033,
            name: "Ghee Rice",
            category: "Rice And Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818034": {
            id: 75818034,
            name: "Malai Kofta",
            category: "Gravy",
            description:
              "Cottage cheese dumplings filled with dry fruits, simmered in a light gravy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818036": {
            id: 75818036,
            name: "Paneer Butter Masala",
            category: "RECOMMENDED",
            description:
              "Paneer butter masala is a creamy and mildly sweet gravy made with butter, tomatoes, cashews, spices and paneer.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818037": {
            id: 75818037,
            name: "Paneeer Shahi Korma",
            category: "Gravy",
            description:
              "Fresh, unmelting cheese flavour is married with a creamy gravy of vegetables, perfect for serving with naan or roti.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818038": {
            id: 75818038,
            name: "Jeera Rice",
            category: "Rice And Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 10000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818042": {
            id: 75818042,
            name: "Paneer Tikka Masala",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818050": {
            id: 75818050,
            name: "Baby Corn Masala",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 11900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818057": {
            id: 75818057,
            name: "Kadai Chicken",
            category: "Gravy",
            description:
              "Famous desi signature dish. Chicken cooked with fresh garlic, ginger, onions, tomatoes and spices. Garnished with chunks of tomatoes and sprinkled with fresh coriander and ginger and freshly chopped green chillies.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "75818059": {
            id: 75818059,
            name: "Veg Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "Rice stir fried with assorted vegetables & soy sauce, perfect entre to satiate your cravings.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 12000,
            variants_new: {},
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76439410": {
            id: 76439410,
            name: "Paneer Pepper Dry",
            category: "Starters",
            description:
              "Paneer pepper dry a crispy pepper flavoured and spiceness of pepper.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76439415": {
            id: 76439415,
            name: "Baby Corn Pepper Dry",
            category: "Starters",
            description:
              "Baby corn pepper dry a crispy pepper flavoured and spiceness of pepper.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76440888": {
            id: 76440888,
            name: "Rogan Josh",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76926950": {
            id: 76926950,
            name: "Andhra Veg Full Carrier Meal (take Away)",
            category: "Meals",
            description:
              "White rice, akkura pappu, sambar, rasam, chutney, sweet, papad, curd, pickle, gongura, ghee, fried chilly.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 35000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927082": {
            id: 76927082,
            name: "Buttermilk",
            category: "Beverage",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927110": {
            id: 76927110,
            name: "Soft Drinks",
            category: "Beverage",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927115": {
            id: 76927115,
            name: "Sweet Lassi",
            category: "Beverage",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 4000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927119": {
            id: 76927119,
            name: "Water",
            category: "Beverage",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 2000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927304": {
            id: 76927304,
            name: "Chicken Fry",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "11698495",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Bone",
                      price: 199,
                      default: 1,
                      id: "38436916",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11698495",
                      order: 997,
                    },
                    {
                      name: "Boneless",
                      price: 199,
                      default: 0,
                      id: "38436917",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11698495",
                      order: 996,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "11698495", variation_id: "38436916" },
                  ],
                  price: 19900,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "11698495", variation_id: "38436917" },
                  ],
                  price: 19900,
                  addon_combinations: [],
                },
              ],
            },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            defaultPrice: 19900,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927309": {
            id: 76927309,
            name: "Chicken Lollipop",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "11698496",
                  name: "Quantity",
                  variations: [
                    {
                      name: "4 Pcs",
                      price: 180,
                      default: 1,
                      id: "38436918",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11698496",
                      order: 995,
                    },
                    {
                      name: "8 Pcs",
                      price: 340,
                      default: 0,
                      id: "38436919",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11698496",
                      order: 994,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "11698496", variation_id: "38436918" },
                  ],
                  price: 18000,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "11698496", variation_id: "38436919" },
                  ],
                  price: 34000,
                  addon_combinations: [],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            defaultPrice: 18000,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927387": {
            id: 76927387,
            name: "Prawn Manchurian",
            category: "Starters",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 28000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927491": {
            id: 76927491,
            name: "Chicken Curry",
            category: "Gravy",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 0,
            variantsV2: {
              variant_groups: [
                {
                  group_id: "11698500",
                  name: "Quantity",
                  variations: [
                    {
                      name: "Bone",
                      price: 179,
                      default: 1,
                      id: "38436932",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11698500",
                      order: 997,
                    },
                    {
                      name: "Boneless",
                      price: 199,
                      default: 0,
                      id: "38436933",
                      inStock: 1,
                      isVeg: 0,
                      variant_group_id: "11698500",
                      order: 996,
                    },
                  ],
                },
              ],
              pricing_models: [
                {
                  variations: [
                    { group_id: "11698500", variation_id: "38436932" },
                  ],
                  price: 17900,
                  addon_combinations: [],
                },
                {
                  variations: [
                    { group_id: "11698500", variation_id: "38436933" },
                  ],
                  price: 19900,
                  addon_combinations: [],
                },
              ],
            },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            defaultPrice: 17900,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927699": {
            id: 76927699,
            name: "Chicken Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927704": {
            id: 76927704,
            name: "Egg Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927715": {
            id: 76927715,
            name: "Veg Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 15000,
            variants_new: {},
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927732": {
            id: 76927732,
            name: "Chicken Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "Chicken Fried rice tossed in Chicken fried rice sauces.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927743": {
            id: 76927743,
            name: "Egg Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "A medley of scrambled eggs and seasonal veggies wok tossed along with rice and aromatic Chinese spices. Eggztravaganza! Contains Egg, Soy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: {},
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927775": {
            id: 76927775,
            name: "Prawns Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "Prawns fried rice tossed in prawns fried rice sauces.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 20000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927787": {
            id: 76927787,
            name: "Chicken Keema Biryani",
            category: "Rice And Biryani",
            description:
              "Chicken biryani served with keema of chicken with a fully cooked chicken.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927789": {
            id: 76927789,
            name: "Chicken Tikka Biryani",
            category: "Rice And Biryani",
            description:
              "Chicken tikka biriyani is one of the richest mughlai recipes. This is a combination of 4 pcs of chicken tikka with biriyani served with salan and raita.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927790": {
            id: 76927790,
            name: "Chicken Ulavachara Biryani",
            category: "RECOMMENDED",
            description:
              "Made Horse gram, tamarind and spices to a thick soup - Mouthwatering combination of biryani with distinct tangy taste of horse gram gravy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:09 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927791": {
            id: 76927791,
            name: "Chicken-65 Biryani",
            category: "Rice And Biryani",
            description:
              "A novel combination of our classic seeraga samba Biryani crowned with succulent chicken 65 chunks - Served With Boiled egg, Raita & Salna.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927793": {
            id: 76927793,
            name: "Gongura Chicken Biryani",
            category: "RECOMMENDED",
            description:
              "The sourness of fresh red sorrel leaves or gongura leaves add a special tangy taste to this andhra delicacy. Also served with gravy, raitha.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927799": {
            id: 76927799,
            name: "Gongura Mutton Biryani",
            category: "Rice And Biryani",
            description:
              "The sourness of fresh red sorrel leaves or gongura leaves add a special tangy taste to this andhra delicacy. Also served with gravy, raitha.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927800": {
            id: 76927800,
            name: "Hyderabadi Chicken Dum Biryani",
            category: "RECOMMENDED",
            description:
              "Juicy succulent chicken pieces biryani slowly dum with natural ingredients served with mirchi ka salan and thick creamy raitha.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927803": {
            id: 76927803,
            name: "Lollipop Biryani",
            category: "RECOMMENDED",
            description:
              "Slow dum cooked indegenous malabar moplah biryani layered with chicken lollypop pieces in authentic aromatic masala, fluffy jeeraga samba rice, crunchy fried onions and simmered with ghee. Served with coconut chammanthi, dates pickle, raitha and pappadam.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927814": {
            id: 76927814,
            name: "Mutton Ulavachara Biryani",
            category: "RECOMMENDED",
            description:
              "Made Horse gram, tamarind and spices to a thick soup - Mouthwatering combination of biryani with distinct tangy taste of horse gram gravy.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 29900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927815": {
            id: 76927815,
            name: "Paneer Makhani Biryani",
            category: "RECOMMENDED",
            description:
              "A flavourful combination of paneer makhani, nuts & fragrant saffron rice. Served with raita & fryums.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 24900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "76927817": {
            id: 76927817,
            name: "Prawns Biryani",
            category: "RECOMMENDED",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533584": {
            id: 81533584,
            name: "Andhra Style Chilli Chicken",
            category: "RECOMMENDED",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533585": {
            id: 81533585,
            name: "Chicken Kebab",
            category: "RECOMMENDED",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533587": {
            id: 81533587,
            name: "Schezwan Chicken Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533588": {
            id: 81533588,
            name: "Schezwan Egg Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 18000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533589": {
            id: 81533589,
            name: "Schezwan Veg Noodles",
            category: "Fried Rice And Noodles",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533590": {
            id: 81533590,
            name: "Schezwan Chicken Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "Chicken Fried rice tossed in Chicken fried rice schzwen sauces.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533591": {
            id: 81533591,
            name: "Schezwan Egg Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "A medley of scrambled eggs and seasonal veggies wok tossed along with rice and aromatic chinese spices. Eggztravaganza! contains egg, soy with schezwan sause.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 16000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533592": {
            id: 81533592,
            name: "Schezwan Prawns Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "Prawns fried rice tossed in prawns fried rice sauces and schzwen sause.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 22000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "81533593": {
            id: 81533593,
            name: "Schezwan Veg Fried Rice",
            category: "Fried Rice And Noodles",
            description:
              "Rice stir fried with assorted vegetables & schezwan sauce, perfect entre to satiate your cravings.",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 14000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82581043": {
            id: 82581043,
            name: "Biryani Rice",
            category: "RECOMMENDED",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82581044": {
            id: 82581044,
            name: "Chicken Boneless Curry",
            category: "RECOMMENDED",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:06 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82581045": {
            id: 82581045,
            name: "Egg Biryani",
            category: "RECOMMENDED",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 17000,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82581046": {
            id: 82581046,
            name: "Maharaj Chicken Majestic",
            category: "RECOMMENDED",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 19900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82581047": {
            id: 82581047,
            name: "Butter Pulka",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82581048": {
            id: 82581048,
            name: "Parota",
            category: "Breads",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 1,
            enabled: 1,
            displayOrder: 0,
            price: 3000,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:07 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "VEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "82581049": {
            id: 82581049,
            name: "Mutton Kheema Biryani",
            category: "Rice And Biryani",
            description: "",
            cloudinaryImageId: "",
            recommended: 0,
            inStock: 0,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            nextAvailableAtMessage: "Next available at 1:08 pm, tomorrow",
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: false,
            itemNudgeType: "",
            isGuiltFree: false,
          },
          "107151888": {
            id: 107151888,
            name: "Biryani Combo @349",
            category: "RECOMMENDED",
            description: "ONE TYPE OF HYD DUM BIRYANI AND 3 CHICKEN STARTERS",
            cloudinaryImageId: "cc71751827ab4878ce6f4795efa1b882",
            recommended: 0,
            inStock: 1,
            isVeg: 0,
            enabled: 1,
            displayOrder: 0,
            price: 34900,
            variants_new: { exclude_list: [], variant_groups: [] },
            cropChoices: 2,
            itemScore: 0,
            itemDiscount: 0,
            isPopular: 0,
            restId: "419413",
            showMC: 0,
            ribbon: {
              text: "Bestseller",
              textColor: "#ffffff",
              topBackgroundColor: "#d53d4c",
              bottomBackgroundColor: "#b02331",
            },
            attributes: {
              portionSize: "",
              vegClassifier: "NONVEG",
              accompaniments: "",
            },
            isHealthy: false,
            isBestSeller: true,
            itemNudgeType: "",
            isGuiltFree: false,
          },
        },
        widgets: [
          {
            name: "RECOMMENDED",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75817827,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75817844,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75817861,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75817878,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927800,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81533584,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 81533585,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 82581043,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 82581045,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 82581046,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 107151888,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75817873,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75817899,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75817902,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 75818036,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927790,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927793,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927803,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927814,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927815,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927817,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 82581044,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Starters",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Starters-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 75817904,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817910,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817914,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817920,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817922,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817934,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817936,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76439410,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76439415,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Starters-non Veg",
                type: "subcategory",
                entities: [
                  {
                    id: 75817962,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817965,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817969,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817971,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817975,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817983,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817984,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817986,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927304,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817990,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817991,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927309,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Starters-egg",
                type: "subcategory",
                entities: [
                  {
                    id: 75817943,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817945,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817955,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Starters-sea Food",
                type: "subcategory",
                entities: [
                  {
                    id: 75818004,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818008,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818013,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927387,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Rice And Biryani",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Biryani",
                type: "subcategory",
                entities: [
                  {
                    id: 76927791,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927787,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927789,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927799,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 82581049,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg Rice",
                type: "subcategory",
                entities: [
                  {
                    id: 75818027,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818033,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818038,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Recommended",
            subTitle: "",
            type: "recommended",
            entities: [],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Gravy",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Veg-gravy",
                type: "subcategory",
                entities: [
                  {
                    id: 75818014,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818023,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818025,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818026,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818029,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818034,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818037,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818042,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818050,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Non Veg-gravy",
                type: "subcategory",
                entities: [
                  {
                    id: 75817796,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817801,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817819,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817823,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817828,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75818057,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927491,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Mutton-gravy",
                type: "subcategory",
                entities: [
                  {
                    id: 75817836,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817849,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817854,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817859,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817864,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817870,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76440888,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Sea Food-gravy",
                type: "subcategory",
                entities: [
                  {
                    id: 75817882,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817886,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817894,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 75817897,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Breads",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75817952,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 82581047,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 82581048,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Meals",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 75818002,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76926950,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Fried Rice And Noodles",
            subTitle: "",
            type: "category",
            widgets: [
              {
                name: "Fried Rice Veg And Non-veg",
                type: "subcategory",
                entities: [
                  {
                    id: 75818059,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927732,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927743,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927775,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81533590,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81533591,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81533592,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81533593,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
              {
                name: "Veg And Non-veg Noodles",
                type: "subcategory",
                entities: [
                  {
                    id: 76927699,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927704,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 76927715,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81533587,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81533588,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                  {
                    id: 81533589,
                    type: "item",
                    showImg: false,
                    showRibbon: false,
                  },
                ],
                collapsible: true,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
          {
            name: "Beverage",
            subTitle: "",
            type: "category",
            entities: [
              {
                id: 76927082,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927110,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927115,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
              {
                id: 76927119,
                type: "item",
                showImg: false,
                showRibbon: false,
              },
            ],
            perRow: 2,
            collapsible: false,
          },
        ],
        layoutType: "normal",
        healthyCollection: [],
      },
      aggregatedDiscountInfo: {
        header: "40% off",
        shortDescriptionList: [
          {
            meta: "40% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "40% off up to ₹80 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
      },
      offerMeta: [
        {
          header: "40% OFF UPTO ₹80",
          offer_tag: "",
          offer_logo: "offers/generic",
          top_logo: "",
          bottom_logo: "",
          offer_info: {
            offer_ids: ["4d4a0f06-52ab-49eb-b4af-fd6fc0e88852"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE TRYNEW",
          description: "ABOVE ₹149",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "20% OFF UPTO ₹120",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/1acdb97aadcb61b323307845bda86535",
          offer_info: {
            offer_ids: ["68d41a53-c297-48e9-b3e0-054e3fd05845"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE FEDERALCC",
          description: "ABOVE ₹249",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
        {
          header: "FLAT ₹100 OFF",
          offer_tag: "",
          offer_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          top_logo: "",
          bottom_logo: "rng/md/ads/production/3a937ddacd3adb70c4543c4895213123",
          offer_info: {
            offer_ids: ["db599105-a5bd-481a-988f-ede0670a6b16"],
            type: "offers",
          },
          expiry_time: 0,
          coupon_code: "USE AUDC100",
          description: "ABOVE ₹299",
          secondary_discount_callout: "",
          show_expiry_timer: false,
        },
      ],
      itemNudgeBanners: {},
      aggregatedDiscountInfoV2: {
        header: "40% off",
        shortDescriptionList: [
          {
            meta: "40% off | Use TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        descriptionList: [
          {
            meta: "40% off up to ₹80 | Use code TRYNEW",
            discountType: "Percentage",
            operationType: "RESTAURANT",
          },
          {
            meta: "FREE DELIVERY",
            discountType: "FREE_DELIVERY",
            operationType: "RESTAURANT",
          },
        ],
        couponDetailsCTAText: "View coupon details",
        visible: false,
      },
      nudgeBanners: [
        {
          minValue: 104.3,
          maxValue: 149,
          priority: 2,
          couponCode: "",
          discountInfo: {
            discountType: "FREE_DELIVERY",
            value: 0,
            operationType: "RESTAURANT",
          },
          lockedMessage: "",
          unlockedMessage: "",
          minItemCount: 0,
          maxItemCount: 0,
          type: "",
          cta: { link: "", text: "", type: "", color: "" },
        },
      ],
      restaurantLicenses: [
        {
          type: "FSSAI",
          imageId: "fssai_final_edss9i",
          text: ["License No. 11221334001703"],
        },
      ],
      menuTabs: [{ title: "Order Now", type: "menu", selected: true }],
      vegOnlyDetails: {
        imageId: "AutoVegOnly_qkjowj",
        title: "Showing only vegetarian options.",
        description: "Tap on the VEG ONLY button to turn off the setting",
      },
      gpInfoList: [],
      expectationNotifiers: [],
      menuCategory: [
        {
          name: "Full Menu",
          identifier: "REGULAR",
          icon: "v1594205104/fullMenuActive_qcsdzt.png",
          unselectedIcon: "v1594205107/fullMenuInactive_fbdtp2.png",
          selected: true,
        },
      ],
      xpConfigParams: { isNewHealthMenu: "false" },
      cafe: false,
      preorderable: false,
      select: false,
      slotInvalid: false,
      requestId: "dffe1a7a-1160-4c34-906a-b20f65a11cd9",
      timeStamp: "1677489422372",
    },
    tid: "2a5033da-edf5-489a-96b0-931a8e58ffce",
    sid: "5n211b87-98d1-4a76-819c-4d9187d7812b",
    deviceId: "c56d8f15-b692-9898-54d3-d5aef48c537a",
    csrfToken: "Cm1HDQeNYmdB-YMtZwSc5QtghybRoevwO1jjenXA",
  },
];
